import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@/graphql/apolloHooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: any; output: any; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  AWSIPAddress: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  AWSTime: { input: any; output: any; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  LocalDate: { input: Date; output: Date; }
};

export type AiSuggestionMeta = {
  __typename: 'AISuggestionMeta';
  available: Scalars['Boolean']['output'];
  latency_ms?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  /** Id de la fila del ledger ai_suggestion (BIL-5189); presente solo cuando available=true y el insert respondió a tiempo. */
  suggestion_id?: Maybe<Scalars['ID']['output']>;
  unavailable_reason?: Maybe<AiSuggestionUnavailableReason>;
};

export enum AiSuggestionUnavailableReason {
  Disabled = 'DISABLED',
  InputTooShort = 'INPUT_TOO_SHORT',
  NotConfigured = 'NOT_CONFIGURED',
  RateLimited = 'RATE_LIMITED',
  ServiceError = 'SERVICE_ERROR'
}

export type AcceptInvitation = {
  __typename: 'AcceptInvitation';
  item: Me;
};

export type AcceptInvitationResponse = AcceptInvitation | NotFoundInvitationError | ServerError;

export type Activity = DailyUsageActivity | FuelDispatchActivity | StockControlActivity | WorkOrderActivity;

export type ActivitySummary = {
  __typename: 'ActivitySummary';
  fuel_dispatched: Scalars['Float']['output'];
  usage_hours_reported: Scalars['Float']['output'];
  wos_completed: Scalars['Int']['output'];
  wos_in_progress: Scalars['Int']['output'];
};

export type AddAssignmentReportInput = {
  date: Scalars['LocalDate']['input'];
  machine_id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddBilderitMaintenancePlanInput = {
  base_period: Scalars['Float']['input'];
  brand_tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  description: Scalars['String']['input'];
  machine_parts: Array<MachinePartInput>;
  period_type: PeriodType;
  programs?: InputMaybe<Array<MpProgramInput>>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  type_tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AddBusinessUnitInput = {
  company_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type AddCertificationCopyRecipientInput = {
  company_id: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddChecklistInput = {
  ad_hoc_items?: InputMaybe<Array<ChecklistAdHocItemInput>>;
  answers: Array<ChecklistAnswerInput>;
  closing_note?: InputMaybe<Scalars['String']['input']>;
  completed_at: Scalars['DateTime']['input'];
  /** The operator's local calendar date. */
  completed_date: Scalars['LocalDate']['input'];
  /** Lectura del contador del equipo (hs/km según el equipo). El tipo se resuelve en el servidor; se ignora si la plantilla no lo pide o el equipo no tiene contador. */
  counter_value?: InputMaybe<Scalars['Float']['input']>;
  /** Generated on the phone (UUID v4). Re-sending the same id returns the existing checklist. */
  id: Scalars['ID']['input'];
  /** Dónde estaba el teléfono al enviar el checklist. Si no es válida se descarta: no rechaza el checklist. */
  location?: InputMaybe<ChecklistLocationInput>;
  machine_id: Scalars['Int']['input'];
  started_at: Scalars['DateTime']['input'];
  template_version_id: Scalars['ID']['input'];
};

export type AddCompany = {
  __typename: 'AddCompany';
  item: Company;
};

export type AddCompanyInput = {
  address: Scalars['String']['input'];
  cuit: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AddCompanyMachineExtraDataInput = {
  company_id: Scalars['Int']['input'];
  field_name: Scalars['String']['input'];
  field_type: MachineExtraDataFieldType;
  is_required: Scalars['Boolean']['input'];
  machine_group?: InputMaybe<MachineGroup>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type AddCompanyResponse = AddCompany | ServerError;

export type AddDailyReportInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  cost_center_id?: InputMaybe<Scalars['Int']['input']>;
  counter: CounterInput;
  date: Scalars['LocalDate']['input'];
  file_ids: Array<Scalars['ID']['input']>;
  filters: Scalars['Boolean']['input'];
  fuel: Scalars['Float']['input'];
  grease: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  machine_id: Scalars['Int']['input'];
  motor_oil?: InputMaybe<Scalars['Float']['input']>;
  project_id: Scalars['Int']['input'];
  tasks?: InputMaybe<Scalars['String']['input']>;
};

export type AddDailyReportOfflineInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  cost_center_id?: InputMaybe<Scalars['Int']['input']>;
  counter: CounterInput;
  date: Scalars['LocalDate']['input'];
  files_data_url: Array<Scalars['String']['input']>;
  filters: Scalars['Boolean']['input'];
  fuel: Scalars['Float']['input'];
  grease: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  machine_id: Scalars['Int']['input'];
  motor_oil?: InputMaybe<Scalars['Float']['input']>;
  tasks?: InputMaybe<Scalars['String']['input']>;
};

export type AddDocumentInput = {
  company_id: Scalars['Int']['input'];
  expiration_date?: InputMaybe<Scalars['LocalDate']['input']>;
  file_ids: Array<Scalars['ID']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
  superseded_document_id?: InputMaybe<Scalars['ID']['input']>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddFixedAssetInput = {
  brand: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
  owner: Scalars['String']['input'];
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  project_id: Scalars['Int']['input'];
  replacement_value: Scalars['Float']['input'];
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type AddFixedAssetResponse = DuplicatedMachineError | Machine;

export type AddFuelDispatchedReportInput = {
  datetime: Scalars['DateTime']['input'];
  destination_counter?: InputMaybe<CounterInput>;
  destination_id: Scalars['Int']['input'];
  destination_project_id: Scalars['Int']['input'];
  file_ids: Array<Scalars['ID']['input']>;
  flowmeter_end: Scalars['Float']['input'];
  flowmeter_start: Scalars['Float']['input'];
  fuel_type: FuelType;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  provider_id?: InputMaybe<Scalars['ID']['input']>;
  source_id?: InputMaybe<Scalars['Int']['input']>;
  source_project_id?: InputMaybe<Scalars['Int']['input']>;
  verified_by?: InputMaybe<Scalars['Int']['input']>;
};

export type AddFuelDispatchedReportPayload = FuelDispatchedReport;

export type AddFuelProviderInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type AddHeavyEquipmentInput = {
  brand: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  counter: CounterInput;
  domain?: InputMaybe<Scalars['String']['input']>;
  engine_number?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
  owner: Scalars['String']['input'];
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  power: Scalars['Float']['input'];
  project_id: Scalars['Int']['input'];
  replacement_value: Scalars['Float']['input'];
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type AddHeavyEquipmentResponse = DuplicatedMachineError | Machine;

export type AddLocationInput = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type AddMachineConsumableInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  equivalences?: InputMaybe<Array<MachineConsumableRef>>;
  internal_code: Scalars['String']['input'];
  manufacturer_code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type AddMachineConsumablePayload = MachineConsumableItem;

export type AddMachineNoticeInput = {
  counter_value?: InputMaybe<Scalars['Float']['input']>;
  file_ids: Array<Scalars['ID']['input']>;
  machine_id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  severity: MachineNoticeSeverity;
  /** Id de AISuggestionMeta.suggestion_id (BIL-5189) si la novedad se creó a partir de una sugerencia de Jev; opcional. */
  suggestion_id?: InputMaybe<Scalars['ID']['input']>;
  tag_ids: Array<Scalars['ID']['input']>;
};

export type AddMaintenancePlanInput = {
  base_period: Scalars['Float']['input'];
  brand_tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  company_id: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  machine_parts: Array<MachinePartInput>;
  period_type: PeriodType;
  programs?: InputMaybe<Array<MpProgramInput>>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  type_tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AddMaintenancePlanPayload = MaintenancePlanItem;

export type AddManagedEmployeeInput = {
  company_id: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
  role: RoleNamesToInvite;
  user: NewUserInput;
};

export type AddMobilityInput = {
  brand: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  counter?: InputMaybe<CounterInput>;
  domain: Scalars['String']['input'];
  engine_number?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  fuel_type: FuelType;
  model: Scalars['String']['input'];
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
  owner: Scalars['String']['input'];
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  project_id: Scalars['Int']['input'];
  replacement_value: Scalars['Float']['input'];
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type AddMobilityResponse = DuplicatedMachineError | Machine;

export type AddOutOfServiceReportForDateRangeInput = {
  cause: Scalars['String']['input'];
  charge_type: OosChargeType;
  counter_type?: InputMaybe<CounterType>;
  counter_value?: InputMaybe<Scalars['Float']['input']>;
  end_date: Scalars['LocalDate']['input'];
  machine_id: Scalars['Int']['input'];
  start_date: Scalars['LocalDate']['input'];
};

export type AddProjectCostCenterInput = {
  name: Scalars['String']['input'];
  project_id: Scalars['Int']['input'];
};

export type AddProjectInput = {
  business_unit_id: Scalars['Int']['input'];
  client?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  location: AddLocationInput;
  name: Scalars['String']['input'];
  ute?: InputMaybe<AddUteInput>;
};

export type AddRoleInput = {
  business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  company_id: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
  role_type: RoleNamesToInvite;
};

export type AddRoleResponse = DuplicatedRoleError | Employee | Invitation;

export type AddServiceReportInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<CounterInput>;
  current_sequence_index: Scalars['Int']['input'];
  date: Scalars['LocalDate']['input'];
  file_ids: Array<Scalars['ID']['input']>;
  machine_id: Scalars['Int']['input'];
  service_type: Scalars['String']['input'];
};

export type AddServiceReportPayload = DailyReportItem;

export type AddStockControlReportInput = {
  datetime: Scalars['DateTime']['input'];
  file_ids: Array<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['Int']['input'];
  stock_measured: Scalars['Float']['input'];
  tank_id: Scalars['Int']['input'];
};

export type AddStockControlReportPayload = DuplicatedReportDateError | StockControlReport;

export type AddTagGroupInput = {
  context?: InputMaybe<Context>;
  name: Scalars['String']['input'];
  scope: TagScope;
};

export type AddTagInput = {
  color?: InputMaybe<TagColor>;
  context?: InputMaybe<Context>;
  description?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['ID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  scope: TagScope;
  tag: Scalars['String']['input'];
};

export type AddTruckInput = {
  brand: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  counter: CounterInput;
  domain: Scalars['String']['input'];
  engine_number?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  model: Scalars['String']['input'];
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
  owner: Scalars['String']['input'];
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  power: Scalars['Float']['input'];
  preferred_counter_type: CounterType;
  project_id: Scalars['Int']['input'];
  replacement_value: Scalars['Float']['input'];
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type AddTruckResponse = DuplicatedMachineError | Machine;

export type AddUteInput = {
  cuit: Scalars['String']['input'];
  partners: Array<AddUtePartnerInput>;
};

export type AddUtePartnerInput = {
  name: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

export type AddWorkOrderHoursInput = {
  labor_type?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  planned_hours: Scalars['Float']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddWorkOrderInput = {
  comments_draft?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  file_ids: Array<Scalars['ID']['input']>;
  hours: Array<AddWorkOrderHoursInput>;
  id: Scalars['String']['input'];
  machine_id: Scalars['Int']['input'];
  program_id?: InputMaybe<Scalars['ID']['input']>;
  project_id: Scalars['Int']['input'];
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks: Array<AddWorkOrderTaskInput>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type AddWorkOrderPayload = ItemWorkOrder;

export type AddWorkOrderTaskInput = {
  action: Scalars['String']['input'];
  compartment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  item: Scalars['String']['input'];
  preferred_consumable_code?: InputMaybe<Scalars['String']['input']>;
  preferred_quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminCognitoIdentity = {
  __typename: 'AdminCognitoIdentity';
  created_at: Scalars['DateTime']['output'];
  dni?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  email_verified: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  sign_in: AdminUserSignIn;
  status: CognitoUserStatus;
  sub: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export enum AdminUserAlert {
  DniMismatch = 'DNI_MISMATCH',
  EmailMismatch = 'EMAIL_MISMATCH',
  ForeignRoles = 'FOREIGN_ROLES',
  NoIdentity = 'NO_IDENTITY'
}

export type AdminUserCheck = {
  __typename: 'AdminUserCheck';
  id: AdminUserCheckId;
  status: AdminUserCheckStatus;
};

export enum AdminUserCheckId {
  Confirmed = 'CONFIRMED',
  DataMatches = 'DATA_MATCHES',
  HasDbRow = 'HAS_DB_ROW',
  HasIdentity = 'HAS_IDENTITY',
  RolesInManagingCompany = 'ROLES_IN_MANAGING_COMPANY',
  SingleAccount = 'SINGLE_ACCOUNT'
}

export enum AdminUserCheckStatus {
  NotApplicable = 'NOT_APPLICABLE',
  Ok = 'OK',
  Pending = 'PENDING',
  Problem = 'PROBLEM'
}

export type AdminUserCompany = {
  __typename: 'AdminUserCompany';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminUserCompanyRoles = {
  __typename: 'AdminUserCompanyRoles';
  company: AdminUserCompany;
  foreign: Scalars['Boolean']['output'];
  managing: Scalars['Boolean']['output'];
  roles: Array<AdminUserRole>;
};

export type AdminUserDatabaseRow = {
  __typename: 'AdminUserDatabaseRow';
  created_at: Scalars['DateTime']['output'];
  created_by_name?: Maybe<Scalars['String']['output']>;
  dni: Scalars['String']['output'];
  email: Scalars['String']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  google_external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  pending_email?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type AdminUserDetail = {
  __typename: 'AdminUserDetail';
  checks: Array<AdminUserCheck>;
  database?: Maybe<AdminUserDatabaseRow>;
  enabled_to_create_company: Scalars['Boolean']['output'];
  identities: Array<AdminCognitoIdentity>;
  roles: Array<AdminUserCompanyRoles>;
  row: AdminUserRow;
};

export enum AdminUserFilter {
  All = 'ALL',
  Attention = 'ATTENTION',
  Disabled = 'DISABLED',
  ForeignRoles = 'FOREIGN_ROLES',
  Incomplete = 'INCOMPLETE',
  Managed = 'MANAGED',
  Unconfirmed = 'UNCONFIRMED'
}

export type AdminUserFilterCount = {
  __typename: 'AdminUserFilterCount';
  count: Scalars['Int']['output'];
  filter: AdminUserFilter;
};

export enum AdminUserKind {
  CognitoOnly = 'COGNITO_ONLY',
  Managed = 'MANAGED',
  Own = 'OWN'
}

export type AdminUserRole = {
  __typename: 'AdminUserRole';
  id: Scalars['Int']['output'];
  role_type: Scalars['String']['output'];
  scope_name?: Maybe<Scalars['String']['output']>;
};

export type AdminUserRow = {
  __typename: 'AdminUserRow';
  alerts: Array<AdminUserAlert>;
  cognito_username?: Maybe<Scalars['String']['output']>;
  companies: Array<AdminUserCompany>;
  dni?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  kind: AdminUserKind;
  last_name?: Maybe<Scalars['String']['output']>;
  last_seen_on?: Maybe<Scalars['LocalDate']['output']>;
  managed_by?: Maybe<AdminUserCompany>;
  registered_at?: Maybe<Scalars['DateTime']['output']>;
  sign_in?: Maybe<AdminUserSignIn>;
  state: AdminUserState;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export enum AdminUserSignIn {
  Google = 'GOOGLE',
  Password = 'PASSWORD'
}

export enum AdminUserState {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Incomplete = 'INCOMPLETE',
  Unconfirmed = 'UNCONFIRMED'
}

export type AdminUsersResult = OffsetPaginatedResponse & {
  __typename: 'AdminUsersResult';
  counts: Array<AdminUserFilterCount>;
  items: Array<AdminUserRow>;
  page_info: PageInfo;
  truncated: Scalars['Boolean']['output'];
};

export enum AempProvider {
  Case = 'CASE',
  Cat = 'CAT',
  Develon = 'Develon',
  Hyundai = 'HYUNDAI',
  Jcb = 'JCB',
  JohnDeere = 'JohnDeere',
  Komtrax = 'Komtrax',
  NewHolland = 'NewHolland',
  Powerscreen = 'Powerscreen',
  Sany = 'SANY',
  Scania = 'SCANIA',
  VolvoAemp = 'VolvoAEMP',
  VolvoTrucks = 'VolvoTrucks',
  Witos = 'Witos'
}

export enum ApproverType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type AssignMaintenancePlanBatchInput = {
  machine_ids: Array<Scalars['Int']['input']>;
  mp_id: Scalars['Int']['input'];
};

export type AssignMaintenancePlanBatchPayload = AssignMaintenancePlanBatchSuccess;

export type AssignMaintenancePlanBatchSuccess = {
  __typename: 'AssignMaintenancePlanBatchSuccess';
  items?: Maybe<Array<Maybe<Machine>>>;
};

export type AssignWorkOrderInput = {
  user_ids: Array<Scalars['Int']['input']>;
  work_order_id: Scalars['ID']['input'];
};

export type AssignWorkOrderPayload = ItemWorkOrder;

export type AuthAddDailyReportResponse = AuthCheckAddDailyReport | AuthorizationError | ServerError;

export type AuthAddProjectResponse = AuthCheckAddProject | AuthorizationError | DuplicatedProjectError | ServerError;

export type AuthAddRoleResponse = AuthCheckAddRole | AuthorizationError | ServerError;

export type AuthCheckAddAvailableReport = {
  __typename: 'AuthCheckAddAvailableReport';
  item: DailyReport;
};

export type AuthCheckAddDailyReport = {
  __typename: 'AuthCheckAddDailyReport';
  item: DailyReport;
};

export type AuthCheckAddOutOfServiceReport = {
  __typename: 'AuthCheckAddOutOfServiceReport';
  item: DailyReport;
};

export type AuthCheckAddProject = {
  __typename: 'AuthCheckAddProject';
  item: Project;
};

export type AuthCheckAddRole = {
  __typename: 'AuthCheckAddRole';
  item: AddRoleResponse;
};

export type AuthCheckDeleteAvailableReport = {
  __typename: 'AuthCheckDeleteAvailableReport';
  item: DailyReport;
};

export type AuthCheckDeleteDailyReport = {
  __typename: 'AuthCheckDeleteDailyReport';
  item: DailyReport;
};

export type AuthCheckDeleteMachine = {
  __typename: 'AuthCheckDeleteMachine';
  item: Machine;
};

export type AuthCheckDeleteOutOfServiceReport = {
  __typename: 'AuthCheckDeleteOutOfServiceReport';
  item: DailyReport;
};

export type AuthCheckDeleteRole = {
  __typename: 'AuthCheckDeleteRole';
  item: Employee;
};

export type AuthCheckGetCompany = {
  __typename: 'AuthCheckGetCompany';
  item: Company;
};

export type AuthCheckGetDailyReportById = {
  __typename: 'AuthCheckGetDailyReportById';
  item: DailyReport;
};

export type AuthCheckGetDailyReports = {
  __typename: 'AuthCheckGetDailyReports';
  items: Array<Maybe<DailyReport>>;
};

export type AuthCheckGetDailyReportsByDayStats = {
  __typename: 'AuthCheckGetDailyReportsByDayStats';
  stats: DailyReportByDayStats;
};

export type AuthCheckGetDailyReportsByMachineIdStats = {
  __typename: 'AuthCheckGetDailyReportsByMachineIdStats';
  stats: DailyReportByMachineIdStats;
};

export type AuthCheckGetEmployees = {
  __typename: 'AuthCheckGetEmployees';
  items: Array<Maybe<Employee>>;
};

export type AuthCheckGetInvitations = {
  __typename: 'AuthCheckGetInvitations';
  items: Array<Maybe<Invitation>>;
};

export type AuthCheckGetMachineById = {
  __typename: 'AuthCheckGetMachineById';
  item: Machine;
};

export type AuthCheckGetMachineGroupCounts = {
  __typename: 'AuthCheckGetMachineGroupCounts';
  items: Array<MachineGroupCount>;
};

export type AuthCheckGetMachineTypes = {
  __typename: 'AuthCheckGetMachineTypes';
  items: Array<Maybe<MachineType>>;
};

export type AuthCheckGetMachineTypesResponse = AuthCheckGetMachineTypes | AuthorizationError | ServerError;

export type AuthCheckGetMachines = {
  __typename: 'AuthCheckGetMachines';
  items: Array<Maybe<Machine>>;
  page_info?: Maybe<PageInfo>;
};

export type AuthCheckGetMyDailyReports = {
  __typename: 'AuthCheckGetMyDailyReports';
  items: Array<Maybe<DailyReport>>;
};

export type AuthCheckGetUploadMachinesPresignatedUrl = {
  __typename: 'AuthCheckGetUploadMachinesPresignatedUrl';
  item: DataUpload;
};

export type AuthCheckGetUsers = {
  __typename: 'AuthCheckGetUsers';
  items: Array<Maybe<User>>;
  pagination?: Maybe<PageInfo>;
};

export type AuthCheckUpdateCompany = {
  __typename: 'AuthCheckUpdateCompany';
  item: Company;
};

export type AuthCheckUpdateDailyReport = {
  __typename: 'AuthCheckUpdateDailyReport';
  item: DailyReport;
};

export type AuthCheckUpdateProject = {
  __typename: 'AuthCheckUpdateProject';
  item: Project;
};

export type AuthDeleteAvailableReportResponse = AuthCheckDeleteAvailableReport | AuthorizationError | ServerError;

export type AuthDeleteDailyReportResponse = AuthCheckDeleteDailyReport | AuthorizationError | NotFoundDailyReportError | ServerError;

export type AuthDeleteOutOfServiceReportResponse = AuthCheckDeleteOutOfServiceReport | AuthorizationError | ServerError;

export type AuthDeleteRoleResponse = AuthCheckDeleteRole | AuthorizationError | NotFoundRoleError | ServerError;

export type AuthGetCompanyResponse = AuthCheckGetCompany | AuthorizationError | ServerError;

export type AuthGetDailyReportByIdResponse = AuthCheckGetDailyReportById | AuthorizationError | ServerError;

export type AuthGetDailyReportsByDayStatsResponse = AuthCheckGetDailyReportsByDayStats | AuthorizationError | ServerError;

export type AuthGetDailyReportsByMachineIdStatsResponse = AuthCheckGetDailyReportsByMachineIdStats | AuthorizationError | ServerError;

export type AuthGetDailyReportsReponse = AuthCheckGetDailyReports | AuthorizationError | ServerError;

export type AuthGetEmployeesResponse = AuthCheckGetEmployees | AuthorizationError | ServerError;

export type AuthGetInvitationsResponse = AuthCheckGetInvitations | AuthorizationError | ServerError;

export type AuthGetMachineByIdResponse = AuthCheckGetMachineById | AuthorizationError | ServerError;

export type AuthGetMachineGroupCountsResponse = AuthCheckGetMachineGroupCounts | AuthorizationError | ServerError;

export type AuthGetMachinesResponse = AuthCheckGetMachines | AuthorizationError | ServerError;

export type AuthGetMyDailyReportsResponse = AuthCheckGetMyDailyReports | AuthorizationError | ServerError;

export type AuthGetUploadMachinesPresignatedUrlResponse = AuthCheckGetUploadMachinesPresignatedUrl | AuthorizationError | ServerError;

export type AuthGetUsersResponse = AuthCheckGetUsers | AuthorizationError | ServerError;

export type AuthUpdateCompanyResponse = AuthCheckUpdateCompany | AuthorizationError | ServerError;

export type AuthUpdateDailyReportResponse = AuthCheckUpdateDailyReport | AuthorizationError | NotFoundDailyReportError | ServerError;

export type AuthUpdateProjectResponse = AuthCheckUpdateProject | AuthorizationError | DuplicatedProjectError | ServerError;

export type AuthorizationError = Error & {
  __typename: 'AuthorizationError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** A template as the app offers it for filling: only its published version. The panel's ChecklistTemplate (draft, criteria, assignment rules) is not readable through it. */
export type AvailableChecklistTemplate = {
  __typename: 'AvailableChecklistTemplate';
  current_version: AvailableChecklistTemplateVersion;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** A published item as the operator's fill flow reads it. No pass criteria and no failure severity: verdicts are computed on the server. */
export type AvailableChecklistTemplateItem = {
  __typename: 'AvailableChecklistTemplateItem';
  /** CHOICE items only (null otherwise): option keys + labels, without pass criteria. */
  choice_options?: Maybe<Array<ChecklistChoiceLabel>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item_key: Scalars['ID']['output'];
  item_type: ChecklistItemType;
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  requirement: ChecklistItemRequirement;
  section?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type AvailableChecklistTemplateVersion = {
  __typename: 'AvailableChecklistTemplateVersion';
  counter_requirement: ChecklistCounterRequirement;
  id: Scalars['ID']['output'];
  items: Array<AvailableChecklistTemplateItem>;
  version_number: Scalars['Int']['output'];
};

export type AvailableReport = {
  __typename: 'AvailableReport';
  created_at: Scalars['DateTime']['output'];
  creator?: Maybe<Employee>;
  id: Scalars['Int']['output'];
  modifier?: Maybe<Employee>;
  observation: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AverageRotationKpi = {
  __typename: 'AverageRotationKpi';
  average_consumption: Scalars['Float']['output'];
  /**
   * Time-weighted average stock level during the period.
   * Null when there's insufficient data to calculate (no stock controls or dispatches).
   */
  average_stock?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum (peak) stock level reached during the period.
   * Calculated from the reconstructed stock curve using dispatch events.
   * Null when there's insufficient data.
   */
  max_stock?: Maybe<Scalars['Float']['output']>;
  /**
   * Minimum (trough) stock level reached during the period.
   * Calculated from the reconstructed stock curve using dispatch events.
   * Null when there's insufficient data.
   */
  min_stock?: Maybe<Scalars['Float']['output']>;
  /**
   * Days of stock remaining at current consumption rate.
   * Null when average_stock is not available.
   */
  rotation_days?: Maybe<Scalars['Float']['output']>;
};

export type AverageUsage = {
  __typename: 'AverageUsage';
  days_in_last_5_reports?: Maybe<Scalars['Float']['output']>;
  hours_in_last_5_reports?: Maybe<Scalars['Float']['output']>;
  hours_in_last_15_days?: Maybe<Scalars['Float']['output']>;
  machine_id: Scalars['Int']['output'];
};

export type BcDeviceSnapshot = {
  __typename: 'BCDeviceSnapshot';
  bc_device: BilderitConnectDevice;
  telemetry_snapshot?: Maybe<TelemetrySnapshot>;
};

export type BatchAddAvailableReportInput = {
  dates: Array<Scalars['LocalDate']['input']>;
  machine_ids: Array<Scalars['Int']['input']>;
  observation: Scalars['String']['input'];
};

export type BatchAddAvailableReportResponse = DailyReportItems;

export type BilderitConnectDevice = {
  __typename: 'BilderitConnectDevice';
  aemp_provider?: Maybe<AempProvider>;
  company: Company;
  counter_offset: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  flespi_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  machine?: Maybe<Machine>;
  serial_number: Scalars['ID']['output'];
  telemetry_provider: TmProvider;
};

export type BilderitModuleEnabled = {
  __typename: 'BilderitModuleEnabled';
  end_date?: Maybe<Scalars['LocalDate']['output']>;
  module_id: BilderitModuleId;
};

export enum BilderitModuleId {
  AiAnalysis = 'AI_ANALYSIS',
  AiTagReview = 'AI_TAG_REVIEW',
  BconnectDashboard = 'BCONNECT_DASHBOARD',
  Btrack = 'BTRACK',
  Checklists = 'CHECKLISTS',
  IdentityClaim = 'IDENTITY_CLAIM',
  Pagaraprata = 'PAGARAPRATA',
  RentalCertification = 'RENTAL_CERTIFICATION',
  WeeklyReports = 'WEEKLY_REPORTS',
  WoSignatures = 'WO_SIGNATURES'
}

export type BilderitPlanAlreadyCopiedError = Error & {
  __typename: 'BilderitPlanAlreadyCopiedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type BilderitReportSubscription = {
  __typename: 'BilderitReportSubscription';
  company: Company;
  created_by: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  report_type: BilderitReportType;
};

export enum BilderitReportType {
  AiMachineNoticesWeeklySummary = 'AI_MACHINE_NOTICES_WEEKLY_SUMMARY',
  DocumentsExpiring = 'DOCUMENTS_EXPIRING',
  MachineNoticesDaily = 'MACHINE_NOTICES_DAILY',
  TelemetryMonthly = 'TELEMETRY_MONTHLY',
  UpcomingServices = 'UPCOMING_SERVICES'
}

export type BooleanSnapshot = {
  __typename: 'BooleanSnapshot';
  datetime_utc: Scalars['DateTime']['output'];
  value: Scalars['Boolean']['output'];
};

export type BusinessUnit = {
  __typename: 'BusinessUnit';
  company_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  projects: Array<Project>;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CalculationContext = {
  __typename: 'CalculationContext';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  usedLastNDays?: Maybe<Scalars['Int']['output']>;
  usedLastNReports?: Maybe<Scalars['Int']['output']>;
};

export type CalibrateTrackerDeviceInput = {
  ignition_voltage_threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type CancelIdentityClaimForUserInput = {
  user_id: Scalars['Int']['input'];
};

export type CancelWorkOrderPayload = ItemWorkOrder | NotAllowedError;

export type CertificationCopyRecipient = {
  __typename: 'CertificationCopyRecipient';
  company_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  project_id?: Maybe<Scalars['Int']['output']>;
};

export type CertificationHistoryConnection = OffsetPaginatedResponse & {
  __typename: 'CertificationHistoryConnection';
  items: Array<RentalCertification>;
  page_info: PageInfo;
};

export type CertificationHistoryFilter = {
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  ownership_group?: InputMaybe<RentalOwnershipGroup>;
  status?: InputMaybe<Array<RentalCertificationStatus>>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type CertificationNotificationAudience = {
  __typename: 'CertificationNotificationAudience';
  event: CertificationNotificationEvent;
  recipients: Array<CertificationNotificationRecipient>;
};

export enum CertificationNotificationEvent {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  SubmittedForReview = 'SUBMITTED_FOR_REVIEW'
}

export type CertificationNotificationRecipient = {
  __typename: 'CertificationNotificationRecipient';
  display_name?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  sources: Array<CertificationNotificationRecipientSource>;
};

export enum CertificationNotificationRecipientSource {
  CompanyCopy = 'COMPANY_COPY',
  ProjectCopy = 'PROJECT_COPY',
  Reviewer = 'REVIEWER',
  Submitter = 'SUBMITTER'
}

export type Checklist = {
  __typename: 'Checklist';
  closing_note?: Maybe<Scalars['String']['output']>;
  completed_at: Scalars['DateTime']['output'];
  completed_date: Scalars['LocalDate']['output'];
  /** Contador del equipo al hacer el checklist, si se cargó. */
  counter?: Maybe<Counter>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Employee>;
  fail_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  items: Array<ChecklistItem>;
  /** Dónde estaba el teléfono al enviar el checklist, si el operario lo permitió. */
  location?: Maybe<ChecklistLocation>;
  machine?: Maybe<Machine>;
  machine_id?: Maybe<Scalars['Int']['output']>;
  na_count: Scalars['Int']['output'];
  pass_count: Scalars['Int']['output'];
  project?: Maybe<Project>;
  project_id: Scalars['Int']['output'];
  serial_number: Scalars['Int']['output'];
  started_at: Scalars['DateTime']['output'];
  template_id: Scalars['ID']['output'];
  template_title: Scalars['String']['output'];
  template_version_id: Scalars['ID']['output'];
  version_number: Scalars['Int']['output'];
};

export type ChecklistAdHocItemInput = {
  label: Scalars['String']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  ok: Scalars['Boolean']['input'];
  photos_data_url?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChecklistAnswerInput = {
  /** CHOICE */
  choice_key?: InputMaybe<Scalars['String']['input']>;
  /** DATE */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  kind: ChecklistAnswerKind;
  /** NA (required when kind = NA) */
  na_reason?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  /** CHECK */
  ok?: InputMaybe<Scalars['Boolean']['input']>;
  /** Compressed images as data URLs (image/jpeg|png|webp). Uploaded server-side. */
  photos_data_url?: InputMaybe<Array<Scalars['String']['input']>>;
  template_item_id: Scalars['ID']['input'];
  /** TEXT */
  text?: InputMaybe<Scalars['String']['input']>;
  /** MEASUREMENT */
  value_number?: InputMaybe<Scalars['Float']['input']>;
};

export enum ChecklistAnswerKind {
  Check = 'CHECK',
  Choice = 'CHOICE',
  Date = 'DATE',
  Empty = 'EMPTY',
  Measurement = 'MEASUREMENT',
  Na = 'NA',
  Text = 'TEXT'
}

export type ChecklistAssignmentPreview = {
  __typename: 'ChecklistAssignmentPreview';
  machine_count: Scalars['Int']['output'];
};

export type ChecklistAssignmentRule = {
  __typename: 'ChecklistAssignmentRule';
  id: Scalars['ID']['output'];
  /** Set only for MACHINE_SUPERTYPE (the UI calls supertypes 'grupos'). */
  machine_group?: Maybe<MachineGroup>;
  scope_type: ChecklistAssignmentScope;
  /** Id of the machine / machine type / project / business unit; null for COMPANY and MACHINE_SUPERTYPE. */
  target_id?: Maybe<Scalars['Int']['output']>;
  target_name?: Maybe<Scalars['String']['output']>;
};

export type ChecklistAssignmentRuleInput = {
  /** Required for MACHINE_SUPERTYPE; null otherwise. */
  machine_group?: InputMaybe<MachineGroup>;
  scope_type: ChecklistAssignmentScope;
  /** Required for MACHINE, MACHINE_TYPE, PROJECT, BUSINESS_UNIT; null otherwise. */
  target_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ChecklistAssignmentScope {
  BusinessUnit = 'BUSINESS_UNIT',
  Company = 'COMPANY',
  Machine = 'MACHINE',
  MachineSupertype = 'MACHINE_SUPERTYPE',
  MachineType = 'MACHINE_TYPE',
  Project = 'PROJECT'
}

export type ChecklistAvailabilityResponse = {
  __typename: 'ChecklistAvailabilityResponse';
  /** Only machines that have at least one available template and are in the caller's scope. A requested machine that is absent has none. */
  machines: Array<MachineChecklistAvailability>;
  /** Every template available to at least one requested machine, with its published items (the phone caches them for offline use). */
  templates: Array<AvailableChecklistTemplate>;
};

/** A CHOICE option as the operator sees it: no result, no severity. */
export type ChecklistChoiceLabel = {
  __typename: 'ChecklistChoiceLabel';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Si la plantilla pide el contador del equipo al empezar. Se congela por versión. */
export enum ChecklistCounterRequirement {
  None = 'NONE',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum ChecklistFacetField {
  Project = 'PROJECT',
  Result = 'RESULT',
  Template = 'TEMPLATE'
}

export type ChecklistFacetGroup = {
  __typename: 'ChecklistFacetGroup';
  /** RESULT: has_failures | no_failures; TEMPLATE: template id; PROJECT: project id. */
  facets: Array<Facet>;
  field: ChecklistFacetField;
};

export type ChecklistItem = {
  __typename: 'ChecklistItem';
  /** Criteria as they were when the checklist was completed. */
  criteria_snapshot?: Maybe<Scalars['JSONObject']['output']>;
  fail_streak?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_ad_hoc: Scalars['Boolean']['output'];
  item_type: ChecklistItemType;
  label: Scalars['String']['output'];
  na_reason?: Maybe<Scalars['String']['output']>;
  notice?: Maybe<ChecklistItemNotice>;
  observation?: Maybe<Scalars['String']['output']>;
  photos: Array<File>;
  position: Scalars['Int']['output'];
  requirement: ChecklistItemRequirement;
  result: ChecklistItemResult;
  result_severity?: Maybe<MachineNoticeSeverity>;
  section?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value_choice_key?: Maybe<Scalars['String']['output']>;
  /** Label of the chosen option, resolved from criteria_snapshot. */
  value_choice_label?: Maybe<Scalars['String']['output']>;
  value_date?: Maybe<Scalars['LocalDate']['output']>;
  value_number?: Maybe<Scalars['Float']['output']>;
  value_text?: Maybe<Scalars['String']['output']>;
};

export type ChecklistItemNotice = {
  __typename: 'ChecklistItemNotice';
  id: Scalars['Int']['output'];
  /** Same shape and resolution as MachineNotice.linked_work_order. */
  linked_work_order?: Maybe<WorkOrder>;
  serial_number: Scalars['Int']['output'];
  severity: MachineNoticeSeverity;
  status: MachineNoticeStatus;
};

export enum ChecklistItemRequirement {
  Optional = 'OPTIONAL',
  OptionalNa = 'OPTIONAL_NA',
  Required = 'REQUIRED'
}

export enum ChecklistItemResult {
  Fail = 'FAIL',
  Na = 'NA',
  None = 'NONE',
  Pass = 'PASS'
}

export enum ChecklistItemType {
  Check = 'CHECK',
  Choice = 'CHOICE',
  Date = 'DATE',
  Measurement = 'MEASUREMENT',
  Text = 'TEXT'
}

export type ChecklistLocation = {
  __typename: 'ChecklistLocation';
  /** Margen de error de la posición, en metros. */
  accuracy_m?: Maybe<Scalars['Int']['output']>;
  /** Cuándo el teléfono tomó la posición. */
  captured_at: Scalars['DateTime']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type ChecklistLocationInput = {
  /** Margen de error de la posición, en metros. */
  accuracy_m?: InputMaybe<Scalars['Float']['input']>;
  /** Cuándo el teléfono tomó la posición. */
  captured_at: Scalars['DateTime']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type ChecklistTemplate = {
  __typename: 'ChecklistTemplate';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  /** Assignment rules — union semantics, no exclusions. */
  assignment_rules: Array<ChecklistAssignmentRule>;
  company_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Employee>;
  /** Latest published version (null while never published). */
  current_version?: Maybe<ChecklistTemplateVersion>;
  description?: Maybe<Scalars['String']['output']>;
  /** The editable draft, if any. */
  draft?: Maybe<ChecklistTemplateVersion>;
  id: Scalars['ID']['output'];
  status: ChecklistTemplateStatus;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ChecklistTemplateItem = {
  __typename: 'ChecklistTemplateItem';
  /** CHOICE items only (null otherwise): option keys + labels, without pass criteria. The phone uses this instead of criteria. */
  choice_options?: Maybe<Array<ChecklistChoiceLabel>>;
  /** Pass criteria; the shape depends on item_type. CHECK and TEXT: null. MEASUREMENT: null (no range: the value is only recorded, with no verdict and no fail_severity) or { kind: 'MEASUREMENT', bands: [{ min, max, result: 'PASS' | 'FAIL', severity }] } — each band needs a min or a max, min/max are inclusive and null means unbounded; the first band containing the value decides, and a value in no band fails with fail_severity. CHOICE: { kind: 'CHOICE', options: [{ key, label, result: 'PASS' | 'FAIL', severity }] } — the answer picks an option by key. DATE: null (no verdict) or { kind: 'DATE', maxAgeDays } — fails when the answered date is more than maxAgeDays before the checklist's completed_date. severity is required when result is 'FAIL'. */
  criteria?: Maybe<Scalars['JSONObject']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fail_severity?: Maybe<MachineNoticeSeverity>;
  id: Scalars['ID']['output'];
  item_key: Scalars['ID']['output'];
  item_type: ChecklistItemType;
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  requirement: ChecklistItemRequirement;
  section?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ChecklistTemplateItemInput = {
  criteria?: InputMaybe<Scalars['JSONObject']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fail_severity?: InputMaybe<MachineNoticeSeverity>;
  /** Keep the existing item_key when editing an item; generate a new UUID for a new item. */
  item_key: Scalars['ID']['input'];
  item_type: ChecklistItemType;
  label: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  requirement: ChecklistItemRequirement;
  section?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export enum ChecklistTemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ChecklistTemplateVersion = {
  __typename: 'ChecklistTemplateVersion';
  counter_requirement: ChecklistCounterRequirement;
  id: Scalars['ID']['output'];
  items: Array<ChecklistTemplateItem>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  published_by?: Maybe<Employee>;
  version_number: Scalars['Int']['output'];
};

export type ChecklistTemplatesResponse = OffsetPaginatedResponse & {
  __typename: 'ChecklistTemplatesResponse';
  items: Array<ChecklistTemplate>;
  page_info: PageInfo;
};

export type ChecklistsResponse = OffsetPaginatedResponse & {
  __typename: 'ChecklistsResponse';
  /** Option counts for the advanced filter; each group ignores its own filter. */
  facets: Array<ChecklistFacetGroup>;
  items: Array<Checklist>;
  page_info: PageInfo;
};

export enum CognitoUserStatus {
  Confirmed = 'CONFIRMED',
  ExternalProvider = 'EXTERNAL_PROVIDER',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  ResetRequired = 'RESET_REQUIRED',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN'
}

export type CompaniesConnection = {
  __typename: 'CompaniesConnection';
  items?: Maybe<Array<Maybe<Company>>>;
};

export type CompaniesWithTotals = {
  __typename: 'CompaniesWithTotals';
  items: Array<CompanyWithTotals>;
};

export type Company = {
  __typename: 'Company';
  address: Scalars['String']['output'];
  archived_projects: Array<Project>;
  business_units: Array<BusinessUnit>;
  created_at: Scalars['DateTime']['output'];
  cuit: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logo_url?: Maybe<Scalars['String']['output']>;
  modules_enabled?: Maybe<Array<Maybe<BilderitModuleEnabled>>>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  projects: Array<Project>;
  slug: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyActivityModuleBreakdown = {
  __typename: 'CompanyActivityModuleBreakdown';
  actionCount: Scalars['Int']['output'];
  module: Scalars['String']['output'];
};

export type CompanyActivitySummary = {
  __typename: 'CompanyActivitySummary';
  activeUserCount: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  lastActivityDate: Scalars['LocalDate']['output'];
  moduleBreakdown: Array<CompanyActivityModuleBreakdown>;
  totalActions: Scalars['Int']['output'];
};

export type CompanyAlerts = {
  __typename: 'CompanyAlerts';
  expired_documents_count: Scalars['Int']['output'];
  open_critical_machine_notices_count: Scalars['Int']['output'];
  overdue_services_count: Scalars['Int']['output'];
};

export type CompanyIntegration = {
  __typename: 'CompanyIntegration';
  company: Company;
  created_at: Scalars['DateTime']['output'];
  credentials: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_error_message?: Maybe<Scalars['String']['output']>;
  last_sync_at?: Maybe<Scalars['DateTime']['output']>;
  last_sync_status?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CompanyMachineExtraData = {
  __typename: 'CompanyMachineExtraData';
  company_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  field_name: Scalars['String']['output'];
  field_type: MachineExtraDataFieldType;
  id: Scalars['ID']['output'];
  is_required: Scalars['Boolean']['output'];
  machine_group?: Maybe<MachineGroup>;
  unit?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyWithTotals = {
  __typename: 'CompanyWithTotals';
  company: Company;
  documents: Scalars['Int']['output'];
  fixed_assets: Scalars['Int']['output'];
  fuel_tanks: Scalars['Int']['output'];
  heavy_equipments: Scalars['Int']['output'];
  last_seen_at?: Maybe<Scalars['DateTime']['output']>;
  maintenance_plans: Scalars['Int']['output'];
  projects: Scalars['Int']['output'];
  trucks: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
  users_seen_30d: Scalars['Int']['output'];
  vehicles: Scalars['Int']['output'];
};

export type ConfirmIdentityClaimInput = {
  password: Scalars['String']['input'];
};

export type ConsumablesConflictError = Error & {
  __typename: 'ConsumablesConflictError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type ConsumptionStats = {
  __typename: 'ConsumptionStats';
  total_consumption_dispatches: Scalars['Int']['output'];
  total_consumption_liters: Scalars['Float']['output'];
};

export type Context = {
  business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  company_id: Scalars['Int']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum CostCenterMode {
  Disabled = 'DISABLED',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type Counter = {
  __typename: 'Counter';
  end?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  type: CounterType;
  value: Scalars['Float']['output'];
};

export type CounterInSequence = {
  __typename: 'CounterInSequence';
  type: PeriodType;
  value: Scalars['Float']['output'];
};

export type CounterInput = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
  type: CounterType;
};

export enum CounterSource {
  Checklist = 'CHECKLIST',
  FuelReport = 'FUEL_REPORT',
  MachineNotice = 'MACHINE_NOTICE',
  MoveReport = 'MOVE_REPORT',
  OosReport = 'OOS_REPORT',
  ServiceReport = 'SERVICE_REPORT',
  Telemetry = 'TELEMETRY',
  UsageReport = 'USAGE_REPORT'
}

export enum CounterType {
  Hs = 'hs',
  Km = 'km',
  Na = 'na'
}

export type CounterValue = {
  __typename: 'CounterValue';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CounterType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CounterValueInput = {
  type: CounterType;
  value: Scalars['Float']['input'];
};

export type CreateChecklistTemplateInput = {
  company_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePublicApiClientInput = {
  companyId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  owner: PublicApiContactInput;
  roles: Array<PublicApiKeyRole>;
  technical: PublicApiContactInput;
};

export type CreateRentalParameterDefinitionInput = {
  code: RentalParamsCode;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  symbol: Scalars['String']['input'];
  type: DataType;
  unit: Scalars['String']['input'];
};

export type Created = {
  __typename: 'Created';
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<User>;
};

export type Cursor = {
  limit: Scalars['Int']['input'];
  next?: InputMaybe<Scalars['String']['input']>;
};

export type CursorPageInfo = {
  __typename: 'CursorPageInfo';
  has_next_page: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
};

export type CursorPaginatedResponse = {
  page_info: CursorPageInfo;
};

export type DailyReport = {
  __typename: 'DailyReport';
  available_report?: Maybe<AvailableReport>;
  checkin_report?: Maybe<MoveReport>;
  checkout_report?: Maybe<MoveReport>;
  creators?: Maybe<Array<Maybe<Employee>>>;
  date: Scalars['LocalDate']['output'];
  has_comments?: Maybe<Scalars['Boolean']['output']>;
  has_filters?: Maybe<Scalars['Boolean']['output']>;
  has_grease?: Maybe<Scalars['Boolean']['output']>;
  has_tasks?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  machine: Machine;
  out_of_service_report?: Maybe<OutOfServiceReport>;
  project?: Maybe<Project>;
  service_reports: Array<ServiceReport>;
  status: MachineReportStatus;
  total_counters: Array<Counter>;
  total_counters_display?: Maybe<Scalars['String']['output']>;
  total_fuel?: Maybe<Scalars['Float']['output']>;
  total_hs?: Maybe<Scalars['Float']['output']>;
  total_km?: Maybe<Scalars['Float']['output']>;
  total_oil?: Maybe<Scalars['Float']['output']>;
  usage_reports: Array<Maybe<UsageReport>>;
};

export type DailyReportByDayStats = {
  __typename: 'DailyReportByDayStats';
  num_available_machines: Scalars['Int']['output'];
  num_greases: Scalars['Int']['output'];
  num_machines: Scalars['Int']['output'];
  num_out_of_service_machines: Scalars['Int']['output'];
  num_pending_machines: Scalars['Int']['output'];
  num_worked_machines: Scalars['Int']['output'];
  stats_by_counter_type: Array<StatsByCounterType>;
  total_fuel: Scalars['Float']['output'];
};

export type DailyReportByMachineIdStats = {
  __typename: 'DailyReportByMachineIdStats';
  num_available_days: Scalars['Int']['output'];
  num_filters: Scalars['Int']['output'];
  num_greases: Scalars['Int']['output'];
  num_oos_days: Scalars['Int']['output'];
  num_pending_days: Scalars['Int']['output'];
  num_worked_days: Scalars['Int']['output'];
  total_counters: Array<Counter>;
  total_days: Scalars['Int']['output'];
  total_days_with_reports: Scalars['Int']['output'];
  total_fuel: Scalars['Float']['output'];
};

export type DailyReportItem = {
  __typename: 'DailyReportItem';
  item?: Maybe<DailyReport>;
};

export type DailyReportItems = {
  __typename: 'DailyReportItems';
  items: Array<Maybe<DailyReport>>;
};

export type DailyReportResponse = DailyReportItem;

export type DailyTelemetry = {
  __typename: 'DailyTelemetry';
  DEF_remaining_percentage?: Maybe<Scalars['Float']['output']>;
  DEF_tank_capacity?: Maybe<Scalars['Float']['output']>;
  counter_offset: Scalars['Float']['output'];
  cumulative_distance_traveled_km?: Maybe<Scalars['Float']['output']>;
  cumulative_fuel_consumed_lts?: Maybe<Scalars['Float']['output']>;
  cumulative_idle_hours?: Maybe<Scalars['Float']['output']>;
  cumulative_idle_non_operating_hours?: Maybe<Scalars['Float']['output']>;
  cumulative_load_count?: Maybe<Scalars['Int']['output']>;
  cumulative_operating_hours?: Maybe<Scalars['Float']['output']>;
  cumulative_payload_moved_kg?: Maybe<Scalars['Float']['output']>;
  cumulative_power_takeoff_hours?: Maybe<Scalars['Float']['output']>;
  daily_contact_hours?: Maybe<Scalars['Float']['output']>;
  daily_distance_traveled_km?: Maybe<Scalars['Float']['output']>;
  daily_fuel_consumed_lts?: Maybe<Scalars['Float']['output']>;
  daily_idle_hours?: Maybe<Scalars['Float']['output']>;
  daily_idle_non_operating_hours?: Maybe<Scalars['Float']['output']>;
  daily_maximum_speed_km_h?: Maybe<Scalars['Float']['output']>;
  daily_operating_hours?: Maybe<Scalars['Float']['output']>;
  device_name?: Maybe<Scalars['String']['output']>;
  device_serial_number?: Maybe<Scalars['String']['output']>;
  end_of_day: Scalars['DateTimeISO']['output'];
  engine_ignition_status?: Maybe<EngineIgnitionStatus>;
  flespi_id: Scalars['ID']['output'];
  fuel_remaining_percentage?: Maybe<Scalars['Float']['output']>;
  fuel_tank_capacity?: Maybe<Scalars['Float']['output']>;
  machine_id: Scalars['Int']['output'];
  position?: Maybe<Position>;
  project_at_day?: Maybe<Project>;
  telemetry_provider: TmProvider;
  vin?: Maybe<Scalars['String']['output']>;
  working_intervals?: Maybe<Array<WorkingInterval>>;
};

export type DailyTelemetryGroup = {
  __typename: 'DailyTelemetryGroup';
  machine: Machine;
  telemetry: Array<DailyTelemetry>;
};

export type DailyUsageActivity = {
  __typename: 'DailyUsageActivity';
  datetime: Scalars['DateTime']['output'];
  report: MyDailyReportSummary;
};

export type DashBoard = OtherProjectsStats | ProjectStats;

export type DashBoardConnection = {
  __typename: 'DashBoardConnection';
  items: Array<DashBoard>;
  totals: TotalCompanyStats;
};

export enum DataType {
  Boolean = 'boolean',
  Number = 'number',
  Select = 'select',
  String = 'string'
}

export type DataUpload = {
  __typename: 'DataUpload';
  statusId: Scalars['ID']['output'];
  templateUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type DateInSequence = {
  __typename: 'DateInSequence';
  type: PeriodType;
  value: Scalars['LocalDate']['output'];
};

export type DeleteIds = {
  __typename: 'DeleteIds';
  ids: Array<Scalars['Int']['output']>;
};

export type DeleteMachineConsumablePayload = MachineConsumableItem | ResourceInUseError;

export type DeletePayload = DeleteIds | ResourceInUseError;

export type DeleteRentalParameterValuePayload = {
  __typename: 'DeleteRentalParameterValuePayload';
  deleted_count: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteServiceReportPayload = {
  __typename: 'DeleteServiceReportPayload';
  id: Scalars['Int']['output'];
};

export type DeleteWorkOrderPayload = IdUnionWrapper | NotAllowedError;

export type DisableBilderitModuleInput = {
  company_id: Scalars['Int']['input'];
  module_id: BilderitModuleId;
};

export type DisableToCreateCompanyInput = {
  email: Scalars['String']['input'];
};

export type Document = {
  __typename: 'Document';
  expiration_date?: Maybe<Scalars['LocalDate']['output']>;
  files: Array<File>;
  id: Scalars['ID']['output'];
  is_current: Scalars['Boolean']['output'];
  machine?: Maybe<Machine>;
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  scope: DocumentScope;
  superseded_by?: Maybe<Scalars['ID']['output']>;
  tags: Array<Tag>;
  user?: Maybe<User>;
};

export type DocumentConnection = {
  __typename: 'DocumentConnection';
  items: Array<Document>;
};

export type DocumentPayload = ItemDocument;

export enum DocumentScope {
  Company = 'COMPANY',
  Machine = 'MACHINE',
  Project = 'PROJECT',
  User = 'USER'
}

export type DuplicatedEntryError = Error & {
  __typename: 'DuplicatedEntryError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type DuplicatedMachineError = Error & {
  __typename: 'DuplicatedMachineError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type DuplicatedProjectError = Error & {
  __typename: 'DuplicatedProjectError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type DuplicatedReportDateError = {
  __typename: 'DuplicatedReportDateError';
  message: Scalars['String']['output'];
};

export type DuplicatedRoleError = Error & {
  __typename: 'DuplicatedRoleError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type EffectiveParameterValue = {
  __typename: 'EffectiveParameterValue';
  applies_to_counter_type?: Maybe<CounterType>;
  applies_to_group?: Maybe<MachineGroup>;
  applies_to_type_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  parameter_def: RentalParameterDefinition;
  priority: Scalars['Int']['output'];
  scope_business_unit_id?: Maybe<Scalars['Int']['output']>;
  scope_company_id?: Maybe<Scalars['Int']['output']>;
  scope_project_id?: Maybe<Scalars['Int']['output']>;
  target_machine_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type Employee = EmployeeInterface & {
  __typename: 'Employee';
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['LocalDate']['output']>;
  cuil?: Maybe<Scalars['String']['output']>;
  dni: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Pedido de hacer propia la identidad. Null salvo para super root. */
  identity_claim?: Maybe<IdentityClaim>;
  is_managed: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  roles: Array<Maybe<Role>>;
  username: Scalars['String']['output'];
};

export type EmployeeInterface = {
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['LocalDate']['output']>;
  cuil?: Maybe<Scalars['String']['output']>;
  dni: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  roles: Array<Maybe<Role>>;
  username: Scalars['String']['output'];
};

export type EnableBilderitModuleInput = {
  company_id: Scalars['Int']['input'];
  end_date?: InputMaybe<Scalars['LocalDate']['input']>;
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  module_id: BilderitModuleId;
};

export type EnableToCreateCompanyInput = {
  email: Scalars['String']['input'];
  end_date: Scalars['LocalDate']['input'];
  is_demo: Scalars['Boolean']['input'];
  modules: Array<BilderitModuleId>;
};

export enum EngineIgnitionStatus {
  Off = 'OFF',
  Running = 'RUNNING'
}

export type EngineIgnitionStatusSnapshot = {
  __typename: 'EngineIgnitionStatusSnapshot';
  datetime_utc: Scalars['DateTime']['output'];
  value: EngineIgnitionStatus;
};

export type Error = {
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export enum ErrorCode {
  BilderitPlanAlreadyCopiedError = 'BilderitPlanAlreadyCopiedError',
  ConsumablesConflictError = 'ConsumablesConflictError',
  DuplicatedEntryError = 'DuplicatedEntryError',
  DuplicatedMachineError = 'DuplicatedMachineError',
  DuplicatedProjectNameError = 'DuplicatedProjectNameError',
  DuplicatedRoleError = 'DuplicatedRoleError',
  InternalServerError = 'InternalServerError',
  NotAllowedError = 'NotAllowedError',
  NotFoundDailyReportError = 'NotFoundDailyReportError',
  NotFoundInvitationError = 'NotFoundInvitationError',
  NotFoundRoleError = 'NotFoundRoleError',
  ProfileDataMissingError = 'ProfileDataMissingError',
  ResourceInUseError = 'ResourceInUseError',
  UserNotSignedUpError = 'UserNotSignedUpError',
  WorkOrderStatusChangeError = 'WorkOrderStatusChangeError'
}

export type Facet = {
  __typename: 'Facet';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type FacetGroup = {
  facets: Array<Facet>;
  field: Scalars['String']['output'];
};

export type FacetedResponse = {
  facets: Array<FacetGroup>;
};

export type File = {
  __typename: 'File';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type FilterChecklistTemplates = {
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FilterChecklists = {
  created_by_me?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  has_failures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inclusion filter ("any of") — empty/absent means no filter. */
  machine_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Inclusion filter ("any of") — empty/absent means no filter. */
  project_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  /** Inclusion filter ("any of") — empty/absent means no filter. */
  template_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type FilterDailyReports = {
  end_date?: InputMaybe<Scalars['LocalDate']['input']>;
  group?: InputMaybe<MachineGroup>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<MachineReportStatus>;
};

export type FilterDailyReportsByDayStats = {
  group?: InputMaybe<MachineGroup>;
};

export type FilterDateRange = {
  end_date: Scalars['LocalDate']['input'];
  start_date: Scalars['LocalDate']['input'];
};

export type FilterEmployee = {
  query?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<RoleNames>>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFuelTanks = {
  fuel_participation?: InputMaybe<FuelParticipation>;
  id?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FilterMachine = {
  fuel_participations?: InputMaybe<Array<InputMaybe<FuelParticipation>>>;
  group?: InputMaybe<MachineGroup>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FilterMachineConsumables = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FilterMachineHistory = {
  /** Required unless `latest` is set; ignored when it is. */
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  kinds?: InputMaybe<Array<MachineHistoryEventKind>>;
  /**
   * When set, return the newest N events regardless of date, and ignore
   * start_date/end_date. Facets then describe those N events, not all
   * history.
   */
  latest?: InputMaybe<Scalars['Int']['input']>;
  machine_id: Scalars['Int']['input'];
  project_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  reporter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Required unless `latest` is set; ignored when it is. */
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterMachineNoticeDashboard = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  has_linked_ot?: InputMaybe<Scalars['Boolean']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<MachineNoticeDashboardMode>;
  query?: InputMaybe<Scalars['String']['input']>;
  reporter_id?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Array<MachineNoticeSeverity>>;
  sort?: InputMaybe<MachineNoticeDashboardSort>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<MachineNoticeStatus>>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FilterMachineNotices = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  has_linked_ot?: InputMaybe<Scalars['Boolean']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reporter_id?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Array<MachineNoticeSeverity>>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<MachineNoticeStatus>>;
};

export type FilterMachineParts = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FilterMaintenancePlans = {
  brand?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MaintenancePlanStatus>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterMyDailyReports = {
  end_date?: InputMaybe<Scalars['LocalDate']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<MachineReportStatus>;
};

export type FilterMyMachineNotices = {
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Array<MachineNoticeSeverity>>;
  status?: InputMaybe<Array<MachineNoticeStatus>>;
};

export type FilterPagination = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterUser = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FilterWorkOrders = {
  end_date?: InputMaybe<Scalars['LocalDate']['input']>;
  start_date?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<Array<WorkOrderStatus>>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FloatSnapshot = {
  __typename: 'FloatSnapshot';
  datetime_utc: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type ForceApproveCertificationInput = {
  certification_id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type ForceApproveCertificationResponse = {
  __typename: 'ForceApproveCertificationResponse';
  certification: RentalCertification;
  skipped_reviewer_count: Scalars['Int']['output'];
};

export type ForceRejectCertificationInput = {
  certification_id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type ForceRejectCertificationResponse = {
  __typename: 'ForceRejectCertificationResponse';
  certification: RentalCertification;
};

export type FuelCostProjectSetting = {
  __typename: 'FuelCostProjectSetting';
  effectiveValue?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  projectScopedValue?: Maybe<Scalars['Float']['output']>;
};

export type FuelCostSettingsOverview = {
  __typename: 'FuelCostSettingsOverview';
  companyValue?: Maybe<Scalars['Float']['output']>;
  projects: Array<FuelCostProjectSetting>;
};

export type FuelDispatchActivity = {
  __typename: 'FuelDispatchActivity';
  datetime: Scalars['DateTime']['output'];
  report: FuelDispatchedReport;
};

export type FuelDispatchedReport = {
  __typename: 'FuelDispatchedReport';
  created_by: Employee;
  datetime: Scalars['DateTime']['output'];
  destination: Machine;
  destination_counter?: Maybe<Counter>;
  destination_project: Project;
  destination_stock?: Maybe<FuelStock>;
  flowmeter_end: Scalars['Float']['output'];
  flowmeter_start: Scalars['Float']['output'];
  fuel_type: FuelType;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  photos: Array<File>;
  prev_destination_counter?: Maybe<Counter>;
  provider?: Maybe<FuelProvider>;
  source?: Maybe<Machine>;
  source_project?: Maybe<Project>;
  source_stock?: Maybe<FuelStock>;
  verified_by?: Maybe<Employee>;
};

export enum FuelParticipation {
  CompanyStorage = 'company_storage',
  Consumer = 'consumer',
  None = 'none',
  Storage = 'storage'
}

export type FuelProvider = {
  __typename: 'FuelProvider';
  comments?: Maybe<Scalars['String']['output']>;
  company: Company;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  last_known_flowmeter: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FuelProvidersResponse = {
  __typename: 'FuelProvidersResponse';
  items: Array<Maybe<FuelProvider>>;
};

export enum FuelSourceType {
  Provider = 'PROVIDER',
  Tank = 'TANK'
}

export type FuelSourcesResponse = {
  __typename: 'FuelSourcesResponse';
  providers: Array<FuelProvider>;
  tanks: Array<Machine>;
};

export type FuelStock = {
  __typename: 'FuelStock';
  end: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
};

export enum FuelType {
  Gasoil = 'gasoil',
  Na = 'na',
  Nafta = 'nafta'
}

export enum Gender {
  Female = 'female',
  Male = 'male'
}

export type GetCertificationNotificationRecipientsResponse = {
  __typename: 'GetCertificationNotificationRecipientsResponse';
  audiences: Array<CertificationNotificationAudience>;
};

export type GetDocumentsFilter = {
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<DocumentScope>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GetFuelDispatchedReports = {
  __typename: 'GetFuelDispatchedReports';
  items: Array<Maybe<FuelDispatchedReport>>;
};

export type GetFuelDispatchedReportsFilter = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  source_type?: InputMaybe<FuelSourceType>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetFuelDispatchedReportsReponse = GetFuelDispatchedReports;

export type GetMachineByNameOfflineFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetMachinesFuelDashboardFilter = {
  end_date: Scalars['LocalDate']['input'];
  start_date: Scalars['LocalDate']['input'];
};

export type GetMe = {
  __typename: 'GetMe';
  item: Me;
};

export type GetMeResponse = GetMe | ProfileDataMissingError | ServerError | UserNotSignedUpError;

export type GetRentalByProjectInput = {
  month: Scalars['String']['input'];
  project_id: Scalars['Int']['input'];
};

export type GetRentalByProjectResponse = {
  __typename: 'GetRentalByProjectResponse';
  machines_rental: Array<MachineRental>;
  project: Project;
};

export type GetRentalCertificationResponse = {
  __typename: 'GetRentalCertificationResponse';
  certification: RentalCertification;
  items: Array<RentalCertificationItemSnapshot>;
  relocations: Array<RentalCertificationRelocationSnapshot>;
};

export type GetRentalParameterByScopeInput = {
  business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GetRentalParameterEffectiveValuesByMachineIdsResponse = {
  __typename: 'GetRentalParameterEffectiveValuesByMachineIdsResponse';
  items: Array<MachineWithEffectiveParameterValues>;
};

export type GetRentalParameterEffectiveValuesByScopeResponse = {
  __typename: 'GetRentalParameterEffectiveValuesByScopeResponse';
  items: Array<EffectiveParameterValue>;
};

export type GetStockControlReports = {
  __typename: 'GetStockControlReports';
  items: Array<Maybe<StockControlReport>>;
};

export type GetStockControlReportsFilter = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetStockControlReportsReponse = GetStockControlReports;

export type GetTanksDashboardFilter = {
  end_date: Scalars['LocalDate']['input'];
  start_date: Scalars['LocalDate']['input'];
};

export type GetTelemetryDevicesFilter = {
  category: TelemetryDeviceCategory;
};

export type GetTimeSeriesByBilderitConnectDeviceIdParams = {
  from_utc: Scalars['DateTime']['input'];
  to_utc: Scalars['DateTime']['input'];
};

export type GetUploadTargetInput = {
  company_id: Scalars['Int']['input'];
  content_type: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
};

export type IdUnionWrapper = {
  __typename: 'IDUnionWrapper';
  value: Scalars['ID']['output'];
};

export type IdentityClaim = {
  __typename: 'IdentityClaim';
  kind: IdentityClaimKind;
  requested_email: Scalars['String']['output'];
};

export enum IdentityClaimKind {
  FreeEmail = 'FREE_EMAIL',
  Merge = 'MERGE'
}

export type ImportBilderitMaintenancePlanInput = {
  company_id: Scalars['Int']['input'];
  import_consumables: Scalars['Boolean']['input'];
  import_consumables_options?: InputMaybe<ImportConsumablesOptionsInput>;
  on_duplicate_plan: OnDuplicatePlan;
  plan_id: Scalars['Int']['input'];
};

export type ImportBilderitMaintenancePlanResponse = BilderitPlanAlreadyCopiedError | ConsumablesConflictError | DuplicatedEntryError | MaintenancePlan;

export type ImportConsumablesOptionsInput = {
  on_conflict: OnConsumableConflict;
  with_equivalences: Scalars['Boolean']['input'];
};

export type IncomingMerge = {
  __typename: 'IncomingMerge';
  company_name: Scalars['String']['output'];
  managed_username: Scalars['String']['output'];
};

export type InitCaseConnectionResponse = {
  __typename: 'InitCaseConnectionResponse';
  access_token: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['Float']['output'];
  refresh_token: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type InitJohnDeereConnectionResponse = {
  __typename: 'InitJohnDeereConnectionResponse';
  access_token: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Float']['output']>;
  expires_in: Scalars['Float']['output'];
  org_connection_redirect_url?: Maybe<Scalars['String']['output']>;
  refresh_token: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type IntSnapshot = {
  __typename: 'IntSnapshot';
  datetime_utc: Scalars['DateTime']['output'];
  value: Scalars['Int']['output'];
};

export type IntegrationProviderConfig = {
  __typename: 'IntegrationProviderConfig';
  fields: Array<IntegrationProviderField>;
  provider: Scalars['String']['output'];
};

export type IntegrationProviderField = {
  __typename: 'IntegrationProviderField';
  default_value?: Maybe<Scalars['String']['output']>;
  field_type: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  visible_when?: Maybe<IntegrationProviderFieldCondition>;
};

export type IntegrationProviderFieldCondition = {
  __typename: 'IntegrationProviderFieldCondition';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IntegrationSyncRun = {
  __typename: 'IntegrationSyncRun';
  capability: Scalars['String']['output'];
  connection_id: Scalars['ID']['output'];
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  started_at: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['JSON']['output']>;
};

export type IntegrationTelemetryDevice = TelemetryDevice & {
  __typename: 'IntegrationTelemetryDevice';
  btrack_unit_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  ident: Scalars['String']['output'];
  integration: Scalars['String']['output'];
  last_activity_at?: Maybe<Scalars['DateTime']['output']>;
  last_horometer?: Maybe<Scalars['Float']['output']>;
  last_horometer_at?: Maybe<Scalars['DateTime']['output']>;
  last_odometer?: Maybe<Scalars['Float']['output']>;
  last_odometer_at?: Maybe<Scalars['DateTime']['output']>;
  links: Array<BilderitConnectDevice>;
  name: Scalars['String']['output'];
  protocol: Scalars['String']['output'];
};

export type Invitation = {
  __typename: 'Invitation';
  business_unit?: Maybe<BusinessUnit>;
  company: Company;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  project?: Maybe<Project>;
  role: RoleNames;
};

/** El secreto se muestra una sola vez: Bilderit no lo conserva. */
export type IssuedPublicApiKey = {
  __typename: 'IssuedPublicApiKey';
  key: PublicApiKey;
  secret: Scalars['String']['output'];
};

export type ItemDocument = {
  __typename: 'ItemDocument';
  item: Document;
};

export type ItemMachine = {
  __typename: 'ItemMachine';
  item?: Maybe<Machine>;
};

export type ItemWorkOrder = {
  __typename: 'ItemWorkOrder';
  item: WorkOrder;
};

export type ItemsWorkOrder = {
  __typename: 'ItemsWorkOrder';
  items: Array<WorkOrder>;
};

export type LinkDeviceToMachineInput = {
  flespi_id: Scalars['Int']['input'];
  machine_id: Scalars['Int']['input'];
};

export type LinkMachineWithTmProviderInput = {
  machineId: Scalars['Int']['input'];
  provider: TmProvider;
  providerId: Scalars['ID']['input'];
};

export type Location = {
  __typename: 'Location';
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
};

export type MpProgram = {
  __typename: 'MPProgram';
  actions?: Maybe<Array<Maybe<ProgramAction>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  multiplier: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type MpProgramInput = {
  actions: Array<ProgramActionInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  multiplier: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type Machine = {
  __typename: 'Machine';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  archived_by?: Maybe<Scalars['Int']['output']>;
  assigned?: Maybe<Employee>;
  bilderit_connect_devices: Array<BilderitConnectDevice>;
  brand: Scalars['String']['output'];
  btrack_unit_id?: Maybe<Scalars['ID']['output']>;
  chasis_number?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  counter: Counter;
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['Int']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  display_type?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  engine_number?: Maybe<Scalars['String']['output']>;
  external_source?: Maybe<MachineExternalSource>;
  extra_data?: Maybe<Scalars['JSONObject']['output']>;
  fuel_capacity?: Maybe<Scalars['Float']['output']>;
  fuel_participation?: Maybe<FuelParticipation>;
  fuel_type?: Maybe<FuelType>;
  id: Scalars['Int']['output'];
  is_archived: Scalars['Boolean']['output'];
  last_computed_fuel_stock?: Maybe<Scalars['Float']['output']>;
  last_computed_fuel_stock_on?: Maybe<Scalars['DateTime']['output']>;
  last_counter_from_fuel_report?: Maybe<MachineCounter>;
  last_counter_from_usage_report?: Maybe<MachineCounter>;
  last_counters: Array<MachineCounter>;
  last_known_flowmeter?: Maybe<Scalars['Float']['output']>;
  last_known_flowmeter_on?: Maybe<Scalars['DateTime']['output']>;
  last_measured_fuel_stock?: Maybe<Scalars['Float']['output']>;
  last_measured_fuel_stock_on?: Maybe<Scalars['DateTime']['output']>;
  last_service?: Maybe<ServiceReport>;
  last_status: MachineReportStatus;
  last_status_on: Scalars['LocalDate']['output'];
  maintenance_plan?: Maybe<MaintenancePlan>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  next_mp_sequence_index?: Maybe<Scalars['Int']['output']>;
  next_services: Array<NextService>;
  observations?: Maybe<Scalars['String']['output']>;
  open_preventive_maintenance_work_orders: Array<WorkOrder>;
  owner: Scalars['String']['output'];
  ownership_type?: Maybe<OwnershipType>;
  ownership_type_other?: Maybe<Scalars['String']['output']>;
  photos: Array<File>;
  power: Scalars['Float']['output'];
  preferred_counter_type: CounterType;
  project?: Maybe<Project>;
  replacement_value: Scalars['Float']['output'];
  serial_number?: Maybe<Scalars['String']['output']>;
  service_sequence: Array<ServiceSequenceItem>;
  type: MachineType;
  weight?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};


export type MachineNext_ServicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** A machine assignment to a project. */
export type MachineAssignmentHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineAssignmentHistoryEvent';
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  report: MachineAssignmentReport;
};

export type MachineAssignmentReport = {
  __typename: 'MachineAssignmentReport';
  end_date?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['Int']['output'];
  machine: Machine;
  project: Project;
  start_date: Scalars['LocalDate']['output'];
  user: Employee;
};

/** An unpaired check-in (no check-out for its deployment in range). */
export type MachineCheckInHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineCheckInHistoryEvent';
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  report: MoveReport;
};

/** An unpaired check-out. */
export type MachineCheckOutHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineCheckOutHistoryEvent';
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  report: MoveReport;
};

export type MachineChecklistAvailability = {
  __typename: 'MachineChecklistAvailability';
  machine_id: Scalars['Int']['output'];
  template_ids: Array<Scalars['ID']['output']>;
};

/** A completed checklist on the machine. */
export type MachineChecklistHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineChecklistHistoryEvent';
  checklist: Checklist;
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
};

export type MachineConsumable = {
  __typename: 'MachineConsumable';
  brand?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  description?: Maybe<Scalars['String']['output']>;
  equivalences: Array<MachineConsumable>;
  id: Scalars['Int']['output'];
  imported_from_id?: Maybe<Scalars['Int']['output']>;
  internal_code?: Maybe<Scalars['ID']['output']>;
  manufacturer_code?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type MachineConsumableConnection = {
  __typename: 'MachineConsumableConnection';
  items?: Maybe<Array<Maybe<MachineConsumable>>>;
};

export type MachineConsumableItem = {
  __typename: 'MachineConsumableItem';
  item?: Maybe<MachineConsumable>;
};

export type MachineConsumableRef = {
  id: Scalars['Int']['input'];
};

export type MachineCounter = {
  __typename: 'MachineCounter';
  datetime: Scalars['DateTime']['output'];
  source: CounterSource;
  type: CounterType;
  value: Scalars['Float']['output'];
};

export type MachineDayReportSummary = {
  __typename: 'MachineDayReportSummary';
  av_cause?: Maybe<Scalars['String']['output']>;
  date: Scalars['LocalDate']['output'];
  has_comments?: Maybe<Scalars['Boolean']['output']>;
  has_filters?: Maybe<Scalars['Boolean']['output']>;
  has_grease?: Maybe<Scalars['Boolean']['output']>;
  has_photos?: Maybe<Scalars['Boolean']['output']>;
  has_tasks?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  num_photos?: Maybe<Scalars['Int']['output']>;
  os_cause?: Maybe<Scalars['String']['output']>;
  os_charge_type?: Maybe<OosChargeType>;
  project_id?: Maybe<Scalars['Int']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MachineReportStatus>;
  total_counters: Array<Counter>;
  total_counters_display?: Maybe<Scalars['String']['output']>;
  total_fuel?: Maybe<Scalars['Float']['output']>;
  total_motor_oil?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type MachineExternalSource = {
  __typename: 'MachineExternalSource';
  provider: Scalars['String']['output'];
  sync_status: MachineExternalSyncStatus;
};

export enum MachineExternalSyncStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED'
}

export enum MachineExtraDataFieldType {
  Boolean = 'Boolean',
  DateTime = 'DateTime',
  Decimal = 'Decimal',
  Integer = 'Integer',
  Text = 'Text'
}

export enum MachineGroup {
  ActivoFijo = 'ACTIVO_FIJO',
  Camion = 'CAMION',
  EquipoPesado = 'EQUIPO_PESADO',
  Movilidad = 'MOVILIDAD'
}

export type MachineGroupCount = {
  __typename: 'MachineGroupCount';
  count: Scalars['Int']['output'];
  group: MachineGroup;
};

export type MachineHistoryConnection = FacetedResponse & OffsetPaginatedResponse & {
  __typename: 'MachineHistoryConnection';
  /**
   * Counts per event kind. In range mode (`start_date`/`end_date`), counts
   * describe the WHOLE filtered range, not just this page. In `latest` mode,
   * counts describe only the N events returned — computing them over all of
   * history is exactly what `latest` mode exists to avoid.
   */
  facets: Array<MachineHistoryFacetGroup>;
  items: Array<MachineHistoryEvent>;
  page_info: PageInfo;
  /**
   * True when the range held more events than the server will return. Always
   * false in `latest` mode, since that result is bounded by construction, not
   * clipped by a cap.
   */
  truncated: Scalars['Boolean']['output'];
};

export type MachineHistoryEvent = {
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
};

export enum MachineHistoryEventKind {
  Assignment = 'ASSIGNMENT',
  Checklist = 'CHECKLIST',
  CheckIn = 'CHECK_IN',
  CheckOut = 'CHECK_OUT',
  MachineNotice = 'MACHINE_NOTICE',
  Move = 'MOVE',
  OutOfService = 'OUT_OF_SERVICE',
  Service = 'SERVICE',
  WorkOrder = 'WORK_ORDER'
}

export type MachineHistoryFacetGroup = FacetGroup & {
  __typename: 'MachineHistoryFacetGroup';
  facets: Array<Facet>;
  field: Scalars['String']['output'];
};

export type MachineKpiEntry = {
  __typename: 'MachineKpiEntry';
  kpis: MaintenanceKpiGroup;
  machine: Machine;
};

export type MachineMarkError = {
  __typename: 'MachineMarkError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type MachineMarkResult = {
  __typename: 'MachineMarkResult';
  error?: Maybe<MachineMarkError>;
  machine_id: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

/** A check-out paired with its check-in — the two rows of one deployment. */
export type MachineMoveHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineMoveHistoryEvent';
  checkin: MoveReport;
  checkout: MoveReport;
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
};

export type MachineNotice = {
  __typename: 'MachineNotice';
  business_unit: BusinessUnit;
  cancelled_by?: Maybe<Employee>;
  cancelled_on?: Maybe<Scalars['DateTime']['output']>;
  counter?: Maybe<Counter>;
  created_at: Scalars['DateTime']['output'];
  creator?: Maybe<Employee>;
  evidence_files: Array<File>;
  files: Array<File>;
  id: Scalars['Int']['output'];
  linked_work_order?: Maybe<WorkOrder>;
  machine: Machine;
  message: Scalars['String']['output'];
  project: Project;
  resolution_note?: Maybe<Scalars['String']['output']>;
  resolved_by?: Maybe<Employee>;
  resolved_on?: Maybe<Scalars['DateTime']['output']>;
  serial_number: Scalars['Int']['output'];
  severity: MachineNoticeSeverity;
  source_checklist_id?: Maybe<Scalars['ID']['output']>;
  source_type: MachineNoticeSourceType;
  source_usage_report_id?: Maybe<Scalars['Int']['output']>;
  status: MachineNoticeStatus;
  tags: Array<Tag>;
};

export type MachineNoticeAnalysisItem = {
  __typename: 'MachineNoticeAnalysisItem';
  date_of_first_occurrence: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id_of_first_occurrence: Scalars['Int']['output'];
  number_of_occurrences: Scalars['Int']['output'];
};

export type MachineNoticeDashboardConnection = OffsetPaginatedResponse & {
  __typename: 'MachineNoticeDashboardConnection';
  backlog_summary: MachineNoticeDashboardSummary;
  facets: Array<MachineNoticeFacetGroup>;
  items: Array<MachineNotice>;
  page_info: PageInfo;
  tag_facets: Array<MachineNoticeTagFacet>;
  warnings: MachineNoticeDashboardWarnings;
};

export enum MachineNoticeDashboardMode {
  History = 'HISTORY',
  Inbox = 'INBOX'
}

export enum MachineNoticeDashboardSort {
  CreatedOnAsc = 'CREATED_ON_ASC',
  CreatedOnDesc = 'CREATED_ON_DESC',
  Priority = 'PRIORITY'
}

export type MachineNoticeDashboardSummary = {
  __typename: 'MachineNoticeDashboardSummary';
  closed_today: Scalars['Int']['output'];
  critical_open: Scalars['Int']['output'];
  linked_ot: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  open_gt_7d: Scalars['Int']['output'];
  open_gt_30d: Scalars['Int']['output'];
  open_without_ot: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MachineNoticeDashboardWarnings = {
  __typename: 'MachineNoticeDashboardWarnings';
  open_outside_date_range: Scalars['Int']['output'];
};

export enum MachineNoticeFacetField {
  Severity = 'SEVERITY',
  Status = 'STATUS'
}

export type MachineNoticeFacetGroup = {
  __typename: 'MachineNoticeFacetGroup';
  facets: Array<Facet>;
  field: MachineNoticeFacetField;
};

/**
 * A notice reported on the machine, optionally linked to the work order it
 * produced.
 */
export type MachineNoticeHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineNoticeHistoryEvent';
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  notice: MachineNotice;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
};

export enum MachineNoticeSeverity {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Low = 'LOW',
  Warning = 'WARNING'
}

export enum MachineNoticeSourceType {
  Checklist = 'CHECKLIST',
  MigratedDailyReportComment = 'MIGRATED_DAILY_REPORT_COMMENT',
  User = 'USER'
}

export enum MachineNoticeStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type MachineNoticeTagFacet = {
  __typename: 'MachineNoticeTagFacet';
  count: Scalars['Int']['output'];
  tag: Tag;
};

export type MachineNoticeWorkOrderResult = {
  __typename: 'MachineNoticeWorkOrderResult';
  notice: MachineNotice;
  work_order: WorkOrder;
};

export type MachineNoticesAnalysisItem = {
  __typename: 'MachineNoticesAnalysisItem';
  machine_id: Scalars['Int']['output'];
  machine_name: Scalars['String']['output'];
  notable_notices: Array<MachineNoticeAnalysisItem>;
  recurring_issues: Array<MachineNoticeAnalysisItem>;
};

export type MachineNoticesDashboardAnalysisResponse = {
  __typename: 'MachineNoticesDashboardAnalysisResponse';
  analysis: Array<MachineNoticesAnalysisItem>;
  analyzed_notice_count: Scalars['Int']['output'];
  total_notice_count: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

/**
 * A period the machine spent out of service, identified by the OOS record
 * itself (not by any one daily report that references it).
 */
export type MachineOutOfServiceHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineOutOfServiceHistoryEvent';
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  report: OutOfServiceReport;
};

export type MachinePart = {
  __typename: 'MachinePart';
  compartment?: Maybe<Scalars['String']['output']>;
  default_consumable?: Maybe<MachineConsumable>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MachinePartConnection = {
  __typename: 'MachinePartConnection';
  items?: Maybe<Array<Maybe<MachinePart>>>;
};

export type MachinePartInput = {
  compartment: Scalars['String']['input'];
  default_consumable?: InputMaybe<MachineConsumableRef>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MachinePartItem = {
  __typename: 'MachinePartItem';
  item?: Maybe<MachinePart>;
};

export type MachinePartRef = {
  id: Scalars['ID']['input'];
};

export type MachineRental = {
  __typename: 'MachineRental';
  availability_coefficient?: Maybe<Scalars['Float']['output']>;
  billing_type: Scalars['String']['output'];
  certification_item_ref?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  days_in_project: Scalars['Int']['output'];
  days_to_charge: Scalars['Float']['output'];
  extra_hours_to_bill?: Maybe<Scalars['Float']['output']>;
  fixed_amount: Scalars['Float']['output'];
  hours_worked?: Maybe<Scalars['Float']['output']>;
  km_traveled?: Maybe<Scalars['Float']['output']>;
  machine: Machine;
  min_hours_to_bill?: Maybe<Scalars['Float']['output']>;
  monthly_reference_amount: Scalars['Float']['output'];
  oos_days_due_to_equipment: Scalars['Int']['output'];
  oos_days_due_to_project: Scalars['Int']['output'];
  regular_hours_to_bill?: Maybe<Scalars['Float']['output']>;
  rental_parameters: Scalars['JSON']['output'];
  resolved_counters?: Maybe<MachineResolvedRentalCounters>;
  total_amount: Scalars['Float']['output'];
  variable_amount: Scalars['Float']['output'];
  warnings: Array<RentalWarning>;
};

export enum MachineReportStatus {
  Available = 'available',
  OutOfService = 'out_of_service',
  Pending = 'pending',
  Unknown = 'unknown',
  Worked = 'worked'
}

export type MachineReportsBoard = {
  __typename: 'MachineReportsBoard';
  machine: Machine;
  reports: Array<MachineDayReportSummary>;
  stats: MachineReportsStats;
  total_days_with_reports_hs: Scalars['Int']['output'];
  total_days_with_reports_km: Scalars['Int']['output'];
};


export type MachineReportsBoardReportsArgs = {
  filter: FilterDateRange;
};


export type MachineReportsBoardStatsArgs = {
  filter: FilterDateRange;
};

export type MachineReportsBoardConnection = {
  __typename: 'MachineReportsBoardConnection';
  items: Array<Maybe<MachineReportsBoard>>;
};

export type MachineReportsStats = {
  __typename: 'MachineReportsStats';
  num_available_days: Scalars['Int']['output'];
  num_filters: Scalars['Int']['output'];
  num_greases: Scalars['Int']['output'];
  num_oos_days: NumOosDays;
  num_pending_days: Scalars['Int']['output'];
  num_worked_days: Scalars['Int']['output'];
  total_counters: Array<Counter>;
  total_counters_display?: Maybe<Scalars['String']['output']>;
  total_days: Scalars['Int']['output'];
  total_days_in_context: Scalars['Int']['output'];
  total_days_with_reports: Scalars['Int']['output'];
  total_fuel: Scalars['Float']['output'];
  total_hs: Scalars['Int']['output'];
  total_km: Scalars['Int']['output'];
  total_motor_oil: Scalars['Float']['output'];
};

export type MachineResolvedRentalCounters = {
  __typename: 'MachineResolvedRentalCounters';
  final?: Maybe<CounterValue>;
  final_candidates?: Maybe<Array<CounterValue>>;
  initial?: Maybe<CounterValue>;
  initial_candidates?: Maybe<Array<CounterValue>>;
};

/** A service report performed on the machine. */
export type MachineServiceHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineServiceHistoryEvent';
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  report: ServiceReport;
};

export type MachineType = {
  __typename: 'MachineType';
  accepts_available: Scalars['Boolean']['output'];
  accepts_oos: Scalars['Boolean']['output'];
  accepts_service: Scalars['Boolean']['output'];
  accepts_usage: Scalars['Boolean']['output'];
  group: MachineGroup;
  id: Scalars['Int']['output'];
  reported_daily: Scalars['Boolean']['output'];
  subtype?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type MachineWithEffectiveParameterValues = {
  __typename: 'MachineWithEffectiveParameterValues';
  items: Array<EffectiveParameterValue>;
  machine: Machine;
};

/** A closed work order performed on the machine. */
export type MachineWorkOrderHistoryEvent = MachineHistoryEvent & {
  __typename: 'MachineWorkOrderHistoryEvent';
  counter?: Maybe<Counter>;
  created_by?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  kind: MachineHistoryEventKind;
  occurred_at: Scalars['DateTime']['output'];
  project?: Maybe<Project>;
  work_order: WorkOrder;
};

export type MachinesFuelDashboard = {
  __typename: 'MachinesFuelDashboard';
  items?: Maybe<Array<Maybe<MachinesFuelDashboardItem>>>;
  /** Trend statistics comparing current period telemetry fuel consumption to previous period. */
  trend_stats?: Maybe<MachinesFuelDashboardTrendStats>;
};

export type MachinesFuelDashboardItem = {
  __typename: 'MachinesFuelDashboardItem';
  machine: Machine;
  telemetry_fuel_consumed: Scalars['Float']['output'];
  total_counter: Scalars['Float']['output'];
  total_fuel_in: Scalars['Float']['output'];
};

/** Period-over-period trend statistics for the machines fuel dashboard. */
export type MachinesFuelDashboardTrendStats = {
  __typename: 'MachinesFuelDashboardTrendStats';
  /** Percentage change in total telemetry fuel consumed compared to previous period */
  telemetry_fuel_change?: Maybe<Scalars['Float']['output']>;
};

export type MachinesStats = {
  __typename: 'MachinesStats';
  average_age?: Maybe<Scalars['Float']['output']>;
  num_fixed_assets: Scalars['Int']['output'];
  num_heavy_equipments: Scalars['Int']['output'];
  num_trucks: Scalars['Int']['output'];
  num_vehicles: Scalars['Int']['output'];
  total_rental_value: Scalars['Float']['output'];
  total_replacement_value: Scalars['Float']['output'];
};

export type MachinistDayWorkSummary = {
  __typename: 'MachinistDayWorkSummary';
  daily_reports: Array<DailyReport>;
  date: Scalars['LocalDate']['output'];
  has_reports: Scalars['Boolean']['output'];
  total_counters: Array<Counter>;
  total_counters_display?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
};

export type MachinistWorkBoard = {
  __typename: 'MachinistWorkBoard';
  rate_reported?: Maybe<Scalars['Float']['output']>;
  summaries: Array<MachinistDayWorkSummary>;
  user: Employee;
};


export type MachinistWorkBoardSummariesArgs = {
  filter: FilterDateRange;
};

export type MachinistWorkBoardConnection = {
  __typename: 'MachinistWorkBoardConnection';
  items: Array<MachinistWorkBoard>;
};

export type MaintenanceDashboardMetrics = {
  __typename: 'MaintenanceDashboardMetrics';
  current: MaintenanceDashboardSnapshot;
  history: Array<MaintenanceDashboardSnapshot>;
  /**
   * Timestamp of when the KPI data was last refreshed/computed.
   * Null if data is computed on-the-fly (no cached snapshot exists).
   */
  lastRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MaintenanceDashboardMetricsHistoryArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenanceDashboardSnapshot = {
  __typename: 'MaintenanceDashboardSnapshot';
  byMachine: Array<MachineKpiEntry>;
  global: MaintenanceKpiGroup;
  month: Scalars['String']['output'];
  page_info: PageInfo;
};

/**
 * Grupo de KPIs de mantenimiento.
 *
 * Criterios de cálculo por KPI:
 * - meanPeriodBetweenFailures (MTBF): Promedio de contador (hs/km) entre fallas.
 *   Periodo: últimos 12 meses terminando en el mes solicitado.
 * - meanTimeToRepair (MTTR): Promedio de días fuera de servicio por falla.
 *   Periodo: últimos 12 meses terminando en el mes solicitado.
 * - plannedMaintenancePercentage (PMP): % de OTs preventivas vs total.
 *   Periodo: solo el mes solicitado.
 * - meanServiceDeviation: Desviación promedio de los services preventivos.
 *   Periodo: solo el mes solicitado.
 * - backlogOtHours: Horas de trabajo pendientes en OTs abiertas.
 *   Periodo: acumulado hasta fin del mes solicitado (sin startDate).
 * - mechanicalAvailability: % de días disponible vs días totales.
 *   Periodo: solo el mes solicitado.
 */
export type MaintenanceKpiGroup = {
  __typename: 'MaintenanceKpiGroup';
  backlogOtHours?: Maybe<MaintenanceMetricResult>;
  meanPeriodBetweenFailures?: Maybe<Array<MaintenanceMetricResult>>;
  meanServiceDeviation?: Maybe<MaintenanceMetricResult>;
  meanTimeToRepair?: Maybe<MaintenanceMetricResult>;
  mechanicalAvailability?: Maybe<MaintenanceMetricResult>;
  plannedMaintenancePercentage?: Maybe<MaintenanceMetricResult>;
};

/** Result of refreshing the maintenance KPI snapshot. */
export type MaintenanceKpiRefreshResult = {
  __typename: 'MaintenanceKpiRefreshResult';
  durationMs: Scalars['Int']['output'];
  machineCount: Scalars['Int']['output'];
  refreshedAt: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
};

export type MaintenanceMetricResult = {
  __typename: 'MaintenanceMetricResult';
  calculationContext?: Maybe<CalculationContext>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
  unit: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type MaintenancePlan = {
  __typename: 'MaintenancePlan';
  assigned_to: Array<Machine>;
  base_period: Scalars['Float']['output'];
  brand_tags?: Maybe<Array<Maybe<Tag>>>;
  created?: Maybe<Created>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imported_by: Array<Company>;
  imported_from_id?: Maybe<Scalars['Int']['output']>;
  machine_parts?: Maybe<Array<Maybe<MachinePart>>>;
  modified?: Maybe<Modified>;
  num_machines?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<Company>;
  period_type: PeriodType;
  programs?: Maybe<Array<Maybe<MpProgram>>>;
  status: MaintenancePlanStatus;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title: Scalars['String']['output'];
  type: MaintenancePlanType;
  type_tags?: Maybe<Array<Maybe<Tag>>>;
};

export type MaintenancePlanConnection = {
  __typename: 'MaintenancePlanConnection';
  items?: Maybe<Array<Maybe<MaintenancePlan>>>;
};

export type MaintenancePlanItem = {
  __typename: 'MaintenancePlanItem';
  item?: Maybe<MaintenancePlan>;
};

export enum MaintenancePlanStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum MaintenancePlanType {
  ManagedByBilderit = 'MANAGED_BY_BILDERIT',
  ManagedByCompany = 'MANAGED_BY_COMPANY'
}

export type MarkMachinesForCertificationResponse = {
  __typename: 'MarkMachinesForCertificationResponse';
  marked_count: Scalars['Int']['output'];
  results: Array<MachineMarkResult>;
};

/** Un cliente OAuth del MCP (ChatGPT, Claude), como lo muestra el permiso. */
export type McpClient = {
  __typename: 'McpClient';
  /** La URL del documento de metadata del cliente. */
  clientId: Scalars['String']['output'];
  /** Vuelve a un proceso de la máquina de la persona (loopback). */
  isLocal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** El dominio al que vuelve la conexión. */
  redirectHost: Scalars['String']['output'];
};

export type Me = EmployeeInterface & {
  __typename: 'Me';
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['LocalDate']['output']>;
  can_create_company: Scalars['Boolean']['output'];
  cuil?: Maybe<Scalars['String']['output']>;
  dni: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identifier_hash: Scalars['String']['output'];
  /** Su pedido de hacer propia la identidad. */
  identity_claim?: Maybe<IdentityClaim>;
  /** Un pedido de unión de un usuario gestionado hacia su email. */
  incoming_merge?: Maybe<IncomingMerge>;
  invitations: Array<Maybe<Invitation>>;
  is_managed: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  /** El email nuevo que pidió soporte y todavía no confirmó. */
  pending_email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  roles: Array<Maybe<Role>>;
  username: Scalars['String']['output'];
};

export type MeItem = {
  __typename: 'MeItem';
  item: Me;
};

export type MergeIdentityClaimInput = {
  other_access_token: Scalars['String']['input'];
};

export type MergeTagsInput = {
  scope: TagScope;
  source_tag_ids: Array<Scalars['ID']['input']>;
  target_tag_id: Scalars['ID']['input'];
};

export type Modified = {
  __typename: 'Modified';
  at?: Maybe<Scalars['DateTime']['output']>;
  by?: Maybe<User>;
};

export type MoveMachineInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  entry_counter_type?: InputMaybe<CounterType>;
  entry_counter_value?: InputMaybe<Scalars['Float']['input']>;
  entry_date: Scalars['LocalDate']['input'];
  exit_counter_type?: InputMaybe<CounterType>;
  exit_counter_value?: InputMaybe<Scalars['Float']['input']>;
  exit_date?: InputMaybe<Scalars['LocalDate']['input']>;
  file_ids_entry_checkin: Array<Scalars['ID']['input']>;
  file_ids_entry_checkout: Array<Scalars['ID']['input']>;
  file_ids_exit_checkin: Array<Scalars['ID']['input']>;
  file_ids_exit_checkout: Array<Scalars['ID']['input']>;
  machine_id: Scalars['Int']['input'];
  to_project_id: Scalars['Int']['input'];
};

export type MoveReport = {
  __typename: 'MoveReport';
  comments?: Maybe<Scalars['String']['output']>;
  counter: Counter;
  created_by: Employee;
  files: Array<File>;
  from_project?: Maybe<Project>;
  id: Scalars['Int']['output'];
  paired_report?: Maybe<MoveReport>;
  to_project?: Maybe<Project>;
};

export type Mutation = {
  __typename: 'Mutation';
  acceptInvitation?: Maybe<AcceptInvitationResponse>;
  addAssignmentReport: Machine;
  addBilderitMaintenancePlan: MaintenancePlan;
  addBusinessUnit: BusinessUnit;
  addCertificationCopyRecipient: CertificationCopyRecipient;
  addChecklist: Checklist;
  addCompany?: Maybe<AddCompanyResponse>;
  addDailyReport?: Maybe<AuthAddDailyReportResponse>;
  addDailyReportOffline: AuthAddDailyReportResponse;
  addDocument: DocumentPayload;
  addFixedAsset?: Maybe<AddFixedAssetResponse>;
  addFuelDispatchedReport: AddFuelDispatchedReportPayload;
  addFuelProvider: FuelProvider;
  addHeavyEquipment?: Maybe<AddHeavyEquipmentResponse>;
  addMachineConsumable?: Maybe<AddMachineConsumablePayload>;
  addMachineNotice: MachineNotice;
  addMaintenancePlan?: Maybe<AddMaintenancePlanPayload>;
  addManagedEmployee: Employee;
  addMobility?: Maybe<AddMobilityResponse>;
  addOutOfServiceReportForDateRange?: Maybe<DailyReportItems>;
  addProject?: Maybe<AuthAddProjectResponse>;
  addProjectCostCenter: ProjectCostCenter;
  addRole?: Maybe<AuthAddRoleResponse>;
  addServiceReport: AddServiceReportPayload;
  addStockControlReport: AddStockControlReportPayload;
  addTag: Tag;
  addTagGroup: TagGroup;
  addTruck?: Maybe<AddTruckResponse>;
  addWorkOrder: AddWorkOrderPayload;
  archiveChecklistTemplate: ChecklistTemplate;
  archiveMachine: Machine;
  archiveProject: Project;
  assignMaintenancePlanBatch?: Maybe<AssignMaintenancePlanBatchPayload>;
  assignWorkOrder: AssignWorkOrderPayload;
  batchAddAvailableReport?: Maybe<BatchAddAvailableReportResponse>;
  batchDeleteCompanyMachineExtraData: Array<Scalars['ID']['output']>;
  batchUpsertCompanyMachineExtraData: Array<CompanyMachineExtraData>;
  calibrateTrackerDevice: TrackerTelemetryDevice;
  cancelIdentityClaim: Scalars['Boolean']['output'];
  cancelIdentityClaimForUser: Scalars['Boolean']['output'];
  cancelUserEmailChange: Scalars['Boolean']['output'];
  cancelWorkOrder: CancelWorkOrderPayload;
  changeCompanyRoot: Company;
  confirmEmailChange: Scalars['Boolean']['output'];
  confirmIdentityClaim: Scalars['Boolean']['output'];
  createChecklistTemplate: ChecklistTemplate;
  createPublicApiClient: PublicApiClient;
  createRentalParameterDefinition: RentalParameterDefinition;
  createWorkOrderFromMachineNotice: MachineNoticeWorkOrderResult;
  deleteAssignmentReport: Scalars['Int']['output'];
  deleteAvailableReport?: Maybe<AuthDeleteAvailableReportResponse>;
  deleteBusinessUnit: Scalars['Int']['output'];
  deleteCompanyIntegration: Scalars['Boolean']['output'];
  deleteCompanyInvitation: Result;
  deleteDailyReport?: Maybe<AuthDeleteDailyReportResponse>;
  deleteDocument: Scalars['ID']['output'];
  deleteDraftCertification: SuccessResult;
  deleteFuelDispatchedReport: Scalars['ID']['output'];
  deleteFuelProvider: Scalars['ID']['output'];
  deleteMachine: Result;
  deleteMachineConsumable?: Maybe<DeletePayload>;
  deleteMaintenancePlan: Result;
  deleteOutOfServiceReport?: Maybe<AuthDeleteOutOfServiceReportResponse>;
  deleteProjectCostCenter: Result;
  deleteRentalParameterDefinition: SuccessResult;
  deleteRentalParameterValues: DeleteRentalParameterValuePayload;
  deleteRole?: Maybe<AuthDeleteRoleResponse>;
  deleteServiceReport: DeleteServiceReportPayload;
  deleteStockControlReport: Scalars['ID']['output'];
  deleteUserByUsername: Scalars['String']['output'];
  deleteWorkOrder: DeleteWorkOrderPayload;
  disableBilderitModule: Scalars['String']['output'];
  disableToCreateCompany: Scalars['String']['output'];
  discardChecklistTemplateDraft: ChecklistTemplate;
  enableBilderitModule: Scalars['String']['output'];
  enableToCreateCompany: Scalars['String']['output'];
  forceApproveCertification: ForceApproveCertificationResponse;
  forceRejectCertification: ForceRejectCertificationResponse;
  generateTelemetryPDF: Result;
  getOrCreateDraftCertification: RentalCertification;
  importBilderitMaintenancePlan: ImportBilderitMaintenancePlanResponse;
  initCaseConnection?: Maybe<InitCaseConnectionResponse>;
  initJohnDeereConnection?: Maybe<InitJohnDeereConnectionResponse>;
  issuePublicApiKey: IssuedPublicApiKey;
  linkTelemetryDevicesToCompany: Result;
  linkToBTrack: Scalars['Int']['output'];
  markMachinesForCertification: MarkMachinesForCertificationResponse;
  mergeIdentityClaim: Scalars['Boolean']['output'];
  mergeTags: Tag;
  moveMachine: Machine;
  /**
   * Envía una previsualización del reporte indicado, con datos reales,
   * ÚNICAMENTE a la casilla del usuario autenticado. No dispara el envío
   * real a los suscriptos: para eso está el comando reports:trigger.
   */
  previewBilderitReport: Result;
  publishChecklistTemplate: ChecklistTemplate;
  /**
   * Manually refresh the maintenance KPI snapshot for a specific company and month.
   * This pre-computes all KPIs and stores them for fast retrieval.
   */
  refreshMaintenanceKpiSnapshot: MaintenanceKpiRefreshResult;
  registerPushSubscription: PushSubscription;
  registerWorkOrderTasks: RegisterWorkOrderTasksPayload;
  rejectInvitation?: Maybe<RejectInvitationResponse>;
  removeCertificationCopyRecipient: SuccessResult;
  removeCertificationReviewer: RemoveCertificationReviewerResponse;
  removeTelemetryDeviceLinks: Result;
  reprocessVisionLinkReportsByDate: VisionLinkReportsByDateResult;
  requestIdentityClaim: IdentityClaim;
  requestIdentityClaimForUser: IdentityClaim;
  requestUserEmailChange: Scalars['Boolean']['output'];
  resendCompanyInvitation: Result;
  resendSignupConfirmation: Scalars['Boolean']['output'];
  respondToMcpAuthorization: RespondToMcpAuthorizationPayload;
  reviewCertification: ReviewCertificationResponse;
  /** Irreversible. */
  revokePublicApiKey: PublicApiKey;
  /** Emite otra key del mismo cliente y le pone vencimiento a la vieja. */
  rotatePublicApiKey: IssuedPublicApiKey;
  saveChecklistTemplateDraft: ChecklistTemplate;
  /** Send a test notification to the CALLER'S OWN devices. Cannot target anyone else. */
  sendTestPushNotification: Scalars['Int']['output'];
  setActiveTelemetrySandboxScope: TelemetrySandboxRuntimeConfig;
  setChecklistTemplateAssignments: ChecklistTemplate;
  /**
   * Sets the fuel cost ($/L) for the given company, optionally scoped to a project.
   * When projectId is provided the value is stored at project scope;
   * otherwise it is stored at company scope.
   * Passing null clears the explicit value for that scope.
   */
  setFuelCostSetting: Result;
  setMachineFuelCapacity: Machine;
  setMachineTelemetryProviderOffset: Result;
  setMachinesFuelParticipation: Array<Machine>;
  setMaintenancePlanStatus: MaintenancePlan;
  setManagedEmployeePassword: Result;
  /** Opt in/out of a derived audience such as machinist-reminder. Per user, not per device. */
  setNotificationOptOut: Scalars['Boolean']['output'];
  /**
   * Replace the calling user's elective topic preferences wholesale.
   * Per-user: the session is the identity — no endpoint, no device id;
   * that is the BIL-4952 fix.
   */
  setNotificationPreferences: NotificationPreferences;
  setProjectCostCenterMode: Result;
  /** Sólo sobre una key vigente; null quita el vencimiento. */
  setPublicApiKeyExpiry: PublicApiKey;
  setRentalParameterValues: SetRentalParameterValuePayload;
  setSystemFlag: SystemFlag;
  setWorkOrderStatusClosed: SetWorkOrderStatusPayload;
  setWorkOrderStatusDraft: SetWorkOrderStatusPayload;
  setWorkOrderStatusInProgress: SetWorkOrderStatusPayload;
  setWorkOrderStatusToApprove: SetWorkOrderStatusPayload;
  setWorkOrderStatusToReview: SetWorkOrderStatusPayload;
  signOutEverywhere: Scalars['Boolean']['output'];
  submitCertificationForReview: SubmitCertificationForReviewResponse;
  subscribeToBilderitReport: BilderitReportSubscription;
  syncMachineCounters: Result;
  syncMachinesStatus: Result;
  triggerCompanyIntegrationSync: CompanyIntegration;
  triggerFleetSync: TriggerFleetSyncResult;
  unarchiveChecklistTemplate: ChecklistTemplate;
  unarchiveMachine: Machine;
  unarchiveProject: Project;
  unlinkFromBTrack: Scalars['Int']['output'];
  unmarkMachinesForCertification: UnmarkMachinesForCertificationResponse;
  unregisterPushSubscription: Scalars['Boolean']['output'];
  unregisterWorkOrderTasks: UnregisterWorkOrderTasksPayload;
  unsubscribeFromBilderitReport: Scalars['ID']['output'];
  updateBusinessUnit: BusinessUnit;
  updateCompany?: Maybe<AuthUpdateCompanyResponse>;
  updateDailyReport?: Maybe<AuthUpdateDailyReportResponse>;
  updateDocument: DocumentPayload;
  updateDocumentTags: ItemDocument;
  updateFederatedIdentityInformation?: Maybe<UpdateFederatedIdentityInformationResponse>;
  updateFixedAsset?: Maybe<UpdateFixedAssetResponse>;
  updateFuelDispatchedReport: UpdateFuelDispatchedReportPayload;
  updateFuelProvider: FuelProvider;
  updateHeavyEquipment?: Maybe<UpdateHeavyEquipmentResponse>;
  updateMachineConsumable?: Maybe<UpdateMachineConsumablePayload>;
  updateMachineNotice: MachineNotice;
  updateMachineNoticeStatus: MachineNotice;
  updateMaintenancePlan?: Maybe<UpdateMaintenancePlanPayload>;
  updateMaintenancePlanTags?: Maybe<UpdateMaintenancePlanPayload>;
  updateMe?: Maybe<UpdateMeResponse>;
  updateMobility?: Maybe<UpdateMobilityResponse>;
  updateMoveReport: MoveReport;
  updateNextService: UpdateNextServicePayload;
  updateOutOfServiceReport: DailyReportItems;
  updateProject?: Maybe<AuthUpdateProjectResponse>;
  updateProjectCostCenter: ProjectCostCenter;
  updatePublicApiClient: PublicApiClient;
  updateRentalParameterDefinition: RentalParameterDefinition;
  updateStockControlReport: UpdateStockControlReportPayload;
  updateTag: Tag;
  updateTagGroup: TagGroup;
  updateTelemetryDeviceLink: Result;
  updateTruck?: Maybe<UpdateTruckResponse>;
  updateUnconfirmedEmail: Scalars['Boolean']['output'];
  updateWorkOrder: UpdateWorkOrderPayload;
  updateWorkOrderTags: UpdateWorkOrderPayload;
  upsertCompanyIntegration: CompanyIntegration;
};


export type MutationAcceptInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddAssignmentReportArgs = {
  input: AddAssignmentReportInput;
};


export type MutationAddBilderitMaintenancePlanArgs = {
  input: AddBilderitMaintenancePlanInput;
};


export type MutationAddBusinessUnitArgs = {
  input: AddBusinessUnitInput;
};


export type MutationAddCertificationCopyRecipientArgs = {
  input: AddCertificationCopyRecipientInput;
};


export type MutationAddChecklistArgs = {
  input: AddChecklistInput;
};


export type MutationAddCompanyArgs = {
  input: AddCompanyInput;
};


export type MutationAddDailyReportArgs = {
  input: AddDailyReportInput;
};


export type MutationAddDailyReportOfflineArgs = {
  input: AddDailyReportOfflineInput;
};


export type MutationAddDocumentArgs = {
  input: AddDocumentInput;
};


export type MutationAddFixedAssetArgs = {
  input: AddFixedAssetInput;
};


export type MutationAddFuelDispatchedReportArgs = {
  input: AddFuelDispatchedReportInput;
};


export type MutationAddFuelProviderArgs = {
  input: AddFuelProviderInput;
};


export type MutationAddHeavyEquipmentArgs = {
  input: AddHeavyEquipmentInput;
};


export type MutationAddMachineConsumableArgs = {
  input: AddMachineConsumableInput;
};


export type MutationAddMachineNoticeArgs = {
  input: AddMachineNoticeInput;
};


export type MutationAddMaintenancePlanArgs = {
  input: AddMaintenancePlanInput;
};


export type MutationAddManagedEmployeeArgs = {
  input: AddManagedEmployeeInput;
};


export type MutationAddMobilityArgs = {
  input: AddMobilityInput;
};


export type MutationAddOutOfServiceReportForDateRangeArgs = {
  input: AddOutOfServiceReportForDateRangeInput;
};


export type MutationAddProjectArgs = {
  input: AddProjectInput;
};


export type MutationAddProjectCostCenterArgs = {
  input: AddProjectCostCenterInput;
};


export type MutationAddRoleArgs = {
  input: AddRoleInput;
};


export type MutationAddServiceReportArgs = {
  input: AddServiceReportInput;
};


export type MutationAddStockControlReportArgs = {
  input: AddStockControlReportInput;
};


export type MutationAddTagArgs = {
  input: AddTagInput;
};


export type MutationAddTagGroupArgs = {
  input: AddTagGroupInput;
};


export type MutationAddTruckArgs = {
  input: AddTruckInput;
};


export type MutationAddWorkOrderArgs = {
  input: AddWorkOrderInput;
};


export type MutationArchiveChecklistTemplateArgs = {
  template_id: Scalars['ID']['input'];
};


export type MutationArchiveMachineArgs = {
  machineId: Scalars['Int']['input'];
};


export type MutationArchiveProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type MutationAssignMaintenancePlanBatchArgs = {
  input: AssignMaintenancePlanBatchInput;
};


export type MutationAssignWorkOrderArgs = {
  input: AssignWorkOrderInput;
};


export type MutationBatchAddAvailableReportArgs = {
  input: BatchAddAvailableReportInput;
};


export type MutationBatchDeleteCompanyMachineExtraDataArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBatchUpsertCompanyMachineExtraDataArgs = {
  input: Array<AddCompanyMachineExtraDataInput>;
};


export type MutationCalibrateTrackerDeviceArgs = {
  id: Scalars['Int']['input'];
  input: CalibrateTrackerDeviceInput;
};


export type MutationCancelIdentityClaimForUserArgs = {
  input: CancelIdentityClaimForUserInput;
};


export type MutationCancelUserEmailChangeArgs = {
  user_id: Scalars['Int']['input'];
};


export type MutationCancelWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeCompanyRootArgs = {
  companyId: Scalars['Int']['input'];
  newRootId: Scalars['Int']['input'];
};


export type MutationConfirmIdentityClaimArgs = {
  input: ConfirmIdentityClaimInput;
};


export type MutationCreateChecklistTemplateArgs = {
  input: CreateChecklistTemplateInput;
};


export type MutationCreatePublicApiClientArgs = {
  input: CreatePublicApiClientInput;
};


export type MutationCreateRentalParameterDefinitionArgs = {
  input: CreateRentalParameterDefinitionInput;
};


export type MutationCreateWorkOrderFromMachineNoticeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAssignmentReportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAvailableReportArgs = {
  parentId: Scalars['Int']['input'];
};


export type MutationDeleteBusinessUnitArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCompanyIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDailyReportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDocumentArgs = {
  document_id: Scalars['ID']['input'];
};


export type MutationDeleteDraftCertificationArgs = {
  certification_id: Scalars['Int']['input'];
};


export type MutationDeleteFuelDispatchedReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFuelProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMachineArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMachineConsumableArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMaintenancePlanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteOutOfServiceReportArgs = {
  parentId: Scalars['Int']['input'];
};


export type MutationDeleteProjectCostCenterArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRentalParameterDefinitionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRentalParameterValuesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteRoleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteServiceReportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteStockControlReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserByUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationDeleteWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableBilderitModuleArgs = {
  input: DisableBilderitModuleInput;
};


export type MutationDisableToCreateCompanyArgs = {
  input: DisableToCreateCompanyInput;
};


export type MutationDiscardChecklistTemplateDraftArgs = {
  template_id: Scalars['ID']['input'];
};


export type MutationEnableBilderitModuleArgs = {
  input: EnableBilderitModuleInput;
};


export type MutationEnableToCreateCompanyArgs = {
  input: EnableToCreateCompanyInput;
};


export type MutationForceApproveCertificationArgs = {
  input: ForceApproveCertificationInput;
};


export type MutationForceRejectCertificationArgs = {
  input: ForceRejectCertificationInput;
};


export type MutationGenerateTelemetryPdfArgs = {
  companyId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  idleConsumptionRate?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};


export type MutationGetOrCreateDraftCertificationArgs = {
  month: Scalars['Date']['input'];
  ownership_group: RentalOwnershipGroup;
  project_id: Scalars['Int']['input'];
  vendor_filter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportBilderitMaintenancePlanArgs = {
  input: ImportBilderitMaintenancePlanInput;
};


export type MutationInitCaseConnectionArgs = {
  auth_code: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
};


export type MutationInitJohnDeereConnectionArgs = {
  auth_code: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
};


export type MutationIssuePublicApiKeyArgs = {
  clientId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationLinkTelemetryDevicesToCompanyArgs = {
  companyId: Scalars['Int']['input'];
  deviceIds: Array<Scalars['ID']['input']>;
};


export type MutationLinkToBTrackArgs = {
  tracker_id: Scalars['Int']['input'];
};


export type MutationMarkMachinesForCertificationArgs = {
  certification_id: Scalars['Int']['input'];
  machine_ids: Array<Scalars['Int']['input']>;
};


export type MutationMergeIdentityClaimArgs = {
  input: MergeIdentityClaimInput;
};


export type MutationMergeTagsArgs = {
  input: MergeTagsInput;
};


export type MutationMoveMachineArgs = {
  input: MoveMachineInput;
};


export type MutationPreviewBilderitReportArgs = {
  input: PreviewBilderitReportInput;
};


export type MutationPublishChecklistTemplateArgs = {
  template_id: Scalars['ID']['input'];
};


export type MutationRefreshMaintenanceKpiSnapshotArgs = {
  context: Context;
  month: Scalars['String']['input'];
};


export type MutationRegisterPushSubscriptionArgs = {
  input: RegisterPushSubscriptionInput;
};


export type MutationRegisterWorkOrderTasksArgs = {
  input: RegisterWorkOrderTasksInput;
};


export type MutationRejectInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCertificationCopyRecipientArgs = {
  certification_copy_id: Scalars['Int']['input'];
};


export type MutationRemoveCertificationReviewerArgs = {
  input: RemoveCertificationReviewerInput;
};


export type MutationRemoveTelemetryDeviceLinksArgs = {
  linkIds: Array<Scalars['ID']['input']>;
};


export type MutationReprocessVisionLinkReportsByDateArgs = {
  input: VisionLinkReportsByDateInput;
};


export type MutationRequestIdentityClaimArgs = {
  input: RequestIdentityClaimInput;
};


export type MutationRequestIdentityClaimForUserArgs = {
  input: RequestIdentityClaimForUserInput;
};


export type MutationRequestUserEmailChangeArgs = {
  email: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


export type MutationResendCompanyInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendSignupConfirmationArgs = {
  cognito_username: Scalars['String']['input'];
};


export type MutationRespondToMcpAuthorizationArgs = {
  input: RespondToMcpAuthorizationInput;
};


export type MutationReviewCertificationArgs = {
  input: ReviewCertificationInput;
};


export type MutationRevokePublicApiKeyArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  keyId: Scalars['Int']['input'];
  reason: PublicApiKeyRevocationReason;
};


export type MutationRotatePublicApiKeyArgs = {
  companyId: Scalars['Int']['input'];
  keyId: Scalars['Int']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveChecklistTemplateDraftArgs = {
  input: SaveChecklistTemplateDraftInput;
};


export type MutationSetActiveTelemetrySandboxScopeArgs = {
  scopeKey: Scalars['ID']['input'];
};


export type MutationSetChecklistTemplateAssignmentsArgs = {
  input: SetChecklistTemplateAssignmentsInput;
};


export type MutationSetFuelCostSettingArgs = {
  companyId: Scalars['Int']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationSetMachineFuelCapacityArgs = {
  input: SetMachineFuelCapacityInput;
};


export type MutationSetMachineTelemetryProviderOffsetArgs = {
  counter_offset: Scalars['Float']['input'];
  machineId: Scalars['Int']['input'];
};


export type MutationSetMachinesFuelParticipationArgs = {
  fuel_participation: FuelParticipation;
  ids: Array<Scalars['Int']['input']>;
};


export type MutationSetMaintenancePlanStatusArgs = {
  plan_id: Scalars['Int']['input'];
  status: MaintenancePlanStatus;
};


export type MutationSetManagedEmployeePasswordArgs = {
  input: SetManagedEmployeePasswordInput;
};


export type MutationSetNotificationOptOutArgs = {
  optedOut: Scalars['Boolean']['input'];
  topic: Scalars['String']['input'];
};


export type MutationSetNotificationPreferencesArgs = {
  topics: Array<PushTopicPreferenceInput>;
};


export type MutationSetProjectCostCenterModeArgs = {
  mode: CostCenterMode;
  projectId: Scalars['Int']['input'];
};


export type MutationSetPublicApiKeyExpiryArgs = {
  companyId: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  keyId: Scalars['Int']['input'];
};


export type MutationSetRentalParameterValuesArgs = {
  input: Array<SetRentalParameterValueInput>;
};


export type MutationSetSystemFlagArgs = {
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};


export type MutationSetWorkOrderStatusClosedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetWorkOrderStatusDraftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetWorkOrderStatusInProgressArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SetWorkOrderStatusInProgressInput>;
};


export type MutationSetWorkOrderStatusToApproveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetWorkOrderStatusToReviewArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SetWorkOrderStatusToReviewInput>;
};


export type MutationSignOutEverywhereArgs = {
  cognito_username: Scalars['String']['input'];
};


export type MutationSubmitCertificationForReviewArgs = {
  input: SubmitCertificationForReviewInput;
};


export type MutationSubscribeToBilderitReportArgs = {
  input: SubscribeToBilderitReportInput;
};


export type MutationSyncMachineCountersArgs = {
  input: SyncMachineCountersInput;
};


export type MutationSyncMachinesStatusArgs = {
  input: SyncMachinesStatusInput;
};


export type MutationTriggerCompanyIntegrationSyncArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerFleetSyncArgs = {
  company_id: Scalars['Int']['input'];
  dry_run: Scalars['Boolean']['input'];
};


export type MutationUnarchiveChecklistTemplateArgs = {
  template_id: Scalars['ID']['input'];
};


export type MutationUnarchiveMachineArgs = {
  input: UnarchiveMachineInput;
};


export type MutationUnarchiveProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type MutationUnlinkFromBTrackArgs = {
  tracker_id: Scalars['Int']['input'];
};


export type MutationUnmarkMachinesForCertificationArgs = {
  certification_id: Scalars['Int']['input'];
  machine_ids: Array<Scalars['Int']['input']>;
};


export type MutationUnregisterPushSubscriptionArgs = {
  endpoint: Scalars['String']['input'];
};


export type MutationUnregisterWorkOrderTasksArgs = {
  input: UnregisterWorkOrderTasksInput;
};


export type MutationUnsubscribeFromBilderitReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateBusinessUnitArgs = {
  id: Scalars['Int']['input'];
  input: UpdateBusinessUnitInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['Int']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateDailyReportArgs = {
  id: Scalars['Int']['input'];
  input: UpdateDailyReportInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentTagsArgs = {
  input: UpdateDocumentTagsInput;
};


export type MutationUpdateFederatedIdentityInformationArgs = {
  input: UpdateFederatedIdentityInformationInput;
};


export type MutationUpdateFixedAssetArgs = {
  id: Scalars['Int']['input'];
  input: UpdateFixedAssetInput;
};


export type MutationUpdateFuelDispatchedReportArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFuelDispatchedReportInput;
};


export type MutationUpdateFuelProviderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFuelProviderInput;
};


export type MutationUpdateHeavyEquipmentArgs = {
  id: Scalars['Int']['input'];
  input: UpdateHeavyEquipmentInput;
};


export type MutationUpdateMachineConsumableArgs = {
  id: Scalars['Int']['input'];
  input: UpdateMachineConsumableInput;
};


export type MutationUpdateMachineNoticeArgs = {
  id: Scalars['Int']['input'];
  input: UpdateMachineNoticeInput;
};


export type MutationUpdateMachineNoticeStatusArgs = {
  id: Scalars['Int']['input'];
  input: UpdateMachineNoticeStatusInput;
};


export type MutationUpdateMaintenancePlanArgs = {
  id: Scalars['Int']['input'];
  input: UpdateMaintenancePlanInput;
};


export type MutationUpdateMaintenancePlanTagsArgs = {
  input: UpdateMaintenancePlanTagsInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateMobilityArgs = {
  id: Scalars['Int']['input'];
  input: UpdateMobilityInput;
};


export type MutationUpdateMoveReportArgs = {
  id: Scalars['Int']['input'];
  input: UpdateMoveReportInput;
};


export type MutationUpdateNextServiceArgs = {
  input: UpdateNextServiceInput;
};


export type MutationUpdateOutOfServiceReportArgs = {
  input: UpdateOosReportInput;
  oosId: Scalars['Int']['input'];
};


export type MutationUpdateProjectArgs = {
  id: Scalars['Int']['input'];
  input: UpdateProjectInput;
};


export type MutationUpdateProjectCostCenterArgs = {
  id: Scalars['Int']['input'];
  input: UpdateProjectCostCenterInput;
};


export type MutationUpdatePublicApiClientArgs = {
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: UpdatePublicApiClientInput;
};


export type MutationUpdateRentalParameterDefinitionArgs = {
  id: Scalars['Int']['input'];
  input: UpdateRentalParameterDefinitionInput;
};


export type MutationUpdateStockControlReportArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStockControlReportInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTagGroupArgs = {
  input: UpdateTagGroupInput;
};


export type MutationUpdateTelemetryDeviceLinkArgs = {
  input: UpdateTelemetryDeviceLinkInput;
  linkId: Scalars['ID']['input'];
};


export type MutationUpdateTruckArgs = {
  id: Scalars['Int']['input'];
  input: UpdateTruckInput;
};


export type MutationUpdateUnconfirmedEmailArgs = {
  cognito_username: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationUpdateWorkOrderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderInput;
};


export type MutationUpdateWorkOrderTagsArgs = {
  input: UpdateWorkOrderTagsInput;
};


export type MutationUpsertCompanyIntegrationArgs = {
  input: UpsertCompanyIntegrationInput;
};

export type MyCertificatesToReviewFilter = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  ownership_group?: InputMaybe<RentalOwnershipGroup>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<RentalCertificationStatus>>;
};

export type MyDailyReportSummary = {
  __typename: 'MyDailyReportSummary';
  counter_end: Scalars['Float']['output'];
  counter_start: Scalars['Float']['output'];
  counter_type: CounterType;
  date: Scalars['LocalDate']['output'];
  machine: Machine;
  machine_report_id: Scalars['Int']['output'];
  project: Project;
  usage_report_id: Scalars['Int']['output'];
};

export type NewUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['LocalDate']['input']>;
  cuil?: InputMaybe<Scalars['String']['input']>;
  dni: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type NextService = {
  __typename: 'NextService';
  counter?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['LocalDate']['output']>;
  remaining: ServiceRemaining;
  service: ServiceSequenceItem;
};

export type NextServiceIn = {
  __typename: 'NextServiceIn';
  program: MpProgram;
  remaining: ServiceRemaining;
};

export type NotAllowedError = Error & {
  __typename: 'NotAllowedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NotFoundDailyReportError = Error & {
  __typename: 'NotFoundDailyReportError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NotFoundInvitationError = Error & {
  __typename: 'NotFoundInvitationError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NotFoundRoleError = Error & {
  __typename: 'NotFoundRoleError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Per-user elective preferences and derived-audience opt-outs. */
export type NotificationPreferences = {
  __typename: 'NotificationPreferences';
  /** Topics this user has opted OUT of. Only meaningful for derived audiences. */
  optedOutTopics: Array<Scalars['String']['output']>;
  topics: Array<PushTopicPreference>;
};

export type NumOosDays = {
  __typename: 'NumOOSDays';
  due_to_equipment: Scalars['Int']['output'];
  due_to_project: Scalars['Int']['output'];
};

export enum OosChargeType {
  DueToEquipment = 'DUE_TO_EQUIPMENT',
  DueToProject = 'DUE_TO_PROJECT'
}

export type OffsetPaginatedResponse = {
  page_info: PageInfo;
};

export type OffsetPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export enum OnConsumableConflict {
  Abort = 'ABORT',
  Overwrite = 'OVERWRITE',
  UseExisting = 'USE_EXISTING'
}

export enum OnDuplicatePlan {
  Abort = 'ABORT',
  Continue = 'CONTINUE'
}

export type OtherProjectsStats = {
  __typename: 'OtherProjectsStats';
  daily_stats: Array<Maybe<ProjectsDayStats>>;
  ids: Array<Scalars['Int']['output']>;
  machines_stats: MachinesStats;
  num_employees: Scalars['Int']['output'];
  num_machines: Scalars['Int']['output'];
  num_projects: Scalars['Int']['output'];
  reports_stats: ProjectsReportsStats;
};

export type OutOfServiceReport = {
  __typename: 'OutOfServiceReport';
  cause: Scalars['String']['output'];
  charge_type: OosChargeType;
  counter?: Maybe<Counter>;
  created_at: Scalars['DateTime']['output'];
  creator?: Maybe<Employee>;
  id: Scalars['Int']['output'];
  modifier?: Maybe<Employee>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum OwnershipType {
  Leased = 'Leased',
  Other = 'Other',
  Owned = 'Owned',
  PartnerOwned = 'Partner_Owned',
  Rented = 'Rented'
}

export type PageInfo = {
  __typename: 'PageInfo';
  current_page: Scalars['Int']['output'];
  items_per_page: Scalars['Int']['output'];
  total_items: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedUsers = OffsetPaginatedResponse & {
  __typename: 'PaginatedUsers';
  items: Array<User>;
  page_info: PageInfo;
};

export type PartialProfile = {
  __typename: 'PartialProfile';
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['LocalDate']['output']>;
  cuil?: Maybe<Scalars['String']['output']>;
  dni?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Un pedido de unión de un usuario gestionado hacia su email. */
  incoming_merge?: Maybe<IncomingMerge>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum PeriodType {
  CalendarDays = 'CALENDAR_DAYS',
  Counter = 'COUNTER'
}

export type Position = {
  __typename: 'Position';
  altitude?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type PositionSnapshot = {
  __typename: 'PositionSnapshot';
  altitude?: Maybe<Scalars['Float']['output']>;
  datetime_utc: Scalars['DateTime']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type PreviewBilderitReportInput = {
  company_id: Scalars['Int']['input'];
  /**
   * Requerido para UPCOMING_SERVICES y AI_MACHINE_NOTICES_WEEKLY_SUMMARY.
   * Opcional para DOCUMENTS_EXPIRING y MACHINE_NOTICES_DAILY (sin él, el
   * reporte cubre toda la compañía). Ignorado para TELEMETRY_MONTHLY.
   */
  project_id?: InputMaybe<Scalars['Int']['input']>;
  report_type: BilderitReportType;
};

export type ProfileDataMissingError = Error & {
  __typename: 'ProfileDataMissingError';
  data_missing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  partial_profile?: Maybe<PartialProfile>;
};

export type ProgramAction = {
  __typename: 'ProgramAction';
  action: Scalars['String']['output'];
  consumable_override?: Maybe<MachineConsumable>;
  consumable_quantity?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  machine_part?: Maybe<MachinePart>;
};

export type ProgramActionInput = {
  action: Scalars['String']['input'];
  consumable_override?: InputMaybe<MachineConsumableRef>;
  consumable_quantity: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  machine_part: MachinePartRef;
};

export type ProgramPeriod = {
  __typename: 'ProgramPeriod';
  type: PeriodType;
  value: Scalars['Float']['output'];
};

export type Project = {
  __typename: 'Project';
  business_unit: BusinessUnit;
  client?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  company: Company;
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_archived: Scalars['Boolean']['output'];
  location: Location;
  name: Scalars['String']['output'];
  num_employees: Scalars['Int']['output'];
  num_machines: Array<TotalMachinesGroup>;
  slug: Scalars['String']['output'];
  ute?: Maybe<Ute>;
};

export type ProjectCostCenter = {
  __typename: 'ProjectCostCenter';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  project_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectStats = {
  __typename: 'ProjectStats';
  daily_stats: Array<Maybe<ProjectsDayStats>>;
  machines_stats: MachinesStats;
  num_employees: Scalars['Int']['output'];
  num_machines: Scalars['Int']['output'];
  project: Project;
  reports_stats: ProjectsReportsStats;
};

export type ProjectsDayStats = {
  __typename: 'ProjectsDayStats';
  available: Scalars['Int']['output'];
  date: Scalars['LocalDate']['output'];
  diesel: Scalars['Float']['output'];
  fuel: Scalars['Float']['output'];
  gasoline: Scalars['Float']['output'];
  oos: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total_counters: Array<Counter>;
  worked: Scalars['Int']['output'];
};

export type ProjectsFuelDashboard = {
  __typename: 'ProjectsFuelDashboard';
  items?: Maybe<Array<Maybe<ProjectsFuelDashboardItem>>>;
  pricing_coverage: ProjectsFuelDashboardPricingCoverage;
};

export type ProjectsFuelDashboardItem = {
  __typename: 'ProjectsFuelDashboardItem';
  consumption_cost?: Maybe<Scalars['Float']['output']>;
  consumption_liters_for_cost: Scalars['Float']['output'];
  direct_consumption_from_other_business_units: Scalars['Float']['output'];
  direct_consumption_from_other_projects: Scalars['Float']['output'];
  direct_consumption_from_providers: Scalars['Float']['output'];
  effective_fuel_cost?: Maybe<Scalars['Float']['output']>;
  effective_fuel_cost_source: Scalars['String']['output'];
  final_stock: Scalars['Float']['output'];
  inflow_from_other_business_units: Scalars['Float']['output'];
  inflow_from_other_projects: Scalars['Float']['output'];
  inflow_from_providers: Scalars['Float']['output'];
  initial_stock: Scalars['Float']['output'];
  internal_transfers: Scalars['Float']['output'];
  measured_error?: Maybe<Scalars['Float']['output']>;
  outflow_dispatch_count: Scalars['Int']['output'];
  outflow_internal_consumption: Scalars['Float']['output'];
  outflow_to_other_business_units: Scalars['Float']['output'];
  outflow_to_other_projects: Scalars['Float']['output'];
  project: Project;
  relocation_stock_in: Scalars['Float']['output'];
  relocation_stock_out: Scalars['Float']['output'];
};

export type ProjectsFuelDashboardKpis = {
  __typename: 'ProjectsFuelDashboardKpis';
  average_rotation: AverageRotationKpi;
  stock_deviation: StockDeviationKpi;
  traceability: TraceabilityKpi;
  verified_dispatches: VerifiedDispatchesKpi;
};

export type ProjectsFuelDashboardPricingCoverage = {
  __typename: 'ProjectsFuelDashboardPricingCoverage';
  consumption_liters_uncovered: Scalars['Float']['output'];
  covered_projects: Scalars['Int']['output'];
  relevant_projects: Scalars['Int']['output'];
  total_projects: Scalars['Int']['output'];
  uncovered_project_ids: Array<Scalars['Int']['output']>;
  uncovered_projects: Scalars['Int']['output'];
};

export type ProjectsReportsStats = {
  __typename: 'ProjectsReportsStats';
  num_available: Scalars['Int']['output'];
  num_oos: Scalars['Int']['output'];
  num_pending: Scalars['Int']['output'];
  num_worked: Scalars['Int']['output'];
  specific_consumption?: Maybe<Scalars['Float']['output']>;
  specific_consumption_hp?: Maybe<Scalars['Float']['output']>;
  total_counters: Array<Counter>;
  total_diesel: Scalars['Float']['output'];
  total_fuel: Scalars['Float']['output'];
  total_gasoline: Scalars['Float']['output'];
};

export type PublicApiClient = {
  __typename: 'PublicApiClient';
  companyId: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  /** Más nueva primero. */
  keys: Array<PublicApiKey>;
  /** Último uso entre todas sus keys. */
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  roles: Array<PublicApiKeyRole>;
  technicalEmail?: Maybe<Scalars['String']['output']>;
  technicalName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicApiContactInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PublicApiKey = {
  __typename: 'PublicApiKey';
  clientId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByName: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  keyPrefix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  revocationComment?: Maybe<Scalars['String']['output']>;
  revocationReason?: Maybe<PublicApiKeyRevocationReason>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedByName?: Maybe<Scalars['String']['output']>;
  status: PublicApiKeyStatus;
};

export enum PublicApiKeyRevocationReason {
  Compromise = 'compromise',
  Decommission = 'decommission',
  Rotation = 'rotation'
}

export enum PublicApiKeyRole {
  BtrackRead = 'btrack_read',
  OrganizationRead = 'organization_read'
}

export enum PublicApiKeyStatus {
  Expired = 'expired',
  Revoked = 'revoked',
  Valid = 'valid'
}

/** Read-only health snapshot of Web Push. superRoot only. Reports on subscriptions, not on individual sends. */
export type PushAdminStats = {
  __typename: 'PushAdminStats';
  activeSubscriptions: Scalars['Int']['output'];
  byPlatform: Array<PushPlatformStat>;
  byTopic: Array<PushTopicStat>;
  distinctUsers: Scalars['Int']['output'];
  optOutCount: Scalars['Int']['output'];
  totalSubscriptions: Scalars['Int']['output'];
};

export type PushConfig = {
  __typename: 'PushConfig';
  /** VAPID public key, safe to expose — browsers need it to subscribe. */
  vapidPublicKey: Scalars['String']['output'];
};

/** Registered devices bucketed by a crude platform guess derived from user_agent. */
export type PushPlatformStat = {
  __typename: 'PushPlatformStat';
  /** Devices with a successful send in the last 30 days. */
  active: Scalars['Int']['output'];
  /** One of: ios, android, macos, windows, other. */
  platform: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

/**
 * A device fact: registration/unregistration state. Elective topic
 * preferences are NOT here — they are a fact about the user, not the
 * device (plan 020). See NotificationPreferences.
 */
export type PushSubscription = {
  __typename: 'PushSubscription';
  endpoint: Scalars['String']['output'];
};

/** An elective topic preference. project_id null means every project in the company. */
export type PushTopicPreference = {
  __typename: 'PushTopicPreference';
  company_id: Scalars['ID']['output'];
  project_id?: Maybe<Scalars['ID']['output']>;
  topic: Scalars['String']['output'];
};

export type PushTopicPreferenceInput = {
  company_id: Scalars['ID']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
  topic: Scalars['String']['input'];
};

/** Elective topic preferences grouped by topic. */
export type PushTopicStat = {
  __typename: 'PushTopicStat';
  companies: Scalars['Int']['output'];
  /** Rows that apply to every project in the company (project_id is null). */
  companyWide: Scalars['Int']['output'];
  rows: Scalars['Int']['output'];
  topic: Scalars['String']['output'];
};

export type Query = {
  __typename: 'Query';
  adminUser?: Maybe<AdminUserDetail>;
  analyzeMachineNoticesDashboard: MachineNoticesDashboardAnalysisResponse;
  downloadMachineNoticesDashboardWorkbook: Result;
  /**
   * Exports the machines workbook for what the caller is currently looking at.
   * Scope it the same way the view is scoped: project_id + group narrow the set
   * server-side (project semantics match getMachines), and machine_ids is only
   * needed when the caller has narrowed things further with filters the server
   * doesn't know about.
   *
   * is_archived follows FilterMachine's semantics: omit it to export everything
   * (the whole-company download does this, archived included), false for only
   * active machines, true for only archived ones.
   */
  downloadMachinesWorkbook: Result;
  downloadRentalCertificationPdf: Result;
  downloadRentalCertificationXlsx: Result;
  downloadTelemetryDevicesWorkbook: Result;
  downloadWorkOrdersWorkbook: Result;
  exportCertificationHistoryWorkbook: Result;
  exportReportsWorkbook: Result;
  getAllCompanies: CompaniesConnection;
  getAllMaintenancePlans: MaintenancePlanConnection;
  /** Which checklists apply to each machine (offline-friendly batch, up to 500 machine ids). No context: the actor's full authorized scope is used — the PWA has none. */
  getAvailableChecklists: ChecklistAvailabilityResponse;
  getBCDeviceSnapshotsByCompanyId: Array<BcDeviceSnapshot>;
  getBilderitMachineConsumables: MachineConsumableConnection;
  getBilderitMaintenancePlans: MaintenancePlanConnection;
  getBtrackAccessToken: Scalars['String']['output'];
  getBtrackDemoAccessToken: Scalars['String']['output'];
  getCertificationCopyRecipients: Array<CertificationCopyRecipient>;
  getCertificationHistory: CertificationHistoryConnection;
  getCertificationNotificationRecipients: GetCertificationNotificationRecipientsResponse;
  getChecklistById: Checklist;
  getChecklistTemplateById: ChecklistTemplate;
  getChecklistTemplates: ChecklistTemplatesResponse;
  /** No context: the actor's full authorized scope is used — the PWA has none. */
  getChecklists: ChecklistsResponse;
  getCompaniesWithTotals?: Maybe<CompaniesWithTotals>;
  getCompany?: Maybe<AuthGetCompanyResponse>;
  getCompanyActivity: Array<CompanyActivitySummary>;
  getCompanyAlerts: CompanyAlerts;
  getCompanyIntegrations: Array<CompanyIntegration>;
  getCompanyMachineExtraData: Array<CompanyMachineExtraData>;
  getComputedStock: Scalars['Float']['output'];
  getDailyAEMPTelemetryByCompany: Array<DailyTelemetryGroup>;
  getDailyReportById?: Maybe<AuthGetDailyReportByIdResponse>;
  getDailyReportByUsageId?: Maybe<DailyReportResponse>;
  getDailyReports?: Maybe<AuthGetDailyReportsReponse>;
  getDailyReportsByDayStats?: Maybe<AuthGetDailyReportsByDayStatsResponse>;
  getDailyReportsByMachineIdStats?: Maybe<AuthGetDailyReportsByMachineIdStatsResponse>;
  getDashBoard: DashBoardConnection;
  getDocuments: DocumentConnection;
  getEmployees?: Maybe<AuthGetEmployeesResponse>;
  getEnabledToCreateCompanyUsers: Array<Scalars['String']['output']>;
  /**
   * Resolves the fuel cost ($/L) for the given company, optionally scoped to a project.
   * Uses the scoped-parameter hierarchy: project -> company -> global.
   * Returns null when no value has been configured.
   */
  getFuelCostSetting?: Maybe<Scalars['Float']['output']>;
  /**
   * Returns fuel cost settings for a company in one request:
   * - companyValue: company-level value (or global fallback)
   * - projects: each project's explicit value and effective value
   */
  getFuelCostSettingsOverview: FuelCostSettingsOverview;
  getFuelDestinations: AuthGetMachinesResponse;
  getFuelDispatchedReportById?: Maybe<FuelDispatchedReport>;
  getFuelDispatchedReports?: Maybe<GetFuelDispatchedReportsReponse>;
  getFuelProviders: FuelProvidersResponse;
  getFuelSources: FuelSourcesResponse;
  getFuelTanks: AuthGetMachinesResponse;
  getIntegrationProviders: Array<IntegrationProviderConfig>;
  getIntegrationSyncRunReport?: Maybe<Scalars['JSON']['output']>;
  getIntegrationSyncRuns: Array<IntegrationSyncRun>;
  getInvitationsByContext: Array<Invitation>;
  getMachineAssignmentsByPeriod: Array<MachineAssignmentReport>;
  getMachineById?: Maybe<AuthGetMachineByIdResponse>;
  getMachineConsumablesByCompanyId: MachineConsumableConnection;
  getMachineGroupCounts?: Maybe<AuthGetMachineGroupCountsResponse>;
  getMachineHistory: MachineHistoryConnection;
  getMachineNoticeById?: Maybe<MachineNotice>;
  getMachineNotices: Array<MachineNotice>;
  getMachineNoticesDashboard: MachineNoticeDashboardConnection;
  getMachinePartsByCompanyId: MachinePartConnection;
  getMachineProjectsAtDate: Array<Project>;
  getMachineReportsBoard: MachineReportsBoardConnection;
  getMachineTypes?: Maybe<AuthCheckGetMachineTypesResponse>;
  getMachines?: Maybe<AuthGetMachinesResponse>;
  getMachinesFuelDashboard: MachinesFuelDashboard;
  getMachinistsWorkBoard: MachinistWorkBoardConnection;
  getMaintenancePlanById?: Maybe<MaintenancePlanItem>;
  getMe?: Maybe<GetMeResponse>;
  getMoveReportById: MoveReport;
  getMyAssignedWorkOrders: WorkOrdersConnection;
  getMyBilderitReportSubscriptions: Array<BilderitReportSubscription>;
  getMyCertificatesToReview: CertificationHistoryConnection;
  getMyDailyReports?: Maybe<AuthGetMyDailyReportsResponse>;
  getMyDocuments: DocumentConnection;
  getMyFuelDispatchedReports?: Maybe<GetFuelDispatchedReportsReponse>;
  getMyInvitations?: Maybe<AuthGetInvitationsResponse>;
  getMyMachineNotices: Array<MachineNotice>;
  /**
   * The calling user's elective preferences and opt-outs. Per-user: the
   * session is the identity — no endpoint, no device id; that is the
   * BIL-4952 fix.
   */
  getMyNotificationPreferences: NotificationPreferences;
  getMyRecentActivity: RecentActivity;
  getMyStockControlReports?: Maybe<GetStockControlReportsReponse>;
  getProjectCostCenterMode: CostCenterMode;
  getProjectCostCenters: Array<ProjectCostCenter>;
  getProjectsFuelDashboard: ProjectsFuelDashboard;
  /** superRoot-only push health snapshot. Read-only: no send, no writes. */
  getPushAdminStats: PushAdminStats;
  getPushConfig: PushConfig;
  getRentalByProject: GetRentalByProjectResponse;
  getRentalCertification: GetRentalCertificationResponse;
  getRentalCertificationProviderOptions: RentalCertificationProviderOptionsResponse;
  getRentalParameterDefinitions: Array<RentalParameterDefinition>;
  getRentalParameterEffectiveValuesByMachineIds: GetRentalParameterEffectiveValuesByMachineIdsResponse;
  getRentalParameterEffectiveValuesByScope: GetRentalParameterEffectiveValuesByScopeResponse;
  getServiceReportById: ServiceReport;
  getServicesDashboard?: Maybe<ServicesDashboard>;
  getSnapshotByBilderitConnectDeviceId: TelemetrySnapshot;
  getStockControlReportById?: Maybe<StockControlReport>;
  getStockControlReports?: Maybe<GetStockControlReportsReponse>;
  getTagGroups: Array<TagGroup>;
  getTagGroupsManagedByBilderit: Array<TagGroup>;
  getTags: TagsConnection;
  getTagsManagedByBilderit: TagsConnection;
  getTanksDashboard: TanksDashboard;
  getTelemetryDashboardStats: TelemetryDashboardStats;
  getTelemetryDevices: Array<TelemetryDevice>;
  getTimeSeriesByBilderitConnectDeviceId: Array<DailyTelemetry>;
  getUploadMachineConsumablesPresignatedUrl: DataUpload;
  getUploadMachinesPresignatedUrl?: Maybe<AuthGetUploadMachinesPresignatedUrlResponse>;
  getUploadStatus?: Maybe<UploadStatus>;
  getUploadTargets?: Maybe<Array<UploadTarget>>;
  getUsers?: Maybe<AuthGetUsersResponse>;
  getVisionLinkReportsByDate: VisionLinkReportsByDateResult;
  getWorkOrderById: ItemWorkOrder;
  getWorkOrders: WorkOrdersConnection;
  getWorkOrdersByMachineId: WorkOrdersConnection;
  /** Validar padrón (root): equipos cargados de la empresa, con sus valores ya cargados, para auditarlos por lotes con suggestRosterRows(machine_ids) y armar la plantilla de descarga sin volver a pedirlos. */
  listRosterAuditMachines: Array<RosterAuditMachine>;
  /**
   * Obtiene métricas de mantenimiento para un mes específico.
   * El parámetro month debe ser formato "YYYY-MM" (ej: "2025-11").
   * El parámetro excludeMachineIds permite excluir equipos del cálculo de estadísticas globales (outliers).
   * El parámetro pagination controla la paginación de los datos por máquina (byMachine).
   *
   * Cada KPI se calcula con el rango temporal apropiado:
   * - MTBF, MTTR: Últimos 12 meses terminando en el mes indicado
   * - PMP, Disponibilidad, Desviación: Solo el mes indicado
   * - Backlog: Acumulado hasta el fin del mes indicado
   *
   * IMPORTANTE: Los KPIs globales siempre se calculan sobre TODAS las máquinas (excepto excludeMachineIds),
   * independientemente de la página solicitada en pagination.
   */
  maintenanceDashboardMetrics: MaintenanceDashboardMetrics;
  /** Null si el cliente no está habilitado en este entorno. */
  mcpClient?: Maybe<McpClient>;
  previewChecklistTemplateAssignments: ChecklistAssignmentPreview;
  publicApiClients: Array<PublicApiClient>;
  /**
   * Revisión asistida del catálogo de etiquetas de una compañía (BIL-5192):
   * posibles duplicados, etiquetas comodín/demasiado amplias y nombres poco
   * legibles, para la administración de etiquetas. Solo lee; cada acción del
   * panel pasa por las mutations de tags existentes (merge/update). Solo
   * root. Igual degradación que el resto de las sugerencias: apagador,
   * servicio no configurado o error de servicio -> meta.available=false.
   */
  reviewTagCatalog: TagCatalogReview;
  searchAdminUsers: AdminUsersResult;
  searchRentalCertificationApprovers: Array<RentalCertificationApprover>;
  /** Validar padrón (root): sugiere a qué columna de la plantilla de carga corresponde cada columna del xlsx del cliente. */
  suggestRosterColumns: RosterColumnsSuggestion;
  /** Validar padrón (root): por fila de equipo, sugiere marca, combustible, contador y grupo+tipo y marca la fila para revisar. */
  suggestRosterRows: RosterRowsSuggestion;
  systemFlags: Array<SystemFlag>;
  telemetrySandboxRuntimeConfig: TelemetrySandboxRuntimeConfig;
};


export type QueryAdminUserArgs = {
  cognito_username?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAnalyzeMachineNoticesDashboardArgs = {
  context: Context;
  filter?: InputMaybe<FilterMachineNoticeDashboard>;
  model?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadMachineNoticesDashboardWorkbookArgs = {
  context: Context;
  filter?: InputMaybe<FilterMachineNoticeDashboard>;
};


export type QueryDownloadMachinesWorkbookArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  company_id: Scalars['Int']['input'];
  group?: InputMaybe<MachineGroup>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  machine_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDownloadRentalCertificationPdfArgs = {
  certification_id: Scalars['Int']['input'];
};


export type QueryDownloadRentalCertificationXlsxArgs = {
  certification_id: Scalars['Int']['input'];
};


export type QueryDownloadTelemetryDevicesWorkbookArgs = {
  category: TelemetryDeviceCategory;
};


export type QueryDownloadWorkOrdersWorkbookArgs = {
  business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  company_id: Scalars['Int']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryExportCertificationHistoryWorkbookArgs = {
  context: Context;
  filter?: InputMaybe<CertificationHistoryFilter>;
};


export type QueryExportReportsWorkbookArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  context: Context;
  filter: FilterDateRange;
  groups?: InputMaybe<Array<MachineGroup>>;
  machineId?: InputMaybe<Scalars['Int']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  reporter?: InputMaybe<Scalars['ID']['input']>;
  reporterName?: InputMaybe<Scalars['String']['input']>;
  summaryMode?: InputMaybe<ReportsWorkbookSummaryMode>;
};


export type QueryGetAllMaintenancePlansArgs = {
  context: Context;
  filter?: InputMaybe<FilterMaintenancePlans>;
};


export type QueryGetAvailableChecklistsArgs = {
  context?: InputMaybe<Context>;
  machine_ids: Array<Scalars['Int']['input']>;
};


export type QueryGetBcDeviceSnapshotsByCompanyIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetBilderitMachineConsumablesArgs = {
  filter?: InputMaybe<FilterMachineConsumables>;
};


export type QueryGetBilderitMaintenancePlansArgs = {
  filter?: InputMaybe<FilterMaintenancePlans>;
};


export type QueryGetBtrackAccessTokenArgs = {
  company_id: Scalars['Int']['input'];
};


export type QueryGetCertificationCopyRecipientsArgs = {
  context: Context;
};


export type QueryGetCertificationHistoryArgs = {
  context: Context;
  filter?: InputMaybe<CertificationHistoryFilter>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetCertificationNotificationRecipientsArgs = {
  certification_id: Scalars['Int']['input'];
};


export type QueryGetChecklistByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetChecklistTemplateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetChecklistTemplatesArgs = {
  context: Context;
  filter?: InputMaybe<FilterChecklistTemplates>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetChecklistsArgs = {
  context?: InputMaybe<Context>;
  filter?: InputMaybe<FilterChecklists>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetCompanyActivityArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryGetCompanyAlertsArgs = {
  context: Context;
};


export type QueryGetCompanyMachineExtraDataArgs = {
  companyId: Scalars['Int']['input'];
  group?: InputMaybe<MachineGroup>;
};


export type QueryGetComputedStockArgs = {
  datetime: Scalars['DateTime']['input'];
  tank_id: Scalars['Int']['input'];
};


export type QueryGetDailyAempTelemetryByCompanyArgs = {
  companyId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryGetDailyReportByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetDailyReportByUsageIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetDailyReportsArgs = {
  context?: InputMaybe<Context>;
  filter?: InputMaybe<FilterDailyReports>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetDailyReportsByDayStatsArgs = {
  context?: InputMaybe<Context>;
  filter?: InputMaybe<FilterDailyReportsByDayStats>;
  yyyymmdd: Scalars['LocalDate']['input'];
};


export type QueryGetDailyReportsByMachineIdStatsArgs = {
  context?: InputMaybe<Context>;
  filter: FilterDateRange;
  id: Scalars['Int']['input'];
};


export type QueryGetDashBoardArgs = {
  context: Context;
  filter: FilterDateRange;
};


export type QueryGetDocumentsArgs = {
  context: Context;
  filter?: InputMaybe<GetDocumentsFilter>;
};


export type QueryGetEmployeesArgs = {
  context: Context;
  filter?: InputMaybe<FilterEmployee>;
};


export type QueryGetFuelCostSettingArgs = {
  companyId: Scalars['Int']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFuelCostSettingsOverviewArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryGetFuelDestinationsArgs = {
  context: Context;
  pagination?: InputMaybe<OffsetPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFuelDispatchedReportByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFuelDispatchedReportsArgs = {
  context: Context;
  filter?: InputMaybe<GetFuelDispatchedReportsFilter>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetFuelProvidersArgs = {
  context: Context;
};


export type QueryGetFuelSourcesArgs = {
  context?: InputMaybe<Context>;
  pagination?: InputMaybe<FilterPagination>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFuelTanksArgs = {
  context: Context;
  filter?: InputMaybe<FilterFuelTanks>;
};


export type QueryGetIntegrationSyncRunReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetIntegrationSyncRunsArgs = {
  connection_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetInvitationsByContextArgs = {
  context: Context;
};


export type QueryGetMachineAssignmentsByPeriodArgs = {
  endDate: Scalars['LocalDate']['input'];
  machineId: Scalars['Int']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type QueryGetMachineByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetMachineConsumablesByCompanyIdArgs = {
  filter?: InputMaybe<FilterMachineConsumables>;
  id: Scalars['Int']['input'];
};


export type QueryGetMachineGroupCountsArgs = {
  context?: InputMaybe<Context>;
};


export type QueryGetMachineHistoryArgs = {
  context: Context;
  filter: FilterMachineHistory;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetMachineNoticeByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetMachineNoticesArgs = {
  context: Context;
  filter?: InputMaybe<FilterMachineNotices>;
};


export type QueryGetMachineNoticesDashboardArgs = {
  context: Context;
  filter?: InputMaybe<FilterMachineNoticeDashboard>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetMachinePartsByCompanyIdArgs = {
  filter: FilterMachineParts;
  id: Scalars['Int']['input'];
};


export type QueryGetMachineProjectsAtDateArgs = {
  date: Scalars['LocalDate']['input'];
  machineId: Scalars['Int']['input'];
};


export type QueryGetMachineReportsBoardArgs = {
  context: Context;
  filter: FilterDateRange;
  groups: Array<MachineGroup>;
  reporter?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMachinesArgs = {
  context?: InputMaybe<Context>;
  filter?: InputMaybe<FilterMachine>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


export type QueryGetMachinesFuelDashboardArgs = {
  context: Context;
  filter?: InputMaybe<GetMachinesFuelDashboardFilter>;
};


export type QueryGetMachinistsWorkBoardArgs = {
  context: Context;
};


export type QueryGetMaintenancePlanByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetMoveReportByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetMyAssignedWorkOrdersArgs = {
  filter?: InputMaybe<FilterWorkOrders>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetMyBilderitReportSubscriptionsArgs = {
  context?: InputMaybe<Context>;
};


export type QueryGetMyCertificatesToReviewArgs = {
  filter?: InputMaybe<MyCertificatesToReviewFilter>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetMyDailyReportsArgs = {
  filter?: InputMaybe<FilterMyDailyReports>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetMyFuelDispatchedReportsArgs = {
  filter?: InputMaybe<GetFuelDispatchedReportsFilter>;
};


export type QueryGetMyMachineNoticesArgs = {
  filter?: InputMaybe<FilterMyMachineNotices>;
};


export type QueryGetMyStockControlReportsArgs = {
  filter?: InputMaybe<GetStockControlReportsFilter>;
};


export type QueryGetProjectCostCenterModeArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryGetProjectCostCentersArgs = {
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['Int']['input'];
};


export type QueryGetProjectsFuelDashboardArgs = {
  context: Context;
  filter: GetTanksDashboardFilter;
};


export type QueryGetRentalByProjectArgs = {
  filter: RentalFilters;
  period: FilterDateRange;
  project_id: Scalars['Int']['input'];
};


export type QueryGetRentalCertificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetRentalCertificationProviderOptionsArgs = {
  month: Scalars['Date']['input'];
  project_id: Scalars['Int']['input'];
};


export type QueryGetRentalParameterEffectiveValuesByMachineIdsArgs = {
  machine_ids: Array<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRentalParameterEffectiveValuesByScopeArgs = {
  scope?: InputMaybe<GetRentalParameterByScopeInput>;
};


export type QueryGetServiceReportByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetServicesDashboardArgs = {
  context?: InputMaybe<Context>;
};


export type QueryGetSnapshotByBilderitConnectDeviceIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetStockControlReportByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetStockControlReportsArgs = {
  context: Context;
  filter?: InputMaybe<GetStockControlReportsFilter>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetTagGroupsArgs = {
  context: Context;
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  scope: TagScope;
};


export type QueryGetTagGroupsManagedByBilderitArgs = {
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  scope: TagScope;
};


export type QueryGetTagsArgs = {
  context: Context;
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  scope: TagScope;
};


export type QueryGetTagsManagedByBilderitArgs = {
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  scope: TagScope;
};


export type QueryGetTanksDashboardArgs = {
  context: Context;
  filter: GetTanksDashboardFilter;
};


export type QueryGetTelemetryDashboardStatsArgs = {
  companyId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  idleConsumptionRate?: InputMaybe<Scalars['Float']['input']>;
  to: Scalars['DateTime']['input'];
};


export type QueryGetTelemetryDevicesArgs = {
  filter: GetTelemetryDevicesFilter;
};


export type QueryGetTimeSeriesByBilderitConnectDeviceIdArgs = {
  id: Scalars['ID']['input'];
  params: GetTimeSeriesByBilderitConnectDeviceIdParams;
};


export type QueryGetUploadMachineConsumablesPresignatedUrlArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUploadMachinesPresignatedUrlArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryGetUploadStatusArgs = {
  statusId: Scalars['ID']['input'];
};


export type QueryGetUploadTargetsArgs = {
  input: Array<GetUploadTargetInput>;
};


export type QueryGetUsersArgs = {
  context: Context;
  filter?: InputMaybe<FilterUser>;
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryGetVisionLinkReportsByDateArgs = {
  input: VisionLinkReportsByDateInput;
};


export type QueryGetWorkOrderByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkOrdersArgs = {
  context: Context;
  filter?: InputMaybe<FilterWorkOrders>;
  pagination?: InputMaybe<FilterPagination>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWorkOrdersByMachineIdArgs = {
  filter?: InputMaybe<FilterWorkOrders>;
  id: Scalars['Int']['input'];
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryListRosterAuditMachinesArgs = {
  context: Context;
};


export type QueryMaintenanceDashboardMetricsArgs = {
  context: Context;
  excludeMachineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  month: Scalars['String']['input'];
  pagination?: InputMaybe<FilterPagination>;
};


export type QueryMcpClientArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryPreviewChecklistTemplateAssignmentsArgs = {
  input: SetChecklistTemplateAssignmentsInput;
};


export type QueryReviewTagCatalogArgs = {
  context: Context;
  scope: TagScope;
};


export type QuerySearchAdminUsersArgs = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  filter: AdminUserFilter;
  pagination?: InputMaybe<OffsetPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchRentalCertificationApproversArgs = {
  project_id: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QuerySuggestRosterColumnsArgs = {
  columns: Array<RosterColumnInput>;
  context: Context;
};


export type QuerySuggestRosterRowsArgs = {
  context: Context;
  machine_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  rows?: InputMaybe<Array<RosterRowInput>>;
};

export type RecentActivity = {
  __typename: 'RecentActivity';
  last_month: ActivitySummary;
  last_week: ActivitySummary;
  latest_reports: Array<Activity>;
  today: ActivitySummary;
};

export type RegisterPushSubscriptionInput = {
  /** Which app this device is registering from: 'manager' or 'maquinista'. Fixed by the subscribing origin — never inferred server-side. */
  app: Scalars['String']['input'];
  auth: Scalars['String']['input'];
  /**
   * Stable client-generated id for this browser install (BIL-4930), persisted
   * in localStorage. The subscription row is keyed by (user, device), so an
   * endpoint rotation updates the row in place and preferences survive.
   * Nullable only for clients built before it existed — the server then falls
   * back to a one-shot id with the old endpoint-keyed semantics.
   */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  endpoint: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterWorkOrderTaskInput = {
  task_id: Scalars['ID']['input'];
  used_consumable_code?: InputMaybe<Scalars['String']['input']>;
  used_quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type RegisterWorkOrderTasksInput = {
  ot_id: Scalars['ID']['input'];
  tasks: Array<RegisterWorkOrderTaskInput>;
};

export type RegisterWorkOrderTasksPayload = ItemWorkOrder;

export type RejectInvitation = {
  __typename: 'RejectInvitation';
  item: Me;
};

export type RejectInvitationResponse = NotFoundInvitationError | RejectInvitation | ServerError;

export type RemoveCertificationReviewerInput = {
  certification_id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  reviewer_user_id: Scalars['Int']['input'];
};

export type RemoveCertificationReviewerResponse = {
  __typename: 'RemoveCertificationReviewerResponse';
  auto_approved: Scalars['Boolean']['output'];
  certification: RentalCertification;
  removed_reviewer_user_id: Scalars['Int']['output'];
};

export enum RentalBillingType {
  Hs = 'HS',
  Km = 'KM',
  Month = 'MONTH'
}

export type RentalCertification = {
  __typename: 'RentalCertification';
  approval_records: Array<RentalCertificationApprovalRecord>;
  comments: Array<RentalCertificationComment>;
  company_id: Scalars['Int']['output'];
  company_name: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Employee;
  currency: Scalars['String']['output'];
  eligible_machine_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  item_count: Scalars['Int']['output'];
  month: Scalars['Date']['output'];
  ownership_group: RentalOwnershipGroup;
  project_id: Scalars['Int']['output'];
  project_name: Scalars['String']['output'];
  serial_number: Scalars['Int']['output'];
  status: RentalCertificationStatus;
  total_amount: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vendor_filter?: Maybe<Scalars['String']['output']>;
};

export type RentalCertificationApprovalRecord = {
  __typename: 'RentalCertificationApprovalRecord';
  comment?: Maybe<Scalars['String']['output']>;
  responded_at?: Maybe<Scalars['DateTime']['output']>;
  reviewer: Employee;
  status: Scalars['String']['output'];
};

export type RentalCertificationApprover = {
  __typename: 'RentalCertificationApprover';
  type: ApproverType;
  user: Employee;
};

export type RentalCertificationComment = {
  __typename: 'RentalCertificationComment';
  action: Scalars['String']['output'];
  certification_id: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  user: Employee;
};

export type RentalCertificationItemSnapshot = {
  __typename: 'RentalCertificationItemSnapshot';
  billing_type: Scalars['String']['output'];
  certification_id: Scalars['Int']['output'];
  company_id: Scalars['Int']['output'];
  company_name_snapshot: Scalars['String']['output'];
  counter_end?: Maybe<Scalars['Float']['output']>;
  counter_start?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by: Employee;
  currency: Scalars['String']['output'];
  days_in_project: Scalars['Int']['output'];
  days_oos_due_to_equipment: Scalars['Int']['output'];
  days_oos_due_to_project: Scalars['Int']['output'];
  days_to_charge: Scalars['Float']['output'];
  fixed_amount: Scalars['Float']['output'];
  hours_worked?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  is_underutilized: Scalars['Boolean']['output'];
  km_traveled?: Maybe<Scalars['Float']['output']>;
  machine: Machine;
  machine_group_snapshot: Scalars['String']['output'];
  machine_name_snapshot: Scalars['String']['output'];
  machine_owner_snapshot: Scalars['String']['output'];
  machine_ownership_type_snapshot: OwnershipType;
  machine_preferred_counter_type_snapshot: CounterType;
  machine_replacement_value_snapshot: Scalars['Float']['output'];
  machine_subtype_snapshot?: Maybe<Scalars['String']['output']>;
  machine_type_snapshot: Scalars['String']['output'];
  machine_year_snapshot: Scalars['Int']['output'];
  min_hours_to_bill?: Maybe<Scalars['Float']['output']>;
  month: Scalars['Date']['output'];
  monthly_reference_amount: Scalars['Float']['output'];
  project_id: Scalars['Int']['output'];
  project_name_snapshot: Scalars['String']['output'];
  rental_params: RentalParamsSnapshot;
  total_amount: Scalars['Float']['output'];
  underutilized_amount: Scalars['Float']['output'];
  variable_amount: Scalars['Float']['output'];
  warnings: Array<RentalWarning>;
};

export type RentalCertificationProviderOptionsResponse = {
  __typename: 'RentalCertificationProviderOptionsResponse';
  all_option: RentalCertificationProviderScopeOption;
  providers: Array<RentalCertificationProviderScopeOption>;
};

export type RentalCertificationProviderScopeOption = {
  __typename: 'RentalCertificationProviderScopeOption';
  existing_status?: Maybe<RentalCertificationStatus>;
  is_disabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  machine_count: Scalars['Int']['output'];
  vendor_filter?: Maybe<Scalars['String']['output']>;
};

export type RentalCertificationRelocationSnapshot = {
  __typename: 'RentalCertificationRelocationSnapshot';
  certification_id: Scalars['Int']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  counter_type?: Maybe<Scalars['String']['output']>;
  counter_value?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by: Employee;
  from_project?: Maybe<Project>;
  id: Scalars['Int']['output'];
  machine: Machine;
  movement_date: Scalars['LocalDate']['output'];
  movement_type: Scalars['String']['output'];
  to_project: Project;
};

export enum RentalCertificationStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export enum RentalCounterSource {
  All = 'all',
  DailyReport = 'daily_report',
  FuelReport = 'fuel_report',
  MoveReport = 'move_report',
  OosReport = 'oos_report',
  ServiceReport = 'service_report',
  Telemetry = 'telemetry'
}

export type RentalFilters = {
  group?: InputMaybe<MachineGroup>;
  ownership_type?: InputMaybe<OwnershipType>;
};

export enum RentalOwnershipGroup {
  Owned = 'OWNED',
  Rented = 'RENTED'
}

export type RentalParameterDefinition = {
  __typename: 'RentalParameterDefinition';
  code: RentalParamsCode;
  description?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  symbol: Scalars['String']['output'];
  type: DataType;
  unit?: Maybe<Scalars['String']['output']>;
};

export enum RentalParamsCode {
  AdditionalFixedAmountUsd = 'ADDITIONAL_FIXED_AMOUNT_USD',
  AdjustmentPriceMultiplier = 'ADJUSTMENT_PRICE_MULTIPLIER',
  BillingType = 'BILLING_TYPE',
  DemeritCoef_00_04 = 'DEMERIT_COEF_00_04',
  DemeritCoef_05_09 = 'DEMERIT_COEF_05_09',
  DemeritCoef_10_14 = 'DEMERIT_COEF_10_14',
  DemeritCoef_15_19 = 'DEMERIT_COEF_15_19',
  DemeritCoef_20Plus = 'DEMERIT_COEF_20_PLUS',
  ExtraHoursMultiplier = 'EXTRA_HOURS_MULTIPLIER',
  ExtraHoursThreshold = 'EXTRA_HOURS_THRESHOLD',
  InitialHoursOverride = 'INITIAL_HOURS_OVERRIDE',
  InitialHoursSource = 'INITIAL_HOURS_SOURCE',
  LastHoursOverride = 'LAST_HOURS_OVERRIDE',
  LastHoursSource = 'LAST_HOURS_SOURCE',
  MinHours = 'MIN_HOURS',
  RentalCoefFixedPct = 'RENTAL_COEF_FIXED_PCT',
  RentalCoefVariablePct = 'RENTAL_COEF_VARIABLE_PCT',
  RentalValueOverrideUsd = 'RENTAL_VALUE_OVERRIDE_USD',
  ReplacementValueUsd = 'REPLACEMENT_VALUE_USD',
  TariffHoursBase = 'TARIFF_HOURS_BASE',
  TotalDaysOverride = 'TOTAL_DAYS_OVERRIDE'
}

export type RentalParamsSnapshot = {
  __typename: 'RentalParamsSnapshot';
  ADDITIONAL_FIXED_AMOUNT_USD: Scalars['Float']['output'];
  ADJUSTMENT_PRICE_MULTIPLIER: Scalars['Float']['output'];
  BILLING_TYPE?: Maybe<RentalBillingType>;
  DEMERIT_COEF_00_04: Scalars['Float']['output'];
  DEMERIT_COEF_05_09: Scalars['Float']['output'];
  DEMERIT_COEF_10_14: Scalars['Float']['output'];
  DEMERIT_COEF_15_19: Scalars['Float']['output'];
  DEMERIT_COEF_20_PLUS: Scalars['Float']['output'];
  EXTRA_HOURS_MULTIPLIER: Scalars['Float']['output'];
  EXTRA_HOURS_THRESHOLD: Scalars['Float']['output'];
  INITIAL_HOURS_OVERRIDE?: Maybe<Scalars['Float']['output']>;
  INITIAL_HOURS_SOURCE: RentalCounterSource;
  LAST_HOURS_OVERRIDE?: Maybe<Scalars['Float']['output']>;
  LAST_HOURS_SOURCE: RentalCounterSource;
  MIN_HOURS: Scalars['Float']['output'];
  RENTAL_COEF_FIXED_PCT: Scalars['Float']['output'];
  RENTAL_COEF_VARIABLE_PCT: Scalars['Float']['output'];
  RENTAL_VALUE_OVERRIDE_USD?: Maybe<Scalars['Float']['output']>;
  REPLACEMENT_VALUE_USD?: Maybe<Scalars['Float']['output']>;
  TARIFF_HOURS_BASE: Scalars['Float']['output'];
  TOTAL_DAYS_OVERRIDE?: Maybe<Scalars['Float']['output']>;
};

export type RentalWarning = {
  __typename: 'RentalWarning';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ReportsWorkbookSummaryMode {
  ByDay = 'BY_DAY'
}

export type RequestIdentityClaimForUserInput = {
  email: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};

export type RequestIdentityClaimInput = {
  email: Scalars['String']['input'];
};

export type ResourceInUseError = Error & {
  __typename: 'ResourceInUseError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type RespondToMcpAuthorizationInput = {
  approve: Scalars['Boolean']['input'];
  clientId: Scalars['String']['input'];
  /** El nonce que mandó el MCP desde /oauth/authorize. */
  request: Scalars['String']['input'];
};

export type RespondToMcpAuthorizationPayload = {
  __typename: 'RespondToMcpAuthorizationPayload';
  /** A dónde sigue el navegador: el callback del MCP. */
  redirectUrl: Scalars['String']['output'];
};

export type Result = ServerError | SuccessResult;

export enum ReviewAction {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export type ReviewCertificationInput = {
  action: ReviewAction;
  certification_id: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewCertificationResponse = {
  __typename: 'ReviewCertificationResponse';
  all_approved: Scalars['Boolean']['output'];
  certification: RentalCertification;
};

export type Role = {
  __typename: 'Role';
  business_unit?: Maybe<BusinessUnit>;
  company?: Maybe<Company>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  role: RoleNames;
};

export enum RoleNames {
  Admin = 'admin',
  Btrack = 'btrack',
  FuelDispatcher = 'fuel_dispatcher',
  Machinist = 'machinist',
  Manager = 'manager',
  Mechanic = 'mechanic',
  RentalApprover = 'rental_approver',
  RentalExternalApprover = 'rental_external_approver',
  RentalIssuer = 'rental_issuer',
  Root = 'root',
  SuperRoot = 'superRoot'
}

export enum RoleNamesToInvite {
  Admin = 'admin',
  Btrack = 'btrack',
  FuelDispatcher = 'fuel_dispatcher',
  Machinist = 'machinist',
  Manager = 'manager',
  Mechanic = 'mechanic',
  RentalApprover = 'rental_approver',
  RentalExternalApprover = 'rental_external_approver',
  RentalIssuer = 'rental_issuer'
}

/** Plan 016: equipo cargado de la empresa con sus valores ya cargados — la página los usa para armar la fila cruda y la plantilla de descarga del modo auditoría sin pedirlos de nuevo por otra vía. */
export type RosterAuditMachine = {
  __typename: 'RosterAuditMachine';
  brand?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Scalars['String']['output']>;
  /** Plan 018 (BIL-5285), finding 4: sólo para mostrar en la grilla de auditoría — Jev nunca los pide (la fuente cruda no existe una vez cargado el equipo). */
  fuel?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  plate?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RosterBrandSuggestion = {
  __typename: 'RosterBrandSuggestion';
  confidence: Scalars['Float']['output'];
  is_new: Scalars['Boolean']['output'];
  probability: Scalars['Float']['output'];
  raw?: Maybe<Scalars['String']['output']>;
  suggested?: Maybe<Scalars['String']['output']>;
};

export type RosterClassificationRule = {
  __typename: 'RosterClassificationRule';
  grupo: Scalars['String']['output'];
  tipo: Scalars['String']['output'];
};

export type RosterClassificationSuggestion = {
  __typename: 'RosterClassificationSuggestion';
  confidence: Scalars['Float']['output'];
  /** Grupo/tipo del juicio propio de Jev cuando una regla lo reemplazó (plan 017); null si ninguna regla aplicó. */
  jev_group?: Maybe<Scalars['String']['output']>;
  jev_probability?: Maybe<Scalars['Float']['output']>;
  jev_type?: Maybe<Scalars['String']['output']>;
  probability: Scalars['Float']['output'];
  rule?: Maybe<RosterClassificationRule>;
  suggested_group?: Maybe<Scalars['String']['output']>;
  suggested_type?: Maybe<Scalars['String']['output']>;
};

export type RosterColumnAlternative = {
  __typename: 'RosterColumnAlternative';
  probability: Scalars['Float']['output'];
  template_column: Scalars['String']['output'];
};

export type RosterColumnInput = {
  header: Scalars['String']['input'];
  n_filled: Scalars['Int']['input'];
  n_rows: Scalars['Int']['input'];
  samples: Array<Scalars['String']['input']>;
  sheet: Scalars['String']['input'];
};

export type RosterColumnSuggestion = {
  __typename: 'RosterColumnSuggestion';
  alternatives: Array<RosterColumnAlternative>;
  confidence: Scalars['Float']['output'];
  error: Scalars['Boolean']['output'];
  header: Scalars['String']['output'];
  ignore: Scalars['Boolean']['output'];
  probability: Scalars['Float']['output'];
  template_column?: Maybe<Scalars['String']['output']>;
};

export type RosterColumnsSuggestion = {
  __typename: 'RosterColumnsSuggestion';
  columns: Array<RosterColumnSuggestion>;
  meta: AiSuggestionMeta;
  truncated: Scalars['Boolean']['output'];
};

export enum RosterConflictField {
  Grupo = 'grupo',
  Marca = 'marca',
  Modelo = 'modelo',
  Tipo = 'tipo',
  TipoCombustible = 'tipo_combustible',
  TipoContador = 'tipo_contador'
}

export type RosterFieldConflict = {
  __typename: 'RosterFieldConflict';
  field: RosterConflictField;
  loaded?: Maybe<Scalars['String']['output']>;
  suggested?: Maybe<Scalars['String']['output']>;
};

export type RosterMatchedMachine = {
  __typename: 'RosterMatchedMachine';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum RosterReviewReason {
  CombustibleBajo = 'combustible_bajo',
  ConflictoConCargado = 'conflicto_con_cargado',
  ContadorBajo = 'contador_bajo',
  ContadorNoRepresentable = 'contador_no_representable',
  ContradiceRegla = 'contradice_regla',
  GrupoYTipoBajo = 'grupo_y_tipo_bajo',
  GrupoYTipoNoClaro = 'grupo_y_tipo_no_claro',
  MarcaBaja = 'marca_baja',
  MarcaNueva = 'marca_nueva',
  Placeholder = 'placeholder',
  PropiedadBaja = 'propiedad_baja',
  TipoDeclaradoAproximado = 'tipo_declarado_aproximado',
  TipoInferido = 'tipo_inferido'
}

export type RosterRowInput = {
  row_index: Scalars['Int']['input'];
  values: Array<RosterRowValueInput>;
};

export type RosterRowSuggestion = {
  __typename: 'RosterRowSuggestion';
  conflicts: Array<RosterFieldConflict>;
  error: Scalars['Boolean']['output'];
  grupo_y_tipo?: Maybe<RosterClassificationSuggestion>;
  marca?: Maybe<RosterBrandSuggestion>;
  matched_machine?: Maybe<RosterMatchedMachine>;
  modelo?: Maybe<Scalars['String']['output']>;
  review_reasons: Array<RosterReviewReason>;
  row_index: Scalars['Int']['output'];
  rules: Array<RosterRule>;
  skipped: Scalars['Boolean']['output'];
  subtipo?: Maybe<Scalars['String']['output']>;
  tipo_combustible?: Maybe<RosterValueSuggestion>;
  tipo_contador?: Maybe<RosterValueSuggestion>;
  tipo_propiedad?: Maybe<RosterValueSuggestion>;
};

export type RosterRowValueInput = {
  template_column: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RosterRowsSuggestion = {
  __typename: 'RosterRowsSuggestion';
  meta: AiSuggestionMeta;
  rows: Array<RosterRowSuggestion>;
  truncated: Scalars['Boolean']['output'];
  type_options_truncated: Scalars['Boolean']['output'];
};

export enum RosterRule {
  EquipoPesadoHs = 'equipo_pesado_hs',
  OtroConSubtipo = 'otro_con_subtipo',
  TipoDeclarado = 'tipo_declarado'
}

export type RosterValueSuggestion = {
  __typename: 'RosterValueSuggestion';
  confidence: Scalars['Float']['output'];
  probability: Scalars['Float']['output'];
  suggested?: Maybe<Scalars['String']['output']>;
};

export type SaveChecklistTemplateDraftInput = {
  /** Omitido: un borrador nuevo hereda el de la versión publicada; uno existente lo conserva. */
  counter_requirement?: InputMaybe<ChecklistCounterRequirement>;
  description?: InputMaybe<Scalars['String']['input']>;
  items: Array<ChecklistTemplateItemInput>;
  template_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type Schema = {
  __typename: 'Schema';
  mutation?: Maybe<Mutation>;
  query?: Maybe<Query>;
  subscription?: Maybe<Subscription>;
};

export type ServerError = Error & {
  __typename: 'ServerError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type ServiceRemaining = {
  __typename: 'ServiceRemaining';
  fraction: Scalars['Float']['output'];
  type: PeriodType;
  value: Scalars['Float']['output'];
};

export type ServiceReport = {
  __typename: 'ServiceReport';
  comments?: Maybe<Scalars['String']['output']>;
  counter: Counter;
  counter_in_sequence?: Maybe<Counter>;
  created_at: Scalars['DateTime']['output'];
  date: Scalars['LocalDate']['output'];
  date_in_sequence?: Maybe<Scalars['LocalDate']['output']>;
  error_fraction?: Maybe<Scalars['Float']['output']>;
  files: Array<File>;
  id: Scalars['Int']['output'];
  plan?: Maybe<MaintenancePlan>;
  program?: Maybe<MpProgram>;
  service_type: Scalars['String']['output'];
};

export type ServiceSequenceConnection = {
  __typename: 'ServiceSequenceConnection';
  items: Array<ServiceSequenceItem>;
};

export type ServiceSequenceItem = {
  __typename: 'ServiceSequenceItem';
  counter?: Maybe<Scalars['Float']['output']>;
  counter_in_sequence?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['LocalDate']['output']>;
  date_in_sequence?: Maybe<Scalars['LocalDate']['output']>;
  period: Scalars['Float']['output'];
  period_type: PeriodType;
  program: MpProgram;
  sequence_index: Scalars['Int']['output'];
};

export type ServicesDashboard = {
  __typename: 'ServicesDashboard';
  machines: Array<Machine>;
  usages: Array<AverageUsage>;
};

export type SetChecklistTemplateAssignmentsInput = {
  rules: Array<ChecklistAssignmentRuleInput>;
  template_id: Scalars['ID']['input'];
};

export type SetMachineFuelCapacityInput = {
  fuel_capacity: Scalars['Float']['input'];
  machine_id: Scalars['Int']['input'];
};

export type SetManagedEmployeePasswordInput = {
  password: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};

export type SetRentalParameterValueInput = {
  applies_to_counter_type?: InputMaybe<CounterType>;
  applies_to_group?: InputMaybe<MachineGroup>;
  applies_to_type_id?: InputMaybe<Scalars['Int']['input']>;
  owner_company_id?: InputMaybe<Scalars['Int']['input']>;
  parameter_def_id: Scalars['Int']['input'];
  scope_business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  scope_company_id?: InputMaybe<Scalars['Int']['input']>;
  scope_project_id?: InputMaybe<Scalars['Int']['input']>;
  target_machine_id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type SetRentalParameterValuePayload = {
  __typename: 'SetRentalParameterValuePayload';
  success: Scalars['Boolean']['output'];
  updated_count: Scalars['Int']['output'];
};

export type SetWorkOrderStatusInProgressInput = {
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SetWorkOrderStatusPayload = ItemWorkOrder | WorkOrderStatusChangeError;

export type SetWorkOrderStatusToReviewInput = {
  counter?: InputMaybe<CounterInput>;
};

export type StatsByCounterType = {
  __typename: 'StatsByCounterType';
  total_counter: Scalars['Float']['output'];
  total_fuel: Scalars['Float']['output'];
  type: CounterType;
};

export type StockControlActivity = {
  __typename: 'StockControlActivity';
  datetime: Scalars['DateTime']['output'];
  report: StockControlReport;
};

export type StockControlReport = {
  __typename: 'StockControlReport';
  created_by: Employee;
  datetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  photos: Array<File>;
  stock_computed?: Maybe<Scalars['Float']['output']>;
  stock_measured: Scalars['Float']['output'];
  tank: Machine;
};

export type StockDeviationKpi = {
  __typename: 'StockDeviationKpi';
  control_frequency: Scalars['Float']['output'];
  deviation_liters: Scalars['Float']['output'];
  deviation_percentage: Scalars['Float']['output'];
  dispatched_liters: Scalars['Float']['output'];
};

export type StringUnionWrapper = {
  __typename: 'StringUnionWrapper';
  value: Scalars['String']['output'];
};

export type SubmitCertificationForReviewInput = {
  certification_id: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  external_reviewer_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  internal_reviewer_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SubmitCertificationForReviewResponse = {
  __typename: 'SubmitCertificationForReviewResponse';
  certification: RentalCertification;
  reviewers: Array<Employee>;
  warnings?: Maybe<SubmitCertificationWarnings>;
};

export type SubmitCertificationWarnings = {
  __typename: 'SubmitCertificationWarnings';
  uncertified_machine_ids: Array<Scalars['Int']['output']>;
  uncertified_machines: Array<UncertifiedMachineSummary>;
};

export type SubscribeToBilderitReportInput = {
  company_id: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
  report_type: BilderitReportType;
};

export type Subscription = {
  __typename: 'Subscription';
  dailyReportChanged?: Maybe<DailyReport>;
  machineNoticeChanged?: Maybe<MachineNotice>;
  uploadStatusChanged?: Maybe<UploadStatus>;
};


export type SubscriptionDailyReportChangedArgs = {
  context: Context;
};


export type SubscriptionMachineNoticeChangedArgs = {
  context: Context;
};


export type SubscriptionUploadStatusChangedArgs = {
  statusId: Scalars['ID']['input'];
};

export type SuccessResult = {
  __typename: 'SuccessResult';
  result?: Maybe<Scalars['String']['output']>;
};

export type SyncMachineCountersInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SyncMachinesStatusInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SystemFlag = {
  __typename: 'SystemFlag';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum TmProvider {
  FlespiAemp = 'FlespiAemp',
  FlespiAovx = 'FlespiAovx',
  FlespiCusat = 'FlespiCUSAT',
  FlespiCalamp = 'FlespiCalamp',
  FlespiDevelon = 'FlespiDevelon',
  FlespiFleetboard = 'FlespiFleetboard',
  FlespiQueclink = 'FlespiQueclink',
  FlespiRsv = 'FlespiRSV',
  FlespiTeltonikaFmc130 = 'FlespiTeltonikaFMC130',
  FlespiTeltonikaFmc150 = 'FlespiTeltonikaFMC150',
  FlespiVisionLink = 'FlespiVisionLink',
  FlespiWarrior = 'FlespiWarrior'
}

export type Tag = {
  __typename: 'Tag';
  color?: Maybe<TagColor>;
  /** Explica qué clasifica la etiqueta, sobre todo útil para códigos ilegibles (p. ej. D007). Opcional, hasta 200 caracteres. */
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<TagGroup>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  tag: Scalars['String']['output'];
  usage_count: Scalars['Int']['output'];
};

/**
 * Resultado de la revisión asistida del catálogo de etiquetas de una
 * compañía y scope (BIL-5192).
 */
export type TagCatalogReview = {
  __typename: 'TagCatalogReview';
  /** Pares que Jev juzga la misma categoría o relacionados, con probabilidad ≥ 0.5, ordenados por probabilidad descendente. */
  duplicates: Array<TagDuplicateCandidate>;
  meta: AiSuggestionMeta;
  /** Etiquetas que efectivamente se revisaron (con respuesta de Jev). */
  reviewed_count: Scalars['Int']['output'];
  /** Una entrada por etiqueta revisada (especificidad, legibilidad del nombre, participación de uso). */
  tags: Array<TagReviewItem>;
  /** Etiquetas activas del catálogo en este scope. */
  total_count: Scalars['Int']['output'];
  /** true cuando el catálogo tenía más de 120 etiquetas activas, o cuando se llegó al presupuesto de tiempo antes de terminar de revisar todo. */
  truncated: Scalars['Boolean']['output'];
  /** Por qué quedó truncada: MAX_TAGS (más de 120 etiquetas activas) o DEADLINE (se agotó el presupuesto de tiempo). null cuando truncated=false. */
  truncated_reason?: Maybe<TagReviewTruncatedReason>;
};

export enum TagColor {
  Amber = 'AMBER',
  Blue = 'BLUE',
  Cyan = 'CYAN',
  Emerald = 'EMERALD',
  Gray = 'GRAY',
  Green = 'GREEN',
  Indigo = 'INDIGO',
  Lime = 'LIME',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Red = 'RED',
  Rose = 'ROSE',
  Sky = 'SKY',
  Slate = 'SLATE',
  Teal = 'TEAL',
  Violet = 'VIOLET',
  Yellow = 'YELLOW'
}

export type TagDuplicateCandidate = {
  __typename: 'TagDuplicateCandidate';
  probability: Scalars['Float']['output'];
  relation: TagRelation;
  tag_a_id: Scalars['ID']['output'];
  tag_b_id: Scalars['ID']['output'];
};

export type TagGroup = {
  __typename: 'TagGroup';
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum TagRelation {
  Related = 'RELATED',
  Same = 'SAME'
}

export type TagReviewItem = {
  __typename: 'TagReviewItem';
  is_code_like: Scalars['Boolean']['output'];
  specificity: TagSpecificity;
  /** Probabilidad asociada a la especificidad elegida (la del valor devuelto en specificity). */
  specificity_probability: Scalars['Float']['output'];
  tag_id: Scalars['ID']['output'];
  unreadable_name_probability: Scalars['Float']['output'];
  /** usage_count de la etiqueta / total de vínculos del scope revisado, en [0,1]. */
  usage_share: Scalars['Float']['output'];
};

export enum TagReviewTruncatedReason {
  Deadline = 'DEADLINE',
  MaxTags = 'MAX_TAGS'
}

export enum TagScope {
  Document = 'DOCUMENT',
  MachineNotice = 'MACHINE_NOTICE',
  Mp = 'MP',
  MpBrand = 'MP_BRAND',
  MpType = 'MP_TYPE',
  Ot = 'OT'
}

export enum TagSpecificity {
  Broad = 'BROAD',
  CatchAll = 'CATCH_ALL',
  Specific = 'SPECIFIC'
}

export type TagsConnection = {
  __typename: 'TagsConnection';
  edges: Array<Tag>;
};

export type TanksDashboard = {
  __typename: 'TanksDashboard';
  consumption_stats?: Maybe<ConsumptionStats>;
  providers?: Maybe<Array<Maybe<TanksDashboardProviderItem>>>;
  tanks: Array<TanksDashboardTankItem>;
  /**
   * Trend statistics comparing current period to previous period of same length.
   * For example, if querying Jan 1-31 (31 days), this compares to Dec 1-31 (also 31 days).
   */
  trend_stats?: Maybe<TrendStats>;
};

export type TanksDashboardKpis = {
  __typename: 'TanksDashboardKpis';
  average_rotation: AverageRotationKpi;
  stock_deviation: StockDeviationKpi;
  traceability: TraceabilityKpi;
  verified_dispatches: VerifiedDispatchesKpi;
};

export type TanksDashboardProviderItem = {
  __typename: 'TanksDashboardProviderItem';
  dispatch_count: Scalars['Int']['output'];
  liters_out: Scalars['Float']['output'];
  liters_to_consumers: Scalars['Float']['output'];
  liters_to_storage: Scalars['Float']['output'];
  provider: FuelProvider;
};

export type TanksDashboardTankItem = {
  __typename: 'TanksDashboardTankItem';
  /**
   * Time-weighted average stock level during the period.
   * Represents "idle capital" - the average fuel level held over time,
   * properly weighted by how long each stock level was maintained.
   * Formula: sum(stock_level * duration_at_that_level) / total_period_duration.
   * If this is high relative to consumption, the company could reduce
   * inventory and free up working capital.
   * Used to calculate the Stock Efficiency / Immobilized Capital KPI.
   * Null when there's insufficient data to calculate (no stock controls or dispatches).
   */
  avg_stock?: Maybe<Scalars['Float']['output']>;
  final_stock: Scalars['Float']['output'];
  initial_stock: Scalars['Float']['output'];
  kpis?: Maybe<TanksDashboardKpis>;
  /**
   * Total liters received by this tank in the period.
   * This is the sum of liters_in_from_providers + liters_in_from_tanks.
   * Kept for backward compatibility.
   */
  liters_in: Scalars['Float']['output'];
  /** Liters received from fuel providers (external sources) */
  liters_in_from_providers: Scalars['Float']['output'];
  /** Liters received from other tanks (internal transfers) */
  liters_in_from_tanks: Scalars['Float']['output'];
  /**
   * Total liters dispatched from this tank in the period.
   * This is the sum of liters_out_to_consumers + liters_out_to_tanks.
   * Kept for backward compatibility.
   */
  liters_out: Scalars['Float']['output'];
  /** Liters dispatched to consumer machines (actual consumption) */
  liters_out_to_consumers: Scalars['Float']['output'];
  /** Liters dispatched to other tanks (internal transfers) */
  liters_out_to_tanks: Scalars['Float']['output'];
  measured_error?: Maybe<Scalars['Float']['output']>;
  /**
   * Project IDs where this tank was deployed during the queried period (from deployment history).
   * Used by frontend to correctly group tanks by project in mass balance selectors.
   * If empty, the tank had no deployment history and the current project should be used as fallback.
   */
  project_ids_in_period: Array<Scalars['Int']['output']>;
  tank: Machine;
};

export type TelemetryDashboardStats = {
  __typename: 'TelemetryDashboardStats';
  equipments: Array<TelemetryEquipmentStats>;
  fuelCostAvailable: Scalars['Boolean']['output'];
  globalStats: TelemetryGroupStats;
  movementSummary: TelemetryMovementSummary;
  pricingCoverage: TelemetryPricingCoverage;
  projectStats: Array<TelemetryProjectStats>;
};

export type TelemetryDevice = {
  btrack_unit_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  ident: Scalars['String']['output'];
  last_activity_at?: Maybe<Scalars['DateTime']['output']>;
  links: Array<BilderitConnectDevice>;
  name: Scalars['String']['output'];
  protocol: Scalars['String']['output'];
};

export enum TelemetryDeviceCategory {
  Integration = 'INTEGRATION',
  Tracker = 'TRACKER'
}

export type TelemetryDeviceMetadata = {
  __typename: 'TelemetryDeviceMetadata';
  ignition_voltage_threshold?: Maybe<Scalars['Float']['output']>;
};

export type TelemetryEquipmentStats = {
  __typename: 'TelemetryEquipmentStats';
  combustible?: Maybe<Scalars['Float']['output']>;
  combustibleActivo?: Maybe<Scalars['Float']['output']>;
  combustibleRalenti?: Maybe<Scalars['Float']['output']>;
  costoActivo?: Maybe<Scalars['Float']['output']>;
  costoRalenti?: Maybe<Scalars['Float']['output']>;
  costoTotal?: Maybe<Scalars['Float']['output']>;
  fechaUltimaActividad?: Maybe<Scalars['DateTime']['output']>;
  horas?: Maybe<Scalars['Float']['output']>;
  horasActivas?: Maybe<Scalars['Float']['output']>;
  machine: Machine;
  machineId: Scalars['Int']['output'];
  porcentajeRalenti?: Maybe<Scalars['Float']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  ralenti?: Maybe<Scalars['Float']['output']>;
};

export type TelemetryGroupStats = {
  __typename: 'TelemetryGroupStats';
  promedioCombustiblePorEquipo?: Maybe<Scalars['Float']['output']>;
  promedioHorasPorEquipo?: Maybe<Scalars['Float']['output']>;
  promedioPorcentajeRalenti?: Maybe<Scalars['Float']['output']>;
  promedioRalentiPorEquipo?: Maybe<Scalars['Float']['output']>;
  totalCombustible?: Maybe<Scalars['Float']['output']>;
  totalCombustibleActivo?: Maybe<Scalars['Float']['output']>;
  totalCombustibleRalenti?: Maybe<Scalars['Float']['output']>;
  totalCostoActivo?: Maybe<Scalars['Float']['output']>;
  totalCostoEstimado?: Maybe<Scalars['Float']['output']>;
  totalCostoRalenti?: Maybe<Scalars['Float']['output']>;
  totalEquipos: Scalars['Int']['output'];
  totalHoras?: Maybe<Scalars['Float']['output']>;
  totalHorasActivas?: Maybe<Scalars['Float']['output']>;
  totalRalenti?: Maybe<Scalars['Float']['output']>;
};

export type TelemetryMovementSummary = {
  __typename: 'TelemetryMovementSummary';
  affectedProjectsCount: Scalars['Int']['output'];
  movedMachinesCount: Scalars['Int']['output'];
};

export type TelemetryPricingCoverage = {
  __typename: 'TelemetryPricingCoverage';
  coveredProjects: Scalars['Int']['output'];
  totalProjects: Scalars['Int']['output'];
  uncoveredProjectIds: Array<Scalars['Int']['output']>;
  uncoveredProjects: Scalars['Int']['output'];
};

export type TelemetryProjectMovement = {
  __typename: 'TelemetryProjectMovement';
  machine: Machine;
  machineId: Scalars['Int']['output'];
  otherProjectIds: Array<Scalars['Int']['output']>;
  otherProjects: Array<Project>;
};

export type TelemetryProjectStats = {
  __typename: 'TelemetryProjectStats';
  equipment: Array<TelemetryEquipmentStats>;
  movement: Array<TelemetryProjectMovement>;
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  stats: TelemetryGroupStats;
};

export type TelemetrySandboxRuntimeConfig = {
  __typename: 'TelemetrySandboxRuntimeConfig';
  active_scope: TelemetrySandboxScope;
  active_scope_key: Scalars['ID']['output'];
  editable: Scalars['Boolean']['output'];
  scopes: Array<TelemetrySandboxScope>;
};

export type TelemetrySandboxScope = {
  __typename: 'TelemetrySandboxScope';
  account_label?: Maybe<Scalars['String']['output']>;
  provider_family?: Maybe<Scalars['String']['output']>;
  scope_key: Scalars['ID']['output'];
};

export type TelemetrySnapshot = {
  __typename: 'TelemetrySnapshot';
  DEF_remaining_percentage?: Maybe<FloatSnapshot>;
  DEF_tank_capacity?: Maybe<FloatSnapshot>;
  counter_offset?: Maybe<Scalars['Float']['output']>;
  cumulative_contact_hours?: Maybe<FloatSnapshot>;
  cumulative_distance_traveled_km?: Maybe<FloatSnapshot>;
  cumulative_fuel_consumed_lts?: Maybe<FloatSnapshot>;
  cumulative_idle_hours?: Maybe<FloatSnapshot>;
  cumulative_idle_non_operating_hours?: Maybe<FloatSnapshot>;
  cumulative_load_count?: Maybe<IntSnapshot>;
  cumulative_operating_hours?: Maybe<FloatSnapshot>;
  cumulative_payload_moved_kg?: Maybe<FloatSnapshot>;
  cumulative_power_takeoff_hours?: Maybe<FloatSnapshot>;
  device_name?: Maybe<Scalars['String']['output']>;
  device_serial_number?: Maybe<Scalars['String']['output']>;
  engine_ignition_status?: Maybe<EngineIgnitionStatusSnapshot>;
  flespi_id: Scalars['ID']['output'];
  fuel_remaining_percentage?: Maybe<FloatSnapshot>;
  fuel_tank_capacity?: Maybe<FloatSnapshot>;
  machine_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<PositionSnapshot>;
  telemetry_provider: TmProvider;
  vin?: Maybe<Scalars['String']['output']>;
};

export type TimestampMicroseconds = {
  __typename: 'TimestampMicroseconds';
  value: Scalars['Float']['output'];
};

export type TimestampSeconds = {
  __typename: 'TimestampSeconds';
  value: Scalars['Float']['output'];
};

export type TotalBcDevices = {
  __typename: 'TotalBCDevices';
  connected: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TotalCompanyStats = {
  __typename: 'TotalCompanyStats';
  total_bc_devices: TotalBcDevices;
  total_employees: Scalars['Int']['output'];
  total_machines: Array<TotalMachinesGroup>;
  total_projects: Scalars['Int']['output'];
};

export type TotalMachinesGroup = {
  __typename: 'TotalMachinesGroup';
  group: MachineGroup;
  total: Scalars['Int']['output'];
};

/**
 * Traceability KPI measures how much of the fuel that went through a tank's flowmeter
 * has a corresponding dispatch report.
 *
 * The calculation compares:
 * 1. Total flowmeter advance: MAX(flowmeter_end) - MIN(flowmeter_start) from all dispatches
 * 2. Sum of dispatched liters: SUM(flowmeter_end - flowmeter_start) for each individual dispatch
 *
 * Three-bucket model:
 * - traced_liters: Fuel confirmed by both flowmeter and dispatch reports (traced)
 * - untraced_liters: Fuel that went through the flowmeter without a corresponding dispatch (traceable but untraced)
 * - non_traceable_liters: Fuel from tanks with non-totalizing flowmeters (untraceable)
 * - surplus_liters: Dispatches that exceed flowmeter advance (indicates flowmeter malfunction)
 *
 * Non-totalizing flowmeters are detected heuristically: if a tank's dispatches frequently show
 * flowmeter_start ~ 0, the flowmeter resets between dispatches and traceability via flowmeter continuity is impossible.
 *
 * consistency_score: 0-100, symmetric penalty for any deviation between flowmeter and dispatches.
 * 100 = perfect match, decreases for any surplus or deficit. Null when all tanks are non-totalizing.
 */
export type TraceabilityKpi = {
  __typename: 'TraceabilityKpi';
  /** Overall consistency score (0-100). Null when all tanks use non-totalizing flowmeters. */
  consistency_score?: Maybe<Scalars['Float']['output']>;
  /** Total flowmeter advance for totalizing tanks in the period */
  flowmeter_advance: Scalars['Float']['output'];
  /** Number of tanks detected as non-totalizing in this period */
  non_totalizing_tank_count: Scalars['Int']['output'];
  /** Liters from tanks with non-totalizing flowmeters (traceability structurally impossible) */
  non_traceable_liters: Scalars['Float']['output'];
  /** Sum of liters from individual dispatch reports for totalizing tanks */
  report_liters: Scalars['Float']['output'];
  /** Liters where dispatches exceed flowmeter advance (indicates flowmeter malfunction) */
  surplus_liters: Scalars['Float']['output'];
  /** Number of tanks detected as totalizing in this period */
  totalizing_tank_count: Scalars['Int']['output'];
  /** Liters confirmed by both flowmeter advance and dispatch reports — traced (min of the two) */
  traced_liters: Scalars['Float']['output'];
  /** Liters that went through the flowmeter but have no dispatch report (deficit, totalizing tanks only) */
  untraced_liters: Scalars['Float']['output'];
};

export type TrackerTelemetryDevice = TelemetryDevice & {
  __typename: 'TrackerTelemetryDevice';
  btrack_unit_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  ident: Scalars['String']['output'];
  ignition_voltage_threshold?: Maybe<Scalars['Float']['output']>;
  last_activity_at?: Maybe<Scalars['DateTime']['output']>;
  last_meassured_voltage?: Maybe<Scalars['Float']['output']>;
  links: Array<BilderitConnectDevice>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  protocol: Scalars['String']['output'];
};

/**
 * Period-over-period trend statistics for the fuel dashboard KPI cards.
 * Each field represents the percentage change from the previous period.
 * Positive values indicate an increase, negative values indicate a decrease.
 * Null indicates insufficient data to calculate the trend (e.g., no previous period data).
 */
export type TrendStats = {
  __typename: 'TrendStats';
  /** Percentage change in total consumption liters */
  consumption_change?: Maybe<Scalars['Float']['output']>;
  /** Percentage change in total provider input liters */
  provider_input_change?: Maybe<Scalars['Float']['output']>;
};

export type TriggerFleetSyncResult = {
  __typename: 'TriggerFleetSyncResult';
  run_id: Scalars['ID']['output'];
};

export type Ute = {
  __typename: 'UTE';
  cuit: Scalars['String']['output'];
  partners?: Maybe<Array<Maybe<UtePartner>>>;
};

export type UtePartner = {
  __typename: 'UTEPartner';
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type UnarchiveMachineInput = {
  counter_type?: InputMaybe<CounterType>;
  counter_value?: InputMaybe<Scalars['Float']['input']>;
  machine_id: Scalars['Int']['input'];
  project_id: Scalars['Int']['input'];
};

export type UncertifiedMachineSummary = {
  __typename: 'UncertifiedMachineSummary';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UnmarkMachinesForCertificationResponse = {
  __typename: 'UnmarkMachinesForCertificationResponse';
  success: Scalars['Boolean']['output'];
  unmarked_count: Scalars['Int']['output'];
};

export type UnregisterWorkOrderTasksInput = {
  ot_id: Scalars['ID']['input'];
  task_ids: Array<Scalars['ID']['input']>;
};

export type UnregisterWorkOrderTasksPayload = ItemWorkOrder;

export type UpdateBusinessUnitInput = {
  name: Scalars['String']['input'];
};

export type UpdateCompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  cuit?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDailyReportInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  cost_center_id?: InputMaybe<Scalars['Int']['input']>;
  counter?: InputMaybe<CounterInput>;
  file_ids: Array<Scalars['ID']['input']>;
  filters?: InputMaybe<Scalars['Boolean']['input']>;
  fuel?: InputMaybe<Scalars['Float']['input']>;
  grease?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  motor_oil?: InputMaybe<Scalars['Float']['input']>;
  tasks?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentInput = {
  document_id: Scalars['ID']['input'];
  expiration_date?: InputMaybe<Scalars['LocalDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentTagsInput = {
  document_id: Scalars['ID']['input'];
  tag_ids: Array<Scalars['ID']['input']>;
};

export type UpdateFederatedIdentityInformationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['LocalDate']['input']>;
  cuil?: InputMaybe<Scalars['String']['input']>;
  dni?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFederatedIdentityInformationResponse = DuplicatedEntryError | MeItem;

export type UpdateFixedAssetInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<CounterInput>;
  domain?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  replacement_value?: InputMaybe<Scalars['Float']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFixedAssetResponse = DuplicatedMachineError | Machine;

export type UpdateFuelDispatchedReportInput = {
  destination_counter?: InputMaybe<CounterInput>;
  file_ids: Array<Scalars['ID']['input']>;
  flowmeter_end: Scalars['Float']['input'];
  flowmeter_start: Scalars['Float']['input'];
  fuel_type: FuelType;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFuelDispatchedReportPayload = FuelDispatchedReport;

export type UpdateFuelProviderInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateHeavyEquipmentInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<CounterInput>;
  domain?: InputMaybe<Scalars['String']['input']>;
  engine_number?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  replacement_value?: InputMaybe<Scalars['Float']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateHeavyEquipmentResponse = DuplicatedMachineError | Machine;

export type UpdateLocationInput = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type UpdateMachineConsumableInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equivalences?: InputMaybe<Array<MachineConsumableRef>>;
  internal_code?: InputMaybe<Scalars['String']['input']>;
  manufacturer_code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMachineConsumablePayload = MachineConsumableItem;

export type UpdateMachineNoticeInput = {
  tag_ids: Array<Scalars['ID']['input']>;
};

export type UpdateMachineNoticeStatusInput = {
  evidence_file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  resolution_note: Scalars['String']['input'];
  status: MachineNoticeStatus;
};

export type UpdateMachinePayload = DuplicatedMachineError | ItemMachine;

export type UpdateMaintenancePlanInput = {
  base_period?: InputMaybe<Scalars['Float']['input']>;
  brand_tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  description: Scalars['String']['input'];
  machine_parts: Array<MachinePartInput>;
  period_type?: InputMaybe<PeriodType>;
  programs: Array<MpProgramInput>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  type_tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateMaintenancePlanPayload = MaintenancePlanItem;

export type UpdateMaintenancePlanTagsInput = {
  brand_tag_ids: Array<Scalars['ID']['input']>;
  plan_id: Scalars['Int']['input'];
  tag_ids: Array<Scalars['ID']['input']>;
  type_tag_ids: Array<Scalars['ID']['input']>;
};

export type UpdateMe = {
  __typename: 'UpdateMe';
  item: Me;
};

export type UpdateMeInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['LocalDate']['input']>;
  cuil?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMeResponse = DuplicatedEntryError | ServerError | UpdateMe;

export type UpdateMobilityInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<CounterInput>;
  domain?: InputMaybe<Scalars['String']['input']>;
  engine_number?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  fuel_type?: InputMaybe<FuelType>;
  model?: InputMaybe<Scalars['String']['input']>;
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  replacement_value?: InputMaybe<Scalars['Float']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMobilityResponse = DuplicatedMachineError | Machine;

export type UpdateMoveReportInput = {
  counter?: InputMaybe<CounterValueInput>;
  file_ids: Array<Scalars['ID']['input']>;
};

export type UpdateNextServiceInput = {
  machine_id: Scalars['Int']['input'];
  next_sequence_index: Scalars['Int']['input'];
  service_shift: Scalars['Int']['input'];
};

export type UpdateNextServicePayload = ItemMachine;

export type UpdateOosReportInput = {
  cause: Scalars['String']['input'];
  charge_type: OosChargeType;
  counter_type: CounterType;
  counter_value: Scalars['Float']['input'];
};

export type UpdateOtHourInput = {
  executed_hours?: InputMaybe<Scalars['Float']['input']>;
  execution_date?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  labor_type?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  planned_hours?: InputMaybe<Scalars['Float']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProjectCostCenterInput = {
  name: Scalars['String']['input'];
};

export type UpdateProjectInput = {
  business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  ute?: InputMaybe<UpdateUteInput>;
};

export type UpdatePublicApiClientInput = {
  /** A pedido de quién se hace el cambio; queda en el log. */
  comment: Scalars['String']['input'];
  name: Scalars['String']['input'];
  owner: PublicApiContactInput;
  roles: Array<PublicApiKeyRole>;
  technical: PublicApiContactInput;
};

export type UpdateRentalParameterDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DataType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStockControlReportInput = {
  file_ids: Array<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  stock_measured: Scalars['Float']['input'];
};

export type UpdateStockControlReportPayload = StockControlReport;

export type UpdateTagGroupInput = {
  id: Scalars['ID']['input'];
  is_archived: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  scope: TagScope;
};

export type UpdateTagInput = {
  color?: InputMaybe<TagColor>;
  description?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['ID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_archived: Scalars['Boolean']['input'];
  scope: TagScope;
  tag: Scalars['String']['input'];
};

export type UpdateTelemetryDeviceLinkInput = {
  counter_offset?: InputMaybe<Scalars['Float']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTruckInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<CounterInput>;
  domain?: InputMaybe<Scalars['String']['input']>;
  engine_number?: InputMaybe<Scalars['String']['input']>;
  extra_data?: InputMaybe<Scalars['JSONObject']['input']>;
  fuel_capacity?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  mp_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  ownership_type: OwnershipType;
  ownership_type_other?: InputMaybe<Scalars['String']['input']>;
  photo_ids: Array<Scalars['ID']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  preferred_counter_type?: InputMaybe<CounterType>;
  replacement_value?: InputMaybe<Scalars['Float']['input']>;
  serial_number?: InputMaybe<Scalars['String']['input']>;
  service_period?: InputMaybe<Scalars['Float']['input']>;
  service_period_type?: InputMaybe<PeriodType>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type_id?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTruckResponse = DuplicatedMachineError | Machine;

export type UpdateUteInput = {
  cuit?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Array<InputMaybe<UpdateUtePartnerInput>>>;
};

export type UpdateUtePartnerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateWorkOrderInput = {
  closed_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  closed_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  comments_draft?: InputMaybe<Scalars['String']['input']>;
  comments_in_progress?: InputMaybe<Scalars['String']['input']>;
  comments_to_approve?: InputMaybe<Scalars['String']['input']>;
  comments_to_review?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<CounterInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  draft_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  draft_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  file_ids: Array<Scalars['ID']['input']>;
  hours: Array<UpdateOtHourInput>;
  in_progress_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  in_progress_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  machine_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  tasks: Array<UpdateWorkOrderTaskInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkOrderPayload = ItemWorkOrder;

export type UpdateWorkOrderTagsInput = {
  tag_ids: Array<Scalars['ID']['input']>;
  work_order_id: Scalars['ID']['input'];
};

export type UpdateWorkOrderTaskInput = {
  action: Scalars['String']['input'];
  compartment: Scalars['String']['input'];
  done: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  item: Scalars['String']['input'];
  preferred_consumable_code?: InputMaybe<Scalars['String']['input']>;
  preferred_quantity?: InputMaybe<Scalars['Float']['input']>;
  used_consumable_code?: InputMaybe<Scalars['String']['input']>;
  used_quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UploadStatus = {
  __typename: 'UploadStatus';
  info?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UploadStatusType>;
};

export enum UploadStatusType {
  Error = 'error',
  Loading = 'loading',
  NotStarted = 'not_started',
  Success = 'success'
}

export type UploadTarget = {
  __typename: 'UploadTarget';
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UpsertCompanyIntegrationInput = {
  company_id: Scalars['Int']['input'];
  credentials: Scalars['JSON']['input'];
  is_active: Scalars['Boolean']['input'];
  provider: Scalars['String']['input'];
};

export type UsageReport = {
  __typename: 'UsageReport';
  comments?: Maybe<Scalars['String']['output']>;
  cost_center?: Maybe<ProjectCostCenter>;
  cost_center_id?: Maybe<Scalars['Int']['output']>;
  counter: Counter;
  created_at: Scalars['DateTime']['output'];
  creator?: Maybe<Employee>;
  filters: Scalars['Boolean']['output'];
  fuel: Scalars['Float']['output'];
  grease: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  modifier?: Maybe<Employee>;
  motor_oil?: Maybe<Scalars['Float']['output']>;
  photos: Array<File>;
  tasks?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type User = {
  __typename: 'User';
  address?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['LocalDate']['output']>;
  cuil?: Maybe<Scalars['String']['output']>;
  dni: Scalars['String']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_employee?: Maybe<Scalars['Boolean']['output']>;
  last_name: Scalars['String']['output'];
  managed_by_company_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserNotSignedUpError = Error & {
  __typename: 'UserNotSignedUpError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type VerifiedDispatchesKpi = {
  __typename: 'VerifiedDispatchesKpi';
  total_dispatches: Scalars['Int']['output'];
  verified_dispatches: Scalars['Int']['output'];
  verified_percentage: Scalars['Float']['output'];
};

export type VisionLinkReportMatch = {
  __typename: 'VisionLinkReportMatch';
  report_type: Scalars['String']['output'];
  s3_key: Scalars['String']['output'];
};

export type VisionLinkReportsByDateInput = {
  date: Scalars['LocalDate']['input'];
  integration_id: Scalars['ID']['input'];
};

export type VisionLinkReportsByDateResult = {
  __typename: 'VisionLinkReportsByDateResult';
  company_id: Scalars['Int']['output'];
  company_name: Scalars['String']['output'];
  date: Scalars['LocalDate']['output'];
  found: Array<VisionLinkReportMatch>;
  integration_id: Scalars['ID']['output'];
  missing: Array<Scalars['String']['output']>;
};

export type WorkOrder = {
  __typename: 'WorkOrder';
  assigned: Array<Employee>;
  canceled_at?: Maybe<Scalars['DateTime']['output']>;
  canceled_by?: Maybe<Employee>;
  closed_date?: Maybe<Scalars['DateTime']['output']>;
  comments_draft?: Maybe<Scalars['String']['output']>;
  comments_in_progress?: Maybe<Scalars['String']['output']>;
  comments_to_approve?: Maybe<Scalars['String']['output']>;
  comments_to_review?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  created_at: Scalars['DateTime']['output'];
  created_by: Employee;
  description: Scalars['String']['output'];
  draft_end_date?: Maybe<Scalars['DateTime']['output']>;
  draft_start_date?: Maybe<Scalars['DateTime']['output']>;
  files: Array<File>;
  hours: Array<WorkOrderHours>;
  id: Scalars['ID']['output'];
  in_progress_end_date?: Maybe<Scalars['DateTime']['output']>;
  in_progress_start_date?: Maybe<Scalars['DateTime']['output']>;
  machine?: Maybe<Machine>;
  project?: Maybe<Project>;
  serial_number: Scalars['Int']['output'];
  service_report?: Maybe<ServiceReport>;
  status: WorkOrderStatus;
  tags: Array<Tag>;
  tasks: Array<WorkOrderTask>;
  title: Scalars['String']['output'];
  to_approve_end_date?: Maybe<Scalars['DateTime']['output']>;
  to_approve_start_date?: Maybe<Scalars['DateTime']['output']>;
  to_review_end_date?: Maybe<Scalars['DateTime']['output']>;
  to_review_start_date?: Maybe<Scalars['DateTime']['output']>;
  type: WorkOrderType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Employee>;
};

export type WorkOrderActivity = {
  __typename: 'WorkOrderActivity';
  datetime: Scalars['DateTime']['output'];
  report: WorkOrder;
};

export enum WorkOrderFacetField {
  Status = 'STATUS',
  Tags = 'TAGS',
  Type = 'TYPE'
}

export type WorkOrderFacetGroup = {
  __typename: 'WorkOrderFacetGroup';
  facets: Array<Facet>;
  field: WorkOrderFacetField;
};

export type WorkOrderHours = {
  __typename: 'WorkOrderHours';
  created_at: Scalars['DateTime']['output'];
  created_by: Employee;
  executed_hours?: Maybe<Scalars['Float']['output']>;
  execution_date?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['ID']['output'];
  labor_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  planned_hours?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Employee>;
  user?: Maybe<Employee>;
};

export enum WorkOrderStatus {
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  ToApprove = 'TO_APPROVE',
  ToReview = 'TO_REVIEW'
}

export type WorkOrderStatusChangeError = Error & {
  __typename: 'WorkOrderStatusChangeError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type WorkOrderTask = {
  __typename: 'WorkOrderTask';
  action: Scalars['String']['output'];
  compartment: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  done: Scalars['Boolean']['output'];
  done_at?: Maybe<Scalars['DateTime']['output']>;
  done_by?: Maybe<User>;
  id: Scalars['ID']['output'];
  item: Scalars['String']['output'];
  preferred_consumable?: Maybe<WorkOrderTaskConsumable>;
  preferred_quantity?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  used_consumable?: Maybe<WorkOrderTaskConsumable>;
  used_quantity?: Maybe<Scalars['Float']['output']>;
};

export type WorkOrderTaskConsumable = MachineConsumable | StringUnionWrapper;

export type WorkOrderType = {
  __typename: 'WorkOrderType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WorkOrderTypeRef = {
  id: Scalars['ID']['input'];
};

export type WorkOrdersConnection = OffsetPaginatedResponse & {
  __typename: 'WorkOrdersConnection';
  facets: Array<WorkOrderFacetGroup>;
  items: Array<WorkOrder>;
  page_info: PageInfo;
};

export type WorkingInterval = {
  __typename: 'WorkingInterval';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type GetRolesWithNestedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesWithNestedProjectsQuery = { __typename: 'Query', getMe?: { __typename: 'GetMe', item: { __typename: 'Me', id: number, first_name: string, last_name: string, dni: string, username: string, birthday?: Date | null, email: string, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, can_create_company: boolean, is_managed: boolean, pending_email?: string | null, identifier_hash: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null, projects: Array<{ __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string, slug: string } }> } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string, slug: string } } | null } | null>, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null, invitations: Array<{ __typename: 'Invitation', id: string, label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } | null> } } | { __typename: 'ProfileDataMissingError', message: string } | { __typename: 'ServerError', message: string } | { __typename: 'UserNotSignedUpError', message: string } | null };

export type RoleFieldsForUseProjectOptionsFragment = { __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null, projects: Array<{ __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string, slug: string } }> } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string, slug: string } } | null };

export type AiAnalysisItemFieldsFragment = { __typename: 'MachineNoticeAnalysisItem', description: string, id_of_first_occurrence: number, date_of_first_occurrence: string, number_of_occurrences: number };

export type MachineNoticesAnalysisItemFieldsFragment = { __typename: 'MachineNoticesAnalysisItem', machine_id: number, machine_name: string, recurring_issues: Array<{ __typename: 'MachineNoticeAnalysisItem', description: string, id_of_first_occurrence: number, date_of_first_occurrence: string, number_of_occurrences: number }>, notable_notices: Array<{ __typename: 'MachineNoticeAnalysisItem', description: string, id_of_first_occurrence: number, date_of_first_occurrence: string, number_of_occurrences: number }> };

export type AnalyzeMachineNoticesDashboardQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterMachineNoticeDashboard>;
  model?: InputMaybe<Scalars['String']['input']>;
}>;


export type AnalyzeMachineNoticesDashboardQuery = { __typename: 'Query', analyzeMachineNoticesDashboard: { __typename: 'MachineNoticesDashboardAnalysisResponse', analyzed_notice_count: number, total_notice_count: number, truncated: boolean, analysis: Array<{ __typename: 'MachineNoticesAnalysisItem', machine_id: number, machine_name: string, recurring_issues: Array<{ __typename: 'MachineNoticeAnalysisItem', description: string, id_of_first_occurrence: number, date_of_first_occurrence: string, number_of_occurrences: number }>, notable_notices: Array<{ __typename: 'MachineNoticeAnalysisItem', description: string, id_of_first_occurrence: number, date_of_first_occurrence: string, number_of_occurrences: number }> }> } };

export type GetCompanyAlertsQueryVariables = Exact<{
  context: Context;
}>;


export type GetCompanyAlertsQuery = { __typename: 'Query', getCompanyAlerts: { __typename: 'CompanyAlerts', expired_documents_count: number, overdue_services_count: number, open_critical_machine_notices_count: number } };

export type ReportSubscriptionFieldsFragment = { __typename: 'BilderitReportSubscription', id: string, report_type: BilderitReportType, email: string, created_by: number, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null };

export type GetMyReportSubscriptionsQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetMyReportSubscriptionsQuery = { __typename: 'Query', getMyBilderitReportSubscriptions: Array<{ __typename: 'BilderitReportSubscription', id: string, report_type: BilderitReportType, email: string, created_by: number, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null }> };

export type SubscribeToBilderitReportMutationVariables = Exact<{
  input: SubscribeToBilderitReportInput;
}>;


export type SubscribeToBilderitReportMutation = { __typename: 'Mutation', subscribeToBilderitReport: { __typename: 'BilderitReportSubscription', id: string, report_type: BilderitReportType, email: string, created_by: number, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null } };

export type UnsubscribeFromBilderitReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnsubscribeFromBilderitReportMutation = { __typename: 'Mutation', unsubscribeFromBilderitReport: string };

export type GetBtrackAccessTokenQueryVariables = Exact<{
  company_id: Scalars['Int']['input'];
}>;


export type GetBtrackAccessTokenQuery = { __typename: 'Query', getBtrackAccessToken: string };

export type GetBtrackDemoAccessTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBtrackDemoAccessTokenQuery = { __typename: 'Query', getBtrackDemoAccessToken: string };

export type CompanyLogoFieldsFragment = { __typename: 'Company', logo_url?: string | null };

export type GetCompanyQueryVariables = Exact<{
  company_id: Scalars['Int']['input'];
}>;


export type GetCompanyQuery = { __typename: 'Query', getCompany?: { __typename: 'AuthCheckGetCompany', item: { __typename: 'Company', id: number, name: string, cuit: string, address: string, email?: string | null, phone?: string | null, website?: string | null, logo_url?: string | null, slug: string } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AddCompanyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  cuit: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddCompanyMutation = { __typename: 'Mutation', addCompany?: { __typename: 'AddCompany', item: { __typename: 'Company', id: number, name: string, cuit: string, address: string, email?: string | null, phone?: string | null, website?: string | null, logo_url?: string | null, slug: string } } | { __typename: 'ServerError', message: string } | null };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  cuit?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyMutation = { __typename: 'Mutation', updateCompany?: { __typename: 'AuthCheckUpdateCompany', item: { __typename: 'Company', id: number, name: string, cuit: string, address: string, email?: string | null, phone?: string | null, website?: string | null, logo_url?: string | null, slug: string } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type ProjectStatsFieldsFragment = { __typename: 'ProjectStats', num_employees: number, num_machines: number, project: { __typename: 'Project', id: number, name: string }, reports_stats: { __typename: 'ProjectsReportsStats', num_oos: number, num_worked: number, num_available: number, num_pending: number, total_fuel: number, total_gasoline: number, total_diesel: number, specific_consumption_hp?: number | null, specific_consumption?: number | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> }, machines_stats: { __typename: 'MachinesStats', num_vehicles: number, num_trucks: number, num_heavy_equipments: number, num_fixed_assets: number, average_age?: number | null, total_replacement_value: number, total_rental_value: number }, daily_stats: Array<{ __typename: 'ProjectsDayStats', date: Date, fuel: number, gasoline: number, diesel: number, pending: number, worked: number, oos: number, available: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> } | null> };

export type OtherProjectsStatsFieldsFragment = { __typename: 'OtherProjectsStats', num_projects: number, num_employees: number, num_machines: number, reports_stats: { __typename: 'ProjectsReportsStats', num_oos: number, num_worked: number, num_available: number, num_pending: number, total_fuel: number, total_gasoline: number, total_diesel: number, specific_consumption_hp?: number | null, specific_consumption?: number | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> }, machines_stats: { __typename: 'MachinesStats', num_vehicles: number, num_trucks: number, num_heavy_equipments: number, num_fixed_assets: number, average_age?: number | null, total_replacement_value: number, total_rental_value: number }, daily_stats: Array<{ __typename: 'ProjectsDayStats', date: Date, fuel: number, gasoline: number, diesel: number, pending: number, worked: number, oos: number, available: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> } | null> };

export type GetDashboardQueryVariables = Exact<{
  context: Context;
  filter: FilterDateRange;
}>;


export type GetDashboardQuery = { __typename: 'Query', getDashBoard: { __typename: 'DashBoardConnection', items: Array<{ __typename: 'OtherProjectsStats', num_projects: number, num_employees: number, num_machines: number, reports_stats: { __typename: 'ProjectsReportsStats', num_oos: number, num_worked: number, num_available: number, num_pending: number, total_fuel: number, total_gasoline: number, total_diesel: number, specific_consumption_hp?: number | null, specific_consumption?: number | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> }, machines_stats: { __typename: 'MachinesStats', num_vehicles: number, num_trucks: number, num_heavy_equipments: number, num_fixed_assets: number, average_age?: number | null, total_replacement_value: number, total_rental_value: number }, daily_stats: Array<{ __typename: 'ProjectsDayStats', date: Date, fuel: number, gasoline: number, diesel: number, pending: number, worked: number, oos: number, available: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> } | null> } | { __typename: 'ProjectStats', num_employees: number, num_machines: number, project: { __typename: 'Project', id: number, name: string }, reports_stats: { __typename: 'ProjectsReportsStats', num_oos: number, num_worked: number, num_available: number, num_pending: number, total_fuel: number, total_gasoline: number, total_diesel: number, specific_consumption_hp?: number | null, specific_consumption?: number | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> }, machines_stats: { __typename: 'MachinesStats', num_vehicles: number, num_trucks: number, num_heavy_equipments: number, num_fixed_assets: number, average_age?: number | null, total_replacement_value: number, total_rental_value: number }, daily_stats: Array<{ __typename: 'ProjectsDayStats', date: Date, fuel: number, gasoline: number, diesel: number, pending: number, worked: number, oos: number, available: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> } | null> }>, totals: { __typename: 'TotalCompanyStats', total_projects: number, total_employees: number, total_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, total_bc_devices: { __typename: 'TotalBCDevices', connected: number, total: number } } } };

export type GetUploadTargetsQueryVariables = Exact<{
  input: Array<GetUploadTargetInput> | GetUploadTargetInput;
}>;


export type GetUploadTargetsQuery = { __typename: 'Query', getUploadTargets?: Array<{ __typename: 'UploadTarget', id: string, uploadUrl: string }> | null };

export type MyUserDataFragment = { __typename: 'Me', id: number, first_name: string, last_name: string, dni: string, username: string, birthday?: Date | null, email: string, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, can_create_company: boolean, is_managed: boolean, pending_email?: string | null, identifier_hash: string, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number } } | null } | null>, invitations: Array<{ __typename: 'Invitation', id: string, label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } | null> };

export type UpdateMyUserMutationVariables = Exact<{
  input: UpdateMeInput;
}>;


export type UpdateMyUserMutation = { __typename: 'Mutation', updateMe?: { __typename: 'DuplicatedEntryError', message: string } | { __typename: 'ServerError', message: string } | { __typename: 'UpdateMe', item: { __typename: 'Me', id: number, first_name: string, last_name: string, dni: string, username: string, birthday?: Date | null, email: string, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, can_create_company: boolean, is_managed: boolean, pending_email?: string | null, identifier_hash: string, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number } } | null } | null>, invitations: Array<{ __typename: 'Invitation', id: string, label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } | null> } } | null };

export type UpdateMyUserFederatedMutationVariables = Exact<{
  input: UpdateFederatedIdentityInformationInput;
}>;


export type UpdateMyUserFederatedMutation = { __typename: 'Mutation', updateFederatedIdentityInformation?: { __typename: 'DuplicatedEntryError', message: string } | { __typename: 'MeItem', item: { __typename: 'Me', id: number, first_name: string, last_name: string, dni: string, username: string, birthday?: Date | null, email: string, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, can_create_company: boolean, is_managed: boolean, pending_email?: string | null, identifier_hash: string, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number } } | null } | null>, invitations: Array<{ __typename: 'Invitation', id: string, label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } | null> } } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename: 'Query', getMe?: { __typename: 'GetMe', item: { __typename: 'Me', id: number, first_name: string, last_name: string, dni: string, username: string, birthday?: Date | null, email: string, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, can_create_company: boolean, is_managed: boolean, pending_email?: string | null, identifier_hash: string, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number } } | null } | null>, invitations: Array<{ __typename: 'Invitation', id: string, label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } | null> } } | { __typename: 'ProfileDataMissingError', message: string, data_missing?: Array<string | null> | null, partial_profile?: { __typename: 'PartialProfile', id?: number | null, first_name?: string | null, last_name?: string | null, dni?: string | null, email?: string | null, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null } | null } | { __typename: 'ServerError', message: string } | { __typename: 'UserNotSignedUpError', message: string } | null };

export type RejectInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectInvitationMutation = { __typename: 'Mutation', rejectInvitation?: { __typename: 'NotFoundInvitationError', message: string } | { __typename: 'RejectInvitation', item: { __typename: 'Me', id: number, first_name: string, last_name: string, dni: string, username: string, birthday?: Date | null, email: string, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, can_create_company: boolean, is_managed: boolean, pending_email?: string | null, identifier_hash: string, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number } } | null } | null>, invitations: Array<{ __typename: 'Invitation', id: string, label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } | null> } } | { __typename: 'ServerError', message: string } | null };

export type AcceptInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcceptInvitationMutation = { __typename: 'Mutation', acceptInvitation?: { __typename: 'AcceptInvitation', item: { __typename: 'Me', id: number, first_name: string, last_name: string, dni: string, username: string, birthday?: Date | null, email: string, phone?: string | null, address?: string | null, cuil?: string | null, gender?: string | null, can_create_company: boolean, is_managed: boolean, pending_email?: string | null, identifier_hash: string, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null, incoming_merge?: { __typename: 'IncomingMerge', company_name: string, managed_username: string } | null, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, label?: string | null, company?: { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string, slug: string } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number } } | null } | null>, invitations: Array<{ __typename: 'Invitation', id: string, label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } | null> } } | { __typename: 'NotFoundInvitationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type BusinessUnitFieldsFragment = { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> };

export type GetBusinessUnitsByCompanyIdQueryVariables = Exact<{
  company_id: Scalars['Int']['input'];
}>;


export type GetBusinessUnitsByCompanyIdQuery = { __typename: 'Query', getCompany?: { __typename: 'AuthCheckGetCompany', item: { __typename: 'Company', id: number, business_units: Array<{ __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }> } } | { __typename: 'AuthorizationError' } | { __typename: 'ServerError' } | null };

export type AddBusinessUnitMutationVariables = Exact<{
  company_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type AddBusinessUnitMutation = { __typename: 'Mutation', addBusinessUnit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> } };

export type UpdateBusinessUnitMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateBusinessUnitMutation = { __typename: 'Mutation', updateBusinessUnit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> } };

export type DeleteBusinessUnitMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBusinessUnitMutation = { __typename: 'Mutation', deleteBusinessUnit: number };

export type ChecklistResultFieldsFragment = { __typename: 'Checklist', id: string, serial_number: number, completed_date: Date, template_id: string, template_title: string, version_number: number, project_id: number, pass_count: number, fail_count: number, na_count: number, closing_note?: string | null, counter?: { __typename: 'Counter', value: number, type: CounterType } | null, location?: { __typename: 'ChecklistLocation', latitude: number, longitude: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null };

export type GetChecklistResultsQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterChecklists>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetChecklistResultsQuery = { __typename: 'Query', getChecklists: { __typename: 'ChecklistsResponse', page_info: { __typename: 'PageInfo', total_pages: number, current_page: number, total_items: number, items_per_page: number }, items: Array<{ __typename: 'Checklist', id: string, serial_number: number, completed_date: Date, template_id: string, template_title: string, version_number: number, project_id: number, pass_count: number, fail_count: number, na_count: number, closing_note?: string | null, counter?: { __typename: 'Counter', value: number, type: CounterType } | null, location?: { __typename: 'ChecklistLocation', latitude: number, longitude: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }>, facets: Array<{ __typename: 'ChecklistFacetGroup', field: ChecklistFacetField, facets: Array<{ __typename: 'Facet', value: string, count: number }> }> } };

export type ChecklistTemplateItemFieldsFragment = { __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null };

export type ChecklistTemplateFieldsFragment = { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> };

export type GetChecklistTemplatesQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterChecklistTemplates>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetChecklistTemplatesQuery = { __typename: 'Query', getChecklistTemplates: { __typename: 'ChecklistTemplatesResponse', page_info: { __typename: 'PageInfo', total_pages: number, current_page: number, total_items: number, items_per_page: number }, items: Array<{ __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> }> } };

export type GetChecklistTemplateByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChecklistTemplateByIdQuery = { __typename: 'Query', getChecklistTemplateById: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type CreateChecklistTemplateMutationVariables = Exact<{
  input: CreateChecklistTemplateInput;
}>;


export type CreateChecklistTemplateMutation = { __typename: 'Mutation', createChecklistTemplate: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type SaveChecklistTemplateDraftMutationVariables = Exact<{
  input: SaveChecklistTemplateDraftInput;
}>;


export type SaveChecklistTemplateDraftMutation = { __typename: 'Mutation', saveChecklistTemplateDraft: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type DiscardChecklistTemplateDraftMutationVariables = Exact<{
  template_id: Scalars['ID']['input'];
}>;


export type DiscardChecklistTemplateDraftMutation = { __typename: 'Mutation', discardChecklistTemplateDraft: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type PublishChecklistTemplateMutationVariables = Exact<{
  template_id: Scalars['ID']['input'];
}>;


export type PublishChecklistTemplateMutation = { __typename: 'Mutation', publishChecklistTemplate: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type ArchiveChecklistTemplateMutationVariables = Exact<{
  template_id: Scalars['ID']['input'];
}>;


export type ArchiveChecklistTemplateMutation = { __typename: 'Mutation', archiveChecklistTemplate: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type UnarchiveChecklistTemplateMutationVariables = Exact<{
  template_id: Scalars['ID']['input'];
}>;


export type UnarchiveChecklistTemplateMutation = { __typename: 'Mutation', unarchiveChecklistTemplate: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type SetChecklistTemplateAssignmentsMutationVariables = Exact<{
  input: SetChecklistTemplateAssignmentsInput;
}>;


export type SetChecklistTemplateAssignmentsMutation = { __typename: 'Mutation', setChecklistTemplateAssignments: { __typename: 'ChecklistTemplate', id: string, company_id: number, title: string, description?: string | null, status: ChecklistTemplateStatus, created_at: any, updated_at?: any | null, archived_at?: any | null, current_version?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, draft?: { __typename: 'ChecklistTemplateVersion', id: string, version_number: number, published_at?: any | null, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'ChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, criteria?: any | null, fail_severity?: MachineNoticeSeverity | null }> } | null, assignment_rules: Array<{ __typename: 'ChecklistAssignmentRule', id: string, scope_type: ChecklistAssignmentScope, target_id?: number | null, machine_group?: MachineGroup | null, target_name?: string | null }> } };

export type PreviewChecklistTemplateAssignmentsQueryVariables = Exact<{
  input: SetChecklistTemplateAssignmentsInput;
}>;


export type PreviewChecklistTemplateAssignmentsQuery = { __typename: 'Query', previewChecklistTemplateAssignments: { __typename: 'ChecklistAssignmentPreview', machine_count: number } };

export type ChecklistListFieldsFragment = { __typename: 'Checklist', id: string, serial_number: number, machine_id?: number | null, template_id: string, template_title: string, version_number: number, completed_at: any, completed_date: Date, pass_count: number, fail_count: number, na_count: number, created_at: any, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, machine?: { __typename: 'Machine', id: number, name: string } | null };

export type GetMyChecklistsQueryVariables = Exact<{
  filter?: InputMaybe<FilterChecklists>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetMyChecklistsQuery = { __typename: 'Query', getChecklists: { __typename: 'ChecklistsResponse', page_info: { __typename: 'PageInfo', total_pages: number, current_page: number, total_items: number, items_per_page: number }, items: Array<{ __typename: 'Checklist', id: string, serial_number: number, machine_id?: number | null, template_id: string, template_title: string, version_number: number, completed_at: any, completed_date: Date, pass_count: number, fail_count: number, na_count: number, created_at: any, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, machine?: { __typename: 'Machine', id: number, name: string } | null }> } };

export type ChecklistFillTemplateItemFieldsFragment = { __typename: 'AvailableChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, choice_options?: Array<{ __typename: 'ChecklistChoiceLabel', key: string, label: string }> | null };

export type ChecklistFillTemplateFieldsFragment = { __typename: 'AvailableChecklistTemplate', id: string, title: string, current_version: { __typename: 'AvailableChecklistTemplateVersion', id: string, version_number: number, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'AvailableChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, choice_options?: Array<{ __typename: 'ChecklistChoiceLabel', key: string, label: string }> | null }> } };

export type GetAvailableChecklistsQueryVariables = Exact<{
  machine_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetAvailableChecklistsQuery = { __typename: 'Query', getAvailableChecklists: { __typename: 'ChecklistAvailabilityResponse', templates: Array<{ __typename: 'AvailableChecklistTemplate', id: string, title: string, current_version: { __typename: 'AvailableChecklistTemplateVersion', id: string, version_number: number, counter_requirement: ChecklistCounterRequirement, items: Array<{ __typename: 'AvailableChecklistTemplateItem', id: string, item_key: string, position: number, section?: string | null, label: string, description?: string | null, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, choice_options?: Array<{ __typename: 'ChecklistChoiceLabel', key: string, label: string }> | null }> } }>, machines: Array<{ __typename: 'MachineChecklistAvailability', machine_id: number, template_ids: Array<string> }> } };

export type AddChecklistMutationVariables = Exact<{
  input: AddChecklistInput;
}>;


export type AddChecklistMutation = { __typename: 'Mutation', addChecklist: { __typename: 'Checklist', id: string, serial_number: number, machine_id?: number | null, template_id: string, template_version_id: string, template_title: string, version_number: number, started_at: any, completed_at: any, completed_date: Date, closing_note?: string | null, pass_count: number, fail_count: number, na_count: number, created_at: any, counter?: { __typename: 'Counter', type: CounterType, value: number } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, machine?: { __typename: 'Machine', id: number, name: string } | null } };

export type ChecklistItemViewFieldsFragment = { __typename: 'ChecklistItem', id: string, position: number, section?: string | null, label: string, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, is_ad_hoc: boolean, value_number?: number | null, value_text?: string | null, value_date?: Date | null, value_choice_key?: string | null, value_choice_label?: string | null, result: ChecklistItemResult, result_severity?: MachineNoticeSeverity | null, na_reason?: string | null, observation?: string | null, fail_streak?: number | null, criteria_snapshot?: any | null, photos: Array<{ __typename: 'File', id: string, url: string }>, notice?: { __typename: 'ChecklistItemNotice', id: number, serial_number: number, status: MachineNoticeStatus, severity: MachineNoticeSeverity, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number } | null } | null };

export type ChecklistDetailFieldsFragment = { __typename: 'Checklist', id: string, serial_number: number, machine_id?: number | null, template_id: string, template_title: string, version_number: number, started_at: any, completed_at: any, completed_date: Date, closing_note?: string | null, pass_count: number, fail_count: number, na_count: number, created_at: any, counter?: { __typename: 'Counter', type: CounterType, value: number } | null, location?: { __typename: 'ChecklistLocation', latitude: number, longitude: number, accuracy_m?: number | null } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, machine?: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null } | null, project?: { __typename: 'Project', id: number, name: string } | null, items: Array<{ __typename: 'ChecklistItem', id: string, position: number, section?: string | null, label: string, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, is_ad_hoc: boolean, value_number?: number | null, value_text?: string | null, value_date?: Date | null, value_choice_key?: string | null, value_choice_label?: string | null, result: ChecklistItemResult, result_severity?: MachineNoticeSeverity | null, na_reason?: string | null, observation?: string | null, fail_streak?: number | null, criteria_snapshot?: any | null, photos: Array<{ __typename: 'File', id: string, url: string }>, notice?: { __typename: 'ChecklistItemNotice', id: number, serial_number: number, status: MachineNoticeStatus, severity: MachineNoticeSeverity, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number } | null } | null }> };

export type GetChecklistByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChecklistByIdQuery = { __typename: 'Query', getChecklistById: { __typename: 'Checklist', id: string, serial_number: number, machine_id?: number | null, template_id: string, template_title: string, version_number: number, started_at: any, completed_at: any, completed_date: Date, closing_note?: string | null, pass_count: number, fail_count: number, na_count: number, created_at: any, counter?: { __typename: 'Counter', type: CounterType, value: number } | null, location?: { __typename: 'ChecklistLocation', latitude: number, longitude: number, accuracy_m?: number | null } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, machine?: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null } | null, project?: { __typename: 'Project', id: number, name: string } | null, items: Array<{ __typename: 'ChecklistItem', id: string, position: number, section?: string | null, label: string, item_type: ChecklistItemType, requirement: ChecklistItemRequirement, unit?: string | null, is_ad_hoc: boolean, value_number?: number | null, value_text?: string | null, value_date?: Date | null, value_choice_key?: string | null, value_choice_label?: string | null, result: ChecklistItemResult, result_severity?: MachineNoticeSeverity | null, na_reason?: string | null, observation?: string | null, fail_streak?: number | null, criteria_snapshot?: any | null, photos: Array<{ __typename: 'File', id: string, url: string }>, notice?: { __typename: 'ChecklistItemNotice', id: number, serial_number: number, status: MachineNoticeStatus, severity: MachineNoticeSeverity, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number } | null } | null }> } };

export type ConsumableFieldsFragment = { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> };

export type AddMachineConsumableMutationVariables = Exact<{
  input: AddMachineConsumableInput;
}>;


export type AddMachineConsumableMutation = { __typename: 'Mutation', addMachineConsumable?: { __typename: 'MachineConsumableItem', item?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null };

export type GetUploadMachineConsumablesPresignatedUrlQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUploadMachineConsumablesPresignatedUrlQuery = { __typename: 'Query', getUploadMachineConsumablesPresignatedUrl: { __typename: 'DataUpload', uploadUrl: string, templateUrl: string, statusId: string } };

export type UpdateMachineConsumableMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateMachineConsumableInput;
}>;


export type UpdateMachineConsumableMutation = { __typename: 'Mutation', updateMachineConsumable?: { __typename: 'MachineConsumableItem', item?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null };

export type DeleteMachineConsumableMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteMachineConsumableMutation = { __typename: 'Mutation', deleteMachineConsumable?: { __typename: 'DeleteIds' } | { __typename: 'ResourceInUseError', message: string } | null };

export type DocumentFieldsFragment = { __typename: 'Document', id: string, name: string, scope: DocumentScope, is_current: boolean, expiration_date?: Date | null, superseded_by?: string | null, files: Array<{ __typename: 'File', id: string, url: string }>, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', brand: string, model: string, domain?: string | null, last_status: MachineReportStatus, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, user?: { __typename: 'User', id: number, first_name: string, last_name: string, dni: string } | null, project?: { __typename: 'Project', id: number, name: string } | null };

export type AddDocumentMutationVariables = Exact<{
  input: AddDocumentInput;
}>;


export type AddDocumentMutation = { __typename: 'Mutation', addDocument: { __typename: 'ItemDocument', item: { __typename: 'Document', id: string, name: string, scope: DocumentScope, is_current: boolean, expiration_date?: Date | null, superseded_by?: string | null, files: Array<{ __typename: 'File', id: string, url: string }>, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', brand: string, model: string, domain?: string | null, last_status: MachineReportStatus, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, user?: { __typename: 'User', id: number, first_name: string, last_name: string, dni: string } | null, project?: { __typename: 'Project', id: number, name: string } | null } } };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename: 'Mutation', updateDocument: { __typename: 'ItemDocument', item: { __typename: 'Document', id: string, name: string, scope: DocumentScope, is_current: boolean, expiration_date?: Date | null, superseded_by?: string | null, files: Array<{ __typename: 'File', id: string, url: string }>, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', brand: string, model: string, domain?: string | null, last_status: MachineReportStatus, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, user?: { __typename: 'User', id: number, first_name: string, last_name: string, dni: string } | null, project?: { __typename: 'Project', id: number, name: string } | null } } };

export type UpdateDocumentTagsMutationVariables = Exact<{
  document_id: Scalars['ID']['input'];
  tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateDocumentTagsMutation = { __typename: 'Mutation', updateDocumentTags: { __typename: 'ItemDocument', item: { __typename: 'Document', id: string, name: string, scope: DocumentScope, is_current: boolean, expiration_date?: Date | null, superseded_by?: string | null, files: Array<{ __typename: 'File', id: string, url: string }>, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', brand: string, model: string, domain?: string | null, last_status: MachineReportStatus, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, user?: { __typename: 'User', id: number, first_name: string, last_name: string, dni: string } | null, project?: { __typename: 'Project', id: number, name: string } | null } } };

export type DeleteDocumentMutationVariables = Exact<{
  document_id: Scalars['ID']['input'];
}>;


export type DeleteDocumentMutation = { __typename: 'Mutation', deleteDocument: string };

export type GetDocumentsQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<GetDocumentsFilter>;
}>;


export type GetDocumentsQuery = { __typename: 'Query', getDocuments: { __typename: 'DocumentConnection', items: Array<{ __typename: 'Document', id: string, name: string, scope: DocumentScope, is_current: boolean, expiration_date?: Date | null, superseded_by?: string | null, files: Array<{ __typename: 'File', id: string, url: string }>, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', brand: string, model: string, domain?: string | null, last_status: MachineReportStatus, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, user?: { __typename: 'User', id: number, first_name: string, last_name: string, dni: string } | null, project?: { __typename: 'Project', id: number, name: string } | null }> } };

export type ConfirmEmailChangeMutationVariables = Exact<{ [key: string]: never; }>;


export type ConfirmEmailChangeMutation = { __typename: 'Mutation', confirmEmailChange: boolean };

export type InvitationFieldsFragment = { __typename: 'Invitation', label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null };

export type EmployeeFieldsFragment = { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> };

export type RemoveRoleMutationVariables = Exact<{
  role_id: Scalars['Int']['input'];
}>;


export type RemoveRoleMutation = { __typename: 'Mutation', deleteRole?: { __typename: 'AuthCheckDeleteRole', item: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'NotFoundRoleError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AddRoleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
  role_type: RoleNamesToInvite;
}>;


export type AddRoleMutation = { __typename: 'Mutation', addRole?: { __typename: 'AuthCheckAddRole', item: { __typename: 'DuplicatedRoleError' } | { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | { __typename: 'Invitation', label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetEmployeeByUserIdQueryVariables = Exact<{
  context: Context;
  user_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEmployeeByUserIdQuery = { __typename: 'Query', getEmployees?: { __typename: 'AuthCheckGetEmployees', items: Array<{ __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetEmployeesQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterEmployee>;
}>;


export type GetEmployeesQuery = { __typename: 'Query', getEmployees?: { __typename: 'AuthCheckGetEmployees', items: Array<{ __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetInvitationsByContextQueryVariables = Exact<{
  context: Context;
}>;


export type GetInvitationsByContextQuery = { __typename: 'Query', getInvitationsByContext: Array<{ __typename: 'Invitation', label?: string | null, email: string, link: string, role: RoleNames, invitationId: string, company: { __typename: 'Company', id: number, name: string }, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null }> };

export type ResendCompanyInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendCompanyInvitationMutation = { __typename: 'Mutation', resendCompanyInvitation: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type DeleteCompanyInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCompanyInvitationMutation = { __typename: 'Mutation', deleteCompanyInvitation: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type AddManagedEmployeeMutationVariables = Exact<{
  input: AddManagedEmployeeInput;
}>;


export type AddManagedEmployeeMutation = { __typename: 'Mutation', addManagedEmployee: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } };

export type SetManagedEmployeePasswordMutationVariables = Exact<{
  input: SetManagedEmployeePasswordInput;
}>;


export type SetManagedEmployeePasswordMutation = { __typename: 'Mutation', setManagedEmployeePassword: { __typename: 'ServerError', message: string, errorCode: ErrorCode } | { __typename: 'SuccessResult', result?: string | null } };

export type GetAllEmployeesQueryVariables = Exact<{
  context: Context;
  query: Scalars['String']['input'];
  roleFilter?: InputMaybe<Array<InputMaybe<RoleNames>> | InputMaybe<RoleNames>>;
}>;


export type GetAllEmployeesQuery = { __typename: 'Query', getEmployees?: { __typename: 'AuthCheckGetEmployees', items: Array<{ __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetAllUsersQueryVariables = Exact<{
  context: Context;
  query: Scalars['String']['input'];
}>;


export type GetAllUsersQuery = { __typename: 'Query', getUsers?: { __typename: 'AuthCheckGetUsers', items: Array<{ __typename: 'User', full_name?: string | null, first_name: string, last_name: string, email: string, id: number, dni: string } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetEmployeeIdentityClaimQueryVariables = Exact<{
  context: Context;
  user_id: Scalars['Int']['input'];
}>;


export type GetEmployeeIdentityClaimQuery = { __typename: 'Query', getEmployees?: { __typename: 'AuthCheckGetEmployees', items: Array<{ __typename: 'Employee', id: number, identity_claim?: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } | null } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type RequestIdentityClaimForUserMutationVariables = Exact<{
  user_id: Scalars['Int']['input'];
  email: Scalars['String']['input'];
}>;


export type RequestIdentityClaimForUserMutation = { __typename: 'Mutation', requestIdentityClaimForUser: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } };

export type CancelIdentityClaimForUserMutationVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;


export type CancelIdentityClaimForUserMutation = { __typename: 'Mutation', cancelIdentityClaimForUser: boolean };

export type AddFixedAssetMutationVariables = Exact<{
  input: AddFixedAssetInput;
}>;


export type AddFixedAssetMutation = { __typename: 'Mutation', addFixedAsset?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null };

export type UpdateFixedAssetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateFixedAssetInput;
}>;


export type UpdateFixedAssetMutation = { __typename: 'Mutation', updateFixedAsset?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }>, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null } | null };

export type GetFixedAssetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFixedAssetByIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetFixedAssetsQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetFixedAssetsQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type TanksDashboardFieldsFragment = { __typename: 'TanksDashboardTankItem', initial_stock: number, final_stock: number, avg_stock?: number | null, liters_in: number, liters_in_from_providers: number, liters_in_from_tanks: number, liters_out: number, liters_out_to_consumers: number, liters_out_to_tanks: number, measured_error?: number | null, project_ids_in_period: Array<number>, tank: { __typename: 'Machine', fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, id: number, is_archived: boolean, name: string, display_name?: string | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, kpis?: { __typename: 'TanksDashboardKpis', stock_deviation: { __typename: 'StockDeviationKpi', deviation_percentage: number, dispatched_liters: number, deviation_liters: number, control_frequency: number }, verified_dispatches: { __typename: 'VerifiedDispatchesKpi', verified_dispatches: number, total_dispatches: number, verified_percentage: number }, average_rotation: { __typename: 'AverageRotationKpi', rotation_days?: number | null, average_stock?: number | null, max_stock?: number | null, min_stock?: number | null, average_consumption: number }, traceability: { __typename: 'TraceabilityKpi', consistency_score?: number | null, flowmeter_advance: number, report_liters: number, traced_liters: number, untraced_liters: number, surplus_liters: number, non_traceable_liters: number, non_totalizing_tank_count: number, totalizing_tank_count: number } } | null };

export type MachinesFuelDashboardFieldsFragment = { __typename: 'MachinesFuelDashboardItem', total_fuel_in: number, total_counter: number, telemetry_fuel_consumed: number, machine: { __typename: 'Machine', id: number, name: string, brand: string, model: string, display_name?: string | null, display_type?: string | null, preferred_counter_type: CounterType, power: number, is_archived: boolean, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null } };

export type ProjectsFuelDashboardFieldsFragment = { __typename: 'ProjectsFuelDashboardItem', initial_stock: number, final_stock: number, measured_error?: number | null, outflow_dispatch_count: number, outflow_internal_consumption: number, outflow_to_other_projects: number, outflow_to_other_business_units: number, inflow_from_providers: number, inflow_from_other_projects: number, inflow_from_other_business_units: number, internal_transfers: number, direct_consumption_from_providers: number, direct_consumption_from_other_projects: number, direct_consumption_from_other_business_units: number, relocation_stock_in: number, relocation_stock_out: number, effective_fuel_cost?: number | null, effective_fuel_cost_source: string, consumption_liters_for_cost: number, consumption_cost?: number | null, project: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } };

export type FuelProviderFieldsFragment = { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } };

export type FuelDispatchReportFieldsFragment = { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, fuel_type: FuelType, observations?: string | null, source?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, provider?: { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } | null, source_stock?: { __typename: 'FuelStock', start: number, end: number } | null, destination: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, prev_destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, destination_stock?: { __typename: 'FuelStock', start: number, end: number } | null, source_project?: { __typename: 'Project', id: number, name: string } | null, destination_project: { __typename: 'Project', id: number, name: string }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string }, verified_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null };

export type FuelDispatchReportForTableFieldsFragment = { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, fuel_type: FuelType, observations?: string | null, provider?: { __typename: 'FuelProvider', id: string, name: string } | null, source?: { __typename: 'Machine', fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, destination: { __typename: 'Machine', fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, fuel_type?: FuelType | null, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, source_stock?: { __typename: 'FuelStock', start: number, end: number } | null, destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, prev_destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, destination_stock?: { __typename: 'FuelStock', start: number, end: number } | null, source_project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, destination_project: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string }, verified_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null };

export type StockControlReportFieldsFragment = { __typename: 'StockControlReport', id: string, datetime: any, stock_measured: number, stock_computed?: number | null, observations?: string | null, tank: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string } };

export type AddFuelProviderMutationVariables = Exact<{
  input: AddFuelProviderInput;
}>;


export type AddFuelProviderMutation = { __typename: 'Mutation', addFuelProvider: { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } };

export type UpdateFuelProviderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateFuelProviderInput;
}>;


export type UpdateFuelProviderMutation = { __typename: 'Mutation', updateFuelProvider: { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } };

export type DeleteFuelProviderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFuelProviderMutation = { __typename: 'Mutation', deleteFuelProvider: string };

export type SetMachinesFuelParticipationMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  fuel_participation: FuelParticipation;
}>;


export type SetMachinesFuelParticipationMutation = { __typename: 'Mutation', setMachinesFuelParticipation: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }> };

export type AddFuelDispatchReportMutationVariables = Exact<{
  input: AddFuelDispatchedReportInput;
}>;


export type AddFuelDispatchReportMutation = { __typename: 'Mutation', addFuelDispatchedReport: { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, fuel_type: FuelType, observations?: string | null, source?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, provider?: { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } | null, source_stock?: { __typename: 'FuelStock', start: number, end: number } | null, destination: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, prev_destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, destination_stock?: { __typename: 'FuelStock', start: number, end: number } | null, source_project?: { __typename: 'Project', id: number, name: string } | null, destination_project: { __typename: 'Project', id: number, name: string }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string }, verified_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } };

export type AddStockControlReportMutationVariables = Exact<{
  input: AddStockControlReportInput;
}>;


export type AddStockControlReportMutation = { __typename: 'Mutation', addStockControlReport: { __typename: 'DuplicatedReportDateError', message: string } | { __typename: 'StockControlReport', id: string, datetime: any, stock_measured: number, stock_computed?: number | null, observations?: string | null, tank: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string } } };

export type UpdateStockControlReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateStockControlReportInput;
}>;


export type UpdateStockControlReportMutation = { __typename: 'Mutation', updateStockControlReport: { __typename: 'StockControlReport', id: string, datetime: any, stock_measured: number, stock_computed?: number | null, observations?: string | null, tank: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string } } };

export type UpdateFuelDispatchReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateFuelDispatchedReportInput;
}>;


export type UpdateFuelDispatchReportMutation = { __typename: 'Mutation', updateFuelDispatchedReport: { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, fuel_type: FuelType, observations?: string | null, source?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, provider?: { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } | null, source_stock?: { __typename: 'FuelStock', start: number, end: number } | null, destination: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, prev_destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, destination_stock?: { __typename: 'FuelStock', start: number, end: number } | null, source_project?: { __typename: 'Project', id: number, name: string } | null, destination_project: { __typename: 'Project', id: number, name: string }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string }, verified_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } };

export type DeleteStockControlReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStockControlReportMutation = { __typename: 'Mutation', deleteStockControlReport: string };

export type DeleteFuelDispatchReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFuelDispatchReportMutation = { __typename: 'Mutation', deleteFuelDispatchedReport: string };

export type GetMachinesFuelDashboardQueryVariables = Exact<{
  context: Context;
  filter: GetMachinesFuelDashboardFilter;
}>;


export type GetMachinesFuelDashboardQuery = { __typename: 'Query', getMachinesFuelDashboard: { __typename: 'MachinesFuelDashboard', items?: Array<{ __typename: 'MachinesFuelDashboardItem', total_fuel_in: number, total_counter: number, telemetry_fuel_consumed: number, machine: { __typename: 'Machine', id: number, name: string, brand: string, model: string, display_name?: string | null, display_type?: string | null, preferred_counter_type: CounterType, power: number, is_archived: boolean, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null } } | null> | null } };

export type GetTanksDashboardQueryVariables = Exact<{
  context: Context;
  filter: GetTanksDashboardFilter;
}>;


export type GetTanksDashboardQuery = { __typename: 'Query', getTanksDashboard: { __typename: 'TanksDashboard', tanks: Array<{ __typename: 'TanksDashboardTankItem', initial_stock: number, final_stock: number, avg_stock?: number | null, liters_in: number, liters_in_from_providers: number, liters_in_from_tanks: number, liters_out: number, liters_out_to_consumers: number, liters_out_to_tanks: number, measured_error?: number | null, project_ids_in_period: Array<number>, tank: { __typename: 'Machine', fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, id: number, is_archived: boolean, name: string, display_name?: string | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, kpis?: { __typename: 'TanksDashboardKpis', stock_deviation: { __typename: 'StockDeviationKpi', deviation_percentage: number, dispatched_liters: number, deviation_liters: number, control_frequency: number }, verified_dispatches: { __typename: 'VerifiedDispatchesKpi', verified_dispatches: number, total_dispatches: number, verified_percentage: number }, average_rotation: { __typename: 'AverageRotationKpi', rotation_days?: number | null, average_stock?: number | null, max_stock?: number | null, min_stock?: number | null, average_consumption: number }, traceability: { __typename: 'TraceabilityKpi', consistency_score?: number | null, flowmeter_advance: number, report_liters: number, traced_liters: number, untraced_liters: number, surplus_liters: number, non_traceable_liters: number, non_totalizing_tank_count: number, totalizing_tank_count: number } } | null }>, providers?: Array<{ __typename: 'TanksDashboardProviderItem', liters_out: number, liters_to_storage: number, liters_to_consumers: number, dispatch_count: number, provider: { __typename: 'FuelProvider', id: string, name: string } } | null> | null } };

export type GetProjectsFuelDashboardQueryVariables = Exact<{
  context: Context;
  filter: GetTanksDashboardFilter;
}>;


export type GetProjectsFuelDashboardQuery = { __typename: 'Query', getProjectsFuelDashboard: { __typename: 'ProjectsFuelDashboard', items?: Array<{ __typename: 'ProjectsFuelDashboardItem', initial_stock: number, final_stock: number, measured_error?: number | null, outflow_dispatch_count: number, outflow_internal_consumption: number, outflow_to_other_projects: number, outflow_to_other_business_units: number, inflow_from_providers: number, inflow_from_other_projects: number, inflow_from_other_business_units: number, internal_transfers: number, direct_consumption_from_providers: number, direct_consumption_from_other_projects: number, direct_consumption_from_other_business_units: number, relocation_stock_in: number, relocation_stock_out: number, effective_fuel_cost?: number | null, effective_fuel_cost_source: string, consumption_liters_for_cost: number, consumption_cost?: number | null, project: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } } | null> | null } };

export type GetFuelSourcesQueryVariables = Exact<{
  context?: InputMaybe<Context>;
  query?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetFuelSourcesQuery = { __typename: 'Query', getFuelSources: { __typename: 'FuelSourcesResponse', tanks: Array<{ __typename: 'Machine', id: number, name: string, domain?: string | null, serial_number?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, accepts_usage: boolean }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number } | null, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null }>, providers: Array<{ __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } }> } };

export type GetFuelDestinationsQueryVariables = Exact<{
  context: Context;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFuelDestinationsQuery = { __typename: 'Query', getFuelDestinations: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } };

export type GetFuelTanksQueryVariables = Exact<{
  context: Context;
}>;


export type GetFuelTanksQuery = { __typename: 'Query', getFuelTanks: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } };

export type GetFuelConsumersQueryVariables = Exact<{
  context: Context;
}>;


export type GetFuelConsumersQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetFuelProvidersQueryVariables = Exact<{
  context: Context;
}>;


export type GetFuelProvidersQuery = { __typename: 'Query', getFuelProviders: { __typename: 'FuelProvidersResponse', items: Array<{ __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } | null> } };

export type GetFuelDispatchReportByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFuelDispatchReportByIdQuery = { __typename: 'Query', getFuelDispatchedReportById?: { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, fuel_type: FuelType, observations?: string | null, source?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, provider?: { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } | null, source_stock?: { __typename: 'FuelStock', start: number, end: number } | null, destination: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, prev_destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, destination_stock?: { __typename: 'FuelStock', start: number, end: number } | null, source_project?: { __typename: 'Project', id: number, name: string } | null, destination_project: { __typename: 'Project', id: number, name: string }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string }, verified_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null };

export type GetFuelDispatchReportPhotosByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFuelDispatchReportPhotosByIdQuery = { __typename: 'Query', getFuelDispatchedReportById?: { __typename: 'FuelDispatchedReport', id: string, photos: Array<{ __typename: 'File', id: string, url: string }> } | null };

export type GetStockControlReportPhotosByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStockControlReportPhotosByIdQuery = { __typename: 'Query', getStockControlReportById?: { __typename: 'StockControlReport', id: string, photos: Array<{ __typename: 'File', id: string, url: string }> } | null };

export type GetFuelDispatchReportsQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<GetFuelDispatchedReportsFilter>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetFuelDispatchReportsQuery = { __typename: 'Query', getFuelDispatchedReports?: { __typename: 'GetFuelDispatchedReports', items: Array<{ __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, fuel_type: FuelType, observations?: string | null, provider?: { __typename: 'FuelProvider', id: string, name: string } | null, source?: { __typename: 'Machine', fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, destination: { __typename: 'Machine', fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, fuel_type?: FuelType | null, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, source_stock?: { __typename: 'FuelStock', start: number, end: number } | null, destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, prev_destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, destination_stock?: { __typename: 'FuelStock', start: number, end: number } | null, source_project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, destination_project: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string }, verified_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null> } | null };

export type GetStockControlReportsQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<GetStockControlReportsFilter>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetStockControlReportsQuery = { __typename: 'Query', getStockControlReports?: { __typename: 'GetStockControlReports', items: Array<{ __typename: 'StockControlReport', id: string, datetime: any, stock_measured: number, stock_computed?: number | null, observations?: string | null, tank: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string } } | null> } | null };

export type GetMyFuelDispatchReportsQueryVariables = Exact<{
  filter?: InputMaybe<GetFuelDispatchedReportsFilter>;
}>;


export type GetMyFuelDispatchReportsQuery = { __typename: 'Query', getMyFuelDispatchedReports?: { __typename: 'GetFuelDispatchedReports', items: Array<{ __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, fuel_type: FuelType, observations?: string | null, source?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, provider?: { __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } | null, source_stock?: { __typename: 'FuelStock', start: number, end: number } | null, destination: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, project?: { __typename: 'Project', id: number, name: string, code: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, prev_destination_counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, destination_stock?: { __typename: 'FuelStock', start: number, end: number } | null, source_project?: { __typename: 'Project', id: number, name: string } | null, destination_project: { __typename: 'Project', id: number, name: string }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string }, verified_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null> } | null };

export type GetMyStockControlReportsQueryVariables = Exact<{
  filter?: InputMaybe<GetStockControlReportsFilter>;
}>;


export type GetMyStockControlReportsQuery = { __typename: 'Query', getMyStockControlReports?: { __typename: 'GetStockControlReports', items: Array<{ __typename: 'StockControlReport', id: string, datetime: any, stock_measured: number, stock_computed?: number | null, observations?: string | null, tank: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string } } | null> } | null };

export type GetComputedStockQueryVariables = Exact<{
  tank_id: Scalars['Int']['input'];
  datetime: Scalars['DateTime']['input'];
}>;


export type GetComputedStockQuery = { __typename: 'Query', getComputedStock: number };

export type GetFuelDispatchedFromDailyReportsQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterDailyReports>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetFuelDispatchedFromDailyReportsQuery = { __typename: 'Query', getDailyReports?: { __typename: 'AuthCheckGetDailyReports', items: Array<{ __typename: 'DailyReport', id: number, date: Date, total_fuel?: number | null, usage_reports: Array<{ __typename: 'UsageReport', fuel: number } | null> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetFuelConsumedFromTelemetryTimeseriesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from_utc: Scalars['DateTime']['input'];
  to_utc: Scalars['DateTime']['input'];
}>;


export type GetFuelConsumedFromTelemetryTimeseriesQuery = { __typename: 'Query', getTimeSeriesByBilderitConnectDeviceId: Array<{ __typename: 'DailyTelemetry', end_of_day: any, daily_fuel_consumed_lts?: number | null, fuel_remaining_percentage?: number | null, cumulative_fuel_consumed_lts?: number | null }> };

export type GetFuelDashboardDataQueryVariables = Exact<{
  context: Context;
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type GetFuelDashboardDataQuery = { __typename: 'Query', tanksDashboard: { __typename: 'TanksDashboard', tanks: Array<{ __typename: 'TanksDashboardTankItem', initial_stock: number, final_stock: number, avg_stock?: number | null, liters_in: number, liters_in_from_providers: number, liters_in_from_tanks: number, liters_out: number, liters_out_to_consumers: number, liters_out_to_tanks: number, measured_error?: number | null, project_ids_in_period: Array<number>, tank: { __typename: 'Machine', fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, id: number, is_archived: boolean, name: string, display_name?: string | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, kpis?: { __typename: 'TanksDashboardKpis', stock_deviation: { __typename: 'StockDeviationKpi', deviation_percentage: number, dispatched_liters: number, deviation_liters: number, control_frequency: number }, verified_dispatches: { __typename: 'VerifiedDispatchesKpi', verified_dispatches: number, total_dispatches: number, verified_percentage: number }, average_rotation: { __typename: 'AverageRotationKpi', rotation_days?: number | null, average_stock?: number | null, max_stock?: number | null, min_stock?: number | null, average_consumption: number }, traceability: { __typename: 'TraceabilityKpi', consistency_score?: number | null, flowmeter_advance: number, report_liters: number, traced_liters: number, untraced_liters: number, surplus_liters: number, non_traceable_liters: number, non_totalizing_tank_count: number, totalizing_tank_count: number } } | null }>, providers?: Array<{ __typename: 'TanksDashboardProviderItem', liters_out: number, liters_to_storage: number, liters_to_consumers: number, dispatch_count: number, provider: { __typename: 'FuelProvider', id: string, name: string } } | null> | null, consumption_stats?: { __typename: 'ConsumptionStats', total_consumption_liters: number, total_consumption_dispatches: number } | null, trend_stats?: { __typename: 'TrendStats', provider_input_change?: number | null, consumption_change?: number | null } | null }, projectsDashboard: { __typename: 'ProjectsFuelDashboard', items?: Array<{ __typename: 'ProjectsFuelDashboardItem', initial_stock: number, final_stock: number, measured_error?: number | null, outflow_dispatch_count: number, outflow_internal_consumption: number, outflow_to_other_projects: number, outflow_to_other_business_units: number, inflow_from_providers: number, inflow_from_other_projects: number, inflow_from_other_business_units: number, internal_transfers: number, direct_consumption_from_providers: number, direct_consumption_from_other_projects: number, direct_consumption_from_other_business_units: number, relocation_stock_in: number, relocation_stock_out: number, effective_fuel_cost?: number | null, effective_fuel_cost_source: string, consumption_liters_for_cost: number, consumption_cost?: number | null, project: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } } | null> | null, pricing_coverage: { __typename: 'ProjectsFuelDashboardPricingCoverage', total_projects: number, relevant_projects: number, covered_projects: number, uncovered_projects: number, uncovered_project_ids: Array<number>, consumption_liters_uncovered: number } }, machinesDashboard: { __typename: 'MachinesFuelDashboard', items?: Array<{ __typename: 'MachinesFuelDashboardItem', total_fuel_in: number, total_counter: number, telemetry_fuel_consumed: number, machine: { __typename: 'Machine', id: number, name: string, brand: string, model: string, display_name?: string | null, display_type?: string | null, preferred_counter_type: CounterType, power: number, is_archived: boolean, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null } } | null> | null, trend_stats?: { __typename: 'MachinesFuelDashboardTrendStats', telemetry_fuel_change?: number | null } | null }, providers: { __typename: 'FuelProvidersResponse', items: Array<{ __typename: 'FuelProvider', id: string, name: string, comments?: string | null, created_at: any, updated_at?: any | null, last_known_flowmeter: number, company: { __typename: 'Company', id: number, name: string } } | null> } };

export type RequestIdentityClaimMutationVariables = Exact<{
  input: RequestIdentityClaimInput;
}>;


export type RequestIdentityClaimMutation = { __typename: 'Mutation', requestIdentityClaim: { __typename: 'IdentityClaim', requested_email: string, kind: IdentityClaimKind } };

export type CancelIdentityClaimMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelIdentityClaimMutation = { __typename: 'Mutation', cancelIdentityClaim: boolean };

export type ConfirmIdentityClaimMutationVariables = Exact<{
  input: ConfirmIdentityClaimInput;
}>;


export type ConfirmIdentityClaimMutation = { __typename: 'Mutation', confirmIdentityClaim: boolean };

export type MergeIdentityClaimMutationVariables = Exact<{
  input: MergeIdentityClaimInput;
}>;


export type MergeIdentityClaimMutation = { __typename: 'Mutation', mergeIdentityClaim: boolean };

export type MachineNoticeFieldsFragment = { __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null };

export type GetMachineNoticesQueryVariables = Exact<{
  filter?: InputMaybe<FilterMachineNotices>;
  context: Context;
}>;


export type GetMachineNoticesQuery = { __typename: 'Query', getMachineNotices: Array<{ __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null }> };

export type GetMachineNoticeByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMachineNoticeByIdQuery = { __typename: 'Query', getMachineNoticeById?: { __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null } | null };

export type GetMachineNoticesDashboardQueryVariables = Exact<{
  filter?: InputMaybe<FilterMachineNoticeDashboard>;
  pagination?: InputMaybe<FilterPagination>;
  context: Context;
}>;


export type GetMachineNoticesDashboardQuery = { __typename: 'Query', getMachineNoticesDashboard: { __typename: 'MachineNoticeDashboardConnection', items: Array<{ __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null }>, page_info: { __typename: 'PageInfo', total_pages: number, total_items: number, current_page: number, items_per_page: number }, facets: Array<{ __typename: 'MachineNoticeFacetGroup', field: MachineNoticeFacetField, facets: Array<{ __typename: 'Facet', value: string, count: number }> }>, tag_facets: Array<{ __typename: 'MachineNoticeTagFacet', count: number, tag: { __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } }>, backlog_summary: { __typename: 'MachineNoticeDashboardSummary', total: number, open: number, critical_open: number, open_gt_7d: number, open_gt_30d: number, open_without_ot: number, linked_ot: number, closed_today: number }, warnings: { __typename: 'MachineNoticeDashboardWarnings', open_outside_date_range: number } } };

export type DownloadMachineNoticesDashboardWorkbookQueryVariables = Exact<{
  filter?: InputMaybe<FilterMachineNoticeDashboard>;
  context: Context;
}>;


export type DownloadMachineNoticesDashboardWorkbookQuery = { __typename: 'Query', downloadMachineNoticesDashboardWorkbook: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type GetMyMachineNoticesQueryVariables = Exact<{
  filter?: InputMaybe<FilterMyMachineNotices>;
}>;


export type GetMyMachineNoticesQuery = { __typename: 'Query', getMyMachineNotices: Array<{ __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null }> };

export type MachineNoticeChangedSubscriptionVariables = Exact<{
  context: Context;
}>;


export type MachineNoticeChangedSubscription = { __typename: 'Subscription', machineNoticeChanged?: { __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null } | null };

export type AddMachineNoticeMutationVariables = Exact<{
  input: AddMachineNoticeInput;
}>;


export type AddMachineNoticeMutation = { __typename: 'Mutation', addMachineNotice: { __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null } };

export type UpdateMachineNoticeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateMachineNoticeInput;
}>;


export type UpdateMachineNoticeMutation = { __typename: 'Mutation', updateMachineNotice: { __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null } };

export type UpdateMachineNoticeStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateMachineNoticeStatusInput;
}>;


export type UpdateMachineNoticeStatusMutation = { __typename: 'Mutation', updateMachineNoticeStatus: { __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null } };

export type CreateWorkOrderFromMachineNoticeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CreateWorkOrderFromMachineNoticeMutation = { __typename: 'Mutation', createWorkOrderFromMachineNotice: { __typename: 'MachineNoticeWorkOrderResult', notice: { __typename: 'MachineNotice', id: number, serial_number: number, created_at: any, status: MachineNoticeStatus, severity: MachineNoticeSeverity, message: string, resolution_note?: string | null, resolved_on?: any | null, cancelled_on?: any | null, source_type: MachineNoticeSourceType, source_usage_report_id?: number | null, source_checklist_id?: string | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine: { __typename: 'Machine', id: number, name: string, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null }, business_unit: { __typename: 'BusinessUnit', id: number, name: string }, project: { __typename: 'Project', id: number, name: string }, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, resolved_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, cancelled_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, evidence_files: Array<{ __typename: 'File', id: string, url: string }>, linked_work_order?: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string, type: { __typename: 'WorkOrderType', id: string, name: string } } | null }, work_order: { __typename: 'WorkOrder', id: string, serial_number: number, status: WorkOrderStatus, title: string } } };

export type BilderitConnectDeviceFieldsFragment = { __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null };

export type MachineCounterFieldsFragment = { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType };

export type MachineFieldsFragment = { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> };

export type MachinePickerFieldsFragment = { __typename: 'Machine', id: number, name: string, domain?: string | null, serial_number?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, accepts_usage: boolean }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number } | null, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null };

export type MachineLinkFieldsFragment = { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> };

export type MachineExtraDataFieldsFragment = { __typename: 'CompanyMachineExtraData', id: string, created_at: any, updated_at?: any | null, machine_group?: MachineGroup | null, field_name: string, field_type: MachineExtraDataFieldType, unit?: string | null, is_required: boolean };

export type DeleteMachineMutationVariables = Exact<{
  machineId: Scalars['Int']['input'];
}>;


export type DeleteMachineMutation = { __typename: 'Mutation', deleteMachine: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type ArchiveMachineMutationVariables = Exact<{
  machineId: Scalars['Int']['input'];
}>;


export type ArchiveMachineMutation = { __typename: 'Mutation', archiveMachine: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } };

export type UnarchiveMachineMutationVariables = Exact<{
  input: UnarchiveMachineInput;
}>;


export type UnarchiveMachineMutation = { __typename: 'Mutation', unarchiveMachine: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } };

export type AddHeavyEquipmentMutationVariables = Exact<{
  input: AddHeavyEquipmentInput;
}>;


export type AddHeavyEquipmentMutation = { __typename: 'Mutation', addHeavyEquipment?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null };

export type UpdateHeavyEquipmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateHeavyEquipmentInput;
}>;


export type UpdateHeavyEquipmentMutation = { __typename: 'Mutation', updateHeavyEquipment?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }>, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null } | null };

export type MoveMachineMutationVariables = Exact<{
  input: MoveMachineInput;
}>;


export type MoveMachineMutation = { __typename: 'Mutation', moveMachine: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } };

export type GetMachinesByNameQueryVariables = Exact<{
  context?: InputMaybe<Context>;
  filter?: InputMaybe<FilterMachine>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetMachinesByNameQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', page_info?: { __typename: 'PageInfo', total_items: number } | null, items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMachinesForPickerQueryVariables = Exact<{
  context?: InputMaybe<Context>;
  filter?: InputMaybe<FilterMachine>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetMachinesForPickerQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', page_info?: { __typename: 'PageInfo', total_items: number } | null, items: Array<{ __typename: 'Machine', id: number, name: string, domain?: string | null, serial_number?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, accepts_usage: boolean }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number } | null, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMachineLinkByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMachineLinkByIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMachineByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMachineByIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetNextServiceByMachineIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetNextServiceByMachineIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, next_services: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMachinePhotosByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMachinePhotosByIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, photos: Array<{ __typename: 'File', id: string, url: string }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMachinesQueryVariables = Exact<{
  context?: InputMaybe<Context>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetMachinesQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetAllArchivedMachinesQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetAllArchivedMachinesQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMachineGroupCountsQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetMachineGroupCountsQuery = { __typename: 'Query', getMachineGroupCounts?: { __typename: 'AuthCheckGetMachineGroupCounts', items: Array<{ __typename: 'MachineGroupCount', group: MachineGroup, count: number }> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetHeavyEquipmentQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetHeavyEquipmentQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetUploadMachinesPresignatedUrlQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetUploadMachinesPresignatedUrlQuery = { __typename: 'Query', getUploadMachinesPresignatedUrl?: { __typename: 'AuthCheckGetUploadMachinesPresignatedUrl', item: { __typename: 'DataUpload', uploadUrl: string, templateUrl: string, statusId: string } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetUploadStatusQueryVariables = Exact<{
  statusId: Scalars['ID']['input'];
}>;


export type GetUploadStatusQuery = { __typename: 'Query', getUploadStatus?: { __typename: 'UploadStatus', type?: UploadStatusType | null, info?: string | null } | null };

export type UploadStatusChangedSubscriptionVariables = Exact<{
  statusId: Scalars['ID']['input'];
}>;


export type UploadStatusChangedSubscription = { __typename: 'Subscription', uploadStatusChanged?: { __typename: 'UploadStatus', type?: UploadStatusType | null, info?: string | null } | null };

export type GetMachineTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMachineTypesQuery = { __typename: 'Query', getMachineTypes?: { __typename: 'AuthCheckGetMachineTypes', items: Array<{ __typename: 'MachineType', id: number, type: string, group: MachineGroup } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type MachineTypeFieldsFragment = { __typename: 'MachineType', id: number, type: string, group: MachineGroup };

export type GetMachinesListCsvQueryVariables = Exact<{
  company_id: Scalars['Int']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<MachineGroup>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  machine_ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetMachinesListCsvQuery = { __typename: 'Query', downloadMachinesWorkbook: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type SetMachineFuelCapacityMutationVariables = Exact<{
  input: SetMachineFuelCapacityInput;
}>;


export type SetMachineFuelCapacityMutation = { __typename: 'Mutation', setMachineFuelCapacity: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } };

export type GetMachineExtraDataByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetMachineExtraDataByCompanyIdQuery = { __typename: 'Query', getCompanyMachineExtraData: Array<{ __typename: 'CompanyMachineExtraData', id: string, created_at: any, updated_at?: any | null, machine_group?: MachineGroup | null, field_name: string, field_type: MachineExtraDataFieldType, unit?: string | null, is_required: boolean }> };

export type BatchUpsertMachineExtraDataMutationVariables = Exact<{
  input: Array<AddCompanyMachineExtraDataInput> | AddCompanyMachineExtraDataInput;
}>;


export type BatchUpsertMachineExtraDataMutation = { __typename: 'Mutation', batchUpsertCompanyMachineExtraData: Array<{ __typename: 'CompanyMachineExtraData', id: string, created_at: any, updated_at?: any | null, machine_group?: MachineGroup | null, field_name: string, field_type: MachineExtraDataFieldType, unit?: string | null, is_required: boolean }> };

export type BatchDeleteMachineExtraDataMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BatchDeleteMachineExtraDataMutation = { __typename: 'Mutation', batchDeleteCompanyMachineExtraData: Array<string> };

export type GetMachineProjectAtDateQueryVariables = Exact<{
  machineId: Scalars['Int']['input'];
  date: Scalars['LocalDate']['input'];
}>;


export type GetMachineProjectAtDateQuery = { __typename: 'Query', getMachineProjectsAtDate: Array<{ __typename: 'Project', id: number, name: string }> };

export type MachineHistoryServiceReportFieldsFragment = { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, date: Date, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string } | null };

export type GetMachineHistoryQueryVariables = Exact<{
  context: Context;
  filter: FilterMachineHistory;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetMachineHistoryQuery = { __typename: 'Query', getMachineHistory: { __typename: 'MachineHistoryConnection', truncated: boolean, page_info: { __typename: 'PageInfo', current_page: number, items_per_page: number, total_items: number, total_pages: number }, facets: Array<{ __typename: 'MachineHistoryFacetGroup', field: string, facets: Array<{ __typename: 'Facet', value: string, count: number }> }>, items: Array<{ __typename: 'MachineAssignmentHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, report: { __typename: 'MachineAssignmentReport', id: number, start_date: Date, end_date?: Date | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null }, project: { __typename: 'Project', id: number, name: string, slug: string }, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string } }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineCheckInHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, report: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineCheckOutHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, report: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineChecklistHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, checklist: { __typename: 'Checklist', id: string, serial_number: number, template_title: string, version_number: number, pass_count: number, fail_count: number, na_count: number }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineMoveHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, checkin: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null }, checkout: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineNoticeHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, notice: { __typename: 'MachineNotice', id: number, serial_number: number, severity: MachineNoticeSeverity, status: MachineNoticeStatus, message: string, created_at: any, source_type: MachineNoticeSourceType, source_checklist_id?: string | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, linked_work_order?: { __typename: 'WorkOrder', id: string, title: string, serial_number: number, type: { __typename: 'WorkOrderType', id: string, name: string } } | null }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineOutOfServiceHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, oos_report: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineServiceHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, report: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, date: Date, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string } | null }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | { __typename: 'MachineWorkOrderHistoryEvent', id: string, kind: MachineHistoryEventKind, occurred_at: any, work_order: { __typename: 'WorkOrder', id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null, created_by?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null }> } };

export type MachinePartFieldsFragment = { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null };

export type MaintenanceProgramFieldsFragment = { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null };

export type MaintenancePlanFieldsFragment = { __typename: 'MaintenancePlan', id: number, title: string, description?: string | null, type: MaintenancePlanType, base_period: number, period_type: PeriodType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, machine_parts?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, modified?: { __typename: 'Modified', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, owner?: { __typename: 'Company', id: number, name: string } | null };

export type MaintenancePlanTableFieldsFragment = { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, programs?: Array<{ __typename: 'MPProgram', id: string } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null };

export type MaintenancePlanTypeaheadFieldsFragment = { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, period_type: PeriodType, base_period: number, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null, owner?: { __typename: 'Company', name: string } | null };

export type GetMachineConsumablesByCompanyIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter: FilterMachineConsumables;
}>;


export type GetMachineConsumablesByCompanyIdQuery = { __typename: 'Query', getMachineConsumablesByCompanyId: { __typename: 'MachineConsumableConnection', items?: Array<{ __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null> | null } };

export type GetBilderitMachineConsumablesQueryVariables = Exact<{
  filter: FilterMachineConsumables;
}>;


export type GetBilderitMachineConsumablesQuery = { __typename: 'Query', getBilderitMachineConsumables: { __typename: 'MachineConsumableConnection', items?: Array<{ __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null> | null } };

export type GetMachinePartsByCompanyIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter: FilterMachineParts;
}>;


export type GetMachinePartsByCompanyIdQuery = { __typename: 'Query', getMachinePartsByCompanyId: { __typename: 'MachinePartConnection', items?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } };

export type GetAllMaintenancePlansQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterMaintenancePlans>;
}>;


export type GetAllMaintenancePlansQuery = { __typename: 'Query', getAllMaintenancePlans: { __typename: 'MaintenancePlanConnection', items?: Array<{ __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, programs?: Array<{ __typename: 'MPProgram', id: string } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null } | null> | null } };

export type GetAllBilderitMaintenancePlansQueryVariables = Exact<{
  filter?: InputMaybe<FilterMaintenancePlans>;
}>;


export type GetAllBilderitMaintenancePlansQuery = { __typename: 'Query', getBilderitMaintenancePlans: { __typename: 'MaintenancePlanConnection', items?: Array<{ __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, programs?: Array<{ __typename: 'MPProgram', id: string } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null } | null> | null } };

export type GetMaintenancePlansForTypeaheadQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterMaintenancePlans>;
}>;


export type GetMaintenancePlansForTypeaheadQuery = { __typename: 'Query', getAllMaintenancePlans: { __typename: 'MaintenancePlanConnection', items?: Array<{ __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, period_type: PeriodType, base_period: number, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null, owner?: { __typename: 'Company', name: string } | null } | null> | null } };

export type GetMaintenancePlanByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMaintenancePlanByIdQuery = { __typename: 'Query', getMaintenancePlanById?: { __typename: 'MaintenancePlanItem', item?: { __typename: 'MaintenancePlan', id: number, title: string, description?: string | null, type: MaintenancePlanType, base_period: number, period_type: PeriodType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, machine_parts?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, modified?: { __typename: 'Modified', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, owner?: { __typename: 'Company', id: number, name: string } | null } | null } | null };

export type AddMaintenancePlanMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  base_period: Scalars['Float']['input'];
  period_type: PeriodType;
  programs: Array<MpProgramInput> | MpProgramInput;
  machine_parts: Array<MachinePartInput> | MachinePartInput;
  tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type_tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  brand_tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddMaintenancePlanMutation = { __typename: 'Mutation', addMaintenancePlan?: { __typename: 'MaintenancePlanItem', item?: { __typename: 'MaintenancePlan', id: number, title: string, description?: string | null, type: MaintenancePlanType, base_period: number, period_type: PeriodType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, machine_parts?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, modified?: { __typename: 'Modified', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, owner?: { __typename: 'Company', id: number, name: string } | null } | null } | null };

export type AddBilderitMaintenancePlanMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  base_period: Scalars['Float']['input'];
  period_type: PeriodType;
  programs: Array<MpProgramInput> | MpProgramInput;
  machine_parts: Array<MachinePartInput> | MachinePartInput;
  tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type_tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  brand_tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddBilderitMaintenancePlanMutation = { __typename: 'Mutation', addBilderitMaintenancePlan: { __typename: 'MaintenancePlan', id: number, title: string, description?: string | null, type: MaintenancePlanType, base_period: number, period_type: PeriodType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, machine_parts?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, modified?: { __typename: 'Modified', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, owner?: { __typename: 'Company', id: number, name: string } | null } };

export type DeleteMaintenancePlanMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteMaintenancePlanMutation = { __typename: 'Mutation', deleteMaintenancePlan: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type UpdateMaintenancePlanMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  base_period?: InputMaybe<Scalars['Float']['input']>;
  period_type?: InputMaybe<PeriodType>;
  programs: Array<MpProgramInput> | MpProgramInput;
  machine_parts: Array<MachinePartInput> | MachinePartInput;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  type_tag_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  brand_tag_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type UpdateMaintenancePlanMutation = { __typename: 'Mutation', updateMaintenancePlan?: { __typename: 'MaintenancePlanItem', item?: { __typename: 'MaintenancePlan', id: number, title: string, description?: string | null, type: MaintenancePlanType, base_period: number, period_type: PeriodType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, machine_parts?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, modified?: { __typename: 'Modified', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, owner?: { __typename: 'Company', id: number, name: string } | null } | null } | null };

export type UpdateMaintenancePlanTagsMutationVariables = Exact<{
  plan_id: Scalars['Int']['input'];
  tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  brand_tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type_tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateMaintenancePlanTagsMutation = { __typename: 'Mutation', updateMaintenancePlanTags?: { __typename: 'MaintenancePlanItem', item?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, programs?: Array<{ __typename: 'MPProgram', id: string } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null } | null } | null };

export type AssignMaintenancePlanBatchMutationVariables = Exact<{
  mp_id: Scalars['Int']['input'];
  machine_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AssignMaintenancePlanBatchMutation = { __typename: 'Mutation', assignMaintenancePlanBatch?: { __typename: 'AssignMaintenancePlanBatchSuccess', items?: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }>, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null } | null> | null } | null };

export type SetMaintenancePlanStatusMutationVariables = Exact<{
  plan_id: Scalars['Int']['input'];
  status: MaintenancePlanStatus;
}>;


export type SetMaintenancePlanStatusMutation = { __typename: 'Mutation', setMaintenancePlanStatus: { __typename: 'MaintenancePlan', id: number, title: string, description?: string | null, type: MaintenancePlanType, base_period: number, period_type: PeriodType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, machine_parts?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, modified?: { __typename: 'Modified', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, owner?: { __typename: 'Company', id: number, name: string } | null } };

export type ImportMaintenancePlanFromLibraryMutationVariables = Exact<{
  input: ImportBilderitMaintenancePlanInput;
}>;


export type ImportMaintenancePlanFromLibraryMutation = { __typename: 'Mutation', importBilderitMaintenancePlan: { __typename: 'BilderitPlanAlreadyCopiedError', message: string, errorCode: ErrorCode } | { __typename: 'ConsumablesConflictError', message: string, errorCode: ErrorCode } | { __typename: 'DuplicatedEntryError', message: string, errorCode: ErrorCode } | { __typename: 'MaintenancePlan', id: number, title: string, description?: string | null, type: MaintenancePlanType, base_period: number, period_type: PeriodType, status: MaintenancePlanStatus, imported_from_id?: number | null, num_machines?: number | null, imported_by: Array<{ __typename: 'Company', id: number, name: string }>, assigned_to: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, machine_parts?: Array<{ __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number, actions?: Array<{ __typename: 'ProgramAction', id: string, action: string, description?: string | null, consumable_quantity?: number | null, machine_part?: { __typename: 'MachinePart', id: string, name: string, compartment?: string | null, default_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null, consumable_override?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | null } | null> | null } | null> | null, type_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, brand_tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, tags?: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean } | null> | null, created?: { __typename: 'Created', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, modified?: { __typename: 'Modified', at?: any | null, by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null } | null, owner?: { __typename: 'Company', id: number, name: string } | null } };

export type RecentActivityFieldsFragment = { __typename: 'RecentActivity', today: { __typename: 'ActivitySummary', usage_hours_reported: number, fuel_dispatched: number, wos_completed: number, wos_in_progress: number }, last_week: { __typename: 'ActivitySummary', usage_hours_reported: number, fuel_dispatched: number, wos_completed: number, wos_in_progress: number }, last_month: { __typename: 'ActivitySummary', usage_hours_reported: number, fuel_dispatched: number, wos_completed: number, wos_in_progress: number }, latest_reports: Array<{ __typename: 'DailyUsageActivity', datetime: any, report: { __typename: 'MyDailyReportSummary', date: Date, machine_report_id: number, usage_report_id: number, counter_start: number, counter_end: number, counter_type: CounterType, daily_machine: { __typename: 'Machine', id: number, name: string, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } }, project: { __typename: 'Project', id: number, name: string } } } | { __typename: 'FuelDispatchActivity', datetime: any, report: { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, provider?: { __typename: 'FuelProvider', id: string, name: string } | null, source?: { __typename: 'Machine', id: number, name: string } | null, destination: { __typename: 'Machine', id: number, name: string, fuel_type?: FuelType | null } } } | { __typename: 'StockControlActivity', datetime: any, report: { __typename: 'StockControlReport', id: string, datetime: any, stock_computed?: number | null, stock_measured: number, tank: { __typename: 'Machine', id: number, name: string } } } | { __typename: 'WorkOrderActivity', datetime: any, report: { __typename: 'WorkOrder', id: string, title: string, description: string, in_progress_end_date?: any | null, serial_number: number, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string }, machine?: { __typename: 'Machine', id: number, name: string, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } } | null } }> };

export type ActivitySummaryFieldsFragment = { __typename: 'ActivitySummary', usage_hours_reported: number, fuel_dispatched: number, wos_completed: number, wos_in_progress: number };

type ActivityFields_DailyUsageActivity_Fragment = { __typename: 'DailyUsageActivity', datetime: any, report: { __typename: 'MyDailyReportSummary', date: Date, machine_report_id: number, usage_report_id: number, counter_start: number, counter_end: number, counter_type: CounterType, daily_machine: { __typename: 'Machine', id: number, name: string, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } }, project: { __typename: 'Project', id: number, name: string } } };

type ActivityFields_FuelDispatchActivity_Fragment = { __typename: 'FuelDispatchActivity', datetime: any, report: { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, provider?: { __typename: 'FuelProvider', id: string, name: string } | null, source?: { __typename: 'Machine', id: number, name: string } | null, destination: { __typename: 'Machine', id: number, name: string, fuel_type?: FuelType | null } } };

type ActivityFields_StockControlActivity_Fragment = { __typename: 'StockControlActivity', datetime: any, report: { __typename: 'StockControlReport', id: string, datetime: any, stock_computed?: number | null, stock_measured: number, tank: { __typename: 'Machine', id: number, name: string } } };

type ActivityFields_WorkOrderActivity_Fragment = { __typename: 'WorkOrderActivity', datetime: any, report: { __typename: 'WorkOrder', id: string, title: string, description: string, in_progress_end_date?: any | null, serial_number: number, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string }, machine?: { __typename: 'Machine', id: number, name: string, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } } | null } };

export type ActivityFieldsFragment = ActivityFields_DailyUsageActivity_Fragment | ActivityFields_FuelDispatchActivity_Fragment | ActivityFields_StockControlActivity_Fragment | ActivityFields_WorkOrderActivity_Fragment;

export type GetMyDailyReportsQueryVariables = Exact<{
  filter?: InputMaybe<FilterMyDailyReports>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetMyDailyReportsQuery = { __typename: 'Query', getMyDailyReports?: { __typename: 'AuthCheckGetMyDailyReports', items: Array<{ __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMyWorkOrdersQueryVariables = Exact<{
  filter?: InputMaybe<FilterWorkOrders>;
}>;


export type GetMyWorkOrdersQuery = { __typename: 'Query', getMyAssignedWorkOrders: { __typename: 'WorkOrdersConnection', items: Array<{ __typename: 'WorkOrder', id: string, serial_number: number, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, canceled_at?: any | null, title: string, description: string, status: WorkOrderStatus, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, type: { __typename: 'WorkOrderType', id: string, name: string }, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', id: number, name: string, display_name?: string | null, display_type?: string | null, brand: string, model: string, is_archived: boolean, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, project?: { __typename: 'Project', id: number, name: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null }> } };

export type GetMyRecentActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyRecentActivityQuery = { __typename: 'Query', getMyRecentActivity: { __typename: 'RecentActivity', today: { __typename: 'ActivitySummary', usage_hours_reported: number, fuel_dispatched: number, wos_completed: number, wos_in_progress: number }, last_week: { __typename: 'ActivitySummary', usage_hours_reported: number, fuel_dispatched: number, wos_completed: number, wos_in_progress: number }, last_month: { __typename: 'ActivitySummary', usage_hours_reported: number, fuel_dispatched: number, wos_completed: number, wos_in_progress: number }, latest_reports: Array<{ __typename: 'DailyUsageActivity', datetime: any, report: { __typename: 'MyDailyReportSummary', date: Date, machine_report_id: number, usage_report_id: number, counter_start: number, counter_end: number, counter_type: CounterType, daily_machine: { __typename: 'Machine', id: number, name: string, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } }, project: { __typename: 'Project', id: number, name: string } } } | { __typename: 'FuelDispatchActivity', datetime: any, report: { __typename: 'FuelDispatchedReport', id: string, datetime: any, flowmeter_start: number, flowmeter_end: number, provider?: { __typename: 'FuelProvider', id: string, name: string } | null, source?: { __typename: 'Machine', id: number, name: string } | null, destination: { __typename: 'Machine', id: number, name: string, fuel_type?: FuelType | null } } } | { __typename: 'StockControlActivity', datetime: any, report: { __typename: 'StockControlReport', id: string, datetime: any, stock_computed?: number | null, stock_measured: number, tank: { __typename: 'Machine', id: number, name: string } } } | { __typename: 'WorkOrderActivity', datetime: any, report: { __typename: 'WorkOrder', id: string, title: string, description: string, in_progress_end_date?: any | null, serial_number: number, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string }, machine?: { __typename: 'Machine', id: number, name: string, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } } | null } }> } };

export type MyDocumentFieldsFragment = { __typename: 'Document', id: string, name: string, scope: DocumentScope, expiration_date?: Date | null, is_current: boolean, files: Array<{ __typename: 'File', id: string, url: string }> };

export type GetMyDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyDocumentsQuery = { __typename: 'Query', getMyDocuments: { __typename: 'DocumentConnection', items: Array<{ __typename: 'Document', id: string, name: string, scope: DocumentScope, expiration_date?: Date | null, is_current: boolean, files: Array<{ __typename: 'File', id: string, url: string }> }> } };

export type GetMcpClientQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
}>;


export type GetMcpClientQuery = { __typename: 'Query', mcpClient?: { __typename: 'McpClient', clientId: string, name: string, redirectHost: string, isLocal: boolean } | null };

export type RespondToMcpAuthorizationMutationVariables = Exact<{
  input: RespondToMcpAuthorizationInput;
}>;


export type RespondToMcpAuthorizationMutation = { __typename: 'Mutation', respondToMcpAuthorization: { __typename: 'RespondToMcpAuthorizationPayload', redirectUrl: string } };

export type GetProjectCostCentersQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectCostCentersQuery = { __typename: 'Query', getProjectCostCenters: Array<{ __typename: 'ProjectCostCenter', id: number, project_id: number, name: string, created_at: any, updated_at?: any | null }> };

export type GetProjectCostCenterModeQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type GetProjectCostCenterModeQuery = { __typename: 'Query', getProjectCostCenterMode: CostCenterMode };

export type AddProjectCostCenterMutationVariables = Exact<{
  input: AddProjectCostCenterInput;
}>;


export type AddProjectCostCenterMutation = { __typename: 'Mutation', addProjectCostCenter: { __typename: 'ProjectCostCenter', id: number, project_id: number, name: string, created_at: any, updated_at?: any | null } };

export type UpdateProjectCostCenterMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateProjectCostCenterInput;
}>;


export type UpdateProjectCostCenterMutation = { __typename: 'Mutation', updateProjectCostCenter: { __typename: 'ProjectCostCenter', id: number, project_id: number, name: string, created_at: any, updated_at?: any | null } };

export type DeleteProjectCostCenterMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteProjectCostCenterMutation = { __typename: 'Mutation', deleteProjectCostCenter: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type SetProjectCostCenterModeMutationVariables = Exact<{
  projectId: Scalars['Int']['input'];
  mode: CostCenterMode;
}>;


export type SetProjectCostCenterModeMutation = { __typename: 'Mutation', setProjectCostCenterMode: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type ProjectFieldsFragment = { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } };

export type UteFieldsFragment = { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null };

export type ArchiveProjectMutationVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type ArchiveProjectMutation = { __typename: 'Mutation', archiveProject: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } };

export type UnarchiveProjectMutationVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type UnarchiveProjectMutation = { __typename: 'Mutation', unarchiveProject: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } };

export type AddProjectMutationVariables = Exact<{
  input: AddProjectInput;
}>;


export type AddProjectMutation = { __typename: 'Mutation', addProject?: { __typename: 'AuthCheckAddProject', item: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'DuplicatedProjectError', message: string } | { __typename: 'ServerError', message: string } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename: 'Mutation', updateProject?: { __typename: 'AuthCheckUpdateProject', item: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'DuplicatedProjectError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetActiveProjectsByCompanyIdQueryVariables = Exact<{
  company_id: Scalars['Int']['input'];
}>;


export type GetActiveProjectsByCompanyIdQuery = { __typename: 'Query', getCompany?: { __typename: 'AuthCheckGetCompany', item: { __typename: 'Company', id: number, projects: Array<{ __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetArchivedProjectsByCompanyIdQueryVariables = Exact<{
  company_id: Scalars['Int']['input'];
}>;


export type GetArchivedProjectsByCompanyIdQuery = { __typename: 'Query', getCompany?: { __typename: 'AuthCheckGetCompany', item: { __typename: 'Company', id: number, archived_projects: Array<{ __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type RentalCertificationFieldsFragment = { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> };

export type MachineRentalRowFieldsFragment = { __typename: 'MachineRental', rental_parameters: any, min_hours_to_bill?: number | null, hours_worked?: number | null, regular_hours_to_bill?: number | null, extra_hours_to_bill?: number | null, billing_type: string, km_traveled?: number | null, days_in_project: number, days_to_charge: number, availability_coefficient?: number | null, oos_days_due_to_equipment: number, oos_days_due_to_project: number, monthly_reference_amount: number, variable_amount: number, fixed_amount: number, total_amount: number, currency: string, certification_item_ref?: number | null, machine: { __typename: 'Machine', owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, replacement_value: number, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string, subtype?: string | null }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, resolved_counters?: { __typename: 'MachineResolvedRentalCounters', initial?: { __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null } | null, initial_candidates?: Array<{ __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null }> | null, final?: { __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null } | null, final_candidates?: Array<{ __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null }> | null } | null };

export type CounterValueFieldsFragment = { __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null };

export type GetRentalByProjectQueryVariables = Exact<{
  project_id: Scalars['Int']['input'];
  period: FilterDateRange;
  filter: RentalFilters;
}>;


export type GetRentalByProjectQuery = { __typename: 'Query', getRentalByProject: { __typename: 'GetRentalByProjectResponse', project: { __typename: 'Project', id: number, name: string }, machines_rental: Array<{ __typename: 'MachineRental', rental_parameters: any, min_hours_to_bill?: number | null, hours_worked?: number | null, regular_hours_to_bill?: number | null, extra_hours_to_bill?: number | null, billing_type: string, km_traveled?: number | null, days_in_project: number, days_to_charge: number, availability_coefficient?: number | null, oos_days_due_to_equipment: number, oos_days_due_to_project: number, monthly_reference_amount: number, variable_amount: number, fixed_amount: number, total_amount: number, currency: string, certification_item_ref?: number | null, machine: { __typename: 'Machine', owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, replacement_value: number, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string, subtype?: string | null }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, resolved_counters?: { __typename: 'MachineResolvedRentalCounters', initial?: { __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null } | null, initial_candidates?: Array<{ __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null }> | null, final?: { __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null } | null, final_candidates?: Array<{ __typename: 'CounterValue', value?: number | null, datetime?: any | null, source?: string | null, type?: CounterType | null }> | null } | null }> } };

export type GetOrCreateDraftCertificationMutationVariables = Exact<{
  project_id: Scalars['Int']['input'];
  month: Scalars['Date']['input'];
  ownership_group: RentalOwnershipGroup;
  vendor_filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrCreateDraftCertificationMutation = { __typename: 'Mutation', getOrCreateDraftCertification: { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> } };

export type GetRentalCertificationProviderOptionsQueryVariables = Exact<{
  project_id: Scalars['Int']['input'];
  month: Scalars['Date']['input'];
}>;


export type GetRentalCertificationProviderOptionsQuery = { __typename: 'Query', getRentalCertificationProviderOptions: { __typename: 'RentalCertificationProviderOptionsResponse', all_option: { __typename: 'RentalCertificationProviderScopeOption', vendor_filter?: string | null, label: string, machine_count: number, is_disabled: boolean, existing_status?: RentalCertificationStatus | null }, providers: Array<{ __typename: 'RentalCertificationProviderScopeOption', vendor_filter?: string | null, label: string, machine_count: number, is_disabled: boolean, existing_status?: RentalCertificationStatus | null }> } };

export type MarkMachinesForCertificationMutationVariables = Exact<{
  certification_id: Scalars['Int']['input'];
  machine_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type MarkMachinesForCertificationMutation = { __typename: 'Mutation', markMachinesForCertification: { __typename: 'MarkMachinesForCertificationResponse', marked_count: number, results: Array<{ __typename: 'MachineMarkResult', machine_id: number, success: boolean, error?: { __typename: 'MachineMarkError', code: string, message: string, metadata?: any | null } | null }> } };

export type UnmarkMachinesForCertificationMutationVariables = Exact<{
  certification_id: Scalars['Int']['input'];
  machine_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UnmarkMachinesForCertificationMutation = { __typename: 'Mutation', unmarkMachinesForCertification: { __typename: 'UnmarkMachinesForCertificationResponse', success: boolean, unmarked_count: number } };

export type DeleteDraftCertificationMutationVariables = Exact<{
  certification_id: Scalars['Int']['input'];
}>;


export type DeleteDraftCertificationMutation = { __typename: 'Mutation', deleteDraftCertification: { __typename: 'SuccessResult', result?: string | null } };

export type SubmitCertificationForReviewMutationVariables = Exact<{
  input: SubmitCertificationForReviewInput;
}>;


export type SubmitCertificationForReviewMutation = { __typename: 'Mutation', submitCertificationForReview: { __typename: 'SubmitCertificationForReviewResponse', certification: { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> }, reviewers: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string }>, warnings?: { __typename: 'SubmitCertificationWarnings', uncertified_machine_ids: Array<number>, uncertified_machines: Array<{ __typename: 'UncertifiedMachineSummary', id: number, name: string }> } | null } };

export type ReviewCertificationMutationVariables = Exact<{
  input: ReviewCertificationInput;
}>;


export type ReviewCertificationMutation = { __typename: 'Mutation', reviewCertification: { __typename: 'ReviewCertificationResponse', all_approved: boolean, certification: { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> } } };

export type RentalCertificationHistoryFieldsFragment = { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> };

export type CertificationCopyRecipientFieldsFragment = { __typename: 'CertificationCopyRecipient', id: number, email: string, company_id: number, project_id?: number | null, created_at: any };

export type GetCertificationCopyRecipientsQueryVariables = Exact<{
  context: Context;
}>;


export type GetCertificationCopyRecipientsQuery = { __typename: 'Query', getCertificationCopyRecipients: Array<{ __typename: 'CertificationCopyRecipient', id: number, email: string, company_id: number, project_id?: number | null, created_at: any }> };

export type GetCertificationNotificationRecipientsQueryVariables = Exact<{
  certification_id: Scalars['Int']['input'];
}>;


export type GetCertificationNotificationRecipientsQuery = { __typename: 'Query', getCertificationNotificationRecipients: { __typename: 'GetCertificationNotificationRecipientsResponse', audiences: Array<{ __typename: 'CertificationNotificationAudience', event: CertificationNotificationEvent, recipients: Array<{ __typename: 'CertificationNotificationRecipient', email: string, display_name?: string | null, sources: Array<CertificationNotificationRecipientSource> }> }> } };

export type AddCertificationCopyRecipientMutationVariables = Exact<{
  input: AddCertificationCopyRecipientInput;
}>;


export type AddCertificationCopyRecipientMutation = { __typename: 'Mutation', addCertificationCopyRecipient: { __typename: 'CertificationCopyRecipient', id: number, email: string, company_id: number, project_id?: number | null, created_at: any } };

export type RemoveCertificationCopyRecipientMutationVariables = Exact<{
  certification_copy_id: Scalars['Int']['input'];
}>;


export type RemoveCertificationCopyRecipientMutation = { __typename: 'Mutation', removeCertificationCopyRecipient: { __typename: 'SuccessResult', result?: string | null } };

export type GetCertificationHistoryQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<CertificationHistoryFilter>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetCertificationHistoryQuery = { __typename: 'Query', getCertificationHistory: { __typename: 'CertificationHistoryConnection', items: Array<{ __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> }>, page_info: { __typename: 'PageInfo', current_page: number, items_per_page: number, total_pages: number, total_items: number } } };

export type ExportCertificationHistoryWorkbookQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<CertificationHistoryFilter>;
}>;


export type ExportCertificationHistoryWorkbookQuery = { __typename: 'Query', exportCertificationHistoryWorkbook: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type RentalCertificationItemSnapshotFieldsFragment = { __typename: 'RentalCertificationItemSnapshot', id: number, certification_id: number, project_id: number, month: any, machine_name_snapshot: string, machine_owner_snapshot: string, machine_group_snapshot: string, machine_type_snapshot: string, machine_subtype_snapshot?: string | null, machine_year_snapshot: number, machine_replacement_value_snapshot: number, machine_preferred_counter_type_snapshot: CounterType, company_id: number, company_name_snapshot: string, project_name_snapshot: string, machine_ownership_type_snapshot: OwnershipType, hours_worked?: number | null, km_traveled?: number | null, min_hours_to_bill?: number | null, counter_start?: number | null, counter_end?: number | null, days_in_project: number, days_to_charge: number, days_oos_due_to_equipment: number, days_oos_due_to_project: number, fixed_amount: number, variable_amount: number, total_amount: number, monthly_reference_amount: number, billing_type: string, currency: string, is_underutilized: boolean, underutilized_amount: number, created_at: any, machine: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, rental_params: { __typename: 'RentalParamsSnapshot', DEMERIT_COEF_00_04: number, DEMERIT_COEF_05_09: number, DEMERIT_COEF_10_14: number, DEMERIT_COEF_15_19: number, DEMERIT_COEF_20_PLUS: number, RENTAL_COEF_FIXED_PCT: number, RENTAL_COEF_VARIABLE_PCT: number, MIN_HOURS: number, TARIFF_HOURS_BASE: number, EXTRA_HOURS_THRESHOLD: number, EXTRA_HOURS_MULTIPLIER: number, BILLING_TYPE?: RentalBillingType | null, REPLACEMENT_VALUE_USD?: number | null, ADDITIONAL_FIXED_AMOUNT_USD: number, ADJUSTMENT_PRICE_MULTIPLIER: number, INITIAL_HOURS_SOURCE: RentalCounterSource, LAST_HOURS_SOURCE: RentalCounterSource, INITIAL_HOURS_OVERRIDE?: number | null, LAST_HOURS_OVERRIDE?: number | null, TOTAL_DAYS_OVERRIDE?: number | null, RENTAL_VALUE_OVERRIDE_USD?: number | null } };

export type ForceRejectCertificationMutationVariables = Exact<{
  input: ForceRejectCertificationInput;
}>;


export type ForceRejectCertificationMutation = { __typename: 'Mutation', forceRejectCertification: { __typename: 'ForceRejectCertificationResponse', certification: { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> } } };

export type ForceApproveCertificationMutationVariables = Exact<{
  input: ForceApproveCertificationInput;
}>;


export type ForceApproveCertificationMutation = { __typename: 'Mutation', forceApproveCertification: { __typename: 'ForceApproveCertificationResponse', skipped_reviewer_count: number, certification: { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> } } };

export type RemoveCertificationReviewerMutationVariables = Exact<{
  input: RemoveCertificationReviewerInput;
}>;


export type RemoveCertificationReviewerMutation = { __typename: 'Mutation', removeCertificationReviewer: { __typename: 'RemoveCertificationReviewerResponse', removed_reviewer_user_id: number, auto_approved: boolean, certification: { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> } } };

export type GetRentalCertificationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetRentalCertificationQuery = { __typename: 'Query', getRentalCertification: { __typename: 'GetRentalCertificationResponse', certification: { __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> }, items: Array<{ __typename: 'RentalCertificationItemSnapshot', id: number, certification_id: number, project_id: number, month: any, machine_name_snapshot: string, machine_owner_snapshot: string, machine_group_snapshot: string, machine_type_snapshot: string, machine_subtype_snapshot?: string | null, machine_year_snapshot: number, machine_replacement_value_snapshot: number, machine_preferred_counter_type_snapshot: CounterType, company_id: number, company_name_snapshot: string, project_name_snapshot: string, machine_ownership_type_snapshot: OwnershipType, hours_worked?: number | null, km_traveled?: number | null, min_hours_to_bill?: number | null, counter_start?: number | null, counter_end?: number | null, days_in_project: number, days_to_charge: number, days_oos_due_to_equipment: number, days_oos_due_to_project: number, fixed_amount: number, variable_amount: number, total_amount: number, monthly_reference_amount: number, billing_type: string, currency: string, is_underutilized: boolean, underutilized_amount: number, created_at: any, machine: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, rental_params: { __typename: 'RentalParamsSnapshot', DEMERIT_COEF_00_04: number, DEMERIT_COEF_05_09: number, DEMERIT_COEF_10_14: number, DEMERIT_COEF_15_19: number, DEMERIT_COEF_20_PLUS: number, RENTAL_COEF_FIXED_PCT: number, RENTAL_COEF_VARIABLE_PCT: number, MIN_HOURS: number, TARIFF_HOURS_BASE: number, EXTRA_HOURS_THRESHOLD: number, EXTRA_HOURS_MULTIPLIER: number, BILLING_TYPE?: RentalBillingType | null, REPLACEMENT_VALUE_USD?: number | null, ADDITIONAL_FIXED_AMOUNT_USD: number, ADJUSTMENT_PRICE_MULTIPLIER: number, INITIAL_HOURS_SOURCE: RentalCounterSource, LAST_HOURS_SOURCE: RentalCounterSource, INITIAL_HOURS_OVERRIDE?: number | null, LAST_HOURS_OVERRIDE?: number | null, TOTAL_DAYS_OVERRIDE?: number | null, RENTAL_VALUE_OVERRIDE_USD?: number | null } }>, relocations: Array<{ __typename: 'RentalCertificationRelocationSnapshot', id: number, certification_id: number, movement_type: string, movement_date: Date, counter_value?: number | null, counter_type?: string | null, comments?: string | null, machine: { __typename: 'Machine', id: number, name: string }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project: { __typename: 'Project', id: number, name: string } }> } };

export type SearchRentalCertificationApproversQueryVariables = Exact<{
  project_id: Scalars['Int']['input'];
  query: Scalars['String']['input'];
}>;


export type SearchRentalCertificationApproversQuery = { __typename: 'Query', searchRentalCertificationApprovers: Array<{ __typename: 'RentalCertificationApprover', type: ApproverType, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string, dni: string } }> };

export type DownloadRentalCertificationPdfQueryVariables = Exact<{
  certification_id: Scalars['Int']['input'];
}>;


export type DownloadRentalCertificationPdfQuery = { __typename: 'Query', downloadRentalCertificationPdf: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type DownloadRentalCertificationXlsxQueryVariables = Exact<{
  certification_id: Scalars['Int']['input'];
}>;


export type DownloadRentalCertificationXlsxQuery = { __typename: 'Query', downloadRentalCertificationXlsx: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type GetMyCertificatesToReviewQueryVariables = Exact<{
  filter?: InputMaybe<MyCertificatesToReviewFilter>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetMyCertificatesToReviewQuery = { __typename: 'Query', getMyCertificatesToReview: { __typename: 'CertificationHistoryConnection', items: Array<{ __typename: 'RentalCertification', id: number, serial_number: number, project_id: number, company_id: number, month: any, ownership_group: RentalOwnershipGroup, vendor_filter?: string | null, status: RentalCertificationStatus, total_amount: number, currency: string, created_at: any, updated_at?: any | null, project_name: string, company_name: string, item_count: number, eligible_machine_count: number, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string }, comments: Array<{ __typename: 'RentalCertificationComment', id: number, certification_id: number, action: string, comment: string, created_at: any, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }>, approval_records: Array<{ __typename: 'RentalCertificationApprovalRecord', status: string, comment?: string | null, responded_at?: any | null, reviewer: { __typename: 'Employee', id: number, first_name: string, last_name: string, email: string } }> }>, page_info: { __typename: 'PageInfo', current_page: number, items_per_page: number, total_pages: number, total_items: number } } };

export type CounterFieldsFragment = { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType };

type ErrorFields_AuthorizationError_Fragment = { __typename: 'AuthorizationError', message: string };

type ErrorFields_BilderitPlanAlreadyCopiedError_Fragment = { __typename: 'BilderitPlanAlreadyCopiedError', message: string };

type ErrorFields_ConsumablesConflictError_Fragment = { __typename: 'ConsumablesConflictError', message: string };

type ErrorFields_DuplicatedEntryError_Fragment = { __typename: 'DuplicatedEntryError', message: string };

type ErrorFields_DuplicatedMachineError_Fragment = { __typename: 'DuplicatedMachineError', message: string };

type ErrorFields_DuplicatedProjectError_Fragment = { __typename: 'DuplicatedProjectError', message: string };

type ErrorFields_DuplicatedRoleError_Fragment = { __typename: 'DuplicatedRoleError', message: string };

type ErrorFields_NotAllowedError_Fragment = { __typename: 'NotAllowedError', message: string };

type ErrorFields_NotFoundDailyReportError_Fragment = { __typename: 'NotFoundDailyReportError', message: string };

type ErrorFields_NotFoundInvitationError_Fragment = { __typename: 'NotFoundInvitationError', message: string };

type ErrorFields_NotFoundRoleError_Fragment = { __typename: 'NotFoundRoleError', message: string };

type ErrorFields_ProfileDataMissingError_Fragment = { __typename: 'ProfileDataMissingError', message: string };

type ErrorFields_ResourceInUseError_Fragment = { __typename: 'ResourceInUseError', message: string };

type ErrorFields_ServerError_Fragment = { __typename: 'ServerError', message: string };

type ErrorFields_UserNotSignedUpError_Fragment = { __typename: 'UserNotSignedUpError', message: string };

type ErrorFields_WorkOrderStatusChangeError_Fragment = { __typename: 'WorkOrderStatusChangeError', message: string };

export type ErrorFieldsFragment = ErrorFields_AuthorizationError_Fragment | ErrorFields_BilderitPlanAlreadyCopiedError_Fragment | ErrorFields_ConsumablesConflictError_Fragment | ErrorFields_DuplicatedEntryError_Fragment | ErrorFields_DuplicatedMachineError_Fragment | ErrorFields_DuplicatedProjectError_Fragment | ErrorFields_DuplicatedRoleError_Fragment | ErrorFields_NotAllowedError_Fragment | ErrorFields_NotFoundDailyReportError_Fragment | ErrorFields_NotFoundInvitationError_Fragment | ErrorFields_NotFoundRoleError_Fragment | ErrorFields_ProfileDataMissingError_Fragment | ErrorFields_ResourceInUseError_Fragment | ErrorFields_ServerError_Fragment | ErrorFields_UserNotSignedUpError_Fragment | ErrorFields_WorkOrderStatusChangeError_Fragment;

export type OutOfServiceReportFieldsFragment = { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null };

export type DailyReportFieldsFragment = { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null };

export type GetDailyReportPhotosByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDailyReportPhotosByIdQuery = { __typename: 'Query', getDailyReportByUsageId?: { __typename: 'DailyReportItem', item?: { __typename: 'DailyReport', usage_reports: Array<{ __typename: 'UsageReport', id: number, photos: Array<{ __typename: 'File', id: string, url: string }> } | null> } | null } | null };

export type GetDailyReportByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDailyReportByIdQuery = { __typename: 'Query', getDailyReportById?: { __typename: 'AuthCheckGetDailyReportById', item: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type DailyReportByDayStatsFieldsFragment = { __typename: 'DailyReportByDayStats', num_machines: number, num_worked_machines: number, num_out_of_service_machines: number, num_pending_machines: number, num_available_machines: number, num_greases: number, total_fuel: number, stats_by_counter_type: Array<{ __typename: 'StatsByCounterType', type: CounterType, total_counter: number, total_fuel: number }> };

export type GetDailyReportsByDayStatsQueryVariables = Exact<{
  context: Context;
  date: Scalars['LocalDate']['input'];
  group?: InputMaybe<MachineGroup>;
}>;


export type GetDailyReportsByDayStatsQuery = { __typename: 'Query', getDailyReportsByDayStats?: { __typename: 'AuthCheckGetDailyReportsByDayStats', stats: { __typename: 'DailyReportByDayStats', num_machines: number, num_worked_machines: number, num_out_of_service_machines: number, num_pending_machines: number, num_available_machines: number, num_greases: number, total_fuel: number, stats_by_counter_type: Array<{ __typename: 'StatsByCounterType', type: CounterType, total_counter: number, total_fuel: number }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type DailyReportByMachineIdStatsFieldsFragment = { __typename: 'DailyReportByMachineIdStats', num_greases: number, total_fuel: number, num_worked_days: number, num_oos_days: number, num_pending_days: number, num_available_days: number, total_days: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> };

export type GetDailyReportsByMachineIdStatsQueryVariables = Exact<{
  context: Context;
  id: Scalars['Int']['input'];
  filter: FilterDateRange;
}>;


export type GetDailyReportsByMachineIdStatsQuery = { __typename: 'Query', getDailyReportsByMachineIdStats?: { __typename: 'AuthCheckGetDailyReportsByMachineIdStats', stats: { __typename: 'DailyReportByMachineIdStats', num_greases: number, total_fuel: number, num_worked_days: number, num_oos_days: number, num_pending_days: number, num_available_days: number, total_days: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetDailyReportsByMachineIdQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterDailyReports>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetDailyReportsByMachineIdQuery = { __typename: 'Query', getDailyReports?: { __typename: 'AuthCheckGetDailyReports', items: Array<{ __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AssignmentReportFieldsFragment = { __typename: 'MachineAssignmentReport', id: number, start_date: Date, end_date?: Date | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null }, project: { __typename: 'Project', id: number, name: string, slug: string }, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string } };

export type GetAssignmentReportsByMachineIdQueryVariables = Exact<{
  machineId: Scalars['Int']['input'];
  startDate: Scalars['LocalDate']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type GetAssignmentReportsByMachineIdQuery = { __typename: 'Query', getMachineAssignmentsByPeriod: Array<{ __typename: 'MachineAssignmentReport', id: number, start_date: Date, end_date?: Date | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null }, project: { __typename: 'Project', id: number, name: string, slug: string }, user: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string } }> };

export type GetMachineReportsHistoryQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterDailyReports>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetMachineReportsHistoryQuery = { __typename: 'Query', getDailyReports?: { __typename: 'AuthCheckGetDailyReports', items: Array<{ __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_hs?: number | null, total_km?: number | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null }, project?: { __typename: 'Project', id: number, name: string } | null, usage_reports: Array<{ __typename: 'UsageReport', id: number, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } } | null>, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }>, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, observation: string } | null, checkin_report?: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null } | null, checkout_report?: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null } | null, service_reports: Array<{ __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, date: Date, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type MachineReportsHistoryFieldsFragment = { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_hs?: number | null, total_km?: number | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null }, project?: { __typename: 'Project', id: number, name: string } | null, usage_reports: Array<{ __typename: 'UsageReport', id: number, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } } | null>, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }>, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, observation: string } | null, checkin_report?: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null } | null, checkout_report?: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null } | null, service_reports: Array<{ __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, date: Date, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string } | null }> };

export type MoveReportHistoryFieldsFragment = { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null };

export type MoveReportDetailPairedFieldsFragment = { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } };

export type MoveReportFieldsFragment = { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null };

export type GetMoveReportByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMoveReportByIdQuery = { __typename: 'Query', getMoveReportById: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null } };

export type GetDailyReportsByDayQueryVariables = Exact<{
  context: Context;
  date: Scalars['LocalDate']['input'];
  pagination?: InputMaybe<FilterPagination>;
  group?: InputMaybe<MachineGroup>;
}>;


export type GetDailyReportsByDayQuery = { __typename: 'Query', getDailyReports?: { __typename: 'AuthCheckGetDailyReports', items: Array<{ __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type MachinistReportsFieldsFragment = { __typename: 'MachinistWorkBoard', rate_reported?: number | null, user: { __typename: 'Employee', id: number, first_name: string, dni: string, email: string, last_name: string, username: string }, summaries: Array<{ __typename: 'MachinistDayWorkSummary', date: Date, has_reports: boolean, total_counters_display?: string | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }>, daily_reports: Array<{ __typename: 'DailyReport', id: number, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, preferred_counter_type: CounterType, is_archived: boolean, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, usage_reports: Array<{ __typename: 'UsageReport', id: number, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } } | null> }> }> };

export type GetMachinistsWorkBoardQueryVariables = Exact<{
  context: Context;
  filter: FilterDateRange;
}>;


export type GetMachinistsWorkBoardQuery = { __typename: 'Query', getMachinistsWorkBoard: { __typename: 'MachinistWorkBoardConnection', items: Array<{ __typename: 'MachinistWorkBoard', rate_reported?: number | null, user: { __typename: 'Employee', id: number, first_name: string, dni: string, email: string, last_name: string, username: string }, summaries: Array<{ __typename: 'MachinistDayWorkSummary', date: Date, has_reports: boolean, total_counters_display?: string | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }>, daily_reports: Array<{ __typename: 'DailyReport', id: number, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, preferred_counter_type: CounterType, is_archived: boolean, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, usage_reports: Array<{ __typename: 'UsageReport', id: number, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } } | null> }> }> }> } };

export type MachineReportsFieldsFragment = { __typename: 'MachineReportsBoard', total_days_with_reports_hs: number, total_days_with_reports_km: number, machine: { __typename: 'Machine', id: number, name: string, brand: string, model: string, year: number, preferred_counter_type: CounterType, power: number, replacement_value: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, is_archived: boolean, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, accepts_usage: boolean, accepts_available: boolean, reported_daily: boolean }, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null }, stats: { __typename: 'MachineReportsStats', num_greases: number, total_counters_display?: string | null, total_hs: number, total_km: number, total_fuel: number, total_motor_oil: number, num_worked_days: number, num_pending_days: number, num_available_days: number, total_days_with_reports: number, total_days: number, total_days_in_context: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }>, num_oos_days: { __typename: 'NumOOSDays', due_to_equipment: number, due_to_project: number } }, reports: Array<{ __typename: 'MachineDayReportSummary', id?: number | null, date: Date, project_id?: number | null, project_name?: string | null, status?: MachineReportStatus | null, total_counters_display?: string | null, total_fuel?: number | null, total_motor_oil?: number | null, has_filters?: boolean | null, has_grease?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, num_photos?: number | null, has_photos?: boolean | null, os_cause?: string | null, os_charge_type?: OosChargeType | null, av_cause?: string | null, user?: string | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> }> };

export type GetMachineReportsBoardQueryVariables = Exact<{
  context: Context;
  groups: Array<MachineGroup> | MachineGroup;
  filter: FilterDateRange;
  reporter?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMachineReportsBoardQuery = { __typename: 'Query', getMachineReportsBoard: { __typename: 'MachineReportsBoardConnection', items: Array<{ __typename: 'MachineReportsBoard', total_days_with_reports_hs: number, total_days_with_reports_km: number, machine: { __typename: 'Machine', id: number, name: string, brand: string, model: string, year: number, preferred_counter_type: CounterType, power: number, replacement_value: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, is_archived: boolean, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, accepts_usage: boolean, accepts_available: boolean, reported_daily: boolean }, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null }, stats: { __typename: 'MachineReportsStats', num_greases: number, total_counters_display?: string | null, total_hs: number, total_km: number, total_fuel: number, total_motor_oil: number, num_worked_days: number, num_pending_days: number, num_available_days: number, total_days_with_reports: number, total_days: number, total_days_in_context: number, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }>, num_oos_days: { __typename: 'NumOOSDays', due_to_equipment: number, due_to_project: number } }, reports: Array<{ __typename: 'MachineDayReportSummary', id?: number | null, date: Date, project_id?: number | null, project_name?: string | null, status?: MachineReportStatus | null, total_counters_display?: string | null, total_fuel?: number | null, total_motor_oil?: number | null, has_filters?: boolean | null, has_grease?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, num_photos?: number | null, has_photos?: boolean | null, os_cause?: string | null, os_charge_type?: OosChargeType | null, av_cause?: string | null, user?: string | null, total_counters: Array<{ __typename: 'Counter', type: CounterType, value: number }> }> } | null> } };

export type ExportReportsWorkbookQueryVariables = Exact<{
  context: Context;
  filter: FilterDateRange;
  machineId?: InputMaybe<Scalars['Int']['input']>;
  summaryMode?: InputMaybe<ReportsWorkbookSummaryMode>;
  groups?: InputMaybe<Array<MachineGroup> | MachineGroup>;
  reporter?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  reporterName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportReportsWorkbookQuery = { __typename: 'Query', exportReportsWorkbook: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type UpdateDailyReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateDailyReportInput;
}>;


export type UpdateDailyReportMutation = { __typename: 'Mutation', updateDailyReport?: { __typename: 'AuthCheckUpdateDailyReport', item: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'NotFoundDailyReportError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AddDailyReportMutationVariables = Exact<{
  input: AddDailyReportInput;
}>;


export type AddDailyReportMutation = { __typename: 'Mutation', addDailyReport?: { __typename: 'AuthCheckAddDailyReport', item: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AddDailyReportOfflineMutationVariables = Exact<{
  input: AddDailyReportOfflineInput;
}>;


export type AddDailyReportOfflineMutation = { __typename: 'Mutation', addDailyReportOffline: { __typename: 'AuthCheckAddDailyReport', item: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } };

export type DeleteDailyReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteDailyReportMutation = { __typename: 'Mutation', deleteDailyReport?: { __typename: 'AuthCheckDeleteDailyReport', item: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'NotFoundDailyReportError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AddOutOfServiceReportMutationVariables = Exact<{
  input: AddOutOfServiceReportForDateRangeInput;
}>;


export type AddOutOfServiceReportMutation = { __typename: 'Mutation', addOutOfServiceReportForDateRange?: { __typename: 'DailyReportItems', items: Array<{ __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } | null> } | null };

export type UpdateOutOfServiceReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateOosReportInput;
}>;


export type UpdateOutOfServiceReportMutation = { __typename: 'Mutation', updateOutOfServiceReport: { __typename: 'DailyReportItems', items: Array<{ __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } | null> } };

export type DeleteOutOfServiceReportMutationVariables = Exact<{
  parentId: Scalars['Int']['input'];
}>;


export type DeleteOutOfServiceReportMutation = { __typename: 'Mutation', deleteOutOfServiceReport?: { __typename: 'AuthCheckDeleteOutOfServiceReport', item: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type DeleteAvailableReportMutationVariables = Exact<{
  parentId: Scalars['Int']['input'];
}>;


export type DeleteAvailableReportMutation = { __typename: 'Mutation', deleteAvailableReport?: { __typename: 'AuthCheckDeleteAvailableReport', item: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type BatchAddAvailableReportMutationVariables = Exact<{
  input: BatchAddAvailableReportInput;
}>;


export type BatchAddAvailableReportMutation = { __typename: 'Mutation', batchAddAvailableReport?: { __typename: 'DailyReportItems', items: Array<{ __typename: 'DailyReport', id: number } | null> } | null };

export type UpdateMoveReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateMoveReportInput;
}>;


export type UpdateMoveReportMutation = { __typename: 'Mutation', updateMoveReport: { __typename: 'MoveReport', id: number, comments?: string | null, paired_report?: { __typename: 'MoveReport', id: number, comments?: string | null, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null } } | null, files: Array<{ __typename: 'File', id: string, url: string }>, created_by: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null }, counter: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null }, from_project?: { __typename: 'Project', id: number, name: string } | null, to_project?: { __typename: 'Project', id: number, name: string } | null } };

export type DailyReportChangedSubscriptionVariables = Exact<{
  context: Context;
}>;


export type DailyReportChangedSubscription = { __typename: 'Subscription', dailyReportChanged?: { __typename: 'DailyReport', id: number, date: Date, status: MachineReportStatus, total_counters_display?: string | null, total_fuel?: number | null, total_oil?: number | null, has_grease?: boolean | null, has_filters?: boolean | null, has_comments?: boolean | null, has_tasks?: boolean | null, project?: { __typename: 'Project', id: number, name: string } | null, machine: { __typename: 'Machine', id: number, name: string, display_name?: string | null, last_status: MachineReportStatus, last_status_on: Date, domain?: string | null, preferred_counter_type: CounterType, is_archived: boolean, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider }>, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null }, usage_reports: Array<{ __typename: 'UsageReport', id: number, created_at: any, updated_at?: any | null, grease: boolean, filters: boolean, fuel: number, motor_oil?: number | null, comments?: string | null, tasks?: string | null, cost_center_id?: number | null, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, cost_center?: { __typename: 'ProjectCostCenter', id: number, name: string, project_id: number } | null } | null>, total_counters: Array<{ __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }>, creators?: Array<{ __typename: 'Employee', id: number, first_name: string, last_name: string } | null> | null, out_of_service_report?: { __typename: 'OutOfServiceReport', id: number, cause: string, charge_type: OosChargeType, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, counter?: { __typename: 'Counter', type: CounterType, value: number, start?: number | null, end?: number | null } | null } | null, available_report?: { __typename: 'AvailableReport', id: number, created_at: any, updated_at?: any | null, observation: string, creator?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null, modifier?: { __typename: 'Employee', id: number, first_name: string, last_name: string } | null } | null } | null };

export type SuggestRosterColumnsQueryVariables = Exact<{
  context: Context;
  columns: Array<RosterColumnInput> | RosterColumnInput;
}>;


export type SuggestRosterColumnsQuery = { __typename: 'Query', suggestRosterColumns: { __typename: 'RosterColumnsSuggestion', truncated: boolean, meta: { __typename: 'AISuggestionMeta', available: boolean, unavailable_reason?: AiSuggestionUnavailableReason | null, model?: string | null, latency_ms?: number | null }, columns: Array<{ __typename: 'RosterColumnSuggestion', header: string, template_column?: string | null, ignore: boolean, probability: number, confidence: number, error: boolean, alternatives: Array<{ __typename: 'RosterColumnAlternative', template_column: string, probability: number }> }> } };

export type ListRosterAuditMachinesQueryVariables = Exact<{
  context: Context;
}>;


export type ListRosterAuditMachinesQuery = { __typename: 'Query', listRosterAuditMachines: Array<{ __typename: 'RosterAuditMachine', id: string, name: string, brand?: string | null, model?: string | null, type?: string | null, group?: string | null, serial?: string | null, plate?: string | null, fuel?: string | null, counter?: string | null }> };

export type SuggestRosterRowsQueryVariables = Exact<{
  context: Context;
  rows?: InputMaybe<Array<RosterRowInput> | RosterRowInput>;
  machine_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SuggestRosterRowsQuery = { __typename: 'Query', suggestRosterRows: { __typename: 'RosterRowsSuggestion', truncated: boolean, type_options_truncated: boolean, meta: { __typename: 'AISuggestionMeta', available: boolean, unavailable_reason?: AiSuggestionUnavailableReason | null, model?: string | null, latency_ms?: number | null }, rows: Array<{ __typename: 'RosterRowSuggestion', row_index: number, skipped: boolean, error: boolean, modelo?: string | null, subtipo?: string | null, rules: Array<RosterRule>, review_reasons: Array<RosterReviewReason>, marca?: { __typename: 'RosterBrandSuggestion', raw?: string | null, suggested?: string | null, is_new: boolean, probability: number, confidence: number } | null, tipo_combustible?: { __typename: 'RosterValueSuggestion', suggested?: string | null, probability: number, confidence: number } | null, tipo_contador?: { __typename: 'RosterValueSuggestion', suggested?: string | null, probability: number, confidence: number } | null, tipo_propiedad?: { __typename: 'RosterValueSuggestion', suggested?: string | null, probability: number, confidence: number } | null, grupo_y_tipo?: { __typename: 'RosterClassificationSuggestion', suggested_group?: string | null, suggested_type?: string | null, probability: number, confidence: number, jev_group?: string | null, jev_type?: string | null, jev_probability?: number | null, rule?: { __typename: 'RosterClassificationRule', grupo: string, tipo: string } | null } | null, matched_machine?: { __typename: 'RosterMatchedMachine', id: string, name: string } | null, conflicts: Array<{ __typename: 'RosterFieldConflict', field: RosterConflictField, loaded?: string | null, suggested?: string | null }> }> } };

export type AverageUsageFieldsFragment = { __typename: 'AverageUsage', machine_id: number, days_in_last_5_reports?: number | null, hours_in_last_5_reports?: number | null, hours_in_last_15_days?: number | null };

export type ServiceSequenceItemFieldsFragment = { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } };

export type NextServiceFieldsFragment = { __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } };

export type ServiceReportFieldsFragment = { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null };

export type MpProgramFieldsForServicesFragment = { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number };

export type ServicesFieldsFragment = { __typename: 'Machine', id: number, preferred_counter_type: CounterType, next_mp_sequence_index?: number | null, is_archived: boolean, name: string, display_name?: string | null, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number, period_type: PeriodType } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> };

export type ServicesFieldsWithoutNextServicesFragment = { __typename: 'Machine', id: number, preferred_counter_type: CounterType, next_mp_sequence_index?: number | null, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number, period_type: PeriodType } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> };

export type AddServiceReportMutationVariables = Exact<{
  input: AddServiceReportInput;
}>;


export type AddServiceReportMutation = { __typename: 'Mutation', addServiceReport: { __typename: 'DailyReportItem', item?: { __typename: 'DailyReport', machine: { __typename: 'Machine', id: number, preferred_counter_type: CounterType, next_mp_sequence_index?: number | null, is_archived: boolean, name: string, display_name?: string | null, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number, period_type: PeriodType } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } } | null } };

export type UpdateNextServicesMutationVariables = Exact<{
  input: UpdateNextServiceInput;
}>;


export type UpdateNextServicesMutation = { __typename: 'Mutation', updateNextService: { __typename: 'ItemMachine', item?: { __typename: 'Machine', id: number, preferred_counter_type: CounterType, next_mp_sequence_index?: number | null, is_archived: boolean, name: string, display_name?: string | null, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number, period_type: PeriodType } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null } };

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteServiceMutation = { __typename: 'Mutation', deleteServiceReport: { __typename: 'DeleteServiceReportPayload', id: number } };

export type GetServicesDashboardQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetServicesDashboardQuery = { __typename: 'Query', getServicesDashboard?: { __typename: 'ServicesDashboard', machines: Array<{ __typename: 'Machine', id: number, preferred_counter_type: CounterType, next_mp_sequence_index?: number | null, is_archived: boolean, name: string, display_name?: string | null, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number, period_type: PeriodType } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }>, usages: Array<{ __typename: 'AverageUsage', machine_id: number, days_in_last_5_reports?: number | null, hours_in_last_5_reports?: number | null, hours_in_last_15_days?: number | null }> } | null };

export type GetMachineWithServicesByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMachineWithServicesByIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, preferred_counter_type: CounterType, next_mp_sequence_index?: number | null, is_archived: boolean, name: string, display_name?: string | null, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, type: { __typename: 'MachineType', id: number, type: string }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number, period_type: PeriodType } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetMachineWithNextServiceByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMachineWithNextServiceByIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetNextServicesByMachineIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetNextServicesByMachineIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, next_services: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetServiceSequenceByMachineIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetServiceSequenceByMachineIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, service_sequence: Array<{ __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetServiceReportByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetServiceReportByIdQuery = { __typename: 'Query', getServiceReportById: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, files: Array<{ __typename: 'File', id: string, url: string }>, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } };

export type AdminUserRowFieldsFragment = { __typename: 'AdminUserRow', user_id?: number | null, cognito_username?: string | null, first_name?: string | null, last_name?: string | null, dni?: string | null, sign_in?: AdminUserSignIn | null, email?: string | null, kind: AdminUserKind, state: AdminUserState, alerts: Array<AdminUserAlert>, registered_at?: any | null, last_seen_on?: Date | null, managed_by?: { __typename: 'AdminUserCompany', id: number, name: string } | null, companies: Array<{ __typename: 'AdminUserCompany', id: number, name: string }> };

export type SearchAdminUsersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  filter: AdminUserFilter;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type SearchAdminUsersQuery = { __typename: 'Query', searchAdminUsers: { __typename: 'AdminUsersResult', truncated: boolean, items: Array<{ __typename: 'AdminUserRow', user_id?: number | null, cognito_username?: string | null, first_name?: string | null, last_name?: string | null, dni?: string | null, sign_in?: AdminUserSignIn | null, email?: string | null, kind: AdminUserKind, state: AdminUserState, alerts: Array<AdminUserAlert>, registered_at?: any | null, last_seen_on?: Date | null, managed_by?: { __typename: 'AdminUserCompany', id: number, name: string } | null, companies: Array<{ __typename: 'AdminUserCompany', id: number, name: string }> }>, counts: Array<{ __typename: 'AdminUserFilterCount', filter: AdminUserFilter, count: number }>, page_info: { __typename: 'PageInfo', total_pages: number, current_page: number, total_items: number, items_per_page: number } } };

export type ResendSignupConfirmationMutationVariables = Exact<{
  cognito_username: Scalars['String']['input'];
}>;


export type ResendSignupConfirmationMutation = { __typename: 'Mutation', resendSignupConfirmation: boolean };

export type UpdateUnconfirmedEmailMutationVariables = Exact<{
  cognito_username: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateUnconfirmedEmailMutation = { __typename: 'Mutation', updateUnconfirmedEmail: boolean };

export type SignOutEverywhereMutationVariables = Exact<{
  cognito_username: Scalars['String']['input'];
}>;


export type SignOutEverywhereMutation = { __typename: 'Mutation', signOutEverywhere: boolean };

export type RequestUserEmailChangeMutationVariables = Exact<{
  user_id: Scalars['Int']['input'];
  email: Scalars['String']['input'];
}>;


export type RequestUserEmailChangeMutation = { __typename: 'Mutation', requestUserEmailChange: boolean };

export type CancelUserEmailChangeMutationVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;


export type CancelUserEmailChangeMutation = { __typename: 'Mutation', cancelUserEmailChange: boolean };

export type AdminUserDetailFieldsFragment = { __typename: 'AdminUserDetail', enabled_to_create_company: boolean, row: { __typename: 'AdminUserRow', user_id?: number | null, cognito_username?: string | null, first_name?: string | null, last_name?: string | null, dni?: string | null, sign_in?: AdminUserSignIn | null, email?: string | null, kind: AdminUserKind, state: AdminUserState, alerts: Array<AdminUserAlert>, registered_at?: any | null, last_seen_on?: Date | null, managed_by?: { __typename: 'AdminUserCompany', id: number, name: string } | null, companies: Array<{ __typename: 'AdminUserCompany', id: number, name: string }> }, identities: Array<{ __typename: 'AdminCognitoIdentity', username: string, sub: string, sign_in: AdminUserSignIn, email: string, email_verified: boolean, status: CognitoUserStatus, enabled: boolean, dni?: string | null, first_name?: string | null, last_name?: string | null, created_at: any, updated_at: any }>, database?: { __typename: 'AdminUserDatabaseRow', id: number, username: string, email: string, dni: string, first_name: string, last_name: string, external_id?: string | null, google_external_id?: string | null, pending_email?: string | null, created_at: any, created_by_name?: string | null } | null, roles: Array<{ __typename: 'AdminUserCompanyRoles', managing: boolean, foreign: boolean, company: { __typename: 'AdminUserCompany', id: number, name: string }, roles: Array<{ __typename: 'AdminUserRole', id: number, role_type: string, scope_name?: string | null }> }>, checks: Array<{ __typename: 'AdminUserCheck', id: AdminUserCheckId, status: AdminUserCheckStatus }> };

export type AdminUserQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']['input']>;
  cognito_username?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUserQuery = { __typename: 'Query', adminUser?: { __typename: 'AdminUserDetail', enabled_to_create_company: boolean, row: { __typename: 'AdminUserRow', user_id?: number | null, cognito_username?: string | null, first_name?: string | null, last_name?: string | null, dni?: string | null, sign_in?: AdminUserSignIn | null, email?: string | null, kind: AdminUserKind, state: AdminUserState, alerts: Array<AdminUserAlert>, registered_at?: any | null, last_seen_on?: Date | null, managed_by?: { __typename: 'AdminUserCompany', id: number, name: string } | null, companies: Array<{ __typename: 'AdminUserCompany', id: number, name: string }> }, identities: Array<{ __typename: 'AdminCognitoIdentity', username: string, sub: string, sign_in: AdminUserSignIn, email: string, email_verified: boolean, status: CognitoUserStatus, enabled: boolean, dni?: string | null, first_name?: string | null, last_name?: string | null, created_at: any, updated_at: any }>, database?: { __typename: 'AdminUserDatabaseRow', id: number, username: string, email: string, dni: string, first_name: string, last_name: string, external_id?: string | null, google_external_id?: string | null, pending_email?: string | null, created_at: any, created_by_name?: string | null } | null, roles: Array<{ __typename: 'AdminUserCompanyRoles', managing: boolean, foreign: boolean, company: { __typename: 'AdminUserCompany', id: number, name: string }, roles: Array<{ __typename: 'AdminUserRole', id: number, role_type: string, scope_name?: string | null }> }>, checks: Array<{ __typename: 'AdminUserCheck', id: AdminUserCheckId, status: AdminUserCheckStatus }> } | null };

export type RentalParameterDefinitionFieldsFragment = { __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null };

export type GetRentalParameterDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRentalParameterDefinitionsQuery = { __typename: 'Query', getRentalParameterDefinitions: Array<{ __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null }> };

export type CreateRentalParameterDefinitionMutationVariables = Exact<{
  input: CreateRentalParameterDefinitionInput;
}>;


export type CreateRentalParameterDefinitionMutation = { __typename: 'Mutation', createRentalParameterDefinition: { __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null } };

export type UpdateRentalParameterDefinitionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateRentalParameterDefinitionInput;
}>;


export type UpdateRentalParameterDefinitionMutation = { __typename: 'Mutation', updateRentalParameterDefinition: { __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null } };

export type DeleteRentalParameterDefinitionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteRentalParameterDefinitionMutation = { __typename: 'Mutation', deleteRentalParameterDefinition: { __typename: 'SuccessResult', result?: string | null } };

export type RentalParameterEffectiveValueFieldsFragment = { __typename: 'EffectiveParameterValue', id: number, value?: any | null, priority: number, target_machine_id?: number | null, scope_project_id?: number | null, scope_business_unit_id?: number | null, scope_company_id?: number | null, applies_to_group?: MachineGroup | null, applies_to_type_id?: number | null, applies_to_counter_type?: CounterType | null, updated_at?: any | null, created_at: any, parameter_def: { __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null } };

export type MachineWithEffectiveParameterValuesFieldsFragment = { __typename: 'MachineWithEffectiveParameterValues', machine: { __typename: 'Machine', id: number, name: string, preferred_counter_type: CounterType, company?: { __typename: 'Company', id: number, name: string } | null, project?: { __typename: 'Project', id: number, name: string } | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } }, items: Array<{ __typename: 'EffectiveParameterValue', id: number, value?: any | null, priority: number, target_machine_id?: number | null, scope_project_id?: number | null, scope_business_unit_id?: number | null, scope_company_id?: number | null, applies_to_group?: MachineGroup | null, applies_to_type_id?: number | null, applies_to_counter_type?: CounterType | null, updated_at?: any | null, created_at: any, parameter_def: { __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null } }> };

export type GetRentalParameterEffectiveValuesByScopeQueryVariables = Exact<{
  scope: GetRentalParameterByScopeInput;
}>;


export type GetRentalParameterEffectiveValuesByScopeQuery = { __typename: 'Query', getRentalParameterEffectiveValuesByScope: { __typename: 'GetRentalParameterEffectiveValuesByScopeResponse', items: Array<{ __typename: 'EffectiveParameterValue', id: number, value?: any | null, priority: number, target_machine_id?: number | null, scope_project_id?: number | null, scope_business_unit_id?: number | null, scope_company_id?: number | null, applies_to_group?: MachineGroup | null, applies_to_type_id?: number | null, applies_to_counter_type?: CounterType | null, updated_at?: any | null, created_at: any, parameter_def: { __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null } }> } };

export type GetRentalParameterEffectiveValuesByMachineIdsQueryVariables = Exact<{
  machine_ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  project_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRentalParameterEffectiveValuesByMachineIdsQuery = { __typename: 'Query', getRentalParameterEffectiveValuesByMachineIds: { __typename: 'GetRentalParameterEffectiveValuesByMachineIdsResponse', items: Array<{ __typename: 'MachineWithEffectiveParameterValues', machine: { __typename: 'Machine', id: number, name: string, preferred_counter_type: CounterType, company?: { __typename: 'Company', id: number, name: string } | null, project?: { __typename: 'Project', id: number, name: string } | null, type: { __typename: 'MachineType', id: number, group: MachineGroup, type: string } }, items: Array<{ __typename: 'EffectiveParameterValue', id: number, value?: any | null, priority: number, target_machine_id?: number | null, scope_project_id?: number | null, scope_business_unit_id?: number | null, scope_company_id?: number | null, applies_to_group?: MachineGroup | null, applies_to_type_id?: number | null, applies_to_counter_type?: CounterType | null, updated_at?: any | null, created_at: any, parameter_def: { __typename: 'RentalParameterDefinition', id: number, code: RentalParamsCode, symbol: string, display_name: string, type: DataType, options?: any | null, unit?: string | null, description?: string | null } }> }> } };

export type SetRentalParameterValuesMutationVariables = Exact<{
  input: Array<SetRentalParameterValueInput> | SetRentalParameterValueInput;
}>;


export type SetRentalParameterValuesMutation = { __typename: 'Mutation', setRentalParameterValues: { __typename: 'SetRentalParameterValuePayload', success: boolean, updated_count: number } };

export type DeleteRentalParameterValuesMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DeleteRentalParameterValuesMutation = { __typename: 'Mutation', deleteRentalParameterValues: { __typename: 'DeleteRentalParameterValuePayload', success: boolean, deleted_count: number } };

export type GetIntegrationSyncRunsQueryVariables = Exact<{
  connection_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetIntegrationSyncRunsQuery = { __typename: 'Query', getIntegrationSyncRuns: Array<{ __typename: 'IntegrationSyncRun', id: string, connection_id: string, capability: string, status: string, started_at: any, finished_at?: any | null, summary?: any | null }> };

export type GetIntegrationSyncRunReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIntegrationSyncRunReportQuery = { __typename: 'Query', getIntegrationSyncRunReport?: any | null };

export type TriggerFleetSyncMutationVariables = Exact<{
  company_id: Scalars['Int']['input'];
  dry_run: Scalars['Boolean']['input'];
}>;


export type TriggerFleetSyncMutation = { __typename: 'Mutation', triggerFleetSync: { __typename: 'TriggerFleetSyncResult', run_id: string } };

export type CompanyIntegrationFieldsFragment = { __typename: 'CompanyIntegration', id: string, provider: string, is_active: boolean, credentials: any, last_sync_at?: any | null, last_sync_status?: string | null, last_error_message?: string | null, created_at: any, updated_at: any, company: { __typename: 'Company', id: number, name: string } };

export type GetCompanyIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyIntegrationsQuery = { __typename: 'Query', getCompanyIntegrations: Array<{ __typename: 'CompanyIntegration', id: string, provider: string, is_active: boolean, credentials: any, last_sync_at?: any | null, last_sync_status?: string | null, last_error_message?: string | null, created_at: any, updated_at: any, company: { __typename: 'Company', id: number, name: string } }> };

export type UpsertCompanyIntegrationMutationVariables = Exact<{
  input: UpsertCompanyIntegrationInput;
}>;


export type UpsertCompanyIntegrationMutation = { __typename: 'Mutation', upsertCompanyIntegration: { __typename: 'CompanyIntegration', id: string, provider: string, is_active: boolean, credentials: any, last_sync_at?: any | null, last_sync_status?: string | null, last_error_message?: string | null, created_at: any, updated_at: any, company: { __typename: 'Company', id: number, name: string } } };

export type DeleteCompanyIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCompanyIntegrationMutation = { __typename: 'Mutation', deleteCompanyIntegration: boolean };

export type TriggerCompanyIntegrationSyncMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggerCompanyIntegrationSyncMutation = { __typename: 'Mutation', triggerCompanyIntegrationSync: { __typename: 'CompanyIntegration', id: string, provider: string, is_active: boolean, credentials: any, last_sync_at?: any | null, last_sync_status?: string | null, last_error_message?: string | null, created_at: any, updated_at: any, company: { __typename: 'Company', id: number, name: string } } };

export type GetIntegrationProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationProvidersQuery = { __typename: 'Query', getIntegrationProviders: Array<{ __typename: 'IntegrationProviderConfig', provider: string, fields: Array<{ __typename: 'IntegrationProviderField', key: string, label: string, field_type: string, options?: Array<string> | null, default_value?: string | null, visible_when?: { __typename: 'IntegrationProviderFieldCondition', key: string, value: string } | null }> }> };

export type VisionLinkReportsByDateFieldsFragment = { __typename: 'VisionLinkReportsByDateResult', integration_id: string, company_id: number, company_name: string, date: Date, missing: Array<string>, found: Array<{ __typename: 'VisionLinkReportMatch', report_type: string, s3_key: string }> };

export type GetVisionLinkReportsByDateQueryVariables = Exact<{
  input: VisionLinkReportsByDateInput;
}>;


export type GetVisionLinkReportsByDateQuery = { __typename: 'Query', getVisionLinkReportsByDate: { __typename: 'VisionLinkReportsByDateResult', integration_id: string, company_id: number, company_name: string, date: Date, missing: Array<string>, found: Array<{ __typename: 'VisionLinkReportMatch', report_type: string, s3_key: string }> } };

export type ReprocessVisionLinkReportsByDateMutationVariables = Exact<{
  input: VisionLinkReportsByDateInput;
}>;


export type ReprocessVisionLinkReportsByDateMutation = { __typename: 'Mutation', reprocessVisionLinkReportsByDate: { __typename: 'VisionLinkReportsByDateResult', integration_id: string, company_id: number, company_name: string, date: Date, missing: Array<string>, found: Array<{ __typename: 'VisionLinkReportMatch', report_type: string, s3_key: string }> } };

export type PublicApiKeyFieldsFragment = { __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null };

export type PublicApiClientFieldsFragment = { __typename: 'PublicApiClient', id: number, companyId: number, companyName: string, name: string, roles: Array<PublicApiKeyRole>, ownerName?: string | null, ownerEmail?: string | null, technicalName?: string | null, technicalEmail?: string | null, createdAt: any, updatedAt?: any | null, lastUsedAt?: any | null, keys: Array<{ __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null }> };

export type PublicApiClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicApiClientsQuery = { __typename: 'Query', publicApiClients: Array<{ __typename: 'PublicApiClient', id: number, companyId: number, companyName: string, name: string, roles: Array<PublicApiKeyRole>, ownerName?: string | null, ownerEmail?: string | null, technicalName?: string | null, technicalEmail?: string | null, createdAt: any, updatedAt?: any | null, lastUsedAt?: any | null, keys: Array<{ __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null }> }> };

export type CreatePublicApiClientMutationVariables = Exact<{
  input: CreatePublicApiClientInput;
}>;


export type CreatePublicApiClientMutation = { __typename: 'Mutation', createPublicApiClient: { __typename: 'PublicApiClient', id: number, companyId: number, companyName: string, name: string, roles: Array<PublicApiKeyRole>, ownerName?: string | null, ownerEmail?: string | null, technicalName?: string | null, technicalEmail?: string | null, createdAt: any, updatedAt?: any | null, lastUsedAt?: any | null, keys: Array<{ __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null }> } };

export type UpdatePublicApiClientMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: UpdatePublicApiClientInput;
}>;


export type UpdatePublicApiClientMutation = { __typename: 'Mutation', updatePublicApiClient: { __typename: 'PublicApiClient', id: number, companyId: number, companyName: string, name: string, roles: Array<PublicApiKeyRole>, ownerName?: string | null, ownerEmail?: string | null, technicalName?: string | null, technicalEmail?: string | null, createdAt: any, updatedAt?: any | null, lastUsedAt?: any | null, keys: Array<{ __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null }> } };

export type IssuePublicApiKeyMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type IssuePublicApiKeyMutation = { __typename: 'Mutation', issuePublicApiKey: { __typename: 'IssuedPublicApiKey', secret: string, key: { __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null } } };

export type RotatePublicApiKeyMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  keyId: Scalars['Int']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RotatePublicApiKeyMutation = { __typename: 'Mutation', rotatePublicApiKey: { __typename: 'IssuedPublicApiKey', secret: string, key: { __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null } } };

export type SetPublicApiKeyExpiryMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  keyId: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SetPublicApiKeyExpiryMutation = { __typename: 'Mutation', setPublicApiKeyExpiry: { __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null } };

export type RevokePublicApiKeyMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  keyId: Scalars['Int']['input'];
  reason: PublicApiKeyRevocationReason;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevokePublicApiKeyMutation = { __typename: 'Mutation', revokePublicApiKey: { __typename: 'PublicApiKey', id: number, clientId: number, keyPrefix: string, status: PublicApiKeyStatus, expiresAt?: any | null, lastUsedAt?: any | null, createdAt: any, createdByName: string, revokedAt?: any | null, revokedByName?: string | null, revocationReason?: PublicApiKeyRevocationReason | null, revocationComment?: string | null } };

export type GetPushAdminStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPushAdminStatsQuery = { __typename: 'Query', getPushAdminStats: { __typename: 'PushAdminStats', totalSubscriptions: number, activeSubscriptions: number, distinctUsers: number, optOutCount: number, byPlatform: Array<{ __typename: 'PushPlatformStat', platform: string, total: number, active: number }>, byTopic: Array<{ __typename: 'PushTopicStat', topic: string, rows: number, companyWide: number, companies: number }> } };

type TelemetryDeviceBaseFields_IntegrationTelemetryDevice_Fragment = { __typename: 'IntegrationTelemetryDevice', id: number, name: string, protocol: string, ident: string, last_activity_at?: any | null, btrack_unit_id?: string | null, links: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> };

type TelemetryDeviceBaseFields_TrackerTelemetryDevice_Fragment = { __typename: 'TrackerTelemetryDevice', id: number, name: string, protocol: string, ident: string, last_activity_at?: any | null, btrack_unit_id?: string | null, links: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> };

export type TelemetryDeviceBaseFieldsFragment = TelemetryDeviceBaseFields_IntegrationTelemetryDevice_Fragment | TelemetryDeviceBaseFields_TrackerTelemetryDevice_Fragment;

export type TrackerTelemetryDeviceFieldsFragment = { __typename: 'TrackerTelemetryDevice', model: string, ignition_voltage_threshold?: number | null, last_meassured_voltage?: number | null, id: number, name: string, protocol: string, ident: string, last_activity_at?: any | null, btrack_unit_id?: string | null, links: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> };

export type IntegrationTelemetryDeviceFieldsFragment = { __typename: 'IntegrationTelemetryDevice', integration: string, last_horometer?: number | null, last_horometer_at?: any | null, last_odometer?: number | null, last_odometer_at?: any | null, id: number, name: string, protocol: string, ident: string, last_activity_at?: any | null, btrack_unit_id?: string | null, links: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> };

export type LinkTelemetryDevicesToCompanyMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  deviceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type LinkTelemetryDevicesToCompanyMutation = { __typename: 'Mutation', linkTelemetryDevicesToCompany: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type RemoveTelemetryDeviceLinksMutationVariables = Exact<{
  linkIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveTelemetryDeviceLinksMutation = { __typename: 'Mutation', removeTelemetryDeviceLinks: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type GetTrackerTelemetryDevicesQueryVariables = Exact<{
  filter: GetTelemetryDevicesFilter;
}>;


export type GetTrackerTelemetryDevicesQuery = { __typename: 'Query', getTelemetryDevices: Array<{ __typename: 'IntegrationTelemetryDevice' } | { __typename: 'TrackerTelemetryDevice', model: string, ignition_voltage_threshold?: number | null, last_meassured_voltage?: number | null, id: number, name: string, protocol: string, ident: string, last_activity_at?: any | null, btrack_unit_id?: string | null, links: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> }> };

export type GetIntegrationTelemetryDevicesQueryVariables = Exact<{
  filter: GetTelemetryDevicesFilter;
}>;


export type GetIntegrationTelemetryDevicesQuery = { __typename: 'Query', getTelemetryDevices: Array<{ __typename: 'IntegrationTelemetryDevice', integration: string, last_horometer?: number | null, last_horometer_at?: any | null, last_odometer?: number | null, last_odometer_at?: any | null, id: number, name: string, protocol: string, ident: string, last_activity_at?: any | null, btrack_unit_id?: string | null, links: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | { __typename: 'TrackerTelemetryDevice' }> };

export type DownloadTelemetryDevicesWorkbookQueryVariables = Exact<{
  category: TelemetryDeviceCategory;
}>;


export type DownloadTelemetryDevicesWorkbookQuery = { __typename: 'Query', downloadTelemetryDevicesWorkbook: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type UpdateTelemetryDeviceLinkMutationVariables = Exact<{
  linkId: Scalars['ID']['input'];
  input: UpdateTelemetryDeviceLinkInput;
}>;


export type UpdateTelemetryDeviceLinkMutation = { __typename: 'Mutation', updateTelemetryDeviceLink: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type CalibrateTrackerDeviceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CalibrateTrackerDeviceInput;
}>;


export type CalibrateTrackerDeviceMutation = { __typename: 'Mutation', calibrateTrackerDevice: { __typename: 'TrackerTelemetryDevice', model: string, ignition_voltage_threshold?: number | null, last_meassured_voltage?: number | null, id: number, name: string, protocol: string, ident: string, last_activity_at?: any | null, btrack_unit_id?: string | null, links: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } };

export type SystemFlagFieldsFragment = { __typename: 'SystemFlag', key: string, enabled: boolean, description: string, updated_at?: any | null };

export type SystemFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemFlagsQuery = { __typename: 'Query', systemFlags: Array<{ __typename: 'SystemFlag', key: string, enabled: boolean, description: string, updated_at?: any | null }> };

export type SetSystemFlagMutationVariables = Exact<{
  key: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetSystemFlagMutation = { __typename: 'Mutation', setSystemFlag: { __typename: 'SystemFlag', key: string, enabled: boolean, description: string, updated_at?: any | null } };

export type TelemetrySandboxScopeFieldsFragment = { __typename: 'TelemetrySandboxScope', scope_key: string, account_label?: string | null, provider_family?: string | null };

export type TelemetrySandboxRuntimeConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type TelemetrySandboxRuntimeConfigQuery = { __typename: 'Query', telemetrySandboxRuntimeConfig: { __typename: 'TelemetrySandboxRuntimeConfig', active_scope_key: string, editable: boolean, active_scope: { __typename: 'TelemetrySandboxScope', scope_key: string, account_label?: string | null, provider_family?: string | null }, scopes: Array<{ __typename: 'TelemetrySandboxScope', scope_key: string, account_label?: string | null, provider_family?: string | null }> } };

export type SetActiveTelemetrySandboxScopeMutationVariables = Exact<{
  scopeKey: Scalars['ID']['input'];
}>;


export type SetActiveTelemetrySandboxScopeMutation = { __typename: 'Mutation', setActiveTelemetrySandboxScope: { __typename: 'TelemetrySandboxRuntimeConfig', active_scope_key: string, editable: boolean, active_scope: { __typename: 'TelemetrySandboxScope', scope_key: string, account_label?: string | null, provider_family?: string | null }, scopes: Array<{ __typename: 'TelemetrySandboxScope', scope_key: string, account_label?: string | null, provider_family?: string | null }> } };

export type CompanyWithTotalsFieldsFragment = { __typename: 'CompanyWithTotals', users: number, projects: number, heavy_equipments: number, trucks: number, vehicles: number, fixed_assets: number, fuel_tanks: number, maintenance_plans: number, documents: number, users_seen_30d: number, last_seen_at?: any | null, company: { __typename: 'Company', id: number, name: string } };

export type CompanyActivityFieldsFragment = { __typename: 'CompanyActivitySummary', companyId: number, activeUserCount: number, totalActions: number, lastActivityDate: Date };

export type GetCompanyActivityQueryVariables = Exact<{
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
}>;


export type GetCompanyActivityQuery = { __typename: 'Query', getCompanyActivity: Array<{ __typename: 'CompanyActivitySummary', companyId: number, activeUserCount: number, totalActions: number, lastActivityDate: Date }> };

export type GetAllCompaniesForProjectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCompaniesForProjectOptionsQuery = { __typename: 'Query', getAllCompanies: { __typename: 'CompaniesConnection', items?: Array<{ __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null, projects: Array<{ __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string, slug: string } }> } | null> | null } };

export type AllCompaniesForSuperRootFieldsFragment = { __typename: 'Company', id: number, name: string, slug: string, logo_url?: string | null, modules_enabled?: Array<{ __typename: 'BilderitModuleEnabled', module_id: BilderitModuleId, end_date?: Date | null } | null> | null, projects: Array<{ __typename: 'Project', id: number, name: string, slug: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string, slug: string } }> };

export type DeleteUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename: 'Mutation', deleteUserByUsername: string };

export type EnableBilderitModuleMutationVariables = Exact<{
  input: EnableBilderitModuleInput;
}>;


export type EnableBilderitModuleMutation = { __typename: 'Mutation', enableBilderitModule: string };

export type DisableBilderitModuleMutationVariables = Exact<{
  input: DisableBilderitModuleInput;
}>;


export type DisableBilderitModuleMutation = { __typename: 'Mutation', disableBilderitModule: string };

export type EnableToCreateCompanyMutationVariables = Exact<{
  input: EnableToCreateCompanyInput;
}>;


export type EnableToCreateCompanyMutation = { __typename: 'Mutation', enableToCreateCompany: string };

export type DisableToCreateCompanyMutationVariables = Exact<{
  input: DisableToCreateCompanyInput;
}>;


export type DisableToCreateCompanyMutation = { __typename: 'Mutation', disableToCreateCompany: string };

export type GetCompaniesWithTotalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesWithTotalsQuery = { __typename: 'Query', getCompaniesWithTotals?: { __typename: 'CompaniesWithTotals', items: Array<{ __typename: 'CompanyWithTotals', users: number, projects: number, heavy_equipments: number, trucks: number, vehicles: number, fixed_assets: number, fuel_tanks: number, maintenance_plans: number, documents: number, users_seen_30d: number, last_seen_at?: any | null, company: { __typename: 'Company', id: number, name: string } }> } | null };

export type ChangeCompanyRootMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  newRootId: Scalars['Int']['input'];
}>;


export type ChangeCompanyRootMutation = { __typename: 'Mutation', changeCompanyRoot: { __typename: 'Company', id: number } };

export type GetCompanyCreatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyCreatorsQuery = { __typename: 'Query', getEnabledToCreateCompanyUsers: Array<string> };

export type SyncMachinesStatusMutationVariables = Exact<{
  input: SyncMachinesStatusInput;
}>;


export type SyncMachinesStatusMutation = { __typename: 'Mutation', syncMachinesStatus: { __typename: 'ServerError', errorCode: ErrorCode, message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type SyncMachineCountersMutationVariables = Exact<{
  input: SyncMachineCountersInput;
}>;


export type SyncMachineCountersMutation = { __typename: 'Mutation', syncMachineCounters: { __typename: 'ServerError', errorCode: ErrorCode, message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type PreviewBilderitReportMutationVariables = Exact<{
  input: PreviewBilderitReportInput;
}>;


export type PreviewBilderitReportMutation = { __typename: 'Mutation', previewBilderitReport: { __typename: 'ServerError', errorCode: ErrorCode, message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type LinkToBTrackMutationVariables = Exact<{
  tracker_id: Scalars['Int']['input'];
}>;


export type LinkToBTrackMutation = { __typename: 'Mutation', linkToBTrack: number };

export type UnlinkFromBTrackMutationVariables = Exact<{
  tracker_id: Scalars['Int']['input'];
}>;


export type UnlinkFromBTrackMutation = { __typename: 'Mutation', unlinkFromBTrack: number };

export type TagCatalogFieldsFragment = { __typename: 'Tag', id: string, tag: string, description?: string | null, icon?: string | null, color?: TagColor | null, is_archived: boolean, usage_count: number, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null };

export type TagGroupCatalogFieldsFragment = { __typename: 'TagGroup', id: string, name: string, is_archived: boolean };

export type GetScopedTagsQueryVariables = Exact<{
  context: Context;
  scope: TagScope;
  query?: InputMaybe<Scalars['String']['input']>;
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetScopedTagsQuery = { __typename: 'Query', getTags: { __typename: 'TagsConnection', edges: Array<{ __typename: 'Tag', id: string, tag: string, description?: string | null, icon?: string | null, color?: TagColor | null, is_archived: boolean, usage_count: number, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null }> } };

export type GetBilderitScopedTagsQueryVariables = Exact<{
  scope: TagScope;
  query?: InputMaybe<Scalars['String']['input']>;
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBilderitScopedTagsQuery = { __typename: 'Query', getTagsManagedByBilderit: { __typename: 'TagsConnection', edges: Array<{ __typename: 'Tag', id: string, tag: string, description?: string | null, icon?: string | null, color?: TagColor | null, is_archived: boolean, usage_count: number, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null }> } };

export type GetScopedTagGroupsQueryVariables = Exact<{
  context: Context;
  scope: TagScope;
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetScopedTagGroupsQuery = { __typename: 'Query', getTagGroups: Array<{ __typename: 'TagGroup', id: string, name: string, is_archived: boolean }> };

export type GetBilderitScopedTagGroupsQueryVariables = Exact<{
  scope: TagScope;
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBilderitScopedTagGroupsQuery = { __typename: 'Query', getTagGroupsManagedByBilderit: Array<{ __typename: 'TagGroup', id: string, name: string, is_archived: boolean }> };

export type AddTagMutationVariables = Exact<{
  input: AddTagInput;
}>;


export type AddTagMutation = { __typename: 'Mutation', addTag: { __typename: 'Tag', id: string, tag: string, description?: string | null, icon?: string | null, color?: TagColor | null, is_archived: boolean, usage_count: number, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null } };

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename: 'Mutation', updateTag: { __typename: 'Tag', id: string, tag: string, description?: string | null, icon?: string | null, color?: TagColor | null, is_archived: boolean, usage_count: number, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null } };

export type MergeTagsMutationVariables = Exact<{
  input: MergeTagsInput;
}>;


export type MergeTagsMutation = { __typename: 'Mutation', mergeTags: { __typename: 'Tag', id: string, tag: string, description?: string | null, icon?: string | null, color?: TagColor | null, is_archived: boolean, usage_count: number, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null } };

export type AddTagGroupMutationVariables = Exact<{
  input: AddTagGroupInput;
}>;


export type AddTagGroupMutation = { __typename: 'Mutation', addTagGroup: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } };

export type UpdateTagGroupMutationVariables = Exact<{
  input: UpdateTagGroupInput;
}>;


export type UpdateTagGroupMutation = { __typename: 'Mutation', updateTagGroup: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } };

export type ReviewTagCatalogQueryVariables = Exact<{
  context: Context;
  scope: TagScope;
}>;


export type ReviewTagCatalogQuery = { __typename: 'Query', reviewTagCatalog: { __typename: 'TagCatalogReview', truncated: boolean, truncated_reason?: TagReviewTruncatedReason | null, reviewed_count: number, total_count: number, meta: { __typename: 'AISuggestionMeta', available: boolean, unavailable_reason?: AiSuggestionUnavailableReason | null, model?: string | null, latency_ms?: number | null }, duplicates: Array<{ __typename: 'TagDuplicateCandidate', tag_a_id: string, tag_b_id: string, relation: TagRelation, probability: number }>, tags: Array<{ __typename: 'TagReviewItem', tag_id: string, specificity: TagSpecificity, specificity_probability: number, unreadable_name_probability: number, is_code_like: boolean, usage_share: number }> } };

export type DailyTelemetryFieldsFragment = { __typename: 'DailyTelemetry', end_of_day: any, flespi_id: string, machine_id: number, telemetry_provider: TmProvider, device_name?: string | null, device_serial_number?: string | null, vin?: string | null, counter_offset: number, engine_ignition_status?: EngineIgnitionStatus | null, DEF_remaining_percentage?: number | null, DEF_tank_capacity?: number | null, cumulative_distance_traveled_km?: number | null, cumulative_fuel_consumed_lts?: number | null, cumulative_idle_hours?: number | null, cumulative_idle_non_operating_hours?: number | null, cumulative_load_count?: number | null, cumulative_operating_hours?: number | null, cumulative_payload_moved_kg?: number | null, cumulative_power_takeoff_hours?: number | null, daily_distance_traveled_km?: number | null, daily_fuel_consumed_lts?: number | null, daily_idle_hours?: number | null, daily_idle_non_operating_hours?: number | null, daily_maximum_speed_km_h?: number | null, daily_operating_hours?: number | null, fuel_remaining_percentage?: number | null, fuel_tank_capacity?: number | null, position?: { __typename: 'Position', latitude?: number | null, longitude?: number | null, altitude?: number | null } | null, working_intervals?: Array<{ __typename: 'WorkingInterval', start: any, end: any }> | null, project_at_day?: { __typename: 'Project', id: number, name: string } | null };

export type TelemetrySnapshotFieldsFragment = { __typename: 'TelemetrySnapshot', flespi_id: string, machine_id?: number | null, telemetry_provider: TmProvider, counter_offset?: number | null, device_name?: string | null, device_serial_number?: string | null, vin?: string | null, DEF_remaining_percentage?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, DEF_tank_capacity?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, fuel_remaining_percentage?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, fuel_tank_capacity?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_distance_traveled_km?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_fuel_consumed_lts?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_idle_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_idle_non_operating_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_load_count?: { __typename: 'IntSnapshot', value: number, datetime_utc: any } | null, cumulative_operating_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_payload_moved_kg?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_power_takeoff_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, engine_ignition_status?: { __typename: 'EngineIgnitionStatusSnapshot', value: EngineIgnitionStatus, datetime_utc: any } | null, position?: { __typename: 'PositionSnapshot', latitude: number, longitude: number, altitude?: number | null, datetime_utc: any } | null };

export type GetTimeSeriesByBilderitConnectDeviceIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from_utc: Scalars['DateTime']['input'];
  to_utc: Scalars['DateTime']['input'];
}>;


export type GetTimeSeriesByBilderitConnectDeviceIdQuery = { __typename: 'Query', getTimeSeriesByBilderitConnectDeviceId: Array<{ __typename: 'DailyTelemetry', end_of_day: any, flespi_id: string, machine_id: number, telemetry_provider: TmProvider, device_name?: string | null, device_serial_number?: string | null, vin?: string | null, counter_offset: number, engine_ignition_status?: EngineIgnitionStatus | null, DEF_remaining_percentage?: number | null, DEF_tank_capacity?: number | null, cumulative_distance_traveled_km?: number | null, cumulative_fuel_consumed_lts?: number | null, cumulative_idle_hours?: number | null, cumulative_idle_non_operating_hours?: number | null, cumulative_load_count?: number | null, cumulative_operating_hours?: number | null, cumulative_payload_moved_kg?: number | null, cumulative_power_takeoff_hours?: number | null, daily_distance_traveled_km?: number | null, daily_fuel_consumed_lts?: number | null, daily_idle_hours?: number | null, daily_idle_non_operating_hours?: number | null, daily_maximum_speed_km_h?: number | null, daily_operating_hours?: number | null, fuel_remaining_percentage?: number | null, fuel_tank_capacity?: number | null, position?: { __typename: 'Position', latitude?: number | null, longitude?: number | null, altitude?: number | null } | null, working_intervals?: Array<{ __typename: 'WorkingInterval', start: any, end: any }> | null, project_at_day?: { __typename: 'Project', id: number, name: string } | null }> };

export type GetSnapshotByBilderitConnectDeviceIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSnapshotByBilderitConnectDeviceIdQuery = { __typename: 'Query', getSnapshotByBilderitConnectDeviceId: { __typename: 'TelemetrySnapshot', flespi_id: string, machine_id?: number | null, telemetry_provider: TmProvider, counter_offset?: number | null, device_name?: string | null, device_serial_number?: string | null, vin?: string | null, DEF_remaining_percentage?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, DEF_tank_capacity?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, fuel_remaining_percentage?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, fuel_tank_capacity?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_distance_traveled_km?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_fuel_consumed_lts?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_idle_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_idle_non_operating_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_load_count?: { __typename: 'IntSnapshot', value: number, datetime_utc: any } | null, cumulative_operating_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_payload_moved_kg?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_power_takeoff_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, engine_ignition_status?: { __typename: 'EngineIgnitionStatusSnapshot', value: EngineIgnitionStatus, datetime_utc: any } | null, position?: { __typename: 'PositionSnapshot', latitude: number, longitude: number, altitude?: number | null, datetime_utc: any } | null } };

export type DailyTelemetryGroupFieldsFragment = { __typename: 'DailyTelemetryGroup', machine: { __typename: 'Machine', id: number, brand: string, model: string, name: string, is_archived: boolean, display_name?: string | null, project?: { __typename: 'Project', id: number, name: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, telemetry: Array<{ __typename: 'DailyTelemetry', end_of_day: any, flespi_id: string, machine_id: number, telemetry_provider: TmProvider, device_name?: string | null, device_serial_number?: string | null, vin?: string | null, counter_offset: number, engine_ignition_status?: EngineIgnitionStatus | null, DEF_remaining_percentage?: number | null, DEF_tank_capacity?: number | null, cumulative_distance_traveled_km?: number | null, cumulative_fuel_consumed_lts?: number | null, cumulative_idle_hours?: number | null, cumulative_idle_non_operating_hours?: number | null, cumulative_load_count?: number | null, cumulative_operating_hours?: number | null, cumulative_payload_moved_kg?: number | null, cumulative_power_takeoff_hours?: number | null, daily_distance_traveled_km?: number | null, daily_fuel_consumed_lts?: number | null, daily_idle_hours?: number | null, daily_idle_non_operating_hours?: number | null, daily_maximum_speed_km_h?: number | null, daily_operating_hours?: number | null, fuel_remaining_percentage?: number | null, fuel_tank_capacity?: number | null, position?: { __typename: 'Position', latitude?: number | null, longitude?: number | null, altitude?: number | null } | null, working_intervals?: Array<{ __typename: 'WorkingInterval', start: any, end: any }> | null, project_at_day?: { __typename: 'Project', id: number, name: string } | null }> };

export type GetDailyTelemetryByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type GetDailyTelemetryByCompanyIdQuery = { __typename: 'Query', getDailyAEMPTelemetryByCompany: Array<{ __typename: 'DailyTelemetryGroup', machine: { __typename: 'Machine', id: number, brand: string, model: string, name: string, is_archived: boolean, display_name?: string | null, project?: { __typename: 'Project', id: number, name: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, telemetry: Array<{ __typename: 'DailyTelemetry', end_of_day: any, flespi_id: string, machine_id: number, telemetry_provider: TmProvider, device_name?: string | null, device_serial_number?: string | null, vin?: string | null, counter_offset: number, engine_ignition_status?: EngineIgnitionStatus | null, DEF_remaining_percentage?: number | null, DEF_tank_capacity?: number | null, cumulative_distance_traveled_km?: number | null, cumulative_fuel_consumed_lts?: number | null, cumulative_idle_hours?: number | null, cumulative_idle_non_operating_hours?: number | null, cumulative_load_count?: number | null, cumulative_operating_hours?: number | null, cumulative_payload_moved_kg?: number | null, cumulative_power_takeoff_hours?: number | null, daily_distance_traveled_km?: number | null, daily_fuel_consumed_lts?: number | null, daily_idle_hours?: number | null, daily_idle_non_operating_hours?: number | null, daily_maximum_speed_km_h?: number | null, daily_operating_hours?: number | null, fuel_remaining_percentage?: number | null, fuel_tank_capacity?: number | null, position?: { __typename: 'Position', latitude?: number | null, longitude?: number | null, altitude?: number | null } | null, working_intervals?: Array<{ __typename: 'WorkingInterval', start: any, end: any }> | null, project_at_day?: { __typename: 'Project', id: number, name: string } | null }> }> };

export type SetMachineTelemetryProviderOffsetMutationVariables = Exact<{
  machineId: Scalars['Int']['input'];
  offset: Scalars['Float']['input'];
}>;


export type SetMachineTelemetryProviderOffsetMutation = { __typename: 'Mutation', setMachineTelemetryProviderOffset: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult' } };

export type GetBcDeviceSnapshotsByCompanyIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBcDeviceSnapshotsByCompanyIdQuery = { __typename: 'Query', getBCDeviceSnapshotsByCompanyId: Array<{ __typename: 'BCDeviceSnapshot', bc_device: { __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }, telemetry_snapshot?: { __typename: 'TelemetrySnapshot', flespi_id: string, machine_id?: number | null, telemetry_provider: TmProvider, counter_offset?: number | null, device_name?: string | null, device_serial_number?: string | null, vin?: string | null, DEF_remaining_percentage?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, DEF_tank_capacity?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, fuel_remaining_percentage?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, fuel_tank_capacity?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_distance_traveled_km?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_fuel_consumed_lts?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_idle_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_idle_non_operating_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_load_count?: { __typename: 'IntSnapshot', value: number, datetime_utc: any } | null, cumulative_operating_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_payload_moved_kg?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, cumulative_power_takeoff_hours?: { __typename: 'FloatSnapshot', value: number, datetime_utc: any } | null, engine_ignition_status?: { __typename: 'EngineIgnitionStatusSnapshot', value: EngineIgnitionStatus, datetime_utc: any } | null, position?: { __typename: 'PositionSnapshot', latitude: number, longitude: number, altitude?: number | null, datetime_utc: any } | null } | null }> };

export type InitJohnDeereConnectionMutationVariables = Exact<{
  company_id: Scalars['Int']['input'];
  auth_code: Scalars['String']['input'];
}>;


export type InitJohnDeereConnectionMutation = { __typename: 'Mutation', initJohnDeereConnection?: { __typename: 'InitJohnDeereConnectionResponse', org_connection_redirect_url?: string | null, access_token: string, created_at?: number | null, expires_in: number, refresh_token: string, scope: string, token_type: string } | null };

export type InitCaseConnectionMutationVariables = Exact<{
  company_id: Scalars['Int']['input'];
  auth_code: Scalars['String']['input'];
}>;


export type InitCaseConnectionMutation = { __typename: 'Mutation', initCaseConnection?: { __typename: 'InitCaseConnectionResponse', access_token: string, created_at?: number | null, expires_in: number, refresh_token: string, scope: string, token_type: string } | null };

export type TelemetryGroupStatsFieldsFragment = { __typename: 'TelemetryGroupStats', totalEquipos: number, totalHoras?: number | null, totalRalenti?: number | null, totalHorasActivas?: number | null, totalCombustible?: number | null, totalCombustibleRalenti?: number | null, totalCombustibleActivo?: number | null, totalCostoEstimado?: number | null, totalCostoRalenti?: number | null, totalCostoActivo?: number | null, promedioHorasPorEquipo?: number | null, promedioRalentiPorEquipo?: number | null, promedioPorcentajeRalenti?: number | null, promedioCombustiblePorEquipo?: number | null };

export type TelemetryEquipmentStatsFieldsFragment = { __typename: 'TelemetryEquipmentStats', machineId: number, projectId: number, horas?: number | null, ralenti?: number | null, porcentajeRalenti?: number | null, horasActivas?: number | null, combustible?: number | null, combustibleRalenti?: number | null, combustibleActivo?: number | null, costoTotal?: number | null, costoRalenti?: number | null, costoActivo?: number | null, fechaUltimaActividad?: any | null, machine: { __typename: 'Machine', id: number, brand: string, model: string, name: string, is_archived: boolean, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, project?: { __typename: 'Project', id: number, name: string } | null };

export type GetTelemetryDashboardStatsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  idleConsumptionRate?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetTelemetryDashboardStatsQuery = { __typename: 'Query', getTelemetryDashboardStats: { __typename: 'TelemetryDashboardStats', fuelCostAvailable: boolean, pricingCoverage: { __typename: 'TelemetryPricingCoverage', totalProjects: number, coveredProjects: number, uncoveredProjects: number, uncoveredProjectIds: Array<number> }, globalStats: { __typename: 'TelemetryGroupStats', totalEquipos: number, totalHoras?: number | null, totalRalenti?: number | null, totalHorasActivas?: number | null, totalCombustible?: number | null, totalCombustibleRalenti?: number | null, totalCombustibleActivo?: number | null, totalCostoEstimado?: number | null, totalCostoRalenti?: number | null, totalCostoActivo?: number | null, promedioHorasPorEquipo?: number | null, promedioRalentiPorEquipo?: number | null, promedioPorcentajeRalenti?: number | null, promedioCombustiblePorEquipo?: number | null }, projectStats: Array<{ __typename: 'TelemetryProjectStats', projectId: number, project?: { __typename: 'Project', id: number, name: string } | null, stats: { __typename: 'TelemetryGroupStats', totalEquipos: number, totalHoras?: number | null, totalRalenti?: number | null, totalHorasActivas?: number | null, totalCombustible?: number | null, totalCombustibleRalenti?: number | null, totalCombustibleActivo?: number | null, totalCostoEstimado?: number | null, totalCostoRalenti?: number | null, totalCostoActivo?: number | null, promedioHorasPorEquipo?: number | null, promedioRalentiPorEquipo?: number | null, promedioPorcentajeRalenti?: number | null, promedioCombustiblePorEquipo?: number | null }, equipment: Array<{ __typename: 'TelemetryEquipmentStats', machineId: number, projectId: number, horas?: number | null, ralenti?: number | null, porcentajeRalenti?: number | null, horasActivas?: number | null, combustible?: number | null, combustibleRalenti?: number | null, combustibleActivo?: number | null, costoTotal?: number | null, costoRalenti?: number | null, costoActivo?: number | null, fechaUltimaActividad?: any | null, machine: { __typename: 'Machine', id: number, brand: string, model: string, name: string, is_archived: boolean, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, project?: { __typename: 'Project', id: number, name: string } | null }>, movement: Array<{ __typename: 'TelemetryProjectMovement', machineId: number, otherProjectIds: Array<number>, machine: { __typename: 'Machine', id: number, name: string }, otherProjects: Array<{ __typename: 'Project', id: number, name: string }> }> }>, equipments: Array<{ __typename: 'TelemetryEquipmentStats', machineId: number, projectId: number, horas?: number | null, ralenti?: number | null, porcentajeRalenti?: number | null, horasActivas?: number | null, combustible?: number | null, combustibleRalenti?: number | null, combustibleActivo?: number | null, costoTotal?: number | null, costoRalenti?: number | null, costoActivo?: number | null, fechaUltimaActividad?: any | null, machine: { __typename: 'Machine', id: number, brand: string, model: string, name: string, is_archived: boolean, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, project?: { __typename: 'Project', id: number, name: string } | null }>, movementSummary: { __typename: 'TelemetryMovementSummary', movedMachinesCount: number, affectedProjectsCount: number } } };

export type GenerateTelemetryPdfMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  idleConsumptionRate?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateTelemetryPdfMutation = { __typename: 'Mutation', generateTelemetryPDF: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type GetFuelCostSettingQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFuelCostSettingQuery = { __typename: 'Query', getFuelCostSetting?: number | null };

export type GetFuelCostSettingsOverviewQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetFuelCostSettingsOverviewQuery = { __typename: 'Query', getFuelCostSettingsOverview: { __typename: 'FuelCostSettingsOverview', companyValue?: number | null, projects: Array<{ __typename: 'FuelCostProjectSetting', projectId: number, projectName: string, projectScopedValue?: number | null, effectiveValue?: number | null }> } };

export type SetFuelCostSettingMutationVariables = Exact<{
  companyId: Scalars['Int']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SetFuelCostSettingMutation = { __typename: 'Mutation', setFuelCostSetting: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type AddTruckMutationVariables = Exact<{
  input: AddTruckInput;
}>;


export type AddTruckMutation = { __typename: 'Mutation', addTruck?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null };

export type UpdateTruckMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateTruckInput;
}>;


export type UpdateTruckMutation = { __typename: 'Mutation', updateTruck?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }>, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null } | null };

export type GetTrucksQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetTrucksQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AddVehicleMutationVariables = Exact<{
  input: AddMobilityInput;
}>;


export type AddVehicleMutation = { __typename: 'Mutation', addMobility?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null };

export type UpdateVehicleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdateMobilityInput;
}>;


export type UpdateVehicleMutation = { __typename: 'Mutation', updateMobility?: { __typename: 'DuplicatedMachineError', message: string } | { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', datetime: any, source: CounterSource, type: CounterType, value: number }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }>, next_service: Array<{ __typename: 'NextService', service: { __typename: 'ServiceSequenceItem', period: number, period_type: PeriodType, sequence_index: number, counter_in_sequence?: number | null, date_in_sequence?: Date | null, program: { __typename: 'MPProgram', id: string, title: string, multiplier: number } }, remaining: { __typename: 'ServiceRemaining', type: PeriodType, value: number, fraction: number } }>, open_preventive_maintenance_work_orders: Array<{ __typename: 'WorkOrder', id: string, status: WorkOrderStatus, type: { __typename: 'WorkOrderType', id: string, name: string } }>, last_service?: { __typename: 'ServiceReport', id: number, created_at: any, date: Date, date_in_sequence?: Date | null, error_fraction?: number | null, service_type: string, comments?: string | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, program?: { __typename: 'MPProgram', id: string, title: string, description?: string | null, multiplier: number } | null, plan?: { __typename: 'MaintenancePlan', id: number, title: string, base_period: number } | null } | null } | null };

export type GetVehicleByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetVehicleByIdQuery = { __typename: 'Query', getMachineById?: { __typename: 'AuthCheckGetMachineById', item: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type GetVehiclesQueryVariables = Exact<{
  context?: InputMaybe<Context>;
}>;


export type GetVehiclesQuery = { __typename: 'Query', getMachines?: { __typename: 'AuthCheckGetMachines', items: Array<{ __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null> } | { __typename: 'AuthorizationError', message: string } | { __typename: 'ServerError', message: string } | null };

export type AddAssignmentReportMutationVariables = Exact<{
  input: AddAssignmentReportInput;
}>;


export type AddAssignmentReportMutation = { __typename: 'Mutation', addAssignmentReport: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } };

export type DeleteAssignmentReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAssignmentReportMutation = { __typename: 'Mutation', deleteAssignmentReport: number };

export type WorkOrderFieldsFragment = { __typename: 'WorkOrder', id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> };

export type WorkOrderTaskFieldsFragment = { __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null };

export type WorkOrderHoursFieldsFragment = { __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null };

export type WorkOrderWithFilesFieldsFragment = { __typename: 'WorkOrder', comments_draft?: string | null, comments_in_progress?: string | null, comments_to_review?: string | null, comments_to_approve?: string | null, id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, files: Array<{ __typename: 'File', id: string, url: string }>, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> };

export type WorkOrdersTableFieldsFragment = { __typename: 'WorkOrder', id: string, serial_number: number, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, canceled_at?: any | null, title: string, description: string, status: WorkOrderStatus, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, type: { __typename: 'WorkOrderType', id: string, name: string }, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', id: number, name: string, display_name?: string | null, display_type?: string | null, brand: string, model: string, is_archived: boolean, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, project?: { __typename: 'Project', id: number, name: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null };

export type AddWorkOrderMutationVariables = Exact<{
  input: AddWorkOrderInput;
}>;


export type AddWorkOrderMutation = { __typename: 'Mutation', addWorkOrder: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', comments_draft?: string | null, comments_in_progress?: string | null, comments_to_review?: string | null, comments_to_approve?: string | null, id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, files: Array<{ __typename: 'File', id: string, url: string }>, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> } } };

export type UpdateWorkOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateWorkOrderInput;
}>;


export type UpdateWorkOrderMutation = { __typename: 'Mutation', updateWorkOrder: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', comments_draft?: string | null, comments_in_progress?: string | null, comments_to_review?: string | null, comments_to_approve?: string | null, id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, files: Array<{ __typename: 'File', id: string, url: string }>, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> } } };

export type UpdateWorkOrderTagsMutationVariables = Exact<{
  work_order_id: Scalars['ID']['input'];
  tag_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateWorkOrderTagsMutation = { __typename: 'Mutation', updateWorkOrderTags: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', id: string, serial_number: number, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, canceled_at?: any | null, title: string, description: string, status: WorkOrderStatus, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, type: { __typename: 'WorkOrderType', id: string, name: string }, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', id: number, name: string, display_name?: string | null, display_type?: string | null, brand: string, model: string, is_archived: boolean, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, project?: { __typename: 'Project', id: number, name: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null } } };

export type DeleteWorkOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkOrderMutation = { __typename: 'Mutation', deleteWorkOrder: { __typename: 'IDUnionWrapper', value: string } | { __typename: 'NotAllowedError', message: string } };

export type SetWorkOrderStatusInProgressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<SetWorkOrderStatusInProgressInput>;
}>;


export type SetWorkOrderStatusInProgressMutation = { __typename: 'Mutation', setWorkOrderStatusInProgress: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> } } | { __typename: 'WorkOrderStatusChangeError', message: string } };

export type GetWorkOrdersQueryVariables = Exact<{
  context: Context;
  filter?: InputMaybe<FilterWorkOrders>;
  query?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetWorkOrdersQuery = { __typename: 'Query', getWorkOrders: { __typename: 'WorkOrdersConnection', items: Array<{ __typename: 'WorkOrder', id: string, serial_number: number, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, canceled_at?: any | null, title: string, description: string, status: WorkOrderStatus, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, type: { __typename: 'WorkOrderType', id: string, name: string }, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, machine?: { __typename: 'Machine', id: number, name: string, display_name?: string | null, display_type?: string | null, brand: string, model: string, is_archived: boolean, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, project?: { __typename: 'Project', id: number, name: string } | null, company?: { __typename: 'Company', id: number } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, project?: { __typename: 'Project', id: number, name: string } | null }>, page_info: { __typename: 'PageInfo', current_page: number, total_pages: number, total_items: number, items_per_page: number }, facets: Array<{ __typename: 'WorkOrderFacetGroup', field: WorkOrderFacetField, facets: Array<{ __typename: 'Facet', count: number, value: string }> }> } };

export type DownloadWorkOrdersWorkbookQueryVariables = Exact<{
  company_id: Scalars['Int']['input'];
  business_unit_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
}>;


export type DownloadWorkOrdersWorkbookQuery = { __typename: 'Query', downloadWorkOrdersWorkbook: { __typename: 'ServerError', message: string } | { __typename: 'SuccessResult', result?: string | null } };

export type GetWorkOrderByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkOrderByIdQuery = { __typename: 'Query', getWorkOrderById: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', comments_draft?: string | null, comments_in_progress?: string | null, comments_to_review?: string | null, comments_to_approve?: string | null, id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, files: Array<{ __typename: 'File', id: string, url: string }>, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> } } };

export type GetWorkOrdersByMachineIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter?: InputMaybe<FilterWorkOrders>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetWorkOrdersByMachineIdQuery = { __typename: 'Query', getWorkOrdersByMachineId: { __typename: 'WorkOrdersConnection', items: Array<{ __typename: 'WorkOrder', comments_draft?: string | null, comments_in_progress?: string | null, comments_to_review?: string | null, comments_to_approve?: string | null, id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, files: Array<{ __typename: 'File', id: string, url: string }>, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> }> } };

export type GetTagsQueryVariables = Exact<{
  context: Context;
  scope: TagScope;
  query?: InputMaybe<Scalars['String']['input']>;
  include_archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTagsQuery = { __typename: 'Query', getTags: { __typename: 'TagsConnection', edges: Array<{ __typename: 'Tag', id: string, tag: string, is_archived: boolean, color?: TagColor | null, icon?: string | null, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null }> } };

export type GetBilderitTagsQueryVariables = Exact<{
  scope: TagScope;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBilderitTagsQuery = { __typename: 'Query', getTagsManagedByBilderit: { __typename: 'TagsConnection', edges: Array<{ __typename: 'Tag', id: string, tag: string, is_archived: boolean, color?: TagColor | null, icon?: string | null, group?: { __typename: 'TagGroup', id: string, name: string, is_archived: boolean } | null }> } };

export type RegisterWorkOrderTasksMutationVariables = Exact<{
  input: RegisterWorkOrderTasksInput;
}>;


export type RegisterWorkOrderTasksMutation = { __typename: 'Mutation', registerWorkOrderTasks: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> } } };

export type UnregisterWorkOrderTasksMutationVariables = Exact<{
  input: UnregisterWorkOrderTasksInput;
}>;


export type UnregisterWorkOrderTasksMutation = { __typename: 'Mutation', unregisterWorkOrderTasks: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> } } };

export type SetWorkOrderStatusClosedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetWorkOrderStatusClosedMutation = { __typename: 'Mutation', setWorkOrderStatusClosed: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', id: string, serial_number: number, title: string, description: string, status: WorkOrderStatus, created_at: any, updated_at?: any | null, draft_start_date?: any | null, draft_end_date?: any | null, in_progress_start_date?: any | null, in_progress_end_date?: any | null, to_review_start_date?: any | null, to_review_end_date?: any | null, to_approve_start_date?: any | null, to_approve_end_date?: any | null, canceled_at?: any | null, closed_date?: any | null, canceled_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, created_by: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null }, updated_by?: { __typename: 'Employee', first_name: string, last_name: string, full_name?: string | null } | null, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }>, service_report?: { __typename: 'ServiceReport', id: number, service_type: string, comments?: string | null, date_in_sequence?: Date | null, error_fraction?: number | null, program?: { __typename: 'MPProgram', id: string, title: string } | null, counter: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType }, counter_in_sequence?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null } | null, tags: Array<{ __typename: 'Tag', id: string, tag: string, icon?: string | null, color?: TagColor | null, is_archived: boolean }>, type: { __typename: 'WorkOrderType', id: string, name: string }, counter?: { __typename: 'Counter', start?: number | null, end?: number | null, value: number, type: CounterType } | null, machine?: { __typename: 'Machine', id: number, is_archived: boolean, name: string, display_name?: string | null, display_type?: string | null, power: number, weight?: number | null, brand: string, model: string, year: number, owner: string, ownership_type?: OwnershipType | null, ownership_type_other?: string | null, extra_data?: any | null, domain?: string | null, preferred_counter_type: CounterType, fuel_type?: FuelType | null, fuel_participation?: FuelParticipation | null, fuel_capacity?: number | null, last_known_flowmeter?: number | null, last_known_flowmeter_on?: any | null, last_computed_fuel_stock?: number | null, last_computed_fuel_stock_on?: any | null, last_measured_fuel_stock?: number | null, last_measured_fuel_stock_on?: any | null, serial_number?: string | null, engine_number?: string | null, replacement_value: number, last_status: MachineReportStatus, last_status_on: Date, observations?: string | null, next_mp_sequence_index?: number | null, external_source?: { __typename: 'MachineExternalSource', provider: string, sync_status: MachineExternalSyncStatus } | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup, subtype?: string | null, reported_daily: boolean, accepts_usage: boolean, accepts_service: boolean, accepts_oos: boolean, accepts_available: boolean }, last_counters: Array<{ __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType }>, last_counter_from_usage_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, last_counter_from_fuel_report?: { __typename: 'MachineCounter', value: number, datetime: any, source: CounterSource, type: CounterType } | null, counter: { __typename: 'Counter', end?: number | null, start?: number | null, type: CounterType, value: number }, maintenance_plan?: { __typename: 'MaintenancePlan', id: number, title: string, type: MaintenancePlanType, base_period: number, period_type: PeriodType, programs?: Array<{ __typename: 'MPProgram', id: string, title: string, multiplier: number } | null> | null } | null, assigned?: { __typename: 'Employee', id: number, first_name: string, last_name: string, full_name?: string | null, dni: string } | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string, business_unit: { __typename: 'BusinessUnit', id: number, name: string } } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string, telemetry_provider: TmProvider, aemp_provider?: AempProvider | null, counter_offset: number, created_at: any, flespi_id: string, serial_number: string, company: { __typename: 'Company', id: number, name: string }, machine?: { __typename: 'Machine', serial_number?: string | null, preferred_counter_type: CounterType, id: number, is_archived: boolean, name: string, display_name?: string | null, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> } | null }> } | null, project?: { __typename: 'Project', id: number, name: string, slug: string, num_employees: number, client?: string | null, code: string, company: { __typename: 'Company', id: number, name: string, slug: string }, num_machines: Array<{ __typename: 'TotalMachinesGroup', group: MachineGroup, total: number }>, ute?: { __typename: 'UTE', cuit: string, partners?: Array<{ __typename: 'UTEPartner', name: string, percentage: number } | null> | null } | null, business_unit: { __typename: 'BusinessUnit', id: number, name: string, company_id: number, created_at: any, updated_at?: any | null, projects: Array<{ __typename: 'Project', id: number, name: string, is_archived: boolean }> }, location: { __typename: 'Location', lat: number, lon: number } } | null, tasks: Array<{ __typename: 'WorkOrderTask', id: string, compartment: string, item: string, preferred_quantity?: number | null, used_quantity?: number | null, action: string, done: boolean, done_at?: any | null, created_at: any, updated_at?: any | null, preferred_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, used_consumable?: { __typename: 'MachineConsumable', id: number, imported_from_id?: number | null, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null, equivalences: Array<{ __typename: 'MachineConsumable', id: number, manufacturer_code?: string | null, internal_code?: string | null, name: string, brand?: string | null, description?: string | null, unit?: string | null }> } | { __typename: 'StringUnionWrapper', value: string } | null, done_by?: { __typename: 'User', id: number, first_name: string, last_name: string } | null }>, hours: Array<{ __typename: 'WorkOrderHours', id: string, planned_hours?: number | null, executed_hours?: number | null, execution_date?: Date | null, labor_type?: string | null, notes?: string | null, created_at: any, updated_at?: any | null, user?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null, created_by: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> }, updated_by?: { __typename: 'Employee', id: number, is_managed: boolean, first_name: string, last_name: string, full_name?: string | null, username: string, email: string, dni: string, roles: Array<{ __typename: 'Role', id: number, role: RoleNames, project?: { __typename: 'Project', id: number, name: string } | null, business_unit?: { __typename: 'BusinessUnit', id: number, name: string } | null, company?: { __typename: 'Company', id: number, name: string } | null } | null> } | null }> } } | { __typename: 'WorkOrderStatusChangeError', message: string } };

export type AssignWorkOrderMutationVariables = Exact<{
  input: AssignWorkOrderInput;
}>;


export type AssignWorkOrderMutation = { __typename: 'Mutation', assignWorkOrder: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', id: string, assigned: Array<{ __typename: 'Employee', id: number, dni: string, email: string, first_name: string, last_name: string, full_name?: string | null }> } } };

export type CancelWorkOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelWorkOrderMutation = { __typename: 'Mutation', cancelWorkOrder: { __typename: 'ItemWorkOrder', item: { __typename: 'WorkOrder', id: string, status: WorkOrderStatus } } | { __typename: 'NotAllowedError', message: string } };

export type MachineKpiEntryFieldsFragment = { __typename: 'MachineKpiEntry', machine: { __typename: 'Machine', last_status: MachineReportStatus, last_status_on: Date, brand: string, ownership_type?: OwnershipType | null, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, kpis: { __typename: 'MaintenanceKpiGroup', backlogOtHours?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanPeriodBetweenFailures?: Array<{ __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null, meanServiceDeviation?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanTimeToRepair?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, mechanicalAvailability?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, plannedMaintenancePercentage?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null } };

export type MaintenanceMetricResultFieldsFragment = { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null };

export type MaintenanceKpiGroupFieldsFragment = { __typename: 'MaintenanceKpiGroup', backlogOtHours?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanPeriodBetweenFailures?: Array<{ __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null, meanServiceDeviation?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanTimeToRepair?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, mechanicalAvailability?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, plannedMaintenancePercentage?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null };

export type GetWorkOrdersDashboardQueryVariables = Exact<{
  context: Context;
  month: Scalars['String']['input'];
  excludeMachineIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  pagination?: InputMaybe<FilterPagination>;
}>;


export type GetWorkOrdersDashboardQuery = { __typename: 'Query', maintenanceDashboardMetrics: { __typename: 'MaintenanceDashboardMetrics', lastRefreshedAt?: any | null, current: { __typename: 'MaintenanceDashboardSnapshot', global: { __typename: 'MaintenanceKpiGroup', backlogOtHours?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanPeriodBetweenFailures?: Array<{ __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null, meanServiceDeviation?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanTimeToRepair?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, mechanicalAvailability?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, plannedMaintenancePercentage?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null }, byMachine: Array<{ __typename: 'MachineKpiEntry', machine: { __typename: 'Machine', last_status: MachineReportStatus, last_status_on: Date, brand: string, ownership_type?: OwnershipType | null, id: number, is_archived: boolean, name: string, display_name?: string | null, type: { __typename: 'MachineType', id: number, type: string, group: MachineGroup }, company?: { __typename: 'Company', id: number } | null, project?: { __typename: 'Project', id: number, name: string } | null, bilderit_connect_devices: Array<{ __typename: 'BilderitConnectDevice', id: string }> }, kpis: { __typename: 'MaintenanceKpiGroup', backlogOtHours?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanPeriodBetweenFailures?: Array<{ __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null, meanServiceDeviation?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanTimeToRepair?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, mechanicalAvailability?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, plannedMaintenancePercentage?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null } }>, page_info: { __typename: 'PageInfo', total_pages: number, current_page: number, total_items: number, items_per_page: number } }, history: Array<{ __typename: 'MaintenanceDashboardSnapshot', month: string, global: { __typename: 'MaintenanceKpiGroup', backlogOtHours?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanPeriodBetweenFailures?: Array<{ __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null }> | null, meanServiceDeviation?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, meanTimeToRepair?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, mechanicalAvailability?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null, plannedMaintenancePercentage?: { __typename: 'MaintenanceMetricResult', target?: number | null, unit: string, value?: number | null, metadata?: any | null, calculationContext?: { __typename: 'CalculationContext', usedLastNDays?: number | null, usedLastNReports?: number | null, startDate?: any | null, endDate?: any | null } | null } | null } }> } };

export type RefreshMaintenanceKpiSnapshotMutationVariables = Exact<{
  context: Context;
  month: Scalars['String']['input'];
}>;


export type RefreshMaintenanceKpiSnapshotMutation = { __typename: 'Mutation', refreshMaintenanceKpiSnapshot: { __typename: 'MaintenanceKpiRefreshResult', success: boolean, refreshedAt: any, machineCount: number, durationMs: number } };

export type PushTopicPreferenceFieldsFragment = { __typename: 'PushTopicPreference', topic: string, company_id: string, project_id?: string | null };

export type PushSubscriptionFieldsFragment = { __typename: 'PushSubscription', endpoint: string };

export type NotificationPreferencesFieldsFragment = { __typename: 'NotificationPreferences', optedOutTopics: Array<string>, topics: Array<{ __typename: 'PushTopicPreference', topic: string, company_id: string, project_id?: string | null }> };

export type GetPushConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPushConfigQuery = { __typename: 'Query', getPushConfig: { __typename: 'PushConfig', vapidPublicKey: string } };

export type GetMyNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyNotificationPreferencesQuery = { __typename: 'Query', getMyNotificationPreferences: { __typename: 'NotificationPreferences', optedOutTopics: Array<string>, topics: Array<{ __typename: 'PushTopicPreference', topic: string, company_id: string, project_id?: string | null }> } };

export type RegisterPushSubscriptionMutationVariables = Exact<{
  input: RegisterPushSubscriptionInput;
}>;


export type RegisterPushSubscriptionMutation = { __typename: 'Mutation', registerPushSubscription: { __typename: 'PushSubscription', endpoint: string } };

export type UnregisterPushSubscriptionMutationVariables = Exact<{
  endpoint: Scalars['String']['input'];
}>;


export type UnregisterPushSubscriptionMutation = { __typename: 'Mutation', unregisterPushSubscription: boolean };

export type SetNotificationPreferencesMutationVariables = Exact<{
  topics: Array<PushTopicPreferenceInput> | PushTopicPreferenceInput;
}>;


export type SetNotificationPreferencesMutation = { __typename: 'Mutation', setNotificationPreferences: { __typename: 'NotificationPreferences', optedOutTopics: Array<string>, topics: Array<{ __typename: 'PushTopicPreference', topic: string, company_id: string, project_id?: string | null }> } };

export type SetNotificationOptOutMutationVariables = Exact<{
  topic: Scalars['String']['input'];
  optedOut: Scalars['Boolean']['input'];
}>;


export type SetNotificationOptOutMutation = { __typename: 'Mutation', setNotificationOptOut: boolean };

export type SendTestPushNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type SendTestPushNotificationMutation = { __typename: 'Mutation', sendTestPushNotification: number };

export const RoleFieldsForUseProjectOptionsFragmentDoc = gql`
    fragment RoleFieldsForUseProjectOptions on Role {
  id
  role
  label @client
  company {
    id
    name
    slug
    modules_enabled {
      module_id
      end_date
    }
    projects {
      id
      name
      slug
      business_unit {
        id
        name
        slug
      }
    }
  }
  business_unit {
    id
    name
    slug
  }
  project {
    id
    name
    slug
    business_unit {
      id
      name
      slug
    }
  }
}
    `;
export const AiAnalysisItemFieldsFragmentDoc = gql`
    fragment AiAnalysisItemFields on MachineNoticeAnalysisItem {
  description
  id_of_first_occurrence
  date_of_first_occurrence
  number_of_occurrences
}
    `;
export const MachineNoticesAnalysisItemFieldsFragmentDoc = gql`
    fragment MachineNoticesAnalysisItemFields on MachineNoticesAnalysisItem {
  machine_id
  machine_name
  recurring_issues {
    ...AiAnalysisItemFields
  }
  notable_notices {
    ...AiAnalysisItemFields
  }
}
    ${AiAnalysisItemFieldsFragmentDoc}`;
export const ReportSubscriptionFieldsFragmentDoc = gql`
    fragment ReportSubscriptionFields on BilderitReportSubscription {
  id
  company {
    id
    name
  }
  project {
    id
    name
  }
  report_type
  email
  created_by
}
    `;
export const CompanyLogoFieldsFragmentDoc = gql`
    fragment CompanyLogoFields on Company {
  logo_url
}
    `;
export const ProjectStatsFieldsFragmentDoc = gql`
    fragment ProjectStatsFields on ProjectStats {
  project {
    id
    name
  }
  num_employees
  num_machines @client
  reports_stats {
    num_oos
    num_worked
    num_available
    num_pending
    total_fuel
    total_gasoline
    total_diesel
    total_counters {
      type
      value
    }
    specific_consumption_hp
    specific_consumption
  }
  machines_stats {
    num_vehicles
    num_trucks
    num_heavy_equipments
    num_fixed_assets
    average_age
    total_replacement_value
    total_rental_value
  }
  daily_stats {
    date
    fuel
    gasoline
    diesel
    pending
    worked
    oos
    available
    total_counters {
      type
      value
    }
  }
}
    `;
export const OtherProjectsStatsFieldsFragmentDoc = gql`
    fragment OtherProjectsStatsFields on OtherProjectsStats {
  num_projects
  num_employees
  num_machines @client
  reports_stats {
    num_oos
    num_worked
    num_available
    num_pending
    total_fuel
    total_gasoline
    total_diesel
    total_counters {
      type
      value
    }
    specific_consumption_hp
    specific_consumption
  }
  machines_stats {
    num_vehicles
    num_trucks
    num_heavy_equipments
    num_fixed_assets
    average_age
    total_replacement_value
    total_rental_value
  }
  daily_stats {
    date
    fuel
    gasoline
    diesel
    pending
    worked
    oos
    available
    total_counters {
      type
      value
    }
  }
}
    `;
export const InvitationFieldsFragmentDoc = gql`
    fragment InvitationFields on Invitation {
  invitationId: id
  label @client
  email
  link
  role
  company {
    id
    name
  }
  project {
    id
    name
  }
  business_unit {
    id
    name
  }
}
    `;
export const MyUserDataFragmentDoc = gql`
    fragment MyUserData on Me {
  id
  first_name
  last_name
  dni
  username
  birthday
  email
  phone
  address
  cuil
  gender
  can_create_company
  is_managed
  identity_claim {
    requested_email
    kind
  }
  incoming_merge {
    company_name
    managed_username
  }
  pending_email
  roles {
    id
    role
    label @client
    company {
      id
      name
      slug
      logo_url
      modules_enabled {
        module_id
        end_date
      }
    }
    business_unit {
      id
      name
      slug
    }
    project {
      id
      name
      slug
      business_unit {
        id
      }
    }
  }
  invitations {
    id
    ...InvitationFields
  }
  identifier_hash
}
    ${InvitationFieldsFragmentDoc}`;
export const MachineLinkFieldsFragmentDoc = gql`
    fragment MachineLinkFields on Machine {
  id
  company {
    id
  }
  project {
    id
    name
  }
  is_archived
  name
  display_name @client
  bilderit_connect_devices {
    id
  }
}
    `;
export const ChecklistResultFieldsFragmentDoc = gql`
    fragment ChecklistResultFields on Checklist {
  id
  serial_number
  completed_date
  template_id
  template_title
  version_number
  project_id
  pass_count
  fail_count
  na_count
  closing_note
  counter {
    value
    type
  }
  location {
    latitude
    longitude
  }
  project {
    id
    name
  }
  created_by {
    id
    first_name
    last_name
  }
  machine {
    ...MachineLinkFields
  }
}
    ${MachineLinkFieldsFragmentDoc}`;
export const ChecklistTemplateItemFieldsFragmentDoc = gql`
    fragment ChecklistTemplateItemFields on ChecklistTemplateItem {
  id
  item_key
  position
  section
  label
  description
  item_type
  requirement
  unit
  criteria
  fail_severity
}
    `;
export const ChecklistTemplateFieldsFragmentDoc = gql`
    fragment ChecklistTemplateFields on ChecklistTemplate {
  id
  company_id
  title
  description
  status
  current_version {
    id
    version_number
    published_at
    counter_requirement
    items {
      ...ChecklistTemplateItemFields
    }
  }
  draft {
    id
    version_number
    published_at
    counter_requirement
    items {
      ...ChecklistTemplateItemFields
    }
  }
  assignment_rules {
    id
    scope_type
    target_id
    machine_group
    target_name
  }
  created_at
  updated_at
  archived_at
}
    ${ChecklistTemplateItemFieldsFragmentDoc}`;
export const ChecklistListFieldsFragmentDoc = gql`
    fragment ChecklistListFields on Checklist {
  id
  serial_number
  machine_id
  template_id
  template_title
  version_number
  completed_at
  completed_date
  pass_count
  fail_count
  na_count
  created_at
  created_by {
    id
    first_name
    last_name
  }
  machine {
    id
    name
  }
}
    `;
export const ChecklistFillTemplateItemFieldsFragmentDoc = gql`
    fragment ChecklistFillTemplateItemFields on AvailableChecklistTemplateItem {
  id
  item_key
  position
  section
  label
  description
  item_type
  requirement
  unit
  choice_options {
    key
    label
  }
}
    `;
export const ChecklistFillTemplateFieldsFragmentDoc = gql`
    fragment ChecklistFillTemplateFields on AvailableChecklistTemplate {
  id
  title
  current_version {
    id
    version_number
    counter_requirement
    items {
      ...ChecklistFillTemplateItemFields
    }
  }
}
    ${ChecklistFillTemplateItemFieldsFragmentDoc}`;
export const ChecklistItemViewFieldsFragmentDoc = gql`
    fragment ChecklistItemViewFields on ChecklistItem {
  id
  position
  section
  label
  item_type
  requirement
  unit
  is_ad_hoc
  value_number
  value_text
  value_date
  value_choice_key
  value_choice_label
  result
  result_severity
  na_reason
  observation
  fail_streak
  criteria_snapshot
  photos {
    id
    url
  }
  notice {
    id
    serial_number
    status
    severity
    linked_work_order {
      id
      serial_number
    }
  }
}
    `;
export const ChecklistDetailFieldsFragmentDoc = gql`
    fragment ChecklistDetailFields on Checklist {
  id
  serial_number
  machine_id
  template_id
  template_title
  version_number
  started_at
  completed_at
  completed_date
  closing_note
  counter {
    type
    value
  }
  location {
    latitude
    longitude
    accuracy_m
  }
  pass_count
  fail_count
  na_count
  created_at
  created_by {
    id
    first_name
    last_name
  }
  machine {
    id
    name
    company {
      id
    }
  }
  project {
    id
    name
  }
  items {
    ...ChecklistItemViewFields
  }
}
    ${ChecklistItemViewFieldsFragmentDoc}`;
export const DocumentFieldsFragmentDoc = gql`
    fragment DocumentFields on Document {
  id
  name
  scope
  is_current
  files {
    id
    url
  }
  expiration_date
  superseded_by
  tags {
    id
    tag
    icon
    color
    is_archived
  }
  machine {
    ...MachineLinkFields
    brand
    model
    domain
    last_status
    type {
      id
      type
      group
    }
    project {
      id
      name
      business_unit {
        id
        name
      }
    }
  }
  user {
    id
    first_name
    last_name
    dni
  }
  project {
    id
    name
  }
}
    ${MachineLinkFieldsFragmentDoc}`;
export const TanksDashboardFieldsFragmentDoc = gql`
    fragment TanksDashboardFields on TanksDashboardTankItem {
  tank {
    ...MachineLinkFields
    project {
      business_unit {
        id
        name
      }
    }
    fuel_participation
    fuel_capacity
  }
  initial_stock
  final_stock
  avg_stock
  liters_in
  liters_in_from_providers
  liters_in_from_tanks
  liters_out
  liters_out_to_consumers
  liters_out_to_tanks
  measured_error
  project_ids_in_period
  kpis {
    stock_deviation {
      deviation_percentage
      dispatched_liters
      deviation_liters
      control_frequency
    }
    verified_dispatches {
      verified_dispatches
      total_dispatches
      verified_percentage
    }
    average_rotation {
      rotation_days
      average_stock
      max_stock
      min_stock
      average_consumption
    }
    traceability {
      consistency_score
      flowmeter_advance
      report_liters
      traced_liters
      untraced_liters
      surplus_liters
      non_traceable_liters
      non_totalizing_tank_count
      totalizing_tank_count
    }
  }
}
    ${MachineLinkFieldsFragmentDoc}`;
export const MachinesFuelDashboardFieldsFragmentDoc = gql`
    fragment MachinesFuelDashboardFields on MachinesFuelDashboardItem {
  machine {
    ...MachineLinkFields
    id
    name
    brand
    model
    type {
      id
      type
      group
    }
    display_name @client
    display_type @client
    preferred_counter_type
    power
    bilderit_connect_devices {
      id
      telemetry_provider
    }
    company {
      id
    }
  }
  total_fuel_in
  total_counter
  telemetry_fuel_consumed
}
    ${MachineLinkFieldsFragmentDoc}`;
export const ProjectsFuelDashboardFieldsFragmentDoc = gql`
    fragment ProjectsFuelDashboardFields on ProjectsFuelDashboardItem {
  project {
    id
    name
    business_unit {
      id
      name
    }
  }
  initial_stock
  final_stock
  measured_error
  outflow_dispatch_count
  outflow_internal_consumption
  outflow_to_other_projects
  outflow_to_other_business_units
  inflow_from_providers
  inflow_from_other_projects
  inflow_from_other_business_units
  internal_transfers
  direct_consumption_from_providers
  direct_consumption_from_other_projects
  direct_consumption_from_other_business_units
  relocation_stock_in
  relocation_stock_out
  effective_fuel_cost
  effective_fuel_cost_source
  consumption_liters_for_cost
  consumption_cost
}
    `;
export const MachineCounterFieldsFragmentDoc = gql`
    fragment MachineCounterFields on MachineCounter {
  value
  datetime
  source
  type
}
    `;
export const BilderitConnectDeviceFieldsFragmentDoc = gql`
    fragment BilderitConnectDeviceFields on BilderitConnectDevice {
  id
  telemetry_provider
  aemp_provider
  company {
    id
    name
  }
  counter_offset
  created_at
  flespi_id
  serial_number
  machine {
    ...MachineLinkFields
    serial_number
    preferred_counter_type
  }
}
    ${MachineLinkFieldsFragmentDoc}`;
export const MachineFieldsFragmentDoc = gql`
    fragment MachineFields on Machine {
  id
  is_archived
  name
  external_source {
    provider
    sync_status
  }
  display_name @client
  display_type @client
  type {
    __typename
    id
    type
    group
    subtype
    reported_daily
    accepts_usage
    accepts_service
    accepts_oos
    accepts_available
  }
  power
  weight
  brand
  model
  year
  owner
  ownership_type
  ownership_type_other
  extra_data
  domain
  preferred_counter_type
  last_counters {
    ...MachineCounterFields
  }
  last_counter_from_usage_report @client {
    ...MachineCounterFields
  }
  last_counter_from_fuel_report @client {
    ...MachineCounterFields
  }
  counter {
    end
    start
    type
    value
  }
  fuel_type
  fuel_participation
  fuel_capacity
  last_known_flowmeter
  last_known_flowmeter_on
  last_computed_fuel_stock
  last_computed_fuel_stock_on
  last_measured_fuel_stock
  last_measured_fuel_stock_on
  serial_number
  engine_number
  replacement_value
  last_status
  last_status_on
  observations
  maintenance_plan {
    id
    title
    type
    base_period
    period_type
    programs {
      id
      title
      multiplier
    }
  }
  assigned {
    __typename
    id
    first_name
    last_name
    full_name @client
    dni
  }
  company {
    id
  }
  project {
    id
    name
    business_unit {
      id
      name
    }
  }
  next_mp_sequence_index
  bilderit_connect_devices {
    ...BilderitConnectDeviceFields
  }
}
    ${MachineCounterFieldsFragmentDoc}
${BilderitConnectDeviceFieldsFragmentDoc}`;
export const FuelProviderFieldsFragmentDoc = gql`
    fragment FuelProviderFields on FuelProvider {
  id
  name
  comments
  created_at
  updated_at
  last_known_flowmeter @client
  company {
    id
    name
  }
}
    `;
export const CounterFieldsFragmentDoc = gql`
    fragment CounterFields on Counter {
  start
  end
  value
  type
}
    `;
export const FuelDispatchReportFieldsFragmentDoc = gql`
    fragment FuelDispatchReportFields on FuelDispatchedReport {
  id
  datetime
  flowmeter_start
  flowmeter_end
  fuel_type
  source {
    ...MachineFields
    project {
      id
      name
      code
    }
  }
  provider {
    ...FuelProviderFields
  }
  source_stock {
    start
    end
  }
  destination {
    ...MachineFields
    project {
      id
      name
      code
    }
  }
  destination_counter {
    ...CounterFields
  }
  prev_destination_counter {
    ...CounterFields
  }
  destination_stock {
    start
    end
  }
  source_project {
    __typename
    id
    name
  }
  destination_project {
    __typename
    id
    name
  }
  observations
  created_by {
    id
    first_name
    last_name
  }
  verified_by {
    id
    first_name
    last_name
  }
}
    ${MachineFieldsFragmentDoc}
${FuelProviderFieldsFragmentDoc}
${CounterFieldsFragmentDoc}`;
export const FuelDispatchReportForTableFieldsFragmentDoc = gql`
    fragment FuelDispatchReportForTableFields on FuelDispatchedReport {
  id
  datetime
  flowmeter_start
  flowmeter_end
  fuel_type
  provider {
    id
    name
  }
  source {
    ...MachineLinkFields
    fuel_participation
    fuel_capacity
    type {
      id
      group
      type
    }
  }
  destination {
    ...MachineLinkFields
    fuel_participation
    fuel_capacity
    fuel_type
    type {
      id
      group
      type
    }
  }
  source_stock {
    start
    end
  }
  destination_counter {
    ...CounterFields
  }
  prev_destination_counter {
    ...CounterFields
  }
  destination_stock {
    start
    end
  }
  source_project {
    __typename
    id
    name
    code
    business_unit {
      id
      name
    }
  }
  destination_project {
    __typename
    id
    name
    code
    business_unit {
      id
      name
    }
  }
  observations
  created_by {
    id
    first_name
    last_name
  }
  verified_by {
    id
    first_name
    last_name
  }
}
    ${MachineLinkFieldsFragmentDoc}
${CounterFieldsFragmentDoc}`;
export const StockControlReportFieldsFragmentDoc = gql`
    fragment StockControlReportFields on StockControlReport {
  id
  datetime
  stock_measured
  stock_computed
  tank {
    ...MachineFields
  }
  observations
  created_by {
    id
    first_name
    last_name
  }
}
    ${MachineFieldsFragmentDoc}`;
export const MachineNoticeFieldsFragmentDoc = gql`
    fragment MachineNoticeFields on MachineNotice {
  id
  serial_number
  created_at
  status
  severity
  message
  counter {
    type
    value
    start
    end
  }
  tags {
    id
    tag
    icon
    color
    is_archived
  }
  resolution_note
  resolved_on
  cancelled_on
  source_type
  source_usage_report_id
  source_checklist_id
  machine {
    id
    name
    company {
      id
    }
    project {
      id
      name
      business_unit {
        id
        name
      }
    }
  }
  business_unit {
    id
    name
  }
  project {
    id
    name
  }
  creator {
    id
    first_name
    last_name
  }
  resolved_by {
    id
    first_name
    last_name
  }
  cancelled_by {
    id
    first_name
    last_name
  }
  files {
    id
    url
  }
  evidence_files {
    id
    url
  }
  linked_work_order {
    id
    serial_number
    status
    title
    type {
      id
      name
    }
  }
}
    `;
export const MachinePickerFieldsFragmentDoc = gql`
    fragment MachinePickerFields on Machine {
  id
  name
  domain
  serial_number
  preferred_counter_type
  fuel_type
  fuel_participation
  fuel_capacity
  last_known_flowmeter
  type {
    __typename
    id
    type
    group
    accepts_usage
  }
  company {
    __typename
    id
  }
  project {
    __typename
    id
  }
  last_counters {
    ...MachineCounterFields
  }
  last_counter_from_usage_report @client {
    ...MachineCounterFields
  }
  last_counter_from_fuel_report @client {
    ...MachineCounterFields
  }
  maintenance_plan {
    id
    title
    type
    base_period
    period_type
    programs {
      id
      title
      multiplier
    }
  }
}
    ${MachineCounterFieldsFragmentDoc}`;
export const MachineExtraDataFieldsFragmentDoc = gql`
    fragment MachineExtraDataFields on CompanyMachineExtraData {
  id
  created_at
  updated_at
  machine_group
  field_name
  field_type
  unit
  is_required
}
    `;
export const MachineTypeFieldsFragmentDoc = gql`
    fragment MachineTypeFields on MachineType {
  id
  type
  group
}
    `;
export const MachineHistoryServiceReportFieldsFragmentDoc = gql`
    fragment MachineHistoryServiceReportFields on ServiceReport {
  id
  service_type
  comments
  counter {
    ...CounterFields
  }
  counter_in_sequence {
    ...CounterFields
  }
  date_in_sequence
  error_fraction
  date
  program {
    id
    title
  }
}
    ${CounterFieldsFragmentDoc}`;
export const ConsumableFieldsFragmentDoc = gql`
    fragment ConsumableFields on MachineConsumable {
  id
  imported_from_id
  manufacturer_code
  internal_code
  name
  brand
  description
  unit
  equivalences {
    id
    manufacturer_code
    internal_code
    name
    brand
    description
    unit
  }
}
    `;
export const MachinePartFieldsFragmentDoc = gql`
    fragment MachinePartFields on MachinePart {
  id
  name
  compartment
  default_consumable {
    ...ConsumableFields
  }
}
    ${ConsumableFieldsFragmentDoc}`;
export const MaintenanceProgramFieldsFragmentDoc = gql`
    fragment MaintenanceProgramFields on MPProgram {
  id
  title
  description
  multiplier
  actions {
    id
    machine_part {
      ...MachinePartFields
    }
    action
    description
    consumable_quantity
    consumable_override {
      ...ConsumableFields
    }
  }
}
    ${MachinePartFieldsFragmentDoc}
${ConsumableFieldsFragmentDoc}`;
export const MaintenancePlanFieldsFragmentDoc = gql`
    fragment MaintenancePlanFields on MaintenancePlan {
  id
  title
  description
  type
  base_period
  period_type
  status
  imported_from_id
  imported_by {
    id
    name
  }
  assigned_to {
    ...MachineLinkFields
  }
  machine_parts {
    ...MachinePartFields
  }
  programs {
    ...MaintenanceProgramFields
  }
  type_tags {
    id
    tag
    icon
    color
    is_archived
  }
  brand_tags {
    id
    tag
    icon
    color
    is_archived
  }
  tags {
    id
    tag
    icon
    color
    is_archived
  }
  num_machines
  created {
    by {
      id
      first_name
      last_name
    }
    at
  }
  modified {
    by {
      id
      first_name
      last_name
    }
    at
  }
  owner {
    id
    name
  }
}
    ${MachineLinkFieldsFragmentDoc}
${MachinePartFieldsFragmentDoc}
${MaintenanceProgramFieldsFragmentDoc}`;
export const MaintenancePlanTableFieldsFragmentDoc = gql`
    fragment MaintenancePlanTableFields on MaintenancePlan {
  id
  title
  type
  status
  imported_from_id
  imported_by {
    id
    name
  }
  assigned_to {
    ...MachineLinkFields
    type {
      id
      type
    }
  }
  programs {
    id
  }
  type_tags {
    id
    tag
    icon
    color
    is_archived
  }
  brand_tags {
    id
    tag
    icon
    color
    is_archived
  }
  tags {
    id
    tag
    icon
    color
    is_archived
  }
  num_machines
  created {
    by {
      id
      first_name
      last_name
    }
    at
  }
}
    ${MachineLinkFieldsFragmentDoc}`;
export const MaintenancePlanTypeaheadFieldsFragmentDoc = gql`
    fragment MaintenancePlanTypeaheadFields on MaintenancePlan {
  id
  title
  type
  type_tags {
    id
    tag
    icon
    color
    is_archived
  }
  brand_tags {
    id
    tag
    icon
    color
    is_archived
  }
  tags {
    id
    tag
    icon
    color
    is_archived
  }
  period_type
  base_period
  programs {
    id
    title
    multiplier
  }
  owner {
    name
  }
}
    `;
export const ActivitySummaryFieldsFragmentDoc = gql`
    fragment ActivitySummaryFields on ActivitySummary {
  usage_hours_reported
  fuel_dispatched
  wos_completed
  wos_in_progress
}
    `;
export const ActivityFieldsFragmentDoc = gql`
    fragment ActivityFields on Activity {
  ... on DailyUsageActivity {
    datetime
    report {
      date
      machine_report_id
      usage_report_id
      daily_machine: machine {
        id
        name
        type {
          id
          group
          type
        }
      }
      project {
        id
        name
      }
      counter_start
      counter_end
      counter_type
    }
  }
  ... on FuelDispatchActivity {
    datetime
    report {
      id
      datetime
      provider {
        id
        name
      }
      source {
        id
        name
      }
      destination {
        id
        name
        fuel_type
      }
      flowmeter_start
      flowmeter_end
    }
  }
  ... on StockControlActivity {
    datetime
    report {
      id
      datetime
      tank {
        id
        name
      }
      stock_computed
      stock_measured
    }
  }
  ... on WorkOrderActivity {
    datetime
    report {
      id
      title
      description
      in_progress_end_date
      serial_number
      type {
        id
        name
      }
      status
      machine {
        id
        name
        type {
          id
          group
          type
        }
      }
    }
  }
}
    `;
export const RecentActivityFieldsFragmentDoc = gql`
    fragment RecentActivityFields on RecentActivity {
  today {
    ...ActivitySummaryFields
  }
  last_week {
    ...ActivitySummaryFields
  }
  last_month {
    ...ActivitySummaryFields
  }
  latest_reports {
    ...ActivityFields
  }
}
    ${ActivitySummaryFieldsFragmentDoc}
${ActivityFieldsFragmentDoc}`;
export const MyDocumentFieldsFragmentDoc = gql`
    fragment MyDocumentFields on Document {
  id
  name
  scope
  expiration_date
  is_current
  files {
    id
    url
  }
}
    `;
export const CounterValueFieldsFragmentDoc = gql`
    fragment CounterValueFields on CounterValue {
  value
  datetime
  source
  type
}
    `;
export const MachineRentalRowFieldsFragmentDoc = gql`
    fragment MachineRentalRowFields on MachineRental {
  machine {
    ...MachineLinkFields
    type {
      id
      group
      type
      subtype
    }
    owner
    ownership_type
    ownership_type_other
    replacement_value
    preferred_counter_type
  }
  rental_parameters
  resolved_counters {
    initial {
      ...CounterValueFields
    }
    initial_candidates {
      ...CounterValueFields
    }
    final {
      ...CounterValueFields
    }
    final_candidates {
      ...CounterValueFields
    }
  }
  min_hours_to_bill
  hours_worked
  regular_hours_to_bill
  extra_hours_to_bill
  billing_type
  km_traveled
  days_in_project
  days_to_charge
  availability_coefficient
  oos_days_due_to_equipment
  oos_days_due_to_project
  monthly_reference_amount
  variable_amount
  fixed_amount
  total_amount
  currency
  certification_item_ref
}
    ${MachineLinkFieldsFragmentDoc}
${CounterValueFieldsFragmentDoc}`;
export const RentalCertificationFieldsFragmentDoc = gql`
    fragment RentalCertificationFields on RentalCertification {
  id
  serial_number
  project_id
  company_id
  month
  ownership_group
  vendor_filter
  status
  total_amount
  currency
  created_at
  created_by {
    id
    first_name
    last_name
    email
  }
  updated_at
  project_name
  company_name
  item_count
  eligible_machine_count
  comments {
    id
    certification_id
    user {
      id
      first_name
      last_name
      email
    }
    action
    comment
    created_at
  }
  approval_records {
    reviewer {
      id
      first_name
      last_name
      email
    }
    status
    comment
    responded_at
  }
}
    `;
export const RentalCertificationHistoryFieldsFragmentDoc = gql`
    fragment RentalCertificationHistoryFields on RentalCertification {
  ...RentalCertificationFields
}
    ${RentalCertificationFieldsFragmentDoc}`;
export const CertificationCopyRecipientFieldsFragmentDoc = gql`
    fragment CertificationCopyRecipientFields on CertificationCopyRecipient {
  id
  email
  company_id
  project_id
  created_at
}
    `;
export const RentalCertificationItemSnapshotFieldsFragmentDoc = gql`
    fragment RentalCertificationItemSnapshotFields on RentalCertificationItemSnapshot {
  id
  certification_id
  machine {
    ...MachineLinkFields
  }
  project_id
  month
  machine_name_snapshot
  machine_owner_snapshot
  machine_group_snapshot
  machine_type_snapshot
  machine_subtype_snapshot
  machine_year_snapshot
  machine_replacement_value_snapshot
  machine_preferred_counter_type_snapshot
  machine_replacement_value_snapshot
  company_id
  company_name_snapshot
  project_name_snapshot
  machine_ownership_type_snapshot
  hours_worked
  km_traveled
  min_hours_to_bill
  counter_start
  counter_end
  days_in_project
  days_to_charge
  days_oos_due_to_equipment
  days_oos_due_to_project
  fixed_amount
  variable_amount
  total_amount
  monthly_reference_amount
  billing_type
  currency
  is_underutilized
  underutilized_amount
  rental_params {
    DEMERIT_COEF_00_04
    DEMERIT_COEF_05_09
    DEMERIT_COEF_10_14
    DEMERIT_COEF_15_19
    DEMERIT_COEF_20_PLUS
    RENTAL_COEF_FIXED_PCT
    RENTAL_COEF_VARIABLE_PCT
    MIN_HOURS
    TARIFF_HOURS_BASE
    EXTRA_HOURS_THRESHOLD
    EXTRA_HOURS_MULTIPLIER
    BILLING_TYPE
    REPLACEMENT_VALUE_USD
    ADDITIONAL_FIXED_AMOUNT_USD
    ADJUSTMENT_PRICE_MULTIPLIER
    INITIAL_HOURS_SOURCE
    LAST_HOURS_SOURCE
    INITIAL_HOURS_OVERRIDE
    LAST_HOURS_OVERRIDE
    TOTAL_DAYS_OVERRIDE
    RENTAL_VALUE_OVERRIDE_USD
  }
  created_at
}
    ${MachineLinkFieldsFragmentDoc}`;
export const ErrorFieldsFragmentDoc = gql`
    fragment ErrorFields on Error {
  message
}
    `;
export const OutOfServiceReportFieldsFragmentDoc = gql`
    fragment OutOfServiceReportFields on OutOfServiceReport {
  id
  creator {
    id
    first_name
    last_name
  }
  modifier {
    id
    first_name
    last_name
  }
  cause
  counter {
    type
    value
    start
    end
  }
  charge_type
}
    `;
export const DailyReportFieldsFragmentDoc = gql`
    fragment DailyReportFields on DailyReport {
  __typename
  id
  date
  status
  project {
    __typename
    id
    name
  }
  machine {
    __typename
    ...MachineLinkFields
    id
    name
    display_name @client
    last_status
    last_status_on
    domain
    preferred_counter_type
    counter {
      ...CounterFields
    }
    last_counters {
      ...MachineCounterFields
    }
    last_counter_from_usage_report @client {
      ...MachineCounterFields
    }
    type {
      __typename
      id
      type
      group
      subtype
      reported_daily
      accepts_usage
      accepts_service
      accepts_oos
      accepts_available
    }
    bilderit_connect_devices {
      id
      telemetry_provider
    }
  }
  usage_reports {
    __typename
    id
    creator {
      __typename
      id
      first_name
      last_name
    }
    modifier {
      __typename
      id
      first_name
      last_name
    }
    created_at
    updated_at
    counter {
      ...CounterFields
    }
    cost_center {
      id
      name
    }
    grease
    filters
    fuel
    motor_oil
    comments
    tasks
    cost_center_id
    cost_center {
      id
      name
      project_id
    }
  }
  total_counters {
    ...CounterFields
  }
  total_counters_display @client
  total_fuel @client
  total_oil @client
  creators @client {
    __typename
    id
    first_name
    last_name
  }
  has_grease @client
  has_filters @client
  has_comments @client
  has_tasks @client
  out_of_service_report {
    ...OutOfServiceReportFields
  }
  available_report {
    id
    creator {
      id
      first_name
      last_name
    }
    modifier {
      id
      first_name
      last_name
    }
    created_at
    updated_at
    observation
  }
}
    ${MachineLinkFieldsFragmentDoc}
${CounterFieldsFragmentDoc}
${MachineCounterFieldsFragmentDoc}
${OutOfServiceReportFieldsFragmentDoc}`;
export const DailyReportByDayStatsFieldsFragmentDoc = gql`
    fragment DailyReportByDayStatsFields on DailyReportByDayStats {
  num_machines
  num_worked_machines
  num_out_of_service_machines
  num_pending_machines
  num_available_machines
  num_greases
  total_fuel
  stats_by_counter_type {
    type
    total_counter
    total_fuel
  }
}
    `;
export const DailyReportByMachineIdStatsFieldsFragmentDoc = gql`
    fragment DailyReportByMachineIdStatsFields on DailyReportByMachineIdStats {
  num_greases
  total_counters {
    type
    value
  }
  total_fuel
  num_worked_days
  num_oos_days
  num_pending_days
  num_available_days
  total_days
}
    `;
export const AssignmentReportFieldsFragmentDoc = gql`
    fragment AssignmentReportFields on MachineAssignmentReport {
  id
  start_date
  end_date
  machine {
    id
    name
    display_name @client
  }
  project {
    id
    name
    slug
  }
  user {
    id
    first_name
    last_name
    full_name @client
    username
    email
    dni
  }
}
    `;
export const MoveReportHistoryFieldsFragmentDoc = gql`
    fragment MoveReportHistoryFields on MoveReport {
  id
  comments
  counter {
    type
    value
    start
    end
  }
  from_project {
    id
    name
  }
  to_project {
    id
    name
  }
}
    `;
export const MoveReportDetailPairedFieldsFragmentDoc = gql`
    fragment MoveReportDetailPairedFields on MoveReport {
  id
  comments
  counter {
    type
    value
    start
    end
  }
  from_project {
    id
    name
  }
  to_project {
    id
    name
  }
  files {
    id
    url
  }
  created_by {
    id
    first_name
    last_name
    full_name @client
  }
}
    `;
export const MoveReportFieldsFragmentDoc = gql`
    fragment MoveReportFields on MoveReport {
  ...MoveReportHistoryFields
  paired_report {
    ...MoveReportDetailPairedFields
  }
  files {
    id
    url
  }
  created_by {
    id
    first_name
    last_name
    full_name @client
  }
}
    ${MoveReportHistoryFieldsFragmentDoc}
${MoveReportDetailPairedFieldsFragmentDoc}`;
export const MachineReportsHistoryFieldsFragmentDoc = gql`
    fragment MachineReportsHistoryFields on DailyReport {
  __typename
  id
  date
  status
  machine {
    id
    name
    display_name @client
  }
  project {
    id
    name
  }
  usage_reports {
    id
    counter {
      type
      value
      start
      end
    }
  }
  total_counters {
    type
    value
    start
    end
  }
  total_counters_display @client
  total_hs @client
  total_km @client
  out_of_service_report {
    ...OutOfServiceReportFields
  }
  available_report {
    id
    observation
  }
  checkin_report {
    ...MoveReportFields
  }
  checkout_report {
    ...MoveReportFields
  }
  service_reports {
    id
    service_type
    comments
    counter {
      ...CounterFields
    }
    counter_in_sequence {
      ...CounterFields
    }
    date_in_sequence
    error_fraction
    date
    program {
      id
      title
    }
  }
}
    ${OutOfServiceReportFieldsFragmentDoc}
${MoveReportFieldsFragmentDoc}
${CounterFieldsFragmentDoc}`;
export const MachinistReportsFieldsFragmentDoc = gql`
    fragment MachinistReportsFields on MachinistWorkBoard {
  user {
    id
    first_name
    dni
    email
    last_name
    username
  }
  rate_reported @client
  summaries(filter: $filter) {
    date
    has_reports
    total_counters {
      type
      value
    }
    total_counters_display @client
    daily_reports {
      id
      total_counters {
        ...CounterFields
      }
      project {
        id
        name
      }
      machine {
        ...MachineLinkFields
        id
        name
        preferred_counter_type
      }
      usage_reports {
        id
        counter {
          type
          value
          start
          end
        }
      }
    }
  }
}
    ${CounterFieldsFragmentDoc}
${MachineLinkFieldsFragmentDoc}`;
export const MachineReportsFieldsFragmentDoc = gql`
    fragment MachineReportsFields on MachineReportsBoard {
  machine {
    ...MachineLinkFields
    id
    name
    type {
      id
      type
      group
      subtype
      accepts_usage
      accepts_available
      reported_daily
    }
    brand
    model
    year
    preferred_counter_type
    power
    replacement_value
    project {
      id
      name
    }
    owner
    ownership_type
    ownership_type_other
    bilderit_connect_devices {
      id
      telemetry_provider
    }
  }
  total_days_with_reports_hs @client
  total_days_with_reports_km @client
  stats(filter: $filter) {
    num_greases
    total_counters {
      type
      value
    }
    total_counters_display @client
    total_hs @client
    total_km @client
    total_fuel
    total_motor_oil
    num_worked_days
    num_oos_days {
      due_to_equipment
      due_to_project
    }
    num_pending_days
    num_available_days
    total_days_with_reports
    total_days
    total_days_in_context
  }
  reports(filter: $filter) {
    id
    date
    project_id
    project_name
    status
    total_counters {
      type
      value
    }
    total_counters_display @client
    total_fuel
    total_motor_oil
    has_filters
    has_grease
    has_comments
    has_tasks
    num_photos
    has_photos @client
    os_cause
    os_charge_type
    av_cause
    user
  }
}
    ${MachineLinkFieldsFragmentDoc}`;
export const AverageUsageFieldsFragmentDoc = gql`
    fragment AverageUsageFields on AverageUsage {
  machine_id
  days_in_last_5_reports
  hours_in_last_5_reports
  hours_in_last_15_days
}
    `;
export const MpProgramFieldsForServicesFragmentDoc = gql`
    fragment MPProgramFieldsForServices on MPProgram {
  id
  title
  description
  multiplier
}
    `;
export const ServiceReportFieldsFragmentDoc = gql`
    fragment ServiceReportFields on ServiceReport {
  id
  created_at
  counter {
    ...CounterFields
  }
  date
  counter_in_sequence {
    ...CounterFields
  }
  date_in_sequence
  error_fraction
  service_type
  program {
    ...MPProgramFieldsForServices
  }
  plan {
    id
    title
    base_period
  }
  comments
}
    ${CounterFieldsFragmentDoc}
${MpProgramFieldsForServicesFragmentDoc}`;
export const ServicesFieldsWithoutNextServicesFragmentDoc = gql`
    fragment ServicesFieldsWithoutNextServices on Machine {
  ...MachineLinkFields
  id
  type {
    id
    type
  }
  company {
    id
  }
  project {
    id
    name
  }
  preferred_counter_type
  counter {
    ...CounterFields
  }
  last_counters {
    datetime
    source
    type
    value
  }
  last_service {
    ...ServiceReportFields
  }
  maintenance_plan {
    id
    title
    base_period
    period_type
  }
  next_mp_sequence_index
}
    ${MachineLinkFieldsFragmentDoc}
${CounterFieldsFragmentDoc}
${ServiceReportFieldsFragmentDoc}`;
export const ServiceSequenceItemFieldsFragmentDoc = gql`
    fragment ServiceSequenceItemFields on ServiceSequenceItem {
  program {
    id
    title
    multiplier
  }
  period
  period_type
  sequence_index
  counter_in_sequence
  date_in_sequence
}
    `;
export const NextServiceFieldsFragmentDoc = gql`
    fragment NextServiceFields on NextService {
  service {
    ...ServiceSequenceItemFields
  }
  remaining {
    type
    value
    fraction
  }
}
    ${ServiceSequenceItemFieldsFragmentDoc}`;
export const ServicesFieldsFragmentDoc = gql`
    fragment ServicesFields on Machine {
  ...ServicesFieldsWithoutNextServices
  next_service: next_services(limit: 1) {
    ...NextServiceFields
  }
  open_preventive_maintenance_work_orders {
    id
    status
    type {
      id
      name
    }
  }
}
    ${ServicesFieldsWithoutNextServicesFragmentDoc}
${NextServiceFieldsFragmentDoc}`;
export const AdminUserRowFieldsFragmentDoc = gql`
    fragment AdminUserRowFields on AdminUserRow {
  user_id
  cognito_username
  first_name
  last_name
  dni
  sign_in
  email
  kind
  managed_by {
    id
    name
  }
  companies {
    id
    name
  }
  state
  alerts
  registered_at
  last_seen_on
}
    `;
export const AdminUserDetailFieldsFragmentDoc = gql`
    fragment AdminUserDetailFields on AdminUserDetail {
  row {
    ...AdminUserRowFields
  }
  identities {
    username
    sub
    sign_in
    email
    email_verified
    status
    enabled
    dni
    first_name
    last_name
    created_at
    updated_at
  }
  database {
    id
    username
    email
    dni
    first_name
    last_name
    external_id
    google_external_id
    pending_email
    created_at
    created_by_name
  }
  roles {
    company {
      id
      name
    }
    managing
    foreign
    roles {
      id
      role_type
      scope_name
    }
  }
  checks {
    id
    status
  }
  enabled_to_create_company
}
    ${AdminUserRowFieldsFragmentDoc}`;
export const RentalParameterDefinitionFieldsFragmentDoc = gql`
    fragment RentalParameterDefinitionFields on RentalParameterDefinition {
  id
  code
  symbol
  display_name
  type
  options
  unit
  description
}
    `;
export const RentalParameterEffectiveValueFieldsFragmentDoc = gql`
    fragment RentalParameterEffectiveValueFields on EffectiveParameterValue {
  id
  parameter_def {
    ...RentalParameterDefinitionFields
  }
  value
  priority
  target_machine_id
  scope_project_id
  scope_business_unit_id
  scope_company_id
  applies_to_group
  applies_to_type_id
  applies_to_counter_type
  updated_at
  created_at
}
    ${RentalParameterDefinitionFieldsFragmentDoc}`;
export const MachineWithEffectiveParameterValuesFieldsFragmentDoc = gql`
    fragment MachineWithEffectiveParameterValuesFields on MachineWithEffectiveParameterValues {
  machine {
    id
    name
    company {
      id
      name
    }
    project {
      id
      name
    }
    type {
      id
      group
      type
    }
    preferred_counter_type
  }
  items {
    ...RentalParameterEffectiveValueFields
  }
}
    ${RentalParameterEffectiveValueFieldsFragmentDoc}`;
export const CompanyIntegrationFieldsFragmentDoc = gql`
    fragment CompanyIntegrationFields on CompanyIntegration {
  id
  company {
    id
    name
  }
  provider
  is_active
  credentials
  last_sync_at
  last_sync_status
  last_error_message
  created_at
  updated_at
}
    `;
export const VisionLinkReportsByDateFieldsFragmentDoc = gql`
    fragment VisionLinkReportsByDateFields on VisionLinkReportsByDateResult {
  integration_id
  company_id
  company_name
  date
  found {
    report_type
    s3_key
  }
  missing
}
    `;
export const PublicApiKeyFieldsFragmentDoc = gql`
    fragment PublicApiKeyFields on PublicApiKey {
  id
  clientId
  keyPrefix
  status
  expiresAt
  lastUsedAt
  createdAt
  createdByName
  revokedAt
  revokedByName
  revocationReason
  revocationComment
}
    `;
export const PublicApiClientFieldsFragmentDoc = gql`
    fragment PublicApiClientFields on PublicApiClient {
  id
  companyId
  companyName
  name
  roles
  ownerName
  ownerEmail
  technicalName
  technicalEmail
  createdAt
  updatedAt
  lastUsedAt
  keys {
    ...PublicApiKeyFields
  }
}
    ${PublicApiKeyFieldsFragmentDoc}`;
export const TelemetryDeviceBaseFieldsFragmentDoc = gql`
    fragment TelemetryDeviceBaseFields on TelemetryDevice {
  id
  name
  protocol
  ident
  last_activity_at
  btrack_unit_id
  links {
    ...BilderitConnectDeviceFields
  }
}
    ${BilderitConnectDeviceFieldsFragmentDoc}`;
export const TrackerTelemetryDeviceFieldsFragmentDoc = gql`
    fragment TrackerTelemetryDeviceFields on TrackerTelemetryDevice {
  ...TelemetryDeviceBaseFields
  model
  ignition_voltage_threshold
  last_meassured_voltage
}
    ${TelemetryDeviceBaseFieldsFragmentDoc}`;
export const IntegrationTelemetryDeviceFieldsFragmentDoc = gql`
    fragment IntegrationTelemetryDeviceFields on IntegrationTelemetryDevice {
  ...TelemetryDeviceBaseFields
  integration
  last_horometer
  last_horometer_at
  last_odometer
  last_odometer_at
}
    ${TelemetryDeviceBaseFieldsFragmentDoc}`;
export const SystemFlagFieldsFragmentDoc = gql`
    fragment SystemFlagFields on SystemFlag {
  key
  enabled
  description
  updated_at
}
    `;
export const TelemetrySandboxScopeFieldsFragmentDoc = gql`
    fragment TelemetrySandboxScopeFields on TelemetrySandboxScope {
  scope_key
  account_label
  provider_family
}
    `;
export const CompanyWithTotalsFieldsFragmentDoc = gql`
    fragment CompanyWithTotalsFields on CompanyWithTotals {
  company {
    id
    name
  }
  users
  projects
  heavy_equipments
  trucks
  vehicles
  fixed_assets
  fuel_tanks
  maintenance_plans
  documents
  users_seen_30d
  last_seen_at
}
    `;
export const CompanyActivityFieldsFragmentDoc = gql`
    fragment CompanyActivityFields on CompanyActivitySummary {
  companyId
  activeUserCount
  totalActions
  lastActivityDate
}
    `;
export const AllCompaniesForSuperRootFieldsFragmentDoc = gql`
    fragment AllCompaniesForSuperRootFields on Company {
  id
  name
  slug
  logo_url
  modules_enabled {
    module_id
    end_date
  }
  projects {
    id
    name
    slug
    business_unit {
      id
      name
      slug
    }
  }
}
    `;
export const TagCatalogFieldsFragmentDoc = gql`
    fragment TagCatalogFields on Tag {
  id
  tag
  description
  icon
  color
  is_archived
  usage_count
  group {
    id
    name
    is_archived
  }
}
    `;
export const TagGroupCatalogFieldsFragmentDoc = gql`
    fragment TagGroupCatalogFields on TagGroup {
  id
  name
  is_archived
}
    `;
export const TelemetrySnapshotFieldsFragmentDoc = gql`
    fragment TelemetrySnapshotFields on TelemetrySnapshot {
  flespi_id
  machine_id
  telemetry_provider
  counter_offset
  device_name
  device_serial_number
  vin
  DEF_remaining_percentage {
    value
    datetime_utc
  }
  DEF_tank_capacity {
    value
    datetime_utc
  }
  fuel_remaining_percentage {
    value
    datetime_utc
  }
  fuel_tank_capacity {
    value
    datetime_utc
  }
  cumulative_distance_traveled_km {
    value
    datetime_utc
  }
  cumulative_fuel_consumed_lts {
    value
    datetime_utc
  }
  cumulative_idle_hours {
    value
    datetime_utc
  }
  cumulative_idle_non_operating_hours {
    value
    datetime_utc
  }
  cumulative_load_count {
    value
    datetime_utc
  }
  cumulative_operating_hours {
    value
    datetime_utc
  }
  cumulative_payload_moved_kg {
    value
    datetime_utc
  }
  cumulative_power_takeoff_hours {
    value
    datetime_utc
  }
  engine_ignition_status {
    value
    datetime_utc
  }
  position {
    latitude
    longitude
    altitude
    datetime_utc
  }
}
    `;
export const DailyTelemetryFieldsFragmentDoc = gql`
    fragment DailyTelemetryFields on DailyTelemetry {
  end_of_day
  flespi_id
  machine_id
  telemetry_provider
  device_name
  device_serial_number
  vin
  counter_offset
  engine_ignition_status
  DEF_remaining_percentage
  DEF_tank_capacity
  cumulative_distance_traveled_km
  cumulative_fuel_consumed_lts
  cumulative_idle_hours
  cumulative_idle_non_operating_hours
  cumulative_load_count
  cumulative_operating_hours
  cumulative_payload_moved_kg
  cumulative_power_takeoff_hours
  daily_distance_traveled_km
  daily_fuel_consumed_lts
  daily_idle_hours
  daily_idle_non_operating_hours
  daily_maximum_speed_km_h
  daily_operating_hours
  fuel_remaining_percentage
  fuel_tank_capacity
  position {
    latitude
    longitude
    altitude
  }
  working_intervals {
    start
    end
  }
  project_at_day {
    id
    name
  }
}
    `;
export const DailyTelemetryGroupFieldsFragmentDoc = gql`
    fragment DailyTelemetryGroupFields on DailyTelemetryGroup {
  machine {
    ...MachineLinkFields
    id
    brand
    model
    name
    project {
      id
      name
    }
  }
  telemetry {
    ...DailyTelemetryFields
  }
}
    ${MachineLinkFieldsFragmentDoc}
${DailyTelemetryFieldsFragmentDoc}`;
export const TelemetryGroupStatsFieldsFragmentDoc = gql`
    fragment TelemetryGroupStatsFields on TelemetryGroupStats {
  totalEquipos
  totalHoras
  totalRalenti
  totalHorasActivas
  totalCombustible
  totalCombustibleRalenti
  totalCombustibleActivo
  totalCostoEstimado
  totalCostoRalenti
  totalCostoActivo
  promedioHorasPorEquipo
  promedioRalentiPorEquipo
  promedioPorcentajeRalenti
  promedioCombustiblePorEquipo
}
    `;
export const TelemetryEquipmentStatsFieldsFragmentDoc = gql`
    fragment TelemetryEquipmentStatsFields on TelemetryEquipmentStats {
  machineId
  machine {
    ...MachineLinkFields
    id
    brand
    model
    name
  }
  projectId
  project {
    id
    name
  }
  horas
  ralenti
  porcentajeRalenti
  horasActivas
  combustible
  combustibleRalenti
  combustibleActivo
  costoTotal
  costoRalenti
  costoActivo
  fechaUltimaActividad
}
    ${MachineLinkFieldsFragmentDoc}`;
export const UteFieldsFragmentDoc = gql`
    fragment UTEFields on UTE {
  cuit
  partners {
    name
    percentage
  }
}
    `;
export const BusinessUnitFieldsFragmentDoc = gql`
    fragment BusinessUnitFields on BusinessUnit {
  id
  name
  company_id
  created_at
  updated_at
  projects {
    id
    name
    is_archived
  }
}
    `;
export const ProjectFieldsFragmentDoc = gql`
    fragment ProjectFields on Project {
  id
  name
  company {
    id
    name
    slug
  }
  slug
  num_employees
  num_machines {
    group
    total
  }
  ute {
    ...UTEFields
  }
  client
  business_unit {
    ...BusinessUnitFields
  }
  code
  location {
    lat
    lon
  }
}
    ${UteFieldsFragmentDoc}
${BusinessUnitFieldsFragmentDoc}`;
export const WorkOrderTaskFieldsFragmentDoc = gql`
    fragment WorkOrderTaskFields on WorkOrderTask {
  id
  compartment
  item
  preferred_consumable {
    ... on MachineConsumable {
      ...ConsumableFields
    }
    ... on StringUnionWrapper {
      value
    }
  }
  preferred_quantity
  used_consumable {
    ... on MachineConsumable {
      ...ConsumableFields
    }
    ... on StringUnionWrapper {
      value
    }
  }
  used_quantity
  action
  done
  done_by {
    id
    first_name
    last_name
  }
  done_at
  created_at
  updated_at
}
    ${ConsumableFieldsFragmentDoc}`;
export const EmployeeFieldsFragmentDoc = gql`
    fragment EmployeeFields on Employee {
  id
  is_managed
  first_name
  last_name
  full_name @client
  username
  email
  dni
  roles {
    id
    role
    project {
      id
      name
    }
    business_unit {
      id
      name
    }
    company {
      id
      name
    }
  }
}
    `;
export const WorkOrderHoursFieldsFragmentDoc = gql`
    fragment WorkOrderHoursFields on WorkOrderHours {
  id
  user {
    ...EmployeeFields
  }
  planned_hours
  executed_hours
  execution_date
  labor_type
  notes
  created_at
  created_by {
    ...EmployeeFields
  }
  updated_at
  updated_by {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;
export const WorkOrderFieldsFragmentDoc = gql`
    fragment WorkOrderFields on WorkOrder {
  id
  serial_number
  title
  description
  status
  created_at
  updated_at
  draft_start_date
  draft_end_date
  in_progress_start_date
  in_progress_end_date
  to_review_start_date
  to_review_end_date
  to_approve_start_date
  to_approve_end_date
  canceled_at
  canceled_by {
    first_name
    last_name
    full_name @client
  }
  created_by {
    first_name
    last_name
    full_name @client
  }
  updated_by {
    first_name
    last_name
    full_name @client
  }
  closed_date
  assigned {
    id
    dni
    email
    first_name
    last_name
    full_name @client
  }
  service_report {
    id
    service_type
    program {
      id
      title
    }
    comments
    counter {
      ...CounterFields
    }
    counter_in_sequence {
      ...CounterFields
    }
    date_in_sequence
    error_fraction
  }
  tags {
    id
    tag
    icon
    color
    is_archived
  }
  type {
    id
    name
  }
  counter {
    ...CounterFields
  }
  machine {
    ...MachineFields
  }
  project {
    ...ProjectFields
  }
  tasks {
    ...WorkOrderTaskFields
  }
  hours {
    ...WorkOrderHoursFields
  }
}
    ${CounterFieldsFragmentDoc}
${MachineFieldsFragmentDoc}
${ProjectFieldsFragmentDoc}
${WorkOrderTaskFieldsFragmentDoc}
${WorkOrderHoursFieldsFragmentDoc}`;
export const WorkOrderWithFilesFieldsFragmentDoc = gql`
    fragment WorkOrderWithFilesFields on WorkOrder {
  ...WorkOrderFields
  files {
    id
    url
  }
  comments_draft
  comments_in_progress
  comments_to_review
  comments_to_approve
}
    ${WorkOrderFieldsFragmentDoc}`;
export const WorkOrdersTableFieldsFragmentDoc = gql`
    fragment WorkOrdersTableFields on WorkOrder {
  id
  serial_number
  created_at
  updated_at
  draft_start_date
  draft_end_date
  in_progress_start_date
  in_progress_end_date
  canceled_at
  canceled_by {
    first_name
    last_name
    full_name @client
  }
  type {
    id
    name
  }
  title
  tags {
    id
    tag
    icon
    color
    is_archived
  }
  machine {
    ...MachineLinkFields
    id
    name
    display_name @client
    display_type @client
    type {
      __typename
      id
      type
      group
      subtype
      reported_daily
      accepts_usage
      accepts_service
      accepts_oos
      accepts_available
    }
    brand
    model
    counter {
      ...CounterFields
    }
    project {
      id
      name
    }
  }
  assigned {
    id
    dni
    email
    first_name
    last_name
    full_name @client
  }
  description
  status
  counter {
    ...CounterFields
  }
  project {
    id
    name
  }
}
    ${MachineLinkFieldsFragmentDoc}
${CounterFieldsFragmentDoc}`;
export const MaintenanceMetricResultFieldsFragmentDoc = gql`
    fragment MaintenanceMetricResultFields on MaintenanceMetricResult {
  target
  unit
  value
  calculationContext {
    usedLastNDays
    usedLastNReports
    startDate
    endDate
  }
  metadata
}
    `;
export const MaintenanceKpiGroupFieldsFragmentDoc = gql`
    fragment MaintenanceKPIGroupFields on MaintenanceKpiGroup {
  backlogOtHours {
    ...MaintenanceMetricResultFields
  }
  meanPeriodBetweenFailures {
    ...MaintenanceMetricResultFields
  }
  meanServiceDeviation {
    ...MaintenanceMetricResultFields
  }
  meanTimeToRepair {
    ...MaintenanceMetricResultFields
  }
  mechanicalAvailability {
    ...MaintenanceMetricResultFields
  }
  plannedMaintenancePercentage {
    ...MaintenanceMetricResultFields
  }
}
    ${MaintenanceMetricResultFieldsFragmentDoc}`;
export const MachineKpiEntryFieldsFragmentDoc = gql`
    fragment MachineKPIEntryFields on MachineKpiEntry {
  machine {
    ...MachineLinkFields
    last_status
    last_status_on
    brand
    ownership_type
    type {
      id
      type
      group
    }
  }
  kpis {
    ...MaintenanceKPIGroupFields
  }
}
    ${MachineLinkFieldsFragmentDoc}
${MaintenanceKpiGroupFieldsFragmentDoc}`;
export const PushSubscriptionFieldsFragmentDoc = gql`
    fragment PushSubscriptionFields on PushSubscription {
  endpoint
}
    `;
export const PushTopicPreferenceFieldsFragmentDoc = gql`
    fragment PushTopicPreferenceFields on PushTopicPreference {
  topic
  company_id
  project_id
}
    `;
export const NotificationPreferencesFieldsFragmentDoc = gql`
    fragment NotificationPreferencesFields on NotificationPreferences {
  topics {
    ...PushTopicPreferenceFields
  }
  optedOutTopics
}
    ${PushTopicPreferenceFieldsFragmentDoc}`;
export const GetRolesWithNestedProjectsDocument = gql`
    query GetRolesWithNestedProjects {
  getMe {
    ... on GetMe {
      item {
        ...MyUserData
        roles {
          ...RoleFieldsForUseProjectOptions
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MyUserDataFragmentDoc}
${RoleFieldsForUseProjectOptionsFragmentDoc}`;

/**
 * __useGetRolesWithNestedProjectsQuery__
 *
 * To run a query within a React component, call `useGetRolesWithNestedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesWithNestedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesWithNestedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesWithNestedProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRolesWithNestedProjectsQuery, GetRolesWithNestedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRolesWithNestedProjectsQuery, GetRolesWithNestedProjectsQueryVariables>(GetRolesWithNestedProjectsDocument, options);
      }
export function useGetRolesWithNestedProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRolesWithNestedProjectsQuery, GetRolesWithNestedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRolesWithNestedProjectsQuery, GetRolesWithNestedProjectsQueryVariables>(GetRolesWithNestedProjectsDocument, options);
        }
export function useGetRolesWithNestedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRolesWithNestedProjectsQuery, GetRolesWithNestedProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRolesWithNestedProjectsQuery, GetRolesWithNestedProjectsQueryVariables>(GetRolesWithNestedProjectsDocument, options);
        }
export type GetRolesWithNestedProjectsQueryHookResult = ReturnType<typeof useGetRolesWithNestedProjectsQuery>;
export type GetRolesWithNestedProjectsLazyQueryHookResult = ReturnType<typeof useGetRolesWithNestedProjectsLazyQuery>;
export type GetRolesWithNestedProjectsSuspenseQueryHookResult = ReturnType<typeof useGetRolesWithNestedProjectsSuspenseQuery>;
export type GetRolesWithNestedProjectsQueryResult = Apollo.QueryResult<GetRolesWithNestedProjectsQuery, GetRolesWithNestedProjectsQueryVariables>;
export const AnalyzeMachineNoticesDashboardDocument = gql`
    query AnalyzeMachineNoticesDashboard($context: Context!, $filter: FilterMachineNoticeDashboard, $model: String) {
  analyzeMachineNoticesDashboard(
    context: $context
    filter: $filter
    model: $model
  ) {
    analysis {
      ...MachineNoticesAnalysisItemFields
    }
    analyzed_notice_count
    total_notice_count
    truncated
  }
}
    ${MachineNoticesAnalysisItemFieldsFragmentDoc}`;

/**
 * __useAnalyzeMachineNoticesDashboardQuery__
 *
 * To run a query within a React component, call `useAnalyzeMachineNoticesDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeMachineNoticesDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyzeMachineNoticesDashboardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useAnalyzeMachineNoticesDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AnalyzeMachineNoticesDashboardQuery, AnalyzeMachineNoticesDashboardQueryVariables> & ({ variables: AnalyzeMachineNoticesDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AnalyzeMachineNoticesDashboardQuery, AnalyzeMachineNoticesDashboardQueryVariables>(AnalyzeMachineNoticesDashboardDocument, options);
      }
export function useAnalyzeMachineNoticesDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AnalyzeMachineNoticesDashboardQuery, AnalyzeMachineNoticesDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AnalyzeMachineNoticesDashboardQuery, AnalyzeMachineNoticesDashboardQueryVariables>(AnalyzeMachineNoticesDashboardDocument, options);
        }
export function useAnalyzeMachineNoticesDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AnalyzeMachineNoticesDashboardQuery, AnalyzeMachineNoticesDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AnalyzeMachineNoticesDashboardQuery, AnalyzeMachineNoticesDashboardQueryVariables>(AnalyzeMachineNoticesDashboardDocument, options);
        }
export type AnalyzeMachineNoticesDashboardQueryHookResult = ReturnType<typeof useAnalyzeMachineNoticesDashboardQuery>;
export type AnalyzeMachineNoticesDashboardLazyQueryHookResult = ReturnType<typeof useAnalyzeMachineNoticesDashboardLazyQuery>;
export type AnalyzeMachineNoticesDashboardSuspenseQueryHookResult = ReturnType<typeof useAnalyzeMachineNoticesDashboardSuspenseQuery>;
export type AnalyzeMachineNoticesDashboardQueryResult = Apollo.QueryResult<AnalyzeMachineNoticesDashboardQuery, AnalyzeMachineNoticesDashboardQueryVariables>;
export const GetCompanyAlertsDocument = gql`
    query GetCompanyAlerts($context: Context!) {
  getCompanyAlerts(context: $context) {
    expired_documents_count
    overdue_services_count
    open_critical_machine_notices_count
  }
}
    `;

/**
 * __useGetCompanyAlertsQuery__
 *
 * To run a query within a React component, call `useGetCompanyAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAlertsQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetCompanyAlertsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCompanyAlertsQuery, GetCompanyAlertsQueryVariables> & ({ variables: GetCompanyAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyAlertsQuery, GetCompanyAlertsQueryVariables>(GetCompanyAlertsDocument, options);
      }
export function useGetCompanyAlertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyAlertsQuery, GetCompanyAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyAlertsQuery, GetCompanyAlertsQueryVariables>(GetCompanyAlertsDocument, options);
        }
export function useGetCompanyAlertsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyAlertsQuery, GetCompanyAlertsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyAlertsQuery, GetCompanyAlertsQueryVariables>(GetCompanyAlertsDocument, options);
        }
export type GetCompanyAlertsQueryHookResult = ReturnType<typeof useGetCompanyAlertsQuery>;
export type GetCompanyAlertsLazyQueryHookResult = ReturnType<typeof useGetCompanyAlertsLazyQuery>;
export type GetCompanyAlertsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAlertsSuspenseQuery>;
export type GetCompanyAlertsQueryResult = Apollo.QueryResult<GetCompanyAlertsQuery, GetCompanyAlertsQueryVariables>;
export const GetMyReportSubscriptionsDocument = gql`
    query GetMyReportSubscriptions($context: Context) {
  getMyBilderitReportSubscriptions(context: $context) {
    ...ReportSubscriptionFields
  }
}
    ${ReportSubscriptionFieldsFragmentDoc}`;

/**
 * __useGetMyReportSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetMyReportSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyReportSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyReportSubscriptionsQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetMyReportSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyReportSubscriptionsQuery, GetMyReportSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyReportSubscriptionsQuery, GetMyReportSubscriptionsQueryVariables>(GetMyReportSubscriptionsDocument, options);
      }
export function useGetMyReportSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyReportSubscriptionsQuery, GetMyReportSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyReportSubscriptionsQuery, GetMyReportSubscriptionsQueryVariables>(GetMyReportSubscriptionsDocument, options);
        }
export function useGetMyReportSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyReportSubscriptionsQuery, GetMyReportSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyReportSubscriptionsQuery, GetMyReportSubscriptionsQueryVariables>(GetMyReportSubscriptionsDocument, options);
        }
export type GetMyReportSubscriptionsQueryHookResult = ReturnType<typeof useGetMyReportSubscriptionsQuery>;
export type GetMyReportSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetMyReportSubscriptionsLazyQuery>;
export type GetMyReportSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useGetMyReportSubscriptionsSuspenseQuery>;
export type GetMyReportSubscriptionsQueryResult = Apollo.QueryResult<GetMyReportSubscriptionsQuery, GetMyReportSubscriptionsQueryVariables>;
export const SubscribeToBilderitReportDocument = gql`
    mutation SubscribeToBilderitReport($input: SubscribeToBilderitReportInput!) {
  subscribeToBilderitReport(input: $input) {
    ...ReportSubscriptionFields
  }
}
    ${ReportSubscriptionFieldsFragmentDoc}`;

/**
 * __useSubscribeToBilderitReportMutation__
 *
 * To run a mutation, you first call `useSubscribeToBilderitReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToBilderitReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToBilderitReportMutation, { data, loading, error }] = useSubscribeToBilderitReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToBilderitReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubscribeToBilderitReportMutation, SubscribeToBilderitReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubscribeToBilderitReportMutation, SubscribeToBilderitReportMutationVariables>(SubscribeToBilderitReportDocument, options);
      }
export type SubscribeToBilderitReportMutationHookResult = ReturnType<typeof useSubscribeToBilderitReportMutation>;
export type SubscribeToBilderitReportMutationResult = Apollo.MutationResult<SubscribeToBilderitReportMutation>;
export type SubscribeToBilderitReportMutationOptions = Apollo.BaseMutationOptions<SubscribeToBilderitReportMutation, SubscribeToBilderitReportMutationVariables>;
export const UnsubscribeFromBilderitReportDocument = gql`
    mutation UnsubscribeFromBilderitReport($id: ID!) {
  unsubscribeFromBilderitReport(id: $id)
}
    `;

/**
 * __useUnsubscribeFromBilderitReportMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromBilderitReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromBilderitReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromBilderitReportMutation, { data, loading, error }] = useUnsubscribeFromBilderitReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsubscribeFromBilderitReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsubscribeFromBilderitReportMutation, UnsubscribeFromBilderitReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnsubscribeFromBilderitReportMutation, UnsubscribeFromBilderitReportMutationVariables>(UnsubscribeFromBilderitReportDocument, options);
      }
export type UnsubscribeFromBilderitReportMutationHookResult = ReturnType<typeof useUnsubscribeFromBilderitReportMutation>;
export type UnsubscribeFromBilderitReportMutationResult = Apollo.MutationResult<UnsubscribeFromBilderitReportMutation>;
export type UnsubscribeFromBilderitReportMutationOptions = Apollo.BaseMutationOptions<UnsubscribeFromBilderitReportMutation, UnsubscribeFromBilderitReportMutationVariables>;
export const GetBtrackAccessTokenDocument = gql`
    query GetBtrackAccessToken($company_id: Int!) {
  getBtrackAccessToken(company_id: $company_id)
}
    `;

/**
 * __useGetBtrackAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetBtrackAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBtrackAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBtrackAccessTokenQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetBtrackAccessTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBtrackAccessTokenQuery, GetBtrackAccessTokenQueryVariables> & ({ variables: GetBtrackAccessTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBtrackAccessTokenQuery, GetBtrackAccessTokenQueryVariables>(GetBtrackAccessTokenDocument, options);
      }
export function useGetBtrackAccessTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBtrackAccessTokenQuery, GetBtrackAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBtrackAccessTokenQuery, GetBtrackAccessTokenQueryVariables>(GetBtrackAccessTokenDocument, options);
        }
export function useGetBtrackAccessTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBtrackAccessTokenQuery, GetBtrackAccessTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBtrackAccessTokenQuery, GetBtrackAccessTokenQueryVariables>(GetBtrackAccessTokenDocument, options);
        }
export type GetBtrackAccessTokenQueryHookResult = ReturnType<typeof useGetBtrackAccessTokenQuery>;
export type GetBtrackAccessTokenLazyQueryHookResult = ReturnType<typeof useGetBtrackAccessTokenLazyQuery>;
export type GetBtrackAccessTokenSuspenseQueryHookResult = ReturnType<typeof useGetBtrackAccessTokenSuspenseQuery>;
export type GetBtrackAccessTokenQueryResult = Apollo.QueryResult<GetBtrackAccessTokenQuery, GetBtrackAccessTokenQueryVariables>;
export const GetBtrackDemoAccessTokenDocument = gql`
    query GetBtrackDemoAccessToken {
  getBtrackDemoAccessToken
}
    `;

/**
 * __useGetBtrackDemoAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetBtrackDemoAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBtrackDemoAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBtrackDemoAccessTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBtrackDemoAccessTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBtrackDemoAccessTokenQuery, GetBtrackDemoAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBtrackDemoAccessTokenQuery, GetBtrackDemoAccessTokenQueryVariables>(GetBtrackDemoAccessTokenDocument, options);
      }
export function useGetBtrackDemoAccessTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBtrackDemoAccessTokenQuery, GetBtrackDemoAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBtrackDemoAccessTokenQuery, GetBtrackDemoAccessTokenQueryVariables>(GetBtrackDemoAccessTokenDocument, options);
        }
export function useGetBtrackDemoAccessTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBtrackDemoAccessTokenQuery, GetBtrackDemoAccessTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBtrackDemoAccessTokenQuery, GetBtrackDemoAccessTokenQueryVariables>(GetBtrackDemoAccessTokenDocument, options);
        }
export type GetBtrackDemoAccessTokenQueryHookResult = ReturnType<typeof useGetBtrackDemoAccessTokenQuery>;
export type GetBtrackDemoAccessTokenLazyQueryHookResult = ReturnType<typeof useGetBtrackDemoAccessTokenLazyQuery>;
export type GetBtrackDemoAccessTokenSuspenseQueryHookResult = ReturnType<typeof useGetBtrackDemoAccessTokenSuspenseQuery>;
export type GetBtrackDemoAccessTokenQueryResult = Apollo.QueryResult<GetBtrackDemoAccessTokenQuery, GetBtrackDemoAccessTokenQueryVariables>;
export const GetCompanyDocument = gql`
    query GetCompany($company_id: Int!) {
  getCompany(id: $company_id) {
    ... on AuthCheckGetCompany {
      item {
        id
        name
        cuit
        address
        email
        phone
        website
        logo_url
        slug
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables> & ({ variables: GetCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export function useGetCompanySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const AddCompanyDocument = gql`
    mutation AddCompany($name: String!, $cuit: String!, $website: String, $address: String!, $phone: String, $email: String, $logo: String) {
  addCompany(
    input: {name: $name, cuit: $cuit, address: $address, email: $email, phone: $phone, website: $website, logo: $logo}
  ) {
    ... on AddCompany {
      item {
        id
        name
        cuit
        address
        email
        phone
        website
        logo_url
        slug
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useAddCompanyMutation__
 *
 * To run a mutation, you first call `useAddCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMutation, { data, loading, error }] = useAddCompanyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      cuit: // value for 'cuit'
 *      website: // value for 'website'
 *      address: // value for 'address'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useAddCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddCompanyMutation, AddCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddCompanyMutation, AddCompanyMutationVariables>(AddCompanyDocument, options);
      }
export type AddCompanyMutationHookResult = ReturnType<typeof useAddCompanyMutation>;
export type AddCompanyMutationResult = Apollo.MutationResult<AddCompanyMutation>;
export type AddCompanyMutationOptions = Apollo.BaseMutationOptions<AddCompanyMutation, AddCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: Int!, $name: String, $cuit: String, $website: String, $address: String, $phone: String, $email: String, $logo: String) {
  updateCompany(
    id: $id
    input: {name: $name, cuit: $cuit, address: $address, email: $email, phone: $phone, website: $website, logo: $logo}
  ) {
    ... on AuthCheckUpdateCompany {
      item {
        id
        name
        cuit
        address
        email
        phone
        website
        logo_url
        slug
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      cuit: // value for 'cuit'
 *      website: // value for 'website'
 *      address: // value for 'address'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const GetDashboardDocument = gql`
    query GetDashboard($context: Context!, $filter: FilterDateRange!) {
  getDashBoard(context: $context, filter: $filter) {
    ... on DashBoardConnection {
      items {
        ... on ProjectStats {
          ...ProjectStatsFields
        }
        ... on OtherProjectsStats {
          ...OtherProjectsStatsFields
        }
      }
      totals {
        total_projects
        total_employees
        total_machines {
          group
          total
        }
        total_bc_devices {
          connected
          total
        }
      }
    }
  }
}
    ${ProjectStatsFieldsFragmentDoc}
${OtherProjectsStatsFieldsFragmentDoc}`;

/**
 * __useGetDashboardQuery__
 *
 * To run a query within a React component, call `useGetDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables> & ({ variables: GetDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, options);
      }
export function useGetDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, options);
        }
export function useGetDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, options);
        }
export type GetDashboardQueryHookResult = ReturnType<typeof useGetDashboardQuery>;
export type GetDashboardLazyQueryHookResult = ReturnType<typeof useGetDashboardLazyQuery>;
export type GetDashboardSuspenseQueryHookResult = ReturnType<typeof useGetDashboardSuspenseQuery>;
export type GetDashboardQueryResult = Apollo.QueryResult<GetDashboardQuery, GetDashboardQueryVariables>;
export const GetUploadTargetsDocument = gql`
    query GetUploadTargets($input: [GetUploadTargetInput!]!) {
  getUploadTargets(input: $input) {
    id
    uploadUrl
  }
}
    `;

/**
 * __useGetUploadTargetsQuery__
 *
 * To run a query within a React component, call `useGetUploadTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadTargetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUploadTargetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUploadTargetsQuery, GetUploadTargetsQueryVariables> & ({ variables: GetUploadTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadTargetsQuery, GetUploadTargetsQueryVariables>(GetUploadTargetsDocument, options);
      }
export function useGetUploadTargetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUploadTargetsQuery, GetUploadTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadTargetsQuery, GetUploadTargetsQueryVariables>(GetUploadTargetsDocument, options);
        }
export function useGetUploadTargetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUploadTargetsQuery, GetUploadTargetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUploadTargetsQuery, GetUploadTargetsQueryVariables>(GetUploadTargetsDocument, options);
        }
export type GetUploadTargetsQueryHookResult = ReturnType<typeof useGetUploadTargetsQuery>;
export type GetUploadTargetsLazyQueryHookResult = ReturnType<typeof useGetUploadTargetsLazyQuery>;
export type GetUploadTargetsSuspenseQueryHookResult = ReturnType<typeof useGetUploadTargetsSuspenseQuery>;
export type GetUploadTargetsQueryResult = Apollo.QueryResult<GetUploadTargetsQuery, GetUploadTargetsQueryVariables>;
export const UpdateMyUserDocument = gql`
    mutation UpdateMyUser($input: UpdateMeInput!) {
  updateMe(input: $input) {
    ... on UpdateMe {
      item {
        ...MyUserData
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MyUserDataFragmentDoc}`;

/**
 * __useUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMutation, { data, loading, error }] = useUpdateMyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyUserMutation, UpdateMyUserMutationVariables>(UpdateMyUserDocument, options);
      }
export type UpdateMyUserMutationHookResult = ReturnType<typeof useUpdateMyUserMutation>;
export type UpdateMyUserMutationResult = Apollo.MutationResult<UpdateMyUserMutation>;
export type UpdateMyUserMutationOptions = Apollo.BaseMutationOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>;
export const UpdateMyUserFederatedDocument = gql`
    mutation UpdateMyUserFederated($input: UpdateFederatedIdentityInformationInput!) {
  updateFederatedIdentityInformation(input: $input) {
    ... on MeItem {
      item {
        ...MyUserData
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MyUserDataFragmentDoc}`;

/**
 * __useUpdateMyUserFederatedMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserFederatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserFederatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserFederatedMutation, { data, loading, error }] = useUpdateMyUserFederatedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyUserFederatedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyUserFederatedMutation, UpdateMyUserFederatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyUserFederatedMutation, UpdateMyUserFederatedMutationVariables>(UpdateMyUserFederatedDocument, options);
      }
export type UpdateMyUserFederatedMutationHookResult = ReturnType<typeof useUpdateMyUserFederatedMutation>;
export type UpdateMyUserFederatedMutationResult = Apollo.MutationResult<UpdateMyUserFederatedMutation>;
export type UpdateMyUserFederatedMutationOptions = Apollo.BaseMutationOptions<UpdateMyUserFederatedMutation, UpdateMyUserFederatedMutationVariables>;
export const GetMeDocument = gql`
    query GetMe {
  getMe {
    ... on GetMe {
      item {
        ...MyUserData
      }
    }
    ... on Error {
      message
    }
    ... on ProfileDataMissingError {
      message
      data_missing
      partial_profile {
        id
        first_name
        last_name
        dni
        email
        phone
        address
        cuil
        gender
        incoming_merge {
          company_name
          managed_username
        }
      }
    }
  }
}
    ${MyUserDataFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export function useGetMeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const RejectInvitationDocument = gql`
    mutation RejectInvitation($id: ID!) {
  rejectInvitation(id: $id) {
    ... on RejectInvitation {
      item {
        ...MyUserData
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MyUserDataFragmentDoc}`;

/**
 * __useRejectInvitationMutation__
 *
 * To run a mutation, you first call `useRejectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInvitationMutation, { data, loading, error }] = useRejectInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectInvitationMutation, RejectInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectInvitationMutation, RejectInvitationMutationVariables>(RejectInvitationDocument, options);
      }
export type RejectInvitationMutationHookResult = ReturnType<typeof useRejectInvitationMutation>;
export type RejectInvitationMutationResult = Apollo.MutationResult<RejectInvitationMutation>;
export type RejectInvitationMutationOptions = Apollo.BaseMutationOptions<RejectInvitationMutation, RejectInvitationMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($id: ID!) {
  acceptInvitation(id: $id) {
    ... on AcceptInvitation {
      item {
        ...MyUserData
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MyUserDataFragmentDoc}`;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const GetBusinessUnitsByCompanyIdDocument = gql`
    query GetBusinessUnitsByCompanyId($company_id: Int!) {
  getCompany(id: $company_id) {
    ... on AuthCheckGetCompany {
      item {
        id
        business_units {
          ...BusinessUnitFields
        }
      }
    }
  }
}
    ${BusinessUnitFieldsFragmentDoc}`;

/**
 * __useGetBusinessUnitsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitsByCompanyIdQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetBusinessUnitsByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBusinessUnitsByCompanyIdQuery, GetBusinessUnitsByCompanyIdQueryVariables> & ({ variables: GetBusinessUnitsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBusinessUnitsByCompanyIdQuery, GetBusinessUnitsByCompanyIdQueryVariables>(GetBusinessUnitsByCompanyIdDocument, options);
      }
export function useGetBusinessUnitsByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBusinessUnitsByCompanyIdQuery, GetBusinessUnitsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBusinessUnitsByCompanyIdQuery, GetBusinessUnitsByCompanyIdQueryVariables>(GetBusinessUnitsByCompanyIdDocument, options);
        }
export function useGetBusinessUnitsByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBusinessUnitsByCompanyIdQuery, GetBusinessUnitsByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBusinessUnitsByCompanyIdQuery, GetBusinessUnitsByCompanyIdQueryVariables>(GetBusinessUnitsByCompanyIdDocument, options);
        }
export type GetBusinessUnitsByCompanyIdQueryHookResult = ReturnType<typeof useGetBusinessUnitsByCompanyIdQuery>;
export type GetBusinessUnitsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitsByCompanyIdLazyQuery>;
export type GetBusinessUnitsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetBusinessUnitsByCompanyIdSuspenseQuery>;
export type GetBusinessUnitsByCompanyIdQueryResult = Apollo.QueryResult<GetBusinessUnitsByCompanyIdQuery, GetBusinessUnitsByCompanyIdQueryVariables>;
export const AddBusinessUnitDocument = gql`
    mutation AddBusinessUnit($company_id: Int!, $name: String!) {
  addBusinessUnit(input: {company_id: $company_id, name: $name}) {
    ...BusinessUnitFields
  }
}
    ${BusinessUnitFieldsFragmentDoc}`;

/**
 * __useAddBusinessUnitMutation__
 *
 * To run a mutation, you first call `useAddBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBusinessUnitMutation, { data, loading, error }] = useAddBusinessUnitMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddBusinessUnitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddBusinessUnitMutation, AddBusinessUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddBusinessUnitMutation, AddBusinessUnitMutationVariables>(AddBusinessUnitDocument, options);
      }
export type AddBusinessUnitMutationHookResult = ReturnType<typeof useAddBusinessUnitMutation>;
export type AddBusinessUnitMutationResult = Apollo.MutationResult<AddBusinessUnitMutation>;
export type AddBusinessUnitMutationOptions = Apollo.BaseMutationOptions<AddBusinessUnitMutation, AddBusinessUnitMutationVariables>;
export const UpdateBusinessUnitDocument = gql`
    mutation UpdateBusinessUnit($id: Int!, $name: String!) {
  updateBusinessUnit(id: $id, input: {name: $name}) {
    ...BusinessUnitFields
  }
}
    ${BusinessUnitFieldsFragmentDoc}`;

/**
 * __useUpdateBusinessUnitMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessUnitMutation, { data, loading, error }] = useUpdateBusinessUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateBusinessUnitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBusinessUnitMutation, UpdateBusinessUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBusinessUnitMutation, UpdateBusinessUnitMutationVariables>(UpdateBusinessUnitDocument, options);
      }
export type UpdateBusinessUnitMutationHookResult = ReturnType<typeof useUpdateBusinessUnitMutation>;
export type UpdateBusinessUnitMutationResult = Apollo.MutationResult<UpdateBusinessUnitMutation>;
export type UpdateBusinessUnitMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessUnitMutation, UpdateBusinessUnitMutationVariables>;
export const DeleteBusinessUnitDocument = gql`
    mutation DeleteBusinessUnit($id: Int!) {
  deleteBusinessUnit(id: $id)
}
    `;

/**
 * __useDeleteBusinessUnitMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessUnitMutation, { data, loading, error }] = useDeleteBusinessUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBusinessUnitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBusinessUnitMutation, DeleteBusinessUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBusinessUnitMutation, DeleteBusinessUnitMutationVariables>(DeleteBusinessUnitDocument, options);
      }
export type DeleteBusinessUnitMutationHookResult = ReturnType<typeof useDeleteBusinessUnitMutation>;
export type DeleteBusinessUnitMutationResult = Apollo.MutationResult<DeleteBusinessUnitMutation>;
export type DeleteBusinessUnitMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessUnitMutation, DeleteBusinessUnitMutationVariables>;
export const GetChecklistResultsDocument = gql`
    query GetChecklistResults($context: Context!, $filter: FilterChecklists, $pagination: FilterPagination) {
  getChecklists(context: $context, filter: $filter, pagination: $pagination) {
    page_info {
      total_pages
      current_page
      total_items
      items_per_page
    }
    items {
      ...ChecklistResultFields
    }
    facets {
      field
      facets {
        value
        count
      }
    }
  }
}
    ${ChecklistResultFieldsFragmentDoc}`;

/**
 * __useGetChecklistResultsQuery__
 *
 * To run a query within a React component, call `useGetChecklistResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecklistResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecklistResultsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetChecklistResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChecklistResultsQuery, GetChecklistResultsQueryVariables> & ({ variables: GetChecklistResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChecklistResultsQuery, GetChecklistResultsQueryVariables>(GetChecklistResultsDocument, options);
      }
export function useGetChecklistResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChecklistResultsQuery, GetChecklistResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChecklistResultsQuery, GetChecklistResultsQueryVariables>(GetChecklistResultsDocument, options);
        }
export function useGetChecklistResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChecklistResultsQuery, GetChecklistResultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChecklistResultsQuery, GetChecklistResultsQueryVariables>(GetChecklistResultsDocument, options);
        }
export type GetChecklistResultsQueryHookResult = ReturnType<typeof useGetChecklistResultsQuery>;
export type GetChecklistResultsLazyQueryHookResult = ReturnType<typeof useGetChecklistResultsLazyQuery>;
export type GetChecklistResultsSuspenseQueryHookResult = ReturnType<typeof useGetChecklistResultsSuspenseQuery>;
export type GetChecklistResultsQueryResult = Apollo.QueryResult<GetChecklistResultsQuery, GetChecklistResultsQueryVariables>;
export const GetChecklistTemplatesDocument = gql`
    query GetChecklistTemplates($context: Context!, $filter: FilterChecklistTemplates, $pagination: FilterPagination) {
  getChecklistTemplates(
    context: $context
    filter: $filter
    pagination: $pagination
  ) {
    page_info {
      total_pages
      current_page
      total_items
      items_per_page
    }
    items {
      ...ChecklistTemplateFields
    }
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useGetChecklistTemplatesQuery__
 *
 * To run a query within a React component, call `useGetChecklistTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecklistTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecklistTemplatesQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetChecklistTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChecklistTemplatesQuery, GetChecklistTemplatesQueryVariables> & ({ variables: GetChecklistTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChecklistTemplatesQuery, GetChecklistTemplatesQueryVariables>(GetChecklistTemplatesDocument, options);
      }
export function useGetChecklistTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChecklistTemplatesQuery, GetChecklistTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChecklistTemplatesQuery, GetChecklistTemplatesQueryVariables>(GetChecklistTemplatesDocument, options);
        }
export function useGetChecklistTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChecklistTemplatesQuery, GetChecklistTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChecklistTemplatesQuery, GetChecklistTemplatesQueryVariables>(GetChecklistTemplatesDocument, options);
        }
export type GetChecklistTemplatesQueryHookResult = ReturnType<typeof useGetChecklistTemplatesQuery>;
export type GetChecklistTemplatesLazyQueryHookResult = ReturnType<typeof useGetChecklistTemplatesLazyQuery>;
export type GetChecklistTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetChecklistTemplatesSuspenseQuery>;
export type GetChecklistTemplatesQueryResult = Apollo.QueryResult<GetChecklistTemplatesQuery, GetChecklistTemplatesQueryVariables>;
export const GetChecklistTemplateByIdDocument = gql`
    query GetChecklistTemplateById($id: ID!) {
  getChecklistTemplateById(id: $id) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useGetChecklistTemplateByIdQuery__
 *
 * To run a query within a React component, call `useGetChecklistTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecklistTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecklistTemplateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChecklistTemplateByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChecklistTemplateByIdQuery, GetChecklistTemplateByIdQueryVariables> & ({ variables: GetChecklistTemplateByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChecklistTemplateByIdQuery, GetChecklistTemplateByIdQueryVariables>(GetChecklistTemplateByIdDocument, options);
      }
export function useGetChecklistTemplateByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChecklistTemplateByIdQuery, GetChecklistTemplateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChecklistTemplateByIdQuery, GetChecklistTemplateByIdQueryVariables>(GetChecklistTemplateByIdDocument, options);
        }
export function useGetChecklistTemplateByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChecklistTemplateByIdQuery, GetChecklistTemplateByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChecklistTemplateByIdQuery, GetChecklistTemplateByIdQueryVariables>(GetChecklistTemplateByIdDocument, options);
        }
export type GetChecklistTemplateByIdQueryHookResult = ReturnType<typeof useGetChecklistTemplateByIdQuery>;
export type GetChecklistTemplateByIdLazyQueryHookResult = ReturnType<typeof useGetChecklistTemplateByIdLazyQuery>;
export type GetChecklistTemplateByIdSuspenseQueryHookResult = ReturnType<typeof useGetChecklistTemplateByIdSuspenseQuery>;
export type GetChecklistTemplateByIdQueryResult = Apollo.QueryResult<GetChecklistTemplateByIdQuery, GetChecklistTemplateByIdQueryVariables>;
export const CreateChecklistTemplateDocument = gql`
    mutation CreateChecklistTemplate($input: CreateChecklistTemplateInput!) {
  createChecklistTemplate(input: $input) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useCreateChecklistTemplateMutation__
 *
 * To run a mutation, you first call `useCreateChecklistTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistTemplateMutation, { data, loading, error }] = useCreateChecklistTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateChecklistTemplateMutation, CreateChecklistTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateChecklistTemplateMutation, CreateChecklistTemplateMutationVariables>(CreateChecklistTemplateDocument, options);
      }
export type CreateChecklistTemplateMutationHookResult = ReturnType<typeof useCreateChecklistTemplateMutation>;
export type CreateChecklistTemplateMutationResult = Apollo.MutationResult<CreateChecklistTemplateMutation>;
export type CreateChecklistTemplateMutationOptions = Apollo.BaseMutationOptions<CreateChecklistTemplateMutation, CreateChecklistTemplateMutationVariables>;
export const SaveChecklistTemplateDraftDocument = gql`
    mutation SaveChecklistTemplateDraft($input: SaveChecklistTemplateDraftInput!) {
  saveChecklistTemplateDraft(input: $input) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useSaveChecklistTemplateDraftMutation__
 *
 * To run a mutation, you first call `useSaveChecklistTemplateDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChecklistTemplateDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChecklistTemplateDraftMutation, { data, loading, error }] = useSaveChecklistTemplateDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveChecklistTemplateDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChecklistTemplateDraftMutation, SaveChecklistTemplateDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChecklistTemplateDraftMutation, SaveChecklistTemplateDraftMutationVariables>(SaveChecklistTemplateDraftDocument, options);
      }
export type SaveChecklistTemplateDraftMutationHookResult = ReturnType<typeof useSaveChecklistTemplateDraftMutation>;
export type SaveChecklistTemplateDraftMutationResult = Apollo.MutationResult<SaveChecklistTemplateDraftMutation>;
export type SaveChecklistTemplateDraftMutationOptions = Apollo.BaseMutationOptions<SaveChecklistTemplateDraftMutation, SaveChecklistTemplateDraftMutationVariables>;
export const DiscardChecklistTemplateDraftDocument = gql`
    mutation DiscardChecklistTemplateDraft($template_id: ID!) {
  discardChecklistTemplateDraft(template_id: $template_id) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useDiscardChecklistTemplateDraftMutation__
 *
 * To run a mutation, you first call `useDiscardChecklistTemplateDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardChecklistTemplateDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardChecklistTemplateDraftMutation, { data, loading, error }] = useDiscardChecklistTemplateDraftMutation({
 *   variables: {
 *      template_id: // value for 'template_id'
 *   },
 * });
 */
export function useDiscardChecklistTemplateDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DiscardChecklistTemplateDraftMutation, DiscardChecklistTemplateDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DiscardChecklistTemplateDraftMutation, DiscardChecklistTemplateDraftMutationVariables>(DiscardChecklistTemplateDraftDocument, options);
      }
export type DiscardChecklistTemplateDraftMutationHookResult = ReturnType<typeof useDiscardChecklistTemplateDraftMutation>;
export type DiscardChecklistTemplateDraftMutationResult = Apollo.MutationResult<DiscardChecklistTemplateDraftMutation>;
export type DiscardChecklistTemplateDraftMutationOptions = Apollo.BaseMutationOptions<DiscardChecklistTemplateDraftMutation, DiscardChecklistTemplateDraftMutationVariables>;
export const PublishChecklistTemplateDocument = gql`
    mutation PublishChecklistTemplate($template_id: ID!) {
  publishChecklistTemplate(template_id: $template_id) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __usePublishChecklistTemplateMutation__
 *
 * To run a mutation, you first call `usePublishChecklistTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishChecklistTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishChecklistTemplateMutation, { data, loading, error }] = usePublishChecklistTemplateMutation({
 *   variables: {
 *      template_id: // value for 'template_id'
 *   },
 * });
 */
export function usePublishChecklistTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishChecklistTemplateMutation, PublishChecklistTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishChecklistTemplateMutation, PublishChecklistTemplateMutationVariables>(PublishChecklistTemplateDocument, options);
      }
export type PublishChecklistTemplateMutationHookResult = ReturnType<typeof usePublishChecklistTemplateMutation>;
export type PublishChecklistTemplateMutationResult = Apollo.MutationResult<PublishChecklistTemplateMutation>;
export type PublishChecklistTemplateMutationOptions = Apollo.BaseMutationOptions<PublishChecklistTemplateMutation, PublishChecklistTemplateMutationVariables>;
export const ArchiveChecklistTemplateDocument = gql`
    mutation ArchiveChecklistTemplate($template_id: ID!) {
  archiveChecklistTemplate(template_id: $template_id) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useArchiveChecklistTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveChecklistTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveChecklistTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveChecklistTemplateMutation, { data, loading, error }] = useArchiveChecklistTemplateMutation({
 *   variables: {
 *      template_id: // value for 'template_id'
 *   },
 * });
 */
export function useArchiveChecklistTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveChecklistTemplateMutation, ArchiveChecklistTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveChecklistTemplateMutation, ArchiveChecklistTemplateMutationVariables>(ArchiveChecklistTemplateDocument, options);
      }
export type ArchiveChecklistTemplateMutationHookResult = ReturnType<typeof useArchiveChecklistTemplateMutation>;
export type ArchiveChecklistTemplateMutationResult = Apollo.MutationResult<ArchiveChecklistTemplateMutation>;
export type ArchiveChecklistTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveChecklistTemplateMutation, ArchiveChecklistTemplateMutationVariables>;
export const UnarchiveChecklistTemplateDocument = gql`
    mutation UnarchiveChecklistTemplate($template_id: ID!) {
  unarchiveChecklistTemplate(template_id: $template_id) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useUnarchiveChecklistTemplateMutation__
 *
 * To run a mutation, you first call `useUnarchiveChecklistTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveChecklistTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveChecklistTemplateMutation, { data, loading, error }] = useUnarchiveChecklistTemplateMutation({
 *   variables: {
 *      template_id: // value for 'template_id'
 *   },
 * });
 */
export function useUnarchiveChecklistTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnarchiveChecklistTemplateMutation, UnarchiveChecklistTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnarchiveChecklistTemplateMutation, UnarchiveChecklistTemplateMutationVariables>(UnarchiveChecklistTemplateDocument, options);
      }
export type UnarchiveChecklistTemplateMutationHookResult = ReturnType<typeof useUnarchiveChecklistTemplateMutation>;
export type UnarchiveChecklistTemplateMutationResult = Apollo.MutationResult<UnarchiveChecklistTemplateMutation>;
export type UnarchiveChecklistTemplateMutationOptions = Apollo.BaseMutationOptions<UnarchiveChecklistTemplateMutation, UnarchiveChecklistTemplateMutationVariables>;
export const SetChecklistTemplateAssignmentsDocument = gql`
    mutation SetChecklistTemplateAssignments($input: SetChecklistTemplateAssignmentsInput!) {
  setChecklistTemplateAssignments(input: $input) {
    ...ChecklistTemplateFields
  }
}
    ${ChecklistTemplateFieldsFragmentDoc}`;

/**
 * __useSetChecklistTemplateAssignmentsMutation__
 *
 * To run a mutation, you first call `useSetChecklistTemplateAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChecklistTemplateAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChecklistTemplateAssignmentsMutation, { data, loading, error }] = useSetChecklistTemplateAssignmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChecklistTemplateAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetChecklistTemplateAssignmentsMutation, SetChecklistTemplateAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetChecklistTemplateAssignmentsMutation, SetChecklistTemplateAssignmentsMutationVariables>(SetChecklistTemplateAssignmentsDocument, options);
      }
export type SetChecklistTemplateAssignmentsMutationHookResult = ReturnType<typeof useSetChecklistTemplateAssignmentsMutation>;
export type SetChecklistTemplateAssignmentsMutationResult = Apollo.MutationResult<SetChecklistTemplateAssignmentsMutation>;
export type SetChecklistTemplateAssignmentsMutationOptions = Apollo.BaseMutationOptions<SetChecklistTemplateAssignmentsMutation, SetChecklistTemplateAssignmentsMutationVariables>;
export const PreviewChecklistTemplateAssignmentsDocument = gql`
    query PreviewChecklistTemplateAssignments($input: SetChecklistTemplateAssignmentsInput!) {
  previewChecklistTemplateAssignments(input: $input) {
    machine_count
  }
}
    `;

/**
 * __usePreviewChecklistTemplateAssignmentsQuery__
 *
 * To run a query within a React component, call `usePreviewChecklistTemplateAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewChecklistTemplateAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewChecklistTemplateAssignmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewChecklistTemplateAssignmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PreviewChecklistTemplateAssignmentsQuery, PreviewChecklistTemplateAssignmentsQueryVariables> & ({ variables: PreviewChecklistTemplateAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreviewChecklistTemplateAssignmentsQuery, PreviewChecklistTemplateAssignmentsQueryVariables>(PreviewChecklistTemplateAssignmentsDocument, options);
      }
export function usePreviewChecklistTemplateAssignmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviewChecklistTemplateAssignmentsQuery, PreviewChecklistTemplateAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreviewChecklistTemplateAssignmentsQuery, PreviewChecklistTemplateAssignmentsQueryVariables>(PreviewChecklistTemplateAssignmentsDocument, options);
        }
export function usePreviewChecklistTemplateAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PreviewChecklistTemplateAssignmentsQuery, PreviewChecklistTemplateAssignmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PreviewChecklistTemplateAssignmentsQuery, PreviewChecklistTemplateAssignmentsQueryVariables>(PreviewChecklistTemplateAssignmentsDocument, options);
        }
export type PreviewChecklistTemplateAssignmentsQueryHookResult = ReturnType<typeof usePreviewChecklistTemplateAssignmentsQuery>;
export type PreviewChecklistTemplateAssignmentsLazyQueryHookResult = ReturnType<typeof usePreviewChecklistTemplateAssignmentsLazyQuery>;
export type PreviewChecklistTemplateAssignmentsSuspenseQueryHookResult = ReturnType<typeof usePreviewChecklistTemplateAssignmentsSuspenseQuery>;
export type PreviewChecklistTemplateAssignmentsQueryResult = Apollo.QueryResult<PreviewChecklistTemplateAssignmentsQuery, PreviewChecklistTemplateAssignmentsQueryVariables>;
export const GetMyChecklistsDocument = gql`
    query GetMyChecklists($filter: FilterChecklists, $pagination: FilterPagination) {
  getChecklists(filter: $filter, pagination: $pagination) {
    page_info {
      total_pages
      current_page
      total_items
      items_per_page
    }
    items {
      ...ChecklistListFields
    }
  }
}
    ${ChecklistListFieldsFragmentDoc}`;

/**
 * __useGetMyChecklistsQuery__
 *
 * To run a query within a React component, call `useGetMyChecklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyChecklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyChecklistsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMyChecklistsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyChecklistsQuery, GetMyChecklistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyChecklistsQuery, GetMyChecklistsQueryVariables>(GetMyChecklistsDocument, options);
      }
export function useGetMyChecklistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyChecklistsQuery, GetMyChecklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyChecklistsQuery, GetMyChecklistsQueryVariables>(GetMyChecklistsDocument, options);
        }
export function useGetMyChecklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyChecklistsQuery, GetMyChecklistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyChecklistsQuery, GetMyChecklistsQueryVariables>(GetMyChecklistsDocument, options);
        }
export type GetMyChecklistsQueryHookResult = ReturnType<typeof useGetMyChecklistsQuery>;
export type GetMyChecklistsLazyQueryHookResult = ReturnType<typeof useGetMyChecklistsLazyQuery>;
export type GetMyChecklistsSuspenseQueryHookResult = ReturnType<typeof useGetMyChecklistsSuspenseQuery>;
export type GetMyChecklistsQueryResult = Apollo.QueryResult<GetMyChecklistsQuery, GetMyChecklistsQueryVariables>;
export const GetAvailableChecklistsDocument = gql`
    query GetAvailableChecklists($machine_ids: [Int!]!) {
  getAvailableChecklists(machine_ids: $machine_ids) {
    templates {
      ...ChecklistFillTemplateFields
    }
    machines {
      machine_id
      template_ids
    }
  }
}
    ${ChecklistFillTemplateFieldsFragmentDoc}`;

/**
 * __useGetAvailableChecklistsQuery__
 *
 * To run a query within a React component, call `useGetAvailableChecklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableChecklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableChecklistsQuery({
 *   variables: {
 *      machine_ids: // value for 'machine_ids'
 *   },
 * });
 */
export function useGetAvailableChecklistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAvailableChecklistsQuery, GetAvailableChecklistsQueryVariables> & ({ variables: GetAvailableChecklistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAvailableChecklistsQuery, GetAvailableChecklistsQueryVariables>(GetAvailableChecklistsDocument, options);
      }
export function useGetAvailableChecklistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAvailableChecklistsQuery, GetAvailableChecklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAvailableChecklistsQuery, GetAvailableChecklistsQueryVariables>(GetAvailableChecklistsDocument, options);
        }
export function useGetAvailableChecklistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAvailableChecklistsQuery, GetAvailableChecklistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAvailableChecklistsQuery, GetAvailableChecklistsQueryVariables>(GetAvailableChecklistsDocument, options);
        }
export type GetAvailableChecklistsQueryHookResult = ReturnType<typeof useGetAvailableChecklistsQuery>;
export type GetAvailableChecklistsLazyQueryHookResult = ReturnType<typeof useGetAvailableChecklistsLazyQuery>;
export type GetAvailableChecklistsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableChecklistsSuspenseQuery>;
export type GetAvailableChecklistsQueryResult = Apollo.QueryResult<GetAvailableChecklistsQuery, GetAvailableChecklistsQueryVariables>;
export const AddChecklistDocument = gql`
    mutation AddChecklist($input: AddChecklistInput!) {
  addChecklist(input: $input) {
    id
    serial_number
    machine_id
    template_id
    template_version_id
    template_title
    version_number
    started_at
    completed_at
    completed_date
    closing_note
    counter {
      type
      value
    }
    pass_count
    fail_count
    na_count
    created_at
    created_by {
      id
      first_name
      last_name
    }
    machine {
      id
      name
    }
  }
}
    `;

/**
 * __useAddChecklistMutation__
 *
 * To run a mutation, you first call `useAddChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChecklistMutation, { data, loading, error }] = useAddChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddChecklistMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddChecklistMutation, AddChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddChecklistMutation, AddChecklistMutationVariables>(AddChecklistDocument, options);
      }
export type AddChecklistMutationHookResult = ReturnType<typeof useAddChecklistMutation>;
export type AddChecklistMutationResult = Apollo.MutationResult<AddChecklistMutation>;
export type AddChecklistMutationOptions = Apollo.BaseMutationOptions<AddChecklistMutation, AddChecklistMutationVariables>;
export const GetChecklistByIdDocument = gql`
    query GetChecklistById($id: ID!) {
  getChecklistById(id: $id) {
    ...ChecklistDetailFields
  }
}
    ${ChecklistDetailFieldsFragmentDoc}`;

/**
 * __useGetChecklistByIdQuery__
 *
 * To run a query within a React component, call `useGetChecklistByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecklistByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecklistByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChecklistByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChecklistByIdQuery, GetChecklistByIdQueryVariables> & ({ variables: GetChecklistByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChecklistByIdQuery, GetChecklistByIdQueryVariables>(GetChecklistByIdDocument, options);
      }
export function useGetChecklistByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChecklistByIdQuery, GetChecklistByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChecklistByIdQuery, GetChecklistByIdQueryVariables>(GetChecklistByIdDocument, options);
        }
export function useGetChecklistByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChecklistByIdQuery, GetChecklistByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChecklistByIdQuery, GetChecklistByIdQueryVariables>(GetChecklistByIdDocument, options);
        }
export type GetChecklistByIdQueryHookResult = ReturnType<typeof useGetChecklistByIdQuery>;
export type GetChecklistByIdLazyQueryHookResult = ReturnType<typeof useGetChecklistByIdLazyQuery>;
export type GetChecklistByIdSuspenseQueryHookResult = ReturnType<typeof useGetChecklistByIdSuspenseQuery>;
export type GetChecklistByIdQueryResult = Apollo.QueryResult<GetChecklistByIdQuery, GetChecklistByIdQueryVariables>;
export const AddMachineConsumableDocument = gql`
    mutation AddMachineConsumable($input: AddMachineConsumableInput!) {
  addMachineConsumable(input: $input) {
    ... on MachineConsumableItem {
      item {
        ...ConsumableFields
      }
    }
  }
}
    ${ConsumableFieldsFragmentDoc}`;

/**
 * __useAddMachineConsumableMutation__
 *
 * To run a mutation, you first call `useAddMachineConsumableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMachineConsumableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMachineConsumableMutation, { data, loading, error }] = useAddMachineConsumableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMachineConsumableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMachineConsumableMutation, AddMachineConsumableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddMachineConsumableMutation, AddMachineConsumableMutationVariables>(AddMachineConsumableDocument, options);
      }
export type AddMachineConsumableMutationHookResult = ReturnType<typeof useAddMachineConsumableMutation>;
export type AddMachineConsumableMutationResult = Apollo.MutationResult<AddMachineConsumableMutation>;
export type AddMachineConsumableMutationOptions = Apollo.BaseMutationOptions<AddMachineConsumableMutation, AddMachineConsumableMutationVariables>;
export const GetUploadMachineConsumablesPresignatedUrlDocument = gql`
    query GetUploadMachineConsumablesPresignatedUrl($companyId: Int) {
  getUploadMachineConsumablesPresignatedUrl(companyId: $companyId) {
    uploadUrl
    templateUrl
    statusId
  }
}
    `;

/**
 * __useGetUploadMachineConsumablesPresignatedUrlQuery__
 *
 * To run a query within a React component, call `useGetUploadMachineConsumablesPresignatedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadMachineConsumablesPresignatedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadMachineConsumablesPresignatedUrlQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetUploadMachineConsumablesPresignatedUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUploadMachineConsumablesPresignatedUrlQuery, GetUploadMachineConsumablesPresignatedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadMachineConsumablesPresignatedUrlQuery, GetUploadMachineConsumablesPresignatedUrlQueryVariables>(GetUploadMachineConsumablesPresignatedUrlDocument, options);
      }
export function useGetUploadMachineConsumablesPresignatedUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUploadMachineConsumablesPresignatedUrlQuery, GetUploadMachineConsumablesPresignatedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadMachineConsumablesPresignatedUrlQuery, GetUploadMachineConsumablesPresignatedUrlQueryVariables>(GetUploadMachineConsumablesPresignatedUrlDocument, options);
        }
export function useGetUploadMachineConsumablesPresignatedUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUploadMachineConsumablesPresignatedUrlQuery, GetUploadMachineConsumablesPresignatedUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUploadMachineConsumablesPresignatedUrlQuery, GetUploadMachineConsumablesPresignatedUrlQueryVariables>(GetUploadMachineConsumablesPresignatedUrlDocument, options);
        }
export type GetUploadMachineConsumablesPresignatedUrlQueryHookResult = ReturnType<typeof useGetUploadMachineConsumablesPresignatedUrlQuery>;
export type GetUploadMachineConsumablesPresignatedUrlLazyQueryHookResult = ReturnType<typeof useGetUploadMachineConsumablesPresignatedUrlLazyQuery>;
export type GetUploadMachineConsumablesPresignatedUrlSuspenseQueryHookResult = ReturnType<typeof useGetUploadMachineConsumablesPresignatedUrlSuspenseQuery>;
export type GetUploadMachineConsumablesPresignatedUrlQueryResult = Apollo.QueryResult<GetUploadMachineConsumablesPresignatedUrlQuery, GetUploadMachineConsumablesPresignatedUrlQueryVariables>;
export const UpdateMachineConsumableDocument = gql`
    mutation UpdateMachineConsumable($id: Int!, $input: UpdateMachineConsumableInput!) {
  updateMachineConsumable(id: $id, input: $input) {
    ... on MachineConsumableItem {
      item {
        ...ConsumableFields
      }
    }
  }
}
    ${ConsumableFieldsFragmentDoc}`;

/**
 * __useUpdateMachineConsumableMutation__
 *
 * To run a mutation, you first call `useUpdateMachineConsumableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineConsumableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineConsumableMutation, { data, loading, error }] = useUpdateMachineConsumableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineConsumableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMachineConsumableMutation, UpdateMachineConsumableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMachineConsumableMutation, UpdateMachineConsumableMutationVariables>(UpdateMachineConsumableDocument, options);
      }
export type UpdateMachineConsumableMutationHookResult = ReturnType<typeof useUpdateMachineConsumableMutation>;
export type UpdateMachineConsumableMutationResult = Apollo.MutationResult<UpdateMachineConsumableMutation>;
export type UpdateMachineConsumableMutationOptions = Apollo.BaseMutationOptions<UpdateMachineConsumableMutation, UpdateMachineConsumableMutationVariables>;
export const DeleteMachineConsumableDocument = gql`
    mutation DeleteMachineConsumable($id: Int!) {
  deleteMachineConsumable(id: $id) {
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useDeleteMachineConsumableMutation__
 *
 * To run a mutation, you first call `useDeleteMachineConsumableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineConsumableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineConsumableMutation, { data, loading, error }] = useDeleteMachineConsumableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMachineConsumableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMachineConsumableMutation, DeleteMachineConsumableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMachineConsumableMutation, DeleteMachineConsumableMutationVariables>(DeleteMachineConsumableDocument, options);
      }
export type DeleteMachineConsumableMutationHookResult = ReturnType<typeof useDeleteMachineConsumableMutation>;
export type DeleteMachineConsumableMutationResult = Apollo.MutationResult<DeleteMachineConsumableMutation>;
export type DeleteMachineConsumableMutationOptions = Apollo.BaseMutationOptions<DeleteMachineConsumableMutation, DeleteMachineConsumableMutationVariables>;
export const AddDocumentDocument = gql`
    mutation AddDocument($input: AddDocumentInput!) {
  addDocument(input: $input) {
    ... on ItemDocument {
      item {
        ...DocumentFields
      }
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useAddDocumentMutation__
 *
 * To run a mutation, you first call `useAddDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentMutation, { data, loading, error }] = useAddDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddDocumentMutation, AddDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddDocumentMutation, AddDocumentMutationVariables>(AddDocumentDocument, options);
      }
export type AddDocumentMutationHookResult = ReturnType<typeof useAddDocumentMutation>;
export type AddDocumentMutationResult = Apollo.MutationResult<AddDocumentMutation>;
export type AddDocumentMutationOptions = Apollo.BaseMutationOptions<AddDocumentMutation, AddDocumentMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    ... on ItemDocument {
      item {
        ...DocumentFields
      }
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UpdateDocumentTagsDocument = gql`
    mutation UpdateDocumentTags($document_id: ID!, $tag_ids: [ID!]!) {
  updateDocumentTags(input: {document_id: $document_id, tag_ids: $tag_ids}) {
    item {
      ...DocumentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useUpdateDocumentTagsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentTagsMutation, { data, loading, error }] = useUpdateDocumentTagsMutation({
 *   variables: {
 *      document_id: // value for 'document_id'
 *      tag_ids: // value for 'tag_ids'
 *   },
 * });
 */
export function useUpdateDocumentTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDocumentTagsMutation, UpdateDocumentTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentTagsMutation, UpdateDocumentTagsMutationVariables>(UpdateDocumentTagsDocument, options);
      }
export type UpdateDocumentTagsMutationHookResult = ReturnType<typeof useUpdateDocumentTagsMutation>;
export type UpdateDocumentTagsMutationResult = Apollo.MutationResult<UpdateDocumentTagsMutation>;
export type UpdateDocumentTagsMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentTagsMutation, UpdateDocumentTagsMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($document_id: ID!) {
  deleteDocument(document_id: $document_id)
}
    `;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      document_id: // value for 'document_id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const GetDocumentsDocument = gql`
    query GetDocuments($context: Context!, $filter: GetDocumentsFilter) {
  getDocuments(context: $context, filter: $filter) {
    items {
      ...DocumentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables> & ({ variables: GetDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
      }
export function useGetDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export function useGetDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export type GetDocumentsQueryHookResult = ReturnType<typeof useGetDocumentsQuery>;
export type GetDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLazyQuery>;
export type GetDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsSuspenseQuery>;
export type GetDocumentsQueryResult = Apollo.QueryResult<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const ConfirmEmailChangeDocument = gql`
    mutation ConfirmEmailChange {
  confirmEmailChange
}
    `;

/**
 * __useConfirmEmailChangeMutation__
 *
 * To run a mutation, you first call `useConfirmEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailChangeMutation, { data, loading, error }] = useConfirmEmailChangeMutation({
 *   variables: {
 *   },
 * });
 */
export function useConfirmEmailChangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmEmailChangeMutation, ConfirmEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmEmailChangeMutation, ConfirmEmailChangeMutationVariables>(ConfirmEmailChangeDocument, options);
      }
export type ConfirmEmailChangeMutationHookResult = ReturnType<typeof useConfirmEmailChangeMutation>;
export type ConfirmEmailChangeMutationResult = Apollo.MutationResult<ConfirmEmailChangeMutation>;
export type ConfirmEmailChangeMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailChangeMutation, ConfirmEmailChangeMutationVariables>;
export const RemoveRoleDocument = gql`
    mutation RemoveRole($role_id: Int!) {
  deleteRole(id: $role_id) {
    ... on AuthCheckDeleteRole {
      item {
        ...EmployeeFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${EmployeeFieldsFragmentDoc}`;

/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      role_id: // value for 'role_id'
 *   },
 * });
 */
export function useRemoveRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveRoleMutation, RemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveRoleMutation, RemoveRoleMutationVariables>(RemoveRoleDocument, options);
      }
export type RemoveRoleMutationHookResult = ReturnType<typeof useRemoveRoleMutation>;
export type RemoveRoleMutationResult = Apollo.MutationResult<RemoveRoleMutation>;
export type RemoveRoleMutationOptions = Apollo.BaseMutationOptions<RemoveRoleMutation, RemoveRoleMutationVariables>;
export const AddRoleDocument = gql`
    mutation AddRole($id: Int, $email: String, $company_id: Int!, $business_unit_id: Int, $project_id: Int, $role_type: RoleNamesToInvite!) {
  addRole(
    input: {id: $id, email: $email, company_id: $company_id, business_unit_id: $business_unit_id, project_id: $project_id, role_type: $role_type}
  ) {
    ... on AuthCheckAddRole {
      item {
        ... on Employee {
          ...EmployeeFields
        }
        ... on Invitation {
          ...InvitationFields
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${EmployeeFieldsFragmentDoc}
${InvitationFieldsFragmentDoc}`;

/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleMutation, { data, loading, error }] = useAddRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      company_id: // value for 'company_id'
 *      business_unit_id: // value for 'business_unit_id'
 *      project_id: // value for 'project_id'
 *      role_type: // value for 'role_type'
 *   },
 * });
 */
export function useAddRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddRoleMutation, AddRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddRoleMutation, AddRoleMutationVariables>(AddRoleDocument, options);
      }
export type AddRoleMutationHookResult = ReturnType<typeof useAddRoleMutation>;
export type AddRoleMutationResult = Apollo.MutationResult<AddRoleMutation>;
export type AddRoleMutationOptions = Apollo.BaseMutationOptions<AddRoleMutation, AddRoleMutationVariables>;
export const GetEmployeeByUserIdDocument = gql`
    query GetEmployeeByUserId($context: Context!, $user_id: Int) {
  getEmployees(context: $context, filter: {user_id: $user_id}) {
    ... on AuthCheckGetEmployees {
      items {
        ...EmployeeFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${EmployeeFieldsFragmentDoc}`;

/**
 * __useGetEmployeeByUserIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeeByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeByUserIdQuery({
 *   variables: {
 *      context: // value for 'context'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetEmployeeByUserIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables> & ({ variables: GetEmployeeByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>(GetEmployeeByUserIdDocument, options);
      }
export function useGetEmployeeByUserIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>(GetEmployeeByUserIdDocument, options);
        }
export function useGetEmployeeByUserIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>(GetEmployeeByUserIdDocument, options);
        }
export type GetEmployeeByUserIdQueryHookResult = ReturnType<typeof useGetEmployeeByUserIdQuery>;
export type GetEmployeeByUserIdLazyQueryHookResult = ReturnType<typeof useGetEmployeeByUserIdLazyQuery>;
export type GetEmployeeByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeByUserIdSuspenseQuery>;
export type GetEmployeeByUserIdQueryResult = Apollo.QueryResult<GetEmployeeByUserIdQuery, GetEmployeeByUserIdQueryVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($context: Context!, $filter: FilterEmployee) {
  getEmployees(context: $context, filter: $filter) {
    ... on AuthCheckGetEmployees {
      items {
        ...EmployeeFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${EmployeeFieldsFragmentDoc}`;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables> & ({ variables: GetEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export function useGetEmployeesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesSuspenseQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetInvitationsByContextDocument = gql`
    query GetInvitationsByContext($context: Context!) {
  getInvitationsByContext(context: $context) {
    ...InvitationFields
  }
}
    ${InvitationFieldsFragmentDoc}`;

/**
 * __useGetInvitationsByContextQuery__
 *
 * To run a query within a React component, call `useGetInvitationsByContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsByContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsByContextQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetInvitationsByContextQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInvitationsByContextQuery, GetInvitationsByContextQueryVariables> & ({ variables: GetInvitationsByContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInvitationsByContextQuery, GetInvitationsByContextQueryVariables>(GetInvitationsByContextDocument, options);
      }
export function useGetInvitationsByContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvitationsByContextQuery, GetInvitationsByContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInvitationsByContextQuery, GetInvitationsByContextQueryVariables>(GetInvitationsByContextDocument, options);
        }
export function useGetInvitationsByContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInvitationsByContextQuery, GetInvitationsByContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInvitationsByContextQuery, GetInvitationsByContextQueryVariables>(GetInvitationsByContextDocument, options);
        }
export type GetInvitationsByContextQueryHookResult = ReturnType<typeof useGetInvitationsByContextQuery>;
export type GetInvitationsByContextLazyQueryHookResult = ReturnType<typeof useGetInvitationsByContextLazyQuery>;
export type GetInvitationsByContextSuspenseQueryHookResult = ReturnType<typeof useGetInvitationsByContextSuspenseQuery>;
export type GetInvitationsByContextQueryResult = Apollo.QueryResult<GetInvitationsByContextQuery, GetInvitationsByContextQueryVariables>;
export const ResendCompanyInvitationDocument = gql`
    mutation ResendCompanyInvitation($id: ID!) {
  resendCompanyInvitation(id: $id) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useResendCompanyInvitationMutation__
 *
 * To run a mutation, you first call `useResendCompanyInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCompanyInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCompanyInvitationMutation, { data, loading, error }] = useResendCompanyInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendCompanyInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendCompanyInvitationMutation, ResendCompanyInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendCompanyInvitationMutation, ResendCompanyInvitationMutationVariables>(ResendCompanyInvitationDocument, options);
      }
export type ResendCompanyInvitationMutationHookResult = ReturnType<typeof useResendCompanyInvitationMutation>;
export type ResendCompanyInvitationMutationResult = Apollo.MutationResult<ResendCompanyInvitationMutation>;
export type ResendCompanyInvitationMutationOptions = Apollo.BaseMutationOptions<ResendCompanyInvitationMutation, ResendCompanyInvitationMutationVariables>;
export const DeleteCompanyInvitationDocument = gql`
    mutation DeleteCompanyInvitation($id: ID!) {
  deleteCompanyInvitation(id: $id) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useDeleteCompanyInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyInvitationMutation, { data, loading, error }] = useDeleteCompanyInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCompanyInvitationMutation, DeleteCompanyInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCompanyInvitationMutation, DeleteCompanyInvitationMutationVariables>(DeleteCompanyInvitationDocument, options);
      }
export type DeleteCompanyInvitationMutationHookResult = ReturnType<typeof useDeleteCompanyInvitationMutation>;
export type DeleteCompanyInvitationMutationResult = Apollo.MutationResult<DeleteCompanyInvitationMutation>;
export type DeleteCompanyInvitationMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyInvitationMutation, DeleteCompanyInvitationMutationVariables>;
export const AddManagedEmployeeDocument = gql`
    mutation AddManagedEmployee($input: AddManagedEmployeeInput!) {
  addManagedEmployee(input: $input) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;

/**
 * __useAddManagedEmployeeMutation__
 *
 * To run a mutation, you first call `useAddManagedEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManagedEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManagedEmployeeMutation, { data, loading, error }] = useAddManagedEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddManagedEmployeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddManagedEmployeeMutation, AddManagedEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddManagedEmployeeMutation, AddManagedEmployeeMutationVariables>(AddManagedEmployeeDocument, options);
      }
export type AddManagedEmployeeMutationHookResult = ReturnType<typeof useAddManagedEmployeeMutation>;
export type AddManagedEmployeeMutationResult = Apollo.MutationResult<AddManagedEmployeeMutation>;
export type AddManagedEmployeeMutationOptions = Apollo.BaseMutationOptions<AddManagedEmployeeMutation, AddManagedEmployeeMutationVariables>;
export const SetManagedEmployeePasswordDocument = gql`
    mutation SetManagedEmployeePassword($input: SetManagedEmployeePasswordInput!) {
  setManagedEmployeePassword(input: $input) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
      errorCode
    }
  }
}
    `;

/**
 * __useSetManagedEmployeePasswordMutation__
 *
 * To run a mutation, you first call `useSetManagedEmployeePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetManagedEmployeePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setManagedEmployeePasswordMutation, { data, loading, error }] = useSetManagedEmployeePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetManagedEmployeePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetManagedEmployeePasswordMutation, SetManagedEmployeePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetManagedEmployeePasswordMutation, SetManagedEmployeePasswordMutationVariables>(SetManagedEmployeePasswordDocument, options);
      }
export type SetManagedEmployeePasswordMutationHookResult = ReturnType<typeof useSetManagedEmployeePasswordMutation>;
export type SetManagedEmployeePasswordMutationResult = Apollo.MutationResult<SetManagedEmployeePasswordMutation>;
export type SetManagedEmployeePasswordMutationOptions = Apollo.BaseMutationOptions<SetManagedEmployeePasswordMutation, SetManagedEmployeePasswordMutationVariables>;
export const GetAllEmployeesDocument = gql`
    query GetAllEmployees($context: Context!, $query: String!, $roleFilter: [RoleNames]) {
  getEmployees(context: $context, filter: {query: $query, roles: $roleFilter}) {
    ... on AuthCheckGetEmployees {
      items {
        ...EmployeeFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${EmployeeFieldsFragmentDoc}`;

/**
 * __useGetAllEmployeesQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeesQuery({
 *   variables: {
 *      context: // value for 'context'
 *      query: // value for 'query'
 *      roleFilter: // value for 'roleFilter'
 *   },
 * });
 */
export function useGetAllEmployeesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables> & ({ variables: GetAllEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
      }
export function useGetAllEmployeesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
        }
export function useGetAllEmployeesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
        }
export type GetAllEmployeesQueryHookResult = ReturnType<typeof useGetAllEmployeesQuery>;
export type GetAllEmployeesLazyQueryHookResult = ReturnType<typeof useGetAllEmployeesLazyQuery>;
export type GetAllEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetAllEmployeesSuspenseQuery>;
export type GetAllEmployeesQueryResult = Apollo.QueryResult<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>;
export const GetAllUsersDocument = gql`
    query GetAllUsers($context: Context!, $query: String!) {
  getUsers(context: $context, filter: {query: $query}) {
    ... on AuthCheckGetUsers {
      items {
        full_name @client
        first_name
        last_name
        email
        id
        dni
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      context: // value for 'context'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables> & ({ variables: GetAllUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export function useGetAllUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetEmployeeIdentityClaimDocument = gql`
    query GetEmployeeIdentityClaim($context: Context!, $user_id: Int!) {
  getEmployees(context: $context, filter: {user_id: $user_id}) {
    ... on AuthCheckGetEmployees {
      items {
        id
        identity_claim {
          requested_email
          kind
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetEmployeeIdentityClaimQuery__
 *
 * To run a query within a React component, call `useGetEmployeeIdentityClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeIdentityClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeIdentityClaimQuery({
 *   variables: {
 *      context: // value for 'context'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetEmployeeIdentityClaimQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEmployeeIdentityClaimQuery, GetEmployeeIdentityClaimQueryVariables> & ({ variables: GetEmployeeIdentityClaimQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmployeeIdentityClaimQuery, GetEmployeeIdentityClaimQueryVariables>(GetEmployeeIdentityClaimDocument, options);
      }
export function useGetEmployeeIdentityClaimLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmployeeIdentityClaimQuery, GetEmployeeIdentityClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmployeeIdentityClaimQuery, GetEmployeeIdentityClaimQueryVariables>(GetEmployeeIdentityClaimDocument, options);
        }
export function useGetEmployeeIdentityClaimSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmployeeIdentityClaimQuery, GetEmployeeIdentityClaimQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEmployeeIdentityClaimQuery, GetEmployeeIdentityClaimQueryVariables>(GetEmployeeIdentityClaimDocument, options);
        }
export type GetEmployeeIdentityClaimQueryHookResult = ReturnType<typeof useGetEmployeeIdentityClaimQuery>;
export type GetEmployeeIdentityClaimLazyQueryHookResult = ReturnType<typeof useGetEmployeeIdentityClaimLazyQuery>;
export type GetEmployeeIdentityClaimSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeIdentityClaimSuspenseQuery>;
export type GetEmployeeIdentityClaimQueryResult = Apollo.QueryResult<GetEmployeeIdentityClaimQuery, GetEmployeeIdentityClaimQueryVariables>;
export const RequestIdentityClaimForUserDocument = gql`
    mutation RequestIdentityClaimForUser($user_id: Int!, $email: String!) {
  requestIdentityClaimForUser(input: {user_id: $user_id, email: $email}) {
    requested_email
    kind
  }
}
    `;

/**
 * __useRequestIdentityClaimForUserMutation__
 *
 * To run a mutation, you first call `useRequestIdentityClaimForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestIdentityClaimForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestIdentityClaimForUserMutation, { data, loading, error }] = useRequestIdentityClaimForUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestIdentityClaimForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestIdentityClaimForUserMutation, RequestIdentityClaimForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestIdentityClaimForUserMutation, RequestIdentityClaimForUserMutationVariables>(RequestIdentityClaimForUserDocument, options);
      }
export type RequestIdentityClaimForUserMutationHookResult = ReturnType<typeof useRequestIdentityClaimForUserMutation>;
export type RequestIdentityClaimForUserMutationResult = Apollo.MutationResult<RequestIdentityClaimForUserMutation>;
export type RequestIdentityClaimForUserMutationOptions = Apollo.BaseMutationOptions<RequestIdentityClaimForUserMutation, RequestIdentityClaimForUserMutationVariables>;
export const CancelIdentityClaimForUserDocument = gql`
    mutation CancelIdentityClaimForUser($user_id: Int!) {
  cancelIdentityClaimForUser(input: {user_id: $user_id})
}
    `;

/**
 * __useCancelIdentityClaimForUserMutation__
 *
 * To run a mutation, you first call `useCancelIdentityClaimForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelIdentityClaimForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelIdentityClaimForUserMutation, { data, loading, error }] = useCancelIdentityClaimForUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useCancelIdentityClaimForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelIdentityClaimForUserMutation, CancelIdentityClaimForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelIdentityClaimForUserMutation, CancelIdentityClaimForUserMutationVariables>(CancelIdentityClaimForUserDocument, options);
      }
export type CancelIdentityClaimForUserMutationHookResult = ReturnType<typeof useCancelIdentityClaimForUserMutation>;
export type CancelIdentityClaimForUserMutationResult = Apollo.MutationResult<CancelIdentityClaimForUserMutation>;
export type CancelIdentityClaimForUserMutationOptions = Apollo.BaseMutationOptions<CancelIdentityClaimForUserMutation, CancelIdentityClaimForUserMutationVariables>;
export const AddFixedAssetDocument = gql`
    mutation AddFixedAsset($input: AddFixedAssetInput!) {
  addFixedAsset(input: $input) {
    ... on AddFixedAssetResponse {
      ...MachineFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useAddFixedAssetMutation__
 *
 * To run a mutation, you first call `useAddFixedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFixedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFixedAssetMutation, { data, loading, error }] = useAddFixedAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFixedAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFixedAssetMutation, AddFixedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFixedAssetMutation, AddFixedAssetMutationVariables>(AddFixedAssetDocument, options);
      }
export type AddFixedAssetMutationHookResult = ReturnType<typeof useAddFixedAssetMutation>;
export type AddFixedAssetMutationResult = Apollo.MutationResult<AddFixedAssetMutation>;
export type AddFixedAssetMutationOptions = Apollo.BaseMutationOptions<AddFixedAssetMutation, AddFixedAssetMutationVariables>;
export const UpdateFixedAssetDocument = gql`
    mutation UpdateFixedAsset($id: Int!, $input: UpdateFixedAssetInput!) {
  updateFixedAsset(id: $id, input: $input) {
    ... on UpdateFixedAssetResponse {
      ...MachineFields
      ...ServicesFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}
${ServicesFieldsFragmentDoc}`;

/**
 * __useUpdateFixedAssetMutation__
 *
 * To run a mutation, you first call `useUpdateFixedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFixedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFixedAssetMutation, { data, loading, error }] = useUpdateFixedAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFixedAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFixedAssetMutation, UpdateFixedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFixedAssetMutation, UpdateFixedAssetMutationVariables>(UpdateFixedAssetDocument, options);
      }
export type UpdateFixedAssetMutationHookResult = ReturnType<typeof useUpdateFixedAssetMutation>;
export type UpdateFixedAssetMutationResult = Apollo.MutationResult<UpdateFixedAssetMutation>;
export type UpdateFixedAssetMutationOptions = Apollo.BaseMutationOptions<UpdateFixedAssetMutation, UpdateFixedAssetMutationVariables>;
export const GetFixedAssetByIdDocument = gql`
    query GetFixedAssetById($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetFixedAssetByIdQuery__
 *
 * To run a query within a React component, call `useGetFixedAssetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixedAssetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixedAssetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFixedAssetByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFixedAssetByIdQuery, GetFixedAssetByIdQueryVariables> & ({ variables: GetFixedAssetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFixedAssetByIdQuery, GetFixedAssetByIdQueryVariables>(GetFixedAssetByIdDocument, options);
      }
export function useGetFixedAssetByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFixedAssetByIdQuery, GetFixedAssetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFixedAssetByIdQuery, GetFixedAssetByIdQueryVariables>(GetFixedAssetByIdDocument, options);
        }
export function useGetFixedAssetByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFixedAssetByIdQuery, GetFixedAssetByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFixedAssetByIdQuery, GetFixedAssetByIdQueryVariables>(GetFixedAssetByIdDocument, options);
        }
export type GetFixedAssetByIdQueryHookResult = ReturnType<typeof useGetFixedAssetByIdQuery>;
export type GetFixedAssetByIdLazyQueryHookResult = ReturnType<typeof useGetFixedAssetByIdLazyQuery>;
export type GetFixedAssetByIdSuspenseQueryHookResult = ReturnType<typeof useGetFixedAssetByIdSuspenseQuery>;
export type GetFixedAssetByIdQueryResult = Apollo.QueryResult<GetFixedAssetByIdQuery, GetFixedAssetByIdQueryVariables>;
export const GetFixedAssetsDocument = gql`
    query GetFixedAssets($context: Context) {
  getMachines(context: $context, filter: {group: ACTIVO_FIJO}) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetFixedAssetsQuery__
 *
 * To run a query within a React component, call `useGetFixedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixedAssetsQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetFixedAssetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFixedAssetsQuery, GetFixedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFixedAssetsQuery, GetFixedAssetsQueryVariables>(GetFixedAssetsDocument, options);
      }
export function useGetFixedAssetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFixedAssetsQuery, GetFixedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFixedAssetsQuery, GetFixedAssetsQueryVariables>(GetFixedAssetsDocument, options);
        }
export function useGetFixedAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFixedAssetsQuery, GetFixedAssetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFixedAssetsQuery, GetFixedAssetsQueryVariables>(GetFixedAssetsDocument, options);
        }
export type GetFixedAssetsQueryHookResult = ReturnType<typeof useGetFixedAssetsQuery>;
export type GetFixedAssetsLazyQueryHookResult = ReturnType<typeof useGetFixedAssetsLazyQuery>;
export type GetFixedAssetsSuspenseQueryHookResult = ReturnType<typeof useGetFixedAssetsSuspenseQuery>;
export type GetFixedAssetsQueryResult = Apollo.QueryResult<GetFixedAssetsQuery, GetFixedAssetsQueryVariables>;
export const AddFuelProviderDocument = gql`
    mutation AddFuelProvider($input: AddFuelProviderInput!) {
  addFuelProvider(input: $input) {
    ...FuelProviderFields
  }
}
    ${FuelProviderFieldsFragmentDoc}`;

/**
 * __useAddFuelProviderMutation__
 *
 * To run a mutation, you first call `useAddFuelProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFuelProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFuelProviderMutation, { data, loading, error }] = useAddFuelProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFuelProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFuelProviderMutation, AddFuelProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFuelProviderMutation, AddFuelProviderMutationVariables>(AddFuelProviderDocument, options);
      }
export type AddFuelProviderMutationHookResult = ReturnType<typeof useAddFuelProviderMutation>;
export type AddFuelProviderMutationResult = Apollo.MutationResult<AddFuelProviderMutation>;
export type AddFuelProviderMutationOptions = Apollo.BaseMutationOptions<AddFuelProviderMutation, AddFuelProviderMutationVariables>;
export const UpdateFuelProviderDocument = gql`
    mutation UpdateFuelProvider($id: ID!, $input: UpdateFuelProviderInput!) {
  updateFuelProvider(id: $id, input: $input) {
    ...FuelProviderFields
  }
}
    ${FuelProviderFieldsFragmentDoc}`;

/**
 * __useUpdateFuelProviderMutation__
 *
 * To run a mutation, you first call `useUpdateFuelProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFuelProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFuelProviderMutation, { data, loading, error }] = useUpdateFuelProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFuelProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFuelProviderMutation, UpdateFuelProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFuelProviderMutation, UpdateFuelProviderMutationVariables>(UpdateFuelProviderDocument, options);
      }
export type UpdateFuelProviderMutationHookResult = ReturnType<typeof useUpdateFuelProviderMutation>;
export type UpdateFuelProviderMutationResult = Apollo.MutationResult<UpdateFuelProviderMutation>;
export type UpdateFuelProviderMutationOptions = Apollo.BaseMutationOptions<UpdateFuelProviderMutation, UpdateFuelProviderMutationVariables>;
export const DeleteFuelProviderDocument = gql`
    mutation DeleteFuelProvider($id: ID!) {
  deleteFuelProvider(id: $id)
}
    `;

/**
 * __useDeleteFuelProviderMutation__
 *
 * To run a mutation, you first call `useDeleteFuelProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFuelProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFuelProviderMutation, { data, loading, error }] = useDeleteFuelProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFuelProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFuelProviderMutation, DeleteFuelProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFuelProviderMutation, DeleteFuelProviderMutationVariables>(DeleteFuelProviderDocument, options);
      }
export type DeleteFuelProviderMutationHookResult = ReturnType<typeof useDeleteFuelProviderMutation>;
export type DeleteFuelProviderMutationResult = Apollo.MutationResult<DeleteFuelProviderMutation>;
export type DeleteFuelProviderMutationOptions = Apollo.BaseMutationOptions<DeleteFuelProviderMutation, DeleteFuelProviderMutationVariables>;
export const SetMachinesFuelParticipationDocument = gql`
    mutation SetMachinesFuelParticipation($ids: [Int!]!, $fuel_participation: FuelParticipation!) {
  setMachinesFuelParticipation(ids: $ids, fuel_participation: $fuel_participation) {
    ...MachineFields
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useSetMachinesFuelParticipationMutation__
 *
 * To run a mutation, you first call `useSetMachinesFuelParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMachinesFuelParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMachinesFuelParticipationMutation, { data, loading, error }] = useSetMachinesFuelParticipationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      fuel_participation: // value for 'fuel_participation'
 *   },
 * });
 */
export function useSetMachinesFuelParticipationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMachinesFuelParticipationMutation, SetMachinesFuelParticipationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMachinesFuelParticipationMutation, SetMachinesFuelParticipationMutationVariables>(SetMachinesFuelParticipationDocument, options);
      }
export type SetMachinesFuelParticipationMutationHookResult = ReturnType<typeof useSetMachinesFuelParticipationMutation>;
export type SetMachinesFuelParticipationMutationResult = Apollo.MutationResult<SetMachinesFuelParticipationMutation>;
export type SetMachinesFuelParticipationMutationOptions = Apollo.BaseMutationOptions<SetMachinesFuelParticipationMutation, SetMachinesFuelParticipationMutationVariables>;
export const AddFuelDispatchReportDocument = gql`
    mutation AddFuelDispatchReport($input: AddFuelDispatchedReportInput!) {
  addFuelDispatchedReport(input: $input) {
    ... on FuelDispatchedReport {
      ...FuelDispatchReportFields
    }
  }
}
    ${FuelDispatchReportFieldsFragmentDoc}`;

/**
 * __useAddFuelDispatchReportMutation__
 *
 * To run a mutation, you first call `useAddFuelDispatchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFuelDispatchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFuelDispatchReportMutation, { data, loading, error }] = useAddFuelDispatchReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFuelDispatchReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFuelDispatchReportMutation, AddFuelDispatchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFuelDispatchReportMutation, AddFuelDispatchReportMutationVariables>(AddFuelDispatchReportDocument, options);
      }
export type AddFuelDispatchReportMutationHookResult = ReturnType<typeof useAddFuelDispatchReportMutation>;
export type AddFuelDispatchReportMutationResult = Apollo.MutationResult<AddFuelDispatchReportMutation>;
export type AddFuelDispatchReportMutationOptions = Apollo.BaseMutationOptions<AddFuelDispatchReportMutation, AddFuelDispatchReportMutationVariables>;
export const AddStockControlReportDocument = gql`
    mutation AddStockControlReport($input: AddStockControlReportInput!) {
  addStockControlReport(input: $input) {
    ... on StockControlReport {
      ...StockControlReportFields
    }
    ... on DuplicatedReportDateError {
      message
    }
  }
}
    ${StockControlReportFieldsFragmentDoc}`;

/**
 * __useAddStockControlReportMutation__
 *
 * To run a mutation, you first call `useAddStockControlReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStockControlReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStockControlReportMutation, { data, loading, error }] = useAddStockControlReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStockControlReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddStockControlReportMutation, AddStockControlReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddStockControlReportMutation, AddStockControlReportMutationVariables>(AddStockControlReportDocument, options);
      }
export type AddStockControlReportMutationHookResult = ReturnType<typeof useAddStockControlReportMutation>;
export type AddStockControlReportMutationResult = Apollo.MutationResult<AddStockControlReportMutation>;
export type AddStockControlReportMutationOptions = Apollo.BaseMutationOptions<AddStockControlReportMutation, AddStockControlReportMutationVariables>;
export const UpdateStockControlReportDocument = gql`
    mutation UpdateStockControlReport($id: ID!, $input: UpdateStockControlReportInput!) {
  updateStockControlReport(id: $id, input: $input) {
    ... on StockControlReport {
      ...StockControlReportFields
    }
  }
}
    ${StockControlReportFieldsFragmentDoc}`;

/**
 * __useUpdateStockControlReportMutation__
 *
 * To run a mutation, you first call `useUpdateStockControlReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockControlReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockControlReportMutation, { data, loading, error }] = useUpdateStockControlReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockControlReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStockControlReportMutation, UpdateStockControlReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStockControlReportMutation, UpdateStockControlReportMutationVariables>(UpdateStockControlReportDocument, options);
      }
export type UpdateStockControlReportMutationHookResult = ReturnType<typeof useUpdateStockControlReportMutation>;
export type UpdateStockControlReportMutationResult = Apollo.MutationResult<UpdateStockControlReportMutation>;
export type UpdateStockControlReportMutationOptions = Apollo.BaseMutationOptions<UpdateStockControlReportMutation, UpdateStockControlReportMutationVariables>;
export const UpdateFuelDispatchReportDocument = gql`
    mutation UpdateFuelDispatchReport($id: ID!, $input: UpdateFuelDispatchedReportInput!) {
  updateFuelDispatchedReport(id: $id, input: $input) {
    ... on FuelDispatchedReport {
      ...FuelDispatchReportFields
    }
  }
}
    ${FuelDispatchReportFieldsFragmentDoc}`;

/**
 * __useUpdateFuelDispatchReportMutation__
 *
 * To run a mutation, you first call `useUpdateFuelDispatchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFuelDispatchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFuelDispatchReportMutation, { data, loading, error }] = useUpdateFuelDispatchReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFuelDispatchReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFuelDispatchReportMutation, UpdateFuelDispatchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFuelDispatchReportMutation, UpdateFuelDispatchReportMutationVariables>(UpdateFuelDispatchReportDocument, options);
      }
export type UpdateFuelDispatchReportMutationHookResult = ReturnType<typeof useUpdateFuelDispatchReportMutation>;
export type UpdateFuelDispatchReportMutationResult = Apollo.MutationResult<UpdateFuelDispatchReportMutation>;
export type UpdateFuelDispatchReportMutationOptions = Apollo.BaseMutationOptions<UpdateFuelDispatchReportMutation, UpdateFuelDispatchReportMutationVariables>;
export const DeleteStockControlReportDocument = gql`
    mutation DeleteStockControlReport($id: ID!) {
  deleteStockControlReport(id: $id)
}
    `;

/**
 * __useDeleteStockControlReportMutation__
 *
 * To run a mutation, you first call `useDeleteStockControlReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStockControlReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStockControlReportMutation, { data, loading, error }] = useDeleteStockControlReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStockControlReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStockControlReportMutation, DeleteStockControlReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteStockControlReportMutation, DeleteStockControlReportMutationVariables>(DeleteStockControlReportDocument, options);
      }
export type DeleteStockControlReportMutationHookResult = ReturnType<typeof useDeleteStockControlReportMutation>;
export type DeleteStockControlReportMutationResult = Apollo.MutationResult<DeleteStockControlReportMutation>;
export type DeleteStockControlReportMutationOptions = Apollo.BaseMutationOptions<DeleteStockControlReportMutation, DeleteStockControlReportMutationVariables>;
export const DeleteFuelDispatchReportDocument = gql`
    mutation DeleteFuelDispatchReport($id: ID!) {
  deleteFuelDispatchedReport(id: $id)
}
    `;

/**
 * __useDeleteFuelDispatchReportMutation__
 *
 * To run a mutation, you first call `useDeleteFuelDispatchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFuelDispatchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFuelDispatchReportMutation, { data, loading, error }] = useDeleteFuelDispatchReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFuelDispatchReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFuelDispatchReportMutation, DeleteFuelDispatchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFuelDispatchReportMutation, DeleteFuelDispatchReportMutationVariables>(DeleteFuelDispatchReportDocument, options);
      }
export type DeleteFuelDispatchReportMutationHookResult = ReturnType<typeof useDeleteFuelDispatchReportMutation>;
export type DeleteFuelDispatchReportMutationResult = Apollo.MutationResult<DeleteFuelDispatchReportMutation>;
export type DeleteFuelDispatchReportMutationOptions = Apollo.BaseMutationOptions<DeleteFuelDispatchReportMutation, DeleteFuelDispatchReportMutationVariables>;
export const GetMachinesFuelDashboardDocument = gql`
    query GetMachinesFuelDashboard($context: Context!, $filter: GetMachinesFuelDashboardFilter!) {
  getMachinesFuelDashboard(context: $context, filter: $filter) {
    items {
      ...MachinesFuelDashboardFields
    }
  }
}
    ${MachinesFuelDashboardFieldsFragmentDoc}`;

/**
 * __useGetMachinesFuelDashboardQuery__
 *
 * To run a query within a React component, call `useGetMachinesFuelDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesFuelDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesFuelDashboardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMachinesFuelDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachinesFuelDashboardQuery, GetMachinesFuelDashboardQueryVariables> & ({ variables: GetMachinesFuelDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinesFuelDashboardQuery, GetMachinesFuelDashboardQueryVariables>(GetMachinesFuelDashboardDocument, options);
      }
export function useGetMachinesFuelDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinesFuelDashboardQuery, GetMachinesFuelDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinesFuelDashboardQuery, GetMachinesFuelDashboardQueryVariables>(GetMachinesFuelDashboardDocument, options);
        }
export function useGetMachinesFuelDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesFuelDashboardQuery, GetMachinesFuelDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinesFuelDashboardQuery, GetMachinesFuelDashboardQueryVariables>(GetMachinesFuelDashboardDocument, options);
        }
export type GetMachinesFuelDashboardQueryHookResult = ReturnType<typeof useGetMachinesFuelDashboardQuery>;
export type GetMachinesFuelDashboardLazyQueryHookResult = ReturnType<typeof useGetMachinesFuelDashboardLazyQuery>;
export type GetMachinesFuelDashboardSuspenseQueryHookResult = ReturnType<typeof useGetMachinesFuelDashboardSuspenseQuery>;
export type GetMachinesFuelDashboardQueryResult = Apollo.QueryResult<GetMachinesFuelDashboardQuery, GetMachinesFuelDashboardQueryVariables>;
export const GetTanksDashboardDocument = gql`
    query GetTanksDashboard($context: Context!, $filter: GetTanksDashboardFilter!) {
  getTanksDashboard(context: $context, filter: $filter) {
    tanks {
      ...TanksDashboardFields
    }
    providers {
      provider {
        id
        name
      }
      liters_out
      liters_to_storage
      liters_to_consumers
      dispatch_count
    }
  }
}
    ${TanksDashboardFieldsFragmentDoc}`;

/**
 * __useGetTanksDashboardQuery__
 *
 * To run a query within a React component, call `useGetTanksDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTanksDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTanksDashboardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTanksDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTanksDashboardQuery, GetTanksDashboardQueryVariables> & ({ variables: GetTanksDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTanksDashboardQuery, GetTanksDashboardQueryVariables>(GetTanksDashboardDocument, options);
      }
export function useGetTanksDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTanksDashboardQuery, GetTanksDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTanksDashboardQuery, GetTanksDashboardQueryVariables>(GetTanksDashboardDocument, options);
        }
export function useGetTanksDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTanksDashboardQuery, GetTanksDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTanksDashboardQuery, GetTanksDashboardQueryVariables>(GetTanksDashboardDocument, options);
        }
export type GetTanksDashboardQueryHookResult = ReturnType<typeof useGetTanksDashboardQuery>;
export type GetTanksDashboardLazyQueryHookResult = ReturnType<typeof useGetTanksDashboardLazyQuery>;
export type GetTanksDashboardSuspenseQueryHookResult = ReturnType<typeof useGetTanksDashboardSuspenseQuery>;
export type GetTanksDashboardQueryResult = Apollo.QueryResult<GetTanksDashboardQuery, GetTanksDashboardQueryVariables>;
export const GetProjectsFuelDashboardDocument = gql`
    query GetProjectsFuelDashboard($context: Context!, $filter: GetTanksDashboardFilter!) {
  getProjectsFuelDashboard(context: $context, filter: $filter) {
    items {
      ...ProjectsFuelDashboardFields
    }
  }
}
    ${ProjectsFuelDashboardFieldsFragmentDoc}`;

/**
 * __useGetProjectsFuelDashboardQuery__
 *
 * To run a query within a React component, call `useGetProjectsFuelDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsFuelDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsFuelDashboardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProjectsFuelDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectsFuelDashboardQuery, GetProjectsFuelDashboardQueryVariables> & ({ variables: GetProjectsFuelDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectsFuelDashboardQuery, GetProjectsFuelDashboardQueryVariables>(GetProjectsFuelDashboardDocument, options);
      }
export function useGetProjectsFuelDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectsFuelDashboardQuery, GetProjectsFuelDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectsFuelDashboardQuery, GetProjectsFuelDashboardQueryVariables>(GetProjectsFuelDashboardDocument, options);
        }
export function useGetProjectsFuelDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectsFuelDashboardQuery, GetProjectsFuelDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectsFuelDashboardQuery, GetProjectsFuelDashboardQueryVariables>(GetProjectsFuelDashboardDocument, options);
        }
export type GetProjectsFuelDashboardQueryHookResult = ReturnType<typeof useGetProjectsFuelDashboardQuery>;
export type GetProjectsFuelDashboardLazyQueryHookResult = ReturnType<typeof useGetProjectsFuelDashboardLazyQuery>;
export type GetProjectsFuelDashboardSuspenseQueryHookResult = ReturnType<typeof useGetProjectsFuelDashboardSuspenseQuery>;
export type GetProjectsFuelDashboardQueryResult = Apollo.QueryResult<GetProjectsFuelDashboardQuery, GetProjectsFuelDashboardQueryVariables>;
export const GetFuelSourcesDocument = gql`
    query GetFuelSources($context: Context, $query: String, $pagination: FilterPagination) {
  getFuelSources(context: $context, query: $query, pagination: $pagination) {
    tanks {
      ...MachinePickerFields
    }
    providers {
      ...FuelProviderFields
    }
  }
}
    ${MachinePickerFieldsFragmentDoc}
${FuelProviderFieldsFragmentDoc}`;

/**
 * __useGetFuelSourcesQuery__
 *
 * To run a query within a React component, call `useGetFuelSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelSourcesQuery({
 *   variables: {
 *      context: // value for 'context'
 *      query: // value for 'query'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFuelSourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFuelSourcesQuery, GetFuelSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelSourcesQuery, GetFuelSourcesQueryVariables>(GetFuelSourcesDocument, options);
      }
export function useGetFuelSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelSourcesQuery, GetFuelSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelSourcesQuery, GetFuelSourcesQueryVariables>(GetFuelSourcesDocument, options);
        }
export function useGetFuelSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelSourcesQuery, GetFuelSourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelSourcesQuery, GetFuelSourcesQueryVariables>(GetFuelSourcesDocument, options);
        }
export type GetFuelSourcesQueryHookResult = ReturnType<typeof useGetFuelSourcesQuery>;
export type GetFuelSourcesLazyQueryHookResult = ReturnType<typeof useGetFuelSourcesLazyQuery>;
export type GetFuelSourcesSuspenseQueryHookResult = ReturnType<typeof useGetFuelSourcesSuspenseQuery>;
export type GetFuelSourcesQueryResult = Apollo.QueryResult<GetFuelSourcesQuery, GetFuelSourcesQueryVariables>;
export const GetFuelDestinationsDocument = gql`
    query GetFuelDestinations($context: Context!, $query: String) {
  getFuelDestinations(context: $context, query: $query) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetFuelDestinationsQuery__
 *
 * To run a query within a React component, call `useGetFuelDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelDestinationsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetFuelDestinationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelDestinationsQuery, GetFuelDestinationsQueryVariables> & ({ variables: GetFuelDestinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelDestinationsQuery, GetFuelDestinationsQueryVariables>(GetFuelDestinationsDocument, options);
      }
export function useGetFuelDestinationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelDestinationsQuery, GetFuelDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelDestinationsQuery, GetFuelDestinationsQueryVariables>(GetFuelDestinationsDocument, options);
        }
export function useGetFuelDestinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelDestinationsQuery, GetFuelDestinationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelDestinationsQuery, GetFuelDestinationsQueryVariables>(GetFuelDestinationsDocument, options);
        }
export type GetFuelDestinationsQueryHookResult = ReturnType<typeof useGetFuelDestinationsQuery>;
export type GetFuelDestinationsLazyQueryHookResult = ReturnType<typeof useGetFuelDestinationsLazyQuery>;
export type GetFuelDestinationsSuspenseQueryHookResult = ReturnType<typeof useGetFuelDestinationsSuspenseQuery>;
export type GetFuelDestinationsQueryResult = Apollo.QueryResult<GetFuelDestinationsQuery, GetFuelDestinationsQueryVariables>;
export const GetFuelTanksDocument = gql`
    query GetFuelTanks($context: Context!) {
  getFuelTanks(context: $context) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetFuelTanksQuery__
 *
 * To run a query within a React component, call `useGetFuelTanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelTanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelTanksQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetFuelTanksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelTanksQuery, GetFuelTanksQueryVariables> & ({ variables: GetFuelTanksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelTanksQuery, GetFuelTanksQueryVariables>(GetFuelTanksDocument, options);
      }
export function useGetFuelTanksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelTanksQuery, GetFuelTanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelTanksQuery, GetFuelTanksQueryVariables>(GetFuelTanksDocument, options);
        }
export function useGetFuelTanksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelTanksQuery, GetFuelTanksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelTanksQuery, GetFuelTanksQueryVariables>(GetFuelTanksDocument, options);
        }
export type GetFuelTanksQueryHookResult = ReturnType<typeof useGetFuelTanksQuery>;
export type GetFuelTanksLazyQueryHookResult = ReturnType<typeof useGetFuelTanksLazyQuery>;
export type GetFuelTanksSuspenseQueryHookResult = ReturnType<typeof useGetFuelTanksSuspenseQuery>;
export type GetFuelTanksQueryResult = Apollo.QueryResult<GetFuelTanksQuery, GetFuelTanksQueryVariables>;
export const GetFuelConsumersDocument = gql`
    query GetFuelConsumers($context: Context!) {
  getMachines(context: $context, filter: {fuel_participations: [consumer]}) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetFuelConsumersQuery__
 *
 * To run a query within a React component, call `useGetFuelConsumersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelConsumersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelConsumersQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetFuelConsumersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelConsumersQuery, GetFuelConsumersQueryVariables> & ({ variables: GetFuelConsumersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelConsumersQuery, GetFuelConsumersQueryVariables>(GetFuelConsumersDocument, options);
      }
export function useGetFuelConsumersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelConsumersQuery, GetFuelConsumersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelConsumersQuery, GetFuelConsumersQueryVariables>(GetFuelConsumersDocument, options);
        }
export function useGetFuelConsumersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelConsumersQuery, GetFuelConsumersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelConsumersQuery, GetFuelConsumersQueryVariables>(GetFuelConsumersDocument, options);
        }
export type GetFuelConsumersQueryHookResult = ReturnType<typeof useGetFuelConsumersQuery>;
export type GetFuelConsumersLazyQueryHookResult = ReturnType<typeof useGetFuelConsumersLazyQuery>;
export type GetFuelConsumersSuspenseQueryHookResult = ReturnType<typeof useGetFuelConsumersSuspenseQuery>;
export type GetFuelConsumersQueryResult = Apollo.QueryResult<GetFuelConsumersQuery, GetFuelConsumersQueryVariables>;
export const GetFuelProvidersDocument = gql`
    query GetFuelProviders($context: Context!) {
  getFuelProviders(context: $context) {
    items {
      ...FuelProviderFields
    }
  }
}
    ${FuelProviderFieldsFragmentDoc}`;

/**
 * __useGetFuelProvidersQuery__
 *
 * To run a query within a React component, call `useGetFuelProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelProvidersQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetFuelProvidersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelProvidersQuery, GetFuelProvidersQueryVariables> & ({ variables: GetFuelProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelProvidersQuery, GetFuelProvidersQueryVariables>(GetFuelProvidersDocument, options);
      }
export function useGetFuelProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelProvidersQuery, GetFuelProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelProvidersQuery, GetFuelProvidersQueryVariables>(GetFuelProvidersDocument, options);
        }
export function useGetFuelProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelProvidersQuery, GetFuelProvidersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelProvidersQuery, GetFuelProvidersQueryVariables>(GetFuelProvidersDocument, options);
        }
export type GetFuelProvidersQueryHookResult = ReturnType<typeof useGetFuelProvidersQuery>;
export type GetFuelProvidersLazyQueryHookResult = ReturnType<typeof useGetFuelProvidersLazyQuery>;
export type GetFuelProvidersSuspenseQueryHookResult = ReturnType<typeof useGetFuelProvidersSuspenseQuery>;
export type GetFuelProvidersQueryResult = Apollo.QueryResult<GetFuelProvidersQuery, GetFuelProvidersQueryVariables>;
export const GetFuelDispatchReportByIdDocument = gql`
    query GetFuelDispatchReportById($id: ID!) {
  getFuelDispatchedReportById(id: $id) {
    ...FuelDispatchReportFields
  }
}
    ${FuelDispatchReportFieldsFragmentDoc}`;

/**
 * __useGetFuelDispatchReportByIdQuery__
 *
 * To run a query within a React component, call `useGetFuelDispatchReportByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelDispatchReportByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelDispatchReportByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFuelDispatchReportByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelDispatchReportByIdQuery, GetFuelDispatchReportByIdQueryVariables> & ({ variables: GetFuelDispatchReportByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelDispatchReportByIdQuery, GetFuelDispatchReportByIdQueryVariables>(GetFuelDispatchReportByIdDocument, options);
      }
export function useGetFuelDispatchReportByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelDispatchReportByIdQuery, GetFuelDispatchReportByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelDispatchReportByIdQuery, GetFuelDispatchReportByIdQueryVariables>(GetFuelDispatchReportByIdDocument, options);
        }
export function useGetFuelDispatchReportByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelDispatchReportByIdQuery, GetFuelDispatchReportByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelDispatchReportByIdQuery, GetFuelDispatchReportByIdQueryVariables>(GetFuelDispatchReportByIdDocument, options);
        }
export type GetFuelDispatchReportByIdQueryHookResult = ReturnType<typeof useGetFuelDispatchReportByIdQuery>;
export type GetFuelDispatchReportByIdLazyQueryHookResult = ReturnType<typeof useGetFuelDispatchReportByIdLazyQuery>;
export type GetFuelDispatchReportByIdSuspenseQueryHookResult = ReturnType<typeof useGetFuelDispatchReportByIdSuspenseQuery>;
export type GetFuelDispatchReportByIdQueryResult = Apollo.QueryResult<GetFuelDispatchReportByIdQuery, GetFuelDispatchReportByIdQueryVariables>;
export const GetFuelDispatchReportPhotosByIdDocument = gql`
    query GetFuelDispatchReportPhotosByID($id: ID!) {
  getFuelDispatchedReportById(id: $id) {
    id
    photos {
      id
      url
    }
  }
}
    `;

/**
 * __useGetFuelDispatchReportPhotosByIdQuery__
 *
 * To run a query within a React component, call `useGetFuelDispatchReportPhotosByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelDispatchReportPhotosByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelDispatchReportPhotosByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFuelDispatchReportPhotosByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelDispatchReportPhotosByIdQuery, GetFuelDispatchReportPhotosByIdQueryVariables> & ({ variables: GetFuelDispatchReportPhotosByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelDispatchReportPhotosByIdQuery, GetFuelDispatchReportPhotosByIdQueryVariables>(GetFuelDispatchReportPhotosByIdDocument, options);
      }
export function useGetFuelDispatchReportPhotosByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelDispatchReportPhotosByIdQuery, GetFuelDispatchReportPhotosByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelDispatchReportPhotosByIdQuery, GetFuelDispatchReportPhotosByIdQueryVariables>(GetFuelDispatchReportPhotosByIdDocument, options);
        }
export function useGetFuelDispatchReportPhotosByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelDispatchReportPhotosByIdQuery, GetFuelDispatchReportPhotosByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelDispatchReportPhotosByIdQuery, GetFuelDispatchReportPhotosByIdQueryVariables>(GetFuelDispatchReportPhotosByIdDocument, options);
        }
export type GetFuelDispatchReportPhotosByIdQueryHookResult = ReturnType<typeof useGetFuelDispatchReportPhotosByIdQuery>;
export type GetFuelDispatchReportPhotosByIdLazyQueryHookResult = ReturnType<typeof useGetFuelDispatchReportPhotosByIdLazyQuery>;
export type GetFuelDispatchReportPhotosByIdSuspenseQueryHookResult = ReturnType<typeof useGetFuelDispatchReportPhotosByIdSuspenseQuery>;
export type GetFuelDispatchReportPhotosByIdQueryResult = Apollo.QueryResult<GetFuelDispatchReportPhotosByIdQuery, GetFuelDispatchReportPhotosByIdQueryVariables>;
export const GetStockControlReportPhotosByIdDocument = gql`
    query GetStockControlReportPhotosByID($id: ID!) {
  getStockControlReportById(id: $id) {
    id
    photos {
      id
      url
    }
  }
}
    `;

/**
 * __useGetStockControlReportPhotosByIdQuery__
 *
 * To run a query within a React component, call `useGetStockControlReportPhotosByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockControlReportPhotosByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockControlReportPhotosByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStockControlReportPhotosByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStockControlReportPhotosByIdQuery, GetStockControlReportPhotosByIdQueryVariables> & ({ variables: GetStockControlReportPhotosByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStockControlReportPhotosByIdQuery, GetStockControlReportPhotosByIdQueryVariables>(GetStockControlReportPhotosByIdDocument, options);
      }
export function useGetStockControlReportPhotosByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStockControlReportPhotosByIdQuery, GetStockControlReportPhotosByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStockControlReportPhotosByIdQuery, GetStockControlReportPhotosByIdQueryVariables>(GetStockControlReportPhotosByIdDocument, options);
        }
export function useGetStockControlReportPhotosByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStockControlReportPhotosByIdQuery, GetStockControlReportPhotosByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStockControlReportPhotosByIdQuery, GetStockControlReportPhotosByIdQueryVariables>(GetStockControlReportPhotosByIdDocument, options);
        }
export type GetStockControlReportPhotosByIdQueryHookResult = ReturnType<typeof useGetStockControlReportPhotosByIdQuery>;
export type GetStockControlReportPhotosByIdLazyQueryHookResult = ReturnType<typeof useGetStockControlReportPhotosByIdLazyQuery>;
export type GetStockControlReportPhotosByIdSuspenseQueryHookResult = ReturnType<typeof useGetStockControlReportPhotosByIdSuspenseQuery>;
export type GetStockControlReportPhotosByIdQueryResult = Apollo.QueryResult<GetStockControlReportPhotosByIdQuery, GetStockControlReportPhotosByIdQueryVariables>;
export const GetFuelDispatchReportsDocument = gql`
    query GetFuelDispatchReports($context: Context!, $filter: GetFuelDispatchedReportsFilter, $pagination: FilterPagination) {
  getFuelDispatchedReports(
    context: $context
    filter: $filter
    pagination: $pagination
  ) {
    ... on GetFuelDispatchedReports {
      items {
        ...FuelDispatchReportForTableFields
      }
    }
  }
}
    ${FuelDispatchReportForTableFieldsFragmentDoc}`;

/**
 * __useGetFuelDispatchReportsQuery__
 *
 * To run a query within a React component, call `useGetFuelDispatchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelDispatchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelDispatchReportsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFuelDispatchReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelDispatchReportsQuery, GetFuelDispatchReportsQueryVariables> & ({ variables: GetFuelDispatchReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelDispatchReportsQuery, GetFuelDispatchReportsQueryVariables>(GetFuelDispatchReportsDocument, options);
      }
export function useGetFuelDispatchReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelDispatchReportsQuery, GetFuelDispatchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelDispatchReportsQuery, GetFuelDispatchReportsQueryVariables>(GetFuelDispatchReportsDocument, options);
        }
export function useGetFuelDispatchReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelDispatchReportsQuery, GetFuelDispatchReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelDispatchReportsQuery, GetFuelDispatchReportsQueryVariables>(GetFuelDispatchReportsDocument, options);
        }
export type GetFuelDispatchReportsQueryHookResult = ReturnType<typeof useGetFuelDispatchReportsQuery>;
export type GetFuelDispatchReportsLazyQueryHookResult = ReturnType<typeof useGetFuelDispatchReportsLazyQuery>;
export type GetFuelDispatchReportsSuspenseQueryHookResult = ReturnType<typeof useGetFuelDispatchReportsSuspenseQuery>;
export type GetFuelDispatchReportsQueryResult = Apollo.QueryResult<GetFuelDispatchReportsQuery, GetFuelDispatchReportsQueryVariables>;
export const GetStockControlReportsDocument = gql`
    query GetStockControlReports($context: Context!, $filter: GetStockControlReportsFilter, $pagination: FilterPagination) {
  getStockControlReports(
    context: $context
    filter: $filter
    pagination: $pagination
  ) {
    ... on GetStockControlReports {
      items {
        ...StockControlReportFields
      }
    }
  }
}
    ${StockControlReportFieldsFragmentDoc}`;

/**
 * __useGetStockControlReportsQuery__
 *
 * To run a query within a React component, call `useGetStockControlReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockControlReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockControlReportsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetStockControlReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStockControlReportsQuery, GetStockControlReportsQueryVariables> & ({ variables: GetStockControlReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStockControlReportsQuery, GetStockControlReportsQueryVariables>(GetStockControlReportsDocument, options);
      }
export function useGetStockControlReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStockControlReportsQuery, GetStockControlReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStockControlReportsQuery, GetStockControlReportsQueryVariables>(GetStockControlReportsDocument, options);
        }
export function useGetStockControlReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStockControlReportsQuery, GetStockControlReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStockControlReportsQuery, GetStockControlReportsQueryVariables>(GetStockControlReportsDocument, options);
        }
export type GetStockControlReportsQueryHookResult = ReturnType<typeof useGetStockControlReportsQuery>;
export type GetStockControlReportsLazyQueryHookResult = ReturnType<typeof useGetStockControlReportsLazyQuery>;
export type GetStockControlReportsSuspenseQueryHookResult = ReturnType<typeof useGetStockControlReportsSuspenseQuery>;
export type GetStockControlReportsQueryResult = Apollo.QueryResult<GetStockControlReportsQuery, GetStockControlReportsQueryVariables>;
export const GetMyFuelDispatchReportsDocument = gql`
    query GetMyFuelDispatchReports($filter: GetFuelDispatchedReportsFilter) {
  getMyFuelDispatchedReports(filter: $filter) {
    ... on GetFuelDispatchedReports {
      items {
        ...FuelDispatchReportFields
      }
    }
  }
}
    ${FuelDispatchReportFieldsFragmentDoc}`;

/**
 * __useGetMyFuelDispatchReportsQuery__
 *
 * To run a query within a React component, call `useGetMyFuelDispatchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFuelDispatchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFuelDispatchReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMyFuelDispatchReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyFuelDispatchReportsQuery, GetMyFuelDispatchReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyFuelDispatchReportsQuery, GetMyFuelDispatchReportsQueryVariables>(GetMyFuelDispatchReportsDocument, options);
      }
export function useGetMyFuelDispatchReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyFuelDispatchReportsQuery, GetMyFuelDispatchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyFuelDispatchReportsQuery, GetMyFuelDispatchReportsQueryVariables>(GetMyFuelDispatchReportsDocument, options);
        }
export function useGetMyFuelDispatchReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyFuelDispatchReportsQuery, GetMyFuelDispatchReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyFuelDispatchReportsQuery, GetMyFuelDispatchReportsQueryVariables>(GetMyFuelDispatchReportsDocument, options);
        }
export type GetMyFuelDispatchReportsQueryHookResult = ReturnType<typeof useGetMyFuelDispatchReportsQuery>;
export type GetMyFuelDispatchReportsLazyQueryHookResult = ReturnType<typeof useGetMyFuelDispatchReportsLazyQuery>;
export type GetMyFuelDispatchReportsSuspenseQueryHookResult = ReturnType<typeof useGetMyFuelDispatchReportsSuspenseQuery>;
export type GetMyFuelDispatchReportsQueryResult = Apollo.QueryResult<GetMyFuelDispatchReportsQuery, GetMyFuelDispatchReportsQueryVariables>;
export const GetMyStockControlReportsDocument = gql`
    query GetMyStockControlReports($filter: GetStockControlReportsFilter) {
  getMyStockControlReports(filter: $filter) {
    ... on GetStockControlReports {
      items {
        ...StockControlReportFields
      }
    }
  }
}
    ${StockControlReportFieldsFragmentDoc}`;

/**
 * __useGetMyStockControlReportsQuery__
 *
 * To run a query within a React component, call `useGetMyStockControlReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyStockControlReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyStockControlReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMyStockControlReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyStockControlReportsQuery, GetMyStockControlReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyStockControlReportsQuery, GetMyStockControlReportsQueryVariables>(GetMyStockControlReportsDocument, options);
      }
export function useGetMyStockControlReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyStockControlReportsQuery, GetMyStockControlReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyStockControlReportsQuery, GetMyStockControlReportsQueryVariables>(GetMyStockControlReportsDocument, options);
        }
export function useGetMyStockControlReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyStockControlReportsQuery, GetMyStockControlReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyStockControlReportsQuery, GetMyStockControlReportsQueryVariables>(GetMyStockControlReportsDocument, options);
        }
export type GetMyStockControlReportsQueryHookResult = ReturnType<typeof useGetMyStockControlReportsQuery>;
export type GetMyStockControlReportsLazyQueryHookResult = ReturnType<typeof useGetMyStockControlReportsLazyQuery>;
export type GetMyStockControlReportsSuspenseQueryHookResult = ReturnType<typeof useGetMyStockControlReportsSuspenseQuery>;
export type GetMyStockControlReportsQueryResult = Apollo.QueryResult<GetMyStockControlReportsQuery, GetMyStockControlReportsQueryVariables>;
export const GetComputedStockDocument = gql`
    query GetComputedStock($tank_id: Int!, $datetime: DateTime!) {
  getComputedStock(tank_id: $tank_id, datetime: $datetime)
}
    `;

/**
 * __useGetComputedStockQuery__
 *
 * To run a query within a React component, call `useGetComputedStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComputedStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComputedStockQuery({
 *   variables: {
 *      tank_id: // value for 'tank_id'
 *      datetime: // value for 'datetime'
 *   },
 * });
 */
export function useGetComputedStockQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetComputedStockQuery, GetComputedStockQueryVariables> & ({ variables: GetComputedStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetComputedStockQuery, GetComputedStockQueryVariables>(GetComputedStockDocument, options);
      }
export function useGetComputedStockLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetComputedStockQuery, GetComputedStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetComputedStockQuery, GetComputedStockQueryVariables>(GetComputedStockDocument, options);
        }
export function useGetComputedStockSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetComputedStockQuery, GetComputedStockQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetComputedStockQuery, GetComputedStockQueryVariables>(GetComputedStockDocument, options);
        }
export type GetComputedStockQueryHookResult = ReturnType<typeof useGetComputedStockQuery>;
export type GetComputedStockLazyQueryHookResult = ReturnType<typeof useGetComputedStockLazyQuery>;
export type GetComputedStockSuspenseQueryHookResult = ReturnType<typeof useGetComputedStockSuspenseQuery>;
export type GetComputedStockQueryResult = Apollo.QueryResult<GetComputedStockQuery, GetComputedStockQueryVariables>;
export const GetFuelDispatchedFromDailyReportsDocument = gql`
    query GetFuelDispatchedFromDailyReports($context: Context!, $filter: FilterDailyReports, $pagination: FilterPagination) {
  getDailyReports(context: $context, filter: $filter, pagination: $pagination) {
    ... on AuthCheckGetDailyReports {
      items {
        id
        date
        total_fuel @client
        usage_reports {
          fuel
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetFuelDispatchedFromDailyReportsQuery__
 *
 * To run a query within a React component, call `useGetFuelDispatchedFromDailyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelDispatchedFromDailyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelDispatchedFromDailyReportsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFuelDispatchedFromDailyReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelDispatchedFromDailyReportsQuery, GetFuelDispatchedFromDailyReportsQueryVariables> & ({ variables: GetFuelDispatchedFromDailyReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelDispatchedFromDailyReportsQuery, GetFuelDispatchedFromDailyReportsQueryVariables>(GetFuelDispatchedFromDailyReportsDocument, options);
      }
export function useGetFuelDispatchedFromDailyReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelDispatchedFromDailyReportsQuery, GetFuelDispatchedFromDailyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelDispatchedFromDailyReportsQuery, GetFuelDispatchedFromDailyReportsQueryVariables>(GetFuelDispatchedFromDailyReportsDocument, options);
        }
export function useGetFuelDispatchedFromDailyReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelDispatchedFromDailyReportsQuery, GetFuelDispatchedFromDailyReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelDispatchedFromDailyReportsQuery, GetFuelDispatchedFromDailyReportsQueryVariables>(GetFuelDispatchedFromDailyReportsDocument, options);
        }
export type GetFuelDispatchedFromDailyReportsQueryHookResult = ReturnType<typeof useGetFuelDispatchedFromDailyReportsQuery>;
export type GetFuelDispatchedFromDailyReportsLazyQueryHookResult = ReturnType<typeof useGetFuelDispatchedFromDailyReportsLazyQuery>;
export type GetFuelDispatchedFromDailyReportsSuspenseQueryHookResult = ReturnType<typeof useGetFuelDispatchedFromDailyReportsSuspenseQuery>;
export type GetFuelDispatchedFromDailyReportsQueryResult = Apollo.QueryResult<GetFuelDispatchedFromDailyReportsQuery, GetFuelDispatchedFromDailyReportsQueryVariables>;
export const GetFuelConsumedFromTelemetryTimeseriesDocument = gql`
    query GetFuelConsumedFromTelemetryTimeseries($id: ID!, $from_utc: DateTime!, $to_utc: DateTime!) {
  getTimeSeriesByBilderitConnectDeviceId(
    id: $id
    params: {from_utc: $from_utc, to_utc: $to_utc}
  ) {
    end_of_day
    daily_fuel_consumed_lts
    fuel_remaining_percentage
    cumulative_fuel_consumed_lts
  }
}
    `;

/**
 * __useGetFuelConsumedFromTelemetryTimeseriesQuery__
 *
 * To run a query within a React component, call `useGetFuelConsumedFromTelemetryTimeseriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelConsumedFromTelemetryTimeseriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelConsumedFromTelemetryTimeseriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from_utc: // value for 'from_utc'
 *      to_utc: // value for 'to_utc'
 *   },
 * });
 */
export function useGetFuelConsumedFromTelemetryTimeseriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelConsumedFromTelemetryTimeseriesQuery, GetFuelConsumedFromTelemetryTimeseriesQueryVariables> & ({ variables: GetFuelConsumedFromTelemetryTimeseriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelConsumedFromTelemetryTimeseriesQuery, GetFuelConsumedFromTelemetryTimeseriesQueryVariables>(GetFuelConsumedFromTelemetryTimeseriesDocument, options);
      }
export function useGetFuelConsumedFromTelemetryTimeseriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelConsumedFromTelemetryTimeseriesQuery, GetFuelConsumedFromTelemetryTimeseriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelConsumedFromTelemetryTimeseriesQuery, GetFuelConsumedFromTelemetryTimeseriesQueryVariables>(GetFuelConsumedFromTelemetryTimeseriesDocument, options);
        }
export function useGetFuelConsumedFromTelemetryTimeseriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelConsumedFromTelemetryTimeseriesQuery, GetFuelConsumedFromTelemetryTimeseriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelConsumedFromTelemetryTimeseriesQuery, GetFuelConsumedFromTelemetryTimeseriesQueryVariables>(GetFuelConsumedFromTelemetryTimeseriesDocument, options);
        }
export type GetFuelConsumedFromTelemetryTimeseriesQueryHookResult = ReturnType<typeof useGetFuelConsumedFromTelemetryTimeseriesQuery>;
export type GetFuelConsumedFromTelemetryTimeseriesLazyQueryHookResult = ReturnType<typeof useGetFuelConsumedFromTelemetryTimeseriesLazyQuery>;
export type GetFuelConsumedFromTelemetryTimeseriesSuspenseQueryHookResult = ReturnType<typeof useGetFuelConsumedFromTelemetryTimeseriesSuspenseQuery>;
export type GetFuelConsumedFromTelemetryTimeseriesQueryResult = Apollo.QueryResult<GetFuelConsumedFromTelemetryTimeseriesQuery, GetFuelConsumedFromTelemetryTimeseriesQueryVariables>;
export const GetFuelDashboardDataDocument = gql`
    query GetFuelDashboardData($context: Context!, $startDate: LocalDate!, $endDate: LocalDate!) {
  tanksDashboard: getTanksDashboard(
    context: $context
    filter: {start_date: $startDate, end_date: $endDate}
  ) {
    tanks {
      ...TanksDashboardFields
    }
    providers {
      provider {
        id
        name
      }
      liters_out
      liters_to_storage
      liters_to_consumers
      dispatch_count
    }
    consumption_stats {
      total_consumption_liters
      total_consumption_dispatches
    }
    trend_stats {
      provider_input_change
      consumption_change
    }
  }
  projectsDashboard: getProjectsFuelDashboard(
    context: $context
    filter: {start_date: $startDate, end_date: $endDate}
  ) {
    items {
      ...ProjectsFuelDashboardFields
    }
    pricing_coverage {
      total_projects
      relevant_projects
      covered_projects
      uncovered_projects
      uncovered_project_ids
      consumption_liters_uncovered
    }
  }
  machinesDashboard: getMachinesFuelDashboard(
    context: $context
    filter: {start_date: $startDate, end_date: $endDate}
  ) {
    items {
      ...MachinesFuelDashboardFields
    }
    trend_stats {
      telemetry_fuel_change
    }
  }
  providers: getFuelProviders(context: $context) {
    items {
      ...FuelProviderFields
    }
  }
}
    ${TanksDashboardFieldsFragmentDoc}
${ProjectsFuelDashboardFieldsFragmentDoc}
${MachinesFuelDashboardFieldsFragmentDoc}
${FuelProviderFieldsFragmentDoc}`;

/**
 * __useGetFuelDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetFuelDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelDashboardDataQuery({
 *   variables: {
 *      context: // value for 'context'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetFuelDashboardDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelDashboardDataQuery, GetFuelDashboardDataQueryVariables> & ({ variables: GetFuelDashboardDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelDashboardDataQuery, GetFuelDashboardDataQueryVariables>(GetFuelDashboardDataDocument, options);
      }
export function useGetFuelDashboardDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelDashboardDataQuery, GetFuelDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelDashboardDataQuery, GetFuelDashboardDataQueryVariables>(GetFuelDashboardDataDocument, options);
        }
export function useGetFuelDashboardDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelDashboardDataQuery, GetFuelDashboardDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelDashboardDataQuery, GetFuelDashboardDataQueryVariables>(GetFuelDashboardDataDocument, options);
        }
export type GetFuelDashboardDataQueryHookResult = ReturnType<typeof useGetFuelDashboardDataQuery>;
export type GetFuelDashboardDataLazyQueryHookResult = ReturnType<typeof useGetFuelDashboardDataLazyQuery>;
export type GetFuelDashboardDataSuspenseQueryHookResult = ReturnType<typeof useGetFuelDashboardDataSuspenseQuery>;
export type GetFuelDashboardDataQueryResult = Apollo.QueryResult<GetFuelDashboardDataQuery, GetFuelDashboardDataQueryVariables>;
export const RequestIdentityClaimDocument = gql`
    mutation RequestIdentityClaim($input: RequestIdentityClaimInput!) {
  requestIdentityClaim(input: $input) {
    requested_email
    kind
  }
}
    `;

/**
 * __useRequestIdentityClaimMutation__
 *
 * To run a mutation, you first call `useRequestIdentityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestIdentityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestIdentityClaimMutation, { data, loading, error }] = useRequestIdentityClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestIdentityClaimMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestIdentityClaimMutation, RequestIdentityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestIdentityClaimMutation, RequestIdentityClaimMutationVariables>(RequestIdentityClaimDocument, options);
      }
export type RequestIdentityClaimMutationHookResult = ReturnType<typeof useRequestIdentityClaimMutation>;
export type RequestIdentityClaimMutationResult = Apollo.MutationResult<RequestIdentityClaimMutation>;
export type RequestIdentityClaimMutationOptions = Apollo.BaseMutationOptions<RequestIdentityClaimMutation, RequestIdentityClaimMutationVariables>;
export const CancelIdentityClaimDocument = gql`
    mutation CancelIdentityClaim {
  cancelIdentityClaim
}
    `;

/**
 * __useCancelIdentityClaimMutation__
 *
 * To run a mutation, you first call `useCancelIdentityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelIdentityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelIdentityClaimMutation, { data, loading, error }] = useCancelIdentityClaimMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelIdentityClaimMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelIdentityClaimMutation, CancelIdentityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelIdentityClaimMutation, CancelIdentityClaimMutationVariables>(CancelIdentityClaimDocument, options);
      }
export type CancelIdentityClaimMutationHookResult = ReturnType<typeof useCancelIdentityClaimMutation>;
export type CancelIdentityClaimMutationResult = Apollo.MutationResult<CancelIdentityClaimMutation>;
export type CancelIdentityClaimMutationOptions = Apollo.BaseMutationOptions<CancelIdentityClaimMutation, CancelIdentityClaimMutationVariables>;
export const ConfirmIdentityClaimDocument = gql`
    mutation ConfirmIdentityClaim($input: ConfirmIdentityClaimInput!) {
  confirmIdentityClaim(input: $input)
}
    `;

/**
 * __useConfirmIdentityClaimMutation__
 *
 * To run a mutation, you first call `useConfirmIdentityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmIdentityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmIdentityClaimMutation, { data, loading, error }] = useConfirmIdentityClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmIdentityClaimMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmIdentityClaimMutation, ConfirmIdentityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmIdentityClaimMutation, ConfirmIdentityClaimMutationVariables>(ConfirmIdentityClaimDocument, options);
      }
export type ConfirmIdentityClaimMutationHookResult = ReturnType<typeof useConfirmIdentityClaimMutation>;
export type ConfirmIdentityClaimMutationResult = Apollo.MutationResult<ConfirmIdentityClaimMutation>;
export type ConfirmIdentityClaimMutationOptions = Apollo.BaseMutationOptions<ConfirmIdentityClaimMutation, ConfirmIdentityClaimMutationVariables>;
export const MergeIdentityClaimDocument = gql`
    mutation MergeIdentityClaim($input: MergeIdentityClaimInput!) {
  mergeIdentityClaim(input: $input)
}
    `;

/**
 * __useMergeIdentityClaimMutation__
 *
 * To run a mutation, you first call `useMergeIdentityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeIdentityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeIdentityClaimMutation, { data, loading, error }] = useMergeIdentityClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeIdentityClaimMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeIdentityClaimMutation, MergeIdentityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeIdentityClaimMutation, MergeIdentityClaimMutationVariables>(MergeIdentityClaimDocument, options);
      }
export type MergeIdentityClaimMutationHookResult = ReturnType<typeof useMergeIdentityClaimMutation>;
export type MergeIdentityClaimMutationResult = Apollo.MutationResult<MergeIdentityClaimMutation>;
export type MergeIdentityClaimMutationOptions = Apollo.BaseMutationOptions<MergeIdentityClaimMutation, MergeIdentityClaimMutationVariables>;
export const GetMachineNoticesDocument = gql`
    query GetMachineNotices($filter: FilterMachineNotices, $context: Context!) {
  getMachineNotices(filter: $filter, context: $context) {
    ...MachineNoticeFields
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useGetMachineNoticesQuery__
 *
 * To run a query within a React component, call `useGetMachineNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineNoticesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetMachineNoticesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineNoticesQuery, GetMachineNoticesQueryVariables> & ({ variables: GetMachineNoticesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineNoticesQuery, GetMachineNoticesQueryVariables>(GetMachineNoticesDocument, options);
      }
export function useGetMachineNoticesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineNoticesQuery, GetMachineNoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineNoticesQuery, GetMachineNoticesQueryVariables>(GetMachineNoticesDocument, options);
        }
export function useGetMachineNoticesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineNoticesQuery, GetMachineNoticesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineNoticesQuery, GetMachineNoticesQueryVariables>(GetMachineNoticesDocument, options);
        }
export type GetMachineNoticesQueryHookResult = ReturnType<typeof useGetMachineNoticesQuery>;
export type GetMachineNoticesLazyQueryHookResult = ReturnType<typeof useGetMachineNoticesLazyQuery>;
export type GetMachineNoticesSuspenseQueryHookResult = ReturnType<typeof useGetMachineNoticesSuspenseQuery>;
export type GetMachineNoticesQueryResult = Apollo.QueryResult<GetMachineNoticesQuery, GetMachineNoticesQueryVariables>;
export const GetMachineNoticeByIdDocument = gql`
    query GetMachineNoticeById($id: Int!) {
  getMachineNoticeById(id: $id) {
    ...MachineNoticeFields
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useGetMachineNoticeByIdQuery__
 *
 * To run a query within a React component, call `useGetMachineNoticeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineNoticeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineNoticeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineNoticeByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineNoticeByIdQuery, GetMachineNoticeByIdQueryVariables> & ({ variables: GetMachineNoticeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineNoticeByIdQuery, GetMachineNoticeByIdQueryVariables>(GetMachineNoticeByIdDocument, options);
      }
export function useGetMachineNoticeByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineNoticeByIdQuery, GetMachineNoticeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineNoticeByIdQuery, GetMachineNoticeByIdQueryVariables>(GetMachineNoticeByIdDocument, options);
        }
export function useGetMachineNoticeByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineNoticeByIdQuery, GetMachineNoticeByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineNoticeByIdQuery, GetMachineNoticeByIdQueryVariables>(GetMachineNoticeByIdDocument, options);
        }
export type GetMachineNoticeByIdQueryHookResult = ReturnType<typeof useGetMachineNoticeByIdQuery>;
export type GetMachineNoticeByIdLazyQueryHookResult = ReturnType<typeof useGetMachineNoticeByIdLazyQuery>;
export type GetMachineNoticeByIdSuspenseQueryHookResult = ReturnType<typeof useGetMachineNoticeByIdSuspenseQuery>;
export type GetMachineNoticeByIdQueryResult = Apollo.QueryResult<GetMachineNoticeByIdQuery, GetMachineNoticeByIdQueryVariables>;
export const GetMachineNoticesDashboardDocument = gql`
    query GetMachineNoticesDashboard($filter: FilterMachineNoticeDashboard, $pagination: FilterPagination, $context: Context!) {
  getMachineNoticesDashboard(
    filter: $filter
    pagination: $pagination
    context: $context
  ) {
    items {
      ...MachineNoticeFields
    }
    page_info {
      total_pages
      total_items
      current_page
      items_per_page
    }
    facets {
      field
      facets {
        value
        count
      }
    }
    tag_facets {
      count
      tag {
        id
        tag
        icon
        color
        is_archived
      }
    }
    backlog_summary {
      total
      open
      critical_open
      open_gt_7d
      open_gt_30d
      open_without_ot
      linked_ot
      closed_today
    }
    warnings {
      open_outside_date_range
    }
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useGetMachineNoticesDashboardQuery__
 *
 * To run a query within a React component, call `useGetMachineNoticesDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineNoticesDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineNoticesDashboardQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetMachineNoticesDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineNoticesDashboardQuery, GetMachineNoticesDashboardQueryVariables> & ({ variables: GetMachineNoticesDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineNoticesDashboardQuery, GetMachineNoticesDashboardQueryVariables>(GetMachineNoticesDashboardDocument, options);
      }
export function useGetMachineNoticesDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineNoticesDashboardQuery, GetMachineNoticesDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineNoticesDashboardQuery, GetMachineNoticesDashboardQueryVariables>(GetMachineNoticesDashboardDocument, options);
        }
export function useGetMachineNoticesDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineNoticesDashboardQuery, GetMachineNoticesDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineNoticesDashboardQuery, GetMachineNoticesDashboardQueryVariables>(GetMachineNoticesDashboardDocument, options);
        }
export type GetMachineNoticesDashboardQueryHookResult = ReturnType<typeof useGetMachineNoticesDashboardQuery>;
export type GetMachineNoticesDashboardLazyQueryHookResult = ReturnType<typeof useGetMachineNoticesDashboardLazyQuery>;
export type GetMachineNoticesDashboardSuspenseQueryHookResult = ReturnType<typeof useGetMachineNoticesDashboardSuspenseQuery>;
export type GetMachineNoticesDashboardQueryResult = Apollo.QueryResult<GetMachineNoticesDashboardQuery, GetMachineNoticesDashboardQueryVariables>;
export const DownloadMachineNoticesDashboardWorkbookDocument = gql`
    query DownloadMachineNoticesDashboardWorkbook($filter: FilterMachineNoticeDashboard, $context: Context!) {
  downloadMachineNoticesDashboardWorkbook(filter: $filter, context: $context) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useDownloadMachineNoticesDashboardWorkbookQuery__
 *
 * To run a query within a React component, call `useDownloadMachineNoticesDashboardWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMachineNoticesDashboardWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMachineNoticesDashboardWorkbookQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDownloadMachineNoticesDashboardWorkbookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DownloadMachineNoticesDashboardWorkbookQuery, DownloadMachineNoticesDashboardWorkbookQueryVariables> & ({ variables: DownloadMachineNoticesDashboardWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DownloadMachineNoticesDashboardWorkbookQuery, DownloadMachineNoticesDashboardWorkbookQueryVariables>(DownloadMachineNoticesDashboardWorkbookDocument, options);
      }
export function useDownloadMachineNoticesDashboardWorkbookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadMachineNoticesDashboardWorkbookQuery, DownloadMachineNoticesDashboardWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DownloadMachineNoticesDashboardWorkbookQuery, DownloadMachineNoticesDashboardWorkbookQueryVariables>(DownloadMachineNoticesDashboardWorkbookDocument, options);
        }
export function useDownloadMachineNoticesDashboardWorkbookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DownloadMachineNoticesDashboardWorkbookQuery, DownloadMachineNoticesDashboardWorkbookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DownloadMachineNoticesDashboardWorkbookQuery, DownloadMachineNoticesDashboardWorkbookQueryVariables>(DownloadMachineNoticesDashboardWorkbookDocument, options);
        }
export type DownloadMachineNoticesDashboardWorkbookQueryHookResult = ReturnType<typeof useDownloadMachineNoticesDashboardWorkbookQuery>;
export type DownloadMachineNoticesDashboardWorkbookLazyQueryHookResult = ReturnType<typeof useDownloadMachineNoticesDashboardWorkbookLazyQuery>;
export type DownloadMachineNoticesDashboardWorkbookSuspenseQueryHookResult = ReturnType<typeof useDownloadMachineNoticesDashboardWorkbookSuspenseQuery>;
export type DownloadMachineNoticesDashboardWorkbookQueryResult = Apollo.QueryResult<DownloadMachineNoticesDashboardWorkbookQuery, DownloadMachineNoticesDashboardWorkbookQueryVariables>;
export const GetMyMachineNoticesDocument = gql`
    query GetMyMachineNotices($filter: FilterMyMachineNotices) {
  getMyMachineNotices(filter: $filter) {
    ...MachineNoticeFields
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useGetMyMachineNoticesQuery__
 *
 * To run a query within a React component, call `useGetMyMachineNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMachineNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMachineNoticesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMyMachineNoticesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyMachineNoticesQuery, GetMyMachineNoticesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyMachineNoticesQuery, GetMyMachineNoticesQueryVariables>(GetMyMachineNoticesDocument, options);
      }
export function useGetMyMachineNoticesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyMachineNoticesQuery, GetMyMachineNoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyMachineNoticesQuery, GetMyMachineNoticesQueryVariables>(GetMyMachineNoticesDocument, options);
        }
export function useGetMyMachineNoticesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyMachineNoticesQuery, GetMyMachineNoticesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyMachineNoticesQuery, GetMyMachineNoticesQueryVariables>(GetMyMachineNoticesDocument, options);
        }
export type GetMyMachineNoticesQueryHookResult = ReturnType<typeof useGetMyMachineNoticesQuery>;
export type GetMyMachineNoticesLazyQueryHookResult = ReturnType<typeof useGetMyMachineNoticesLazyQuery>;
export type GetMyMachineNoticesSuspenseQueryHookResult = ReturnType<typeof useGetMyMachineNoticesSuspenseQuery>;
export type GetMyMachineNoticesQueryResult = Apollo.QueryResult<GetMyMachineNoticesQuery, GetMyMachineNoticesQueryVariables>;
export const MachineNoticeChangedDocument = gql`
    subscription MachineNoticeChanged($context: Context!) {
  machineNoticeChanged(context: $context) {
    ...MachineNoticeFields
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useMachineNoticeChangedSubscription__
 *
 * To run a query within a React component, call `useMachineNoticeChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMachineNoticeChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMachineNoticeChangedSubscription({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useMachineNoticeChangedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<MachineNoticeChangedSubscription, MachineNoticeChangedSubscriptionVariables> & ({ variables: MachineNoticeChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<MachineNoticeChangedSubscription, MachineNoticeChangedSubscriptionVariables>(MachineNoticeChangedDocument, options);
      }
export type MachineNoticeChangedSubscriptionHookResult = ReturnType<typeof useMachineNoticeChangedSubscription>;
export type MachineNoticeChangedSubscriptionResult = Apollo.SubscriptionResult<MachineNoticeChangedSubscription>;
export const AddMachineNoticeDocument = gql`
    mutation AddMachineNotice($input: AddMachineNoticeInput!) {
  addMachineNotice(input: $input) {
    ...MachineNoticeFields
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useAddMachineNoticeMutation__
 *
 * To run a mutation, you first call `useAddMachineNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMachineNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMachineNoticeMutation, { data, loading, error }] = useAddMachineNoticeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMachineNoticeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMachineNoticeMutation, AddMachineNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddMachineNoticeMutation, AddMachineNoticeMutationVariables>(AddMachineNoticeDocument, options);
      }
export type AddMachineNoticeMutationHookResult = ReturnType<typeof useAddMachineNoticeMutation>;
export type AddMachineNoticeMutationResult = Apollo.MutationResult<AddMachineNoticeMutation>;
export type AddMachineNoticeMutationOptions = Apollo.BaseMutationOptions<AddMachineNoticeMutation, AddMachineNoticeMutationVariables>;
export const UpdateMachineNoticeDocument = gql`
    mutation UpdateMachineNotice($id: Int!, $input: UpdateMachineNoticeInput!) {
  updateMachineNotice(id: $id, input: $input) {
    ...MachineNoticeFields
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useUpdateMachineNoticeMutation__
 *
 * To run a mutation, you first call `useUpdateMachineNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineNoticeMutation, { data, loading, error }] = useUpdateMachineNoticeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineNoticeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMachineNoticeMutation, UpdateMachineNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMachineNoticeMutation, UpdateMachineNoticeMutationVariables>(UpdateMachineNoticeDocument, options);
      }
export type UpdateMachineNoticeMutationHookResult = ReturnType<typeof useUpdateMachineNoticeMutation>;
export type UpdateMachineNoticeMutationResult = Apollo.MutationResult<UpdateMachineNoticeMutation>;
export type UpdateMachineNoticeMutationOptions = Apollo.BaseMutationOptions<UpdateMachineNoticeMutation, UpdateMachineNoticeMutationVariables>;
export const UpdateMachineNoticeStatusDocument = gql`
    mutation UpdateMachineNoticeStatus($id: Int!, $input: UpdateMachineNoticeStatusInput!) {
  updateMachineNoticeStatus(id: $id, input: $input) {
    ...MachineNoticeFields
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useUpdateMachineNoticeStatusMutation__
 *
 * To run a mutation, you first call `useUpdateMachineNoticeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMachineNoticeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMachineNoticeStatusMutation, { data, loading, error }] = useUpdateMachineNoticeStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMachineNoticeStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMachineNoticeStatusMutation, UpdateMachineNoticeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMachineNoticeStatusMutation, UpdateMachineNoticeStatusMutationVariables>(UpdateMachineNoticeStatusDocument, options);
      }
export type UpdateMachineNoticeStatusMutationHookResult = ReturnType<typeof useUpdateMachineNoticeStatusMutation>;
export type UpdateMachineNoticeStatusMutationResult = Apollo.MutationResult<UpdateMachineNoticeStatusMutation>;
export type UpdateMachineNoticeStatusMutationOptions = Apollo.BaseMutationOptions<UpdateMachineNoticeStatusMutation, UpdateMachineNoticeStatusMutationVariables>;
export const CreateWorkOrderFromMachineNoticeDocument = gql`
    mutation CreateWorkOrderFromMachineNotice($id: Int!) {
  createWorkOrderFromMachineNotice(id: $id) {
    notice {
      ...MachineNoticeFields
    }
    work_order {
      id
      serial_number
      status
      title
    }
  }
}
    ${MachineNoticeFieldsFragmentDoc}`;

/**
 * __useCreateWorkOrderFromMachineNoticeMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderFromMachineNoticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderFromMachineNoticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderFromMachineNoticeMutation, { data, loading, error }] = useCreateWorkOrderFromMachineNoticeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateWorkOrderFromMachineNoticeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWorkOrderFromMachineNoticeMutation, CreateWorkOrderFromMachineNoticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWorkOrderFromMachineNoticeMutation, CreateWorkOrderFromMachineNoticeMutationVariables>(CreateWorkOrderFromMachineNoticeDocument, options);
      }
export type CreateWorkOrderFromMachineNoticeMutationHookResult = ReturnType<typeof useCreateWorkOrderFromMachineNoticeMutation>;
export type CreateWorkOrderFromMachineNoticeMutationResult = Apollo.MutationResult<CreateWorkOrderFromMachineNoticeMutation>;
export type CreateWorkOrderFromMachineNoticeMutationOptions = Apollo.BaseMutationOptions<CreateWorkOrderFromMachineNoticeMutation, CreateWorkOrderFromMachineNoticeMutationVariables>;
export const DeleteMachineDocument = gql`
    mutation DeleteMachine($machineId: Int!) {
  deleteMachine(id: $machineId) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useDeleteMachineMutation__
 *
 * To run a mutation, you first call `useDeleteMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMachineMutation, { data, loading, error }] = useDeleteMachineMutation({
 *   variables: {
 *      machineId: // value for 'machineId'
 *   },
 * });
 */
export function useDeleteMachineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMachineMutation, DeleteMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMachineMutation, DeleteMachineMutationVariables>(DeleteMachineDocument, options);
      }
export type DeleteMachineMutationHookResult = ReturnType<typeof useDeleteMachineMutation>;
export type DeleteMachineMutationResult = Apollo.MutationResult<DeleteMachineMutation>;
export type DeleteMachineMutationOptions = Apollo.BaseMutationOptions<DeleteMachineMutation, DeleteMachineMutationVariables>;
export const ArchiveMachineDocument = gql`
    mutation ArchiveMachine($machineId: Int!) {
  archiveMachine(machineId: $machineId) {
    ...MachineFields
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useArchiveMachineMutation__
 *
 * To run a mutation, you first call `useArchiveMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMachineMutation, { data, loading, error }] = useArchiveMachineMutation({
 *   variables: {
 *      machineId: // value for 'machineId'
 *   },
 * });
 */
export function useArchiveMachineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveMachineMutation, ArchiveMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveMachineMutation, ArchiveMachineMutationVariables>(ArchiveMachineDocument, options);
      }
export type ArchiveMachineMutationHookResult = ReturnType<typeof useArchiveMachineMutation>;
export type ArchiveMachineMutationResult = Apollo.MutationResult<ArchiveMachineMutation>;
export type ArchiveMachineMutationOptions = Apollo.BaseMutationOptions<ArchiveMachineMutation, ArchiveMachineMutationVariables>;
export const UnarchiveMachineDocument = gql`
    mutation UnarchiveMachine($input: UnarchiveMachineInput!) {
  unarchiveMachine(input: $input) {
    ...MachineFields
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useUnarchiveMachineMutation__
 *
 * To run a mutation, you first call `useUnarchiveMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveMachineMutation, { data, loading, error }] = useUnarchiveMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveMachineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnarchiveMachineMutation, UnarchiveMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnarchiveMachineMutation, UnarchiveMachineMutationVariables>(UnarchiveMachineDocument, options);
      }
export type UnarchiveMachineMutationHookResult = ReturnType<typeof useUnarchiveMachineMutation>;
export type UnarchiveMachineMutationResult = Apollo.MutationResult<UnarchiveMachineMutation>;
export type UnarchiveMachineMutationOptions = Apollo.BaseMutationOptions<UnarchiveMachineMutation, UnarchiveMachineMutationVariables>;
export const AddHeavyEquipmentDocument = gql`
    mutation AddHeavyEquipment($input: AddHeavyEquipmentInput!) {
  addHeavyEquipment(input: $input) {
    ... on Machine {
      ...MachineFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useAddHeavyEquipmentMutation__
 *
 * To run a mutation, you first call `useAddHeavyEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHeavyEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHeavyEquipmentMutation, { data, loading, error }] = useAddHeavyEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddHeavyEquipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddHeavyEquipmentMutation, AddHeavyEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddHeavyEquipmentMutation, AddHeavyEquipmentMutationVariables>(AddHeavyEquipmentDocument, options);
      }
export type AddHeavyEquipmentMutationHookResult = ReturnType<typeof useAddHeavyEquipmentMutation>;
export type AddHeavyEquipmentMutationResult = Apollo.MutationResult<AddHeavyEquipmentMutation>;
export type AddHeavyEquipmentMutationOptions = Apollo.BaseMutationOptions<AddHeavyEquipmentMutation, AddHeavyEquipmentMutationVariables>;
export const UpdateHeavyEquipmentDocument = gql`
    mutation UpdateHeavyEquipment($id: Int!, $input: UpdateHeavyEquipmentInput!) {
  updateHeavyEquipment(id: $id, input: $input) {
    ... on Machine {
      ...MachineFields
      ...ServicesFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}
${ServicesFieldsFragmentDoc}`;

/**
 * __useUpdateHeavyEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateHeavyEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHeavyEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHeavyEquipmentMutation, { data, loading, error }] = useUpdateHeavyEquipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHeavyEquipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHeavyEquipmentMutation, UpdateHeavyEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHeavyEquipmentMutation, UpdateHeavyEquipmentMutationVariables>(UpdateHeavyEquipmentDocument, options);
      }
export type UpdateHeavyEquipmentMutationHookResult = ReturnType<typeof useUpdateHeavyEquipmentMutation>;
export type UpdateHeavyEquipmentMutationResult = Apollo.MutationResult<UpdateHeavyEquipmentMutation>;
export type UpdateHeavyEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateHeavyEquipmentMutation, UpdateHeavyEquipmentMutationVariables>;
export const MoveMachineDocument = gql`
    mutation MoveMachine($input: MoveMachineInput!) {
  moveMachine(input: $input) {
    ...MachineFields
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useMoveMachineMutation__
 *
 * To run a mutation, you first call `useMoveMachineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveMachineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveMachineMutation, { data, loading, error }] = useMoveMachineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveMachineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveMachineMutation, MoveMachineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveMachineMutation, MoveMachineMutationVariables>(MoveMachineDocument, options);
      }
export type MoveMachineMutationHookResult = ReturnType<typeof useMoveMachineMutation>;
export type MoveMachineMutationResult = Apollo.MutationResult<MoveMachineMutation>;
export type MoveMachineMutationOptions = Apollo.BaseMutationOptions<MoveMachineMutation, MoveMachineMutationVariables>;
export const GetMachinesByNameDocument = gql`
    query GetMachinesByName($context: Context, $filter: FilterMachine, $pagination: OffsetPaginationInput) {
  getMachines(context: $context, filter: $filter, pagination: $pagination) {
    ... on AuthCheckGetMachines {
      page_info {
        total_items
      }
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetMachinesByNameQuery__
 *
 * To run a query within a React component, call `useGetMachinesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesByNameQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMachinesByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMachinesByNameQuery, GetMachinesByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinesByNameQuery, GetMachinesByNameQueryVariables>(GetMachinesByNameDocument, options);
      }
export function useGetMachinesByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinesByNameQuery, GetMachinesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinesByNameQuery, GetMachinesByNameQueryVariables>(GetMachinesByNameDocument, options);
        }
export function useGetMachinesByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesByNameQuery, GetMachinesByNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinesByNameQuery, GetMachinesByNameQueryVariables>(GetMachinesByNameDocument, options);
        }
export type GetMachinesByNameQueryHookResult = ReturnType<typeof useGetMachinesByNameQuery>;
export type GetMachinesByNameLazyQueryHookResult = ReturnType<typeof useGetMachinesByNameLazyQuery>;
export type GetMachinesByNameSuspenseQueryHookResult = ReturnType<typeof useGetMachinesByNameSuspenseQuery>;
export type GetMachinesByNameQueryResult = Apollo.QueryResult<GetMachinesByNameQuery, GetMachinesByNameQueryVariables>;
export const GetMachinesForPickerDocument = gql`
    query GetMachinesForPicker($context: Context, $filter: FilterMachine, $pagination: OffsetPaginationInput) {
  getMachines(context: $context, filter: $filter, pagination: $pagination) {
    ... on AuthCheckGetMachines {
      page_info {
        total_items
      }
      items {
        ...MachinePickerFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachinePickerFieldsFragmentDoc}`;

/**
 * __useGetMachinesForPickerQuery__
 *
 * To run a query within a React component, call `useGetMachinesForPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesForPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesForPickerQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMachinesForPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMachinesForPickerQuery, GetMachinesForPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinesForPickerQuery, GetMachinesForPickerQueryVariables>(GetMachinesForPickerDocument, options);
      }
export function useGetMachinesForPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinesForPickerQuery, GetMachinesForPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinesForPickerQuery, GetMachinesForPickerQueryVariables>(GetMachinesForPickerDocument, options);
        }
export function useGetMachinesForPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesForPickerQuery, GetMachinesForPickerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinesForPickerQuery, GetMachinesForPickerQueryVariables>(GetMachinesForPickerDocument, options);
        }
export type GetMachinesForPickerQueryHookResult = ReturnType<typeof useGetMachinesForPickerQuery>;
export type GetMachinesForPickerLazyQueryHookResult = ReturnType<typeof useGetMachinesForPickerLazyQuery>;
export type GetMachinesForPickerSuspenseQueryHookResult = ReturnType<typeof useGetMachinesForPickerSuspenseQuery>;
export type GetMachinesForPickerQueryResult = Apollo.QueryResult<GetMachinesForPickerQuery, GetMachinesForPickerQueryVariables>;
export const GetMachineLinkByIdDocument = gql`
    query GetMachineLinkById($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        ...MachineLinkFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineLinkFieldsFragmentDoc}`;

/**
 * __useGetMachineLinkByIdQuery__
 *
 * To run a query within a React component, call `useGetMachineLinkByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineLinkByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineLinkByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineLinkByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineLinkByIdQuery, GetMachineLinkByIdQueryVariables> & ({ variables: GetMachineLinkByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineLinkByIdQuery, GetMachineLinkByIdQueryVariables>(GetMachineLinkByIdDocument, options);
      }
export function useGetMachineLinkByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineLinkByIdQuery, GetMachineLinkByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineLinkByIdQuery, GetMachineLinkByIdQueryVariables>(GetMachineLinkByIdDocument, options);
        }
export function useGetMachineLinkByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineLinkByIdQuery, GetMachineLinkByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineLinkByIdQuery, GetMachineLinkByIdQueryVariables>(GetMachineLinkByIdDocument, options);
        }
export type GetMachineLinkByIdQueryHookResult = ReturnType<typeof useGetMachineLinkByIdQuery>;
export type GetMachineLinkByIdLazyQueryHookResult = ReturnType<typeof useGetMachineLinkByIdLazyQuery>;
export type GetMachineLinkByIdSuspenseQueryHookResult = ReturnType<typeof useGetMachineLinkByIdSuspenseQuery>;
export type GetMachineLinkByIdQueryResult = Apollo.QueryResult<GetMachineLinkByIdQuery, GetMachineLinkByIdQueryVariables>;
export const GetMachineByIdDocument = gql`
    query GetMachineById($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetMachineByIdQuery__
 *
 * To run a query within a React component, call `useGetMachineByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineByIdQuery, GetMachineByIdQueryVariables> & ({ variables: GetMachineByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineByIdQuery, GetMachineByIdQueryVariables>(GetMachineByIdDocument, options);
      }
export function useGetMachineByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineByIdQuery, GetMachineByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineByIdQuery, GetMachineByIdQueryVariables>(GetMachineByIdDocument, options);
        }
export function useGetMachineByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineByIdQuery, GetMachineByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineByIdQuery, GetMachineByIdQueryVariables>(GetMachineByIdDocument, options);
        }
export type GetMachineByIdQueryHookResult = ReturnType<typeof useGetMachineByIdQuery>;
export type GetMachineByIdLazyQueryHookResult = ReturnType<typeof useGetMachineByIdLazyQuery>;
export type GetMachineByIdSuspenseQueryHookResult = ReturnType<typeof useGetMachineByIdSuspenseQuery>;
export type GetMachineByIdQueryResult = Apollo.QueryResult<GetMachineByIdQuery, GetMachineByIdQueryVariables>;
export const GetNextServiceByMachineIdDocument = gql`
    query GetNextServiceByMachineId($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        id
        next_services(limit: 1) {
          ...NextServiceFields
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${NextServiceFieldsFragmentDoc}`;

/**
 * __useGetNextServiceByMachineIdQuery__
 *
 * To run a query within a React component, call `useGetNextServiceByMachineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextServiceByMachineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextServiceByMachineIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNextServiceByMachineIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNextServiceByMachineIdQuery, GetNextServiceByMachineIdQueryVariables> & ({ variables: GetNextServiceByMachineIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNextServiceByMachineIdQuery, GetNextServiceByMachineIdQueryVariables>(GetNextServiceByMachineIdDocument, options);
      }
export function useGetNextServiceByMachineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNextServiceByMachineIdQuery, GetNextServiceByMachineIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNextServiceByMachineIdQuery, GetNextServiceByMachineIdQueryVariables>(GetNextServiceByMachineIdDocument, options);
        }
export function useGetNextServiceByMachineIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNextServiceByMachineIdQuery, GetNextServiceByMachineIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNextServiceByMachineIdQuery, GetNextServiceByMachineIdQueryVariables>(GetNextServiceByMachineIdDocument, options);
        }
export type GetNextServiceByMachineIdQueryHookResult = ReturnType<typeof useGetNextServiceByMachineIdQuery>;
export type GetNextServiceByMachineIdLazyQueryHookResult = ReturnType<typeof useGetNextServiceByMachineIdLazyQuery>;
export type GetNextServiceByMachineIdSuspenseQueryHookResult = ReturnType<typeof useGetNextServiceByMachineIdSuspenseQuery>;
export type GetNextServiceByMachineIdQueryResult = Apollo.QueryResult<GetNextServiceByMachineIdQuery, GetNextServiceByMachineIdQueryVariables>;
export const GetMachinePhotosByIdDocument = gql`
    query GetMachinePhotosById($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        id
        photos {
          id
          url
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetMachinePhotosByIdQuery__
 *
 * To run a query within a React component, call `useGetMachinePhotosByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinePhotosByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinePhotosByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachinePhotosByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachinePhotosByIdQuery, GetMachinePhotosByIdQueryVariables> & ({ variables: GetMachinePhotosByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinePhotosByIdQuery, GetMachinePhotosByIdQueryVariables>(GetMachinePhotosByIdDocument, options);
      }
export function useGetMachinePhotosByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinePhotosByIdQuery, GetMachinePhotosByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinePhotosByIdQuery, GetMachinePhotosByIdQueryVariables>(GetMachinePhotosByIdDocument, options);
        }
export function useGetMachinePhotosByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinePhotosByIdQuery, GetMachinePhotosByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinePhotosByIdQuery, GetMachinePhotosByIdQueryVariables>(GetMachinePhotosByIdDocument, options);
        }
export type GetMachinePhotosByIdQueryHookResult = ReturnType<typeof useGetMachinePhotosByIdQuery>;
export type GetMachinePhotosByIdLazyQueryHookResult = ReturnType<typeof useGetMachinePhotosByIdLazyQuery>;
export type GetMachinePhotosByIdSuspenseQueryHookResult = ReturnType<typeof useGetMachinePhotosByIdSuspenseQuery>;
export type GetMachinePhotosByIdQueryResult = Apollo.QueryResult<GetMachinePhotosByIdQuery, GetMachinePhotosByIdQueryVariables>;
export const GetMachinesDocument = gql`
    query GetMachines($context: Context, $pagination: OffsetPaginationInput) {
  getMachines(context: $context, pagination: $pagination) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetMachinesQuery__
 *
 * To run a query within a React component, call `useGetMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesQuery({
 *   variables: {
 *      context: // value for 'context'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMachinesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinesQuery, GetMachinesQueryVariables>(GetMachinesDocument, options);
      }
export function useGetMachinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinesQuery, GetMachinesQueryVariables>(GetMachinesDocument, options);
        }
export function useGetMachinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinesQuery, GetMachinesQueryVariables>(GetMachinesDocument, options);
        }
export type GetMachinesQueryHookResult = ReturnType<typeof useGetMachinesQuery>;
export type GetMachinesLazyQueryHookResult = ReturnType<typeof useGetMachinesLazyQuery>;
export type GetMachinesSuspenseQueryHookResult = ReturnType<typeof useGetMachinesSuspenseQuery>;
export type GetMachinesQueryResult = Apollo.QueryResult<GetMachinesQuery, GetMachinesQueryVariables>;
export const GetAllArchivedMachinesDocument = gql`
    query GetAllArchivedMachines($context: Context) {
  getMachines(context: $context, filter: {is_archived: true}) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetAllArchivedMachinesQuery__
 *
 * To run a query within a React component, call `useGetAllArchivedMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllArchivedMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllArchivedMachinesQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetAllArchivedMachinesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllArchivedMachinesQuery, GetAllArchivedMachinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllArchivedMachinesQuery, GetAllArchivedMachinesQueryVariables>(GetAllArchivedMachinesDocument, options);
      }
export function useGetAllArchivedMachinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllArchivedMachinesQuery, GetAllArchivedMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllArchivedMachinesQuery, GetAllArchivedMachinesQueryVariables>(GetAllArchivedMachinesDocument, options);
        }
export function useGetAllArchivedMachinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllArchivedMachinesQuery, GetAllArchivedMachinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllArchivedMachinesQuery, GetAllArchivedMachinesQueryVariables>(GetAllArchivedMachinesDocument, options);
        }
export type GetAllArchivedMachinesQueryHookResult = ReturnType<typeof useGetAllArchivedMachinesQuery>;
export type GetAllArchivedMachinesLazyQueryHookResult = ReturnType<typeof useGetAllArchivedMachinesLazyQuery>;
export type GetAllArchivedMachinesSuspenseQueryHookResult = ReturnType<typeof useGetAllArchivedMachinesSuspenseQuery>;
export type GetAllArchivedMachinesQueryResult = Apollo.QueryResult<GetAllArchivedMachinesQuery, GetAllArchivedMachinesQueryVariables>;
export const GetMachineGroupCountsDocument = gql`
    query GetMachineGroupCounts($context: Context) {
  getMachineGroupCounts(context: $context) {
    ... on AuthCheckGetMachineGroupCounts {
      items {
        group
        count
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetMachineGroupCountsQuery__
 *
 * To run a query within a React component, call `useGetMachineGroupCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineGroupCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineGroupCountsQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetMachineGroupCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMachineGroupCountsQuery, GetMachineGroupCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineGroupCountsQuery, GetMachineGroupCountsQueryVariables>(GetMachineGroupCountsDocument, options);
      }
export function useGetMachineGroupCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineGroupCountsQuery, GetMachineGroupCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineGroupCountsQuery, GetMachineGroupCountsQueryVariables>(GetMachineGroupCountsDocument, options);
        }
export function useGetMachineGroupCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineGroupCountsQuery, GetMachineGroupCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineGroupCountsQuery, GetMachineGroupCountsQueryVariables>(GetMachineGroupCountsDocument, options);
        }
export type GetMachineGroupCountsQueryHookResult = ReturnType<typeof useGetMachineGroupCountsQuery>;
export type GetMachineGroupCountsLazyQueryHookResult = ReturnType<typeof useGetMachineGroupCountsLazyQuery>;
export type GetMachineGroupCountsSuspenseQueryHookResult = ReturnType<typeof useGetMachineGroupCountsSuspenseQuery>;
export type GetMachineGroupCountsQueryResult = Apollo.QueryResult<GetMachineGroupCountsQuery, GetMachineGroupCountsQueryVariables>;
export const GetHeavyEquipmentDocument = gql`
    query GetHeavyEquipment($context: Context) {
  getMachines(context: $context, filter: {group: EQUIPO_PESADO}) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetHeavyEquipmentQuery__
 *
 * To run a query within a React component, call `useGetHeavyEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeavyEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeavyEquipmentQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetHeavyEquipmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHeavyEquipmentQuery, GetHeavyEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHeavyEquipmentQuery, GetHeavyEquipmentQueryVariables>(GetHeavyEquipmentDocument, options);
      }
export function useGetHeavyEquipmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHeavyEquipmentQuery, GetHeavyEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHeavyEquipmentQuery, GetHeavyEquipmentQueryVariables>(GetHeavyEquipmentDocument, options);
        }
export function useGetHeavyEquipmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetHeavyEquipmentQuery, GetHeavyEquipmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHeavyEquipmentQuery, GetHeavyEquipmentQueryVariables>(GetHeavyEquipmentDocument, options);
        }
export type GetHeavyEquipmentQueryHookResult = ReturnType<typeof useGetHeavyEquipmentQuery>;
export type GetHeavyEquipmentLazyQueryHookResult = ReturnType<typeof useGetHeavyEquipmentLazyQuery>;
export type GetHeavyEquipmentSuspenseQueryHookResult = ReturnType<typeof useGetHeavyEquipmentSuspenseQuery>;
export type GetHeavyEquipmentQueryResult = Apollo.QueryResult<GetHeavyEquipmentQuery, GetHeavyEquipmentQueryVariables>;
export const GetUploadMachinesPresignatedUrlDocument = gql`
    query GetUploadMachinesPresignatedUrl($companyId: Int!) {
  getUploadMachinesPresignatedUrl(companyId: $companyId) {
    ... on AuthCheckGetUploadMachinesPresignatedUrl {
      item {
        uploadUrl
        templateUrl
        statusId
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetUploadMachinesPresignatedUrlQuery__
 *
 * To run a query within a React component, call `useGetUploadMachinesPresignatedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadMachinesPresignatedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadMachinesPresignatedUrlQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetUploadMachinesPresignatedUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUploadMachinesPresignatedUrlQuery, GetUploadMachinesPresignatedUrlQueryVariables> & ({ variables: GetUploadMachinesPresignatedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadMachinesPresignatedUrlQuery, GetUploadMachinesPresignatedUrlQueryVariables>(GetUploadMachinesPresignatedUrlDocument, options);
      }
export function useGetUploadMachinesPresignatedUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUploadMachinesPresignatedUrlQuery, GetUploadMachinesPresignatedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadMachinesPresignatedUrlQuery, GetUploadMachinesPresignatedUrlQueryVariables>(GetUploadMachinesPresignatedUrlDocument, options);
        }
export function useGetUploadMachinesPresignatedUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUploadMachinesPresignatedUrlQuery, GetUploadMachinesPresignatedUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUploadMachinesPresignatedUrlQuery, GetUploadMachinesPresignatedUrlQueryVariables>(GetUploadMachinesPresignatedUrlDocument, options);
        }
export type GetUploadMachinesPresignatedUrlQueryHookResult = ReturnType<typeof useGetUploadMachinesPresignatedUrlQuery>;
export type GetUploadMachinesPresignatedUrlLazyQueryHookResult = ReturnType<typeof useGetUploadMachinesPresignatedUrlLazyQuery>;
export type GetUploadMachinesPresignatedUrlSuspenseQueryHookResult = ReturnType<typeof useGetUploadMachinesPresignatedUrlSuspenseQuery>;
export type GetUploadMachinesPresignatedUrlQueryResult = Apollo.QueryResult<GetUploadMachinesPresignatedUrlQuery, GetUploadMachinesPresignatedUrlQueryVariables>;
export const GetUploadStatusDocument = gql`
    query GetUploadStatus($statusId: ID!) {
  getUploadStatus(statusId: $statusId) {
    type
    info
  }
}
    `;

/**
 * __useGetUploadStatusQuery__
 *
 * To run a query within a React component, call `useGetUploadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadStatusQuery({
 *   variables: {
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useGetUploadStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUploadStatusQuery, GetUploadStatusQueryVariables> & ({ variables: GetUploadStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadStatusQuery, GetUploadStatusQueryVariables>(GetUploadStatusDocument, options);
      }
export function useGetUploadStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUploadStatusQuery, GetUploadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadStatusQuery, GetUploadStatusQueryVariables>(GetUploadStatusDocument, options);
        }
export function useGetUploadStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUploadStatusQuery, GetUploadStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUploadStatusQuery, GetUploadStatusQueryVariables>(GetUploadStatusDocument, options);
        }
export type GetUploadStatusQueryHookResult = ReturnType<typeof useGetUploadStatusQuery>;
export type GetUploadStatusLazyQueryHookResult = ReturnType<typeof useGetUploadStatusLazyQuery>;
export type GetUploadStatusSuspenseQueryHookResult = ReturnType<typeof useGetUploadStatusSuspenseQuery>;
export type GetUploadStatusQueryResult = Apollo.QueryResult<GetUploadStatusQuery, GetUploadStatusQueryVariables>;
export const UploadStatusChangedDocument = gql`
    subscription UploadStatusChanged($statusId: ID!) {
  uploadStatusChanged(statusId: $statusId) {
    type
    info
  }
}
    `;

/**
 * __useUploadStatusChangedSubscription__
 *
 * To run a query within a React component, call `useUploadStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUploadStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadStatusChangedSubscription({
 *   variables: {
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useUploadStatusChangedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<UploadStatusChangedSubscription, UploadStatusChangedSubscriptionVariables> & ({ variables: UploadStatusChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<UploadStatusChangedSubscription, UploadStatusChangedSubscriptionVariables>(UploadStatusChangedDocument, options);
      }
export type UploadStatusChangedSubscriptionHookResult = ReturnType<typeof useUploadStatusChangedSubscription>;
export type UploadStatusChangedSubscriptionResult = Apollo.SubscriptionResult<UploadStatusChangedSubscription>;
export const GetMachineTypesDocument = gql`
    query GetMachineTypes {
  getMachineTypes {
    ... on AuthCheckGetMachineTypes {
      items {
        ...MachineTypeFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineTypeFieldsFragmentDoc}`;

/**
 * __useGetMachineTypesQuery__
 *
 * To run a query within a React component, call `useGetMachineTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMachineTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMachineTypesQuery, GetMachineTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineTypesQuery, GetMachineTypesQueryVariables>(GetMachineTypesDocument, options);
      }
export function useGetMachineTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineTypesQuery, GetMachineTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineTypesQuery, GetMachineTypesQueryVariables>(GetMachineTypesDocument, options);
        }
export function useGetMachineTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineTypesQuery, GetMachineTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineTypesQuery, GetMachineTypesQueryVariables>(GetMachineTypesDocument, options);
        }
export type GetMachineTypesQueryHookResult = ReturnType<typeof useGetMachineTypesQuery>;
export type GetMachineTypesLazyQueryHookResult = ReturnType<typeof useGetMachineTypesLazyQuery>;
export type GetMachineTypesSuspenseQueryHookResult = ReturnType<typeof useGetMachineTypesSuspenseQuery>;
export type GetMachineTypesQueryResult = Apollo.QueryResult<GetMachineTypesQuery, GetMachineTypesQueryVariables>;
export const GetMachinesListCsvDocument = gql`
    query GetMachinesListCSV($company_id: Int!, $project_id: Int, $group: MachineGroup, $is_archived: Boolean, $machine_ids: [Int!], $columns: [String!]) {
  downloadMachinesWorkbook(
    company_id: $company_id
    project_id: $project_id
    group: $group
    is_archived: $is_archived
    machine_ids: $machine_ids
    columns: $columns
  ) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useGetMachinesListCsvQuery__
 *
 * To run a query within a React component, call `useGetMachinesListCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesListCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesListCsvQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      project_id: // value for 'project_id'
 *      group: // value for 'group'
 *      is_archived: // value for 'is_archived'
 *      machine_ids: // value for 'machine_ids'
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useGetMachinesListCsvQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachinesListCsvQuery, GetMachinesListCsvQueryVariables> & ({ variables: GetMachinesListCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinesListCsvQuery, GetMachinesListCsvQueryVariables>(GetMachinesListCsvDocument, options);
      }
export function useGetMachinesListCsvLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinesListCsvQuery, GetMachinesListCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinesListCsvQuery, GetMachinesListCsvQueryVariables>(GetMachinesListCsvDocument, options);
        }
export function useGetMachinesListCsvSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesListCsvQuery, GetMachinesListCsvQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinesListCsvQuery, GetMachinesListCsvQueryVariables>(GetMachinesListCsvDocument, options);
        }
export type GetMachinesListCsvQueryHookResult = ReturnType<typeof useGetMachinesListCsvQuery>;
export type GetMachinesListCsvLazyQueryHookResult = ReturnType<typeof useGetMachinesListCsvLazyQuery>;
export type GetMachinesListCsvSuspenseQueryHookResult = ReturnType<typeof useGetMachinesListCsvSuspenseQuery>;
export type GetMachinesListCsvQueryResult = Apollo.QueryResult<GetMachinesListCsvQuery, GetMachinesListCsvQueryVariables>;
export const SetMachineFuelCapacityDocument = gql`
    mutation SetMachineFuelCapacity($input: SetMachineFuelCapacityInput!) {
  setMachineFuelCapacity(input: $input) {
    ...MachineFields
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useSetMachineFuelCapacityMutation__
 *
 * To run a mutation, you first call `useSetMachineFuelCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMachineFuelCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMachineFuelCapacityMutation, { data, loading, error }] = useSetMachineFuelCapacityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMachineFuelCapacityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMachineFuelCapacityMutation, SetMachineFuelCapacityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMachineFuelCapacityMutation, SetMachineFuelCapacityMutationVariables>(SetMachineFuelCapacityDocument, options);
      }
export type SetMachineFuelCapacityMutationHookResult = ReturnType<typeof useSetMachineFuelCapacityMutation>;
export type SetMachineFuelCapacityMutationResult = Apollo.MutationResult<SetMachineFuelCapacityMutation>;
export type SetMachineFuelCapacityMutationOptions = Apollo.BaseMutationOptions<SetMachineFuelCapacityMutation, SetMachineFuelCapacityMutationVariables>;
export const GetMachineExtraDataByCompanyIdDocument = gql`
    query GetMachineExtraDataByCompanyId($companyId: Int!) {
  getCompanyMachineExtraData(companyId: $companyId) {
    ...MachineExtraDataFields
  }
}
    ${MachineExtraDataFieldsFragmentDoc}`;

/**
 * __useGetMachineExtraDataByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetMachineExtraDataByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineExtraDataByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineExtraDataByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetMachineExtraDataByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineExtraDataByCompanyIdQuery, GetMachineExtraDataByCompanyIdQueryVariables> & ({ variables: GetMachineExtraDataByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineExtraDataByCompanyIdQuery, GetMachineExtraDataByCompanyIdQueryVariables>(GetMachineExtraDataByCompanyIdDocument, options);
      }
export function useGetMachineExtraDataByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineExtraDataByCompanyIdQuery, GetMachineExtraDataByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineExtraDataByCompanyIdQuery, GetMachineExtraDataByCompanyIdQueryVariables>(GetMachineExtraDataByCompanyIdDocument, options);
        }
export function useGetMachineExtraDataByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineExtraDataByCompanyIdQuery, GetMachineExtraDataByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineExtraDataByCompanyIdQuery, GetMachineExtraDataByCompanyIdQueryVariables>(GetMachineExtraDataByCompanyIdDocument, options);
        }
export type GetMachineExtraDataByCompanyIdQueryHookResult = ReturnType<typeof useGetMachineExtraDataByCompanyIdQuery>;
export type GetMachineExtraDataByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetMachineExtraDataByCompanyIdLazyQuery>;
export type GetMachineExtraDataByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetMachineExtraDataByCompanyIdSuspenseQuery>;
export type GetMachineExtraDataByCompanyIdQueryResult = Apollo.QueryResult<GetMachineExtraDataByCompanyIdQuery, GetMachineExtraDataByCompanyIdQueryVariables>;
export const BatchUpsertMachineExtraDataDocument = gql`
    mutation BatchUpsertMachineExtraData($input: [AddCompanyMachineExtraDataInput!]!) {
  batchUpsertCompanyMachineExtraData(input: $input) {
    ...MachineExtraDataFields
  }
}
    ${MachineExtraDataFieldsFragmentDoc}`;

/**
 * __useBatchUpsertMachineExtraDataMutation__
 *
 * To run a mutation, you first call `useBatchUpsertMachineExtraDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpsertMachineExtraDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpsertMachineExtraDataMutation, { data, loading, error }] = useBatchUpsertMachineExtraDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchUpsertMachineExtraDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchUpsertMachineExtraDataMutation, BatchUpsertMachineExtraDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchUpsertMachineExtraDataMutation, BatchUpsertMachineExtraDataMutationVariables>(BatchUpsertMachineExtraDataDocument, options);
      }
export type BatchUpsertMachineExtraDataMutationHookResult = ReturnType<typeof useBatchUpsertMachineExtraDataMutation>;
export type BatchUpsertMachineExtraDataMutationResult = Apollo.MutationResult<BatchUpsertMachineExtraDataMutation>;
export type BatchUpsertMachineExtraDataMutationOptions = Apollo.BaseMutationOptions<BatchUpsertMachineExtraDataMutation, BatchUpsertMachineExtraDataMutationVariables>;
export const BatchDeleteMachineExtraDataDocument = gql`
    mutation BatchDeleteMachineExtraData($ids: [ID!]!) {
  batchDeleteCompanyMachineExtraData(ids: $ids)
}
    `;

/**
 * __useBatchDeleteMachineExtraDataMutation__
 *
 * To run a mutation, you first call `useBatchDeleteMachineExtraDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeleteMachineExtraDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeleteMachineExtraDataMutation, { data, loading, error }] = useBatchDeleteMachineExtraDataMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBatchDeleteMachineExtraDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchDeleteMachineExtraDataMutation, BatchDeleteMachineExtraDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchDeleteMachineExtraDataMutation, BatchDeleteMachineExtraDataMutationVariables>(BatchDeleteMachineExtraDataDocument, options);
      }
export type BatchDeleteMachineExtraDataMutationHookResult = ReturnType<typeof useBatchDeleteMachineExtraDataMutation>;
export type BatchDeleteMachineExtraDataMutationResult = Apollo.MutationResult<BatchDeleteMachineExtraDataMutation>;
export type BatchDeleteMachineExtraDataMutationOptions = Apollo.BaseMutationOptions<BatchDeleteMachineExtraDataMutation, BatchDeleteMachineExtraDataMutationVariables>;
export const GetMachineProjectAtDateDocument = gql`
    query GetMachineProjectAtDate($machineId: Int!, $date: LocalDate!) {
  getMachineProjectsAtDate(machineId: $machineId, date: $date) {
    id
    name
  }
}
    `;

/**
 * __useGetMachineProjectAtDateQuery__
 *
 * To run a query within a React component, call `useGetMachineProjectAtDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineProjectAtDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineProjectAtDateQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetMachineProjectAtDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineProjectAtDateQuery, GetMachineProjectAtDateQueryVariables> & ({ variables: GetMachineProjectAtDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineProjectAtDateQuery, GetMachineProjectAtDateQueryVariables>(GetMachineProjectAtDateDocument, options);
      }
export function useGetMachineProjectAtDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineProjectAtDateQuery, GetMachineProjectAtDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineProjectAtDateQuery, GetMachineProjectAtDateQueryVariables>(GetMachineProjectAtDateDocument, options);
        }
export function useGetMachineProjectAtDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineProjectAtDateQuery, GetMachineProjectAtDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineProjectAtDateQuery, GetMachineProjectAtDateQueryVariables>(GetMachineProjectAtDateDocument, options);
        }
export type GetMachineProjectAtDateQueryHookResult = ReturnType<typeof useGetMachineProjectAtDateQuery>;
export type GetMachineProjectAtDateLazyQueryHookResult = ReturnType<typeof useGetMachineProjectAtDateLazyQuery>;
export type GetMachineProjectAtDateSuspenseQueryHookResult = ReturnType<typeof useGetMachineProjectAtDateSuspenseQuery>;
export type GetMachineProjectAtDateQueryResult = Apollo.QueryResult<GetMachineProjectAtDateQuery, GetMachineProjectAtDateQueryVariables>;
export const GetMachineHistoryDocument = gql`
    query GetMachineHistory($context: Context!, $filter: FilterMachineHistory!, $pagination: FilterPagination) {
  getMachineHistory(context: $context, filter: $filter, pagination: $pagination) {
    truncated
    page_info {
      current_page
      items_per_page
      total_items
      total_pages
    }
    facets {
      field
      facets {
        value
        count
      }
    }
    items {
      __typename
      id
      kind
      occurred_at
      counter {
        ...CounterFields
      }
      project {
        id
        name
      }
      created_by {
        id
        first_name
        last_name
      }
      ... on MachineMoveHistoryEvent {
        checkin {
          ...MoveReportFields
        }
        checkout {
          ...MoveReportFields
        }
      }
      ... on MachineCheckInHistoryEvent {
        report {
          ...MoveReportFields
        }
      }
      ... on MachineCheckOutHistoryEvent {
        report {
          ...MoveReportFields
        }
      }
      ... on MachineOutOfServiceHistoryEvent {
        oos_report: report {
          ...OutOfServiceReportFields
        }
      }
      ... on MachineServiceHistoryEvent {
        report {
          ...MachineHistoryServiceReportFields
        }
      }
      ... on MachineAssignmentHistoryEvent {
        report {
          ...AssignmentReportFields
        }
      }
      ... on MachineWorkOrderHistoryEvent {
        work_order {
          ...WorkOrderFields
        }
      }
      ... on MachineNoticeHistoryEvent {
        notice {
          id
          serial_number
          severity
          status
          message
          created_at
          source_type
          source_checklist_id
          creator {
            id
            first_name
            last_name
          }
          linked_work_order {
            id
            title
            serial_number
            type {
              id
              name
            }
          }
        }
      }
      ... on MachineChecklistHistoryEvent {
        checklist {
          id
          serial_number
          template_title
          version_number
          pass_count
          fail_count
          na_count
        }
      }
    }
  }
}
    ${CounterFieldsFragmentDoc}
${MoveReportFieldsFragmentDoc}
${OutOfServiceReportFieldsFragmentDoc}
${MachineHistoryServiceReportFieldsFragmentDoc}
${AssignmentReportFieldsFragmentDoc}
${WorkOrderFieldsFragmentDoc}`;

/**
 * __useGetMachineHistoryQuery__
 *
 * To run a query within a React component, call `useGetMachineHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineHistoryQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMachineHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineHistoryQuery, GetMachineHistoryQueryVariables> & ({ variables: GetMachineHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>(GetMachineHistoryDocument, options);
      }
export function useGetMachineHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>(GetMachineHistoryDocument, options);
        }
export function useGetMachineHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>(GetMachineHistoryDocument, options);
        }
export type GetMachineHistoryQueryHookResult = ReturnType<typeof useGetMachineHistoryQuery>;
export type GetMachineHistoryLazyQueryHookResult = ReturnType<typeof useGetMachineHistoryLazyQuery>;
export type GetMachineHistorySuspenseQueryHookResult = ReturnType<typeof useGetMachineHistorySuspenseQuery>;
export type GetMachineHistoryQueryResult = Apollo.QueryResult<GetMachineHistoryQuery, GetMachineHistoryQueryVariables>;
export const GetMachineConsumablesByCompanyIdDocument = gql`
    query GetMachineConsumablesByCompanyId($id: Int!, $filter: FilterMachineConsumables!) {
  getMachineConsumablesByCompanyId(id: $id, filter: $filter) {
    items {
      ...ConsumableFields
    }
  }
}
    ${ConsumableFieldsFragmentDoc}`;

/**
 * __useGetMachineConsumablesByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetMachineConsumablesByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineConsumablesByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineConsumablesByCompanyIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMachineConsumablesByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineConsumablesByCompanyIdQuery, GetMachineConsumablesByCompanyIdQueryVariables> & ({ variables: GetMachineConsumablesByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineConsumablesByCompanyIdQuery, GetMachineConsumablesByCompanyIdQueryVariables>(GetMachineConsumablesByCompanyIdDocument, options);
      }
export function useGetMachineConsumablesByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineConsumablesByCompanyIdQuery, GetMachineConsumablesByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineConsumablesByCompanyIdQuery, GetMachineConsumablesByCompanyIdQueryVariables>(GetMachineConsumablesByCompanyIdDocument, options);
        }
export function useGetMachineConsumablesByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineConsumablesByCompanyIdQuery, GetMachineConsumablesByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineConsumablesByCompanyIdQuery, GetMachineConsumablesByCompanyIdQueryVariables>(GetMachineConsumablesByCompanyIdDocument, options);
        }
export type GetMachineConsumablesByCompanyIdQueryHookResult = ReturnType<typeof useGetMachineConsumablesByCompanyIdQuery>;
export type GetMachineConsumablesByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetMachineConsumablesByCompanyIdLazyQuery>;
export type GetMachineConsumablesByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetMachineConsumablesByCompanyIdSuspenseQuery>;
export type GetMachineConsumablesByCompanyIdQueryResult = Apollo.QueryResult<GetMachineConsumablesByCompanyIdQuery, GetMachineConsumablesByCompanyIdQueryVariables>;
export const GetBilderitMachineConsumablesDocument = gql`
    query GetBilderitMachineConsumables($filter: FilterMachineConsumables!) {
  getBilderitMachineConsumables(filter: $filter) {
    items {
      ...ConsumableFields
    }
  }
}
    ${ConsumableFieldsFragmentDoc}`;

/**
 * __useGetBilderitMachineConsumablesQuery__
 *
 * To run a query within a React component, call `useGetBilderitMachineConsumablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBilderitMachineConsumablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBilderitMachineConsumablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBilderitMachineConsumablesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBilderitMachineConsumablesQuery, GetBilderitMachineConsumablesQueryVariables> & ({ variables: GetBilderitMachineConsumablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBilderitMachineConsumablesQuery, GetBilderitMachineConsumablesQueryVariables>(GetBilderitMachineConsumablesDocument, options);
      }
export function useGetBilderitMachineConsumablesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBilderitMachineConsumablesQuery, GetBilderitMachineConsumablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBilderitMachineConsumablesQuery, GetBilderitMachineConsumablesQueryVariables>(GetBilderitMachineConsumablesDocument, options);
        }
export function useGetBilderitMachineConsumablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBilderitMachineConsumablesQuery, GetBilderitMachineConsumablesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBilderitMachineConsumablesQuery, GetBilderitMachineConsumablesQueryVariables>(GetBilderitMachineConsumablesDocument, options);
        }
export type GetBilderitMachineConsumablesQueryHookResult = ReturnType<typeof useGetBilderitMachineConsumablesQuery>;
export type GetBilderitMachineConsumablesLazyQueryHookResult = ReturnType<typeof useGetBilderitMachineConsumablesLazyQuery>;
export type GetBilderitMachineConsumablesSuspenseQueryHookResult = ReturnType<typeof useGetBilderitMachineConsumablesSuspenseQuery>;
export type GetBilderitMachineConsumablesQueryResult = Apollo.QueryResult<GetBilderitMachineConsumablesQuery, GetBilderitMachineConsumablesQueryVariables>;
export const GetMachinePartsByCompanyIdDocument = gql`
    query GetMachinePartsByCompanyId($id: Int!, $filter: FilterMachineParts!) {
  getMachinePartsByCompanyId(id: $id, filter: $filter) {
    items {
      ...MachinePartFields
    }
  }
}
    ${MachinePartFieldsFragmentDoc}`;

/**
 * __useGetMachinePartsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetMachinePartsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinePartsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinePartsByCompanyIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMachinePartsByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachinePartsByCompanyIdQuery, GetMachinePartsByCompanyIdQueryVariables> & ({ variables: GetMachinePartsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinePartsByCompanyIdQuery, GetMachinePartsByCompanyIdQueryVariables>(GetMachinePartsByCompanyIdDocument, options);
      }
export function useGetMachinePartsByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinePartsByCompanyIdQuery, GetMachinePartsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinePartsByCompanyIdQuery, GetMachinePartsByCompanyIdQueryVariables>(GetMachinePartsByCompanyIdDocument, options);
        }
export function useGetMachinePartsByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinePartsByCompanyIdQuery, GetMachinePartsByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinePartsByCompanyIdQuery, GetMachinePartsByCompanyIdQueryVariables>(GetMachinePartsByCompanyIdDocument, options);
        }
export type GetMachinePartsByCompanyIdQueryHookResult = ReturnType<typeof useGetMachinePartsByCompanyIdQuery>;
export type GetMachinePartsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetMachinePartsByCompanyIdLazyQuery>;
export type GetMachinePartsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetMachinePartsByCompanyIdSuspenseQuery>;
export type GetMachinePartsByCompanyIdQueryResult = Apollo.QueryResult<GetMachinePartsByCompanyIdQuery, GetMachinePartsByCompanyIdQueryVariables>;
export const GetAllMaintenancePlansDocument = gql`
    query GetAllMaintenancePlans($context: Context!, $filter: FilterMaintenancePlans) {
  getAllMaintenancePlans(context: $context, filter: $filter) {
    items {
      ...MaintenancePlanTableFields
    }
  }
}
    ${MaintenancePlanTableFieldsFragmentDoc}`;

/**
 * __useGetAllMaintenancePlansQuery__
 *
 * To run a query within a React component, call `useGetAllMaintenancePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMaintenancePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMaintenancePlansQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllMaintenancePlansQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAllMaintenancePlansQuery, GetAllMaintenancePlansQueryVariables> & ({ variables: GetAllMaintenancePlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllMaintenancePlansQuery, GetAllMaintenancePlansQueryVariables>(GetAllMaintenancePlansDocument, options);
      }
export function useGetAllMaintenancePlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllMaintenancePlansQuery, GetAllMaintenancePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllMaintenancePlansQuery, GetAllMaintenancePlansQueryVariables>(GetAllMaintenancePlansDocument, options);
        }
export function useGetAllMaintenancePlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllMaintenancePlansQuery, GetAllMaintenancePlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllMaintenancePlansQuery, GetAllMaintenancePlansQueryVariables>(GetAllMaintenancePlansDocument, options);
        }
export type GetAllMaintenancePlansQueryHookResult = ReturnType<typeof useGetAllMaintenancePlansQuery>;
export type GetAllMaintenancePlansLazyQueryHookResult = ReturnType<typeof useGetAllMaintenancePlansLazyQuery>;
export type GetAllMaintenancePlansSuspenseQueryHookResult = ReturnType<typeof useGetAllMaintenancePlansSuspenseQuery>;
export type GetAllMaintenancePlansQueryResult = Apollo.QueryResult<GetAllMaintenancePlansQuery, GetAllMaintenancePlansQueryVariables>;
export const GetAllBilderitMaintenancePlansDocument = gql`
    query GetAllBilderitMaintenancePlans($filter: FilterMaintenancePlans) {
  getBilderitMaintenancePlans(filter: $filter) {
    items {
      ...MaintenancePlanTableFields
    }
  }
}
    ${MaintenancePlanTableFieldsFragmentDoc}`;

/**
 * __useGetAllBilderitMaintenancePlansQuery__
 *
 * To run a query within a React component, call `useGetAllBilderitMaintenancePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBilderitMaintenancePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBilderitMaintenancePlansQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllBilderitMaintenancePlansQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllBilderitMaintenancePlansQuery, GetAllBilderitMaintenancePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllBilderitMaintenancePlansQuery, GetAllBilderitMaintenancePlansQueryVariables>(GetAllBilderitMaintenancePlansDocument, options);
      }
export function useGetAllBilderitMaintenancePlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllBilderitMaintenancePlansQuery, GetAllBilderitMaintenancePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllBilderitMaintenancePlansQuery, GetAllBilderitMaintenancePlansQueryVariables>(GetAllBilderitMaintenancePlansDocument, options);
        }
export function useGetAllBilderitMaintenancePlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllBilderitMaintenancePlansQuery, GetAllBilderitMaintenancePlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllBilderitMaintenancePlansQuery, GetAllBilderitMaintenancePlansQueryVariables>(GetAllBilderitMaintenancePlansDocument, options);
        }
export type GetAllBilderitMaintenancePlansQueryHookResult = ReturnType<typeof useGetAllBilderitMaintenancePlansQuery>;
export type GetAllBilderitMaintenancePlansLazyQueryHookResult = ReturnType<typeof useGetAllBilderitMaintenancePlansLazyQuery>;
export type GetAllBilderitMaintenancePlansSuspenseQueryHookResult = ReturnType<typeof useGetAllBilderitMaintenancePlansSuspenseQuery>;
export type GetAllBilderitMaintenancePlansQueryResult = Apollo.QueryResult<GetAllBilderitMaintenancePlansQuery, GetAllBilderitMaintenancePlansQueryVariables>;
export const GetMaintenancePlansForTypeaheadDocument = gql`
    query GetMaintenancePlansForTypeahead($context: Context!, $filter: FilterMaintenancePlans) {
  getAllMaintenancePlans(context: $context, filter: $filter) {
    items {
      ...MaintenancePlanTypeaheadFields
    }
  }
}
    ${MaintenancePlanTypeaheadFieldsFragmentDoc}`;

/**
 * __useGetMaintenancePlansForTypeaheadQuery__
 *
 * To run a query within a React component, call `useGetMaintenancePlansForTypeaheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenancePlansForTypeaheadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenancePlansForTypeaheadQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMaintenancePlansForTypeaheadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMaintenancePlansForTypeaheadQuery, GetMaintenancePlansForTypeaheadQueryVariables> & ({ variables: GetMaintenancePlansForTypeaheadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMaintenancePlansForTypeaheadQuery, GetMaintenancePlansForTypeaheadQueryVariables>(GetMaintenancePlansForTypeaheadDocument, options);
      }
export function useGetMaintenancePlansForTypeaheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMaintenancePlansForTypeaheadQuery, GetMaintenancePlansForTypeaheadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMaintenancePlansForTypeaheadQuery, GetMaintenancePlansForTypeaheadQueryVariables>(GetMaintenancePlansForTypeaheadDocument, options);
        }
export function useGetMaintenancePlansForTypeaheadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMaintenancePlansForTypeaheadQuery, GetMaintenancePlansForTypeaheadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMaintenancePlansForTypeaheadQuery, GetMaintenancePlansForTypeaheadQueryVariables>(GetMaintenancePlansForTypeaheadDocument, options);
        }
export type GetMaintenancePlansForTypeaheadQueryHookResult = ReturnType<typeof useGetMaintenancePlansForTypeaheadQuery>;
export type GetMaintenancePlansForTypeaheadLazyQueryHookResult = ReturnType<typeof useGetMaintenancePlansForTypeaheadLazyQuery>;
export type GetMaintenancePlansForTypeaheadSuspenseQueryHookResult = ReturnType<typeof useGetMaintenancePlansForTypeaheadSuspenseQuery>;
export type GetMaintenancePlansForTypeaheadQueryResult = Apollo.QueryResult<GetMaintenancePlansForTypeaheadQuery, GetMaintenancePlansForTypeaheadQueryVariables>;
export const GetMaintenancePlanByIdDocument = gql`
    query GetMaintenancePlanById($id: Int!) {
  getMaintenancePlanById(id: $id) {
    item {
      ...MaintenancePlanFields
    }
  }
}
    ${MaintenancePlanFieldsFragmentDoc}`;

/**
 * __useGetMaintenancePlanByIdQuery__
 *
 * To run a query within a React component, call `useGetMaintenancePlanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenancePlanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenancePlanByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMaintenancePlanByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMaintenancePlanByIdQuery, GetMaintenancePlanByIdQueryVariables> & ({ variables: GetMaintenancePlanByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMaintenancePlanByIdQuery, GetMaintenancePlanByIdQueryVariables>(GetMaintenancePlanByIdDocument, options);
      }
export function useGetMaintenancePlanByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMaintenancePlanByIdQuery, GetMaintenancePlanByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMaintenancePlanByIdQuery, GetMaintenancePlanByIdQueryVariables>(GetMaintenancePlanByIdDocument, options);
        }
export function useGetMaintenancePlanByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMaintenancePlanByIdQuery, GetMaintenancePlanByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMaintenancePlanByIdQuery, GetMaintenancePlanByIdQueryVariables>(GetMaintenancePlanByIdDocument, options);
        }
export type GetMaintenancePlanByIdQueryHookResult = ReturnType<typeof useGetMaintenancePlanByIdQuery>;
export type GetMaintenancePlanByIdLazyQueryHookResult = ReturnType<typeof useGetMaintenancePlanByIdLazyQuery>;
export type GetMaintenancePlanByIdSuspenseQueryHookResult = ReturnType<typeof useGetMaintenancePlanByIdSuspenseQuery>;
export type GetMaintenancePlanByIdQueryResult = Apollo.QueryResult<GetMaintenancePlanByIdQuery, GetMaintenancePlanByIdQueryVariables>;
export const AddMaintenancePlanDocument = gql`
    mutation AddMaintenancePlan($title: String!, $description: String!, $company_id: Int!, $base_period: Float!, $period_type: PeriodType!, $programs: [MPProgramInput!]!, $machine_parts: [MachinePartInput!]!, $tag_ids: [ID!]!, $type_tag_ids: [ID!]!, $brand_tag_ids: [ID!]!) {
  addMaintenancePlan(
    input: {title: $title, description: $description, company_id: $company_id, base_period: $base_period, period_type: $period_type, programs: $programs, machine_parts: $machine_parts, tag_ids: $tag_ids, type_tag_ids: $type_tag_ids, brand_tag_ids: $brand_tag_ids}
  ) {
    ... on MaintenancePlanItem {
      item {
        ...MaintenancePlanFields
      }
    }
  }
}
    ${MaintenancePlanFieldsFragmentDoc}`;

/**
 * __useAddMaintenancePlanMutation__
 *
 * To run a mutation, you first call `useAddMaintenancePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMaintenancePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMaintenancePlanMutation, { data, loading, error }] = useAddMaintenancePlanMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      company_id: // value for 'company_id'
 *      base_period: // value for 'base_period'
 *      period_type: // value for 'period_type'
 *      programs: // value for 'programs'
 *      machine_parts: // value for 'machine_parts'
 *      tag_ids: // value for 'tag_ids'
 *      type_tag_ids: // value for 'type_tag_ids'
 *      brand_tag_ids: // value for 'brand_tag_ids'
 *   },
 * });
 */
export function useAddMaintenancePlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMaintenancePlanMutation, AddMaintenancePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddMaintenancePlanMutation, AddMaintenancePlanMutationVariables>(AddMaintenancePlanDocument, options);
      }
export type AddMaintenancePlanMutationHookResult = ReturnType<typeof useAddMaintenancePlanMutation>;
export type AddMaintenancePlanMutationResult = Apollo.MutationResult<AddMaintenancePlanMutation>;
export type AddMaintenancePlanMutationOptions = Apollo.BaseMutationOptions<AddMaintenancePlanMutation, AddMaintenancePlanMutationVariables>;
export const AddBilderitMaintenancePlanDocument = gql`
    mutation AddBilderitMaintenancePlan($title: String!, $description: String!, $base_period: Float!, $period_type: PeriodType!, $programs: [MPProgramInput!]!, $machine_parts: [MachinePartInput!]!, $tag_ids: [ID!]!, $type_tag_ids: [ID!]!, $brand_tag_ids: [ID!]!) {
  addBilderitMaintenancePlan(
    input: {title: $title, description: $description, base_period: $base_period, period_type: $period_type, programs: $programs, machine_parts: $machine_parts, tag_ids: $tag_ids, type_tag_ids: $type_tag_ids, brand_tag_ids: $brand_tag_ids}
  ) {
    ... on MaintenancePlan {
      ...MaintenancePlanFields
    }
  }
}
    ${MaintenancePlanFieldsFragmentDoc}`;

/**
 * __useAddBilderitMaintenancePlanMutation__
 *
 * To run a mutation, you first call `useAddBilderitMaintenancePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBilderitMaintenancePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBilderitMaintenancePlanMutation, { data, loading, error }] = useAddBilderitMaintenancePlanMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      base_period: // value for 'base_period'
 *      period_type: // value for 'period_type'
 *      programs: // value for 'programs'
 *      machine_parts: // value for 'machine_parts'
 *      tag_ids: // value for 'tag_ids'
 *      type_tag_ids: // value for 'type_tag_ids'
 *      brand_tag_ids: // value for 'brand_tag_ids'
 *   },
 * });
 */
export function useAddBilderitMaintenancePlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddBilderitMaintenancePlanMutation, AddBilderitMaintenancePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddBilderitMaintenancePlanMutation, AddBilderitMaintenancePlanMutationVariables>(AddBilderitMaintenancePlanDocument, options);
      }
export type AddBilderitMaintenancePlanMutationHookResult = ReturnType<typeof useAddBilderitMaintenancePlanMutation>;
export type AddBilderitMaintenancePlanMutationResult = Apollo.MutationResult<AddBilderitMaintenancePlanMutation>;
export type AddBilderitMaintenancePlanMutationOptions = Apollo.BaseMutationOptions<AddBilderitMaintenancePlanMutation, AddBilderitMaintenancePlanMutationVariables>;
export const DeleteMaintenancePlanDocument = gql`
    mutation DeleteMaintenancePlan($id: Int!) {
  deleteMaintenancePlan(id: $id) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useDeleteMaintenancePlanMutation__
 *
 * To run a mutation, you first call `useDeleteMaintenancePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaintenancePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaintenancePlanMutation, { data, loading, error }] = useDeleteMaintenancePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMaintenancePlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMaintenancePlanMutation, DeleteMaintenancePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMaintenancePlanMutation, DeleteMaintenancePlanMutationVariables>(DeleteMaintenancePlanDocument, options);
      }
export type DeleteMaintenancePlanMutationHookResult = ReturnType<typeof useDeleteMaintenancePlanMutation>;
export type DeleteMaintenancePlanMutationResult = Apollo.MutationResult<DeleteMaintenancePlanMutation>;
export type DeleteMaintenancePlanMutationOptions = Apollo.BaseMutationOptions<DeleteMaintenancePlanMutation, DeleteMaintenancePlanMutationVariables>;
export const UpdateMaintenancePlanDocument = gql`
    mutation UpdateMaintenancePlan($id: Int!, $title: String!, $description: String!, $base_period: Float, $period_type: PeriodType, $programs: [MPProgramInput!]!, $machine_parts: [MachinePartInput!]!, $tag_ids: [ID!], $type_tag_ids: [ID!], $brand_tag_ids: [ID!]) {
  updateMaintenancePlan(
    id: $id
    input: {title: $title, description: $description, base_period: $base_period, period_type: $period_type, programs: $programs, machine_parts: $machine_parts, tag_ids: $tag_ids, type_tag_ids: $type_tag_ids, brand_tag_ids: $brand_tag_ids}
  ) {
    ... on MaintenancePlanItem {
      item {
        ...MaintenancePlanFields
      }
    }
  }
}
    ${MaintenancePlanFieldsFragmentDoc}`;

/**
 * __useUpdateMaintenancePlanMutation__
 *
 * To run a mutation, you first call `useUpdateMaintenancePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaintenancePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaintenancePlanMutation, { data, loading, error }] = useUpdateMaintenancePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      base_period: // value for 'base_period'
 *      period_type: // value for 'period_type'
 *      programs: // value for 'programs'
 *      machine_parts: // value for 'machine_parts'
 *      tag_ids: // value for 'tag_ids'
 *      type_tag_ids: // value for 'type_tag_ids'
 *      brand_tag_ids: // value for 'brand_tag_ids'
 *   },
 * });
 */
export function useUpdateMaintenancePlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMaintenancePlanMutation, UpdateMaintenancePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMaintenancePlanMutation, UpdateMaintenancePlanMutationVariables>(UpdateMaintenancePlanDocument, options);
      }
export type UpdateMaintenancePlanMutationHookResult = ReturnType<typeof useUpdateMaintenancePlanMutation>;
export type UpdateMaintenancePlanMutationResult = Apollo.MutationResult<UpdateMaintenancePlanMutation>;
export type UpdateMaintenancePlanMutationOptions = Apollo.BaseMutationOptions<UpdateMaintenancePlanMutation, UpdateMaintenancePlanMutationVariables>;
export const UpdateMaintenancePlanTagsDocument = gql`
    mutation UpdateMaintenancePlanTags($plan_id: Int!, $tag_ids: [ID!]!, $brand_tag_ids: [ID!]!, $type_tag_ids: [ID!]!) {
  updateMaintenancePlanTags(
    input: {plan_id: $plan_id, tag_ids: $tag_ids, brand_tag_ids: $brand_tag_ids, type_tag_ids: $type_tag_ids}
  ) {
    ... on MaintenancePlanItem {
      item {
        ...MaintenancePlanTableFields
      }
    }
  }
}
    ${MaintenancePlanTableFieldsFragmentDoc}`;

/**
 * __useUpdateMaintenancePlanTagsMutation__
 *
 * To run a mutation, you first call `useUpdateMaintenancePlanTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaintenancePlanTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaintenancePlanTagsMutation, { data, loading, error }] = useUpdateMaintenancePlanTagsMutation({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      tag_ids: // value for 'tag_ids'
 *      brand_tag_ids: // value for 'brand_tag_ids'
 *      type_tag_ids: // value for 'type_tag_ids'
 *   },
 * });
 */
export function useUpdateMaintenancePlanTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMaintenancePlanTagsMutation, UpdateMaintenancePlanTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMaintenancePlanTagsMutation, UpdateMaintenancePlanTagsMutationVariables>(UpdateMaintenancePlanTagsDocument, options);
      }
export type UpdateMaintenancePlanTagsMutationHookResult = ReturnType<typeof useUpdateMaintenancePlanTagsMutation>;
export type UpdateMaintenancePlanTagsMutationResult = Apollo.MutationResult<UpdateMaintenancePlanTagsMutation>;
export type UpdateMaintenancePlanTagsMutationOptions = Apollo.BaseMutationOptions<UpdateMaintenancePlanTagsMutation, UpdateMaintenancePlanTagsMutationVariables>;
export const AssignMaintenancePlanBatchDocument = gql`
    mutation AssignMaintenancePlanBatch($mp_id: Int!, $machine_ids: [Int!]!) {
  assignMaintenancePlanBatch(input: {mp_id: $mp_id, machine_ids: $machine_ids}) {
    ... on AssignMaintenancePlanBatchSuccess {
      items {
        ...MachineFields
        ...ServicesFields
      }
    }
  }
}
    ${MachineFieldsFragmentDoc}
${ServicesFieldsFragmentDoc}`;

/**
 * __useAssignMaintenancePlanBatchMutation__
 *
 * To run a mutation, you first call `useAssignMaintenancePlanBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMaintenancePlanBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMaintenancePlanBatchMutation, { data, loading, error }] = useAssignMaintenancePlanBatchMutation({
 *   variables: {
 *      mp_id: // value for 'mp_id'
 *      machine_ids: // value for 'machine_ids'
 *   },
 * });
 */
export function useAssignMaintenancePlanBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignMaintenancePlanBatchMutation, AssignMaintenancePlanBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignMaintenancePlanBatchMutation, AssignMaintenancePlanBatchMutationVariables>(AssignMaintenancePlanBatchDocument, options);
      }
export type AssignMaintenancePlanBatchMutationHookResult = ReturnType<typeof useAssignMaintenancePlanBatchMutation>;
export type AssignMaintenancePlanBatchMutationResult = Apollo.MutationResult<AssignMaintenancePlanBatchMutation>;
export type AssignMaintenancePlanBatchMutationOptions = Apollo.BaseMutationOptions<AssignMaintenancePlanBatchMutation, AssignMaintenancePlanBatchMutationVariables>;
export const SetMaintenancePlanStatusDocument = gql`
    mutation SetMaintenancePlanStatus($plan_id: Int!, $status: MaintenancePlanStatus!) {
  setMaintenancePlanStatus(plan_id: $plan_id, status: $status) {
    ...MaintenancePlanFields
  }
}
    ${MaintenancePlanFieldsFragmentDoc}`;

/**
 * __useSetMaintenancePlanStatusMutation__
 *
 * To run a mutation, you first call `useSetMaintenancePlanStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMaintenancePlanStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMaintenancePlanStatusMutation, { data, loading, error }] = useSetMaintenancePlanStatusMutation({
 *   variables: {
 *      plan_id: // value for 'plan_id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetMaintenancePlanStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMaintenancePlanStatusMutation, SetMaintenancePlanStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMaintenancePlanStatusMutation, SetMaintenancePlanStatusMutationVariables>(SetMaintenancePlanStatusDocument, options);
      }
export type SetMaintenancePlanStatusMutationHookResult = ReturnType<typeof useSetMaintenancePlanStatusMutation>;
export type SetMaintenancePlanStatusMutationResult = Apollo.MutationResult<SetMaintenancePlanStatusMutation>;
export type SetMaintenancePlanStatusMutationOptions = Apollo.BaseMutationOptions<SetMaintenancePlanStatusMutation, SetMaintenancePlanStatusMutationVariables>;
export const ImportMaintenancePlanFromLibraryDocument = gql`
    mutation ImportMaintenancePlanFromLibrary($input: ImportBilderitMaintenancePlanInput!) {
  importBilderitMaintenancePlan(input: $input) {
    ... on MaintenancePlan {
      ...MaintenancePlanFields
    }
    ... on DuplicatedEntryError {
      message
      errorCode
    }
    ... on ConsumablesConflictError {
      message
      errorCode
    }
    ... on BilderitPlanAlreadyCopiedError {
      message
      errorCode
    }
  }
}
    ${MaintenancePlanFieldsFragmentDoc}`;

/**
 * __useImportMaintenancePlanFromLibraryMutation__
 *
 * To run a mutation, you first call `useImportMaintenancePlanFromLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMaintenancePlanFromLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMaintenancePlanFromLibraryMutation, { data, loading, error }] = useImportMaintenancePlanFromLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMaintenancePlanFromLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportMaintenancePlanFromLibraryMutation, ImportMaintenancePlanFromLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImportMaintenancePlanFromLibraryMutation, ImportMaintenancePlanFromLibraryMutationVariables>(ImportMaintenancePlanFromLibraryDocument, options);
      }
export type ImportMaintenancePlanFromLibraryMutationHookResult = ReturnType<typeof useImportMaintenancePlanFromLibraryMutation>;
export type ImportMaintenancePlanFromLibraryMutationResult = Apollo.MutationResult<ImportMaintenancePlanFromLibraryMutation>;
export type ImportMaintenancePlanFromLibraryMutationOptions = Apollo.BaseMutationOptions<ImportMaintenancePlanFromLibraryMutation, ImportMaintenancePlanFromLibraryMutationVariables>;
export const GetMyDailyReportsDocument = gql`
    query GetMyDailyReports($filter: FilterMyDailyReports, $pagination: FilterPagination) {
  getMyDailyReports(filter: $filter, pagination: $pagination) {
    ... on AuthCheckGetMyDailyReports {
      items {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useGetMyDailyReportsQuery__
 *
 * To run a query within a React component, call `useGetMyDailyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDailyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDailyReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMyDailyReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyDailyReportsQuery, GetMyDailyReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyDailyReportsQuery, GetMyDailyReportsQueryVariables>(GetMyDailyReportsDocument, options);
      }
export function useGetMyDailyReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyDailyReportsQuery, GetMyDailyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyDailyReportsQuery, GetMyDailyReportsQueryVariables>(GetMyDailyReportsDocument, options);
        }
export function useGetMyDailyReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyDailyReportsQuery, GetMyDailyReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyDailyReportsQuery, GetMyDailyReportsQueryVariables>(GetMyDailyReportsDocument, options);
        }
export type GetMyDailyReportsQueryHookResult = ReturnType<typeof useGetMyDailyReportsQuery>;
export type GetMyDailyReportsLazyQueryHookResult = ReturnType<typeof useGetMyDailyReportsLazyQuery>;
export type GetMyDailyReportsSuspenseQueryHookResult = ReturnType<typeof useGetMyDailyReportsSuspenseQuery>;
export type GetMyDailyReportsQueryResult = Apollo.QueryResult<GetMyDailyReportsQuery, GetMyDailyReportsQueryVariables>;
export const GetMyWorkOrdersDocument = gql`
    query GetMyWorkOrders($filter: FilterWorkOrders) {
  getMyAssignedWorkOrders(filter: $filter) {
    items {
      ...WorkOrdersTableFields
    }
  }
}
    ${WorkOrdersTableFieldsFragmentDoc}`;

/**
 * __useGetMyWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetMyWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyWorkOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMyWorkOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyWorkOrdersQuery, GetMyWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyWorkOrdersQuery, GetMyWorkOrdersQueryVariables>(GetMyWorkOrdersDocument, options);
      }
export function useGetMyWorkOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyWorkOrdersQuery, GetMyWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyWorkOrdersQuery, GetMyWorkOrdersQueryVariables>(GetMyWorkOrdersDocument, options);
        }
export function useGetMyWorkOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyWorkOrdersQuery, GetMyWorkOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyWorkOrdersQuery, GetMyWorkOrdersQueryVariables>(GetMyWorkOrdersDocument, options);
        }
export type GetMyWorkOrdersQueryHookResult = ReturnType<typeof useGetMyWorkOrdersQuery>;
export type GetMyWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetMyWorkOrdersLazyQuery>;
export type GetMyWorkOrdersSuspenseQueryHookResult = ReturnType<typeof useGetMyWorkOrdersSuspenseQuery>;
export type GetMyWorkOrdersQueryResult = Apollo.QueryResult<GetMyWorkOrdersQuery, GetMyWorkOrdersQueryVariables>;
export const GetMyRecentActivityDocument = gql`
    query GetMyRecentActivity {
  getMyRecentActivity {
    ... on RecentActivity {
      ...RecentActivityFields
    }
  }
}
    ${RecentActivityFieldsFragmentDoc}`;

/**
 * __useGetMyRecentActivityQuery__
 *
 * To run a query within a React component, call `useGetMyRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRecentActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyRecentActivityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyRecentActivityQuery, GetMyRecentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyRecentActivityQuery, GetMyRecentActivityQueryVariables>(GetMyRecentActivityDocument, options);
      }
export function useGetMyRecentActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyRecentActivityQuery, GetMyRecentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyRecentActivityQuery, GetMyRecentActivityQueryVariables>(GetMyRecentActivityDocument, options);
        }
export function useGetMyRecentActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyRecentActivityQuery, GetMyRecentActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyRecentActivityQuery, GetMyRecentActivityQueryVariables>(GetMyRecentActivityDocument, options);
        }
export type GetMyRecentActivityQueryHookResult = ReturnType<typeof useGetMyRecentActivityQuery>;
export type GetMyRecentActivityLazyQueryHookResult = ReturnType<typeof useGetMyRecentActivityLazyQuery>;
export type GetMyRecentActivitySuspenseQueryHookResult = ReturnType<typeof useGetMyRecentActivitySuspenseQuery>;
export type GetMyRecentActivityQueryResult = Apollo.QueryResult<GetMyRecentActivityQuery, GetMyRecentActivityQueryVariables>;
export const GetMyDocumentsDocument = gql`
    query GetMyDocuments {
  getMyDocuments {
    items {
      ...MyDocumentFields
    }
  }
}
    ${MyDocumentFieldsFragmentDoc}`;

/**
 * __useGetMyDocumentsQuery__
 *
 * To run a query within a React component, call `useGetMyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDocumentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>(GetMyDocumentsDocument, options);
      }
export function useGetMyDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>(GetMyDocumentsDocument, options);
        }
export function useGetMyDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>(GetMyDocumentsDocument, options);
        }
export type GetMyDocumentsQueryHookResult = ReturnType<typeof useGetMyDocumentsQuery>;
export type GetMyDocumentsLazyQueryHookResult = ReturnType<typeof useGetMyDocumentsLazyQuery>;
export type GetMyDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetMyDocumentsSuspenseQuery>;
export type GetMyDocumentsQueryResult = Apollo.QueryResult<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>;
export const GetMcpClientDocument = gql`
    query GetMcpClient($clientId: String!) {
  mcpClient(clientId: $clientId) {
    clientId
    name
    redirectHost
    isLocal
  }
}
    `;

/**
 * __useGetMcpClientQuery__
 *
 * To run a query within a React component, call `useGetMcpClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetMcpClientQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMcpClientQuery, GetMcpClientQueryVariables> & ({ variables: GetMcpClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMcpClientQuery, GetMcpClientQueryVariables>(GetMcpClientDocument, options);
      }
export function useGetMcpClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMcpClientQuery, GetMcpClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMcpClientQuery, GetMcpClientQueryVariables>(GetMcpClientDocument, options);
        }
export function useGetMcpClientSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMcpClientQuery, GetMcpClientQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMcpClientQuery, GetMcpClientQueryVariables>(GetMcpClientDocument, options);
        }
export type GetMcpClientQueryHookResult = ReturnType<typeof useGetMcpClientQuery>;
export type GetMcpClientLazyQueryHookResult = ReturnType<typeof useGetMcpClientLazyQuery>;
export type GetMcpClientSuspenseQueryHookResult = ReturnType<typeof useGetMcpClientSuspenseQuery>;
export type GetMcpClientQueryResult = Apollo.QueryResult<GetMcpClientQuery, GetMcpClientQueryVariables>;
export const RespondToMcpAuthorizationDocument = gql`
    mutation RespondToMcpAuthorization($input: RespondToMcpAuthorizationInput!) {
  respondToMcpAuthorization(input: $input) {
    redirectUrl
  }
}
    `;

/**
 * __useRespondToMcpAuthorizationMutation__
 *
 * To run a mutation, you first call `useRespondToMcpAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToMcpAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToMcpAuthorizationMutation, { data, loading, error }] = useRespondToMcpAuthorizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToMcpAuthorizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RespondToMcpAuthorizationMutation, RespondToMcpAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToMcpAuthorizationMutation, RespondToMcpAuthorizationMutationVariables>(RespondToMcpAuthorizationDocument, options);
      }
export type RespondToMcpAuthorizationMutationHookResult = ReturnType<typeof useRespondToMcpAuthorizationMutation>;
export type RespondToMcpAuthorizationMutationResult = Apollo.MutationResult<RespondToMcpAuthorizationMutation>;
export type RespondToMcpAuthorizationMutationOptions = Apollo.BaseMutationOptions<RespondToMcpAuthorizationMutation, RespondToMcpAuthorizationMutationVariables>;
export const GetProjectCostCentersDocument = gql`
    query GetProjectCostCenters($projectId: Int!, $include_archived: Boolean) {
  getProjectCostCenters(
    projectId: $projectId
    include_archived: $include_archived
  ) {
    id
    project_id
    name
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetProjectCostCentersQuery__
 *
 * To run a query within a React component, call `useGetProjectCostCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCostCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCostCentersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      include_archived: // value for 'include_archived'
 *   },
 * });
 */
export function useGetProjectCostCentersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectCostCentersQuery, GetProjectCostCentersQueryVariables> & ({ variables: GetProjectCostCentersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectCostCentersQuery, GetProjectCostCentersQueryVariables>(GetProjectCostCentersDocument, options);
      }
export function useGetProjectCostCentersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectCostCentersQuery, GetProjectCostCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectCostCentersQuery, GetProjectCostCentersQueryVariables>(GetProjectCostCentersDocument, options);
        }
export function useGetProjectCostCentersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectCostCentersQuery, GetProjectCostCentersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectCostCentersQuery, GetProjectCostCentersQueryVariables>(GetProjectCostCentersDocument, options);
        }
export type GetProjectCostCentersQueryHookResult = ReturnType<typeof useGetProjectCostCentersQuery>;
export type GetProjectCostCentersLazyQueryHookResult = ReturnType<typeof useGetProjectCostCentersLazyQuery>;
export type GetProjectCostCentersSuspenseQueryHookResult = ReturnType<typeof useGetProjectCostCentersSuspenseQuery>;
export type GetProjectCostCentersQueryResult = Apollo.QueryResult<GetProjectCostCentersQuery, GetProjectCostCentersQueryVariables>;
export const GetProjectCostCenterModeDocument = gql`
    query GetProjectCostCenterMode($projectId: Int!) {
  getProjectCostCenterMode(projectId: $projectId)
}
    `;

/**
 * __useGetProjectCostCenterModeQuery__
 *
 * To run a query within a React component, call `useGetProjectCostCenterModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCostCenterModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCostCenterModeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectCostCenterModeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectCostCenterModeQuery, GetProjectCostCenterModeQueryVariables> & ({ variables: GetProjectCostCenterModeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectCostCenterModeQuery, GetProjectCostCenterModeQueryVariables>(GetProjectCostCenterModeDocument, options);
      }
export function useGetProjectCostCenterModeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectCostCenterModeQuery, GetProjectCostCenterModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectCostCenterModeQuery, GetProjectCostCenterModeQueryVariables>(GetProjectCostCenterModeDocument, options);
        }
export function useGetProjectCostCenterModeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectCostCenterModeQuery, GetProjectCostCenterModeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectCostCenterModeQuery, GetProjectCostCenterModeQueryVariables>(GetProjectCostCenterModeDocument, options);
        }
export type GetProjectCostCenterModeQueryHookResult = ReturnType<typeof useGetProjectCostCenterModeQuery>;
export type GetProjectCostCenterModeLazyQueryHookResult = ReturnType<typeof useGetProjectCostCenterModeLazyQuery>;
export type GetProjectCostCenterModeSuspenseQueryHookResult = ReturnType<typeof useGetProjectCostCenterModeSuspenseQuery>;
export type GetProjectCostCenterModeQueryResult = Apollo.QueryResult<GetProjectCostCenterModeQuery, GetProjectCostCenterModeQueryVariables>;
export const AddProjectCostCenterDocument = gql`
    mutation AddProjectCostCenter($input: AddProjectCostCenterInput!) {
  addProjectCostCenter(input: $input) {
    id
    project_id
    name
    created_at
    updated_at
  }
}
    `;

/**
 * __useAddProjectCostCenterMutation__
 *
 * To run a mutation, you first call `useAddProjectCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectCostCenterMutation, { data, loading, error }] = useAddProjectCostCenterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectCostCenterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProjectCostCenterMutation, AddProjectCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProjectCostCenterMutation, AddProjectCostCenterMutationVariables>(AddProjectCostCenterDocument, options);
      }
export type AddProjectCostCenterMutationHookResult = ReturnType<typeof useAddProjectCostCenterMutation>;
export type AddProjectCostCenterMutationResult = Apollo.MutationResult<AddProjectCostCenterMutation>;
export type AddProjectCostCenterMutationOptions = Apollo.BaseMutationOptions<AddProjectCostCenterMutation, AddProjectCostCenterMutationVariables>;
export const UpdateProjectCostCenterDocument = gql`
    mutation UpdateProjectCostCenter($id: Int!, $input: UpdateProjectCostCenterInput!) {
  updateProjectCostCenter(id: $id, input: $input) {
    id
    project_id
    name
    created_at
    updated_at
  }
}
    `;

/**
 * __useUpdateProjectCostCenterMutation__
 *
 * To run a mutation, you first call `useUpdateProjectCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectCostCenterMutation, { data, loading, error }] = useUpdateProjectCostCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectCostCenterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectCostCenterMutation, UpdateProjectCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectCostCenterMutation, UpdateProjectCostCenterMutationVariables>(UpdateProjectCostCenterDocument, options);
      }
export type UpdateProjectCostCenterMutationHookResult = ReturnType<typeof useUpdateProjectCostCenterMutation>;
export type UpdateProjectCostCenterMutationResult = Apollo.MutationResult<UpdateProjectCostCenterMutation>;
export type UpdateProjectCostCenterMutationOptions = Apollo.BaseMutationOptions<UpdateProjectCostCenterMutation, UpdateProjectCostCenterMutationVariables>;
export const DeleteProjectCostCenterDocument = gql`
    mutation DeleteProjectCostCenter($id: Int!) {
  deleteProjectCostCenter(id: $id) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useDeleteProjectCostCenterMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCostCenterMutation, { data, loading, error }] = useDeleteProjectCostCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectCostCenterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectCostCenterMutation, DeleteProjectCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectCostCenterMutation, DeleteProjectCostCenterMutationVariables>(DeleteProjectCostCenterDocument, options);
      }
export type DeleteProjectCostCenterMutationHookResult = ReturnType<typeof useDeleteProjectCostCenterMutation>;
export type DeleteProjectCostCenterMutationResult = Apollo.MutationResult<DeleteProjectCostCenterMutation>;
export type DeleteProjectCostCenterMutationOptions = Apollo.BaseMutationOptions<DeleteProjectCostCenterMutation, DeleteProjectCostCenterMutationVariables>;
export const SetProjectCostCenterModeDocument = gql`
    mutation SetProjectCostCenterMode($projectId: Int!, $mode: CostCenterMode!) {
  setProjectCostCenterMode(projectId: $projectId, mode: $mode) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useSetProjectCostCenterModeMutation__
 *
 * To run a mutation, you first call `useSetProjectCostCenterModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectCostCenterModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectCostCenterModeMutation, { data, loading, error }] = useSetProjectCostCenterModeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useSetProjectCostCenterModeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetProjectCostCenterModeMutation, SetProjectCostCenterModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetProjectCostCenterModeMutation, SetProjectCostCenterModeMutationVariables>(SetProjectCostCenterModeDocument, options);
      }
export type SetProjectCostCenterModeMutationHookResult = ReturnType<typeof useSetProjectCostCenterModeMutation>;
export type SetProjectCostCenterModeMutationResult = Apollo.MutationResult<SetProjectCostCenterModeMutation>;
export type SetProjectCostCenterModeMutationOptions = Apollo.BaseMutationOptions<SetProjectCostCenterModeMutation, SetProjectCostCenterModeMutationVariables>;
export const ArchiveProjectDocument = gql`
    mutation ArchiveProject($projectId: Int!) {
  archiveProject(projectId: $projectId) {
    ...ProjectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectMutation, { data, loading, error }] = useArchiveProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useArchiveProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument, options);
      }
export type ArchiveProjectMutationHookResult = ReturnType<typeof useArchiveProjectMutation>;
export type ArchiveProjectMutationResult = Apollo.MutationResult<ArchiveProjectMutation>;
export type ArchiveProjectMutationOptions = Apollo.BaseMutationOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>;
export const UnarchiveProjectDocument = gql`
    mutation UnarchiveProject($projectId: Int!) {
  unarchiveProject(projectId: $projectId) {
    ...ProjectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useUnarchiveProjectMutation__
 *
 * To run a mutation, you first call `useUnarchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProjectMutation, { data, loading, error }] = useUnarchiveProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUnarchiveProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>(UnarchiveProjectDocument, options);
      }
export type UnarchiveProjectMutationHookResult = ReturnType<typeof useUnarchiveProjectMutation>;
export type UnarchiveProjectMutationResult = Apollo.MutationResult<UnarchiveProjectMutation>;
export type UnarchiveProjectMutationOptions = Apollo.BaseMutationOptions<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>;
export const AddProjectDocument = gql`
    mutation AddProject($input: AddProjectInput!) {
  addProject(input: $input) {
    ... on AuthCheckAddProject {
      item {
        ...ProjectFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useAddProjectMutation__
 *
 * To run a mutation, you first call `useAddProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMutation, { data, loading, error }] = useAddProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProjectMutation, AddProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProjectMutation, AddProjectMutationVariables>(AddProjectDocument, options);
      }
export type AddProjectMutationHookResult = ReturnType<typeof useAddProjectMutation>;
export type AddProjectMutationResult = Apollo.MutationResult<AddProjectMutation>;
export type AddProjectMutationOptions = Apollo.BaseMutationOptions<AddProjectMutation, AddProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: Int!, $input: UpdateProjectInput!) {
  updateProject(id: $id, input: $input) {
    ... on AuthCheckUpdateProject {
      item {
        ...ProjectFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const GetActiveProjectsByCompanyIdDocument = gql`
    query GetActiveProjectsByCompanyId($company_id: Int!) {
  getCompany(id: $company_id) {
    ... on AuthCheckGetCompany {
      item {
        id
        projects {
          ...ProjectFields
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useGetActiveProjectsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetActiveProjectsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveProjectsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveProjectsByCompanyIdQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetActiveProjectsByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActiveProjectsByCompanyIdQuery, GetActiveProjectsByCompanyIdQueryVariables> & ({ variables: GetActiveProjectsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActiveProjectsByCompanyIdQuery, GetActiveProjectsByCompanyIdQueryVariables>(GetActiveProjectsByCompanyIdDocument, options);
      }
export function useGetActiveProjectsByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveProjectsByCompanyIdQuery, GetActiveProjectsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActiveProjectsByCompanyIdQuery, GetActiveProjectsByCompanyIdQueryVariables>(GetActiveProjectsByCompanyIdDocument, options);
        }
export function useGetActiveProjectsByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActiveProjectsByCompanyIdQuery, GetActiveProjectsByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActiveProjectsByCompanyIdQuery, GetActiveProjectsByCompanyIdQueryVariables>(GetActiveProjectsByCompanyIdDocument, options);
        }
export type GetActiveProjectsByCompanyIdQueryHookResult = ReturnType<typeof useGetActiveProjectsByCompanyIdQuery>;
export type GetActiveProjectsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetActiveProjectsByCompanyIdLazyQuery>;
export type GetActiveProjectsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetActiveProjectsByCompanyIdSuspenseQuery>;
export type GetActiveProjectsByCompanyIdQueryResult = Apollo.QueryResult<GetActiveProjectsByCompanyIdQuery, GetActiveProjectsByCompanyIdQueryVariables>;
export const GetArchivedProjectsByCompanyIdDocument = gql`
    query GetArchivedProjectsByCompanyId($company_id: Int!) {
  getCompany(id: $company_id) {
    ... on AuthCheckGetCompany {
      item {
        id
        archived_projects {
          ...ProjectFields
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useGetArchivedProjectsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetArchivedProjectsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedProjectsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedProjectsByCompanyIdQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useGetArchivedProjectsByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetArchivedProjectsByCompanyIdQuery, GetArchivedProjectsByCompanyIdQueryVariables> & ({ variables: GetArchivedProjectsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetArchivedProjectsByCompanyIdQuery, GetArchivedProjectsByCompanyIdQueryVariables>(GetArchivedProjectsByCompanyIdDocument, options);
      }
export function useGetArchivedProjectsByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetArchivedProjectsByCompanyIdQuery, GetArchivedProjectsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetArchivedProjectsByCompanyIdQuery, GetArchivedProjectsByCompanyIdQueryVariables>(GetArchivedProjectsByCompanyIdDocument, options);
        }
export function useGetArchivedProjectsByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetArchivedProjectsByCompanyIdQuery, GetArchivedProjectsByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetArchivedProjectsByCompanyIdQuery, GetArchivedProjectsByCompanyIdQueryVariables>(GetArchivedProjectsByCompanyIdDocument, options);
        }
export type GetArchivedProjectsByCompanyIdQueryHookResult = ReturnType<typeof useGetArchivedProjectsByCompanyIdQuery>;
export type GetArchivedProjectsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetArchivedProjectsByCompanyIdLazyQuery>;
export type GetArchivedProjectsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetArchivedProjectsByCompanyIdSuspenseQuery>;
export type GetArchivedProjectsByCompanyIdQueryResult = Apollo.QueryResult<GetArchivedProjectsByCompanyIdQuery, GetArchivedProjectsByCompanyIdQueryVariables>;
export const GetRentalByProjectDocument = gql`
    query GetRentalByProject($project_id: Int!, $period: FilterDateRange!, $filter: RentalFilters!) {
  getRentalByProject(project_id: $project_id, period: $period, filter: $filter) {
    project {
      id
      name
    }
    machines_rental {
      ...MachineRentalRowFields
    }
  }
}
    ${MachineRentalRowFieldsFragmentDoc}`;

/**
 * __useGetRentalByProjectQuery__
 *
 * To run a query within a React component, call `useGetRentalByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalByProjectQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      period: // value for 'period'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRentalByProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRentalByProjectQuery, GetRentalByProjectQueryVariables> & ({ variables: GetRentalByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRentalByProjectQuery, GetRentalByProjectQueryVariables>(GetRentalByProjectDocument, options);
      }
export function useGetRentalByProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRentalByProjectQuery, GetRentalByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRentalByProjectQuery, GetRentalByProjectQueryVariables>(GetRentalByProjectDocument, options);
        }
export function useGetRentalByProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRentalByProjectQuery, GetRentalByProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRentalByProjectQuery, GetRentalByProjectQueryVariables>(GetRentalByProjectDocument, options);
        }
export type GetRentalByProjectQueryHookResult = ReturnType<typeof useGetRentalByProjectQuery>;
export type GetRentalByProjectLazyQueryHookResult = ReturnType<typeof useGetRentalByProjectLazyQuery>;
export type GetRentalByProjectSuspenseQueryHookResult = ReturnType<typeof useGetRentalByProjectSuspenseQuery>;
export type GetRentalByProjectQueryResult = Apollo.QueryResult<GetRentalByProjectQuery, GetRentalByProjectQueryVariables>;
export const GetOrCreateDraftCertificationDocument = gql`
    mutation GetOrCreateDraftCertification($project_id: Int!, $month: Date!, $ownership_group: RentalOwnershipGroup!, $vendor_filter: String) {
  getOrCreateDraftCertification(
    project_id: $project_id
    month: $month
    ownership_group: $ownership_group
    vendor_filter: $vendor_filter
  ) {
    ...RentalCertificationFields
  }
}
    ${RentalCertificationFieldsFragmentDoc}`;

/**
 * __useGetOrCreateDraftCertificationMutation__
 *
 * To run a mutation, you first call `useGetOrCreateDraftCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateDraftCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateDraftCertificationMutation, { data, loading, error }] = useGetOrCreateDraftCertificationMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      month: // value for 'month'
 *      ownership_group: // value for 'ownership_group'
 *      vendor_filter: // value for 'vendor_filter'
 *   },
 * });
 */
export function useGetOrCreateDraftCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetOrCreateDraftCertificationMutation, GetOrCreateDraftCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetOrCreateDraftCertificationMutation, GetOrCreateDraftCertificationMutationVariables>(GetOrCreateDraftCertificationDocument, options);
      }
export type GetOrCreateDraftCertificationMutationHookResult = ReturnType<typeof useGetOrCreateDraftCertificationMutation>;
export type GetOrCreateDraftCertificationMutationResult = Apollo.MutationResult<GetOrCreateDraftCertificationMutation>;
export type GetOrCreateDraftCertificationMutationOptions = Apollo.BaseMutationOptions<GetOrCreateDraftCertificationMutation, GetOrCreateDraftCertificationMutationVariables>;
export const GetRentalCertificationProviderOptionsDocument = gql`
    query GetRentalCertificationProviderOptions($project_id: Int!, $month: Date!) {
  getRentalCertificationProviderOptions(project_id: $project_id, month: $month) {
    all_option {
      vendor_filter
      label
      machine_count
      is_disabled
      existing_status
    }
    providers {
      vendor_filter
      label
      machine_count
      is_disabled
      existing_status
    }
  }
}
    `;

/**
 * __useGetRentalCertificationProviderOptionsQuery__
 *
 * To run a query within a React component, call `useGetRentalCertificationProviderOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalCertificationProviderOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalCertificationProviderOptionsQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetRentalCertificationProviderOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRentalCertificationProviderOptionsQuery, GetRentalCertificationProviderOptionsQueryVariables> & ({ variables: GetRentalCertificationProviderOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRentalCertificationProviderOptionsQuery, GetRentalCertificationProviderOptionsQueryVariables>(GetRentalCertificationProviderOptionsDocument, options);
      }
export function useGetRentalCertificationProviderOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRentalCertificationProviderOptionsQuery, GetRentalCertificationProviderOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRentalCertificationProviderOptionsQuery, GetRentalCertificationProviderOptionsQueryVariables>(GetRentalCertificationProviderOptionsDocument, options);
        }
export function useGetRentalCertificationProviderOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRentalCertificationProviderOptionsQuery, GetRentalCertificationProviderOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRentalCertificationProviderOptionsQuery, GetRentalCertificationProviderOptionsQueryVariables>(GetRentalCertificationProviderOptionsDocument, options);
        }
export type GetRentalCertificationProviderOptionsQueryHookResult = ReturnType<typeof useGetRentalCertificationProviderOptionsQuery>;
export type GetRentalCertificationProviderOptionsLazyQueryHookResult = ReturnType<typeof useGetRentalCertificationProviderOptionsLazyQuery>;
export type GetRentalCertificationProviderOptionsSuspenseQueryHookResult = ReturnType<typeof useGetRentalCertificationProviderOptionsSuspenseQuery>;
export type GetRentalCertificationProviderOptionsQueryResult = Apollo.QueryResult<GetRentalCertificationProviderOptionsQuery, GetRentalCertificationProviderOptionsQueryVariables>;
export const MarkMachinesForCertificationDocument = gql`
    mutation MarkMachinesForCertification($certification_id: Int!, $machine_ids: [Int!]!) {
  markMachinesForCertification(
    certification_id: $certification_id
    machine_ids: $machine_ids
  ) {
    marked_count
    results {
      machine_id
      success
      error {
        code
        message
        metadata
      }
    }
  }
}
    `;

/**
 * __useMarkMachinesForCertificationMutation__
 *
 * To run a mutation, you first call `useMarkMachinesForCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMachinesForCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMachinesForCertificationMutation, { data, loading, error }] = useMarkMachinesForCertificationMutation({
 *   variables: {
 *      certification_id: // value for 'certification_id'
 *      machine_ids: // value for 'machine_ids'
 *   },
 * });
 */
export function useMarkMachinesForCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkMachinesForCertificationMutation, MarkMachinesForCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkMachinesForCertificationMutation, MarkMachinesForCertificationMutationVariables>(MarkMachinesForCertificationDocument, options);
      }
export type MarkMachinesForCertificationMutationHookResult = ReturnType<typeof useMarkMachinesForCertificationMutation>;
export type MarkMachinesForCertificationMutationResult = Apollo.MutationResult<MarkMachinesForCertificationMutation>;
export type MarkMachinesForCertificationMutationOptions = Apollo.BaseMutationOptions<MarkMachinesForCertificationMutation, MarkMachinesForCertificationMutationVariables>;
export const UnmarkMachinesForCertificationDocument = gql`
    mutation UnmarkMachinesForCertification($certification_id: Int!, $machine_ids: [Int!]!) {
  unmarkMachinesForCertification(
    certification_id: $certification_id
    machine_ids: $machine_ids
  ) {
    success
    unmarked_count
  }
}
    `;

/**
 * __useUnmarkMachinesForCertificationMutation__
 *
 * To run a mutation, you first call `useUnmarkMachinesForCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmarkMachinesForCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmarkMachinesForCertificationMutation, { data, loading, error }] = useUnmarkMachinesForCertificationMutation({
 *   variables: {
 *      certification_id: // value for 'certification_id'
 *      machine_ids: // value for 'machine_ids'
 *   },
 * });
 */
export function useUnmarkMachinesForCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnmarkMachinesForCertificationMutation, UnmarkMachinesForCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnmarkMachinesForCertificationMutation, UnmarkMachinesForCertificationMutationVariables>(UnmarkMachinesForCertificationDocument, options);
      }
export type UnmarkMachinesForCertificationMutationHookResult = ReturnType<typeof useUnmarkMachinesForCertificationMutation>;
export type UnmarkMachinesForCertificationMutationResult = Apollo.MutationResult<UnmarkMachinesForCertificationMutation>;
export type UnmarkMachinesForCertificationMutationOptions = Apollo.BaseMutationOptions<UnmarkMachinesForCertificationMutation, UnmarkMachinesForCertificationMutationVariables>;
export const DeleteDraftCertificationDocument = gql`
    mutation DeleteDraftCertification($certification_id: Int!) {
  deleteDraftCertification(certification_id: $certification_id) {
    result
  }
}
    `;

/**
 * __useDeleteDraftCertificationMutation__
 *
 * To run a mutation, you first call `useDeleteDraftCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftCertificationMutation, { data, loading, error }] = useDeleteDraftCertificationMutation({
 *   variables: {
 *      certification_id: // value for 'certification_id'
 *   },
 * });
 */
export function useDeleteDraftCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDraftCertificationMutation, DeleteDraftCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDraftCertificationMutation, DeleteDraftCertificationMutationVariables>(DeleteDraftCertificationDocument, options);
      }
export type DeleteDraftCertificationMutationHookResult = ReturnType<typeof useDeleteDraftCertificationMutation>;
export type DeleteDraftCertificationMutationResult = Apollo.MutationResult<DeleteDraftCertificationMutation>;
export type DeleteDraftCertificationMutationOptions = Apollo.BaseMutationOptions<DeleteDraftCertificationMutation, DeleteDraftCertificationMutationVariables>;
export const SubmitCertificationForReviewDocument = gql`
    mutation SubmitCertificationForReview($input: SubmitCertificationForReviewInput!) {
  submitCertificationForReview(input: $input) {
    certification {
      ...RentalCertificationFields
    }
    reviewers {
      id
      first_name
      last_name
    }
    warnings {
      uncertified_machine_ids
      uncertified_machines {
        id
        name
      }
    }
  }
}
    ${RentalCertificationFieldsFragmentDoc}`;

/**
 * __useSubmitCertificationForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitCertificationForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCertificationForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCertificationForReviewMutation, { data, loading, error }] = useSubmitCertificationForReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCertificationForReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitCertificationForReviewMutation, SubmitCertificationForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitCertificationForReviewMutation, SubmitCertificationForReviewMutationVariables>(SubmitCertificationForReviewDocument, options);
      }
export type SubmitCertificationForReviewMutationHookResult = ReturnType<typeof useSubmitCertificationForReviewMutation>;
export type SubmitCertificationForReviewMutationResult = Apollo.MutationResult<SubmitCertificationForReviewMutation>;
export type SubmitCertificationForReviewMutationOptions = Apollo.BaseMutationOptions<SubmitCertificationForReviewMutation, SubmitCertificationForReviewMutationVariables>;
export const ReviewCertificationDocument = gql`
    mutation ReviewCertification($input: ReviewCertificationInput!) {
  reviewCertification(input: $input) {
    certification {
      ...RentalCertificationFields
    }
    all_approved
  }
}
    ${RentalCertificationFieldsFragmentDoc}`;

/**
 * __useReviewCertificationMutation__
 *
 * To run a mutation, you first call `useReviewCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewCertificationMutation, { data, loading, error }] = useReviewCertificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReviewCertificationMutation, ReviewCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReviewCertificationMutation, ReviewCertificationMutationVariables>(ReviewCertificationDocument, options);
      }
export type ReviewCertificationMutationHookResult = ReturnType<typeof useReviewCertificationMutation>;
export type ReviewCertificationMutationResult = Apollo.MutationResult<ReviewCertificationMutation>;
export type ReviewCertificationMutationOptions = Apollo.BaseMutationOptions<ReviewCertificationMutation, ReviewCertificationMutationVariables>;
export const GetCertificationCopyRecipientsDocument = gql`
    query GetCertificationCopyRecipients($context: Context!) {
  getCertificationCopyRecipients(context: $context) {
    ...CertificationCopyRecipientFields
  }
}
    ${CertificationCopyRecipientFieldsFragmentDoc}`;

/**
 * __useGetCertificationCopyRecipientsQuery__
 *
 * To run a query within a React component, call `useGetCertificationCopyRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificationCopyRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificationCopyRecipientsQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetCertificationCopyRecipientsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCertificationCopyRecipientsQuery, GetCertificationCopyRecipientsQueryVariables> & ({ variables: GetCertificationCopyRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCertificationCopyRecipientsQuery, GetCertificationCopyRecipientsQueryVariables>(GetCertificationCopyRecipientsDocument, options);
      }
export function useGetCertificationCopyRecipientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCertificationCopyRecipientsQuery, GetCertificationCopyRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCertificationCopyRecipientsQuery, GetCertificationCopyRecipientsQueryVariables>(GetCertificationCopyRecipientsDocument, options);
        }
export function useGetCertificationCopyRecipientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCertificationCopyRecipientsQuery, GetCertificationCopyRecipientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCertificationCopyRecipientsQuery, GetCertificationCopyRecipientsQueryVariables>(GetCertificationCopyRecipientsDocument, options);
        }
export type GetCertificationCopyRecipientsQueryHookResult = ReturnType<typeof useGetCertificationCopyRecipientsQuery>;
export type GetCertificationCopyRecipientsLazyQueryHookResult = ReturnType<typeof useGetCertificationCopyRecipientsLazyQuery>;
export type GetCertificationCopyRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetCertificationCopyRecipientsSuspenseQuery>;
export type GetCertificationCopyRecipientsQueryResult = Apollo.QueryResult<GetCertificationCopyRecipientsQuery, GetCertificationCopyRecipientsQueryVariables>;
export const GetCertificationNotificationRecipientsDocument = gql`
    query GetCertificationNotificationRecipients($certification_id: Int!) {
  getCertificationNotificationRecipients(certification_id: $certification_id) {
    audiences {
      event
      recipients {
        email
        display_name
        sources
      }
    }
  }
}
    `;

/**
 * __useGetCertificationNotificationRecipientsQuery__
 *
 * To run a query within a React component, call `useGetCertificationNotificationRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificationNotificationRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificationNotificationRecipientsQuery({
 *   variables: {
 *      certification_id: // value for 'certification_id'
 *   },
 * });
 */
export function useGetCertificationNotificationRecipientsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCertificationNotificationRecipientsQuery, GetCertificationNotificationRecipientsQueryVariables> & ({ variables: GetCertificationNotificationRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCertificationNotificationRecipientsQuery, GetCertificationNotificationRecipientsQueryVariables>(GetCertificationNotificationRecipientsDocument, options);
      }
export function useGetCertificationNotificationRecipientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCertificationNotificationRecipientsQuery, GetCertificationNotificationRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCertificationNotificationRecipientsQuery, GetCertificationNotificationRecipientsQueryVariables>(GetCertificationNotificationRecipientsDocument, options);
        }
export function useGetCertificationNotificationRecipientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCertificationNotificationRecipientsQuery, GetCertificationNotificationRecipientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCertificationNotificationRecipientsQuery, GetCertificationNotificationRecipientsQueryVariables>(GetCertificationNotificationRecipientsDocument, options);
        }
export type GetCertificationNotificationRecipientsQueryHookResult = ReturnType<typeof useGetCertificationNotificationRecipientsQuery>;
export type GetCertificationNotificationRecipientsLazyQueryHookResult = ReturnType<typeof useGetCertificationNotificationRecipientsLazyQuery>;
export type GetCertificationNotificationRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetCertificationNotificationRecipientsSuspenseQuery>;
export type GetCertificationNotificationRecipientsQueryResult = Apollo.QueryResult<GetCertificationNotificationRecipientsQuery, GetCertificationNotificationRecipientsQueryVariables>;
export const AddCertificationCopyRecipientDocument = gql`
    mutation AddCertificationCopyRecipient($input: AddCertificationCopyRecipientInput!) {
  addCertificationCopyRecipient(input: $input) {
    ...CertificationCopyRecipientFields
  }
}
    ${CertificationCopyRecipientFieldsFragmentDoc}`;

/**
 * __useAddCertificationCopyRecipientMutation__
 *
 * To run a mutation, you first call `useAddCertificationCopyRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCertificationCopyRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCertificationCopyRecipientMutation, { data, loading, error }] = useAddCertificationCopyRecipientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCertificationCopyRecipientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddCertificationCopyRecipientMutation, AddCertificationCopyRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddCertificationCopyRecipientMutation, AddCertificationCopyRecipientMutationVariables>(AddCertificationCopyRecipientDocument, options);
      }
export type AddCertificationCopyRecipientMutationHookResult = ReturnType<typeof useAddCertificationCopyRecipientMutation>;
export type AddCertificationCopyRecipientMutationResult = Apollo.MutationResult<AddCertificationCopyRecipientMutation>;
export type AddCertificationCopyRecipientMutationOptions = Apollo.BaseMutationOptions<AddCertificationCopyRecipientMutation, AddCertificationCopyRecipientMutationVariables>;
export const RemoveCertificationCopyRecipientDocument = gql`
    mutation RemoveCertificationCopyRecipient($certification_copy_id: Int!) {
  removeCertificationCopyRecipient(certification_copy_id: $certification_copy_id) {
    result
  }
}
    `;

/**
 * __useRemoveCertificationCopyRecipientMutation__
 *
 * To run a mutation, you first call `useRemoveCertificationCopyRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCertificationCopyRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCertificationCopyRecipientMutation, { data, loading, error }] = useRemoveCertificationCopyRecipientMutation({
 *   variables: {
 *      certification_copy_id: // value for 'certification_copy_id'
 *   },
 * });
 */
export function useRemoveCertificationCopyRecipientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCertificationCopyRecipientMutation, RemoveCertificationCopyRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveCertificationCopyRecipientMutation, RemoveCertificationCopyRecipientMutationVariables>(RemoveCertificationCopyRecipientDocument, options);
      }
export type RemoveCertificationCopyRecipientMutationHookResult = ReturnType<typeof useRemoveCertificationCopyRecipientMutation>;
export type RemoveCertificationCopyRecipientMutationResult = Apollo.MutationResult<RemoveCertificationCopyRecipientMutation>;
export type RemoveCertificationCopyRecipientMutationOptions = Apollo.BaseMutationOptions<RemoveCertificationCopyRecipientMutation, RemoveCertificationCopyRecipientMutationVariables>;
export const GetCertificationHistoryDocument = gql`
    query GetCertificationHistory($context: Context!, $filter: CertificationHistoryFilter, $pagination: FilterPagination) {
  getCertificationHistory(
    context: $context
    filter: $filter
    pagination: $pagination
  ) {
    items {
      ...RentalCertificationHistoryFields
    }
    page_info {
      current_page
      items_per_page
      total_pages
      total_items
    }
  }
}
    ${RentalCertificationHistoryFieldsFragmentDoc}`;

/**
 * __useGetCertificationHistoryQuery__
 *
 * To run a query within a React component, call `useGetCertificationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificationHistoryQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCertificationHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCertificationHistoryQuery, GetCertificationHistoryQueryVariables> & ({ variables: GetCertificationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCertificationHistoryQuery, GetCertificationHistoryQueryVariables>(GetCertificationHistoryDocument, options);
      }
export function useGetCertificationHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCertificationHistoryQuery, GetCertificationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCertificationHistoryQuery, GetCertificationHistoryQueryVariables>(GetCertificationHistoryDocument, options);
        }
export function useGetCertificationHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCertificationHistoryQuery, GetCertificationHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCertificationHistoryQuery, GetCertificationHistoryQueryVariables>(GetCertificationHistoryDocument, options);
        }
export type GetCertificationHistoryQueryHookResult = ReturnType<typeof useGetCertificationHistoryQuery>;
export type GetCertificationHistoryLazyQueryHookResult = ReturnType<typeof useGetCertificationHistoryLazyQuery>;
export type GetCertificationHistorySuspenseQueryHookResult = ReturnType<typeof useGetCertificationHistorySuspenseQuery>;
export type GetCertificationHistoryQueryResult = Apollo.QueryResult<GetCertificationHistoryQuery, GetCertificationHistoryQueryVariables>;
export const ExportCertificationHistoryWorkbookDocument = gql`
    query ExportCertificationHistoryWorkbook($context: Context!, $filter: CertificationHistoryFilter) {
  exportCertificationHistoryWorkbook(context: $context, filter: $filter) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useExportCertificationHistoryWorkbookQuery__
 *
 * To run a query within a React component, call `useExportCertificationHistoryWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCertificationHistoryWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCertificationHistoryWorkbookQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportCertificationHistoryWorkbookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExportCertificationHistoryWorkbookQuery, ExportCertificationHistoryWorkbookQueryVariables> & ({ variables: ExportCertificationHistoryWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportCertificationHistoryWorkbookQuery, ExportCertificationHistoryWorkbookQueryVariables>(ExportCertificationHistoryWorkbookDocument, options);
      }
export function useExportCertificationHistoryWorkbookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportCertificationHistoryWorkbookQuery, ExportCertificationHistoryWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportCertificationHistoryWorkbookQuery, ExportCertificationHistoryWorkbookQueryVariables>(ExportCertificationHistoryWorkbookDocument, options);
        }
export function useExportCertificationHistoryWorkbookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExportCertificationHistoryWorkbookQuery, ExportCertificationHistoryWorkbookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExportCertificationHistoryWorkbookQuery, ExportCertificationHistoryWorkbookQueryVariables>(ExportCertificationHistoryWorkbookDocument, options);
        }
export type ExportCertificationHistoryWorkbookQueryHookResult = ReturnType<typeof useExportCertificationHistoryWorkbookQuery>;
export type ExportCertificationHistoryWorkbookLazyQueryHookResult = ReturnType<typeof useExportCertificationHistoryWorkbookLazyQuery>;
export type ExportCertificationHistoryWorkbookSuspenseQueryHookResult = ReturnType<typeof useExportCertificationHistoryWorkbookSuspenseQuery>;
export type ExportCertificationHistoryWorkbookQueryResult = Apollo.QueryResult<ExportCertificationHistoryWorkbookQuery, ExportCertificationHistoryWorkbookQueryVariables>;
export const ForceRejectCertificationDocument = gql`
    mutation ForceRejectCertification($input: ForceRejectCertificationInput!) {
  forceRejectCertification(input: $input) {
    certification {
      ...RentalCertificationFields
    }
  }
}
    ${RentalCertificationFieldsFragmentDoc}`;

/**
 * __useForceRejectCertificationMutation__
 *
 * To run a mutation, you first call `useForceRejectCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceRejectCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceRejectCertificationMutation, { data, loading, error }] = useForceRejectCertificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForceRejectCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ForceRejectCertificationMutation, ForceRejectCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForceRejectCertificationMutation, ForceRejectCertificationMutationVariables>(ForceRejectCertificationDocument, options);
      }
export type ForceRejectCertificationMutationHookResult = ReturnType<typeof useForceRejectCertificationMutation>;
export type ForceRejectCertificationMutationResult = Apollo.MutationResult<ForceRejectCertificationMutation>;
export type ForceRejectCertificationMutationOptions = Apollo.BaseMutationOptions<ForceRejectCertificationMutation, ForceRejectCertificationMutationVariables>;
export const ForceApproveCertificationDocument = gql`
    mutation ForceApproveCertification($input: ForceApproveCertificationInput!) {
  forceApproveCertification(input: $input) {
    certification {
      ...RentalCertificationFields
    }
    skipped_reviewer_count
  }
}
    ${RentalCertificationFieldsFragmentDoc}`;

/**
 * __useForceApproveCertificationMutation__
 *
 * To run a mutation, you first call `useForceApproveCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceApproveCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceApproveCertificationMutation, { data, loading, error }] = useForceApproveCertificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForceApproveCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ForceApproveCertificationMutation, ForceApproveCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForceApproveCertificationMutation, ForceApproveCertificationMutationVariables>(ForceApproveCertificationDocument, options);
      }
export type ForceApproveCertificationMutationHookResult = ReturnType<typeof useForceApproveCertificationMutation>;
export type ForceApproveCertificationMutationResult = Apollo.MutationResult<ForceApproveCertificationMutation>;
export type ForceApproveCertificationMutationOptions = Apollo.BaseMutationOptions<ForceApproveCertificationMutation, ForceApproveCertificationMutationVariables>;
export const RemoveCertificationReviewerDocument = gql`
    mutation RemoveCertificationReviewer($input: RemoveCertificationReviewerInput!) {
  removeCertificationReviewer(input: $input) {
    certification {
      ...RentalCertificationFields
    }
    removed_reviewer_user_id
    auto_approved
  }
}
    ${RentalCertificationFieldsFragmentDoc}`;

/**
 * __useRemoveCertificationReviewerMutation__
 *
 * To run a mutation, you first call `useRemoveCertificationReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCertificationReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCertificationReviewerMutation, { data, loading, error }] = useRemoveCertificationReviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCertificationReviewerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCertificationReviewerMutation, RemoveCertificationReviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveCertificationReviewerMutation, RemoveCertificationReviewerMutationVariables>(RemoveCertificationReviewerDocument, options);
      }
export type RemoveCertificationReviewerMutationHookResult = ReturnType<typeof useRemoveCertificationReviewerMutation>;
export type RemoveCertificationReviewerMutationResult = Apollo.MutationResult<RemoveCertificationReviewerMutation>;
export type RemoveCertificationReviewerMutationOptions = Apollo.BaseMutationOptions<RemoveCertificationReviewerMutation, RemoveCertificationReviewerMutationVariables>;
export const GetRentalCertificationDocument = gql`
    query GetRentalCertification($id: Int!) {
  getRentalCertification(id: $id) {
    certification {
      ...RentalCertificationFields
    }
    items {
      ...RentalCertificationItemSnapshotFields
    }
    relocations {
      id
      certification_id
      machine {
        id
        name
      }
      movement_type
      movement_date
      counter_value
      counter_type
      from_project {
        id
        name
      }
      to_project {
        id
        name
      }
      comments
    }
  }
}
    ${RentalCertificationFieldsFragmentDoc}
${RentalCertificationItemSnapshotFieldsFragmentDoc}`;

/**
 * __useGetRentalCertificationQuery__
 *
 * To run a query within a React component, call `useGetRentalCertificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalCertificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalCertificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRentalCertificationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRentalCertificationQuery, GetRentalCertificationQueryVariables> & ({ variables: GetRentalCertificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRentalCertificationQuery, GetRentalCertificationQueryVariables>(GetRentalCertificationDocument, options);
      }
export function useGetRentalCertificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRentalCertificationQuery, GetRentalCertificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRentalCertificationQuery, GetRentalCertificationQueryVariables>(GetRentalCertificationDocument, options);
        }
export function useGetRentalCertificationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRentalCertificationQuery, GetRentalCertificationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRentalCertificationQuery, GetRentalCertificationQueryVariables>(GetRentalCertificationDocument, options);
        }
export type GetRentalCertificationQueryHookResult = ReturnType<typeof useGetRentalCertificationQuery>;
export type GetRentalCertificationLazyQueryHookResult = ReturnType<typeof useGetRentalCertificationLazyQuery>;
export type GetRentalCertificationSuspenseQueryHookResult = ReturnType<typeof useGetRentalCertificationSuspenseQuery>;
export type GetRentalCertificationQueryResult = Apollo.QueryResult<GetRentalCertificationQuery, GetRentalCertificationQueryVariables>;
export const SearchRentalCertificationApproversDocument = gql`
    query SearchRentalCertificationApprovers($project_id: Int!, $query: String!) {
  searchRentalCertificationApprovers(project_id: $project_id, query: $query) {
    type
    user {
      id
      first_name
      last_name
      email
      dni
    }
  }
}
    `;

/**
 * __useSearchRentalCertificationApproversQuery__
 *
 * To run a query within a React component, call `useSearchRentalCertificationApproversQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRentalCertificationApproversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRentalCertificationApproversQuery({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchRentalCertificationApproversQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchRentalCertificationApproversQuery, SearchRentalCertificationApproversQueryVariables> & ({ variables: SearchRentalCertificationApproversQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchRentalCertificationApproversQuery, SearchRentalCertificationApproversQueryVariables>(SearchRentalCertificationApproversDocument, options);
      }
export function useSearchRentalCertificationApproversLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchRentalCertificationApproversQuery, SearchRentalCertificationApproversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchRentalCertificationApproversQuery, SearchRentalCertificationApproversQueryVariables>(SearchRentalCertificationApproversDocument, options);
        }
export function useSearchRentalCertificationApproversSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchRentalCertificationApproversQuery, SearchRentalCertificationApproversQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchRentalCertificationApproversQuery, SearchRentalCertificationApproversQueryVariables>(SearchRentalCertificationApproversDocument, options);
        }
export type SearchRentalCertificationApproversQueryHookResult = ReturnType<typeof useSearchRentalCertificationApproversQuery>;
export type SearchRentalCertificationApproversLazyQueryHookResult = ReturnType<typeof useSearchRentalCertificationApproversLazyQuery>;
export type SearchRentalCertificationApproversSuspenseQueryHookResult = ReturnType<typeof useSearchRentalCertificationApproversSuspenseQuery>;
export type SearchRentalCertificationApproversQueryResult = Apollo.QueryResult<SearchRentalCertificationApproversQuery, SearchRentalCertificationApproversQueryVariables>;
export const DownloadRentalCertificationPdfDocument = gql`
    query DownloadRentalCertificationPdf($certification_id: Int!) {
  downloadRentalCertificationPdf(certification_id: $certification_id) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useDownloadRentalCertificationPdfQuery__
 *
 * To run a query within a React component, call `useDownloadRentalCertificationPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadRentalCertificationPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadRentalCertificationPdfQuery({
 *   variables: {
 *      certification_id: // value for 'certification_id'
 *   },
 * });
 */
export function useDownloadRentalCertificationPdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DownloadRentalCertificationPdfQuery, DownloadRentalCertificationPdfQueryVariables> & ({ variables: DownloadRentalCertificationPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DownloadRentalCertificationPdfQuery, DownloadRentalCertificationPdfQueryVariables>(DownloadRentalCertificationPdfDocument, options);
      }
export function useDownloadRentalCertificationPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadRentalCertificationPdfQuery, DownloadRentalCertificationPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DownloadRentalCertificationPdfQuery, DownloadRentalCertificationPdfQueryVariables>(DownloadRentalCertificationPdfDocument, options);
        }
export function useDownloadRentalCertificationPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DownloadRentalCertificationPdfQuery, DownloadRentalCertificationPdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DownloadRentalCertificationPdfQuery, DownloadRentalCertificationPdfQueryVariables>(DownloadRentalCertificationPdfDocument, options);
        }
export type DownloadRentalCertificationPdfQueryHookResult = ReturnType<typeof useDownloadRentalCertificationPdfQuery>;
export type DownloadRentalCertificationPdfLazyQueryHookResult = ReturnType<typeof useDownloadRentalCertificationPdfLazyQuery>;
export type DownloadRentalCertificationPdfSuspenseQueryHookResult = ReturnType<typeof useDownloadRentalCertificationPdfSuspenseQuery>;
export type DownloadRentalCertificationPdfQueryResult = Apollo.QueryResult<DownloadRentalCertificationPdfQuery, DownloadRentalCertificationPdfQueryVariables>;
export const DownloadRentalCertificationXlsxDocument = gql`
    query DownloadRentalCertificationXlsx($certification_id: Int!) {
  downloadRentalCertificationXlsx(certification_id: $certification_id) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useDownloadRentalCertificationXlsxQuery__
 *
 * To run a query within a React component, call `useDownloadRentalCertificationXlsxQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadRentalCertificationXlsxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadRentalCertificationXlsxQuery({
 *   variables: {
 *      certification_id: // value for 'certification_id'
 *   },
 * });
 */
export function useDownloadRentalCertificationXlsxQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DownloadRentalCertificationXlsxQuery, DownloadRentalCertificationXlsxQueryVariables> & ({ variables: DownloadRentalCertificationXlsxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DownloadRentalCertificationXlsxQuery, DownloadRentalCertificationXlsxQueryVariables>(DownloadRentalCertificationXlsxDocument, options);
      }
export function useDownloadRentalCertificationXlsxLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadRentalCertificationXlsxQuery, DownloadRentalCertificationXlsxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DownloadRentalCertificationXlsxQuery, DownloadRentalCertificationXlsxQueryVariables>(DownloadRentalCertificationXlsxDocument, options);
        }
export function useDownloadRentalCertificationXlsxSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DownloadRentalCertificationXlsxQuery, DownloadRentalCertificationXlsxQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DownloadRentalCertificationXlsxQuery, DownloadRentalCertificationXlsxQueryVariables>(DownloadRentalCertificationXlsxDocument, options);
        }
export type DownloadRentalCertificationXlsxQueryHookResult = ReturnType<typeof useDownloadRentalCertificationXlsxQuery>;
export type DownloadRentalCertificationXlsxLazyQueryHookResult = ReturnType<typeof useDownloadRentalCertificationXlsxLazyQuery>;
export type DownloadRentalCertificationXlsxSuspenseQueryHookResult = ReturnType<typeof useDownloadRentalCertificationXlsxSuspenseQuery>;
export type DownloadRentalCertificationXlsxQueryResult = Apollo.QueryResult<DownloadRentalCertificationXlsxQuery, DownloadRentalCertificationXlsxQueryVariables>;
export const GetMyCertificatesToReviewDocument = gql`
    query GetMyCertificatesToReview($filter: MyCertificatesToReviewFilter, $pagination: FilterPagination) {
  getMyCertificatesToReview(filter: $filter, pagination: $pagination) {
    items {
      ...RentalCertificationFields
    }
    page_info {
      current_page
      items_per_page
      total_pages
      total_items
    }
  }
}
    ${RentalCertificationFieldsFragmentDoc}`;

/**
 * __useGetMyCertificatesToReviewQuery__
 *
 * To run a query within a React component, call `useGetMyCertificatesToReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCertificatesToReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCertificatesToReviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMyCertificatesToReviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyCertificatesToReviewQuery, GetMyCertificatesToReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyCertificatesToReviewQuery, GetMyCertificatesToReviewQueryVariables>(GetMyCertificatesToReviewDocument, options);
      }
export function useGetMyCertificatesToReviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyCertificatesToReviewQuery, GetMyCertificatesToReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyCertificatesToReviewQuery, GetMyCertificatesToReviewQueryVariables>(GetMyCertificatesToReviewDocument, options);
        }
export function useGetMyCertificatesToReviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyCertificatesToReviewQuery, GetMyCertificatesToReviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyCertificatesToReviewQuery, GetMyCertificatesToReviewQueryVariables>(GetMyCertificatesToReviewDocument, options);
        }
export type GetMyCertificatesToReviewQueryHookResult = ReturnType<typeof useGetMyCertificatesToReviewQuery>;
export type GetMyCertificatesToReviewLazyQueryHookResult = ReturnType<typeof useGetMyCertificatesToReviewLazyQuery>;
export type GetMyCertificatesToReviewSuspenseQueryHookResult = ReturnType<typeof useGetMyCertificatesToReviewSuspenseQuery>;
export type GetMyCertificatesToReviewQueryResult = Apollo.QueryResult<GetMyCertificatesToReviewQuery, GetMyCertificatesToReviewQueryVariables>;
export const GetDailyReportPhotosByIdDocument = gql`
    query GetDailyReportPhotosByID($id: Int!) {
  getDailyReportByUsageId(id: $id) {
    ... on DailyReportItem {
      item {
        usage_reports {
          id
          photos {
            id
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDailyReportPhotosByIdQuery__
 *
 * To run a query within a React component, call `useGetDailyReportPhotosByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportPhotosByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportPhotosByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyReportPhotosByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyReportPhotosByIdQuery, GetDailyReportPhotosByIdQueryVariables> & ({ variables: GetDailyReportPhotosByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyReportPhotosByIdQuery, GetDailyReportPhotosByIdQueryVariables>(GetDailyReportPhotosByIdDocument, options);
      }
export function useGetDailyReportPhotosByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyReportPhotosByIdQuery, GetDailyReportPhotosByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyReportPhotosByIdQuery, GetDailyReportPhotosByIdQueryVariables>(GetDailyReportPhotosByIdDocument, options);
        }
export function useGetDailyReportPhotosByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyReportPhotosByIdQuery, GetDailyReportPhotosByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyReportPhotosByIdQuery, GetDailyReportPhotosByIdQueryVariables>(GetDailyReportPhotosByIdDocument, options);
        }
export type GetDailyReportPhotosByIdQueryHookResult = ReturnType<typeof useGetDailyReportPhotosByIdQuery>;
export type GetDailyReportPhotosByIdLazyQueryHookResult = ReturnType<typeof useGetDailyReportPhotosByIdLazyQuery>;
export type GetDailyReportPhotosByIdSuspenseQueryHookResult = ReturnType<typeof useGetDailyReportPhotosByIdSuspenseQuery>;
export type GetDailyReportPhotosByIdQueryResult = Apollo.QueryResult<GetDailyReportPhotosByIdQuery, GetDailyReportPhotosByIdQueryVariables>;
export const GetDailyReportByIdDocument = gql`
    query GetDailyReportByID($id: Int!) {
  getDailyReportById(id: $id) {
    ... on AuthCheckGetDailyReportById {
      item {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useGetDailyReportByIdQuery__
 *
 * To run a query within a React component, call `useGetDailyReportByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDailyReportByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyReportByIdQuery, GetDailyReportByIdQueryVariables> & ({ variables: GetDailyReportByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyReportByIdQuery, GetDailyReportByIdQueryVariables>(GetDailyReportByIdDocument, options);
      }
export function useGetDailyReportByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyReportByIdQuery, GetDailyReportByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyReportByIdQuery, GetDailyReportByIdQueryVariables>(GetDailyReportByIdDocument, options);
        }
export function useGetDailyReportByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyReportByIdQuery, GetDailyReportByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyReportByIdQuery, GetDailyReportByIdQueryVariables>(GetDailyReportByIdDocument, options);
        }
export type GetDailyReportByIdQueryHookResult = ReturnType<typeof useGetDailyReportByIdQuery>;
export type GetDailyReportByIdLazyQueryHookResult = ReturnType<typeof useGetDailyReportByIdLazyQuery>;
export type GetDailyReportByIdSuspenseQueryHookResult = ReturnType<typeof useGetDailyReportByIdSuspenseQuery>;
export type GetDailyReportByIdQueryResult = Apollo.QueryResult<GetDailyReportByIdQuery, GetDailyReportByIdQueryVariables>;
export const GetDailyReportsByDayStatsDocument = gql`
    query GetDailyReportsByDayStats($context: Context!, $date: LocalDate!, $group: MachineGroup) {
  getDailyReportsByDayStats(
    context: $context
    yyyymmdd: $date
    filter: {group: $group}
  ) {
    ... on AuthCheckGetDailyReportsByDayStats {
      stats {
        ...DailyReportByDayStatsFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportByDayStatsFieldsFragmentDoc}`;

/**
 * __useGetDailyReportsByDayStatsQuery__
 *
 * To run a query within a React component, call `useGetDailyReportsByDayStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportsByDayStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportsByDayStatsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      date: // value for 'date'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGetDailyReportsByDayStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyReportsByDayStatsQuery, GetDailyReportsByDayStatsQueryVariables> & ({ variables: GetDailyReportsByDayStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyReportsByDayStatsQuery, GetDailyReportsByDayStatsQueryVariables>(GetDailyReportsByDayStatsDocument, options);
      }
export function useGetDailyReportsByDayStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyReportsByDayStatsQuery, GetDailyReportsByDayStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyReportsByDayStatsQuery, GetDailyReportsByDayStatsQueryVariables>(GetDailyReportsByDayStatsDocument, options);
        }
export function useGetDailyReportsByDayStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyReportsByDayStatsQuery, GetDailyReportsByDayStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyReportsByDayStatsQuery, GetDailyReportsByDayStatsQueryVariables>(GetDailyReportsByDayStatsDocument, options);
        }
export type GetDailyReportsByDayStatsQueryHookResult = ReturnType<typeof useGetDailyReportsByDayStatsQuery>;
export type GetDailyReportsByDayStatsLazyQueryHookResult = ReturnType<typeof useGetDailyReportsByDayStatsLazyQuery>;
export type GetDailyReportsByDayStatsSuspenseQueryHookResult = ReturnType<typeof useGetDailyReportsByDayStatsSuspenseQuery>;
export type GetDailyReportsByDayStatsQueryResult = Apollo.QueryResult<GetDailyReportsByDayStatsQuery, GetDailyReportsByDayStatsQueryVariables>;
export const GetDailyReportsByMachineIdStatsDocument = gql`
    query GetDailyReportsByMachineIdStats($context: Context!, $id: Int!, $filter: FilterDateRange!) {
  getDailyReportsByMachineIdStats(context: $context, id: $id, filter: $filter) {
    ... on AuthCheckGetDailyReportsByMachineIdStats {
      stats {
        ...DailyReportByMachineIdStatsFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportByMachineIdStatsFieldsFragmentDoc}`;

/**
 * __useGetDailyReportsByMachineIdStatsQuery__
 *
 * To run a query within a React component, call `useGetDailyReportsByMachineIdStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportsByMachineIdStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportsByMachineIdStatsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDailyReportsByMachineIdStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyReportsByMachineIdStatsQuery, GetDailyReportsByMachineIdStatsQueryVariables> & ({ variables: GetDailyReportsByMachineIdStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyReportsByMachineIdStatsQuery, GetDailyReportsByMachineIdStatsQueryVariables>(GetDailyReportsByMachineIdStatsDocument, options);
      }
export function useGetDailyReportsByMachineIdStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyReportsByMachineIdStatsQuery, GetDailyReportsByMachineIdStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyReportsByMachineIdStatsQuery, GetDailyReportsByMachineIdStatsQueryVariables>(GetDailyReportsByMachineIdStatsDocument, options);
        }
export function useGetDailyReportsByMachineIdStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyReportsByMachineIdStatsQuery, GetDailyReportsByMachineIdStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyReportsByMachineIdStatsQuery, GetDailyReportsByMachineIdStatsQueryVariables>(GetDailyReportsByMachineIdStatsDocument, options);
        }
export type GetDailyReportsByMachineIdStatsQueryHookResult = ReturnType<typeof useGetDailyReportsByMachineIdStatsQuery>;
export type GetDailyReportsByMachineIdStatsLazyQueryHookResult = ReturnType<typeof useGetDailyReportsByMachineIdStatsLazyQuery>;
export type GetDailyReportsByMachineIdStatsSuspenseQueryHookResult = ReturnType<typeof useGetDailyReportsByMachineIdStatsSuspenseQuery>;
export type GetDailyReportsByMachineIdStatsQueryResult = Apollo.QueryResult<GetDailyReportsByMachineIdStatsQuery, GetDailyReportsByMachineIdStatsQueryVariables>;
export const GetDailyReportsByMachineIdDocument = gql`
    query GetDailyReportsByMachineId($context: Context!, $filter: FilterDailyReports, $pagination: FilterPagination) {
  getDailyReports(context: $context, filter: $filter, pagination: $pagination) {
    ... on AuthCheckGetDailyReports {
      items {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useGetDailyReportsByMachineIdQuery__
 *
 * To run a query within a React component, call `useGetDailyReportsByMachineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportsByMachineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportsByMachineIdQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetDailyReportsByMachineIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyReportsByMachineIdQuery, GetDailyReportsByMachineIdQueryVariables> & ({ variables: GetDailyReportsByMachineIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyReportsByMachineIdQuery, GetDailyReportsByMachineIdQueryVariables>(GetDailyReportsByMachineIdDocument, options);
      }
export function useGetDailyReportsByMachineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyReportsByMachineIdQuery, GetDailyReportsByMachineIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyReportsByMachineIdQuery, GetDailyReportsByMachineIdQueryVariables>(GetDailyReportsByMachineIdDocument, options);
        }
export function useGetDailyReportsByMachineIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyReportsByMachineIdQuery, GetDailyReportsByMachineIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyReportsByMachineIdQuery, GetDailyReportsByMachineIdQueryVariables>(GetDailyReportsByMachineIdDocument, options);
        }
export type GetDailyReportsByMachineIdQueryHookResult = ReturnType<typeof useGetDailyReportsByMachineIdQuery>;
export type GetDailyReportsByMachineIdLazyQueryHookResult = ReturnType<typeof useGetDailyReportsByMachineIdLazyQuery>;
export type GetDailyReportsByMachineIdSuspenseQueryHookResult = ReturnType<typeof useGetDailyReportsByMachineIdSuspenseQuery>;
export type GetDailyReportsByMachineIdQueryResult = Apollo.QueryResult<GetDailyReportsByMachineIdQuery, GetDailyReportsByMachineIdQueryVariables>;
export const GetAssignmentReportsByMachineIdDocument = gql`
    query GetAssignmentReportsByMachineId($machineId: Int!, $startDate: LocalDate!, $endDate: LocalDate!) {
  getMachineAssignmentsByPeriod(
    machineId: $machineId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...AssignmentReportFields
  }
}
    ${AssignmentReportFieldsFragmentDoc}`;

/**
 * __useGetAssignmentReportsByMachineIdQuery__
 *
 * To run a query within a React component, call `useGetAssignmentReportsByMachineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentReportsByMachineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentReportsByMachineIdQuery({
 *   variables: {
 *      machineId: // value for 'machineId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAssignmentReportsByMachineIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAssignmentReportsByMachineIdQuery, GetAssignmentReportsByMachineIdQueryVariables> & ({ variables: GetAssignmentReportsByMachineIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAssignmentReportsByMachineIdQuery, GetAssignmentReportsByMachineIdQueryVariables>(GetAssignmentReportsByMachineIdDocument, options);
      }
export function useGetAssignmentReportsByMachineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAssignmentReportsByMachineIdQuery, GetAssignmentReportsByMachineIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAssignmentReportsByMachineIdQuery, GetAssignmentReportsByMachineIdQueryVariables>(GetAssignmentReportsByMachineIdDocument, options);
        }
export function useGetAssignmentReportsByMachineIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAssignmentReportsByMachineIdQuery, GetAssignmentReportsByMachineIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAssignmentReportsByMachineIdQuery, GetAssignmentReportsByMachineIdQueryVariables>(GetAssignmentReportsByMachineIdDocument, options);
        }
export type GetAssignmentReportsByMachineIdQueryHookResult = ReturnType<typeof useGetAssignmentReportsByMachineIdQuery>;
export type GetAssignmentReportsByMachineIdLazyQueryHookResult = ReturnType<typeof useGetAssignmentReportsByMachineIdLazyQuery>;
export type GetAssignmentReportsByMachineIdSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentReportsByMachineIdSuspenseQuery>;
export type GetAssignmentReportsByMachineIdQueryResult = Apollo.QueryResult<GetAssignmentReportsByMachineIdQuery, GetAssignmentReportsByMachineIdQueryVariables>;
export const GetMachineReportsHistoryDocument = gql`
    query GetMachineReportsHistory($context: Context!, $filter: FilterDailyReports, $pagination: FilterPagination) {
  getDailyReports(context: $context, filter: $filter, pagination: $pagination) {
    ... on AuthCheckGetDailyReports {
      items {
        ...MachineReportsHistoryFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineReportsHistoryFieldsFragmentDoc}`;

/**
 * __useGetMachineReportsHistoryQuery__
 *
 * To run a query within a React component, call `useGetMachineReportsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineReportsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineReportsHistoryQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMachineReportsHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineReportsHistoryQuery, GetMachineReportsHistoryQueryVariables> & ({ variables: GetMachineReportsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineReportsHistoryQuery, GetMachineReportsHistoryQueryVariables>(GetMachineReportsHistoryDocument, options);
      }
export function useGetMachineReportsHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineReportsHistoryQuery, GetMachineReportsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineReportsHistoryQuery, GetMachineReportsHistoryQueryVariables>(GetMachineReportsHistoryDocument, options);
        }
export function useGetMachineReportsHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineReportsHistoryQuery, GetMachineReportsHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineReportsHistoryQuery, GetMachineReportsHistoryQueryVariables>(GetMachineReportsHistoryDocument, options);
        }
export type GetMachineReportsHistoryQueryHookResult = ReturnType<typeof useGetMachineReportsHistoryQuery>;
export type GetMachineReportsHistoryLazyQueryHookResult = ReturnType<typeof useGetMachineReportsHistoryLazyQuery>;
export type GetMachineReportsHistorySuspenseQueryHookResult = ReturnType<typeof useGetMachineReportsHistorySuspenseQuery>;
export type GetMachineReportsHistoryQueryResult = Apollo.QueryResult<GetMachineReportsHistoryQuery, GetMachineReportsHistoryQueryVariables>;
export const GetMoveReportByIdDocument = gql`
    query GetMoveReportById($id: Int!) {
  getMoveReportById(id: $id) {
    ...MoveReportFields
  }
}
    ${MoveReportFieldsFragmentDoc}`;

/**
 * __useGetMoveReportByIdQuery__
 *
 * To run a query within a React component, call `useGetMoveReportByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveReportByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveReportByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMoveReportByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMoveReportByIdQuery, GetMoveReportByIdQueryVariables> & ({ variables: GetMoveReportByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMoveReportByIdQuery, GetMoveReportByIdQueryVariables>(GetMoveReportByIdDocument, options);
      }
export function useGetMoveReportByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMoveReportByIdQuery, GetMoveReportByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMoveReportByIdQuery, GetMoveReportByIdQueryVariables>(GetMoveReportByIdDocument, options);
        }
export function useGetMoveReportByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMoveReportByIdQuery, GetMoveReportByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMoveReportByIdQuery, GetMoveReportByIdQueryVariables>(GetMoveReportByIdDocument, options);
        }
export type GetMoveReportByIdQueryHookResult = ReturnType<typeof useGetMoveReportByIdQuery>;
export type GetMoveReportByIdLazyQueryHookResult = ReturnType<typeof useGetMoveReportByIdLazyQuery>;
export type GetMoveReportByIdSuspenseQueryHookResult = ReturnType<typeof useGetMoveReportByIdSuspenseQuery>;
export type GetMoveReportByIdQueryResult = Apollo.QueryResult<GetMoveReportByIdQuery, GetMoveReportByIdQueryVariables>;
export const GetDailyReportsByDayDocument = gql`
    query GetDailyReportsByDay($context: Context!, $date: LocalDate!, $pagination: FilterPagination, $group: MachineGroup) {
  getDailyReports(
    context: $context
    filter: {start_date: $date, end_date: $date, group: $group}
    pagination: $pagination
  ) {
    ... on AuthCheckGetDailyReports {
      items {
        ...DailyReportFields
      }
    }
    ... on Error {
      ...ErrorFields
    }
  }
}
    ${DailyReportFieldsFragmentDoc}
${ErrorFieldsFragmentDoc}`;

/**
 * __useGetDailyReportsByDayQuery__
 *
 * To run a query within a React component, call `useGetDailyReportsByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportsByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportsByDayQuery({
 *   variables: {
 *      context: // value for 'context'
 *      date: // value for 'date'
 *      pagination: // value for 'pagination'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGetDailyReportsByDayQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyReportsByDayQuery, GetDailyReportsByDayQueryVariables> & ({ variables: GetDailyReportsByDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyReportsByDayQuery, GetDailyReportsByDayQueryVariables>(GetDailyReportsByDayDocument, options);
      }
export function useGetDailyReportsByDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyReportsByDayQuery, GetDailyReportsByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyReportsByDayQuery, GetDailyReportsByDayQueryVariables>(GetDailyReportsByDayDocument, options);
        }
export function useGetDailyReportsByDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyReportsByDayQuery, GetDailyReportsByDayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyReportsByDayQuery, GetDailyReportsByDayQueryVariables>(GetDailyReportsByDayDocument, options);
        }
export type GetDailyReportsByDayQueryHookResult = ReturnType<typeof useGetDailyReportsByDayQuery>;
export type GetDailyReportsByDayLazyQueryHookResult = ReturnType<typeof useGetDailyReportsByDayLazyQuery>;
export type GetDailyReportsByDaySuspenseQueryHookResult = ReturnType<typeof useGetDailyReportsByDaySuspenseQuery>;
export type GetDailyReportsByDayQueryResult = Apollo.QueryResult<GetDailyReportsByDayQuery, GetDailyReportsByDayQueryVariables>;
export const GetMachinistsWorkBoardDocument = gql`
    query GetMachinistsWorkBoard($context: Context!, $filter: FilterDateRange!) {
  getMachinistsWorkBoard(context: $context) {
    items {
      ...MachinistReportsFields
    }
  }
}
    ${MachinistReportsFieldsFragmentDoc}`;

/**
 * __useGetMachinistsWorkBoardQuery__
 *
 * To run a query within a React component, call `useGetMachinistsWorkBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinistsWorkBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinistsWorkBoardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMachinistsWorkBoardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachinistsWorkBoardQuery, GetMachinistsWorkBoardQueryVariables> & ({ variables: GetMachinistsWorkBoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinistsWorkBoardQuery, GetMachinistsWorkBoardQueryVariables>(GetMachinistsWorkBoardDocument, options);
      }
export function useGetMachinistsWorkBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinistsWorkBoardQuery, GetMachinistsWorkBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinistsWorkBoardQuery, GetMachinistsWorkBoardQueryVariables>(GetMachinistsWorkBoardDocument, options);
        }
export function useGetMachinistsWorkBoardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinistsWorkBoardQuery, GetMachinistsWorkBoardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinistsWorkBoardQuery, GetMachinistsWorkBoardQueryVariables>(GetMachinistsWorkBoardDocument, options);
        }
export type GetMachinistsWorkBoardQueryHookResult = ReturnType<typeof useGetMachinistsWorkBoardQuery>;
export type GetMachinistsWorkBoardLazyQueryHookResult = ReturnType<typeof useGetMachinistsWorkBoardLazyQuery>;
export type GetMachinistsWorkBoardSuspenseQueryHookResult = ReturnType<typeof useGetMachinistsWorkBoardSuspenseQuery>;
export type GetMachinistsWorkBoardQueryResult = Apollo.QueryResult<GetMachinistsWorkBoardQuery, GetMachinistsWorkBoardQueryVariables>;
export const GetMachineReportsBoardDocument = gql`
    query GetMachineReportsBoard($context: Context!, $groups: [MachineGroup!]!, $filter: FilterDateRange!, $reporter: ID) {
  getMachineReportsBoard(
    context: $context
    groups: $groups
    filter: $filter
    reporter: $reporter
  ) {
    ... on MachineReportsBoardConnection {
      items {
        ...MachineReportsFields
      }
    }
  }
}
    ${MachineReportsFieldsFragmentDoc}`;

/**
 * __useGetMachineReportsBoardQuery__
 *
 * To run a query within a React component, call `useGetMachineReportsBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineReportsBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineReportsBoardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      groups: // value for 'groups'
 *      filter: // value for 'filter'
 *      reporter: // value for 'reporter'
 *   },
 * });
 */
export function useGetMachineReportsBoardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineReportsBoardQuery, GetMachineReportsBoardQueryVariables> & ({ variables: GetMachineReportsBoardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineReportsBoardQuery, GetMachineReportsBoardQueryVariables>(GetMachineReportsBoardDocument, options);
      }
export function useGetMachineReportsBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineReportsBoardQuery, GetMachineReportsBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineReportsBoardQuery, GetMachineReportsBoardQueryVariables>(GetMachineReportsBoardDocument, options);
        }
export function useGetMachineReportsBoardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineReportsBoardQuery, GetMachineReportsBoardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineReportsBoardQuery, GetMachineReportsBoardQueryVariables>(GetMachineReportsBoardDocument, options);
        }
export type GetMachineReportsBoardQueryHookResult = ReturnType<typeof useGetMachineReportsBoardQuery>;
export type GetMachineReportsBoardLazyQueryHookResult = ReturnType<typeof useGetMachineReportsBoardLazyQuery>;
export type GetMachineReportsBoardSuspenseQueryHookResult = ReturnType<typeof useGetMachineReportsBoardSuspenseQuery>;
export type GetMachineReportsBoardQueryResult = Apollo.QueryResult<GetMachineReportsBoardQuery, GetMachineReportsBoardQueryVariables>;
export const ExportReportsWorkbookDocument = gql`
    query ExportReportsWorkbook($context: Context!, $filter: FilterDateRange!, $machineId: Int, $summaryMode: ReportsWorkbookSummaryMode, $groups: [MachineGroup!], $reporter: ID, $companyName: String, $projectName: String, $reporterName: String) {
  exportReportsWorkbook(
    context: $context
    filter: $filter
    machineId: $machineId
    summaryMode: $summaryMode
    groups: $groups
    reporter: $reporter
    companyName: $companyName
    projectName: $projectName
    reporterName: $reporterName
  ) {
    ... on SuccessResult {
      result
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useExportReportsWorkbookQuery__
 *
 * To run a query within a React component, call `useExportReportsWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportReportsWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportReportsWorkbookQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      machineId: // value for 'machineId'
 *      summaryMode: // value for 'summaryMode'
 *      groups: // value for 'groups'
 *      reporter: // value for 'reporter'
 *      companyName: // value for 'companyName'
 *      projectName: // value for 'projectName'
 *      reporterName: // value for 'reporterName'
 *   },
 * });
 */
export function useExportReportsWorkbookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExportReportsWorkbookQuery, ExportReportsWorkbookQueryVariables> & ({ variables: ExportReportsWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportReportsWorkbookQuery, ExportReportsWorkbookQueryVariables>(ExportReportsWorkbookDocument, options);
      }
export function useExportReportsWorkbookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportReportsWorkbookQuery, ExportReportsWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportReportsWorkbookQuery, ExportReportsWorkbookQueryVariables>(ExportReportsWorkbookDocument, options);
        }
export function useExportReportsWorkbookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExportReportsWorkbookQuery, ExportReportsWorkbookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExportReportsWorkbookQuery, ExportReportsWorkbookQueryVariables>(ExportReportsWorkbookDocument, options);
        }
export type ExportReportsWorkbookQueryHookResult = ReturnType<typeof useExportReportsWorkbookQuery>;
export type ExportReportsWorkbookLazyQueryHookResult = ReturnType<typeof useExportReportsWorkbookLazyQuery>;
export type ExportReportsWorkbookSuspenseQueryHookResult = ReturnType<typeof useExportReportsWorkbookSuspenseQuery>;
export type ExportReportsWorkbookQueryResult = Apollo.QueryResult<ExportReportsWorkbookQuery, ExportReportsWorkbookQueryVariables>;
export const UpdateDailyReportDocument = gql`
    mutation UpdateDailyReport($id: Int!, $input: UpdateDailyReportInput!) {
  updateDailyReport(id: $id, input: $input) {
    ... on AuthCheckUpdateDailyReport {
      item {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useUpdateDailyReportMutation__
 *
 * To run a mutation, you first call `useUpdateDailyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyReportMutation, { data, loading, error }] = useUpdateDailyReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDailyReportMutation, UpdateDailyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDailyReportMutation, UpdateDailyReportMutationVariables>(UpdateDailyReportDocument, options);
      }
export type UpdateDailyReportMutationHookResult = ReturnType<typeof useUpdateDailyReportMutation>;
export type UpdateDailyReportMutationResult = Apollo.MutationResult<UpdateDailyReportMutation>;
export type UpdateDailyReportMutationOptions = Apollo.BaseMutationOptions<UpdateDailyReportMutation, UpdateDailyReportMutationVariables>;
export const AddDailyReportDocument = gql`
    mutation AddDailyReport($input: AddDailyReportInput!) {
  addDailyReport(input: $input) {
    ... on AuthCheckAddDailyReport {
      item {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useAddDailyReportMutation__
 *
 * To run a mutation, you first call `useAddDailyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDailyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDailyReportMutation, { data, loading, error }] = useAddDailyReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDailyReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddDailyReportMutation, AddDailyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddDailyReportMutation, AddDailyReportMutationVariables>(AddDailyReportDocument, options);
      }
export type AddDailyReportMutationHookResult = ReturnType<typeof useAddDailyReportMutation>;
export type AddDailyReportMutationResult = Apollo.MutationResult<AddDailyReportMutation>;
export type AddDailyReportMutationOptions = Apollo.BaseMutationOptions<AddDailyReportMutation, AddDailyReportMutationVariables>;
export const AddDailyReportOfflineDocument = gql`
    mutation AddDailyReportOffline($input: AddDailyReportOfflineInput!) {
  addDailyReportOffline(input: $input) {
    ... on AuthCheckAddDailyReport {
      item {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useAddDailyReportOfflineMutation__
 *
 * To run a mutation, you first call `useAddDailyReportOfflineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDailyReportOfflineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDailyReportOfflineMutation, { data, loading, error }] = useAddDailyReportOfflineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDailyReportOfflineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddDailyReportOfflineMutation, AddDailyReportOfflineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddDailyReportOfflineMutation, AddDailyReportOfflineMutationVariables>(AddDailyReportOfflineDocument, options);
      }
export type AddDailyReportOfflineMutationHookResult = ReturnType<typeof useAddDailyReportOfflineMutation>;
export type AddDailyReportOfflineMutationResult = Apollo.MutationResult<AddDailyReportOfflineMutation>;
export type AddDailyReportOfflineMutationOptions = Apollo.BaseMutationOptions<AddDailyReportOfflineMutation, AddDailyReportOfflineMutationVariables>;
export const DeleteDailyReportDocument = gql`
    mutation DeleteDailyReport($id: Int!) {
  deleteDailyReport(id: $id) {
    ... on AuthCheckDeleteDailyReport {
      item {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useDeleteDailyReportMutation__
 *
 * To run a mutation, you first call `useDeleteDailyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyReportMutation, { data, loading, error }] = useDeleteDailyReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDailyReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDailyReportMutation, DeleteDailyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDailyReportMutation, DeleteDailyReportMutationVariables>(DeleteDailyReportDocument, options);
      }
export type DeleteDailyReportMutationHookResult = ReturnType<typeof useDeleteDailyReportMutation>;
export type DeleteDailyReportMutationResult = Apollo.MutationResult<DeleteDailyReportMutation>;
export type DeleteDailyReportMutationOptions = Apollo.BaseMutationOptions<DeleteDailyReportMutation, DeleteDailyReportMutationVariables>;
export const AddOutOfServiceReportDocument = gql`
    mutation AddOutOfServiceReport($input: AddOutOfServiceReportForDateRangeInput!) {
  addOutOfServiceReportForDateRange(input: $input) {
    items {
      ...DailyReportFields
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useAddOutOfServiceReportMutation__
 *
 * To run a mutation, you first call `useAddOutOfServiceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOutOfServiceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOutOfServiceReportMutation, { data, loading, error }] = useAddOutOfServiceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOutOfServiceReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddOutOfServiceReportMutation, AddOutOfServiceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddOutOfServiceReportMutation, AddOutOfServiceReportMutationVariables>(AddOutOfServiceReportDocument, options);
      }
export type AddOutOfServiceReportMutationHookResult = ReturnType<typeof useAddOutOfServiceReportMutation>;
export type AddOutOfServiceReportMutationResult = Apollo.MutationResult<AddOutOfServiceReportMutation>;
export type AddOutOfServiceReportMutationOptions = Apollo.BaseMutationOptions<AddOutOfServiceReportMutation, AddOutOfServiceReportMutationVariables>;
export const UpdateOutOfServiceReportDocument = gql`
    mutation UpdateOutOfServiceReport($id: Int!, $input: UpdateOOSReportInput!) {
  updateOutOfServiceReport(oosId: $id, input: $input) {
    items {
      ...DailyReportFields
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useUpdateOutOfServiceReportMutation__
 *
 * To run a mutation, you first call `useUpdateOutOfServiceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutOfServiceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutOfServiceReportMutation, { data, loading, error }] = useUpdateOutOfServiceReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOutOfServiceReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOutOfServiceReportMutation, UpdateOutOfServiceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOutOfServiceReportMutation, UpdateOutOfServiceReportMutationVariables>(UpdateOutOfServiceReportDocument, options);
      }
export type UpdateOutOfServiceReportMutationHookResult = ReturnType<typeof useUpdateOutOfServiceReportMutation>;
export type UpdateOutOfServiceReportMutationResult = Apollo.MutationResult<UpdateOutOfServiceReportMutation>;
export type UpdateOutOfServiceReportMutationOptions = Apollo.BaseMutationOptions<UpdateOutOfServiceReportMutation, UpdateOutOfServiceReportMutationVariables>;
export const DeleteOutOfServiceReportDocument = gql`
    mutation DeleteOutOfServiceReport($parentId: Int!) {
  deleteOutOfServiceReport(parentId: $parentId) {
    ... on AuthCheckDeleteOutOfServiceReport {
      item {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useDeleteOutOfServiceReportMutation__
 *
 * To run a mutation, you first call `useDeleteOutOfServiceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOutOfServiceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOutOfServiceReportMutation, { data, loading, error }] = useDeleteOutOfServiceReportMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useDeleteOutOfServiceReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOutOfServiceReportMutation, DeleteOutOfServiceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOutOfServiceReportMutation, DeleteOutOfServiceReportMutationVariables>(DeleteOutOfServiceReportDocument, options);
      }
export type DeleteOutOfServiceReportMutationHookResult = ReturnType<typeof useDeleteOutOfServiceReportMutation>;
export type DeleteOutOfServiceReportMutationResult = Apollo.MutationResult<DeleteOutOfServiceReportMutation>;
export type DeleteOutOfServiceReportMutationOptions = Apollo.BaseMutationOptions<DeleteOutOfServiceReportMutation, DeleteOutOfServiceReportMutationVariables>;
export const DeleteAvailableReportDocument = gql`
    mutation DeleteAvailableReport($parentId: Int!) {
  deleteAvailableReport(parentId: $parentId) {
    ... on AuthCheckDeleteAvailableReport {
      item {
        ...DailyReportFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useDeleteAvailableReportMutation__
 *
 * To run a mutation, you first call `useDeleteAvailableReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAvailableReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAvailableReportMutation, { data, loading, error }] = useDeleteAvailableReportMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useDeleteAvailableReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAvailableReportMutation, DeleteAvailableReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAvailableReportMutation, DeleteAvailableReportMutationVariables>(DeleteAvailableReportDocument, options);
      }
export type DeleteAvailableReportMutationHookResult = ReturnType<typeof useDeleteAvailableReportMutation>;
export type DeleteAvailableReportMutationResult = Apollo.MutationResult<DeleteAvailableReportMutation>;
export type DeleteAvailableReportMutationOptions = Apollo.BaseMutationOptions<DeleteAvailableReportMutation, DeleteAvailableReportMutationVariables>;
export const BatchAddAvailableReportDocument = gql`
    mutation BatchAddAvailableReport($input: BatchAddAvailableReportInput!) {
  batchAddAvailableReport(input: $input) {
    ... on DailyReportItems {
      items {
        id
      }
    }
  }
}
    `;

/**
 * __useBatchAddAvailableReportMutation__
 *
 * To run a mutation, you first call `useBatchAddAvailableReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchAddAvailableReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchAddAvailableReportMutation, { data, loading, error }] = useBatchAddAvailableReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchAddAvailableReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchAddAvailableReportMutation, BatchAddAvailableReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchAddAvailableReportMutation, BatchAddAvailableReportMutationVariables>(BatchAddAvailableReportDocument, options);
      }
export type BatchAddAvailableReportMutationHookResult = ReturnType<typeof useBatchAddAvailableReportMutation>;
export type BatchAddAvailableReportMutationResult = Apollo.MutationResult<BatchAddAvailableReportMutation>;
export type BatchAddAvailableReportMutationOptions = Apollo.BaseMutationOptions<BatchAddAvailableReportMutation, BatchAddAvailableReportMutationVariables>;
export const UpdateMoveReportDocument = gql`
    mutation updateMoveReport($id: Int!, $input: UpdateMoveReportInput!) {
  updateMoveReport(id: $id, input: $input) {
    ...MoveReportFields
  }
}
    ${MoveReportFieldsFragmentDoc}`;

/**
 * __useUpdateMoveReportMutation__
 *
 * To run a mutation, you first call `useUpdateMoveReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoveReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoveReportMutation, { data, loading, error }] = useUpdateMoveReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMoveReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMoveReportMutation, UpdateMoveReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMoveReportMutation, UpdateMoveReportMutationVariables>(UpdateMoveReportDocument, options);
      }
export type UpdateMoveReportMutationHookResult = ReturnType<typeof useUpdateMoveReportMutation>;
export type UpdateMoveReportMutationResult = Apollo.MutationResult<UpdateMoveReportMutation>;
export type UpdateMoveReportMutationOptions = Apollo.BaseMutationOptions<UpdateMoveReportMutation, UpdateMoveReportMutationVariables>;
export const DailyReportChangedDocument = gql`
    subscription DailyReportChanged($context: Context!) {
  dailyReportChanged(context: $context) {
    ...DailyReportFields
  }
}
    ${DailyReportFieldsFragmentDoc}`;

/**
 * __useDailyReportChangedSubscription__
 *
 * To run a query within a React component, call `useDailyReportChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDailyReportChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyReportChangedSubscription({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDailyReportChangedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<DailyReportChangedSubscription, DailyReportChangedSubscriptionVariables> & ({ variables: DailyReportChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<DailyReportChangedSubscription, DailyReportChangedSubscriptionVariables>(DailyReportChangedDocument, options);
      }
export type DailyReportChangedSubscriptionHookResult = ReturnType<typeof useDailyReportChangedSubscription>;
export type DailyReportChangedSubscriptionResult = Apollo.SubscriptionResult<DailyReportChangedSubscription>;
export const SuggestRosterColumnsDocument = gql`
    query SuggestRosterColumns($context: Context!, $columns: [RosterColumnInput!]!) {
  suggestRosterColumns(context: $context, columns: $columns) {
    meta {
      available
      unavailable_reason
      model
      latency_ms
    }
    truncated
    columns {
      header
      template_column
      ignore
      probability
      confidence
      error
      alternatives {
        template_column
        probability
      }
    }
  }
}
    `;

/**
 * __useSuggestRosterColumnsQuery__
 *
 * To run a query within a React component, call `useSuggestRosterColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestRosterColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestRosterColumnsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useSuggestRosterColumnsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuggestRosterColumnsQuery, SuggestRosterColumnsQueryVariables> & ({ variables: SuggestRosterColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuggestRosterColumnsQuery, SuggestRosterColumnsQueryVariables>(SuggestRosterColumnsDocument, options);
      }
export function useSuggestRosterColumnsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuggestRosterColumnsQuery, SuggestRosterColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuggestRosterColumnsQuery, SuggestRosterColumnsQueryVariables>(SuggestRosterColumnsDocument, options);
        }
export function useSuggestRosterColumnsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuggestRosterColumnsQuery, SuggestRosterColumnsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuggestRosterColumnsQuery, SuggestRosterColumnsQueryVariables>(SuggestRosterColumnsDocument, options);
        }
export type SuggestRosterColumnsQueryHookResult = ReturnType<typeof useSuggestRosterColumnsQuery>;
export type SuggestRosterColumnsLazyQueryHookResult = ReturnType<typeof useSuggestRosterColumnsLazyQuery>;
export type SuggestRosterColumnsSuspenseQueryHookResult = ReturnType<typeof useSuggestRosterColumnsSuspenseQuery>;
export type SuggestRosterColumnsQueryResult = Apollo.QueryResult<SuggestRosterColumnsQuery, SuggestRosterColumnsQueryVariables>;
export const ListRosterAuditMachinesDocument = gql`
    query ListRosterAuditMachines($context: Context!) {
  listRosterAuditMachines(context: $context) {
    id
    name
    brand
    model
    type
    group
    serial
    plate
    fuel
    counter
  }
}
    `;

/**
 * __useListRosterAuditMachinesQuery__
 *
 * To run a query within a React component, call `useListRosterAuditMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRosterAuditMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRosterAuditMachinesQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useListRosterAuditMachinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListRosterAuditMachinesQuery, ListRosterAuditMachinesQueryVariables> & ({ variables: ListRosterAuditMachinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListRosterAuditMachinesQuery, ListRosterAuditMachinesQueryVariables>(ListRosterAuditMachinesDocument, options);
      }
export function useListRosterAuditMachinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListRosterAuditMachinesQuery, ListRosterAuditMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListRosterAuditMachinesQuery, ListRosterAuditMachinesQueryVariables>(ListRosterAuditMachinesDocument, options);
        }
export function useListRosterAuditMachinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListRosterAuditMachinesQuery, ListRosterAuditMachinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListRosterAuditMachinesQuery, ListRosterAuditMachinesQueryVariables>(ListRosterAuditMachinesDocument, options);
        }
export type ListRosterAuditMachinesQueryHookResult = ReturnType<typeof useListRosterAuditMachinesQuery>;
export type ListRosterAuditMachinesLazyQueryHookResult = ReturnType<typeof useListRosterAuditMachinesLazyQuery>;
export type ListRosterAuditMachinesSuspenseQueryHookResult = ReturnType<typeof useListRosterAuditMachinesSuspenseQuery>;
export type ListRosterAuditMachinesQueryResult = Apollo.QueryResult<ListRosterAuditMachinesQuery, ListRosterAuditMachinesQueryVariables>;
export const SuggestRosterRowsDocument = gql`
    query SuggestRosterRows($context: Context!, $rows: [RosterRowInput!], $machine_ids: [ID!]) {
  suggestRosterRows(context: $context, rows: $rows, machine_ids: $machine_ids) {
    meta {
      available
      unavailable_reason
      model
      latency_ms
    }
    truncated
    type_options_truncated
    rows {
      row_index
      skipped
      error
      modelo
      subtipo
      rules
      review_reasons
      marca {
        raw
        suggested
        is_new
        probability
        confidence
      }
      tipo_combustible {
        suggested
        probability
        confidence
      }
      tipo_contador {
        suggested
        probability
        confidence
      }
      tipo_propiedad {
        suggested
        probability
        confidence
      }
      grupo_y_tipo {
        suggested_group
        suggested_type
        probability
        confidence
        rule {
          grupo
          tipo
        }
        jev_group
        jev_type
        jev_probability
      }
      matched_machine {
        id
        name
      }
      conflicts {
        field
        loaded
        suggested
      }
    }
  }
}
    `;

/**
 * __useSuggestRosterRowsQuery__
 *
 * To run a query within a React component, call `useSuggestRosterRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestRosterRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestRosterRowsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      rows: // value for 'rows'
 *      machine_ids: // value for 'machine_ids'
 *   },
 * });
 */
export function useSuggestRosterRowsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuggestRosterRowsQuery, SuggestRosterRowsQueryVariables> & ({ variables: SuggestRosterRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuggestRosterRowsQuery, SuggestRosterRowsQueryVariables>(SuggestRosterRowsDocument, options);
      }
export function useSuggestRosterRowsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuggestRosterRowsQuery, SuggestRosterRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuggestRosterRowsQuery, SuggestRosterRowsQueryVariables>(SuggestRosterRowsDocument, options);
        }
export function useSuggestRosterRowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuggestRosterRowsQuery, SuggestRosterRowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuggestRosterRowsQuery, SuggestRosterRowsQueryVariables>(SuggestRosterRowsDocument, options);
        }
export type SuggestRosterRowsQueryHookResult = ReturnType<typeof useSuggestRosterRowsQuery>;
export type SuggestRosterRowsLazyQueryHookResult = ReturnType<typeof useSuggestRosterRowsLazyQuery>;
export type SuggestRosterRowsSuspenseQueryHookResult = ReturnType<typeof useSuggestRosterRowsSuspenseQuery>;
export type SuggestRosterRowsQueryResult = Apollo.QueryResult<SuggestRosterRowsQuery, SuggestRosterRowsQueryVariables>;
export const AddServiceReportDocument = gql`
    mutation AddServiceReport($input: AddServiceReportInput!) {
  addServiceReport(input: $input) {
    ... on DailyReportItem {
      item {
        machine {
          ...ServicesFields
        }
      }
    }
  }
}
    ${ServicesFieldsFragmentDoc}`;

/**
 * __useAddServiceReportMutation__
 *
 * To run a mutation, you first call `useAddServiceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceReportMutation, { data, loading, error }] = useAddServiceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddServiceReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddServiceReportMutation, AddServiceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddServiceReportMutation, AddServiceReportMutationVariables>(AddServiceReportDocument, options);
      }
export type AddServiceReportMutationHookResult = ReturnType<typeof useAddServiceReportMutation>;
export type AddServiceReportMutationResult = Apollo.MutationResult<AddServiceReportMutation>;
export type AddServiceReportMutationOptions = Apollo.BaseMutationOptions<AddServiceReportMutation, AddServiceReportMutationVariables>;
export const UpdateNextServicesDocument = gql`
    mutation UpdateNextServices($input: UpdateNextServiceInput!) {
  updateNextService(input: $input) {
    ... on ItemMachine {
      item {
        ...ServicesFields
      }
    }
  }
}
    ${ServicesFieldsFragmentDoc}`;

/**
 * __useUpdateNextServicesMutation__
 *
 * To run a mutation, you first call `useUpdateNextServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNextServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNextServicesMutation, { data, loading, error }] = useUpdateNextServicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNextServicesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNextServicesMutation, UpdateNextServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNextServicesMutation, UpdateNextServicesMutationVariables>(UpdateNextServicesDocument, options);
      }
export type UpdateNextServicesMutationHookResult = ReturnType<typeof useUpdateNextServicesMutation>;
export type UpdateNextServicesMutationResult = Apollo.MutationResult<UpdateNextServicesMutation>;
export type UpdateNextServicesMutationOptions = Apollo.BaseMutationOptions<UpdateNextServicesMutation, UpdateNextServicesMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation DeleteService($id: Int!) {
  deleteServiceReport(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const GetServicesDashboardDocument = gql`
    query GetServicesDashboard($context: Context) {
  getServicesDashboard(context: $context) {
    machines {
      ...ServicesFields
    }
    usages {
      ...AverageUsageFields
    }
  }
}
    ${ServicesFieldsFragmentDoc}
${AverageUsageFieldsFragmentDoc}`;

/**
 * __useGetServicesDashboardQuery__
 *
 * To run a query within a React component, call `useGetServicesDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesDashboardQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetServicesDashboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetServicesDashboardQuery, GetServicesDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetServicesDashboardQuery, GetServicesDashboardQueryVariables>(GetServicesDashboardDocument, options);
      }
export function useGetServicesDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetServicesDashboardQuery, GetServicesDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetServicesDashboardQuery, GetServicesDashboardQueryVariables>(GetServicesDashboardDocument, options);
        }
export function useGetServicesDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetServicesDashboardQuery, GetServicesDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetServicesDashboardQuery, GetServicesDashboardQueryVariables>(GetServicesDashboardDocument, options);
        }
export type GetServicesDashboardQueryHookResult = ReturnType<typeof useGetServicesDashboardQuery>;
export type GetServicesDashboardLazyQueryHookResult = ReturnType<typeof useGetServicesDashboardLazyQuery>;
export type GetServicesDashboardSuspenseQueryHookResult = ReturnType<typeof useGetServicesDashboardSuspenseQuery>;
export type GetServicesDashboardQueryResult = Apollo.QueryResult<GetServicesDashboardQuery, GetServicesDashboardQueryVariables>;
export const GetMachineWithServicesByIdDocument = gql`
    query GetMachineWithServicesById($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        ...ServicesFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ServicesFieldsFragmentDoc}`;

/**
 * __useGetMachineWithServicesByIdQuery__
 *
 * To run a query within a React component, call `useGetMachineWithServicesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineWithServicesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineWithServicesByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineWithServicesByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineWithServicesByIdQuery, GetMachineWithServicesByIdQueryVariables> & ({ variables: GetMachineWithServicesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineWithServicesByIdQuery, GetMachineWithServicesByIdQueryVariables>(GetMachineWithServicesByIdDocument, options);
      }
export function useGetMachineWithServicesByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineWithServicesByIdQuery, GetMachineWithServicesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineWithServicesByIdQuery, GetMachineWithServicesByIdQueryVariables>(GetMachineWithServicesByIdDocument, options);
        }
export function useGetMachineWithServicesByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineWithServicesByIdQuery, GetMachineWithServicesByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineWithServicesByIdQuery, GetMachineWithServicesByIdQueryVariables>(GetMachineWithServicesByIdDocument, options);
        }
export type GetMachineWithServicesByIdQueryHookResult = ReturnType<typeof useGetMachineWithServicesByIdQuery>;
export type GetMachineWithServicesByIdLazyQueryHookResult = ReturnType<typeof useGetMachineWithServicesByIdLazyQuery>;
export type GetMachineWithServicesByIdSuspenseQueryHookResult = ReturnType<typeof useGetMachineWithServicesByIdSuspenseQuery>;
export type GetMachineWithServicesByIdQueryResult = Apollo.QueryResult<GetMachineWithServicesByIdQuery, GetMachineWithServicesByIdQueryVariables>;
export const GetMachineWithNextServiceByIdDocument = gql`
    query GetMachineWithNextServiceById($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        ...MachineFields
        next_service: next_services(limit: 1) {
          ...NextServiceFields
        }
        open_preventive_maintenance_work_orders {
          id
          status
          type {
            id
            name
          }
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}
${NextServiceFieldsFragmentDoc}`;

/**
 * __useGetMachineWithNextServiceByIdQuery__
 *
 * To run a query within a React component, call `useGetMachineWithNextServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineWithNextServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineWithNextServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineWithNextServiceByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineWithNextServiceByIdQuery, GetMachineWithNextServiceByIdQueryVariables> & ({ variables: GetMachineWithNextServiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineWithNextServiceByIdQuery, GetMachineWithNextServiceByIdQueryVariables>(GetMachineWithNextServiceByIdDocument, options);
      }
export function useGetMachineWithNextServiceByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineWithNextServiceByIdQuery, GetMachineWithNextServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineWithNextServiceByIdQuery, GetMachineWithNextServiceByIdQueryVariables>(GetMachineWithNextServiceByIdDocument, options);
        }
export function useGetMachineWithNextServiceByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineWithNextServiceByIdQuery, GetMachineWithNextServiceByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineWithNextServiceByIdQuery, GetMachineWithNextServiceByIdQueryVariables>(GetMachineWithNextServiceByIdDocument, options);
        }
export type GetMachineWithNextServiceByIdQueryHookResult = ReturnType<typeof useGetMachineWithNextServiceByIdQuery>;
export type GetMachineWithNextServiceByIdLazyQueryHookResult = ReturnType<typeof useGetMachineWithNextServiceByIdLazyQuery>;
export type GetMachineWithNextServiceByIdSuspenseQueryHookResult = ReturnType<typeof useGetMachineWithNextServiceByIdSuspenseQuery>;
export type GetMachineWithNextServiceByIdQueryResult = Apollo.QueryResult<GetMachineWithNextServiceByIdQuery, GetMachineWithNextServiceByIdQueryVariables>;
export const GetNextServicesByMachineIdDocument = gql`
    query GetNextServicesByMachineId($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        id
        next_services {
          ...NextServiceFields
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${NextServiceFieldsFragmentDoc}`;

/**
 * __useGetNextServicesByMachineIdQuery__
 *
 * To run a query within a React component, call `useGetNextServicesByMachineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextServicesByMachineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextServicesByMachineIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNextServicesByMachineIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNextServicesByMachineIdQuery, GetNextServicesByMachineIdQueryVariables> & ({ variables: GetNextServicesByMachineIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNextServicesByMachineIdQuery, GetNextServicesByMachineIdQueryVariables>(GetNextServicesByMachineIdDocument, options);
      }
export function useGetNextServicesByMachineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNextServicesByMachineIdQuery, GetNextServicesByMachineIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNextServicesByMachineIdQuery, GetNextServicesByMachineIdQueryVariables>(GetNextServicesByMachineIdDocument, options);
        }
export function useGetNextServicesByMachineIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNextServicesByMachineIdQuery, GetNextServicesByMachineIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNextServicesByMachineIdQuery, GetNextServicesByMachineIdQueryVariables>(GetNextServicesByMachineIdDocument, options);
        }
export type GetNextServicesByMachineIdQueryHookResult = ReturnType<typeof useGetNextServicesByMachineIdQuery>;
export type GetNextServicesByMachineIdLazyQueryHookResult = ReturnType<typeof useGetNextServicesByMachineIdLazyQuery>;
export type GetNextServicesByMachineIdSuspenseQueryHookResult = ReturnType<typeof useGetNextServicesByMachineIdSuspenseQuery>;
export type GetNextServicesByMachineIdQueryResult = Apollo.QueryResult<GetNextServicesByMachineIdQuery, GetNextServicesByMachineIdQueryVariables>;
export const GetServiceSequenceByMachineIdDocument = gql`
    query GetServiceSequenceByMachineId($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        id
        service_sequence {
          ...ServiceSequenceItemFields
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ServiceSequenceItemFieldsFragmentDoc}`;

/**
 * __useGetServiceSequenceByMachineIdQuery__
 *
 * To run a query within a React component, call `useGetServiceSequenceByMachineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceSequenceByMachineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceSequenceByMachineIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceSequenceByMachineIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetServiceSequenceByMachineIdQuery, GetServiceSequenceByMachineIdQueryVariables> & ({ variables: GetServiceSequenceByMachineIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetServiceSequenceByMachineIdQuery, GetServiceSequenceByMachineIdQueryVariables>(GetServiceSequenceByMachineIdDocument, options);
      }
export function useGetServiceSequenceByMachineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetServiceSequenceByMachineIdQuery, GetServiceSequenceByMachineIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetServiceSequenceByMachineIdQuery, GetServiceSequenceByMachineIdQueryVariables>(GetServiceSequenceByMachineIdDocument, options);
        }
export function useGetServiceSequenceByMachineIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetServiceSequenceByMachineIdQuery, GetServiceSequenceByMachineIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetServiceSequenceByMachineIdQuery, GetServiceSequenceByMachineIdQueryVariables>(GetServiceSequenceByMachineIdDocument, options);
        }
export type GetServiceSequenceByMachineIdQueryHookResult = ReturnType<typeof useGetServiceSequenceByMachineIdQuery>;
export type GetServiceSequenceByMachineIdLazyQueryHookResult = ReturnType<typeof useGetServiceSequenceByMachineIdLazyQuery>;
export type GetServiceSequenceByMachineIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceSequenceByMachineIdSuspenseQuery>;
export type GetServiceSequenceByMachineIdQueryResult = Apollo.QueryResult<GetServiceSequenceByMachineIdQuery, GetServiceSequenceByMachineIdQueryVariables>;
export const GetServiceReportByIdDocument = gql`
    query GetServiceReportById($id: Int!) {
  getServiceReportById(id: $id) {
    ...ServiceReportFields
    files {
      id
      url
    }
  }
}
    ${ServiceReportFieldsFragmentDoc}`;

/**
 * __useGetServiceReportByIdQuery__
 *
 * To run a query within a React component, call `useGetServiceReportByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceReportByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceReportByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceReportByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetServiceReportByIdQuery, GetServiceReportByIdQueryVariables> & ({ variables: GetServiceReportByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetServiceReportByIdQuery, GetServiceReportByIdQueryVariables>(GetServiceReportByIdDocument, options);
      }
export function useGetServiceReportByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetServiceReportByIdQuery, GetServiceReportByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetServiceReportByIdQuery, GetServiceReportByIdQueryVariables>(GetServiceReportByIdDocument, options);
        }
export function useGetServiceReportByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetServiceReportByIdQuery, GetServiceReportByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetServiceReportByIdQuery, GetServiceReportByIdQueryVariables>(GetServiceReportByIdDocument, options);
        }
export type GetServiceReportByIdQueryHookResult = ReturnType<typeof useGetServiceReportByIdQuery>;
export type GetServiceReportByIdLazyQueryHookResult = ReturnType<typeof useGetServiceReportByIdLazyQuery>;
export type GetServiceReportByIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceReportByIdSuspenseQuery>;
export type GetServiceReportByIdQueryResult = Apollo.QueryResult<GetServiceReportByIdQuery, GetServiceReportByIdQueryVariables>;
export const SearchAdminUsersDocument = gql`
    query SearchAdminUsers($query: String, $filter: AdminUserFilter!, $company_id: Int, $pagination: OffsetPaginationInput) {
  searchAdminUsers(
    query: $query
    filter: $filter
    company_id: $company_id
    pagination: $pagination
  ) {
    items {
      ...AdminUserRowFields
    }
    counts {
      filter
      count
    }
    page_info {
      total_pages
      current_page
      total_items
      items_per_page
    }
    truncated
  }
}
    ${AdminUserRowFieldsFragmentDoc}`;

/**
 * __useSearchAdminUsersQuery__
 *
 * To run a query within a React component, call `useSearchAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAdminUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      company_id: // value for 'company_id'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchAdminUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAdminUsersQuery, SearchAdminUsersQueryVariables> & ({ variables: SearchAdminUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>(SearchAdminUsersDocument, options);
      }
export function useSearchAdminUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>(SearchAdminUsersDocument, options);
        }
export function useSearchAdminUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>(SearchAdminUsersDocument, options);
        }
export type SearchAdminUsersQueryHookResult = ReturnType<typeof useSearchAdminUsersQuery>;
export type SearchAdminUsersLazyQueryHookResult = ReturnType<typeof useSearchAdminUsersLazyQuery>;
export type SearchAdminUsersSuspenseQueryHookResult = ReturnType<typeof useSearchAdminUsersSuspenseQuery>;
export type SearchAdminUsersQueryResult = Apollo.QueryResult<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>;
export const ResendSignupConfirmationDocument = gql`
    mutation ResendSignupConfirmation($cognito_username: String!) {
  resendSignupConfirmation(cognito_username: $cognito_username)
}
    `;

/**
 * __useResendSignupConfirmationMutation__
 *
 * To run a mutation, you first call `useResendSignupConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSignupConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSignupConfirmationMutation, { data, loading, error }] = useResendSignupConfirmationMutation({
 *   variables: {
 *      cognito_username: // value for 'cognito_username'
 *   },
 * });
 */
export function useResendSignupConfirmationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendSignupConfirmationMutation, ResendSignupConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendSignupConfirmationMutation, ResendSignupConfirmationMutationVariables>(ResendSignupConfirmationDocument, options);
      }
export type ResendSignupConfirmationMutationHookResult = ReturnType<typeof useResendSignupConfirmationMutation>;
export type ResendSignupConfirmationMutationResult = Apollo.MutationResult<ResendSignupConfirmationMutation>;
export type ResendSignupConfirmationMutationOptions = Apollo.BaseMutationOptions<ResendSignupConfirmationMutation, ResendSignupConfirmationMutationVariables>;
export const UpdateUnconfirmedEmailDocument = gql`
    mutation UpdateUnconfirmedEmail($cognito_username: String!, $email: String!) {
  updateUnconfirmedEmail(cognito_username: $cognito_username, email: $email)
}
    `;

/**
 * __useUpdateUnconfirmedEmailMutation__
 *
 * To run a mutation, you first call `useUpdateUnconfirmedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnconfirmedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnconfirmedEmailMutation, { data, loading, error }] = useUpdateUnconfirmedEmailMutation({
 *   variables: {
 *      cognito_username: // value for 'cognito_username'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateUnconfirmedEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUnconfirmedEmailMutation, UpdateUnconfirmedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUnconfirmedEmailMutation, UpdateUnconfirmedEmailMutationVariables>(UpdateUnconfirmedEmailDocument, options);
      }
export type UpdateUnconfirmedEmailMutationHookResult = ReturnType<typeof useUpdateUnconfirmedEmailMutation>;
export type UpdateUnconfirmedEmailMutationResult = Apollo.MutationResult<UpdateUnconfirmedEmailMutation>;
export type UpdateUnconfirmedEmailMutationOptions = Apollo.BaseMutationOptions<UpdateUnconfirmedEmailMutation, UpdateUnconfirmedEmailMutationVariables>;
export const SignOutEverywhereDocument = gql`
    mutation SignOutEverywhere($cognito_username: String!) {
  signOutEverywhere(cognito_username: $cognito_username)
}
    `;

/**
 * __useSignOutEverywhereMutation__
 *
 * To run a mutation, you first call `useSignOutEverywhereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutEverywhereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutEverywhereMutation, { data, loading, error }] = useSignOutEverywhereMutation({
 *   variables: {
 *      cognito_username: // value for 'cognito_username'
 *   },
 * });
 */
export function useSignOutEverywhereMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignOutEverywhereMutation, SignOutEverywhereMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignOutEverywhereMutation, SignOutEverywhereMutationVariables>(SignOutEverywhereDocument, options);
      }
export type SignOutEverywhereMutationHookResult = ReturnType<typeof useSignOutEverywhereMutation>;
export type SignOutEverywhereMutationResult = Apollo.MutationResult<SignOutEverywhereMutation>;
export type SignOutEverywhereMutationOptions = Apollo.BaseMutationOptions<SignOutEverywhereMutation, SignOutEverywhereMutationVariables>;
export const RequestUserEmailChangeDocument = gql`
    mutation RequestUserEmailChange($user_id: Int!, $email: String!) {
  requestUserEmailChange(user_id: $user_id, email: $email)
}
    `;

/**
 * __useRequestUserEmailChangeMutation__
 *
 * To run a mutation, you first call `useRequestUserEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUserEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUserEmailChangeMutation, { data, loading, error }] = useRequestUserEmailChangeMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestUserEmailChangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestUserEmailChangeMutation, RequestUserEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestUserEmailChangeMutation, RequestUserEmailChangeMutationVariables>(RequestUserEmailChangeDocument, options);
      }
export type RequestUserEmailChangeMutationHookResult = ReturnType<typeof useRequestUserEmailChangeMutation>;
export type RequestUserEmailChangeMutationResult = Apollo.MutationResult<RequestUserEmailChangeMutation>;
export type RequestUserEmailChangeMutationOptions = Apollo.BaseMutationOptions<RequestUserEmailChangeMutation, RequestUserEmailChangeMutationVariables>;
export const CancelUserEmailChangeDocument = gql`
    mutation CancelUserEmailChange($user_id: Int!) {
  cancelUserEmailChange(user_id: $user_id)
}
    `;

/**
 * __useCancelUserEmailChangeMutation__
 *
 * To run a mutation, you first call `useCancelUserEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUserEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUserEmailChangeMutation, { data, loading, error }] = useCancelUserEmailChangeMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useCancelUserEmailChangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelUserEmailChangeMutation, CancelUserEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelUserEmailChangeMutation, CancelUserEmailChangeMutationVariables>(CancelUserEmailChangeDocument, options);
      }
export type CancelUserEmailChangeMutationHookResult = ReturnType<typeof useCancelUserEmailChangeMutation>;
export type CancelUserEmailChangeMutationResult = Apollo.MutationResult<CancelUserEmailChangeMutation>;
export type CancelUserEmailChangeMutationOptions = Apollo.BaseMutationOptions<CancelUserEmailChangeMutation, CancelUserEmailChangeMutationVariables>;
export const AdminUserDocument = gql`
    query AdminUser($user_id: Int, $cognito_username: String) {
  adminUser(user_id: $user_id, cognito_username: $cognito_username) {
    ...AdminUserDetailFields
  }
}
    ${AdminUserDetailFieldsFragmentDoc}`;

/**
 * __useAdminUserQuery__
 *
 * To run a query within a React component, call `useAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      cognito_username: // value for 'cognito_username'
 *   },
 * });
 */
export function useAdminUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
      }
export function useAdminUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
        }
export function useAdminUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
        }
export type AdminUserQueryHookResult = ReturnType<typeof useAdminUserQuery>;
export type AdminUserLazyQueryHookResult = ReturnType<typeof useAdminUserLazyQuery>;
export type AdminUserSuspenseQueryHookResult = ReturnType<typeof useAdminUserSuspenseQuery>;
export type AdminUserQueryResult = Apollo.QueryResult<AdminUserQuery, AdminUserQueryVariables>;
export const GetRentalParameterDefinitionsDocument = gql`
    query GetRentalParameterDefinitions {
  getRentalParameterDefinitions {
    ...RentalParameterDefinitionFields
  }
}
    ${RentalParameterDefinitionFieldsFragmentDoc}`;

/**
 * __useGetRentalParameterDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetRentalParameterDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalParameterDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalParameterDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRentalParameterDefinitionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRentalParameterDefinitionsQuery, GetRentalParameterDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRentalParameterDefinitionsQuery, GetRentalParameterDefinitionsQueryVariables>(GetRentalParameterDefinitionsDocument, options);
      }
export function useGetRentalParameterDefinitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRentalParameterDefinitionsQuery, GetRentalParameterDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRentalParameterDefinitionsQuery, GetRentalParameterDefinitionsQueryVariables>(GetRentalParameterDefinitionsDocument, options);
        }
export function useGetRentalParameterDefinitionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRentalParameterDefinitionsQuery, GetRentalParameterDefinitionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRentalParameterDefinitionsQuery, GetRentalParameterDefinitionsQueryVariables>(GetRentalParameterDefinitionsDocument, options);
        }
export type GetRentalParameterDefinitionsQueryHookResult = ReturnType<typeof useGetRentalParameterDefinitionsQuery>;
export type GetRentalParameterDefinitionsLazyQueryHookResult = ReturnType<typeof useGetRentalParameterDefinitionsLazyQuery>;
export type GetRentalParameterDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetRentalParameterDefinitionsSuspenseQuery>;
export type GetRentalParameterDefinitionsQueryResult = Apollo.QueryResult<GetRentalParameterDefinitionsQuery, GetRentalParameterDefinitionsQueryVariables>;
export const CreateRentalParameterDefinitionDocument = gql`
    mutation CreateRentalParameterDefinition($input: CreateRentalParameterDefinitionInput!) {
  createRentalParameterDefinition(input: $input) {
    ...RentalParameterDefinitionFields
  }
}
    ${RentalParameterDefinitionFieldsFragmentDoc}`;

/**
 * __useCreateRentalParameterDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateRentalParameterDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRentalParameterDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRentalParameterDefinitionMutation, { data, loading, error }] = useCreateRentalParameterDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRentalParameterDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRentalParameterDefinitionMutation, CreateRentalParameterDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRentalParameterDefinitionMutation, CreateRentalParameterDefinitionMutationVariables>(CreateRentalParameterDefinitionDocument, options);
      }
export type CreateRentalParameterDefinitionMutationHookResult = ReturnType<typeof useCreateRentalParameterDefinitionMutation>;
export type CreateRentalParameterDefinitionMutationResult = Apollo.MutationResult<CreateRentalParameterDefinitionMutation>;
export type CreateRentalParameterDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateRentalParameterDefinitionMutation, CreateRentalParameterDefinitionMutationVariables>;
export const UpdateRentalParameterDefinitionDocument = gql`
    mutation UpdateRentalParameterDefinition($id: Int!, $input: UpdateRentalParameterDefinitionInput!) {
  updateRentalParameterDefinition(id: $id, input: $input) {
    ...RentalParameterDefinitionFields
  }
}
    ${RentalParameterDefinitionFieldsFragmentDoc}`;

/**
 * __useUpdateRentalParameterDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateRentalParameterDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRentalParameterDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRentalParameterDefinitionMutation, { data, loading, error }] = useUpdateRentalParameterDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRentalParameterDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRentalParameterDefinitionMutation, UpdateRentalParameterDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRentalParameterDefinitionMutation, UpdateRentalParameterDefinitionMutationVariables>(UpdateRentalParameterDefinitionDocument, options);
      }
export type UpdateRentalParameterDefinitionMutationHookResult = ReturnType<typeof useUpdateRentalParameterDefinitionMutation>;
export type UpdateRentalParameterDefinitionMutationResult = Apollo.MutationResult<UpdateRentalParameterDefinitionMutation>;
export type UpdateRentalParameterDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateRentalParameterDefinitionMutation, UpdateRentalParameterDefinitionMutationVariables>;
export const DeleteRentalParameterDefinitionDocument = gql`
    mutation DeleteRentalParameterDefinition($id: Int!) {
  deleteRentalParameterDefinition(id: $id) {
    result
  }
}
    `;

/**
 * __useDeleteRentalParameterDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteRentalParameterDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRentalParameterDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRentalParameterDefinitionMutation, { data, loading, error }] = useDeleteRentalParameterDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRentalParameterDefinitionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRentalParameterDefinitionMutation, DeleteRentalParameterDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRentalParameterDefinitionMutation, DeleteRentalParameterDefinitionMutationVariables>(DeleteRentalParameterDefinitionDocument, options);
      }
export type DeleteRentalParameterDefinitionMutationHookResult = ReturnType<typeof useDeleteRentalParameterDefinitionMutation>;
export type DeleteRentalParameterDefinitionMutationResult = Apollo.MutationResult<DeleteRentalParameterDefinitionMutation>;
export type DeleteRentalParameterDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteRentalParameterDefinitionMutation, DeleteRentalParameterDefinitionMutationVariables>;
export const GetRentalParameterEffectiveValuesByScopeDocument = gql`
    query GetRentalParameterEffectiveValuesByScope($scope: GetRentalParameterByScopeInput!) {
  getRentalParameterEffectiveValuesByScope(scope: $scope) {
    items {
      ...RentalParameterEffectiveValueFields
    }
  }
}
    ${RentalParameterEffectiveValueFieldsFragmentDoc}`;

/**
 * __useGetRentalParameterEffectiveValuesByScopeQuery__
 *
 * To run a query within a React component, call `useGetRentalParameterEffectiveValuesByScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalParameterEffectiveValuesByScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalParameterEffectiveValuesByScopeQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetRentalParameterEffectiveValuesByScopeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRentalParameterEffectiveValuesByScopeQuery, GetRentalParameterEffectiveValuesByScopeQueryVariables> & ({ variables: GetRentalParameterEffectiveValuesByScopeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRentalParameterEffectiveValuesByScopeQuery, GetRentalParameterEffectiveValuesByScopeQueryVariables>(GetRentalParameterEffectiveValuesByScopeDocument, options);
      }
export function useGetRentalParameterEffectiveValuesByScopeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRentalParameterEffectiveValuesByScopeQuery, GetRentalParameterEffectiveValuesByScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRentalParameterEffectiveValuesByScopeQuery, GetRentalParameterEffectiveValuesByScopeQueryVariables>(GetRentalParameterEffectiveValuesByScopeDocument, options);
        }
export function useGetRentalParameterEffectiveValuesByScopeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRentalParameterEffectiveValuesByScopeQuery, GetRentalParameterEffectiveValuesByScopeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRentalParameterEffectiveValuesByScopeQuery, GetRentalParameterEffectiveValuesByScopeQueryVariables>(GetRentalParameterEffectiveValuesByScopeDocument, options);
        }
export type GetRentalParameterEffectiveValuesByScopeQueryHookResult = ReturnType<typeof useGetRentalParameterEffectiveValuesByScopeQuery>;
export type GetRentalParameterEffectiveValuesByScopeLazyQueryHookResult = ReturnType<typeof useGetRentalParameterEffectiveValuesByScopeLazyQuery>;
export type GetRentalParameterEffectiveValuesByScopeSuspenseQueryHookResult = ReturnType<typeof useGetRentalParameterEffectiveValuesByScopeSuspenseQuery>;
export type GetRentalParameterEffectiveValuesByScopeQueryResult = Apollo.QueryResult<GetRentalParameterEffectiveValuesByScopeQuery, GetRentalParameterEffectiveValuesByScopeQueryVariables>;
export const GetRentalParameterEffectiveValuesByMachineIdsDocument = gql`
    query GetRentalParameterEffectiveValuesByMachineIds($machine_ids: [Int!]!, $project_id: Int) {
  getRentalParameterEffectiveValuesByMachineIds(
    machine_ids: $machine_ids
    project_id: $project_id
  ) {
    items {
      ...MachineWithEffectiveParameterValuesFields
    }
  }
}
    ${MachineWithEffectiveParameterValuesFieldsFragmentDoc}`;

/**
 * __useGetRentalParameterEffectiveValuesByMachineIdsQuery__
 *
 * To run a query within a React component, call `useGetRentalParameterEffectiveValuesByMachineIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalParameterEffectiveValuesByMachineIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalParameterEffectiveValuesByMachineIdsQuery({
 *   variables: {
 *      machine_ids: // value for 'machine_ids'
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useGetRentalParameterEffectiveValuesByMachineIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRentalParameterEffectiveValuesByMachineIdsQuery, GetRentalParameterEffectiveValuesByMachineIdsQueryVariables> & ({ variables: GetRentalParameterEffectiveValuesByMachineIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRentalParameterEffectiveValuesByMachineIdsQuery, GetRentalParameterEffectiveValuesByMachineIdsQueryVariables>(GetRentalParameterEffectiveValuesByMachineIdsDocument, options);
      }
export function useGetRentalParameterEffectiveValuesByMachineIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRentalParameterEffectiveValuesByMachineIdsQuery, GetRentalParameterEffectiveValuesByMachineIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRentalParameterEffectiveValuesByMachineIdsQuery, GetRentalParameterEffectiveValuesByMachineIdsQueryVariables>(GetRentalParameterEffectiveValuesByMachineIdsDocument, options);
        }
export function useGetRentalParameterEffectiveValuesByMachineIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRentalParameterEffectiveValuesByMachineIdsQuery, GetRentalParameterEffectiveValuesByMachineIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRentalParameterEffectiveValuesByMachineIdsQuery, GetRentalParameterEffectiveValuesByMachineIdsQueryVariables>(GetRentalParameterEffectiveValuesByMachineIdsDocument, options);
        }
export type GetRentalParameterEffectiveValuesByMachineIdsQueryHookResult = ReturnType<typeof useGetRentalParameterEffectiveValuesByMachineIdsQuery>;
export type GetRentalParameterEffectiveValuesByMachineIdsLazyQueryHookResult = ReturnType<typeof useGetRentalParameterEffectiveValuesByMachineIdsLazyQuery>;
export type GetRentalParameterEffectiveValuesByMachineIdsSuspenseQueryHookResult = ReturnType<typeof useGetRentalParameterEffectiveValuesByMachineIdsSuspenseQuery>;
export type GetRentalParameterEffectiveValuesByMachineIdsQueryResult = Apollo.QueryResult<GetRentalParameterEffectiveValuesByMachineIdsQuery, GetRentalParameterEffectiveValuesByMachineIdsQueryVariables>;
export const SetRentalParameterValuesDocument = gql`
    mutation SetRentalParameterValues($input: [SetRentalParameterValueInput!]!) {
  setRentalParameterValues(input: $input) {
    success
    updated_count
  }
}
    `;

/**
 * __useSetRentalParameterValuesMutation__
 *
 * To run a mutation, you first call `useSetRentalParameterValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRentalParameterValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRentalParameterValuesMutation, { data, loading, error }] = useSetRentalParameterValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRentalParameterValuesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetRentalParameterValuesMutation, SetRentalParameterValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetRentalParameterValuesMutation, SetRentalParameterValuesMutationVariables>(SetRentalParameterValuesDocument, options);
      }
export type SetRentalParameterValuesMutationHookResult = ReturnType<typeof useSetRentalParameterValuesMutation>;
export type SetRentalParameterValuesMutationResult = Apollo.MutationResult<SetRentalParameterValuesMutation>;
export type SetRentalParameterValuesMutationOptions = Apollo.BaseMutationOptions<SetRentalParameterValuesMutation, SetRentalParameterValuesMutationVariables>;
export const DeleteRentalParameterValuesDocument = gql`
    mutation DeleteRentalParameterValues($ids: [Int!]!) {
  deleteRentalParameterValues(ids: $ids) {
    success
    deleted_count
  }
}
    `;

/**
 * __useDeleteRentalParameterValuesMutation__
 *
 * To run a mutation, you first call `useDeleteRentalParameterValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRentalParameterValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRentalParameterValuesMutation, { data, loading, error }] = useDeleteRentalParameterValuesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteRentalParameterValuesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRentalParameterValuesMutation, DeleteRentalParameterValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRentalParameterValuesMutation, DeleteRentalParameterValuesMutationVariables>(DeleteRentalParameterValuesDocument, options);
      }
export type DeleteRentalParameterValuesMutationHookResult = ReturnType<typeof useDeleteRentalParameterValuesMutation>;
export type DeleteRentalParameterValuesMutationResult = Apollo.MutationResult<DeleteRentalParameterValuesMutation>;
export type DeleteRentalParameterValuesMutationOptions = Apollo.BaseMutationOptions<DeleteRentalParameterValuesMutation, DeleteRentalParameterValuesMutationVariables>;
export const GetIntegrationSyncRunsDocument = gql`
    query GetIntegrationSyncRuns($connection_id: ID!, $limit: Int) {
  getIntegrationSyncRuns(connection_id: $connection_id, limit: $limit) {
    id
    connection_id
    capability
    status
    started_at
    finished_at
    summary
  }
}
    `;

/**
 * __useGetIntegrationSyncRunsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationSyncRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationSyncRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationSyncRunsQuery({
 *   variables: {
 *      connection_id: // value for 'connection_id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetIntegrationSyncRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIntegrationSyncRunsQuery, GetIntegrationSyncRunsQueryVariables> & ({ variables: GetIntegrationSyncRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationSyncRunsQuery, GetIntegrationSyncRunsQueryVariables>(GetIntegrationSyncRunsDocument, options);
      }
export function useGetIntegrationSyncRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntegrationSyncRunsQuery, GetIntegrationSyncRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationSyncRunsQuery, GetIntegrationSyncRunsQueryVariables>(GetIntegrationSyncRunsDocument, options);
        }
export function useGetIntegrationSyncRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationSyncRunsQuery, GetIntegrationSyncRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationSyncRunsQuery, GetIntegrationSyncRunsQueryVariables>(GetIntegrationSyncRunsDocument, options);
        }
export type GetIntegrationSyncRunsQueryHookResult = ReturnType<typeof useGetIntegrationSyncRunsQuery>;
export type GetIntegrationSyncRunsLazyQueryHookResult = ReturnType<typeof useGetIntegrationSyncRunsLazyQuery>;
export type GetIntegrationSyncRunsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationSyncRunsSuspenseQuery>;
export type GetIntegrationSyncRunsQueryResult = Apollo.QueryResult<GetIntegrationSyncRunsQuery, GetIntegrationSyncRunsQueryVariables>;
export const GetIntegrationSyncRunReportDocument = gql`
    query GetIntegrationSyncRunReport($id: ID!) {
  getIntegrationSyncRunReport(id: $id)
}
    `;

/**
 * __useGetIntegrationSyncRunReportQuery__
 *
 * To run a query within a React component, call `useGetIntegrationSyncRunReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationSyncRunReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationSyncRunReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationSyncRunReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIntegrationSyncRunReportQuery, GetIntegrationSyncRunReportQueryVariables> & ({ variables: GetIntegrationSyncRunReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationSyncRunReportQuery, GetIntegrationSyncRunReportQueryVariables>(GetIntegrationSyncRunReportDocument, options);
      }
export function useGetIntegrationSyncRunReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntegrationSyncRunReportQuery, GetIntegrationSyncRunReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationSyncRunReportQuery, GetIntegrationSyncRunReportQueryVariables>(GetIntegrationSyncRunReportDocument, options);
        }
export function useGetIntegrationSyncRunReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationSyncRunReportQuery, GetIntegrationSyncRunReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationSyncRunReportQuery, GetIntegrationSyncRunReportQueryVariables>(GetIntegrationSyncRunReportDocument, options);
        }
export type GetIntegrationSyncRunReportQueryHookResult = ReturnType<typeof useGetIntegrationSyncRunReportQuery>;
export type GetIntegrationSyncRunReportLazyQueryHookResult = ReturnType<typeof useGetIntegrationSyncRunReportLazyQuery>;
export type GetIntegrationSyncRunReportSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationSyncRunReportSuspenseQuery>;
export type GetIntegrationSyncRunReportQueryResult = Apollo.QueryResult<GetIntegrationSyncRunReportQuery, GetIntegrationSyncRunReportQueryVariables>;
export const TriggerFleetSyncDocument = gql`
    mutation TriggerFleetSync($company_id: Int!, $dry_run: Boolean!) {
  triggerFleetSync(company_id: $company_id, dry_run: $dry_run) {
    run_id
  }
}
    `;

/**
 * __useTriggerFleetSyncMutation__
 *
 * To run a mutation, you first call `useTriggerFleetSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerFleetSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerFleetSyncMutation, { data, loading, error }] = useTriggerFleetSyncMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      dry_run: // value for 'dry_run'
 *   },
 * });
 */
export function useTriggerFleetSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerFleetSyncMutation, TriggerFleetSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerFleetSyncMutation, TriggerFleetSyncMutationVariables>(TriggerFleetSyncDocument, options);
      }
export type TriggerFleetSyncMutationHookResult = ReturnType<typeof useTriggerFleetSyncMutation>;
export type TriggerFleetSyncMutationResult = Apollo.MutationResult<TriggerFleetSyncMutation>;
export type TriggerFleetSyncMutationOptions = Apollo.BaseMutationOptions<TriggerFleetSyncMutation, TriggerFleetSyncMutationVariables>;
export const GetCompanyIntegrationsDocument = gql`
    query GetCompanyIntegrations {
  getCompanyIntegrations {
    ...CompanyIntegrationFields
  }
}
    ${CompanyIntegrationFieldsFragmentDoc}`;

/**
 * __useGetCompanyIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetCompanyIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyIntegrationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyIntegrationsQuery, GetCompanyIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyIntegrationsQuery, GetCompanyIntegrationsQueryVariables>(GetCompanyIntegrationsDocument, options);
      }
export function useGetCompanyIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyIntegrationsQuery, GetCompanyIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyIntegrationsQuery, GetCompanyIntegrationsQueryVariables>(GetCompanyIntegrationsDocument, options);
        }
export function useGetCompanyIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyIntegrationsQuery, GetCompanyIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyIntegrationsQuery, GetCompanyIntegrationsQueryVariables>(GetCompanyIntegrationsDocument, options);
        }
export type GetCompanyIntegrationsQueryHookResult = ReturnType<typeof useGetCompanyIntegrationsQuery>;
export type GetCompanyIntegrationsLazyQueryHookResult = ReturnType<typeof useGetCompanyIntegrationsLazyQuery>;
export type GetCompanyIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyIntegrationsSuspenseQuery>;
export type GetCompanyIntegrationsQueryResult = Apollo.QueryResult<GetCompanyIntegrationsQuery, GetCompanyIntegrationsQueryVariables>;
export const UpsertCompanyIntegrationDocument = gql`
    mutation UpsertCompanyIntegration($input: UpsertCompanyIntegrationInput!) {
  upsertCompanyIntegration(input: $input) {
    ...CompanyIntegrationFields
  }
}
    ${CompanyIntegrationFieldsFragmentDoc}`;

/**
 * __useUpsertCompanyIntegrationMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyIntegrationMutation, { data, loading, error }] = useUpsertCompanyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCompanyIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertCompanyIntegrationMutation, UpsertCompanyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertCompanyIntegrationMutation, UpsertCompanyIntegrationMutationVariables>(UpsertCompanyIntegrationDocument, options);
      }
export type UpsertCompanyIntegrationMutationHookResult = ReturnType<typeof useUpsertCompanyIntegrationMutation>;
export type UpsertCompanyIntegrationMutationResult = Apollo.MutationResult<UpsertCompanyIntegrationMutation>;
export type UpsertCompanyIntegrationMutationOptions = Apollo.BaseMutationOptions<UpsertCompanyIntegrationMutation, UpsertCompanyIntegrationMutationVariables>;
export const DeleteCompanyIntegrationDocument = gql`
    mutation DeleteCompanyIntegration($id: ID!) {
  deleteCompanyIntegration(id: $id)
}
    `;

/**
 * __useDeleteCompanyIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyIntegrationMutation, { data, loading, error }] = useDeleteCompanyIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCompanyIntegrationMutation, DeleteCompanyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCompanyIntegrationMutation, DeleteCompanyIntegrationMutationVariables>(DeleteCompanyIntegrationDocument, options);
      }
export type DeleteCompanyIntegrationMutationHookResult = ReturnType<typeof useDeleteCompanyIntegrationMutation>;
export type DeleteCompanyIntegrationMutationResult = Apollo.MutationResult<DeleteCompanyIntegrationMutation>;
export type DeleteCompanyIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyIntegrationMutation, DeleteCompanyIntegrationMutationVariables>;
export const TriggerCompanyIntegrationSyncDocument = gql`
    mutation TriggerCompanyIntegrationSync($id: ID!) {
  triggerCompanyIntegrationSync(id: $id) {
    ...CompanyIntegrationFields
  }
}
    ${CompanyIntegrationFieldsFragmentDoc}`;

/**
 * __useTriggerCompanyIntegrationSyncMutation__
 *
 * To run a mutation, you first call `useTriggerCompanyIntegrationSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCompanyIntegrationSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCompanyIntegrationSyncMutation, { data, loading, error }] = useTriggerCompanyIntegrationSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerCompanyIntegrationSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerCompanyIntegrationSyncMutation, TriggerCompanyIntegrationSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerCompanyIntegrationSyncMutation, TriggerCompanyIntegrationSyncMutationVariables>(TriggerCompanyIntegrationSyncDocument, options);
      }
export type TriggerCompanyIntegrationSyncMutationHookResult = ReturnType<typeof useTriggerCompanyIntegrationSyncMutation>;
export type TriggerCompanyIntegrationSyncMutationResult = Apollo.MutationResult<TriggerCompanyIntegrationSyncMutation>;
export type TriggerCompanyIntegrationSyncMutationOptions = Apollo.BaseMutationOptions<TriggerCompanyIntegrationSyncMutation, TriggerCompanyIntegrationSyncMutationVariables>;
export const GetIntegrationProvidersDocument = gql`
    query GetIntegrationProviders {
  getIntegrationProviders {
    provider
    fields {
      key
      label
      field_type
      options
      default_value
      visible_when {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetIntegrationProvidersQuery__
 *
 * To run a query within a React component, call `useGetIntegrationProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationProvidersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>(GetIntegrationProvidersDocument, options);
      }
export function useGetIntegrationProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>(GetIntegrationProvidersDocument, options);
        }
export function useGetIntegrationProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>(GetIntegrationProvidersDocument, options);
        }
export type GetIntegrationProvidersQueryHookResult = ReturnType<typeof useGetIntegrationProvidersQuery>;
export type GetIntegrationProvidersLazyQueryHookResult = ReturnType<typeof useGetIntegrationProvidersLazyQuery>;
export type GetIntegrationProvidersSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationProvidersSuspenseQuery>;
export type GetIntegrationProvidersQueryResult = Apollo.QueryResult<GetIntegrationProvidersQuery, GetIntegrationProvidersQueryVariables>;
export const GetVisionLinkReportsByDateDocument = gql`
    query GetVisionLinkReportsByDate($input: VisionLinkReportsByDateInput!) {
  getVisionLinkReportsByDate(input: $input) {
    ...VisionLinkReportsByDateFields
  }
}
    ${VisionLinkReportsByDateFieldsFragmentDoc}`;

/**
 * __useGetVisionLinkReportsByDateQuery__
 *
 * To run a query within a React component, call `useGetVisionLinkReportsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisionLinkReportsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisionLinkReportsByDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVisionLinkReportsByDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVisionLinkReportsByDateQuery, GetVisionLinkReportsByDateQueryVariables> & ({ variables: GetVisionLinkReportsByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVisionLinkReportsByDateQuery, GetVisionLinkReportsByDateQueryVariables>(GetVisionLinkReportsByDateDocument, options);
      }
export function useGetVisionLinkReportsByDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVisionLinkReportsByDateQuery, GetVisionLinkReportsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVisionLinkReportsByDateQuery, GetVisionLinkReportsByDateQueryVariables>(GetVisionLinkReportsByDateDocument, options);
        }
export function useGetVisionLinkReportsByDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVisionLinkReportsByDateQuery, GetVisionLinkReportsByDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVisionLinkReportsByDateQuery, GetVisionLinkReportsByDateQueryVariables>(GetVisionLinkReportsByDateDocument, options);
        }
export type GetVisionLinkReportsByDateQueryHookResult = ReturnType<typeof useGetVisionLinkReportsByDateQuery>;
export type GetVisionLinkReportsByDateLazyQueryHookResult = ReturnType<typeof useGetVisionLinkReportsByDateLazyQuery>;
export type GetVisionLinkReportsByDateSuspenseQueryHookResult = ReturnType<typeof useGetVisionLinkReportsByDateSuspenseQuery>;
export type GetVisionLinkReportsByDateQueryResult = Apollo.QueryResult<GetVisionLinkReportsByDateQuery, GetVisionLinkReportsByDateQueryVariables>;
export const ReprocessVisionLinkReportsByDateDocument = gql`
    mutation ReprocessVisionLinkReportsByDate($input: VisionLinkReportsByDateInput!) {
  reprocessVisionLinkReportsByDate(input: $input) {
    ...VisionLinkReportsByDateFields
  }
}
    ${VisionLinkReportsByDateFieldsFragmentDoc}`;

/**
 * __useReprocessVisionLinkReportsByDateMutation__
 *
 * To run a mutation, you first call `useReprocessVisionLinkReportsByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessVisionLinkReportsByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessVisionLinkReportsByDateMutation, { data, loading, error }] = useReprocessVisionLinkReportsByDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReprocessVisionLinkReportsByDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReprocessVisionLinkReportsByDateMutation, ReprocessVisionLinkReportsByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReprocessVisionLinkReportsByDateMutation, ReprocessVisionLinkReportsByDateMutationVariables>(ReprocessVisionLinkReportsByDateDocument, options);
      }
export type ReprocessVisionLinkReportsByDateMutationHookResult = ReturnType<typeof useReprocessVisionLinkReportsByDateMutation>;
export type ReprocessVisionLinkReportsByDateMutationResult = Apollo.MutationResult<ReprocessVisionLinkReportsByDateMutation>;
export type ReprocessVisionLinkReportsByDateMutationOptions = Apollo.BaseMutationOptions<ReprocessVisionLinkReportsByDateMutation, ReprocessVisionLinkReportsByDateMutationVariables>;
export const PublicApiClientsDocument = gql`
    query PublicApiClients {
  publicApiClients {
    ...PublicApiClientFields
  }
}
    ${PublicApiClientFieldsFragmentDoc}`;

/**
 * __usePublicApiClientsQuery__
 *
 * To run a query within a React component, call `usePublicApiClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicApiClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicApiClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicApiClientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicApiClientsQuery, PublicApiClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicApiClientsQuery, PublicApiClientsQueryVariables>(PublicApiClientsDocument, options);
      }
export function usePublicApiClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicApiClientsQuery, PublicApiClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicApiClientsQuery, PublicApiClientsQueryVariables>(PublicApiClientsDocument, options);
        }
export function usePublicApiClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicApiClientsQuery, PublicApiClientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicApiClientsQuery, PublicApiClientsQueryVariables>(PublicApiClientsDocument, options);
        }
export type PublicApiClientsQueryHookResult = ReturnType<typeof usePublicApiClientsQuery>;
export type PublicApiClientsLazyQueryHookResult = ReturnType<typeof usePublicApiClientsLazyQuery>;
export type PublicApiClientsSuspenseQueryHookResult = ReturnType<typeof usePublicApiClientsSuspenseQuery>;
export type PublicApiClientsQueryResult = Apollo.QueryResult<PublicApiClientsQuery, PublicApiClientsQueryVariables>;
export const CreatePublicApiClientDocument = gql`
    mutation CreatePublicApiClient($input: CreatePublicApiClientInput!) {
  createPublicApiClient(input: $input) {
    ...PublicApiClientFields
  }
}
    ${PublicApiClientFieldsFragmentDoc}`;

/**
 * __useCreatePublicApiClientMutation__
 *
 * To run a mutation, you first call `useCreatePublicApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicApiClientMutation, { data, loading, error }] = useCreatePublicApiClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePublicApiClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePublicApiClientMutation, CreatePublicApiClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePublicApiClientMutation, CreatePublicApiClientMutationVariables>(CreatePublicApiClientDocument, options);
      }
export type CreatePublicApiClientMutationHookResult = ReturnType<typeof useCreatePublicApiClientMutation>;
export type CreatePublicApiClientMutationResult = Apollo.MutationResult<CreatePublicApiClientMutation>;
export type CreatePublicApiClientMutationOptions = Apollo.BaseMutationOptions<CreatePublicApiClientMutation, CreatePublicApiClientMutationVariables>;
export const UpdatePublicApiClientDocument = gql`
    mutation UpdatePublicApiClient($id: Int!, $companyId: Int!, $input: UpdatePublicApiClientInput!) {
  updatePublicApiClient(id: $id, companyId: $companyId, input: $input) {
    ...PublicApiClientFields
  }
}
    ${PublicApiClientFieldsFragmentDoc}`;

/**
 * __useUpdatePublicApiClientMutation__
 *
 * To run a mutation, you first call `useUpdatePublicApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicApiClientMutation, { data, loading, error }] = useUpdatePublicApiClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePublicApiClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePublicApiClientMutation, UpdatePublicApiClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePublicApiClientMutation, UpdatePublicApiClientMutationVariables>(UpdatePublicApiClientDocument, options);
      }
export type UpdatePublicApiClientMutationHookResult = ReturnType<typeof useUpdatePublicApiClientMutation>;
export type UpdatePublicApiClientMutationResult = Apollo.MutationResult<UpdatePublicApiClientMutation>;
export type UpdatePublicApiClientMutationOptions = Apollo.BaseMutationOptions<UpdatePublicApiClientMutation, UpdatePublicApiClientMutationVariables>;
export const IssuePublicApiKeyDocument = gql`
    mutation IssuePublicApiKey($companyId: Int!, $clientId: Int!, $expiresAt: DateTime) {
  issuePublicApiKey(
    companyId: $companyId
    clientId: $clientId
    expiresAt: $expiresAt
  ) {
    key {
      ...PublicApiKeyFields
    }
    secret
  }
}
    ${PublicApiKeyFieldsFragmentDoc}`;

/**
 * __useIssuePublicApiKeyMutation__
 *
 * To run a mutation, you first call `useIssuePublicApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssuePublicApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issuePublicApiKeyMutation, { data, loading, error }] = useIssuePublicApiKeyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useIssuePublicApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IssuePublicApiKeyMutation, IssuePublicApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IssuePublicApiKeyMutation, IssuePublicApiKeyMutationVariables>(IssuePublicApiKeyDocument, options);
      }
export type IssuePublicApiKeyMutationHookResult = ReturnType<typeof useIssuePublicApiKeyMutation>;
export type IssuePublicApiKeyMutationResult = Apollo.MutationResult<IssuePublicApiKeyMutation>;
export type IssuePublicApiKeyMutationOptions = Apollo.BaseMutationOptions<IssuePublicApiKeyMutation, IssuePublicApiKeyMutationVariables>;
export const RotatePublicApiKeyDocument = gql`
    mutation RotatePublicApiKey($companyId: Int!, $keyId: Int!, $windowDays: Int) {
  rotatePublicApiKey(
    companyId: $companyId
    keyId: $keyId
    windowDays: $windowDays
  ) {
    key {
      ...PublicApiKeyFields
    }
    secret
  }
}
    ${PublicApiKeyFieldsFragmentDoc}`;

/**
 * __useRotatePublicApiKeyMutation__
 *
 * To run a mutation, you first call `useRotatePublicApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotatePublicApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotatePublicApiKeyMutation, { data, loading, error }] = useRotatePublicApiKeyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      keyId: // value for 'keyId'
 *      windowDays: // value for 'windowDays'
 *   },
 * });
 */
export function useRotatePublicApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RotatePublicApiKeyMutation, RotatePublicApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RotatePublicApiKeyMutation, RotatePublicApiKeyMutationVariables>(RotatePublicApiKeyDocument, options);
      }
export type RotatePublicApiKeyMutationHookResult = ReturnType<typeof useRotatePublicApiKeyMutation>;
export type RotatePublicApiKeyMutationResult = Apollo.MutationResult<RotatePublicApiKeyMutation>;
export type RotatePublicApiKeyMutationOptions = Apollo.BaseMutationOptions<RotatePublicApiKeyMutation, RotatePublicApiKeyMutationVariables>;
export const SetPublicApiKeyExpiryDocument = gql`
    mutation SetPublicApiKeyExpiry($companyId: Int!, $keyId: Int!, $expiresAt: DateTime) {
  setPublicApiKeyExpiry(
    companyId: $companyId
    keyId: $keyId
    expiresAt: $expiresAt
  ) {
    ...PublicApiKeyFields
  }
}
    ${PublicApiKeyFieldsFragmentDoc}`;

/**
 * __useSetPublicApiKeyExpiryMutation__
 *
 * To run a mutation, you first call `useSetPublicApiKeyExpiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPublicApiKeyExpiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPublicApiKeyExpiryMutation, { data, loading, error }] = useSetPublicApiKeyExpiryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      keyId: // value for 'keyId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useSetPublicApiKeyExpiryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPublicApiKeyExpiryMutation, SetPublicApiKeyExpiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPublicApiKeyExpiryMutation, SetPublicApiKeyExpiryMutationVariables>(SetPublicApiKeyExpiryDocument, options);
      }
export type SetPublicApiKeyExpiryMutationHookResult = ReturnType<typeof useSetPublicApiKeyExpiryMutation>;
export type SetPublicApiKeyExpiryMutationResult = Apollo.MutationResult<SetPublicApiKeyExpiryMutation>;
export type SetPublicApiKeyExpiryMutationOptions = Apollo.BaseMutationOptions<SetPublicApiKeyExpiryMutation, SetPublicApiKeyExpiryMutationVariables>;
export const RevokePublicApiKeyDocument = gql`
    mutation RevokePublicApiKey($companyId: Int!, $keyId: Int!, $reason: PublicApiKeyRevocationReason!, $comment: String) {
  revokePublicApiKey(
    companyId: $companyId
    keyId: $keyId
    reason: $reason
    comment: $comment
  ) {
    ...PublicApiKeyFields
  }
}
    ${PublicApiKeyFieldsFragmentDoc}`;

/**
 * __useRevokePublicApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokePublicApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokePublicApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokePublicApiKeyMutation, { data, loading, error }] = useRevokePublicApiKeyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      keyId: // value for 'keyId'
 *      reason: // value for 'reason'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRevokePublicApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokePublicApiKeyMutation, RevokePublicApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokePublicApiKeyMutation, RevokePublicApiKeyMutationVariables>(RevokePublicApiKeyDocument, options);
      }
export type RevokePublicApiKeyMutationHookResult = ReturnType<typeof useRevokePublicApiKeyMutation>;
export type RevokePublicApiKeyMutationResult = Apollo.MutationResult<RevokePublicApiKeyMutation>;
export type RevokePublicApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokePublicApiKeyMutation, RevokePublicApiKeyMutationVariables>;
export const GetPushAdminStatsDocument = gql`
    query GetPushAdminStats {
  getPushAdminStats {
    totalSubscriptions
    activeSubscriptions
    distinctUsers
    optOutCount
    byPlatform {
      platform
      total
      active
    }
    byTopic {
      topic
      rows
      companyWide
      companies
    }
  }
}
    `;

/**
 * __useGetPushAdminStatsQuery__
 *
 * To run a query within a React component, call `useGetPushAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushAdminStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPushAdminStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPushAdminStatsQuery, GetPushAdminStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPushAdminStatsQuery, GetPushAdminStatsQueryVariables>(GetPushAdminStatsDocument, options);
      }
export function useGetPushAdminStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPushAdminStatsQuery, GetPushAdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPushAdminStatsQuery, GetPushAdminStatsQueryVariables>(GetPushAdminStatsDocument, options);
        }
export function useGetPushAdminStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPushAdminStatsQuery, GetPushAdminStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPushAdminStatsQuery, GetPushAdminStatsQueryVariables>(GetPushAdminStatsDocument, options);
        }
export type GetPushAdminStatsQueryHookResult = ReturnType<typeof useGetPushAdminStatsQuery>;
export type GetPushAdminStatsLazyQueryHookResult = ReturnType<typeof useGetPushAdminStatsLazyQuery>;
export type GetPushAdminStatsSuspenseQueryHookResult = ReturnType<typeof useGetPushAdminStatsSuspenseQuery>;
export type GetPushAdminStatsQueryResult = Apollo.QueryResult<GetPushAdminStatsQuery, GetPushAdminStatsQueryVariables>;
export const LinkTelemetryDevicesToCompanyDocument = gql`
    mutation LinkTelemetryDevicesToCompany($companyId: Int!, $deviceIds: [ID!]!) {
  linkTelemetryDevicesToCompany(companyId: $companyId, deviceIds: $deviceIds) {
    __typename
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useLinkTelemetryDevicesToCompanyMutation__
 *
 * To run a mutation, you first call `useLinkTelemetryDevicesToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTelemetryDevicesToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTelemetryDevicesToCompanyMutation, { data, loading, error }] = useLinkTelemetryDevicesToCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      deviceIds: // value for 'deviceIds'
 *   },
 * });
 */
export function useLinkTelemetryDevicesToCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkTelemetryDevicesToCompanyMutation, LinkTelemetryDevicesToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkTelemetryDevicesToCompanyMutation, LinkTelemetryDevicesToCompanyMutationVariables>(LinkTelemetryDevicesToCompanyDocument, options);
      }
export type LinkTelemetryDevicesToCompanyMutationHookResult = ReturnType<typeof useLinkTelemetryDevicesToCompanyMutation>;
export type LinkTelemetryDevicesToCompanyMutationResult = Apollo.MutationResult<LinkTelemetryDevicesToCompanyMutation>;
export type LinkTelemetryDevicesToCompanyMutationOptions = Apollo.BaseMutationOptions<LinkTelemetryDevicesToCompanyMutation, LinkTelemetryDevicesToCompanyMutationVariables>;
export const RemoveTelemetryDeviceLinksDocument = gql`
    mutation RemoveTelemetryDeviceLinks($linkIds: [ID!]!) {
  removeTelemetryDeviceLinks(linkIds: $linkIds) {
    __typename
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useRemoveTelemetryDeviceLinksMutation__
 *
 * To run a mutation, you first call `useRemoveTelemetryDeviceLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTelemetryDeviceLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTelemetryDeviceLinksMutation, { data, loading, error }] = useRemoveTelemetryDeviceLinksMutation({
 *   variables: {
 *      linkIds: // value for 'linkIds'
 *   },
 * });
 */
export function useRemoveTelemetryDeviceLinksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTelemetryDeviceLinksMutation, RemoveTelemetryDeviceLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTelemetryDeviceLinksMutation, RemoveTelemetryDeviceLinksMutationVariables>(RemoveTelemetryDeviceLinksDocument, options);
      }
export type RemoveTelemetryDeviceLinksMutationHookResult = ReturnType<typeof useRemoveTelemetryDeviceLinksMutation>;
export type RemoveTelemetryDeviceLinksMutationResult = Apollo.MutationResult<RemoveTelemetryDeviceLinksMutation>;
export type RemoveTelemetryDeviceLinksMutationOptions = Apollo.BaseMutationOptions<RemoveTelemetryDeviceLinksMutation, RemoveTelemetryDeviceLinksMutationVariables>;
export const GetTrackerTelemetryDevicesDocument = gql`
    query GetTrackerTelemetryDevices($filter: GetTelemetryDevicesFilter!) {
  getTelemetryDevices(filter: $filter) {
    ... on TrackerTelemetryDevice {
      ...TrackerTelemetryDeviceFields
    }
  }
}
    ${TrackerTelemetryDeviceFieldsFragmentDoc}`;

/**
 * __useGetTrackerTelemetryDevicesQuery__
 *
 * To run a query within a React component, call `useGetTrackerTelemetryDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackerTelemetryDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackerTelemetryDevicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTrackerTelemetryDevicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTrackerTelemetryDevicesQuery, GetTrackerTelemetryDevicesQueryVariables> & ({ variables: GetTrackerTelemetryDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrackerTelemetryDevicesQuery, GetTrackerTelemetryDevicesQueryVariables>(GetTrackerTelemetryDevicesDocument, options);
      }
export function useGetTrackerTelemetryDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrackerTelemetryDevicesQuery, GetTrackerTelemetryDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrackerTelemetryDevicesQuery, GetTrackerTelemetryDevicesQueryVariables>(GetTrackerTelemetryDevicesDocument, options);
        }
export function useGetTrackerTelemetryDevicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTrackerTelemetryDevicesQuery, GetTrackerTelemetryDevicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTrackerTelemetryDevicesQuery, GetTrackerTelemetryDevicesQueryVariables>(GetTrackerTelemetryDevicesDocument, options);
        }
export type GetTrackerTelemetryDevicesQueryHookResult = ReturnType<typeof useGetTrackerTelemetryDevicesQuery>;
export type GetTrackerTelemetryDevicesLazyQueryHookResult = ReturnType<typeof useGetTrackerTelemetryDevicesLazyQuery>;
export type GetTrackerTelemetryDevicesSuspenseQueryHookResult = ReturnType<typeof useGetTrackerTelemetryDevicesSuspenseQuery>;
export type GetTrackerTelemetryDevicesQueryResult = Apollo.QueryResult<GetTrackerTelemetryDevicesQuery, GetTrackerTelemetryDevicesQueryVariables>;
export const GetIntegrationTelemetryDevicesDocument = gql`
    query GetIntegrationTelemetryDevices($filter: GetTelemetryDevicesFilter!) {
  getTelemetryDevices(filter: $filter) {
    ... on IntegrationTelemetryDevice {
      ...IntegrationTelemetryDeviceFields
    }
  }
}
    ${IntegrationTelemetryDeviceFieldsFragmentDoc}`;

/**
 * __useGetIntegrationTelemetryDevicesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationTelemetryDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationTelemetryDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationTelemetryDevicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetIntegrationTelemetryDevicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIntegrationTelemetryDevicesQuery, GetIntegrationTelemetryDevicesQueryVariables> & ({ variables: GetIntegrationTelemetryDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntegrationTelemetryDevicesQuery, GetIntegrationTelemetryDevicesQueryVariables>(GetIntegrationTelemetryDevicesDocument, options);
      }
export function useGetIntegrationTelemetryDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntegrationTelemetryDevicesQuery, GetIntegrationTelemetryDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntegrationTelemetryDevicesQuery, GetIntegrationTelemetryDevicesQueryVariables>(GetIntegrationTelemetryDevicesDocument, options);
        }
export function useGetIntegrationTelemetryDevicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntegrationTelemetryDevicesQuery, GetIntegrationTelemetryDevicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntegrationTelemetryDevicesQuery, GetIntegrationTelemetryDevicesQueryVariables>(GetIntegrationTelemetryDevicesDocument, options);
        }
export type GetIntegrationTelemetryDevicesQueryHookResult = ReturnType<typeof useGetIntegrationTelemetryDevicesQuery>;
export type GetIntegrationTelemetryDevicesLazyQueryHookResult = ReturnType<typeof useGetIntegrationTelemetryDevicesLazyQuery>;
export type GetIntegrationTelemetryDevicesSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationTelemetryDevicesSuspenseQuery>;
export type GetIntegrationTelemetryDevicesQueryResult = Apollo.QueryResult<GetIntegrationTelemetryDevicesQuery, GetIntegrationTelemetryDevicesQueryVariables>;
export const DownloadTelemetryDevicesWorkbookDocument = gql`
    query DownloadTelemetryDevicesWorkbook($category: TelemetryDeviceCategory!) {
  downloadTelemetryDevicesWorkbook(category: $category) {
    __typename
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useDownloadTelemetryDevicesWorkbookQuery__
 *
 * To run a query within a React component, call `useDownloadTelemetryDevicesWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTelemetryDevicesWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadTelemetryDevicesWorkbookQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useDownloadTelemetryDevicesWorkbookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DownloadTelemetryDevicesWorkbookQuery, DownloadTelemetryDevicesWorkbookQueryVariables> & ({ variables: DownloadTelemetryDevicesWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DownloadTelemetryDevicesWorkbookQuery, DownloadTelemetryDevicesWorkbookQueryVariables>(DownloadTelemetryDevicesWorkbookDocument, options);
      }
export function useDownloadTelemetryDevicesWorkbookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadTelemetryDevicesWorkbookQuery, DownloadTelemetryDevicesWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DownloadTelemetryDevicesWorkbookQuery, DownloadTelemetryDevicesWorkbookQueryVariables>(DownloadTelemetryDevicesWorkbookDocument, options);
        }
export function useDownloadTelemetryDevicesWorkbookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DownloadTelemetryDevicesWorkbookQuery, DownloadTelemetryDevicesWorkbookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DownloadTelemetryDevicesWorkbookQuery, DownloadTelemetryDevicesWorkbookQueryVariables>(DownloadTelemetryDevicesWorkbookDocument, options);
        }
export type DownloadTelemetryDevicesWorkbookQueryHookResult = ReturnType<typeof useDownloadTelemetryDevicesWorkbookQuery>;
export type DownloadTelemetryDevicesWorkbookLazyQueryHookResult = ReturnType<typeof useDownloadTelemetryDevicesWorkbookLazyQuery>;
export type DownloadTelemetryDevicesWorkbookSuspenseQueryHookResult = ReturnType<typeof useDownloadTelemetryDevicesWorkbookSuspenseQuery>;
export type DownloadTelemetryDevicesWorkbookQueryResult = Apollo.QueryResult<DownloadTelemetryDevicesWorkbookQuery, DownloadTelemetryDevicesWorkbookQueryVariables>;
export const UpdateTelemetryDeviceLinkDocument = gql`
    mutation UpdateTelemetryDeviceLink($linkId: ID!, $input: UpdateTelemetryDeviceLinkInput!) {
  updateTelemetryDeviceLink(linkId: $linkId, input: $input) {
    __typename
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useUpdateTelemetryDeviceLinkMutation__
 *
 * To run a mutation, you first call `useUpdateTelemetryDeviceLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTelemetryDeviceLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTelemetryDeviceLinkMutation, { data, loading, error }] = useUpdateTelemetryDeviceLinkMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTelemetryDeviceLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTelemetryDeviceLinkMutation, UpdateTelemetryDeviceLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTelemetryDeviceLinkMutation, UpdateTelemetryDeviceLinkMutationVariables>(UpdateTelemetryDeviceLinkDocument, options);
      }
export type UpdateTelemetryDeviceLinkMutationHookResult = ReturnType<typeof useUpdateTelemetryDeviceLinkMutation>;
export type UpdateTelemetryDeviceLinkMutationResult = Apollo.MutationResult<UpdateTelemetryDeviceLinkMutation>;
export type UpdateTelemetryDeviceLinkMutationOptions = Apollo.BaseMutationOptions<UpdateTelemetryDeviceLinkMutation, UpdateTelemetryDeviceLinkMutationVariables>;
export const CalibrateTrackerDeviceDocument = gql`
    mutation CalibrateTrackerDevice($id: Int!, $input: CalibrateTrackerDeviceInput!) {
  calibrateTrackerDevice(id: $id, input: $input) {
    ...TrackerTelemetryDeviceFields
  }
}
    ${TrackerTelemetryDeviceFieldsFragmentDoc}`;

/**
 * __useCalibrateTrackerDeviceMutation__
 *
 * To run a mutation, you first call `useCalibrateTrackerDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalibrateTrackerDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calibrateTrackerDeviceMutation, { data, loading, error }] = useCalibrateTrackerDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalibrateTrackerDeviceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalibrateTrackerDeviceMutation, CalibrateTrackerDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CalibrateTrackerDeviceMutation, CalibrateTrackerDeviceMutationVariables>(CalibrateTrackerDeviceDocument, options);
      }
export type CalibrateTrackerDeviceMutationHookResult = ReturnType<typeof useCalibrateTrackerDeviceMutation>;
export type CalibrateTrackerDeviceMutationResult = Apollo.MutationResult<CalibrateTrackerDeviceMutation>;
export type CalibrateTrackerDeviceMutationOptions = Apollo.BaseMutationOptions<CalibrateTrackerDeviceMutation, CalibrateTrackerDeviceMutationVariables>;
export const SystemFlagsDocument = gql`
    query SystemFlags {
  systemFlags {
    ...SystemFlagFields
  }
}
    ${SystemFlagFieldsFragmentDoc}`;

/**
 * __useSystemFlagsQuery__
 *
 * To run a query within a React component, call `useSystemFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SystemFlagsQuery, SystemFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SystemFlagsQuery, SystemFlagsQueryVariables>(SystemFlagsDocument, options);
      }
export function useSystemFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SystemFlagsQuery, SystemFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SystemFlagsQuery, SystemFlagsQueryVariables>(SystemFlagsDocument, options);
        }
export function useSystemFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SystemFlagsQuery, SystemFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SystemFlagsQuery, SystemFlagsQueryVariables>(SystemFlagsDocument, options);
        }
export type SystemFlagsQueryHookResult = ReturnType<typeof useSystemFlagsQuery>;
export type SystemFlagsLazyQueryHookResult = ReturnType<typeof useSystemFlagsLazyQuery>;
export type SystemFlagsSuspenseQueryHookResult = ReturnType<typeof useSystemFlagsSuspenseQuery>;
export type SystemFlagsQueryResult = Apollo.QueryResult<SystemFlagsQuery, SystemFlagsQueryVariables>;
export const SetSystemFlagDocument = gql`
    mutation SetSystemFlag($key: String!, $enabled: Boolean!) {
  setSystemFlag(key: $key, enabled: $enabled) {
    ...SystemFlagFields
  }
}
    ${SystemFlagFieldsFragmentDoc}`;

/**
 * __useSetSystemFlagMutation__
 *
 * To run a mutation, you first call `useSetSystemFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSystemFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSystemFlagMutation, { data, loading, error }] = useSetSystemFlagMutation({
 *   variables: {
 *      key: // value for 'key'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetSystemFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetSystemFlagMutation, SetSystemFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetSystemFlagMutation, SetSystemFlagMutationVariables>(SetSystemFlagDocument, options);
      }
export type SetSystemFlagMutationHookResult = ReturnType<typeof useSetSystemFlagMutation>;
export type SetSystemFlagMutationResult = Apollo.MutationResult<SetSystemFlagMutation>;
export type SetSystemFlagMutationOptions = Apollo.BaseMutationOptions<SetSystemFlagMutation, SetSystemFlagMutationVariables>;
export const TelemetrySandboxRuntimeConfigDocument = gql`
    query TelemetrySandboxRuntimeConfig {
  telemetrySandboxRuntimeConfig {
    active_scope_key
    editable
    active_scope {
      ...TelemetrySandboxScopeFields
    }
    scopes {
      ...TelemetrySandboxScopeFields
    }
  }
}
    ${TelemetrySandboxScopeFieldsFragmentDoc}`;

/**
 * __useTelemetrySandboxRuntimeConfigQuery__
 *
 * To run a query within a React component, call `useTelemetrySandboxRuntimeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelemetrySandboxRuntimeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelemetrySandboxRuntimeConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useTelemetrySandboxRuntimeConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TelemetrySandboxRuntimeConfigQuery, TelemetrySandboxRuntimeConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TelemetrySandboxRuntimeConfigQuery, TelemetrySandboxRuntimeConfigQueryVariables>(TelemetrySandboxRuntimeConfigDocument, options);
      }
export function useTelemetrySandboxRuntimeConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TelemetrySandboxRuntimeConfigQuery, TelemetrySandboxRuntimeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TelemetrySandboxRuntimeConfigQuery, TelemetrySandboxRuntimeConfigQueryVariables>(TelemetrySandboxRuntimeConfigDocument, options);
        }
export function useTelemetrySandboxRuntimeConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TelemetrySandboxRuntimeConfigQuery, TelemetrySandboxRuntimeConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TelemetrySandboxRuntimeConfigQuery, TelemetrySandboxRuntimeConfigQueryVariables>(TelemetrySandboxRuntimeConfigDocument, options);
        }
export type TelemetrySandboxRuntimeConfigQueryHookResult = ReturnType<typeof useTelemetrySandboxRuntimeConfigQuery>;
export type TelemetrySandboxRuntimeConfigLazyQueryHookResult = ReturnType<typeof useTelemetrySandboxRuntimeConfigLazyQuery>;
export type TelemetrySandboxRuntimeConfigSuspenseQueryHookResult = ReturnType<typeof useTelemetrySandboxRuntimeConfigSuspenseQuery>;
export type TelemetrySandboxRuntimeConfigQueryResult = Apollo.QueryResult<TelemetrySandboxRuntimeConfigQuery, TelemetrySandboxRuntimeConfigQueryVariables>;
export const SetActiveTelemetrySandboxScopeDocument = gql`
    mutation SetActiveTelemetrySandboxScope($scopeKey: ID!) {
  setActiveTelemetrySandboxScope(scopeKey: $scopeKey) {
    active_scope_key
    editable
    active_scope {
      ...TelemetrySandboxScopeFields
    }
    scopes {
      ...TelemetrySandboxScopeFields
    }
  }
}
    ${TelemetrySandboxScopeFieldsFragmentDoc}`;

/**
 * __useSetActiveTelemetrySandboxScopeMutation__
 *
 * To run a mutation, you first call `useSetActiveTelemetrySandboxScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveTelemetrySandboxScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveTelemetrySandboxScopeMutation, { data, loading, error }] = useSetActiveTelemetrySandboxScopeMutation({
 *   variables: {
 *      scopeKey: // value for 'scopeKey'
 *   },
 * });
 */
export function useSetActiveTelemetrySandboxScopeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetActiveTelemetrySandboxScopeMutation, SetActiveTelemetrySandboxScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetActiveTelemetrySandboxScopeMutation, SetActiveTelemetrySandboxScopeMutationVariables>(SetActiveTelemetrySandboxScopeDocument, options);
      }
export type SetActiveTelemetrySandboxScopeMutationHookResult = ReturnType<typeof useSetActiveTelemetrySandboxScopeMutation>;
export type SetActiveTelemetrySandboxScopeMutationResult = Apollo.MutationResult<SetActiveTelemetrySandboxScopeMutation>;
export type SetActiveTelemetrySandboxScopeMutationOptions = Apollo.BaseMutationOptions<SetActiveTelemetrySandboxScopeMutation, SetActiveTelemetrySandboxScopeMutationVariables>;
export const GetCompanyActivityDocument = gql`
    query GetCompanyActivity($from: LocalDate!, $to: LocalDate!) {
  getCompanyActivity(from: $from, to: $to) {
    ...CompanyActivityFields
  }
}
    ${CompanyActivityFieldsFragmentDoc}`;

/**
 * __useGetCompanyActivityQuery__
 *
 * To run a query within a React component, call `useGetCompanyActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyActivityQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetCompanyActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCompanyActivityQuery, GetCompanyActivityQueryVariables> & ({ variables: GetCompanyActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyActivityQuery, GetCompanyActivityQueryVariables>(GetCompanyActivityDocument, options);
      }
export function useGetCompanyActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyActivityQuery, GetCompanyActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyActivityQuery, GetCompanyActivityQueryVariables>(GetCompanyActivityDocument, options);
        }
export function useGetCompanyActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyActivityQuery, GetCompanyActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyActivityQuery, GetCompanyActivityQueryVariables>(GetCompanyActivityDocument, options);
        }
export type GetCompanyActivityQueryHookResult = ReturnType<typeof useGetCompanyActivityQuery>;
export type GetCompanyActivityLazyQueryHookResult = ReturnType<typeof useGetCompanyActivityLazyQuery>;
export type GetCompanyActivitySuspenseQueryHookResult = ReturnType<typeof useGetCompanyActivitySuspenseQuery>;
export type GetCompanyActivityQueryResult = Apollo.QueryResult<GetCompanyActivityQuery, GetCompanyActivityQueryVariables>;
export const GetAllCompaniesForProjectOptionsDocument = gql`
    query GetAllCompaniesForProjectOptions {
  getAllCompanies {
    items {
      ...AllCompaniesForSuperRootFields
    }
  }
}
    ${AllCompaniesForSuperRootFieldsFragmentDoc}`;

/**
 * __useGetAllCompaniesForProjectOptionsQuery__
 *
 * To run a query within a React component, call `useGetAllCompaniesForProjectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompaniesForProjectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompaniesForProjectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCompaniesForProjectOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllCompaniesForProjectOptionsQuery, GetAllCompaniesForProjectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllCompaniesForProjectOptionsQuery, GetAllCompaniesForProjectOptionsQueryVariables>(GetAllCompaniesForProjectOptionsDocument, options);
      }
export function useGetAllCompaniesForProjectOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllCompaniesForProjectOptionsQuery, GetAllCompaniesForProjectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllCompaniesForProjectOptionsQuery, GetAllCompaniesForProjectOptionsQueryVariables>(GetAllCompaniesForProjectOptionsDocument, options);
        }
export function useGetAllCompaniesForProjectOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllCompaniesForProjectOptionsQuery, GetAllCompaniesForProjectOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllCompaniesForProjectOptionsQuery, GetAllCompaniesForProjectOptionsQueryVariables>(GetAllCompaniesForProjectOptionsDocument, options);
        }
export type GetAllCompaniesForProjectOptionsQueryHookResult = ReturnType<typeof useGetAllCompaniesForProjectOptionsQuery>;
export type GetAllCompaniesForProjectOptionsLazyQueryHookResult = ReturnType<typeof useGetAllCompaniesForProjectOptionsLazyQuery>;
export type GetAllCompaniesForProjectOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAllCompaniesForProjectOptionsSuspenseQuery>;
export type GetAllCompaniesForProjectOptionsQueryResult = Apollo.QueryResult<GetAllCompaniesForProjectOptionsQuery, GetAllCompaniesForProjectOptionsQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($username: String!) {
  deleteUserByUsername(username: $username)
}
    `;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const EnableBilderitModuleDocument = gql`
    mutation EnableBilderitModule($input: EnableBilderitModuleInput!) {
  enableBilderitModule(input: $input)
}
    `;

/**
 * __useEnableBilderitModuleMutation__
 *
 * To run a mutation, you first call `useEnableBilderitModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableBilderitModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableBilderitModuleMutation, { data, loading, error }] = useEnableBilderitModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableBilderitModuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableBilderitModuleMutation, EnableBilderitModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableBilderitModuleMutation, EnableBilderitModuleMutationVariables>(EnableBilderitModuleDocument, options);
      }
export type EnableBilderitModuleMutationHookResult = ReturnType<typeof useEnableBilderitModuleMutation>;
export type EnableBilderitModuleMutationResult = Apollo.MutationResult<EnableBilderitModuleMutation>;
export type EnableBilderitModuleMutationOptions = Apollo.BaseMutationOptions<EnableBilderitModuleMutation, EnableBilderitModuleMutationVariables>;
export const DisableBilderitModuleDocument = gql`
    mutation DisableBilderitModule($input: DisableBilderitModuleInput!) {
  disableBilderitModule(input: $input)
}
    `;

/**
 * __useDisableBilderitModuleMutation__
 *
 * To run a mutation, you first call `useDisableBilderitModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableBilderitModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableBilderitModuleMutation, { data, loading, error }] = useDisableBilderitModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableBilderitModuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableBilderitModuleMutation, DisableBilderitModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableBilderitModuleMutation, DisableBilderitModuleMutationVariables>(DisableBilderitModuleDocument, options);
      }
export type DisableBilderitModuleMutationHookResult = ReturnType<typeof useDisableBilderitModuleMutation>;
export type DisableBilderitModuleMutationResult = Apollo.MutationResult<DisableBilderitModuleMutation>;
export type DisableBilderitModuleMutationOptions = Apollo.BaseMutationOptions<DisableBilderitModuleMutation, DisableBilderitModuleMutationVariables>;
export const EnableToCreateCompanyDocument = gql`
    mutation EnableToCreateCompany($input: EnableToCreateCompanyInput!) {
  enableToCreateCompany(input: $input)
}
    `;

/**
 * __useEnableToCreateCompanyMutation__
 *
 * To run a mutation, you first call `useEnableToCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableToCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableToCreateCompanyMutation, { data, loading, error }] = useEnableToCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableToCreateCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableToCreateCompanyMutation, EnableToCreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableToCreateCompanyMutation, EnableToCreateCompanyMutationVariables>(EnableToCreateCompanyDocument, options);
      }
export type EnableToCreateCompanyMutationHookResult = ReturnType<typeof useEnableToCreateCompanyMutation>;
export type EnableToCreateCompanyMutationResult = Apollo.MutationResult<EnableToCreateCompanyMutation>;
export type EnableToCreateCompanyMutationOptions = Apollo.BaseMutationOptions<EnableToCreateCompanyMutation, EnableToCreateCompanyMutationVariables>;
export const DisableToCreateCompanyDocument = gql`
    mutation DisableToCreateCompany($input: DisableToCreateCompanyInput!) {
  disableToCreateCompany(input: $input)
}
    `;

/**
 * __useDisableToCreateCompanyMutation__
 *
 * To run a mutation, you first call `useDisableToCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableToCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableToCreateCompanyMutation, { data, loading, error }] = useDisableToCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableToCreateCompanyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableToCreateCompanyMutation, DisableToCreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableToCreateCompanyMutation, DisableToCreateCompanyMutationVariables>(DisableToCreateCompanyDocument, options);
      }
export type DisableToCreateCompanyMutationHookResult = ReturnType<typeof useDisableToCreateCompanyMutation>;
export type DisableToCreateCompanyMutationResult = Apollo.MutationResult<DisableToCreateCompanyMutation>;
export type DisableToCreateCompanyMutationOptions = Apollo.BaseMutationOptions<DisableToCreateCompanyMutation, DisableToCreateCompanyMutationVariables>;
export const GetCompaniesWithTotalsDocument = gql`
    query GetCompaniesWithTotals {
  getCompaniesWithTotals {
    items {
      ...CompanyWithTotalsFields
    }
  }
}
    ${CompanyWithTotalsFieldsFragmentDoc}`;

/**
 * __useGetCompaniesWithTotalsQuery__
 *
 * To run a query within a React component, call `useGetCompaniesWithTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesWithTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesWithTotalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesWithTotalsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompaniesWithTotalsQuery, GetCompaniesWithTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompaniesWithTotalsQuery, GetCompaniesWithTotalsQueryVariables>(GetCompaniesWithTotalsDocument, options);
      }
export function useGetCompaniesWithTotalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompaniesWithTotalsQuery, GetCompaniesWithTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompaniesWithTotalsQuery, GetCompaniesWithTotalsQueryVariables>(GetCompaniesWithTotalsDocument, options);
        }
export function useGetCompaniesWithTotalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompaniesWithTotalsQuery, GetCompaniesWithTotalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompaniesWithTotalsQuery, GetCompaniesWithTotalsQueryVariables>(GetCompaniesWithTotalsDocument, options);
        }
export type GetCompaniesWithTotalsQueryHookResult = ReturnType<typeof useGetCompaniesWithTotalsQuery>;
export type GetCompaniesWithTotalsLazyQueryHookResult = ReturnType<typeof useGetCompaniesWithTotalsLazyQuery>;
export type GetCompaniesWithTotalsSuspenseQueryHookResult = ReturnType<typeof useGetCompaniesWithTotalsSuspenseQuery>;
export type GetCompaniesWithTotalsQueryResult = Apollo.QueryResult<GetCompaniesWithTotalsQuery, GetCompaniesWithTotalsQueryVariables>;
export const ChangeCompanyRootDocument = gql`
    mutation ChangeCompanyRoot($companyId: Int!, $newRootId: Int!) {
  changeCompanyRoot(companyId: $companyId, newRootId: $newRootId) {
    id
  }
}
    `;

/**
 * __useChangeCompanyRootMutation__
 *
 * To run a mutation, you first call `useChangeCompanyRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCompanyRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCompanyRootMutation, { data, loading, error }] = useChangeCompanyRootMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      newRootId: // value for 'newRootId'
 *   },
 * });
 */
export function useChangeCompanyRootMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeCompanyRootMutation, ChangeCompanyRootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeCompanyRootMutation, ChangeCompanyRootMutationVariables>(ChangeCompanyRootDocument, options);
      }
export type ChangeCompanyRootMutationHookResult = ReturnType<typeof useChangeCompanyRootMutation>;
export type ChangeCompanyRootMutationResult = Apollo.MutationResult<ChangeCompanyRootMutation>;
export type ChangeCompanyRootMutationOptions = Apollo.BaseMutationOptions<ChangeCompanyRootMutation, ChangeCompanyRootMutationVariables>;
export const GetCompanyCreatorsDocument = gql`
    query GetCompanyCreators {
  getEnabledToCreateCompanyUsers
}
    `;

/**
 * __useGetCompanyCreatorsQuery__
 *
 * To run a query within a React component, call `useGetCompanyCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyCreatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyCreatorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyCreatorsQuery, GetCompanyCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyCreatorsQuery, GetCompanyCreatorsQueryVariables>(GetCompanyCreatorsDocument, options);
      }
export function useGetCompanyCreatorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyCreatorsQuery, GetCompanyCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyCreatorsQuery, GetCompanyCreatorsQueryVariables>(GetCompanyCreatorsDocument, options);
        }
export function useGetCompanyCreatorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyCreatorsQuery, GetCompanyCreatorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyCreatorsQuery, GetCompanyCreatorsQueryVariables>(GetCompanyCreatorsDocument, options);
        }
export type GetCompanyCreatorsQueryHookResult = ReturnType<typeof useGetCompanyCreatorsQuery>;
export type GetCompanyCreatorsLazyQueryHookResult = ReturnType<typeof useGetCompanyCreatorsLazyQuery>;
export type GetCompanyCreatorsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyCreatorsSuspenseQuery>;
export type GetCompanyCreatorsQueryResult = Apollo.QueryResult<GetCompanyCreatorsQuery, GetCompanyCreatorsQueryVariables>;
export const SyncMachinesStatusDocument = gql`
    mutation SyncMachinesStatus($input: SyncMachinesStatusInput!) {
  syncMachinesStatus(input: $input) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useSyncMachinesStatusMutation__
 *
 * To run a mutation, you first call `useSyncMachinesStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncMachinesStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncMachinesStatusMutation, { data, loading, error }] = useSyncMachinesStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncMachinesStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncMachinesStatusMutation, SyncMachinesStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncMachinesStatusMutation, SyncMachinesStatusMutationVariables>(SyncMachinesStatusDocument, options);
      }
export type SyncMachinesStatusMutationHookResult = ReturnType<typeof useSyncMachinesStatusMutation>;
export type SyncMachinesStatusMutationResult = Apollo.MutationResult<SyncMachinesStatusMutation>;
export type SyncMachinesStatusMutationOptions = Apollo.BaseMutationOptions<SyncMachinesStatusMutation, SyncMachinesStatusMutationVariables>;
export const SyncMachineCountersDocument = gql`
    mutation SyncMachineCounters($input: SyncMachineCountersInput!) {
  syncMachineCounters(input: $input) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useSyncMachineCountersMutation__
 *
 * To run a mutation, you first call `useSyncMachineCountersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncMachineCountersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncMachineCountersMutation, { data, loading, error }] = useSyncMachineCountersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncMachineCountersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncMachineCountersMutation, SyncMachineCountersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncMachineCountersMutation, SyncMachineCountersMutationVariables>(SyncMachineCountersDocument, options);
      }
export type SyncMachineCountersMutationHookResult = ReturnType<typeof useSyncMachineCountersMutation>;
export type SyncMachineCountersMutationResult = Apollo.MutationResult<SyncMachineCountersMutation>;
export type SyncMachineCountersMutationOptions = Apollo.BaseMutationOptions<SyncMachineCountersMutation, SyncMachineCountersMutationVariables>;
export const PreviewBilderitReportDocument = gql`
    mutation PreviewBilderitReport($input: PreviewBilderitReportInput!) {
  previewBilderitReport(input: $input) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      errorCode
      message
    }
  }
}
    `;

/**
 * __usePreviewBilderitReportMutation__
 *
 * To run a mutation, you first call `usePreviewBilderitReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewBilderitReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewBilderitReportMutation, { data, loading, error }] = usePreviewBilderitReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewBilderitReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PreviewBilderitReportMutation, PreviewBilderitReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PreviewBilderitReportMutation, PreviewBilderitReportMutationVariables>(PreviewBilderitReportDocument, options);
      }
export type PreviewBilderitReportMutationHookResult = ReturnType<typeof usePreviewBilderitReportMutation>;
export type PreviewBilderitReportMutationResult = Apollo.MutationResult<PreviewBilderitReportMutation>;
export type PreviewBilderitReportMutationOptions = Apollo.BaseMutationOptions<PreviewBilderitReportMutation, PreviewBilderitReportMutationVariables>;
export const LinkToBTrackDocument = gql`
    mutation LinkToBTrack($tracker_id: Int!) {
  linkToBTrack(tracker_id: $tracker_id)
}
    `;

/**
 * __useLinkToBTrackMutation__
 *
 * To run a mutation, you first call `useLinkToBTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkToBTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkToBTrackMutation, { data, loading, error }] = useLinkToBTrackMutation({
 *   variables: {
 *      tracker_id: // value for 'tracker_id'
 *   },
 * });
 */
export function useLinkToBTrackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkToBTrackMutation, LinkToBTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkToBTrackMutation, LinkToBTrackMutationVariables>(LinkToBTrackDocument, options);
      }
export type LinkToBTrackMutationHookResult = ReturnType<typeof useLinkToBTrackMutation>;
export type LinkToBTrackMutationResult = Apollo.MutationResult<LinkToBTrackMutation>;
export type LinkToBTrackMutationOptions = Apollo.BaseMutationOptions<LinkToBTrackMutation, LinkToBTrackMutationVariables>;
export const UnlinkFromBTrackDocument = gql`
    mutation UnlinkFromBTrack($tracker_id: Int!) {
  unlinkFromBTrack(tracker_id: $tracker_id)
}
    `;

/**
 * __useUnlinkFromBTrackMutation__
 *
 * To run a mutation, you first call `useUnlinkFromBTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkFromBTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkFromBTrackMutation, { data, loading, error }] = useUnlinkFromBTrackMutation({
 *   variables: {
 *      tracker_id: // value for 'tracker_id'
 *   },
 * });
 */
export function useUnlinkFromBTrackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlinkFromBTrackMutation, UnlinkFromBTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlinkFromBTrackMutation, UnlinkFromBTrackMutationVariables>(UnlinkFromBTrackDocument, options);
      }
export type UnlinkFromBTrackMutationHookResult = ReturnType<typeof useUnlinkFromBTrackMutation>;
export type UnlinkFromBTrackMutationResult = Apollo.MutationResult<UnlinkFromBTrackMutation>;
export type UnlinkFromBTrackMutationOptions = Apollo.BaseMutationOptions<UnlinkFromBTrackMutation, UnlinkFromBTrackMutationVariables>;
export const GetScopedTagsDocument = gql`
    query GetScopedTags($context: Context!, $scope: TagScope!, $query: String, $include_archived: Boolean) {
  getTags(
    context: $context
    scope: $scope
    query: $query
    include_archived: $include_archived
  ) {
    edges {
      ...TagCatalogFields
    }
  }
}
    ${TagCatalogFieldsFragmentDoc}`;

/**
 * __useGetScopedTagsQuery__
 *
 * To run a query within a React component, call `useGetScopedTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopedTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopedTagsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      scope: // value for 'scope'
 *      query: // value for 'query'
 *      include_archived: // value for 'include_archived'
 *   },
 * });
 */
export function useGetScopedTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetScopedTagsQuery, GetScopedTagsQueryVariables> & ({ variables: GetScopedTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetScopedTagsQuery, GetScopedTagsQueryVariables>(GetScopedTagsDocument, options);
      }
export function useGetScopedTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScopedTagsQuery, GetScopedTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetScopedTagsQuery, GetScopedTagsQueryVariables>(GetScopedTagsDocument, options);
        }
export function useGetScopedTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetScopedTagsQuery, GetScopedTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetScopedTagsQuery, GetScopedTagsQueryVariables>(GetScopedTagsDocument, options);
        }
export type GetScopedTagsQueryHookResult = ReturnType<typeof useGetScopedTagsQuery>;
export type GetScopedTagsLazyQueryHookResult = ReturnType<typeof useGetScopedTagsLazyQuery>;
export type GetScopedTagsSuspenseQueryHookResult = ReturnType<typeof useGetScopedTagsSuspenseQuery>;
export type GetScopedTagsQueryResult = Apollo.QueryResult<GetScopedTagsQuery, GetScopedTagsQueryVariables>;
export const GetBilderitScopedTagsDocument = gql`
    query GetBilderitScopedTags($scope: TagScope!, $query: String, $include_archived: Boolean) {
  getTagsManagedByBilderit(
    scope: $scope
    query: $query
    include_archived: $include_archived
  ) {
    edges {
      ...TagCatalogFields
    }
  }
}
    ${TagCatalogFieldsFragmentDoc}`;

/**
 * __useGetBilderitScopedTagsQuery__
 *
 * To run a query within a React component, call `useGetBilderitScopedTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBilderitScopedTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBilderitScopedTagsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      query: // value for 'query'
 *      include_archived: // value for 'include_archived'
 *   },
 * });
 */
export function useGetBilderitScopedTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBilderitScopedTagsQuery, GetBilderitScopedTagsQueryVariables> & ({ variables: GetBilderitScopedTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBilderitScopedTagsQuery, GetBilderitScopedTagsQueryVariables>(GetBilderitScopedTagsDocument, options);
      }
export function useGetBilderitScopedTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBilderitScopedTagsQuery, GetBilderitScopedTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBilderitScopedTagsQuery, GetBilderitScopedTagsQueryVariables>(GetBilderitScopedTagsDocument, options);
        }
export function useGetBilderitScopedTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBilderitScopedTagsQuery, GetBilderitScopedTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBilderitScopedTagsQuery, GetBilderitScopedTagsQueryVariables>(GetBilderitScopedTagsDocument, options);
        }
export type GetBilderitScopedTagsQueryHookResult = ReturnType<typeof useGetBilderitScopedTagsQuery>;
export type GetBilderitScopedTagsLazyQueryHookResult = ReturnType<typeof useGetBilderitScopedTagsLazyQuery>;
export type GetBilderitScopedTagsSuspenseQueryHookResult = ReturnType<typeof useGetBilderitScopedTagsSuspenseQuery>;
export type GetBilderitScopedTagsQueryResult = Apollo.QueryResult<GetBilderitScopedTagsQuery, GetBilderitScopedTagsQueryVariables>;
export const GetScopedTagGroupsDocument = gql`
    query GetScopedTagGroups($context: Context!, $scope: TagScope!, $include_archived: Boolean) {
  getTagGroups(
    context: $context
    scope: $scope
    include_archived: $include_archived
  ) {
    ...TagGroupCatalogFields
  }
}
    ${TagGroupCatalogFieldsFragmentDoc}`;

/**
 * __useGetScopedTagGroupsQuery__
 *
 * To run a query within a React component, call `useGetScopedTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopedTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopedTagGroupsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      scope: // value for 'scope'
 *      include_archived: // value for 'include_archived'
 *   },
 * });
 */
export function useGetScopedTagGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetScopedTagGroupsQuery, GetScopedTagGroupsQueryVariables> & ({ variables: GetScopedTagGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetScopedTagGroupsQuery, GetScopedTagGroupsQueryVariables>(GetScopedTagGroupsDocument, options);
      }
export function useGetScopedTagGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScopedTagGroupsQuery, GetScopedTagGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetScopedTagGroupsQuery, GetScopedTagGroupsQueryVariables>(GetScopedTagGroupsDocument, options);
        }
export function useGetScopedTagGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetScopedTagGroupsQuery, GetScopedTagGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetScopedTagGroupsQuery, GetScopedTagGroupsQueryVariables>(GetScopedTagGroupsDocument, options);
        }
export type GetScopedTagGroupsQueryHookResult = ReturnType<typeof useGetScopedTagGroupsQuery>;
export type GetScopedTagGroupsLazyQueryHookResult = ReturnType<typeof useGetScopedTagGroupsLazyQuery>;
export type GetScopedTagGroupsSuspenseQueryHookResult = ReturnType<typeof useGetScopedTagGroupsSuspenseQuery>;
export type GetScopedTagGroupsQueryResult = Apollo.QueryResult<GetScopedTagGroupsQuery, GetScopedTagGroupsQueryVariables>;
export const GetBilderitScopedTagGroupsDocument = gql`
    query GetBilderitScopedTagGroups($scope: TagScope!, $include_archived: Boolean) {
  getTagGroupsManagedByBilderit(
    scope: $scope
    include_archived: $include_archived
  ) {
    ...TagGroupCatalogFields
  }
}
    ${TagGroupCatalogFieldsFragmentDoc}`;

/**
 * __useGetBilderitScopedTagGroupsQuery__
 *
 * To run a query within a React component, call `useGetBilderitScopedTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBilderitScopedTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBilderitScopedTagGroupsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      include_archived: // value for 'include_archived'
 *   },
 * });
 */
export function useGetBilderitScopedTagGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBilderitScopedTagGroupsQuery, GetBilderitScopedTagGroupsQueryVariables> & ({ variables: GetBilderitScopedTagGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBilderitScopedTagGroupsQuery, GetBilderitScopedTagGroupsQueryVariables>(GetBilderitScopedTagGroupsDocument, options);
      }
export function useGetBilderitScopedTagGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBilderitScopedTagGroupsQuery, GetBilderitScopedTagGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBilderitScopedTagGroupsQuery, GetBilderitScopedTagGroupsQueryVariables>(GetBilderitScopedTagGroupsDocument, options);
        }
export function useGetBilderitScopedTagGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBilderitScopedTagGroupsQuery, GetBilderitScopedTagGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBilderitScopedTagGroupsQuery, GetBilderitScopedTagGroupsQueryVariables>(GetBilderitScopedTagGroupsDocument, options);
        }
export type GetBilderitScopedTagGroupsQueryHookResult = ReturnType<typeof useGetBilderitScopedTagGroupsQuery>;
export type GetBilderitScopedTagGroupsLazyQueryHookResult = ReturnType<typeof useGetBilderitScopedTagGroupsLazyQuery>;
export type GetBilderitScopedTagGroupsSuspenseQueryHookResult = ReturnType<typeof useGetBilderitScopedTagGroupsSuspenseQuery>;
export type GetBilderitScopedTagGroupsQueryResult = Apollo.QueryResult<GetBilderitScopedTagGroupsQuery, GetBilderitScopedTagGroupsQueryVariables>;
export const AddTagDocument = gql`
    mutation AddTag($input: AddTagInput!) {
  addTag(input: $input) {
    ...TagCatalogFields
  }
}
    ${TagCatalogFieldsFragmentDoc}`;

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagMutation, AddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagMutation, AddTagMutationVariables>(AddTagDocument, options);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = Apollo.MutationResult<AddTagMutation>;
export type AddTagMutationOptions = Apollo.BaseMutationOptions<AddTagMutation, AddTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    ...TagCatalogFields
  }
}
    ${TagCatalogFieldsFragmentDoc}`;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const MergeTagsDocument = gql`
    mutation MergeTags($input: MergeTagsInput!) {
  mergeTags(input: $input) {
    ...TagCatalogFields
  }
}
    ${TagCatalogFieldsFragmentDoc}`;

/**
 * __useMergeTagsMutation__
 *
 * To run a mutation, you first call `useMergeTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeTagsMutation, { data, loading, error }] = useMergeTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeTagsMutation, MergeTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeTagsMutation, MergeTagsMutationVariables>(MergeTagsDocument, options);
      }
export type MergeTagsMutationHookResult = ReturnType<typeof useMergeTagsMutation>;
export type MergeTagsMutationResult = Apollo.MutationResult<MergeTagsMutation>;
export type MergeTagsMutationOptions = Apollo.BaseMutationOptions<MergeTagsMutation, MergeTagsMutationVariables>;
export const AddTagGroupDocument = gql`
    mutation AddTagGroup($input: AddTagGroupInput!) {
  addTagGroup(input: $input) {
    ...TagGroupCatalogFields
  }
}
    ${TagGroupCatalogFieldsFragmentDoc}`;

/**
 * __useAddTagGroupMutation__
 *
 * To run a mutation, you first call `useAddTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagGroupMutation, { data, loading, error }] = useAddTagGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTagGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagGroupMutation, AddTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagGroupMutation, AddTagGroupMutationVariables>(AddTagGroupDocument, options);
      }
export type AddTagGroupMutationHookResult = ReturnType<typeof useAddTagGroupMutation>;
export type AddTagGroupMutationResult = Apollo.MutationResult<AddTagGroupMutation>;
export type AddTagGroupMutationOptions = Apollo.BaseMutationOptions<AddTagGroupMutation, AddTagGroupMutationVariables>;
export const UpdateTagGroupDocument = gql`
    mutation UpdateTagGroup($input: UpdateTagGroupInput!) {
  updateTagGroup(input: $input) {
    ...TagGroupCatalogFields
  }
}
    ${TagGroupCatalogFieldsFragmentDoc}`;

/**
 * __useUpdateTagGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagGroupMutation, { data, loading, error }] = useUpdateTagGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTagGroupMutation, UpdateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTagGroupMutation, UpdateTagGroupMutationVariables>(UpdateTagGroupDocument, options);
      }
export type UpdateTagGroupMutationHookResult = ReturnType<typeof useUpdateTagGroupMutation>;
export type UpdateTagGroupMutationResult = Apollo.MutationResult<UpdateTagGroupMutation>;
export type UpdateTagGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTagGroupMutation, UpdateTagGroupMutationVariables>;
export const ReviewTagCatalogDocument = gql`
    query ReviewTagCatalog($context: Context!, $scope: TagScope!) {
  reviewTagCatalog(context: $context, scope: $scope) {
    meta {
      available
      unavailable_reason
      model
      latency_ms
    }
    truncated
    truncated_reason
    reviewed_count
    total_count
    duplicates {
      tag_a_id
      tag_b_id
      relation
      probability
    }
    tags {
      tag_id
      specificity
      specificity_probability
      unreadable_name_probability
      is_code_like
      usage_share
    }
  }
}
    `;

/**
 * __useReviewTagCatalogQuery__
 *
 * To run a query within a React component, call `useReviewTagCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewTagCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewTagCatalogQuery({
 *   variables: {
 *      context: // value for 'context'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useReviewTagCatalogQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewTagCatalogQuery, ReviewTagCatalogQueryVariables> & ({ variables: ReviewTagCatalogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewTagCatalogQuery, ReviewTagCatalogQueryVariables>(ReviewTagCatalogDocument, options);
      }
export function useReviewTagCatalogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewTagCatalogQuery, ReviewTagCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewTagCatalogQuery, ReviewTagCatalogQueryVariables>(ReviewTagCatalogDocument, options);
        }
export function useReviewTagCatalogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewTagCatalogQuery, ReviewTagCatalogQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewTagCatalogQuery, ReviewTagCatalogQueryVariables>(ReviewTagCatalogDocument, options);
        }
export type ReviewTagCatalogQueryHookResult = ReturnType<typeof useReviewTagCatalogQuery>;
export type ReviewTagCatalogLazyQueryHookResult = ReturnType<typeof useReviewTagCatalogLazyQuery>;
export type ReviewTagCatalogSuspenseQueryHookResult = ReturnType<typeof useReviewTagCatalogSuspenseQuery>;
export type ReviewTagCatalogQueryResult = Apollo.QueryResult<ReviewTagCatalogQuery, ReviewTagCatalogQueryVariables>;
export const GetTimeSeriesByBilderitConnectDeviceIdDocument = gql`
    query GetTimeSeriesByBilderitConnectDeviceId($id: ID!, $from_utc: DateTime!, $to_utc: DateTime!) {
  getTimeSeriesByBilderitConnectDeviceId(
    id: $id
    params: {from_utc: $from_utc, to_utc: $to_utc}
  ) {
    ...DailyTelemetryFields
  }
}
    ${DailyTelemetryFieldsFragmentDoc}`;

/**
 * __useGetTimeSeriesByBilderitConnectDeviceIdQuery__
 *
 * To run a query within a React component, call `useGetTimeSeriesByBilderitConnectDeviceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSeriesByBilderitConnectDeviceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeSeriesByBilderitConnectDeviceIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from_utc: // value for 'from_utc'
 *      to_utc: // value for 'to_utc'
 *   },
 * });
 */
export function useGetTimeSeriesByBilderitConnectDeviceIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTimeSeriesByBilderitConnectDeviceIdQuery, GetTimeSeriesByBilderitConnectDeviceIdQueryVariables> & ({ variables: GetTimeSeriesByBilderitConnectDeviceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTimeSeriesByBilderitConnectDeviceIdQuery, GetTimeSeriesByBilderitConnectDeviceIdQueryVariables>(GetTimeSeriesByBilderitConnectDeviceIdDocument, options);
      }
export function useGetTimeSeriesByBilderitConnectDeviceIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTimeSeriesByBilderitConnectDeviceIdQuery, GetTimeSeriesByBilderitConnectDeviceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTimeSeriesByBilderitConnectDeviceIdQuery, GetTimeSeriesByBilderitConnectDeviceIdQueryVariables>(GetTimeSeriesByBilderitConnectDeviceIdDocument, options);
        }
export function useGetTimeSeriesByBilderitConnectDeviceIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTimeSeriesByBilderitConnectDeviceIdQuery, GetTimeSeriesByBilderitConnectDeviceIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTimeSeriesByBilderitConnectDeviceIdQuery, GetTimeSeriesByBilderitConnectDeviceIdQueryVariables>(GetTimeSeriesByBilderitConnectDeviceIdDocument, options);
        }
export type GetTimeSeriesByBilderitConnectDeviceIdQueryHookResult = ReturnType<typeof useGetTimeSeriesByBilderitConnectDeviceIdQuery>;
export type GetTimeSeriesByBilderitConnectDeviceIdLazyQueryHookResult = ReturnType<typeof useGetTimeSeriesByBilderitConnectDeviceIdLazyQuery>;
export type GetTimeSeriesByBilderitConnectDeviceIdSuspenseQueryHookResult = ReturnType<typeof useGetTimeSeriesByBilderitConnectDeviceIdSuspenseQuery>;
export type GetTimeSeriesByBilderitConnectDeviceIdQueryResult = Apollo.QueryResult<GetTimeSeriesByBilderitConnectDeviceIdQuery, GetTimeSeriesByBilderitConnectDeviceIdQueryVariables>;
export const GetSnapshotByBilderitConnectDeviceIdDocument = gql`
    query GetSnapshotByBilderitConnectDeviceId($id: ID!) {
  getSnapshotByBilderitConnectDeviceId(id: $id) {
    ...TelemetrySnapshotFields
  }
}
    ${TelemetrySnapshotFieldsFragmentDoc}`;

/**
 * __useGetSnapshotByBilderitConnectDeviceIdQuery__
 *
 * To run a query within a React component, call `useGetSnapshotByBilderitConnectDeviceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnapshotByBilderitConnectDeviceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnapshotByBilderitConnectDeviceIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSnapshotByBilderitConnectDeviceIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSnapshotByBilderitConnectDeviceIdQuery, GetSnapshotByBilderitConnectDeviceIdQueryVariables> & ({ variables: GetSnapshotByBilderitConnectDeviceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSnapshotByBilderitConnectDeviceIdQuery, GetSnapshotByBilderitConnectDeviceIdQueryVariables>(GetSnapshotByBilderitConnectDeviceIdDocument, options);
      }
export function useGetSnapshotByBilderitConnectDeviceIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSnapshotByBilderitConnectDeviceIdQuery, GetSnapshotByBilderitConnectDeviceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSnapshotByBilderitConnectDeviceIdQuery, GetSnapshotByBilderitConnectDeviceIdQueryVariables>(GetSnapshotByBilderitConnectDeviceIdDocument, options);
        }
export function useGetSnapshotByBilderitConnectDeviceIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSnapshotByBilderitConnectDeviceIdQuery, GetSnapshotByBilderitConnectDeviceIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSnapshotByBilderitConnectDeviceIdQuery, GetSnapshotByBilderitConnectDeviceIdQueryVariables>(GetSnapshotByBilderitConnectDeviceIdDocument, options);
        }
export type GetSnapshotByBilderitConnectDeviceIdQueryHookResult = ReturnType<typeof useGetSnapshotByBilderitConnectDeviceIdQuery>;
export type GetSnapshotByBilderitConnectDeviceIdLazyQueryHookResult = ReturnType<typeof useGetSnapshotByBilderitConnectDeviceIdLazyQuery>;
export type GetSnapshotByBilderitConnectDeviceIdSuspenseQueryHookResult = ReturnType<typeof useGetSnapshotByBilderitConnectDeviceIdSuspenseQuery>;
export type GetSnapshotByBilderitConnectDeviceIdQueryResult = Apollo.QueryResult<GetSnapshotByBilderitConnectDeviceIdQuery, GetSnapshotByBilderitConnectDeviceIdQueryVariables>;
export const GetDailyTelemetryByCompanyIdDocument = gql`
    query GetDailyTelemetryByCompanyId($companyId: Int!, $from: DateTime!, $to: DateTime!) {
  getDailyAEMPTelemetryByCompany(companyId: $companyId, from: $from, to: $to) {
    ...DailyTelemetryGroupFields
  }
}
    ${DailyTelemetryGroupFieldsFragmentDoc}`;

/**
 * __useGetDailyTelemetryByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetDailyTelemetryByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyTelemetryByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyTelemetryByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetDailyTelemetryByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDailyTelemetryByCompanyIdQuery, GetDailyTelemetryByCompanyIdQueryVariables> & ({ variables: GetDailyTelemetryByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDailyTelemetryByCompanyIdQuery, GetDailyTelemetryByCompanyIdQueryVariables>(GetDailyTelemetryByCompanyIdDocument, options);
      }
export function useGetDailyTelemetryByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDailyTelemetryByCompanyIdQuery, GetDailyTelemetryByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDailyTelemetryByCompanyIdQuery, GetDailyTelemetryByCompanyIdQueryVariables>(GetDailyTelemetryByCompanyIdDocument, options);
        }
export function useGetDailyTelemetryByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDailyTelemetryByCompanyIdQuery, GetDailyTelemetryByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDailyTelemetryByCompanyIdQuery, GetDailyTelemetryByCompanyIdQueryVariables>(GetDailyTelemetryByCompanyIdDocument, options);
        }
export type GetDailyTelemetryByCompanyIdQueryHookResult = ReturnType<typeof useGetDailyTelemetryByCompanyIdQuery>;
export type GetDailyTelemetryByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetDailyTelemetryByCompanyIdLazyQuery>;
export type GetDailyTelemetryByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetDailyTelemetryByCompanyIdSuspenseQuery>;
export type GetDailyTelemetryByCompanyIdQueryResult = Apollo.QueryResult<GetDailyTelemetryByCompanyIdQuery, GetDailyTelemetryByCompanyIdQueryVariables>;
export const SetMachineTelemetryProviderOffsetDocument = gql`
    mutation SetMachineTelemetryProviderOffset($machineId: Int!, $offset: Float!) {
  setMachineTelemetryProviderOffset(
    machineId: $machineId
    counter_offset: $offset
  ) {
    __typename
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useSetMachineTelemetryProviderOffsetMutation__
 *
 * To run a mutation, you first call `useSetMachineTelemetryProviderOffsetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMachineTelemetryProviderOffsetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMachineTelemetryProviderOffsetMutation, { data, loading, error }] = useSetMachineTelemetryProviderOffsetMutation({
 *   variables: {
 *      machineId: // value for 'machineId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSetMachineTelemetryProviderOffsetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMachineTelemetryProviderOffsetMutation, SetMachineTelemetryProviderOffsetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMachineTelemetryProviderOffsetMutation, SetMachineTelemetryProviderOffsetMutationVariables>(SetMachineTelemetryProviderOffsetDocument, options);
      }
export type SetMachineTelemetryProviderOffsetMutationHookResult = ReturnType<typeof useSetMachineTelemetryProviderOffsetMutation>;
export type SetMachineTelemetryProviderOffsetMutationResult = Apollo.MutationResult<SetMachineTelemetryProviderOffsetMutation>;
export type SetMachineTelemetryProviderOffsetMutationOptions = Apollo.BaseMutationOptions<SetMachineTelemetryProviderOffsetMutation, SetMachineTelemetryProviderOffsetMutationVariables>;
export const GetBcDeviceSnapshotsByCompanyIdDocument = gql`
    query GetBCDeviceSnapshotsByCompanyId($id: Int!) {
  getBCDeviceSnapshotsByCompanyId(id: $id) {
    bc_device {
      ...BilderitConnectDeviceFields
    }
    telemetry_snapshot {
      ...TelemetrySnapshotFields
    }
  }
}
    ${BilderitConnectDeviceFieldsFragmentDoc}
${TelemetrySnapshotFieldsFragmentDoc}`;

/**
 * __useGetBcDeviceSnapshotsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetBcDeviceSnapshotsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBcDeviceSnapshotsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBcDeviceSnapshotsByCompanyIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBcDeviceSnapshotsByCompanyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBcDeviceSnapshotsByCompanyIdQuery, GetBcDeviceSnapshotsByCompanyIdQueryVariables> & ({ variables: GetBcDeviceSnapshotsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBcDeviceSnapshotsByCompanyIdQuery, GetBcDeviceSnapshotsByCompanyIdQueryVariables>(GetBcDeviceSnapshotsByCompanyIdDocument, options);
      }
export function useGetBcDeviceSnapshotsByCompanyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBcDeviceSnapshotsByCompanyIdQuery, GetBcDeviceSnapshotsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBcDeviceSnapshotsByCompanyIdQuery, GetBcDeviceSnapshotsByCompanyIdQueryVariables>(GetBcDeviceSnapshotsByCompanyIdDocument, options);
        }
export function useGetBcDeviceSnapshotsByCompanyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBcDeviceSnapshotsByCompanyIdQuery, GetBcDeviceSnapshotsByCompanyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBcDeviceSnapshotsByCompanyIdQuery, GetBcDeviceSnapshotsByCompanyIdQueryVariables>(GetBcDeviceSnapshotsByCompanyIdDocument, options);
        }
export type GetBcDeviceSnapshotsByCompanyIdQueryHookResult = ReturnType<typeof useGetBcDeviceSnapshotsByCompanyIdQuery>;
export type GetBcDeviceSnapshotsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetBcDeviceSnapshotsByCompanyIdLazyQuery>;
export type GetBcDeviceSnapshotsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetBcDeviceSnapshotsByCompanyIdSuspenseQuery>;
export type GetBcDeviceSnapshotsByCompanyIdQueryResult = Apollo.QueryResult<GetBcDeviceSnapshotsByCompanyIdQuery, GetBcDeviceSnapshotsByCompanyIdQueryVariables>;
export const InitJohnDeereConnectionDocument = gql`
    mutation InitJohnDeereConnection($company_id: Int!, $auth_code: String!) {
  initJohnDeereConnection(auth_code: $auth_code, company_id: $company_id) {
    org_connection_redirect_url
    access_token
    created_at
    expires_in
    refresh_token
    scope
    token_type
  }
}
    `;

/**
 * __useInitJohnDeereConnectionMutation__
 *
 * To run a mutation, you first call `useInitJohnDeereConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitJohnDeereConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initJohnDeereConnectionMutation, { data, loading, error }] = useInitJohnDeereConnectionMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      auth_code: // value for 'auth_code'
 *   },
 * });
 */
export function useInitJohnDeereConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitJohnDeereConnectionMutation, InitJohnDeereConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InitJohnDeereConnectionMutation, InitJohnDeereConnectionMutationVariables>(InitJohnDeereConnectionDocument, options);
      }
export type InitJohnDeereConnectionMutationHookResult = ReturnType<typeof useInitJohnDeereConnectionMutation>;
export type InitJohnDeereConnectionMutationResult = Apollo.MutationResult<InitJohnDeereConnectionMutation>;
export type InitJohnDeereConnectionMutationOptions = Apollo.BaseMutationOptions<InitJohnDeereConnectionMutation, InitJohnDeereConnectionMutationVariables>;
export const InitCaseConnectionDocument = gql`
    mutation InitCaseConnection($company_id: Int!, $auth_code: String!) {
  initCaseConnection(auth_code: $auth_code, company_id: $company_id) {
    access_token
    created_at
    expires_in
    refresh_token
    scope
    token_type
  }
}
    `;

/**
 * __useInitCaseConnectionMutation__
 *
 * To run a mutation, you first call `useInitCaseConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitCaseConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initCaseConnectionMutation, { data, loading, error }] = useInitCaseConnectionMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      auth_code: // value for 'auth_code'
 *   },
 * });
 */
export function useInitCaseConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitCaseConnectionMutation, InitCaseConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InitCaseConnectionMutation, InitCaseConnectionMutationVariables>(InitCaseConnectionDocument, options);
      }
export type InitCaseConnectionMutationHookResult = ReturnType<typeof useInitCaseConnectionMutation>;
export type InitCaseConnectionMutationResult = Apollo.MutationResult<InitCaseConnectionMutation>;
export type InitCaseConnectionMutationOptions = Apollo.BaseMutationOptions<InitCaseConnectionMutation, InitCaseConnectionMutationVariables>;
export const GetTelemetryDashboardStatsDocument = gql`
    query GetTelemetryDashboardStats($companyId: Int!, $from: DateTime!, $to: DateTime!, $idleConsumptionRate: Float) {
  getTelemetryDashboardStats(
    companyId: $companyId
    from: $from
    to: $to
    idleConsumptionRate: $idleConsumptionRate
  ) {
    fuelCostAvailable
    pricingCoverage {
      totalProjects
      coveredProjects
      uncoveredProjects
      uncoveredProjectIds
    }
    globalStats {
      ...TelemetryGroupStatsFields
    }
    projectStats {
      projectId
      project {
        id
        name
      }
      stats {
        ...TelemetryGroupStatsFields
      }
      equipment {
        ...TelemetryEquipmentStatsFields
      }
      movement {
        machineId
        machine {
          id
          name
        }
        otherProjectIds
        otherProjects {
          id
          name
        }
      }
    }
    equipments {
      ...TelemetryEquipmentStatsFields
    }
    movementSummary {
      movedMachinesCount
      affectedProjectsCount
    }
  }
}
    ${TelemetryGroupStatsFieldsFragmentDoc}
${TelemetryEquipmentStatsFieldsFragmentDoc}`;

/**
 * __useGetTelemetryDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetTelemetryDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTelemetryDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTelemetryDashboardStatsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      idleConsumptionRate: // value for 'idleConsumptionRate'
 *   },
 * });
 */
export function useGetTelemetryDashboardStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTelemetryDashboardStatsQuery, GetTelemetryDashboardStatsQueryVariables> & ({ variables: GetTelemetryDashboardStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTelemetryDashboardStatsQuery, GetTelemetryDashboardStatsQueryVariables>(GetTelemetryDashboardStatsDocument, options);
      }
export function useGetTelemetryDashboardStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTelemetryDashboardStatsQuery, GetTelemetryDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTelemetryDashboardStatsQuery, GetTelemetryDashboardStatsQueryVariables>(GetTelemetryDashboardStatsDocument, options);
        }
export function useGetTelemetryDashboardStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTelemetryDashboardStatsQuery, GetTelemetryDashboardStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTelemetryDashboardStatsQuery, GetTelemetryDashboardStatsQueryVariables>(GetTelemetryDashboardStatsDocument, options);
        }
export type GetTelemetryDashboardStatsQueryHookResult = ReturnType<typeof useGetTelemetryDashboardStatsQuery>;
export type GetTelemetryDashboardStatsLazyQueryHookResult = ReturnType<typeof useGetTelemetryDashboardStatsLazyQuery>;
export type GetTelemetryDashboardStatsSuspenseQueryHookResult = ReturnType<typeof useGetTelemetryDashboardStatsSuspenseQuery>;
export type GetTelemetryDashboardStatsQueryResult = Apollo.QueryResult<GetTelemetryDashboardStatsQuery, GetTelemetryDashboardStatsQueryVariables>;
export const GenerateTelemetryPdfDocument = gql`
    mutation GenerateTelemetryPDF($companyId: Int!, $from: DateTime!, $to: DateTime!, $idleConsumptionRate: Float, $projectId: Int) {
  generateTelemetryPDF(
    companyId: $companyId
    from: $from
    to: $to
    idleConsumptionRate: $idleConsumptionRate
    projectId: $projectId
  ) {
    __typename
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useGenerateTelemetryPdfMutation__
 *
 * To run a mutation, you first call `useGenerateTelemetryPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTelemetryPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTelemetryPdfMutation, { data, loading, error }] = useGenerateTelemetryPdfMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      idleConsumptionRate: // value for 'idleConsumptionRate'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGenerateTelemetryPdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateTelemetryPdfMutation, GenerateTelemetryPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateTelemetryPdfMutation, GenerateTelemetryPdfMutationVariables>(GenerateTelemetryPdfDocument, options);
      }
export type GenerateTelemetryPdfMutationHookResult = ReturnType<typeof useGenerateTelemetryPdfMutation>;
export type GenerateTelemetryPdfMutationResult = Apollo.MutationResult<GenerateTelemetryPdfMutation>;
export type GenerateTelemetryPdfMutationOptions = Apollo.BaseMutationOptions<GenerateTelemetryPdfMutation, GenerateTelemetryPdfMutationVariables>;
export const GetFuelCostSettingDocument = gql`
    query GetFuelCostSetting($companyId: Int!, $projectId: Int) {
  getFuelCostSetting(companyId: $companyId, projectId: $projectId)
}
    `;

/**
 * __useGetFuelCostSettingQuery__
 *
 * To run a query within a React component, call `useGetFuelCostSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelCostSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelCostSettingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetFuelCostSettingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelCostSettingQuery, GetFuelCostSettingQueryVariables> & ({ variables: GetFuelCostSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelCostSettingQuery, GetFuelCostSettingQueryVariables>(GetFuelCostSettingDocument, options);
      }
export function useGetFuelCostSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelCostSettingQuery, GetFuelCostSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelCostSettingQuery, GetFuelCostSettingQueryVariables>(GetFuelCostSettingDocument, options);
        }
export function useGetFuelCostSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelCostSettingQuery, GetFuelCostSettingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelCostSettingQuery, GetFuelCostSettingQueryVariables>(GetFuelCostSettingDocument, options);
        }
export type GetFuelCostSettingQueryHookResult = ReturnType<typeof useGetFuelCostSettingQuery>;
export type GetFuelCostSettingLazyQueryHookResult = ReturnType<typeof useGetFuelCostSettingLazyQuery>;
export type GetFuelCostSettingSuspenseQueryHookResult = ReturnType<typeof useGetFuelCostSettingSuspenseQuery>;
export type GetFuelCostSettingQueryResult = Apollo.QueryResult<GetFuelCostSettingQuery, GetFuelCostSettingQueryVariables>;
export const GetFuelCostSettingsOverviewDocument = gql`
    query GetFuelCostSettingsOverview($companyId: Int!) {
  getFuelCostSettingsOverview(companyId: $companyId) {
    companyValue
    projects {
      projectId
      projectName
      projectScopedValue
      effectiveValue
    }
  }
}
    `;

/**
 * __useGetFuelCostSettingsOverviewQuery__
 *
 * To run a query within a React component, call `useGetFuelCostSettingsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelCostSettingsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelCostSettingsOverviewQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetFuelCostSettingsOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFuelCostSettingsOverviewQuery, GetFuelCostSettingsOverviewQueryVariables> & ({ variables: GetFuelCostSettingsOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFuelCostSettingsOverviewQuery, GetFuelCostSettingsOverviewQueryVariables>(GetFuelCostSettingsOverviewDocument, options);
      }
export function useGetFuelCostSettingsOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFuelCostSettingsOverviewQuery, GetFuelCostSettingsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFuelCostSettingsOverviewQuery, GetFuelCostSettingsOverviewQueryVariables>(GetFuelCostSettingsOverviewDocument, options);
        }
export function useGetFuelCostSettingsOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFuelCostSettingsOverviewQuery, GetFuelCostSettingsOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFuelCostSettingsOverviewQuery, GetFuelCostSettingsOverviewQueryVariables>(GetFuelCostSettingsOverviewDocument, options);
        }
export type GetFuelCostSettingsOverviewQueryHookResult = ReturnType<typeof useGetFuelCostSettingsOverviewQuery>;
export type GetFuelCostSettingsOverviewLazyQueryHookResult = ReturnType<typeof useGetFuelCostSettingsOverviewLazyQuery>;
export type GetFuelCostSettingsOverviewSuspenseQueryHookResult = ReturnType<typeof useGetFuelCostSettingsOverviewSuspenseQuery>;
export type GetFuelCostSettingsOverviewQueryResult = Apollo.QueryResult<GetFuelCostSettingsOverviewQuery, GetFuelCostSettingsOverviewQueryVariables>;
export const SetFuelCostSettingDocument = gql`
    mutation SetFuelCostSetting($companyId: Int!, $projectId: Int, $value: Float) {
  setFuelCostSetting(companyId: $companyId, projectId: $projectId, value: $value) {
    __typename
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
  }
}
    `;

/**
 * __useSetFuelCostSettingMutation__
 *
 * To run a mutation, you first call `useSetFuelCostSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFuelCostSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFuelCostSettingMutation, { data, loading, error }] = useSetFuelCostSettingMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      projectId: // value for 'projectId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetFuelCostSettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetFuelCostSettingMutation, SetFuelCostSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetFuelCostSettingMutation, SetFuelCostSettingMutationVariables>(SetFuelCostSettingDocument, options);
      }
export type SetFuelCostSettingMutationHookResult = ReturnType<typeof useSetFuelCostSettingMutation>;
export type SetFuelCostSettingMutationResult = Apollo.MutationResult<SetFuelCostSettingMutation>;
export type SetFuelCostSettingMutationOptions = Apollo.BaseMutationOptions<SetFuelCostSettingMutation, SetFuelCostSettingMutationVariables>;
export const AddTruckDocument = gql`
    mutation AddTruck($input: AddTruckInput!) {
  addTruck(input: $input) {
    ... on Machine {
      ...MachineFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useAddTruckMutation__
 *
 * To run a mutation, you first call `useAddTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTruckMutation, { data, loading, error }] = useAddTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTruckMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTruckMutation, AddTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTruckMutation, AddTruckMutationVariables>(AddTruckDocument, options);
      }
export type AddTruckMutationHookResult = ReturnType<typeof useAddTruckMutation>;
export type AddTruckMutationResult = Apollo.MutationResult<AddTruckMutation>;
export type AddTruckMutationOptions = Apollo.BaseMutationOptions<AddTruckMutation, AddTruckMutationVariables>;
export const UpdateTruckDocument = gql`
    mutation UpdateTruck($id: Int!, $input: UpdateTruckInput!) {
  updateTruck(id: $id, input: $input) {
    ... on Machine {
      ...MachineFields
      ...ServicesFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}
${ServicesFieldsFragmentDoc}`;

/**
 * __useUpdateTruckMutation__
 *
 * To run a mutation, you first call `useUpdateTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTruckMutation, { data, loading, error }] = useUpdateTruckMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTruckMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTruckMutation, UpdateTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTruckMutation, UpdateTruckMutationVariables>(UpdateTruckDocument, options);
      }
export type UpdateTruckMutationHookResult = ReturnType<typeof useUpdateTruckMutation>;
export type UpdateTruckMutationResult = Apollo.MutationResult<UpdateTruckMutation>;
export type UpdateTruckMutationOptions = Apollo.BaseMutationOptions<UpdateTruckMutation, UpdateTruckMutationVariables>;
export const GetTrucksDocument = gql`
    query GetTrucks($context: Context) {
  getMachines(context: $context, filter: {group: CAMION}) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetTrucksQuery__
 *
 * To run a query within a React component, call `useGetTrucksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrucksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrucksQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetTrucksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTrucksQuery, GetTrucksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrucksQuery, GetTrucksQueryVariables>(GetTrucksDocument, options);
      }
export function useGetTrucksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrucksQuery, GetTrucksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrucksQuery, GetTrucksQueryVariables>(GetTrucksDocument, options);
        }
export function useGetTrucksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTrucksQuery, GetTrucksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTrucksQuery, GetTrucksQueryVariables>(GetTrucksDocument, options);
        }
export type GetTrucksQueryHookResult = ReturnType<typeof useGetTrucksQuery>;
export type GetTrucksLazyQueryHookResult = ReturnType<typeof useGetTrucksLazyQuery>;
export type GetTrucksSuspenseQueryHookResult = ReturnType<typeof useGetTrucksSuspenseQuery>;
export type GetTrucksQueryResult = Apollo.QueryResult<GetTrucksQuery, GetTrucksQueryVariables>;
export const AddVehicleDocument = gql`
    mutation AddVehicle($input: AddMobilityInput!) {
  addMobility(input: $input) {
    ... on AddMobilityResponse {
      ...MachineFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useAddVehicleMutation__
 *
 * To run a mutation, you first call `useAddVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVehicleMutation, { data, loading, error }] = useAddVehicleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVehicleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddVehicleMutation, AddVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddVehicleMutation, AddVehicleMutationVariables>(AddVehicleDocument, options);
      }
export type AddVehicleMutationHookResult = ReturnType<typeof useAddVehicleMutation>;
export type AddVehicleMutationResult = Apollo.MutationResult<AddVehicleMutation>;
export type AddVehicleMutationOptions = Apollo.BaseMutationOptions<AddVehicleMutation, AddVehicleMutationVariables>;
export const UpdateVehicleDocument = gql`
    mutation UpdateVehicle($id: Int!, $input: UpdateMobilityInput!) {
  updateMobility(id: $id, input: $input) {
    ... on UpdateMobilityResponse {
      ...MachineFields
      ...ServicesFields
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}
${ServicesFieldsFragmentDoc}`;

/**
 * __useUpdateVehicleMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleMutation, { data, loading, error }] = useUpdateVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVehicleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateVehicleMutation, UpdateVehicleMutationVariables>(UpdateVehicleDocument, options);
      }
export type UpdateVehicleMutationHookResult = ReturnType<typeof useUpdateVehicleMutation>;
export type UpdateVehicleMutationResult = Apollo.MutationResult<UpdateVehicleMutation>;
export type UpdateVehicleMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables>;
export const GetVehicleByIdDocument = gql`
    query GetVehicleById($id: Int!) {
  getMachineById(id: $id) {
    ... on AuthCheckGetMachineById {
      item {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetVehicleByIdQuery__
 *
 * To run a query within a React component, call `useGetVehicleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVehicleByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVehicleByIdQuery, GetVehicleByIdQueryVariables> & ({ variables: GetVehicleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVehicleByIdQuery, GetVehicleByIdQueryVariables>(GetVehicleByIdDocument, options);
      }
export function useGetVehicleByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVehicleByIdQuery, GetVehicleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVehicleByIdQuery, GetVehicleByIdQueryVariables>(GetVehicleByIdDocument, options);
        }
export function useGetVehicleByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVehicleByIdQuery, GetVehicleByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVehicleByIdQuery, GetVehicleByIdQueryVariables>(GetVehicleByIdDocument, options);
        }
export type GetVehicleByIdQueryHookResult = ReturnType<typeof useGetVehicleByIdQuery>;
export type GetVehicleByIdLazyQueryHookResult = ReturnType<typeof useGetVehicleByIdLazyQuery>;
export type GetVehicleByIdSuspenseQueryHookResult = ReturnType<typeof useGetVehicleByIdSuspenseQuery>;
export type GetVehicleByIdQueryResult = Apollo.QueryResult<GetVehicleByIdQuery, GetVehicleByIdQueryVariables>;
export const GetVehiclesDocument = gql`
    query GetVehicles($context: Context) {
  getMachines(context: $context, filter: {group: MOVILIDAD}) {
    ... on AuthCheckGetMachines {
      items {
        ...MachineFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useGetVehiclesQuery__
 *
 * To run a query within a React component, call `useGetVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiclesQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetVehiclesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
      }
export function useGetVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
        }
export function useGetVehiclesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
        }
export type GetVehiclesQueryHookResult = ReturnType<typeof useGetVehiclesQuery>;
export type GetVehiclesLazyQueryHookResult = ReturnType<typeof useGetVehiclesLazyQuery>;
export type GetVehiclesSuspenseQueryHookResult = ReturnType<typeof useGetVehiclesSuspenseQuery>;
export type GetVehiclesQueryResult = Apollo.QueryResult<GetVehiclesQuery, GetVehiclesQueryVariables>;
export const AddAssignmentReportDocument = gql`
    mutation AddAssignmentReport($input: AddAssignmentReportInput!) {
  addAssignmentReport(input: $input) {
    ...MachineFields
  }
}
    ${MachineFieldsFragmentDoc}`;

/**
 * __useAddAssignmentReportMutation__
 *
 * To run a mutation, you first call `useAddAssignmentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssignmentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssignmentReportMutation, { data, loading, error }] = useAddAssignmentReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAssignmentReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAssignmentReportMutation, AddAssignmentReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAssignmentReportMutation, AddAssignmentReportMutationVariables>(AddAssignmentReportDocument, options);
      }
export type AddAssignmentReportMutationHookResult = ReturnType<typeof useAddAssignmentReportMutation>;
export type AddAssignmentReportMutationResult = Apollo.MutationResult<AddAssignmentReportMutation>;
export type AddAssignmentReportMutationOptions = Apollo.BaseMutationOptions<AddAssignmentReportMutation, AddAssignmentReportMutationVariables>;
export const DeleteAssignmentReportDocument = gql`
    mutation DeleteAssignmentReport($id: Int!) {
  deleteAssignmentReport(id: $id)
}
    `;

/**
 * __useDeleteAssignmentReportMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentReportMutation, { data, loading, error }] = useDeleteAssignmentReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAssignmentReportMutation, DeleteAssignmentReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAssignmentReportMutation, DeleteAssignmentReportMutationVariables>(DeleteAssignmentReportDocument, options);
      }
export type DeleteAssignmentReportMutationHookResult = ReturnType<typeof useDeleteAssignmentReportMutation>;
export type DeleteAssignmentReportMutationResult = Apollo.MutationResult<DeleteAssignmentReportMutation>;
export type DeleteAssignmentReportMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentReportMutation, DeleteAssignmentReportMutationVariables>;
export const AddWorkOrderDocument = gql`
    mutation AddWorkOrder($input: AddWorkOrderInput!) {
  addWorkOrder(input: $input) {
    ... on ItemWorkOrder {
      item {
        ...WorkOrderWithFilesFields
      }
    }
  }
}
    ${WorkOrderWithFilesFieldsFragmentDoc}`;

/**
 * __useAddWorkOrderMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderMutation, { data, loading, error }] = useAddWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWorkOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddWorkOrderMutation, AddWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWorkOrderMutation, AddWorkOrderMutationVariables>(AddWorkOrderDocument, options);
      }
export type AddWorkOrderMutationHookResult = ReturnType<typeof useAddWorkOrderMutation>;
export type AddWorkOrderMutationResult = Apollo.MutationResult<AddWorkOrderMutation>;
export type AddWorkOrderMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderMutation, AddWorkOrderMutationVariables>;
export const UpdateWorkOrderDocument = gql`
    mutation UpdateWorkOrder($id: ID!, $input: UpdateWorkOrderInput!) {
  updateWorkOrder(id: $id, input: $input) {
    ... on ItemWorkOrder {
      item {
        ...WorkOrderWithFilesFields
        files {
          id
          url
        }
      }
    }
  }
}
    ${WorkOrderWithFilesFieldsFragmentDoc}`;

/**
 * __useUpdateWorkOrderMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderMutation, { data, loading, error }] = useUpdateWorkOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkOrderMutation, UpdateWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkOrderMutation, UpdateWorkOrderMutationVariables>(UpdateWorkOrderDocument, options);
      }
export type UpdateWorkOrderMutationHookResult = ReturnType<typeof useUpdateWorkOrderMutation>;
export type UpdateWorkOrderMutationResult = Apollo.MutationResult<UpdateWorkOrderMutation>;
export type UpdateWorkOrderMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderMutation, UpdateWorkOrderMutationVariables>;
export const UpdateWorkOrderTagsDocument = gql`
    mutation UpdateWorkOrderTags($work_order_id: ID!, $tag_ids: [ID!]!) {
  updateWorkOrderTags(input: {work_order_id: $work_order_id, tag_ids: $tag_ids}) {
    ... on ItemWorkOrder {
      item {
        ...WorkOrdersTableFields
      }
    }
  }
}
    ${WorkOrdersTableFieldsFragmentDoc}`;

/**
 * __useUpdateWorkOrderTagsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderTagsMutation, { data, loading, error }] = useUpdateWorkOrderTagsMutation({
 *   variables: {
 *      work_order_id: // value for 'work_order_id'
 *      tag_ids: // value for 'tag_ids'
 *   },
 * });
 */
export function useUpdateWorkOrderTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkOrderTagsMutation, UpdateWorkOrderTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWorkOrderTagsMutation, UpdateWorkOrderTagsMutationVariables>(UpdateWorkOrderTagsDocument, options);
      }
export type UpdateWorkOrderTagsMutationHookResult = ReturnType<typeof useUpdateWorkOrderTagsMutation>;
export type UpdateWorkOrderTagsMutationResult = Apollo.MutationResult<UpdateWorkOrderTagsMutation>;
export type UpdateWorkOrderTagsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderTagsMutation, UpdateWorkOrderTagsMutationVariables>;
export const DeleteWorkOrderDocument = gql`
    mutation DeleteWorkOrder($id: ID!) {
  deleteWorkOrder(id: $id) {
    ... on IDUnionWrapper {
      value
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useDeleteWorkOrderMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderMutation, { data, loading, error }] = useDeleteWorkOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkOrderMutation, DeleteWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkOrderMutation, DeleteWorkOrderMutationVariables>(DeleteWorkOrderDocument, options);
      }
export type DeleteWorkOrderMutationHookResult = ReturnType<typeof useDeleteWorkOrderMutation>;
export type DeleteWorkOrderMutationResult = Apollo.MutationResult<DeleteWorkOrderMutation>;
export type DeleteWorkOrderMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderMutation, DeleteWorkOrderMutationVariables>;
export const SetWorkOrderStatusInProgressDocument = gql`
    mutation SetWorkOrderStatusInProgress($id: ID!, $input: SetWorkOrderStatusInProgressInput) {
  setWorkOrderStatusInProgress(id: $id, input: $input) {
    ... on ItemWorkOrder {
      item {
        ...WorkOrderFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${WorkOrderFieldsFragmentDoc}`;

/**
 * __useSetWorkOrderStatusInProgressMutation__
 *
 * To run a mutation, you first call `useSetWorkOrderStatusInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkOrderStatusInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkOrderStatusInProgressMutation, { data, loading, error }] = useSetWorkOrderStatusInProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkOrderStatusInProgressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetWorkOrderStatusInProgressMutation, SetWorkOrderStatusInProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkOrderStatusInProgressMutation, SetWorkOrderStatusInProgressMutationVariables>(SetWorkOrderStatusInProgressDocument, options);
      }
export type SetWorkOrderStatusInProgressMutationHookResult = ReturnType<typeof useSetWorkOrderStatusInProgressMutation>;
export type SetWorkOrderStatusInProgressMutationResult = Apollo.MutationResult<SetWorkOrderStatusInProgressMutation>;
export type SetWorkOrderStatusInProgressMutationOptions = Apollo.BaseMutationOptions<SetWorkOrderStatusInProgressMutation, SetWorkOrderStatusInProgressMutationVariables>;
export const GetWorkOrdersDocument = gql`
    query GetWorkOrders($context: Context!, $filter: FilterWorkOrders, $query: String, $pagination: FilterPagination) {
  getWorkOrders(
    context: $context
    filter: $filter
    query: $query
    pagination: $pagination
  ) {
    items {
      ...WorkOrdersTableFields
    }
    page_info {
      current_page
      total_pages
      total_items
      items_per_page
    }
    facets {
      field
      facets {
        count
        value
      }
    }
  }
}
    ${WorkOrdersTableFieldsFragmentDoc}`;

/**
 * __useGetWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrdersQuery({
 *   variables: {
 *      context: // value for 'context'
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetWorkOrdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkOrdersQuery, GetWorkOrdersQueryVariables> & ({ variables: GetWorkOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
      }
export function useGetWorkOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
        }
export function useGetWorkOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
        }
export type GetWorkOrdersQueryHookResult = ReturnType<typeof useGetWorkOrdersQuery>;
export type GetWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetWorkOrdersLazyQuery>;
export type GetWorkOrdersSuspenseQueryHookResult = ReturnType<typeof useGetWorkOrdersSuspenseQuery>;
export type GetWorkOrdersQueryResult = Apollo.QueryResult<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>;
export const DownloadWorkOrdersWorkbookDocument = gql`
    query DownloadWorkOrdersWorkbook($company_id: Int!, $business_unit_id: Int, $project_id: Int, $year: Int!) {
  downloadWorkOrdersWorkbook(
    company_id: $company_id
    business_unit_id: $business_unit_id
    project_id: $project_id
    year: $year
  ) {
    ... on SuccessResult {
      result
    }
    ... on ServerError {
      message
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useDownloadWorkOrdersWorkbookQuery__
 *
 * To run a query within a React component, call `useDownloadWorkOrdersWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkOrdersWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadWorkOrdersWorkbookQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      business_unit_id: // value for 'business_unit_id'
 *      project_id: // value for 'project_id'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDownloadWorkOrdersWorkbookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DownloadWorkOrdersWorkbookQuery, DownloadWorkOrdersWorkbookQueryVariables> & ({ variables: DownloadWorkOrdersWorkbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DownloadWorkOrdersWorkbookQuery, DownloadWorkOrdersWorkbookQueryVariables>(DownloadWorkOrdersWorkbookDocument, options);
      }
export function useDownloadWorkOrdersWorkbookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadWorkOrdersWorkbookQuery, DownloadWorkOrdersWorkbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DownloadWorkOrdersWorkbookQuery, DownloadWorkOrdersWorkbookQueryVariables>(DownloadWorkOrdersWorkbookDocument, options);
        }
export function useDownloadWorkOrdersWorkbookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DownloadWorkOrdersWorkbookQuery, DownloadWorkOrdersWorkbookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DownloadWorkOrdersWorkbookQuery, DownloadWorkOrdersWorkbookQueryVariables>(DownloadWorkOrdersWorkbookDocument, options);
        }
export type DownloadWorkOrdersWorkbookQueryHookResult = ReturnType<typeof useDownloadWorkOrdersWorkbookQuery>;
export type DownloadWorkOrdersWorkbookLazyQueryHookResult = ReturnType<typeof useDownloadWorkOrdersWorkbookLazyQuery>;
export type DownloadWorkOrdersWorkbookSuspenseQueryHookResult = ReturnType<typeof useDownloadWorkOrdersWorkbookSuspenseQuery>;
export type DownloadWorkOrdersWorkbookQueryResult = Apollo.QueryResult<DownloadWorkOrdersWorkbookQuery, DownloadWorkOrdersWorkbookQueryVariables>;
export const GetWorkOrderByIdDocument = gql`
    query GetWorkOrderById($id: ID!) {
  getWorkOrderById(id: $id) {
    item {
      ...WorkOrderWithFilesFields
    }
  }
}
    ${WorkOrderWithFilesFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkOrderByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkOrderByIdQuery, GetWorkOrderByIdQueryVariables> & ({ variables: GetWorkOrderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkOrderByIdQuery, GetWorkOrderByIdQueryVariables>(GetWorkOrderByIdDocument, options);
      }
export function useGetWorkOrderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkOrderByIdQuery, GetWorkOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkOrderByIdQuery, GetWorkOrderByIdQueryVariables>(GetWorkOrderByIdDocument, options);
        }
export function useGetWorkOrderByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkOrderByIdQuery, GetWorkOrderByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkOrderByIdQuery, GetWorkOrderByIdQueryVariables>(GetWorkOrderByIdDocument, options);
        }
export type GetWorkOrderByIdQueryHookResult = ReturnType<typeof useGetWorkOrderByIdQuery>;
export type GetWorkOrderByIdLazyQueryHookResult = ReturnType<typeof useGetWorkOrderByIdLazyQuery>;
export type GetWorkOrderByIdSuspenseQueryHookResult = ReturnType<typeof useGetWorkOrderByIdSuspenseQuery>;
export type GetWorkOrderByIdQueryResult = Apollo.QueryResult<GetWorkOrderByIdQuery, GetWorkOrderByIdQueryVariables>;
export const GetWorkOrdersByMachineIdDocument = gql`
    query GetWorkOrdersByMachineId($id: Int!, $filter: FilterWorkOrders, $pagination: FilterPagination) {
  getWorkOrdersByMachineId(id: $id, filter: $filter, pagination: $pagination) {
    items {
      ...WorkOrderWithFilesFields
    }
  }
}
    ${WorkOrderWithFilesFieldsFragmentDoc}`;

/**
 * __useGetWorkOrdersByMachineIdQuery__
 *
 * To run a query within a React component, call `useGetWorkOrdersByMachineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrdersByMachineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrdersByMachineIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetWorkOrdersByMachineIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkOrdersByMachineIdQuery, GetWorkOrdersByMachineIdQueryVariables> & ({ variables: GetWorkOrdersByMachineIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkOrdersByMachineIdQuery, GetWorkOrdersByMachineIdQueryVariables>(GetWorkOrdersByMachineIdDocument, options);
      }
export function useGetWorkOrdersByMachineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkOrdersByMachineIdQuery, GetWorkOrdersByMachineIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkOrdersByMachineIdQuery, GetWorkOrdersByMachineIdQueryVariables>(GetWorkOrdersByMachineIdDocument, options);
        }
export function useGetWorkOrdersByMachineIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkOrdersByMachineIdQuery, GetWorkOrdersByMachineIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkOrdersByMachineIdQuery, GetWorkOrdersByMachineIdQueryVariables>(GetWorkOrdersByMachineIdDocument, options);
        }
export type GetWorkOrdersByMachineIdQueryHookResult = ReturnType<typeof useGetWorkOrdersByMachineIdQuery>;
export type GetWorkOrdersByMachineIdLazyQueryHookResult = ReturnType<typeof useGetWorkOrdersByMachineIdLazyQuery>;
export type GetWorkOrdersByMachineIdSuspenseQueryHookResult = ReturnType<typeof useGetWorkOrdersByMachineIdSuspenseQuery>;
export type GetWorkOrdersByMachineIdQueryResult = Apollo.QueryResult<GetWorkOrdersByMachineIdQuery, GetWorkOrdersByMachineIdQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags($context: Context!, $scope: TagScope!, $query: String, $include_archived: Boolean) {
  getTags(
    context: $context
    scope: $scope
    query: $query
    include_archived: $include_archived
  ) {
    edges {
      id
      tag
      is_archived
      color
      icon
      group {
        id
        name
        is_archived
      }
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      scope: // value for 'scope'
 *      query: // value for 'query'
 *      include_archived: // value for 'include_archived'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables> & ({ variables: GetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetBilderitTagsDocument = gql`
    query GetBilderitTags($scope: TagScope!, $query: String) {
  getTagsManagedByBilderit(scope: $scope, query: $query) {
    edges {
      id
      tag
      is_archived
      color
      icon
      group {
        id
        name
        is_archived
      }
    }
  }
}
    `;

/**
 * __useGetBilderitTagsQuery__
 *
 * To run a query within a React component, call `useGetBilderitTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBilderitTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBilderitTagsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetBilderitTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBilderitTagsQuery, GetBilderitTagsQueryVariables> & ({ variables: GetBilderitTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBilderitTagsQuery, GetBilderitTagsQueryVariables>(GetBilderitTagsDocument, options);
      }
export function useGetBilderitTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBilderitTagsQuery, GetBilderitTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBilderitTagsQuery, GetBilderitTagsQueryVariables>(GetBilderitTagsDocument, options);
        }
export function useGetBilderitTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBilderitTagsQuery, GetBilderitTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBilderitTagsQuery, GetBilderitTagsQueryVariables>(GetBilderitTagsDocument, options);
        }
export type GetBilderitTagsQueryHookResult = ReturnType<typeof useGetBilderitTagsQuery>;
export type GetBilderitTagsLazyQueryHookResult = ReturnType<typeof useGetBilderitTagsLazyQuery>;
export type GetBilderitTagsSuspenseQueryHookResult = ReturnType<typeof useGetBilderitTagsSuspenseQuery>;
export type GetBilderitTagsQueryResult = Apollo.QueryResult<GetBilderitTagsQuery, GetBilderitTagsQueryVariables>;
export const RegisterWorkOrderTasksDocument = gql`
    mutation RegisterWorkOrderTasks($input: RegisterWorkOrderTasksInput!) {
  registerWorkOrderTasks(input: $input) {
    ... on ItemWorkOrder {
      item {
        ...WorkOrderFields
      }
    }
  }
}
    ${WorkOrderFieldsFragmentDoc}`;

/**
 * __useRegisterWorkOrderTasksMutation__
 *
 * To run a mutation, you first call `useRegisterWorkOrderTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWorkOrderTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWorkOrderTasksMutation, { data, loading, error }] = useRegisterWorkOrderTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterWorkOrderTasksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterWorkOrderTasksMutation, RegisterWorkOrderTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterWorkOrderTasksMutation, RegisterWorkOrderTasksMutationVariables>(RegisterWorkOrderTasksDocument, options);
      }
export type RegisterWorkOrderTasksMutationHookResult = ReturnType<typeof useRegisterWorkOrderTasksMutation>;
export type RegisterWorkOrderTasksMutationResult = Apollo.MutationResult<RegisterWorkOrderTasksMutation>;
export type RegisterWorkOrderTasksMutationOptions = Apollo.BaseMutationOptions<RegisterWorkOrderTasksMutation, RegisterWorkOrderTasksMutationVariables>;
export const UnregisterWorkOrderTasksDocument = gql`
    mutation UnregisterWorkOrderTasks($input: UnregisterWorkOrderTasksInput!) {
  unregisterWorkOrderTasks(input: $input) {
    ... on ItemWorkOrder {
      item {
        ...WorkOrderFields
      }
    }
  }
}
    ${WorkOrderFieldsFragmentDoc}`;

/**
 * __useUnregisterWorkOrderTasksMutation__
 *
 * To run a mutation, you first call `useUnregisterWorkOrderTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterWorkOrderTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterWorkOrderTasksMutation, { data, loading, error }] = useUnregisterWorkOrderTasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnregisterWorkOrderTasksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnregisterWorkOrderTasksMutation, UnregisterWorkOrderTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnregisterWorkOrderTasksMutation, UnregisterWorkOrderTasksMutationVariables>(UnregisterWorkOrderTasksDocument, options);
      }
export type UnregisterWorkOrderTasksMutationHookResult = ReturnType<typeof useUnregisterWorkOrderTasksMutation>;
export type UnregisterWorkOrderTasksMutationResult = Apollo.MutationResult<UnregisterWorkOrderTasksMutation>;
export type UnregisterWorkOrderTasksMutationOptions = Apollo.BaseMutationOptions<UnregisterWorkOrderTasksMutation, UnregisterWorkOrderTasksMutationVariables>;
export const SetWorkOrderStatusClosedDocument = gql`
    mutation SetWorkOrderStatusClosed($id: ID!) {
  setWorkOrderStatusClosed(id: $id) {
    ... on ItemWorkOrder {
      item {
        ...WorkOrderFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${WorkOrderFieldsFragmentDoc}`;

/**
 * __useSetWorkOrderStatusClosedMutation__
 *
 * To run a mutation, you first call `useSetWorkOrderStatusClosedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkOrderStatusClosedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkOrderStatusClosedMutation, { data, loading, error }] = useSetWorkOrderStatusClosedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetWorkOrderStatusClosedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetWorkOrderStatusClosedMutation, SetWorkOrderStatusClosedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetWorkOrderStatusClosedMutation, SetWorkOrderStatusClosedMutationVariables>(SetWorkOrderStatusClosedDocument, options);
      }
export type SetWorkOrderStatusClosedMutationHookResult = ReturnType<typeof useSetWorkOrderStatusClosedMutation>;
export type SetWorkOrderStatusClosedMutationResult = Apollo.MutationResult<SetWorkOrderStatusClosedMutation>;
export type SetWorkOrderStatusClosedMutationOptions = Apollo.BaseMutationOptions<SetWorkOrderStatusClosedMutation, SetWorkOrderStatusClosedMutationVariables>;
export const AssignWorkOrderDocument = gql`
    mutation AssignWorkOrder($input: AssignWorkOrderInput!) {
  assignWorkOrder(input: $input) {
    ... on ItemWorkOrder {
      item {
        id
        assigned {
          id
          dni
          email
          first_name
          last_name
          full_name @client
        }
      }
    }
  }
}
    `;

/**
 * __useAssignWorkOrderMutation__
 *
 * To run a mutation, you first call `useAssignWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignWorkOrderMutation, { data, loading, error }] = useAssignWorkOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignWorkOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignWorkOrderMutation, AssignWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignWorkOrderMutation, AssignWorkOrderMutationVariables>(AssignWorkOrderDocument, options);
      }
export type AssignWorkOrderMutationHookResult = ReturnType<typeof useAssignWorkOrderMutation>;
export type AssignWorkOrderMutationResult = Apollo.MutationResult<AssignWorkOrderMutation>;
export type AssignWorkOrderMutationOptions = Apollo.BaseMutationOptions<AssignWorkOrderMutation, AssignWorkOrderMutationVariables>;
export const CancelWorkOrderDocument = gql`
    mutation CancelWorkOrder($id: ID!) {
  cancelWorkOrder(id: $id) {
    ... on ItemWorkOrder {
      item {
        id
        status
      }
    }
    ... on Error {
      message
    }
  }
}
    `;

/**
 * __useCancelWorkOrderMutation__
 *
 * To run a mutation, you first call `useCancelWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWorkOrderMutation, { data, loading, error }] = useCancelWorkOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelWorkOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelWorkOrderMutation, CancelWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelWorkOrderMutation, CancelWorkOrderMutationVariables>(CancelWorkOrderDocument, options);
      }
export type CancelWorkOrderMutationHookResult = ReturnType<typeof useCancelWorkOrderMutation>;
export type CancelWorkOrderMutationResult = Apollo.MutationResult<CancelWorkOrderMutation>;
export type CancelWorkOrderMutationOptions = Apollo.BaseMutationOptions<CancelWorkOrderMutation, CancelWorkOrderMutationVariables>;
export const GetWorkOrdersDashboardDocument = gql`
    query GetWorkOrdersDashboard($context: Context!, $month: String!, $excludeMachineIds: [Int!], $pagination: FilterPagination) {
  maintenanceDashboardMetrics(
    context: $context
    month: $month
    excludeMachineIds: $excludeMachineIds
    pagination: $pagination
  ) {
    current {
      global {
        ...MaintenanceKPIGroupFields
      }
      byMachine {
        ...MachineKPIEntryFields
      }
      page_info {
        total_pages
        current_page
        total_items
        items_per_page
      }
    }
    history(months: 6) {
      month
      global {
        ...MaintenanceKPIGroupFields
      }
    }
    lastRefreshedAt
  }
}
    ${MaintenanceKpiGroupFieldsFragmentDoc}
${MachineKpiEntryFieldsFragmentDoc}`;

/**
 * __useGetWorkOrdersDashboardQuery__
 *
 * To run a query within a React component, call `useGetWorkOrdersDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrdersDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrdersDashboardQuery({
 *   variables: {
 *      context: // value for 'context'
 *      month: // value for 'month'
 *      excludeMachineIds: // value for 'excludeMachineIds'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetWorkOrdersDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWorkOrdersDashboardQuery, GetWorkOrdersDashboardQueryVariables> & ({ variables: GetWorkOrdersDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkOrdersDashboardQuery, GetWorkOrdersDashboardQueryVariables>(GetWorkOrdersDashboardDocument, options);
      }
export function useGetWorkOrdersDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkOrdersDashboardQuery, GetWorkOrdersDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkOrdersDashboardQuery, GetWorkOrdersDashboardQueryVariables>(GetWorkOrdersDashboardDocument, options);
        }
export function useGetWorkOrdersDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWorkOrdersDashboardQuery, GetWorkOrdersDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWorkOrdersDashboardQuery, GetWorkOrdersDashboardQueryVariables>(GetWorkOrdersDashboardDocument, options);
        }
export type GetWorkOrdersDashboardQueryHookResult = ReturnType<typeof useGetWorkOrdersDashboardQuery>;
export type GetWorkOrdersDashboardLazyQueryHookResult = ReturnType<typeof useGetWorkOrdersDashboardLazyQuery>;
export type GetWorkOrdersDashboardSuspenseQueryHookResult = ReturnType<typeof useGetWorkOrdersDashboardSuspenseQuery>;
export type GetWorkOrdersDashboardQueryResult = Apollo.QueryResult<GetWorkOrdersDashboardQuery, GetWorkOrdersDashboardQueryVariables>;
export const RefreshMaintenanceKpiSnapshotDocument = gql`
    mutation RefreshMaintenanceKpiSnapshot($context: Context!, $month: String!) {
  refreshMaintenanceKpiSnapshot(context: $context, month: $month) {
    success
    refreshedAt
    machineCount
    durationMs
  }
}
    `;

/**
 * __useRefreshMaintenanceKpiSnapshotMutation__
 *
 * To run a mutation, you first call `useRefreshMaintenanceKpiSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMaintenanceKpiSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMaintenanceKpiSnapshotMutation, { data, loading, error }] = useRefreshMaintenanceKpiSnapshotMutation({
 *   variables: {
 *      context: // value for 'context'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useRefreshMaintenanceKpiSnapshotMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshMaintenanceKpiSnapshotMutation, RefreshMaintenanceKpiSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefreshMaintenanceKpiSnapshotMutation, RefreshMaintenanceKpiSnapshotMutationVariables>(RefreshMaintenanceKpiSnapshotDocument, options);
      }
export type RefreshMaintenanceKpiSnapshotMutationHookResult = ReturnType<typeof useRefreshMaintenanceKpiSnapshotMutation>;
export type RefreshMaintenanceKpiSnapshotMutationResult = Apollo.MutationResult<RefreshMaintenanceKpiSnapshotMutation>;
export type RefreshMaintenanceKpiSnapshotMutationOptions = Apollo.BaseMutationOptions<RefreshMaintenanceKpiSnapshotMutation, RefreshMaintenanceKpiSnapshotMutationVariables>;
export const GetPushConfigDocument = gql`
    query GetPushConfig {
  getPushConfig {
    vapidPublicKey
  }
}
    `;

/**
 * __useGetPushConfigQuery__
 *
 * To run a query within a React component, call `useGetPushConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPushConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPushConfigQuery, GetPushConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPushConfigQuery, GetPushConfigQueryVariables>(GetPushConfigDocument, options);
      }
export function useGetPushConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPushConfigQuery, GetPushConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPushConfigQuery, GetPushConfigQueryVariables>(GetPushConfigDocument, options);
        }
export function useGetPushConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPushConfigQuery, GetPushConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPushConfigQuery, GetPushConfigQueryVariables>(GetPushConfigDocument, options);
        }
export type GetPushConfigQueryHookResult = ReturnType<typeof useGetPushConfigQuery>;
export type GetPushConfigLazyQueryHookResult = ReturnType<typeof useGetPushConfigLazyQuery>;
export type GetPushConfigSuspenseQueryHookResult = ReturnType<typeof useGetPushConfigSuspenseQuery>;
export type GetPushConfigQueryResult = Apollo.QueryResult<GetPushConfigQuery, GetPushConfigQueryVariables>;
export const GetMyNotificationPreferencesDocument = gql`
    query GetMyNotificationPreferences {
  getMyNotificationPreferences {
    ...NotificationPreferencesFields
  }
}
    ${NotificationPreferencesFieldsFragmentDoc}`;

/**
 * __useGetMyNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyNotificationPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>(GetMyNotificationPreferencesDocument, options);
      }
export function useGetMyNotificationPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>(GetMyNotificationPreferencesDocument, options);
        }
export function useGetMyNotificationPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>(GetMyNotificationPreferencesDocument, options);
        }
export type GetMyNotificationPreferencesQueryHookResult = ReturnType<typeof useGetMyNotificationPreferencesQuery>;
export type GetMyNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetMyNotificationPreferencesLazyQuery>;
export type GetMyNotificationPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetMyNotificationPreferencesSuspenseQuery>;
export type GetMyNotificationPreferencesQueryResult = Apollo.QueryResult<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>;
export const RegisterPushSubscriptionDocument = gql`
    mutation RegisterPushSubscription($input: RegisterPushSubscriptionInput!) {
  registerPushSubscription(input: $input) {
    ...PushSubscriptionFields
  }
}
    ${PushSubscriptionFieldsFragmentDoc}`;

/**
 * __useRegisterPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useRegisterPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPushSubscriptionMutation, { data, loading, error }] = useRegisterPushSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterPushSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>(RegisterPushSubscriptionDocument, options);
      }
export type RegisterPushSubscriptionMutationHookResult = ReturnType<typeof useRegisterPushSubscriptionMutation>;
export type RegisterPushSubscriptionMutationResult = Apollo.MutationResult<RegisterPushSubscriptionMutation>;
export type RegisterPushSubscriptionMutationOptions = Apollo.BaseMutationOptions<RegisterPushSubscriptionMutation, RegisterPushSubscriptionMutationVariables>;
export const UnregisterPushSubscriptionDocument = gql`
    mutation UnregisterPushSubscription($endpoint: String!) {
  unregisterPushSubscription(endpoint: $endpoint)
}
    `;

/**
 * __useUnregisterPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useUnregisterPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterPushSubscriptionMutation, { data, loading, error }] = useUnregisterPushSubscriptionMutation({
 *   variables: {
 *      endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useUnregisterPushSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnregisterPushSubscriptionMutation, UnregisterPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnregisterPushSubscriptionMutation, UnregisterPushSubscriptionMutationVariables>(UnregisterPushSubscriptionDocument, options);
      }
export type UnregisterPushSubscriptionMutationHookResult = ReturnType<typeof useUnregisterPushSubscriptionMutation>;
export type UnregisterPushSubscriptionMutationResult = Apollo.MutationResult<UnregisterPushSubscriptionMutation>;
export type UnregisterPushSubscriptionMutationOptions = Apollo.BaseMutationOptions<UnregisterPushSubscriptionMutation, UnregisterPushSubscriptionMutationVariables>;
export const SetNotificationPreferencesDocument = gql`
    mutation SetNotificationPreferences($topics: [PushTopicPreferenceInput!]!) {
  setNotificationPreferences(topics: $topics) {
    ...NotificationPreferencesFields
  }
}
    ${NotificationPreferencesFieldsFragmentDoc}`;

/**
 * __useSetNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useSetNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationPreferencesMutation, { data, loading, error }] = useSetNotificationPreferencesMutation({
 *   variables: {
 *      topics: // value for 'topics'
 *   },
 * });
 */
export function useSetNotificationPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNotificationPreferencesMutation, SetNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetNotificationPreferencesMutation, SetNotificationPreferencesMutationVariables>(SetNotificationPreferencesDocument, options);
      }
export type SetNotificationPreferencesMutationHookResult = ReturnType<typeof useSetNotificationPreferencesMutation>;
export type SetNotificationPreferencesMutationResult = Apollo.MutationResult<SetNotificationPreferencesMutation>;
export type SetNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<SetNotificationPreferencesMutation, SetNotificationPreferencesMutationVariables>;
export const SetNotificationOptOutDocument = gql`
    mutation SetNotificationOptOut($topic: String!, $optedOut: Boolean!) {
  setNotificationOptOut(topic: $topic, optedOut: $optedOut)
}
    `;

/**
 * __useSetNotificationOptOutMutation__
 *
 * To run a mutation, you first call `useSetNotificationOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationOptOutMutation, { data, loading, error }] = useSetNotificationOptOutMutation({
 *   variables: {
 *      topic: // value for 'topic'
 *      optedOut: // value for 'optedOut'
 *   },
 * });
 */
export function useSetNotificationOptOutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNotificationOptOutMutation, SetNotificationOptOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetNotificationOptOutMutation, SetNotificationOptOutMutationVariables>(SetNotificationOptOutDocument, options);
      }
export type SetNotificationOptOutMutationHookResult = ReturnType<typeof useSetNotificationOptOutMutation>;
export type SetNotificationOptOutMutationResult = Apollo.MutationResult<SetNotificationOptOutMutation>;
export type SetNotificationOptOutMutationOptions = Apollo.BaseMutationOptions<SetNotificationOptOutMutation, SetNotificationOptOutMutationVariables>;
export const SendTestPushNotificationDocument = gql`
    mutation SendTestPushNotification {
  sendTestPushNotification
}
    `;

/**
 * __useSendTestPushNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestPushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestPushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestPushNotificationMutation, { data, loading, error }] = useSendTestPushNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendTestPushNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTestPushNotificationMutation, SendTestPushNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendTestPushNotificationMutation, SendTestPushNotificationMutationVariables>(SendTestPushNotificationDocument, options);
      }
export type SendTestPushNotificationMutationHookResult = ReturnType<typeof useSendTestPushNotificationMutation>;
export type SendTestPushNotificationMutationResult = Apollo.MutationResult<SendTestPushNotificationMutation>;
export type SendTestPushNotificationMutationOptions = Apollo.BaseMutationOptions<SendTestPushNotificationMutation, SendTestPushNotificationMutationVariables>;